export const spellSchools = [
    {
        "id": "0",
        "name": "Offene Leitmagie",
        "spellLists": [
            {
                "id": "0.0",
                "name": "8.1.1: Abwehr von Zaubern",
                "spells": [
                    {
                        "name": "Schutz I",
                        "level": 1,
                        "value": "Zieht 5 von allen elementaren Angriffen gegen das Ziel ab und gewährt einen Bonus von +5 auf alle WW des Ziels gegen Sprüche"
                    },
                    {
                        "name": "Leitmagie aufheben",
                        "level": 2,
                        "value": "Wenn der Zauberer Ziel eines Spruches aus dem Bereich Leitmagie wird, muß dieser „ankommende“ Spruch vor dem Zauberer einen WW durchführen. Dabei benutzt der Spruch als Stufe die desjenigen, der ihn gewirkt hat. Wenn der „ankommende“ Spruch diesen WW besteht, betrifft er den Zauberer von Leitmagie aufheben normal, andernfalls hat er keine Wirkung auf diesen"
                    },
                    {
                        "name": "Schutzsphäre I",
                        "level": 3,
                        "value": "Wie Schutz I, bis auf die Dauer und daß alle Wesen innerhalb eines 3m Radius um das Ziel die Vorteile genießen"
                    },
                    {
                        "name": "Essenz aufheben",
                        "level": 4,
                        "value": "Wie Leitmagie aufheben, allerdings ist der Zauberer gegen Sprüche aus dem Bereich der Essenz geschützt"
                    },
                    {
                        "name": "Schutz II",
                        "level": 5,
                        "value": "Wie Schutz I, nur sind der Malus und der Bonus jeweils 10"
                    },
                    {
                        "name": "Mentalismus aufheben",
                        "level": 6,
                        "value": "Wie Leitmagie aufheben, allerdings ist der Zauberer gegen Sprüche aus dem Bereich des Mentalismus geschützt"
                    },
                    {
                        "name": "Schutzsphäre II",
                        "level": 7,
                        "value": "Wie Schutzsphäre I, nur liegen der Malus und der Bonus jeweils bei zehn"
                    },
                    {
                        "name": "Leitmagie bannen I",
                        "level": 8,
                        "value": "Für jeden Spruch aus dem Bereich Leitmagie, der auf dem Ziel liegt, muß ein WW durchgeführt werden (verwenden Sie dazu als Stufe des Spruches die des Zauberers, der ihn ursprünglich wirkte). Mißlingt der WW, so ist der Spruch gebannt"
                    },
                    {
                        "name": "Leitmagieschild",
                        "level": 9,
                        "value": "Erzeugt einen schimmernden Schild vor dem Zauberer. Alle Basis-Angriffswürfe und Elementarangriffswürfe für frontale Leitmagiesprüche gegen ihn erleiden einen Malus von -10. Zusätzlich kann der Zauberer einen Zauberangriff „parieren“ (wie mit einem normalen Schild), wenn er in dieser Runde keine andere Handlung ausführt. Sein Paradebonus entspricht 10 plus der Anzahl an Fertigkeitsrängen in dieser Liste"
                    },
                    {
                        "name": "Schutz III",
                        "level": 10,
                        "value": "Wie Schutz I, nur liegen der Malus und der Bonus bei je 15"
                    },
                    {
                        "name": "Essenzschild",
                        "level": 11,
                        "value": "Wie Leitmagieschild, aber der Spruch wirkt gegen Essenz"
                    },
                    {
                        "name": "Essenz bannen I",
                        "level": 12,
                        "value": "Wie Leitmagie bannen I, nur betrifft er Sprüche aus dem Gebiet der Essenz"
                    },
                    {
                        "name": "Mentalismusschild",
                        "level": 13,
                        "value": "Wie Leitmagieschild, nur wirkt der Spruch nur gegen Mentalismussprüche"
                    },
                    {
                        "name": "Schutz IV",
                        "level": 14,
                        "value": "Wie Schutz I, nur liegen der Malus und der Bonus bei je 20"
                    },
                    {
                        "name": "Spruchschild II",
                        "level": 15,
                        "value": "Wie Leitmagieschild, allerdings wirkt der Spruch gegen 2 Magiebereiche, die der Zauberer wählen kann"
                    },
                    {
                        "name": "Mentalismus bannenI",
                        "level": 16,
                        "value": "Wie Leitmagie bannen I, nur betrifft er Sprüche aus dem Gebiet des Mentalismus"
                    },
                    {
                        "name": "Schutz V",
                        "level": 17,
                        "value": "Wie Schutz I, nur liegen der Malus und der Bonus bei je 25"
                    },
                    {
                        "name": "Wahrhaftiger Spruchschild",
                        "level": 19,
                        "value": "Wie Leitmagieschild, nur betrifft der Spruch alle drei Magiebereiche"
                    },
                    {
                        "name": "Widerstand gegen Leitmagie",
                        "level": 20,
                        "value": "Das Ziel erhält einen Bonus von +50 auf alle Widerstandswürfe gegen Leitmagiesprüche"
                    },
                    {
                        "name": "Widerstand gegen Essenz",
                        "level": 25,
                        "value": "Wie Widerstand gegen Leitmagie, allerdings wirkt der Spruch nur gegen Essenzsprüche"
                    },
                    {
                        "name": "Widerstand gegen Mentalismus",
                        "level": 30,
                        "value": "Wie Widerstand gegen Leitmagie, allerdings wirkt der Spruch nur gegen Mentalismussprüche"
                    },
                    {
                        "name": "Wahrhaftiger Widerstand",
                        "level": 50,
                        "value": "Wie Widerstand gegen Leitmagie, allerdings wirkt der Spruch gegen alle 3 Magiebereiche."
                    }
                ]
            },
            {
                "id": "0.1",
                "name": "8.1.2: Gesetz der Barrieren",
                "spells": [
                    {
                        "name": "Lichtbarriere I",
                        "level": 1,
                        "value": "Erschafft eine schwarze, substanzlose Barriere mit einer Ausdehnung von bis zu 6m x 6m x 3cm, durch die Licht nicht hindurchdringt (sie stört die Bewegung nicht, aber man kann nicht hindurchsehen)"
                    },
                    {
                        "name": "Luftbarriere",
                        "level": 2,
                        "value": "Erzeugt eine Barriere aus dichter, sich heftig drehender Luft mit Ausmaßen von bis zu 3m x 3m x 1m. Diese Barriere reduziert alle Bewegung durch sie hindurch um 50%. Zusätzlich erleiden Angriffe durch die Barriere einen Malus von -50"
                    },
                    {
                        "name": "Lichtbarriere II",
                        "level": 3,
                        "value": "Wie Lichtbarriere I, bis auf die Dauer"
                    },
                    {
                        "name": "Wasserbarriere",
                        "level": 4,
                        "value": "Erschafft eine Barriere aus Wasser mit einer Ausdehnung von bis zu 3m x 3m x 30cm. Diese Barriere reduziert die Bewegung durch sie hindurch um 80%. Zusätzlich erleiden alle Angriffe durch diese Barriere hindurch einen Malus von -80"
                    },
                    {
                        "name": "Holzbarriere",
                        "level": 5,
                        "value": "Erschafft eine Barriere aus Holz mit einer Ausdehnung von bis zu 3m x 6m x 6cm. Man kann sich durch die Barriere durchbrennen, ein Loch hineinschlagen oder sie umwerfen (wenn sie nicht irgendwie abgestützt ist)"
                    },
                    {
                        "name": "Erdbarriere",
                        "level": 7,
                        "value": "Wie Holzbarriere, nur besteht diese Barriere aus gepreßter Erde und hat eine Ausdehnung von bis zu 3m x 3m x (1m am Boden, 30cm an der oberen Kante)"
                    },
                    {
                        "name": "Eisbarriere I",
                        "level": 8,
                        "value": "Wie Holzbarriere, nur besteht die Barriere aus Eis und hat eine Ausdehnung von bis zu 3m x 3m x (60cm am Boden, 30cm an der oberen Kante). Sie kann geschmolzen werden, man kann ein Loch hineinschlagen oder sie umwerfen (wenn sie nicht irgendwie abgestützt ist)"
                    },
                    {
                        "name": "Grube",
                        "level": 10,
                        "value": "Öffnet eine Fallgrube (15m³ in Stein, 30m³ in Erde oder Eis). Kein Teil der Fallgrube darf weiter als 15m vom Zauberer entfernt sein. Die Grube kann nur in einer horizontalen Fläche geöffnet werden, deren Steigung 45° nicht übersteigt"
                    },
                    {
                        "name": "Wahrhaftige Luftbarriere",
                        "level": 11,
                        "value": "Wie Luftbarriere, bis auf die Dauer"
                    },
                    {
                        "name": "Steinbarriere",
                        "level": 12,
                        "value": "Wie Holzbarriere, nur besteht sie aus Stein und hat eine Ausdehnung von bis zu 3m x 3m x 30cm. Man kann ein Loch hineinschlagen"
                    },
                    {
                        "name": "Wahrhaftige Wasserbarriere",
                        "level": 13,
                        "value": "Wie Wasserbarriere, bis auf die Dauer"
                    },
                    {
                        "name": "Wahrhaftige Holzbarriere",
                        "level": 15,
                        "value": "Wie Holzbarriere, bis auf die Dauer"
                    },
                    {
                        "name": "Wahrhaftige Erdbarriere",
                        "level": 17,
                        "value": "Wie Erdbarriere, bis auf die Dauer"
                    },
                    {
                        "name": "Eisbarriere II",
                        "level": 18,
                        "value": "Wie Eisbarriere I, nur hat sie eine Ausdehnung von bis zu 6m x 6m x (1,25m am Boden und 60cm an der Oberkante)"
                    },
                    {
                        "name": "Wahrhaftige Steinbarriere",
                        "level": 20,
                        "value": "Wie Steinbarriere, bis auf die Dauer"
                    },
                    {
                        "name": "Barrieren verschmelzen",
                        "level": 25,
                        "value": "Verbindet zwei sich berührende Barrieren miteinander (die Nahtstelle kann bis zu 6m lang sein) oder verschmilzt einen Bereich von Steinblöcken miteinander (bis zu 3m³)"
                    },
                    {
                        "name": "Gebogene Barriere",
                        "level": 30,
                        "value": "Wie jedweder andere Barrierenspruch auf dieser Liste, nur kann die Wand auch bis zu halbkreisförmig gebogen sein"
                    },
                    {
                        "name": "Energiebarriere",
                        "level": 50,
                        "value": "Indem der Zauberer direkt die Macht seiner Gottheit durch sich hindurchleitet, erschafft er eine durchsichtige Wand aus Energie, die für alles und jeden vollkommen undurchdringlich ist. Sie kann eine Ausdehnung von bis zu 3m x 6m x 3cm haben."
                    }
                ]
            },
            {
                "id": "0.2",
                "name": "8.1.3: Gesetz der Natur",
                "spells": [
                    {
                        "name": "Pflanzenkunde",
                        "level": 2,
                        "value": "Der Zauberer erfährt Wesen, Geschichte und Wert einer beliebigen Pflanze"
                    },
                    {
                        "name": "Kräuterkunde",
                        "level": 3,
                        "value": "Der Zauberer begreift Wesen, Ursprung und Wert eines beliebigen Heilkrauts. Wenn die Pflanze kein Heilkraut ist, erhält der Zauberer keine Informationen"
                    },
                    {
                        "name": "Steinkunde",
                        "level": 5,
                        "value": "Der Zauberer erfährt Wesen, Geschichte und Ursprung eines beliebigen Steins"
                    },
                    {
                        "name": "Schnelles Wachsen",
                        "level": 6,
                        "value": "Der Zauberer kann das Wachstum einer Pflanzenart innerhalb der Reichweite um das Zehnfache beschleunigen"
                    },
                    {
                        "name": "Tiersprache",
                        "level": 7,
                        "value": "Erlaubt es dem Zauberer, die Sprache einer Tierart zu verstehen und zu „sprechen“"
                    },
                    {
                        "name": "Tierbeherrschung I",
                        "level": 9,
                        "value": "Der Zauberer kann die Handlungen eines beliebigen Tieres kontrollieren"
                    },
                    {
                        "name": "Naturwahrnehmung I",
                        "level": 10,
                        "value": "Der Zauberer kann alle Aktivität von Lebendem im Wirkungsbereich überwachen (d.h. er ist sich auch kleinster Bewegungen bewußt). Solange dieser Spruch anhält, kann sich der Zauberer nicht bewegen"
                    },
                    {
                        "name": "Pflanzensprache",
                        "level": 11,
                        "value": "Erlaubt es dem Zauberer, die Sprache einer Pflanzenart zu verstehen und zu „sprechen“"
                    },
                    {
                        "name": "Tierbeherrschung III",
                        "level": 12,
                        "value": "Wie Tierbeherrschung I, nur kann der Zauberer 3 beliebige Tiere kontrollieren"
                    },
                    {
                        "name": "Tiereinfühlung",
                        "level": 13,
                        "value": "Der Zauberer kann die Gedanken oder Gefühle eines beliebigen Tieres verstehen und/oder sich vorstellen"
                    },
                    {
                        "name": "Pflanzenkontrolle I",
                        "level": 14,
                        "value": "Der Zauberer kann die automatischen und geistigen Vorgänge einer beliebigen Pflanze kontrollieren. Auch die Bewegungen der Pflanze kann er steuern. Bedenken Sie, daß der Spruch nicht zu mehr Bewegung befähigt als normalerweise möglich wäre"
                    },
                    {
                        "name": "Steinsprache",
                        "level": 15,
                        "value": "Der Zauberer kann mit einem beliebigen Stein kommunizieren, sofern dieser auf irgendeine Weise belebt ist (z.B. könnte der Zauberer mit einem heiligen Stein sprechen, dem Intelligenz zu eigen ist)"
                    },
                    {
                        "name": "Kräutererzeugung",
                        "level": 16,
                        "value": "Der Zauberer kann ein Heilkraut wachen lassen, indem er den richtigen Samen pflanzt. Das Heilkraut ist steril und wächst innerhalb von 1-10 Runden"
                    },
                    {
                        "name": "Tierbeherrschung V",
                        "level": 18,
                        "value": "Wie Tierbeherrschung I, nur kann der Zauberer beliebige fünf Tiere kontrollieren"
                    },
                    {
                        "name": "Pflanzenkontrolle III",
                        "level": 19,
                        "value": "Wie Pflanzenkontrolle I, nur kann der Zauberer beliebige drei Pflanzen kontrollieren"
                    },
                    {
                        "name": "Naturwahrnehmung V",
                        "level": 20,
                        "value": "Wie Naturwahrnehmung I, nur ist der Radius 150m groß"
                    },
                    {
                        "name": "Erdeinfühlung",
                        "level": 25,
                        "value": "Der Zauberer kann die Gedanken oder Gefühle eines beliebigen Tieres, einer Pflanze, eines Steins oder eines toten, organischen Objekts verstehen und/oder sich bildlich vorstellen. Einmal pro Runde kann er das Ziel wechseln"
                    },
                    {
                        "name": "Beherrschung",
                        "level": 30,
                        "value": "Wie Tierbeherrschung I, nur kann der Zauberer alle Tiere einer bestimmten Art innerhalb einer Reichweite von 3m/Stufe kontrollieren (z.B. könnten Sie auf der 30. Stufe alle Frettchen und Nerze im Umkreis von 90m kontrollieren)"
                    },
                    {
                        "name": "Wahrhaftige Tierbeherrschung",
                        "level": 50,
                        "value": "Wie Tierbeherrschung I, allerdings ist die Dauer permanent und es ist keine Konzentration nötig. Der Zauberer kann zu jeder Zeit nur ein Tier auf einmal durch diesen Spruch beherrschen."
                    }
                ]
            },
            {
                "id": "0.3",
                "name": "8.1.4: Meisterschaft der Entdeckung",
                "spells": [
                    {
                        "name": "Leitmagie entdecken",
                        "level": 1,
                        "value": "Entdeckt alle aktiven Sprüche oder magische Gegenstände der Leitmagie"
                    },
                    {
                        "name": "Essenz entdecken",
                        "level": 2,
                        "value": "Wie Leitmagie entdecken, nur ist der Magiebereich der der Essenz"
                    },
                    {
                        "name": "Mentalismus entdecken",
                        "level": 3,
                        "value": "Wie Leitmagie entdecken, nur ist der Magiebereich der des Mentalismus"
                    },
                    {
                        "name": "Leben entdecken",
                        "level": 4,
                        "value": "Wie Leitmagie entdecken, nur entdeckt der Spruch Lebewesen"
                    },
                    {
                        "name": "Fluch entdecken",
                        "level": 5,
                        "value": "Wie Leitmagie entdecken, nur entdeckt der Spruch Flüche, die auf Gegenständen oder Leuten liegen"
                    },
                    {
                        "name": "Untote entdecken",
                        "level": 6,
                        "value": "Wie Leitmagie entdecken, nur entdeckt der Spruch die Anwesenheit von Untoten"
                    },
                    {
                        "name": "Fallen entdecken",
                        "level": 7,
                        "value": "Wie Leitmagie entdecken, nur verleiht dieser Spruch eine 75% Chance, Fallen zu finden (je nachdem, wie ausgefeilt die Falle ist, kann die Chance nach unten oder oben modifiziert werden)"
                    },
                    {
                        "name": "Leben analysieren",
                        "level": 8,
                        "value": "Wie Leitmagie entdecken, nur analysiert der Spruch ein Lebewesen und liefert dessen Volk, Alter und derzeitigen Gesundheitsstand"
                    },
                    {
                        "name": "Unsichtbares entdecken",
                        "level": 9,
                        "value": "Wie Leitmagie entdecken, nur entdeckt der Spruch unsichtbare Dinge. Angriffe auf unsichtbare Ziele erleiden einen Malus von -50 (statt der normalen -100)"
                    },
                    {
                        "name": "Macht analysieren",
                        "level": 10,
                        "value": "Wie Leitmagie entdecken, nur liefert der Spruch außerdem eine Schätzung der Macht (z.B. der Stufe) der Person, des Gegenstands oder des Spruches, den man untersucht"
                    },
                    {
                        "name": "Gift analysieren",
                        "level": 11,
                        "value": "Wie Leitmagie entdecken, nur gibt der Spruch eine Analyse jedweden Gifts in einem einzelnen Gegenstand oder Wesen"
                    },
                    {
                        "name": "Macht bestimmen",
                        "level": 13,
                        "value": "Wie Leitmagie entdecken, nur analysiert der Spruch allgemein die Klasse des gewirkten oder in einem Gegenstand vorhandenen Spruchs und gibt an, von welcher Spruchliste er stammt. Wird eine Person untersucht, liefert er den genauen Beruf"
                    },
                    {
                        "name": "Spruch entdecken",
                        "level": 15,
                        "value": "Wie Leitmagie entdecken, nur entdeckt er jeden Spruch, der jemals in dem untersuchten Gebiet gesprochen wurde"
                    },
                    {
                        "name": "Macht analysieren II",
                        "level": 17,
                        "value": "Wie Macht analysieren, nur hat der Spruch eine Reichweite von 150m und einen Wirkungsbereich von 15m Radius"
                    },
                    {
                        "name": "Wiederfinden",
                        "level": 18,
                        "value": "Liefert die Richtung und Entfernung zu jedem bestimmten Gegenstand oder Ort, mit dem der Zauberer vertraut ist oder von dem er eine genaue Beschreibung hat. Der Zauberer muß die Ausmaße des Gegenstandes bis auf eine maximale Abweichung von 10% der tatsächlichen Größe genau wissen und muß mindestens noch zwei weitere Eigenschaften des Gegenstandes kennen, die ihn unverwechselbar machen (z.B. Farbe, Oberflächenbeschaffenheit, Gewicht etc.)"
                    },
                    {
                        "name": "Fluch analysieren",
                        "level": 20,
                        "value": "Wie Leitmagie entdecken, nur daß die Stufe, die Wirkung und Mittel, den Fluch zu bannen, herausgefunden werden können"
                    },
                    {
                        "name": "Lebensanalyse",
                        "level": 25,
                        "value": "Wie Leben analysieren, allerdings liefert dieser Spruch den genauen Beruf, die Gesinnung und andere wesentliche Details"
                    },
                    {
                        "name": "Wahrhaftiges Entdecken",
                        "level": 30,
                        "value": "Wie Leitmagie entdecken, allerdings kann einmal pro Runde jedweder andere Spruch dieser Liste angewendet werden"
                    },
                    {
                        "name": "Wahrhaftiges Wiederfinden",
                        "level": 50,
                        "value": "Wie Wiederfinden, nur liegt die Reichweite bei 2 km pro Stufe."
                    }
                ]
            },
            {
                "id": "0.4",
                "name": "8.1.5: Reinigung",
                "spells": [
                    {
                        "name": "Reinigung von Krankheit",
                        "level": 1,
                        "value": "Stoppt Infektion und/oder Ausbreitung einer Krankheit in einem Ziel, das bereits darunter leidet. Es entsteht kein weiterer Schaden in noch unbetroffenen Körperteilen"
                    },
                    {
                        "name": "Nahrungskonservierung",
                        "level": 2,
                        "value": "Dieser Spruch macht eine Tagesration an Nahrung für eine Woche vollkommen haltbar, danach verdirbt sie normal"
                    },
                    {
                        "name": "Reinigung von Gift",
                        "level": 3,
                        "value": "Neutralisiert ein beliebiges Gift im Körper des Ziels. Bereits erlittener Schaden wird nicht geheilt 4. Widerstand gegen Krankheiten I"
                    },
                    {
                        "name": "Widerstand gegen Gift I",
                        "level": 5,
                        "value": "Während der Spruchdauer erhält das Ziel einen zusätzlichen WW gegen Gift(e)"
                    },
                    {
                        "name": "Reinigung von Tagesvorräten",
                        "level": 6,
                        "value": "Dieser Spruch neutralisiert Krankheitserreger, Gifte oder ähnliche Substanzen in einer Tagesration an Nahrung und/oder Wasser, wenn sie dort nicht normal auftreten. Der Spruch neutralisiert kein Gift oder eine ähnliche Substanz, wenn sie ein natürlicher Bestandteil dieser Nahrung ist (z.B. würde er nicht das Gift in Giftpilzen neutralisieren)"
                    },
                    {
                        "name": "Widerstand gegen Krankheiten II",
                        "level": 7,
                        "value": "Wie Widerstand gegen Krankheiten I, nur erhält das Ziel 2 zusätzliche Widerstandswürfe"
                    },
                    {
                        "name": "Widerstand gegen Gift II",
                        "level": 8,
                        "value": "Wie Widerstand gegen Gift I, nur erhält das Ziel 2 zusätzliche Widerstandswürfe"
                    },
                    {
                        "name": "Geisteskrankheit heilen",
                        "level": 10,
                        "value": "Das Ziel wird von einer beliebigen Geisteskrankheit geheilt"
                    },
                    {
                        "name": "Widerstand gegen Krankheiten III",
                        "level": 11,
                        "value": "Wie Widerstand gegen Krankheiten I, nur erhält das Ziel 3 zusätzliche Widerstandswürfe"
                    },
                    {
                        "name": "Widerstand gegen Gift III",
                        "level": 12,
                        "value": "Wie Widerstand gegen Gift I, nur erhält das Ziel 3 zusätzliche Widerstandswürfe"
                    },
                    {
                        "name": "Krankheit heilen",
                        "level": 14,
                        "value": "Der Zauberer kann das Ziel von einer beliebigen Krankheit heilen"
                    },
                    {
                        "name": "Entgiften",
                        "level": 15,
                        "value": "Der Zauberer kann ein beliebiges Gift aus dem Ziel entfernen"
                    },
                    {
                        "name": "Massen-Heilung von Krankheit",
                        "level": 18,
                        "value": "Der Zauberer kann seine Stufe in Zielen von einer beliebigen Krankheit heilen"
                    },
                    {
                        "name": "Massen-Entgiftung",
                        "level": 19,
                        "value": "Der Zauberer kann ein beliebiges Gift aus dem Körper einer Anzahl von Zielen entfernen, die seiner Stufe entspricht"
                    },
                    {
                        "name": "Wahrhaftige Geisteskrankheitsheilung",
                        "level": 20,
                        "value": "Wie Geisteskrankheit heilen, allerdings tritt die Genesung sofort ein"
                    },
                    {
                        "name": "Starke Reinigung von Krankheiten",
                        "level": 25,
                        "value": "Alle Krankheiten innerhalb der Reichweite werden geheilt"
                    },
                    {
                        "name": "Starke Reinigung von Gift",
                        "level": 30,
                        "value": "Alles Gift innerhalb der Reichweite wird neutralisiert"
                    },
                    {
                        "name": "Wahrhaftige Reinigung",
                        "level": 50,
                        "value": "Beseitigt alle Krankheiten und Gifte innerhalb der Reichweite."
                    }
                ]
            },
            {
                "id": "0.5",
                "name": "8.1.6: Wege der Heilung",
                "spells": [
                    {
                        "name": "Heilung I",
                        "level": 1,
                        "value": "1W10 Treffer des Ziels werden geheilt"
                    },
                    {
                        "name": "Erfrierungen/Verbrennungen I",
                        "level": 2,
                        "value": "Heilt bei einem Ziel und in einem Bereich einen leichten Frostbrand oder eine Verbrennung ersten Grades"
                    },
                    {
                        "name": "Leichte Beschwerden heilen",
                        "level": 3,
                        "value": "Heilt eine leichte Beschwerde eines Ziels (Kopfschmerzen, Zahnschmerzen, Insektenstich, Kater usw.)"
                    },
                    {
                        "name": "Heilung III",
                        "level": 4,
                        "value": "Wie Heilung I, nur werden 3W10 Treffer des Ziels geheilt"
                    },
                    {
                        "name": "Benommenheit heilen",
                        "level": 5,
                        "value": "Heilt eine Runde Benommenheit des Ziels"
                    },
                    {
                        "name": "Erfrierungen/Verbrennungen II",
                        "level": 6,
                        "value": "Wie Erfrierungen/Verbrennungen I, nur kann der Zauberer 2 Bereiche mit leichter Erfrierung/Verbrennung heilen oder mittleren Erfrierungs-/Verbrennungsschaden in einem Bereich (z.B. eine Verbrennung zweiten Grades)"
                    },
                    {
                        "name": "Regeneration I",
                        "level": 7,
                        "value": "Reduziert die Treffer des Zieles um einen pro Minute, solange sich der Zauberer konzentriert. Wenn der Zauberer bewußtlos ist, wirkt dieser Spruch auch ohne Konzentration bei ihm"
                    },
                    {
                        "name": "Heilung V",
                        "level": 8,
                        "value": "Wie Heilung I, nur werden 5W10 Treffer des Ziels geheilt"
                    },
                    {
                        "name": "Erfrierungen/Verbrennungen III",
                        "level": 9,
                        "value": "Wie Er - frierungen/Verbrennungen I, nur kann der Zauberer 3 Bereiche mit schwacher Erfrierung/Verbrennung heilen oder schweren Erfrierungs-/Verbrennungsschaden in einem Bereich (z.B. eine Verbrennung 2. Grades) oder eine Kombination aus einem Bereich mit leichter und einem mit mittleren Erfrierung/Verbrennung"
                    },
                    {
                        "name": "Aufwecken",
                        "level": 10,
                        "value": "Das Ziel wacht sofort auf"
                    },
                    {
                        "name": "Heilung VII",
                        "level": 11,
                        "value": "Wie Heilung I, nur werden 7W10 Treffer des Ziels geheilt"
                    },
                    {
                        "name": "Regeneration II",
                        "level": 12,
                        "value": "Wie Regeneration I, nur reduzieren sich die Treffer des Ziels um zwei pro Minute, in der sich der Zauberer konzentriert"
                    },
                    {
                        "name": "Erfrierungen/Verbrennungen IV",
                        "level": 13,
                        "value": "Wie Erfrierungen/Verbrennungen I, nur kann der Zauberer 4 Bereiche mit leichter Erfrierung/Verbrennung oder 2 mit mittlerer oder einen mit leichter und einen mit schwerer oder 2 mit leichter und einen mit mittlerer Verbrennung heilen"
                    },
                    {
                        "name": "Heilung X",
                        "level": 15,
                        "value": "Wie Heilung I, nur werden 10W10 Treffer des Ziels geheilt"
                    },
                    {
                        "name": "Fern-Benommenheitsheilung",
                        "level": 17,
                        "value": "Wie Benommenheit heilen, nur hat der Spruch eine Reichweite von 30m"
                    },
                    {
                        "name": "Regeneration III",
                        "level": 18,
                        "value": "Wie Regeneration I, nur reduzieren sich die Treffer des Ziels um 3 pro Minute"
                    },
                    {
                        "name": "Heilung XV",
                        "level": 20,
                        "value": "Wie Heilung I, nur werden 15W10 Treffer des Ziels geheilt"
                    },
                    {
                        "name": "Regeneration V",
                        "level": 25,
                        "value": "Wie Regeneration I, nur reduzieren sich die Treffer des Ziels um fünf pro Minute"
                    },
                    {
                        "name": "Wahrhaftige Heilung",
                        "level": 30,
                        "value": "Wie Heilung I, nur werden alle Treffer des Ziels geheilt"
                    },
                    {
                        "name": "Wahrhaftige Massen-Heilung",
                        "level": 50,
                        "value": "Erlaubt dem Zauberer, alle Treffer einer Anzahl von Zielen zu heilen, die seiner Stufe entspricht."
                    }
                ]
            },
            {
                "id": "0.6",
                "name": "8.1.7: Wege des Lichts",
                "spells": [
                    {
                        "name": "Lichtstrahl",
                        "level": 1,
                        "value": "Aus der Handfläche des Zauberers entspringt ein Lichtkegel (wie der einer Taschenlampe) mit einer effektiven Reichweite von 15m. Wenn der Zauberer seine Hand zur Faust ballt, schaltet er das Licht „aus“. Öffnet er sie wieder, ist das Licht wieder da (sofern die Dauer noch nicht abgelaufen ist)"
                    },
                    {
                        "name": "Licht I",
                        "level": 2,
                        "value": "Erhellt einen Umkreis von 3 Metern um den berührten Punkt. Wenn dieser Punkt auf einem beweglichen Gegenstand oder Wesen liegt, so bewegt sich das Licht mit ihm"
                    },
                    {
                        "name": "Aura",
                        "level": 3,
                        "value": "Erzeugt eine strahlende Aura um das Ziel, die es mächtiger erscheinen läßt, was einen Malus von -10 auf alle Angriffe gegen es zur Folge hat"
                    },
                    {
                        "name": "Licht II",
                        "level": 4,
                        "value": "Wie Licht I, nur daß 2 Lichtbereiche erschaffen werden können, die zusammen einen Radius von bis zu 6 Metern haben können (z.B. ein Bereich mit 6m Radius oder zwei mit je 3m Radius)"
                    },
                    {
                        "name": "Lichtblitz",
                        "level": 5,
                        "value": "Verursacht einen grellen Lichtblitz mit einem Radius von 3 Metern. Alle innerhalb des Radius sind 1 Runde/ 10 Fehlschlag lang benommen"
                    },
                    {
                        "name": "Wahrhaftige Aura",
                        "level": 6,
                        "value": "Wie Aura, nur läßt der Spruch das Ziel sehr mächtig erscheinen, was einen Malus von -15 auf alle Angriffe gegen es zur Folge hat"
                    },
                    {
                        "name": "Schockstrahl",
                        "level": 7,
                        "value": "Ein Strahl intensiven, geladenen Lichts schießt aus der Handfläche des Zauberers hervor. Das Ergebnis wird auf der Schockstrahl-Angriffstabelle 12.8 (Seite 245) ausgewürfelt"
                    },
                    {
                        "name": "Licht III",
                        "level": 8,
                        "value": "Wie Licht II, nur können bis zu 3 Lichtbereiche mit einem Gesamtradius von 9 Metern erschaffen werden"
                    },
                    {
                        "name": "Pures Licht I",
                        "level": 9,
                        "value": "Wie Licht I, nur ist es so hell wie volles Tageslicht und hebt auch magisch erschaffene Dunkelheit für die Dauer des Spruches auf"
                    },
                    {
                        "name": "Wartendes Licht",
                        "level": 10,
                        "value": "Wie Licht I, allerdings kann der Zauberer den Spruch um bis zu 24 Stunden verzögern. Er wird dann durch eine der folgenden Bedingungen ausgelöst (vom Zauberer festgelegt): Verstreichen einer Zeitspanne, bestimmte Bewegungen, bestimmte Geräusche oder Berührung"
                    },
                    {
                        "name": "Leuchtkugel",
                        "level": 11,
                        "value": "Eine Lichtkugel von 2 cm Radius schießt aus der Handfläche des Zauberers hervor. Sie bewegt sich bis zum Ende der Spruchreichweite, explodiert wie eine Leuchtkugel, brennt mit hellem Licht und sinkt langsam zu Boden, wo sie erlischt. Wenn die Kugel bis zu der vollen Spruchreichweite aufsteigen kann, erhellt sie ein Gebiet mit der Reichweite als Radius. Wenn sie gegen ein Ziel geschossen wird, verwenden Sie die Schockstrahl-Angriffstabelle 12.8 (Seite 245), allerdings verursacht sie Kritische Hitzetreffer"
                    },
                    {
                        "name": "Licht V",
                        "level": 13,
                        "value": "Wie Licht II, nur daß bis zu 5 Lichtbereiche mit einem Gesamtradius von 15 Metern erschaffen werden können"
                    },
                    {
                        "name": "Licht X",
                        "level": 15,
                        "value": "Wie Licht II, aber es können bis zu 10 Lichtbereiche mit einem Gesamtradius von 30 Metern erschaffen werden"
                    },
                    {
                        "name": "Pures Licht V",
                        "level": 17,
                        "value": "Wie Pures Licht I, nur können bis zu 5 Lichtbereiche mit einem Gesamtradius von 15 Metern erschaffen werden"
                    },
                    {
                        "name": "Massen-Licht",
                        "level": 18,
                        "value": "Wie Licht II, nur ist der Gesamtradius 3m/Stufe"
                    },
                    {
                        "name": "Massen-Aura",
                        "level": 20,
                        "value": "Wie Aura, nur können die Stufe des Zauberers an Zielen betroffen werden"
                    },
                    {
                        "name": "Blitz rufen",
                        "level": 25,
                        "value": "Der Zauberer kann bewirken, daß ein Blitz in ein Ziel innerhalb der Reichweite einschlägt. Die Ergebnisse werden über die BlitzschlagAngriffstabelle bestimmt. Hierzu muß im Umkreis von 2 km ein Sturm toben, der so stark ist, daß er sich in heftigem Niederschlag, Blitzen oder sehr starkem Wind äußert. Der Zauberer muß im Freien sein, um diesen Spruch zu wirken"
                    },
                    {
                        "name": "Alkar",
                        "level": 30,
                        "value": "Wie Aura, nur wirkt das Ziel wie ein niederer Gott und der Malus liegt bei -25"
                    },
                    {
                        "name": "Pures Massen-Licht",
                        "level": 50,
                        "value": "Wie Pures Licht I, nur kann der Zauberer eine Anzahl an Lichtbereichen erschaffen, die seiner Stufe entspricht und deren Gesamtradius bei 3m /Stufe liegt."
                    }
                ]
            },
            {
                "id": "0.7",
                "name": "8.1.8: Wege des Reisens",
                "spells": [
                    {
                        "name": "Gehen auf Kanten",
                        "level": 2,
                        "value": "Das Ziel kann auf schmalen Kanten (Mindestbreite 6cm) gehen, sofern sie sein Gewicht tragen können. Normalerweise sind keine Manöverwürfe nötig"
                    },
                    {
                        "name": "Gehen auf Ästen",
                        "level": 4,
                        "value": "Das Ziel kann so auf den Ästen der Bäume entlang gehen, als würde es sich ebenerdig bewegen"
                    },
                    {
                        "name": "Gehen auf Stein",
                        "level": 5,
                        "value": "Das Ziel kann auf Steinoberflächen mit bis zu 60° Steigung gehen, als würde es sich ebenerdig bewegen"
                    },
                    {
                        "name": "Gehen auf Wasser",
                        "level": 6,
                        "value": "Das Ziel kann über Wasser gehen, als würde er sich ebenerdig bewegen. Dieser Spruch wirkt nicht auf unruhigem Wasser"
                    },
                    {
                        "name": "Organisches Verschmelzen",
                        "level": 7,
                        "value": "Das Ziel kann mit totem oder lebendigem organischen Material verschmelzen. Während es so verschmolzen ist, kann es sich nicht bewegen und nimmt nichts wahr. Wenn es wieder hervorkommt, kann es das auf einer beliebigen Seite des Materials tun. Das Ziel kann sich nicht durch Material hindurchbewegen, das breiter ist als sein eigener Körper plus 60cm"
                    },
                    {
                        "name": "Zuflucht speichern",
                        "level": 8,
                        "value": "Der Zauberer speichert einen Ort, um ihn mit anderen Sprüchen dieser Liste zu verwenden. Während er diesen Spruch wirkt, muß der Zauberer eine Stunde lang an dem Ort meditieren, den er speichern will. Der Zauberer kann immer nur eine Zuflucht gespeichert haben. Solange dieser Ort gespeichert bleibt, wird er von Sprüchen als ein magischer (heiliger) Ort erkannt"
                    },
                    {
                        "name": "Laufen auf Ästen",
                        "level": 9,
                        "value": "Wie Gehen auf Ästen, nur kann das Ziel laufen"
                    },
                    {
                        "name": "Laufen auf Stein",
                        "level": 10,
                        "value": "Wie Gehen auf Stein, nur kann das Ziel laufen"
                    },
                    {
                        "name": "Laufen auf Wasser",
                        "level": 11,
                        "value": "Wie Gehen auf Wasser, nur kann das Ziel laufen"
                    },
                    {
                        "name": "Gehen auf Wind",
                        "level": 12,
                        "value": "Das Ziel kann auf ruhigem Wind gehen. Dieser Spruch erlaubt nur horizontale Fortbewegung, vertikale muß über andere Mittel erreicht werden"
                    },
                    {
                        "name": "Rückkehr I",
                        "level": 13,
                        "value": "Der Zauberer kann zu einer Zuflucht zurückkehren, die er gespeichert hat, solange der Ort nicht weiter als 2 km entfernt ist"
                    },
                    {
                        "name": "Vollendetes Organisches Verschmelzen",
                        "level": 15,
                        "value": "Wie Verschmelzen mit Organischem, nur kann sich das Ziel in dem Material umdrehen und die Welt draußen wahrnehmen"
                    },
                    {
                        "name": "Rückkehr V",
                        "level": 16,
                        "value": "Wie Rückkehr I, nur kann der Zufluchtsort bis zu 8 km entfernt sein"
                    },
                    {
                        "name": "Laufen auf Wind",
                        "level": 18,
                        "value": "Wie Gehen auf Wind, nur kann das Ziel laufen"
                    },
                    {
                        "name": "Rückkehr X",
                        "level": 19,
                        "value": "Wie Rückkehr I, nur kann der Zufluchtsort bis zu 16 km entfernt sein"
                    },
                    {
                        "name": "Wahrhaftiges Organisches Verschmelzen",
                        "level": 20,
                        "value": "Wie Vollendetes Organisches Verschmelzen, nur kann das Ziel Sprüche wirken, während es verschmolzen ist"
                    },
                    {
                        "name": "Wahrhaftiges Laufen auf Wind",
                        "level": 25,
                        "value": "Wie Laufen auf Wind, nur kann das Ziel doppelt so schnell auf ruhiger Luft laufen, ohne Energie aufzuwenden"
                    },
                    {
                        "name": "Wort der Rückkehr",
                        "level": 30,
                        "value": "Wie Rückkehr I, nur kann der Zufluchtsort bis zu 16 km/Stufe entfernt sein"
                    },
                    {
                        "name": "Zweifache Rückkehr",
                        "level": 50,
                        "value": "Der Zauberer kann zu seinem Zufluchtsort zurückkehren (wie bei Wort der Rückkehr), dort eine Runde pro Stufe bleiben und dann zu dem Punkt zurückkehren, an dem er den Spruch wirkte (womit es eine Rundreise wird)."
                    }
                ]
            },
            {
                "id": "0.8",
                "name": "8.1.9: Wege des Schalls",
                "spells": [
                    {
                        "name": "Sprache I",
                        "level": 1,
                        "value": "Das Ziel kann sehr einfache Vorstellungen in der Sprache (z.B. Hunger, Durst, Toilette, Frieden usw.) eines bestimmten Wesens mitteilen. Für die Spruchdauer spricht das Ziel die Sprache wie mit einem Fertigkeitsrang von 2"
                    },
                    {
                        "name": "Ruhe I",
                        "level": 3,
                        "value": "Erzeugt einen Bereich von 30cm Radius um das Ziel, durch den Schall weder hinein noch hinaus dringen kann. Wird der Spruch auf ein bewegliches Objekt oder Wesen gewirkt, so bewegt sich die Wirkung mit ihm. Dies bringt einen Bonus von +25 auf Schleichen"
                    },
                    {
                        "name": "Schallbarriere I",
                        "level": 5,
                        "value": "Erzeugt eine bis zu 6m x 6m messende Fläche, durch die kein Schall dringt"
                    },
                    {
                        "name": "Sprache II",
                        "level": 6,
                        "value": "Wie Sprache I, nur kann das Ziel komplexere Gedanken ausdrücken. Allerdings ist die Wahrscheinlichkeit hoch, daß Mißverständnisse auftreten. Für die Spruchdauer spricht das Ziel die Sprache wie mit einem Fertigkeitsrang von 4"
                    },
                    {
                        "name": "Stille I",
                        "level": 7,
                        "value": "Wie Ruhe I, nur wirkt der Spruch in einem Radius von 3 Metern"
                    },
                    {
                        "name": "Ruhe III",
                        "level": 8,
                        "value": "Wie Ruhe I, nur kann der Spruch auf 3 Ziele gewirkt werden"
                    },
                    {
                        "name": "Schallbarriere V",
                        "level": 10,
                        "value": "Wie Schallbarriere I, nur können 5 solcher Flächen erschaffen werden. Jeder der Barrieren muß mit mindestens einer anderen verbunden sein"
                    },
                    {
                        "name": "Ruhe V",
                        "level": 11,
                        "value": "Wie Ruhe I, nur kann der Spruch auf 5 Ziele gewirkt werden"
                    },
                    {
                        "name": "Stille V",
                        "level": 13,
                        "value": "Wie Stille I, nur wirkt der Spruch in einem Radius von 15 Metern"
                    },
                    {
                        "name": "Sprache III",
                        "level": 15,
                        "value": "Wie Sprache I, nur kann das Ziel die Sprache einigermaßen fließend sprechen. Das Ziel spricht mit Akzent, aber die Wahrscheinlichkeit, daß Mißverständnisse auftreten, ist gering. Für die Spruchdauer spricht das Ziel die Sprache wie mit einem Fertigkeitsrang von 6"
                    },
                    {
                        "name": "Schreien",
                        "level": 17,
                        "value": "Das Ziel kann fünfmal lauter als normal sprechen"
                    },
                    {
                        "name": "Stille X",
                        "level": 20,
                        "value": "Wie Stille I, nur hat der Spruch einen Radius von 30 Metern"
                    },
                    {
                        "name": "Massen-Schallbarrieren",
                        "level": 25,
                        "value": "Wie Schallbarriere I, nur können so viele Barrieren erschaffen werden, wie der Zauberer Stufen hat"
                    },
                    {
                        "name": "Massen-Ruhe",
                        "level": 30,
                        "value": "Wie Ruhe I, nur können so viele Ziele betroffen werden, wie der Zauberer Stufen hat"
                    },
                    {
                        "name": "Wahrhaftige Sprache",
                        "level": 50,
                        "value": "Wie Sprache III, bis auf die Dauer und darauf, daß das Ziel die Sprache wie ein Muttersprachler spricht. Für die Spruchdauer spricht das Ziel die Sprache wie mit einem Fertigkeitsrang von 8."
                    }
                ]
            },
            {
                "id": "0.9",
                "name": "8.1.10: Wege des Wetters",
                "spells": [
                    {
                        "name": "Lebendes Barometer",
                        "level": 1,
                        "value": "Der Zauberer kann der ihn umgebenden Atmosphäre Informationen entnehmen. Dies beinhaltet: Temperatur, Luftfeuchtigkeit, Luftdruck und Windgeschwindigkeit. In jeder Runde kann der Zauberer einen dieser Punkte abfragen"
                    },
                    {
                        "name": "Regen vorhersagen",
                        "level": 2,
                        "value": "Verleiht dem Zauberer eine 95%-Chance, für die folgenden 24h die Art und den Zeitpunkt von Niederschlägen auf ±15min genau vorherzusagen"
                    },
                    {
                        "name": "Sturm vorhersagen",
                        "level": 4,
                        "value": "Wie Regen vorhersagen, aber der Spruch verleiht eine 95%-Chance, für die folgenden 24h den Zeitpunkt und die Art eines Sturms auf ±15min genau vorherzusagen"
                    },
                    {
                        "name": "Wettervorhersage I",
                        "level": 5,
                        "value": "Wie Regen vorhersagen, aber der Spruch verleiht eine 95%-Chance, für die folgenden 24h den Zeitpunkt, die Art und die Schwere des Wetters auf ±15min genau vorherzusagen"
                    },
                    {
                        "name": "Brise",
                        "level": 7,
                        "value": "Der Zauberer erzeugt eine Brise, die alle Gase (Wolken usw.) davon bläst und alle Fernkampfangriffe um -10 erschwert, die in den Wirkungsbereich hinein, aus ihm heraus oder durch in hindurch gehen. Sobald die Windrichtung der Brise festgelegt wurde, ändert sie sich nicht mehr"
                    },
                    {
                        "name": "Nebel",
                        "level": 8,
                        "value": "Der Zauberer läßt Nebel aufsteigen, der innerhalb des Wirkungsbereiches und durch ihn hindurch die Sicht trübt. Alle Fernkampfangriffe in den Nebel hinein oder aus ihm heraus gehen, sind um -10 bis -50 erschwert (SL-Entscheidung). In Abschnitt 5.12 (Seite 39) finden Sie mehr zu Nebel"
                    },
                    {
                        "name": "Wettervorhersage III",
                        "level": 10,
                        "value": "Wie Wettervorhersage I, nur hat der Zauberer eine 95%-Chance, das Wetter der nächsten 3 Tage vorauszusagen"
                    },
                    {
                        "name": "Niederschlag",
                        "level": 11,
                        "value": "Der Zauber läßt es schneien oder regnen (je nach Temperatur). Der Niederschlag trübt die Sicht in den Wirkungsbereich um 25%, und alle Fernkampfangriffe, die durch irgendeinen Teil dieses Gebiets hindurchgehen, erleiden einen Malus von -25"
                    },
                    {
                        "name": "Wettervorhersage V",
                        "level": 13,
                        "value": "Wie Wettervorhersage I, nur hat der Zau - berer eine 95%-Chance, das Wetter der nächsten 5 Tage vorauszusagen"
                    },
                    {
                        "name": "Windbeherrschung",
                        "level": 15,
                        "value": "Der Zauberer kann die Geschwindigkeit und die Richtung des Winds kontrollieren. Er kann die Windgeschwindigkeit um 2 km/h mal seiner Stufe verringern oder erhöhen (wenn die Windgeschwindigkeit 30 km/h beträgt, kann ein 15-stufiger Zauberer sie neu auf irgend etwas zwischen 0 und 60 km/h festlegen). Wenn er die Windrichtung gegen einen Fernkampfangriff ausrichtet, kann er ihn für pro 2 km/h um -1 erschweren. Beachten Sie auch, daß der Zauberer auch die Richtung kontrollieren kann, in der sich Gase und/oder Wolken bewegen"
                    },
                    {
                        "name": "Klarer Himmel",
                        "level": 18,
                        "value": "Der Zauberer kann den Himmel von Dunst, Niederschlag, Wolken usw. befreien. Dieser Spruch hat keinen Einfluß auf den Wind"
                    },
                    {
                        "name": "Wahrhaftige Wettervorhersage",
                        "level": 19,
                        "value": "Wie Wettervorhersage I, nur hat der Zauberer eine 95%-Chance, das Wetter der nächsten 30 Tage vorauszusagen"
                    },
                    {
                        "name": "Regen",
                        "level": 20,
                        "value": "Der Zauberer kann mittelstarken Regen herbeirufen. Der Regen trübt Nahsicht um bis zu 20% und Fernsicht um bis zu 75%. Zusätzlich erleiden Fernkampfangriffe Abzüge. Kurzdistanzangriffe erleiden einen Malus von -25. Angriffe aus mittlerer Entfernung sind um -75 erschwert, und Angriffe aus hoher Entfernung sind unmöglich"
                    },
                    {
                        "name": "Wetter",
                        "level": 25,
                        "value": "Der Zauberer kann jeden niedrigeren Spruch auf dieser Liste wirken, allerdings ist dessen Wirkungsbereich dann auf 2 km erhöht"
                    },
                    {
                        "name": "Sturm",
                        "level": 30,
                        "value": "Der Zauberer kann einen Sturm herbeirufen, dessen maximale Windgeschwindigkeit seiner Stufe mal drei entspricht und dessen Heftigkeit seinen Wünschen entspricht. Die Auswirkungen werden je nach den Umständen unterschiedlich sein (SL-Entscheidung). Beispielsweise könnte ein Zauberer der 30. Stufe einen Gewittersturm mit starkem Regen und konstanter Windgeschwindigkeit von bis zu 90 km/h hervorrufen, und der SL könnte Zufallswürfe verlangen, um festzustellen, ob Ziele vom Blitz getroffen werden, wenn sie dem Sturm ausgesetzt sind"
                    },
                    {
                        "name": "Wetterbeherrschung",
                        "level": 50,
                        "value": "Der Zauberer kann die Wetterbedingungen für das Gebiet angeben. Er kann die Windgeschwindigkeit um 1,5 km/h pro Stufe verändern, die (Un-)wetterstärke festlegen und entscheiden, ob es neblig ist oder wie bewölkt es ist. Wenn er sich konzentriert, kann er Verlagerungen in den gewählten Mustern bewirken, aber es dauert mindestens eine Minute, bis die Veränderung eintritt."
                    }
                ]
            }
        ]
    },
    {
        "id": "1",
        "name": "Geschlossene Leitmagie",
        "spellLists": [
            {
                "id": "1.0",
                "name": "8.2.1: Gesetz des Blutes",
                "spells": [
                    {
                        "name": "Blutung stoppen I",
                        "level": 1,
                        "value": "Gestattet dem Zauberer, den Blutverlust eines Zieles um 1 Treffer/Runde zu reduzieren. Das Ziel darf nicht bewegt werden, ansonsten setzt der Blutverlust wieder in der ursprünglichen Geschwindigkeit ein"
                    },
                    {
                        "name": "Blutung stoppen III",
                        "level": 2,
                        "value": "Wie Blutung stoppen I, aber der Zauberer kann die Blutung einer Wunde um bis zu 3 Treffer/Runde reduzieren"
                    },
                    {
                        "name": "Gerinnung I",
                        "level": 3,
                        "value": "Gestattet dem Zauberer, den Blutverlust eines Ziels um 1 Treffer/Runde zu reduzieren. Das Ziel darf sich eine Stunde lang nur mit Gehgeschwindigkeit bewegen, ansonsten setzt der Blutverlust wieder in der ursprünglichen Geschwindigkeit ein"
                    },
                    {
                        "name": "Blutung stoppen V",
                        "level": 4,
                        "value": "Wie Blutung stoppen I, aber der Zauberer kann die Blutung einer Wunde um bis zu 5 Treffer/Runde reduzieren"
                    },
                    {
                        "name": "Gliedmaße erhalten",
                        "level": 5,
                        "value": "Gestattet, die Verwesung eines Körpergliedes aufzuhalten (selbst im abgetrennten Zustand). Dazu sind aber auch die gleichnamigen Sprüche der Listen Gesetz der Muskeln, Gesetz der Knochen und Gesetz der Nerven nötig. Alle vier Sprüche müssen auf die Gliedmaße angewendet werden, damit die Verwesung aufgehalten wird"
                    },
                    {
                        "name": "Blutung stillen I",
                        "level": 6,
                        "value": "Der Zauberer heilt eine Blutung vollständig, die einen Blutverlust von 1 Treffer/Runde verursacht"
                    },
                    {
                        "name": "Gerinnung III",
                        "level": 7,
                        "value": "Wie Gerinnung I, aber der Zauberer kann die Blutung eine Wunde stillen, die bis zu 3 Treffer/Runde verursacht"
                    },
                    {
                        "name": "Heilung kleiner Blutgefäße",
                        "level": 8,
                        "value": "Der Zauberer kann ein verletztes kleines Blutgefäß vollständig heilen (eine Ader, deren Blutung nicht mehr als 4 Treffer/Runde verursacht, keine Hauptschlagadern oder Venen)"
                    },
                    {
                        "name": "Blutung stillen III",
                        "level": 9,
                        "value": "Wie Blutung stillen I, aber der Zauberer kann Wunden heilen, die insgesamt zu einem Blutverlust von bis zu 3 Treffern pro Runde führen"
                    },
                    {
                        "name": "Heilung großer Blutgefäße",
                        "level": 10,
                        "value": "Der Zauberer kann ein verletztes Blutgefäß beliebiger Größe heilen, auch durchtrennte Schlagadern. Genesungszeit: 1-10 Tage, abhängig von der Größe des Blutgefäßes und Schwere der Verletzung. Als große Blutgefäße werden Adern bezeichnet, deren Durchtrennung zu einem Blutverlust von mehr als 4 Treffer/Runde führt"
                    },
                    {
                        "name": "Anfügen",
                        "level": 12,
                        "value": "Erlaubt dem Zauberer, ein abgetrenntes Körperglied wieder anzufügen. Damit die Gliedmaße wieder voll funktionstüchtig wird, müssen die AnfügenSprüche aus dem Gesetz der Muskeln, dem Gesetz der Knochen und dem Gesetz der Nerven zusätzlich auf die Gliedmaße gewirkt werden. Das Körperglied ist nach 1-10 Tagen wieder voll beweglich"
                    },
                    {
                        "name": "Wahrhaftiger Blutungsstopp",
                        "level": 13,
                        "value": "Wie Blutung stoppen I, nur daß jeglicher Blutverlust (also Treffer/ Runde) durch eine Wunde gestoppt wird"
                    },
                    {
                        "name": "Wahrhaftige Gerinnung",
                        "level": 14,
                        "value": "Wie Gerinnung I, nur daß jeglicher Blutverlust (also Treffer/Runde) durch eine Wunde gestoppt wird"
                    },
                    {
                        "name": "Blutgerinnsel auflösen",
                        "level": 16,
                        "value": "Erlaubt dem Zauberer, ein beliebiges Blutgerinnsel zu entfernen"
                    },
                    {
                        "name": "Wahrhaftige Blutungsstillung",
                        "level": 18,
                        "value": "Wie Blutung stillen I, nur stillt der Spruch jedwede Blutung und schließt eine Wunde"
                    },
                    {
                        "name": "Massen-Blutungsstopp",
                        "level": 20,
                        "value": "Wie Wahrhaftiger Blutungsstop, nur kann der Zauberer die Blutung einer Anzahl von Wunden stillen, die seiner Stufe entspricht (z.B. kann ein Zauberer der 20. Stufe die Blutung von 20 Wunden stoppen)"
                    },
                    {
                        "name": "Wahrhaftiges Anfügen",
                        "level": 25,
                        "value": "Wie Anfügen, nur ist das Körperglied bereits nach 10 Minuten wieder voll funktionstüchtig (vorausgesetzt, daß der Zauberer auch die anderen drei Wahrhaftiges Anfügen-Sprüche wirkt)"
                    },
                    {
                        "name": "Massen-Gerinnung",
                        "level": 30,
                        "value": "Wie Massen-Blutungsstopp, nur wird die Blutung so gestoppt wie in Wahrhaftige Gerinnung"
                    },
                    {
                        "name": "Massen-Blutheilung",
                        "level": 50,
                        "value": "Erlaubt dem Zauberer, die Blutung einer Wunde pro Stufe zu stoppen und diese vollständig zu heilen (ein Zauberer der 50. Stufe kann pro Spruch, den er wirkt, so 50 Wunden vollkommen heilen)."
                    }
                ]
            },
            {
                "id": "1.1",
                "name": "8.2.2: Gesetz der Knochen",
                "spells": [
                    {
                        "name": "Knochenkunde",
                        "level": 1,
                        "value": "Der Zauberer gewinnt ein vollständige Bild der Knochenschäden sowie der Werkzeuge und Methoden, die zu ihrer Heilung nötig sind"
                    },
                    {
                        "name": "Heilung einfacher Brüche",
                        "level": 3,
                        "value": "Erlaubt dem Zauberer, einen einzelnen einfachen Bruch zu heilen (keine komplexen Brüche, Trümmerbrüche, Gelenkschäden usw.). Die Genesungszeit beträgt einen Tag"
                    },
                    {
                        "name": "Knorpelheilung",
                        "level": 4,
                        "value": "Erlaubt dem Zauberer, die gesamte Knorpelmasse um ein Gelenk zu heilen. Die Genesungszeit beträgt einen Tag"
                    },
                    {
                        "name": "Gliedmaße erhalten",
                        "level": 5,
                        "value": "Erlaubt dem Zauberer, die Verwesung eines Köpergliedes aufzuhalten (selbst wenn es abgetrennt wurde). Hierzu müssen auch die gleichnamigen Sprüche der Listen Gesetz der Muskeln, Gesetz des Blutes und Gesetz der Nerven zusätzlich auf die Gliedmaße gewirkt werden"
                    },
                    {
                        "name": "Heilung komplexer Brüche",
                        "level": 6,
                        "value": "Wie Heilung einfacher Brüche, aber der Zauberer kann auch komplexe Brüche heilen. Die Genesungszeit beträgt einen Tag"
                    },
                    {
                        "name": "Schädelbruch heilen",
                        "level": 8,
                        "value": "Erlaubt dem Zauberer, eine einzelnen Schädelbruch (nicht jedoch TrümmerSchädelbrüche) zu heilen. Die Genesungszeit beträgt je nach Schwere der Verletzung 1-10 Tage"
                    },
                    {
                        "name": "Gelenkheilung",
                        "level": 10,
                        "value": "Erlaubt dem Zauberer, ein einzelnes, gebrochenes (nicht aber zertrümmertes) Gelenk zu heilen. Die Genesungszeit beträgt 1W10 Tage"
                    },
                    {
                        "name": "Wahrhaftige Heilung einfacher Brüche",
                        "level": 11,
                        "value": "Wie Heilung einfacher Brüche, nur tritt die Genesung sofort ein"
                    },
                    {
                        "name": "Anfügen",
                        "level": 12,
                        "value": "Erlaubt dem Zauberer, ein abgetrenntes Körperglied wieder anzufügen. Damit die Gliedmaße wieder voll funktionstüchtig wird, müssen die Anfügen-Sprüche aus dem Gesetz der Muskeln, dem Gesetz des Blutes und dem Gesetz der Nerven zusätzlich auf die Gliedmaße gewirkt werden. Das Körperglied ist nach 1-10 Tagen wieder voll beweglich"
                    },
                    {
                        "name": "Wahrhaftige Knorpelheilung",
                        "level": 13,
                        "value": "Wie Knorpelheilung, nur tritt die Genesung sofort ein 14. Wahrhaftige Heilung komplexer Brüche"
                    },
                    {
                        "name": "Wahrhaftige Schädelbruchheilung",
                        "level": 15,
                        "value": "Wie Schädelbruch heilen, nur tritt die Genesung sofort ein 16. Wahrhaftige Gelenkheilung"
                    },
                    {
                        "name": "Trümmerbruchheilung",
                        "level": 17,
                        "value": "Erlaubt dem Zauberer, einen beliebigen gebrochenen oder zertrümmerten Knochen zu heilen. Erfordert eine zehnminütige Operation und 1-10 Tage Genesung"
                    },
                    {
                        "name": "Massen-Heilung einfacher Brüche",
                        "level": 18,
                        "value": "Wie Heilung einfacher Brüche, nur heilt der Spruch einen einfachen Bruch pro Stufe des Zauberers. Der Spruch wirkt, solange sich der Zauberer konzentriert"
                    },
                    {
                        "name": "Massen-Knorpelheilung",
                        "level": 20,
                        "value": "Wie Massen-Heilung einfacher Brüche, abgesehen von der Reichweite und davon, daß dieser Zauber Knorpel heilt (wie in Knorpelheilung)"
                    },
                    {
                        "name": "Wahrhaftiges Anfügen",
                        "level": 25,
                        "value": "Wie Anfügen, nur ist das Körperglied bereits nach zehn Minuten wieder voll funktionstüchtig (vorausgesetzt, daß der Zauberer auch die anderen drei Wahrhaftiges Anfügen-Sprüche wirkt)"
                    },
                    {
                        "name": "Massen-Heilung komplexer Brüche",
                        "level": 30,
                        "value": "Wie MassenHeilung einfacher Brüche, abgesehen von der Reichweite und davon, daß dieser Spruch auch komplexe Knochenbrüche heilt"
                    },
                    {
                        "name": "Massen-Trümmerbruchheilung",
                        "level": 50,
                        "value": "Wie MassenHeilung einfacher Brüche, abgesehen von der Reichweite und davon, daß dieser Spruch auch komplexe Knochenbrüche und Trümmerbrüche heilt."
                    }
                ]
            },
            {
                "id": "1.2",
                "name": "8.2.3: Gesetz der Muskeln",
                "spells": [
                    {
                        "name": "Muskelkunde",
                        "level": 1,
                        "value": "Gibt ein vollständiges Bild der Muskelschäden sowie derjenigen Werkzeuge und Methode, die zur Heilung nötig sind. Der Zauberer erhält durch diesen Spruch nicht die Fertigkeiten, um die Heilung auszuführen"
                    },
                    {
                        "name": "Sehnenkunde",
                        "level": 2,
                        "value": "Wie Muskelkunde, aber das erworbene Wissen befaßt sich mit der Heilung von Sehnenverletzungen"
                    },
                    {
                        "name": "Verstauchung heilen",
                        "level": 3,
                        "value": "Gestattet, eine Verstauchung zu heilen. Genesungszeit: 1 Stunde"
                    },
                    {
                        "name": "Muskeln heilen I",
                        "level": 4,
                        "value": "Gestattet es dem Zauberer, einen verletzten Muskel zu heilen (nicht zu ersetzen). Genesungszeit: 1 Stunde"
                    },
                    {
                        "name": "Gliedmaße erhalten",
                        "level": 5,
                        "value": "Erlaubt dem Zauberer, die Verwesung eines Köpergliedes aufzuhalten (selbst wenn es abgetrennt wurde). Hierzu müssen auch die gleichnamigen Sprüche der Listen Gesetz der Knochen, Gesetz des Blutes und Gesetz der Nerven zusätzlich auf die Gliedmaße gewirkt werden"
                    },
                    {
                        "name": "Sehnen heilen I",
                        "level": 6,
                        "value": "Gestattet es dem Zauberer, eine verletzte Sehne zu heilen (nicht zu ersetzen). Genesungszeit: 1 Stunde"
                    },
                    {
                        "name": "Muskel heilen III",
                        "level": 9,
                        "value": "Wie Muskel heilen I, nur kann der Zauberer 3 verletzte Muskeln heilen, wenn auch nicht ersetzen. Die Genesungszeit beträgt eine Stunde"
                    },
                    {
                        "name": "Sehnen heilen III",
                        "level": 10,
                        "value": "Wie Sehnen heilen I, außer daß der Zauberer 3 verletzte Sehnen heilen kann"
                    },
                    {
                        "name": "Anfügen",
                        "level": 12,
                        "value": "Erlaubt dem Zauberer, ein abgetrenntes Körperglied wieder anzufügen. Damit die Gliedmaße wieder voll funktionstüchtig wird, müssen die Anfügen-Sprüche aus dem Gesetz der Knochen, dem Gesetz des Blutes und dem Gesetz der Nerven zusätzlich auf die Gliedmaße gewirkt werden. Das Körperglied ist nach 1-100 Tagen wieder voll beweglich"
                    },
                    {
                        "name": "Wahrhaftige Muskelheilung",
                        "level": 13,
                        "value": "Wie Muskel heilen I, nur tritt die Genesung sofort nach einer einminütigen „Operation“ ein (Konzentration des Zauberers)"
                    },
                    {
                        "name": "Wahrhaftige Sehnenheilung",
                        "level": 15,
                        "value": "Wie Sehnen heilen I, nur tritt die Genesung sofort nach einer einminütigen „Operation“ ein (Konzentration des Zauberers)"
                    },
                    {
                        "name": "Massen-Muskelheilung",
                        "level": 17,
                        "value": "Erlaubt dem Zauberer, einen Muskel pro Stufe zu heilen (d.h. ein Zauberer der 17. Stufe kann 17 Muskeln heilen). Der Spruch kann aufrechterhalten werden, solange sich der Zauberer konzentriert (z.B. kann ein Zauberer sich von Ziel zu Ziel bewegen, bis er die Anzahl an Muskeln geheilt hat). Genesungszeit: eine Stunde"
                    },
                    {
                        "name": "Massen-Sehnenheilung",
                        "level": 19,
                        "value": "Wie MassenMuskelheilung, nur daß der Zauberer Sehnen heilt"
                    },
                    {
                        "name": "Muskelregeneration",
                        "level": 20,
                        "value": "Erlaubt dem Zauberer, einen Muskel regenerieren zu lassen. Je nachdem, wieviel Muskelmasse erhalten war, dauert es 1-10 Stunden, bis der neue Muskel nachgewachsen ist"
                    },
                    {
                        "name": "Wahrhaftiges Anfügen",
                        "level": 25,
                        "value": "Wie Anfügen, nur ist das Körperglied bereits nach 10 Minuten wieder voll funktionstüchtig (vorausgesetzt, daß der Zauberer auch die anderen drei Wahrhaftiges Anfügen-Sprüche wirkt)"
                    },
                    {
                        "name": "Sehnenregeneration",
                        "level": 30,
                        "value": "Erlaubt dem Zauberer, eine Sehne regenerieren zu lassen. Je nachdem wieviel der Sehne erhalten war, dauert es 1-10 Stunden, bis die neue Sehne nachgewachsen ist"
                    },
                    {
                        "name": "Wahrhaftige Massen-Heilung (Muskel/Sehnen)",
                        "level": 50,
                        "value": "Wie Massen-Muskelheilung, nur heilt der Zauberer jedwede Kombination aus Muskel- und Sehnenschaden innerhalb einer Reichweite von 30m und die Genesung tritt sofort ein."
                    }
                ]
            },
            {
                "id": "1.3",
                "name": "8.2.4: Gesetz der Nerven",
                "spells": [
                    {
                        "name": "Nervenkunde",
                        "level": 1,
                        "value": "Gibt ein vollständiges Bild der Nervenschäden sowie derjenigen Werkzeuge und Methoden, die zur Heilung nötig sind. Der Zauberer erhält durch diesen Spruch nicht die Fertigkeiten, um die Heilung auszuführen"
                    },
                    {
                        "name": "Heilung leichter Nervenschäden",
                        "level": 4,
                        "value": "Erlaubt dem Zauberer, leichten Schaden an einem Nerv zu heilen. Erfordert eine Genesungszeit von einem Tag. Als leichter Schaden gilt ein Nervenschaden, der einen Malus von bis zu -20 hervorruft"
                    },
                    {
                        "name": "Gliedmaße erhalten",
                        "level": 5,
                        "value": "Erlaubt dem Zauberer, die Verwesung eines Köpergliedes aufzuhalten (selbst wenn es abgetrennt wurde). Hierzu müssen auch die gleichnamigen Sprüche der Listen Gesetz der Knochen, Gesetz des Blutes und Gesetz der Muskeln zusätzlich auf die Gliedmaße gewirkt werden"
                    },
                    {
                        "name": "Heilung schwerer Nervenschäden",
                        "level": 9,
                        "value": "Wie Heilung leichter Nervenschäden, aber jeglicher Nervenschaden wird geheilt. Mit diesem Spruch kann man jedoch keine Nerven heilen, die komplett zerstört wurden"
                    },
                    {
                        "name": "Lähmung aufheben",
                        "level": 10,
                        "value": "Mit diesem Spruch kann eine Lähmung aufgehoben werden"
                    },
                    {
                        "name": "Wahrhaftige Heilung leichter Nervenschäden",
                        "level": 11,
                        "value": "Wie Heilung leichter Nervenschäden, nur wird jeglicher Nervenschaden geheilt. Dieser Spruch heilt keine Nerven, die vollständig zerstört wurden"
                    },
                    {
                        "name": "Anfügen",
                        "level": 12,
                        "value": "Erlaubt dem Zauberer, ein abgetrenntes Körperglied wieder anzufügen. Damit die Gliedmaße wieder voll funktionstüchtig wird, müssen die Anfügen-Sprüche aus dem Gesetz der Knochen, dem Gesetz des Blutes und dem Gesetz der Nerven zusätzlich auf die Gliedmaße gewirkt werden. Das Körperglied ist nach 1-100 Tagen wieder voll beweglich"
                    },
                    {
                        "name": "Heilung leichter Gehirnschäden",
                        "level": 15,
                        "value": "Erlaubt dem Zauberer, leichte Gehirnschäden zu heilen (auch die Folgen eines Komas). Verlorene Erfahrung wird nicht wiederhergestellt (wieviel Prozent verloren gingen, hängt von der Schwere der Verletzung ab). Es ist eine einstündige Operation erforderlich. Genesungszeit: 1-10 Tage"
                    },
                    {
                        "name": "Wahrhaftige Heilung schwerer Nervenschäden",
                        "level": 16,
                        "value": "Wie Heilung schwerer Nervenschäden, nur ist keine Genesungszeit nötig"
                    },
                    {
                        "name": "Lähmung heilen",
                        "level": 18,
                        "value": "Erlaubt dem Zauberer, die Lähmung eines Ziels zu heilen (mit einer Genesungszeit von 1-10 Tagen). Die Lähmung muß durch einen Spruch oder durch eine Krankheit verursacht worden sein (nicht durch ein Gift)"
                    },
                    {
                        "name": "Psychose heilen",
                        "level": 19,
                        "value": "Erlaubt dem Zauberer, eine leichte Psychose eines Ziels zu heilen (mit einer Genesungszeit von 1-10 Tagen). Unter leichte Psychosen fallen leichte und mittelschwere Phobien (im Handbuch für Spielleiter finden Sie Näheres zu Geisteskrankheiten)"
                    },
                    {
                        "name": "Wahrhaftige MassenNervenheilung",
                        "level": 20,
                        "value": "Wie Wahrhaftige Heilung schwerer Nervenschäden, nur daß jeder gewirkte Spruch einen Nerv pro Stufe des Zauberers heilt"
                    },
                    {
                        "name": "Wahrhaftiges Anfügen",
                        "level": 25,
                        "value": "Wie Anfügen, nur ist das Körperglied bereits nach 10 Minuten wieder voll funktionstüchtig (vorausgesetzt, daß der Zauberer auch die anderen drei Wahrhaftiges Anfügen-Sprüche wirkt)"
                    },
                    {
                        "name": "Nervenregeneration",
                        "level": 30,
                        "value": "Erlaubt dem Ziel, einen Nerv regenerieren. Je nachdem, wieviel des Nervs erhalten war, dauert es 1-10 Stunden, bis der neue nachgewachsen ist"
                    },
                    {
                        "name": "Gehirnregeneration",
                        "level": 50,
                        "value": "Erlaubt es dem Ziel, verlorene Hirnmasse zu regenerieren. Je nachdem, wie stark beschädigt das Gehirn war, dauert es 10-100 Tage, bis sie nachgewachsen ist. Während der Genesung liegt das Ziel im Koma. Verlorene Erfahrung wird nicht wiederhergestellt (wieviel Prozent verloren gingen, hängt von der Schwere der Verletzung ab)."
                    }
                ]
            },
            {
                "id": "1.4",
                "name": "8.2.5: Gesetz der Organe",
                "spells": [
                    {
                        "name": "Organkunde",
                        "level": 1,
                        "value": "Gibt ein vollständiges Bild der Organschäden sowie derjenigen Werkzeuge und Methode, die zur Heilung nötig sind. Der Zauberer erhält durch diesen Spruch nicht die Fertigkeiten, um die Heilung auszuführen"
                    },
                    {
                        "name": "Nase heilen",
                        "level": 2,
                        "value": "Heilt alle Nasenverletzungen außer komplettem Verlust. Je nach Schwere der Verletzung dauert die Operation 5W100 Minuten"
                    },
                    {
                        "name": "Heilung leichter Ohrenschäden",
                        "level": 5,
                        "value": "Erlaubt dem Zauberer, Verletzungen des Außenohres zu heilen, einschließlich eines kompletten Verlustes (Regenerationszeit: 1W10 Stunden)"
                    },
                    {
                        "name": "Heilung leichter Augenschäden",
                        "level": 6,
                        "value": "Erlaubt es dem Zauberer, leichte Augenschäden zu heilen (z.B. eine Hornhautabschürfung oder ein Fremdkörper im Auge)"
                    },
                    {
                        "name": "Heilung schwerer Ohrenschäden",
                        "level": 9,
                        "value": "Wie Heilung leichter Ohrenschäden, aber der Spruch heilt jede Verletzung des Innen- oder des Außenohres. Das Gehör kehrt nach 1W10 Tagen zurück. Der komplette Austausch des Innenohres ist hier ausgenommen"
                    },
                    {
                        "name": "Heilung schwerer Augenschäden",
                        "level": 11,
                        "value": "Wie Heilung leichter Augenschäden, nur kann der Zauberer beliebige Augenschäden bis auf den völligen Verlust eines Auges heilen (d.h. die Zerstörung eines Auges verunmöglicht erhaltende Maßnahmen). Genesungszeit: 1-10 Tage"
                    },
                    {
                        "name": "Herz heilen",
                        "level": 14,
                        "value": "Erlaubt dem Zauberer, jeden beliebigen Herzfehler zu heilen, solange das Herz nicht zerstört wurde oder verloren ist (und ersetzt werden müßte). Es ist eine 1-10-stündige Operation nötig, und die Genesungszeit liegt bei 1-100 Tagen"
                    },
                    {
                        "name": "Lunge heilen",
                        "level": 15,
                        "value": "Erlaubt dem Zauberer, jeden beliebigen Lungenschaden zu heilen, solange die Lunge nicht zerstört wurde oder verloren ist (und ersetzt werden müßte). Es ist eine 1-10-stündige Operation nötig, und die Genesungszeit liegt bei 1-100 Tagen"
                    },
                    {
                        "name": "Organ heilen",
                        "level": 16,
                        "value": "Erlaubt dem Zauberer, einen beliebigen innerlichen oder äußerlichen Organschaden zu heilen (mit Ausnahme des Gehirns und des Nervensystems). Es ist eine 1-10-stündige Operation nötig, und die Genesungszeit liegt bei 1-10 Tagen"
                    },
                    {
                        "name": "Nasenregeneration",
                        "level": 17,
                        "value": "Erlaubt dem Ziel, seine verlorene Nase zu regenerieren. Es dauert 1-10 Tage, bis die neue Nase wieder gewachsen ist"
                    },
                    {
                        "name": "Organtransplantation",
                        "level": 18,
                        "value": "Erlaubt dem Zauberer, ein gesundes Organ zu transplantieren. Die Operation dauert eine Stunde. Genesungszeit: 1-10 Tage. Wenn der Spender dem gleichen Volk angehört wie das Ziel, besteht eine zehnprozentige Wahrscheinlichkeit, daß der Körper das Organ abstößt. Stammt der Spender aus einem anderen Humanoidenvolk, erhöht sie sich auf 50%"
                    },
                    {
                        "name": "Augen- und Ohrenregeneration",
                        "level": 20,
                        "value": "Erlaubt dem Ziel, ein verlorenes Auge oder Ohr (inklusive des Innenohrs) zu regenerieren. Je nachdem, wie groß der Verlust war, dauert es 1-10 Tage bis das neue Ohr bzw. Auge nachgewachsen ist"
                    },
                    {
                        "name": "Wahrhaftige Organheilung",
                        "level": 25,
                        "value": "Wie Organ heilen, nur beträgt die Genesungszeit 10 Minuten und es ist keine Operation nötig"
                    },
                    {
                        "name": "Herzregeneration",
                        "level": 30,
                        "value": "Erlaubt dem Ziel, sein Herz zu regenerieren. Es dauert es 1-10 Tage, bis das neue Herz nachgewachsen ist"
                    },
                    {
                        "name": "Organregeneration",
                        "level": 50,
                        "value": "Erlaubt dem Zauberer, ein beliebiges äußeres oder inneres Organ regenerieren zu lassen (ausschließlich des Gehirns und des Nervensystems). Es dauert es 1-10 Tage, bis das neue Organ nachgewachsen ist."
                    }
                ]
            },
            {
                "id": "1.5",
                "name": "8.2.6: Wege der Beruhigung",
                "spells": [
                    {
                        "name": "Tierberuhigung I",
                        "level": 1,
                        "value": "Das Tier handelt nicht aggressiv/offensiv und kämpft nur, wenn es angegriffen wird"
                    },
                    {
                        "name": "Beruhigung I",
                        "level": 2,
                        "value": "Das Ziel handelt nicht aggressiv/ offensiv und kämpft nur, wenn es angegriffen wird"
                    },
                    {
                        "name": "Tierberuhigung III",
                        "level": 3,
                        "value": "Wie Tierberuhigung I, nur können 3 Ziele betroffen werden"
                    },
                    {
                        "name": "Beruhigung II",
                        "level": 4,
                        "value": "Wie Beruhigung I, nur können 2 Ziele betroffen werden"
                    },
                    {
                        "name": "Handlung einschränken",
                        "level": 5,
                        "value": "Ein humanoides Ziel wird auf 25% seiner normalen Aktionsfähigkeit beschränkt"
                    },
                    {
                        "name": "Beruhigung III",
                        "level": 6,
                        "value": "Wie Beruhigung I, nur können 3 Ziele betroffen werden"
                    },
                    {
                        "name": "Tierberuhigung V",
                        "level": 7,
                        "value": "Wie Tierberuhigung I, nur können 5 Ziele betroffen werden"
                    },
                    {
                        "name": "Beruhigung IV",
                        "level": 8,
                        "value": "Wie Beruhigung I, nur können 4 Ziele betroffen werden"
                    },
                    {
                        "name": "Beruhigung V",
                        "level": 9,
                        "value": "Wie Beruhigung I, nur können 5 Ziele betroffen werden"
                    },
                    {
                        "name": "Massen-Tierberuhigung I",
                        "level": 10,
                        "value": "Der Zauberer kann seine Stufe an Tieren beruhigen"
                    },
                    {
                        "name": "Wahrhaftige Handlungseinschränkung",
                        "level": 11,
                        "value": "Wie Handlung einschränken, nur betrifft der Spruch ein beliebiges Ziel"
                    },
                    {
                        "name": "Beruhigung X",
                        "level": 12,
                        "value": "Wie Beruhigung I, nur können zehn Ziele betroffen werden"
                    },
                    {
                        "name": "Ruf der Beruhigung",
                        "level": 15,
                        "value": "Alle Ziele in einem 15mRadius werden beruhigt, wenn ihnen ihr WW gegen den Spruch mißlingt"
                    },
                    {
                        "name": "Massen-Tierberuhigung II",
                        "level": 18,
                        "value": "Wie Massen-Tierberuhigung I, allerdings sind zusätzlich die Widerstandswürfe um -20 erschwert, und der Spruch hat eine Reichweite von 3m/Stufe"
                    },
                    {
                        "name": "Meisterberuhigung",
                        "level": 20,
                        "value": "Erlaubt dem Zauberer, bis zu 20 Ziele zu beruhigen"
                    },
                    {
                        "name": "Fern-Beruhigung",
                        "level": 25,
                        "value": "Der Zauberer kann ein beliebiges Ziel beruhigen"
                    },
                    {
                        "name": "Massen-Beruhigung",
                        "level": 30,
                        "value": "Der Zauberer beruhigt seine Stufe an Zielen"
                    },
                    {
                        "name": "Wahrhaftige Beruhigung",
                        "level": 50,
                        "value": "Der Zauberer kann ein beliebiges Ziel beruhigen."
                    }
                ]
            },
            {
                "id": "1.6",
                "name": "8.2.7: Wege der Erschaffung",
                "spells": [
                    {
                        "name": "Selbstversorgung",
                        "level": 2,
                        "value": "Gestattet dem Zauberer, unbeschadet ohne Wasser und Nahrung auszukommen (d.h. der Spruch versorgt den Körper des Zauberers einen Tag lang mit Nährstoffen und Flüssigkeit)"
                    },
                    {
                        "name": "Wasser erzeugen I",
                        "level": 3,
                        "value": "Der Zauberer kann in einem beliebigen, verfügbaren Gefäß ausreichend Wasser erschaffen, um ein normales, menschengroßes Wesen einen Tag lang damit zu versorgen"
                    },
                    {
                        "name": "Nahrung erzeugen I",
                        "level": 4,
                        "value": "Der Zauberer erschafft aus der Umgebung genug Nahrung, um einen gesunden Appetit für einen Tag zu befriedigen"
                    },
                    {
                        "name": "Entzünden",
                        "level": 5,
                        "value": "Entfacht ein Feuer mit einem Radius von 30cm, das brennt, solange es Nahrung findet. Ziele im Wirkungsbereich (30cmRadius) erleiden einen kritischen Hitzeschaden der Stufe A"
                    },
                    {
                        "name": "Wegzehrung I",
                        "level": 6,
                        "value": "Der Zauberer kann einen Laib Wegbrot von 250g Gewicht erzeugen, der ein Wesen einen Tag lang ernähren kann. Das Brot ist einen Monat haltbar"
                    },
                    {
                        "name": "Wasser erzeugen III",
                        "level": 7,
                        "value": "Wie Wasser erzeugen I, nur kann der Zauberer genug Wasser für 3 Tage erzeugen"
                    },
                    {
                        "name": "Nahrung erzeugen III",
                        "level": 8,
                        "value": "Wie Nahrung erzeugen I, nur kann der Zauberer genug Nahrung erschaffen, um 3 Wesen einen Tag lang zu ernähren"
                    },
                    {
                        "name": "Heilkraut verstärken",
                        "level": 9,
                        "value": "Erlaubt dem Zauberer, die Wirkung eines beliebigen, wachsenden Heilkrauts zu verdoppeln (siehe Anmerkungen). Dieser Spruch kann nur einmal auf ein Heilkraut angewendet werden"
                    },
                    {
                        "name": "Wasser erzeugen V",
                        "level": 10,
                        "value": "Wie Wasser erzeugen I, nur kann der Zauberer genug Wasser für 5 Tage erzeugen"
                    },
                    {
                        "name": "Nahrung erzeugen V",
                        "level": 11,
                        "value": "Wie Nahrung erzeugen I, nur kann der Zauberer genug Nahrung erschaffen, um 5 Wesen einen Tag lang zu ernähren"
                    },
                    {
                        "name": "Wegzehrung III",
                        "level": 12,
                        "value": "Wie Wegzehrung I, nur kann der Zauberer 3 Wegbrote erzeugen"
                    },
                    {
                        "name": "Meisterschaft über Heilkräuter",
                        "level": 13,
                        "value": "Der Zauberer kann die Wirkung jedes beliebigen (wachsenden oder geernteten) Heilkrauts verdoppeln"
                    },
                    {
                        "name": "Schwächere Pflanzenerzeugung",
                        "level": 15,
                        "value": "Der Zauberer kann eine Pflanze von bis zu 3m Höhe und/oder Breite erschaffen"
                    },
                    {
                        "name": "Massen-Wassererzeugung",
                        "level": 16,
                        "value": "Wie Wasser erzeugen I, nur kann der Zauberer pro Stufe einen Tagesvorrat Wasser erzeugen (z.B. könnte ein Zauberer der 17. Stufe Wasser für 17 Tage erzeugen)"
                    },
                    {
                        "name": "Wahrhaftige Nahrungserzeugung",
                        "level": 17,
                        "value": "Wie Nahrung erzeugen I, nur kann der Zauberer genug Nahrung erschaffen, um ein Wesen/Stufe einen Tag lang zu ernähren"
                    },
                    {
                        "name": "Schwächere Tiererzeugung",
                        "level": 20,
                        "value": "Der Zauberer kann ein Tier erschaffen, dessen Art im Umland heimisch ist und das nicht mehr als 5 Kilo wiegt. Das Tier verhält sich gegenüber dem Zauberer freundlich"
                    },
                    {
                        "name": "Wahrhaftige Wegzehrung",
                        "level": 25,
                        "value": "Wie Wegzehrung I, nur kann der Zauberer seine Stufe an Wegbroten erzeugen"
                    },
                    {
                        "name": "Mächtige Pflanzenerzeugung",
                        "level": 30,
                        "value": "Wie Schwächere Pflanzenerzeugung, nur kann der Zauberer eine Pflanze erschaffen, die in Breite und/oder Höhe 30cm mal seiner Stufe entspricht (d.h. ein Zauberer der 30. Stufe könnte einen neun Meter hohen Baum entstehen lassen, der an der dicksten Stelle neun Meter breit ist). Die Pflanze muß im Umland heimisch sein"
                    },
                    {
                        "name": "Mächtige Tiererzeugung",
                        "level": 50,
                        "value": "Wie Schwächere Tiererzeugung, nur kann der Zauberer ein Tier erzeugen, das maximal ein halbes Kilo pro Stufe wiegt. Das Tier muß in der Region heimisch sein."
                    }
                ]
            },
            {
                "id": "1.7",
                "name": "8.2.8: Wege der Orientierung",
                "spells": [
                    {
                        "name": "Raten",
                        "level": 2,
                        "value": "Wenn der Zauberer eine Wahl treffen muß, die auf wenigen oder gar keinen Informationen beruht (z.B. welcher Gang am schnellsten ins Freie führt), kann er diesen Spruch einsetzen. Dann trifft der Spielleiter die Wahl für ihn, wobei er die Entscheidung um 25% zugunsten des Zauberers beeinflußt (d.h. Sie würfeln mit 1W100: 01-25 entspricht einer falschen Entscheidung, 26-100 einer richtigen)"
                    },
                    {
                        "name": "Pfadfinder I",
                        "level": 3,
                        "value": "Der Zauberer erfährt, wo sich im Umkreis von 30 Metern Pfade befinden. Der Spruch zeigt ihm den nächstgelegenen Punkt jedes dieser Wege, nicht aber deren Verlauf"
                    },
                    {
                        "name": "Führung",
                        "level": 4,
                        "value": "Der Zauberer wird auf subtile Art und Weise (durch Tips und Hinweise) zu einem bestimmten Ziel geführt (innerhalb von 30 Metern pro Stufe des Zauberers), indem seine Gottheit ihn lenkt. Wie genau sich diese Führung gestaltet, kann von Gottheit zu Gottheit unterschiedlich sein (ein Gott des Wassers könnte ihn einen Hinweis in der Anordnung der Felsen im Fluß sehen lassen). Der Zauberer muß sich während der Spruchdauer darauf konzentrieren, der Führung zu folgen"
                    },
                    {
                        "name": "Wiederfinden I",
                        "level": 5,
                        "value": "Liefert Richtung und Entfernung eines bestimmten Objekts oder Ortes, mit dem der Zauberer vertraut ist oder der ihm detailliert beschrieben wurde"
                    },
                    {
                        "name": "Pfadfinder III",
                        "level": 6,
                        "value": "Wie Pfadfinder I, nur hat der Spruch eine Reichweite von 100m"
                    },
                    {
                        "name": "Wiederfinden III",
                        "level": 8,
                        "value": "Wie Wiederfinden I, nur hat der Spruch eine Reichweite von 100m"
                    },
                    {
                        "name": "Pfadfinder V",
                        "level": 9,
                        "value": "Wie Pfadfinder I, nur hat der Spruch eine Reichweite von 150m"
                    },
                    {
                        "name": "Wiederfinden V",
                        "level": 10,
                        "value": "Wie Wiederfinden I, nur hat der Spruch eine Reichweite von 150m"
                    },
                    {
                        "name": "Pfadgedächtnis",
                        "level": 11,
                        "value": "Der Zauberer kann sich an die genaue Route einer Reise erinnern"
                    },
                    {
                        "name": "Pfadfinder X",
                        "level": 12,
                        "value": "Wie Pfadfinder I, nur hat der Spruch eine Reichweite von zwei Kilometern"
                    },
                    {
                        "name": "Göttliche Führung",
                        "level": 13,
                        "value": "Wie Führung, nur hilft die Gottheit dem Zauberer, indem sie ihm ein Tier als Führer schickt. Der Zauberer kann dem Tier bis zu einem festgelegten Ort folgen. Wenn 24 Stunden verstreichen, ohne daß sich der Zauberer dem Zielort nähert, verläßt ihn das Tier"
                    },
                    {
                        "name": "Finden I",
                        "level": 15,
                        "value": "Der Zauberer kann einen beliebigen Gegenstand finden, den er beschreibt, vorausgesetzt es gibt ihn und er ist in Reichweite (z.B. könnte der Zauberer eine Streitkolbenart beschreiben, von der er nie etwas gehört hat und die er nie gesehen hat)"
                    },
                    {
                        "name": "Wiederfinden X",
                        "level": 16,
                        "value": "Wie Wiederfinden I, nur hat der Spruch eine Reichweite von zwei Kilometern"
                    },
                    {
                        "name": "Wahrhaftiger Pfadfinder",
                        "level": 17,
                        "value": "Wie Pfadfinder I, nur hat der Spruch eine Reichweite von 15 km"
                    },
                    {
                        "name": "Finden III",
                        "level": 18,
                        "value": "Wie Finden I, nur hat der Spruch eine Reichweite von 100m"
                    },
                    {
                        "name": "Meister-Wiederfinden",
                        "level": 20,
                        "value": "Wie Wiederfinden I, nur hat der Spruch eine Reichweite von 30 km"
                    },
                    {
                        "name": "Wahrhaftige Pfade",
                        "level": 25,
                        "value": "Wie Pfadfinder I, nur hat der Spruch eine Reichweite von 1,5 km pro Stufe, und der Zauberer kann auch deren Verlauf innerhalb der Reichweite feststellen"
                    },
                    {
                        "name": "Wahrhaftiges Wiederfinden",
                        "level": 30,
                        "value": "Wie Wiederfinden I, nur hat der Spruch eine Reichweite von 1,5 km pro Stufe"
                    },
                    {
                        "name": "Wahrhaftiges Finden",
                        "level": 50,
                        "value": "Wie Finden I, nur hat der Spruch eine Reichweite von 30 Metern pro Stufe."
                    }
                ]
            },
            {
                "id": "1.8",
                "name": "8.2.9: Wege der Symbole",
                "spells": [
                    {
                        "name": "Symbolanalyse I",
                        "level": 1,
                        "value": "Gibt an, welcher Spruch in einem einzelnen Symbol innerhalb von 15 Metern enthalten ist. Das Symbol wird dadurch nicht ausgelöst (sofern es nicht ausdrücklich so erstellt wurde, daß Symbolanalyse es auslöst)"
                    },
                    {
                        "name": "Spruchvorbereitung",
                        "level": 2,
                        "value": "Dieser Spruch bereitet den folgenden Spruch des Zauberers vor. Der folgende Spruch wird dann so gewirkt, als wäre er unverzüglich. Die MP-Kosten dieses Spruchs entsprechen der höchsten Stufe, die der Zauberer vorbereiten möchte. Wenn der Zauberer beispielsweise den nächsten Spruch der vierten Stufe als unverzüglich wirken möchte, dann kostet dieser Spruch 4 MP. Beim Wirken dieses Spruches muß der Zauberer pro ausgegebenem MP eine Minute beten. Wenn er also 4 MP für diesen Spruch ausgegeben hat, muß er 4 Minuten beten, bevor der Spruch vollständig ist. Wird dies unterbrochen, schlägt der Spruch fehl. Die Effekte dieses Spruchs enden, sobald der Zauberer seinen nächsten Spruch wirkt (selbst wenn die Stufe des nächsten Spruchs höher als die ausgegebenen MP ist, und der Spruch damit nicht hiervon profitiert). (Alles klar?) 3. Symbol entfernen I"
                    },
                    {
                        "name": "Symbol I",
                        "level": 5,
                        "value": "Bettet einen Spruch der 1. Stufe in einen unbeweglichen Stein ein. Innerhalb einer Minute muß der einzubettende Spruch gewirkt werden (innerhalb von 3 Metern). Das Symbol ist normalerweise sichtbar, es muß aber nur dann sichtbar sein, wenn Lesen der Auslöser ist (siehe unten). • Ein Symbol muß auf einem Steinblock (Felsen, Steinplatte) von mindestens einer Tonne Gewicht eingebettet werden. Pro Steinblock kann nur ein Symbol angebracht werden. Das Bewegen des Steinblocks zerstört das Symbol. • Ein Symbol kann (nach Wunsch des Zauberers) auf eine der folgenden Weisen ausgelöst werden: Verstreichen einer bestimmten Zeit, bestimmte Bewegungen, Geräusche, Berührung, Lesen des Symbols, Gewalt in der Nähe usw. Der Maximalabstand für eine Auslösung ist 3 Meter oder gleich der Reichweite des eingebetteten Spruchs (die größere Entfernung gilt). • Ist der eingebettete Spruch ein Angriffsspruch, so entspricht die Angriffsstufe der Stufe des eingebetteten Spruchs (Bei Symbol I ist dies also immer 1, nicht die Stufe des Zauberers). Wenn der Spruch ein elementarer Angriffsspruch ist, ist der OB normalerweise +0. Der Angriff kann aber auf einen Ort fokussiert sein (im Gegensatz zu der Person, die das Symbol ausgelöst hat), dann ist der OB +50. • Normalerweise kann ein Symbol, das Auswirkungen auf eine Person oder ein Objekt hat (Heilzauber, Angriffssprüche usw.), nur einmal am Tag ausgelöst werden"
                    },
                    {
                        "name": "Symbol II",
                        "level": 7,
                        "value": "Wie Symbol I, aber für einen Spruch der zweiten Stufe"
                    },
                    {
                        "name": "Symbol entfernen II",
                        "level": 8,
                        "value": "Wie Symbol entfernen I, aber für einen Spruch der zweiten Stufe"
                    },
                    {
                        "name": "Symbol III",
                        "level": 9,
                        "value": "Wie Symbol I, aber für einen Spruch der dritten Stufe 10. Wahrhaftige Symbolanalyse"
                    },
                    {
                        "name": "Symbol V",
                        "level": 11,
                        "value": "Wie Symbol I, nur kann ein Spruch der 3. Stufe eingebettet werden"
                    },
                    {
                        "name": "Symbol entfernen III",
                        "level": 12,
                        "value": "Wie Symbol entfernen I, nur daß ein Spruch der 3. Stufe entfernt wird"
                    },
                    {
                        "name": "Symbol VI",
                        "level": 13,
                        "value": "Wie Symbol I, nur kann ein Spruch der 6. Stufe eingebettet werden"
                    },
                    {
                        "name": "Symbol VII",
                        "level": 15,
                        "value": "Wie Symbol I, nur wird ein Spruch der 7. Stufe eingebettet"
                    },
                    {
                        "name": "Symbol entfernen V",
                        "level": 16,
                        "value": "Wie Symbol entfernen I, nur daß ein Spruch der 5. Stufe entfernt wird"
                    },
                    {
                        "name": "Symbol VIII",
                        "level": 17,
                        "value": "Wie Symbol I, nur wird ein Spruch der 8. Stufe eingebettet"
                    },
                    {
                        "name": "Symbol entfernen X",
                        "level": 18,
                        "value": "Wie Symbol entfernen I, nur daß ein Spruch der 10. Stufe entfernt wird"
                    },
                    {
                        "name": "Symbol IX",
                        "level": 19,
                        "value": "Wie Symbol I, nur wird ein Spruch der 9. Stufe eingebettet"
                    },
                    {
                        "name": "Symbol X",
                        "level": 20,
                        "value": "Wie Symbol I, nur wird ein Spruch der 10. Stufe eingebettet"
                    },
                    {
                        "name": "Meister-Forschen",
                        "level": 25,
                        "value": "Siehe Kapitel 5.0 (Seite 35)"
                    },
                    {
                        "name": "Meister-Symbol",
                        "level": 30,
                        "value": "Wie Symbol I, nur wird ein Spruch der 20. Stufe eingebettet"
                    },
                    {
                        "name": "Wahrhaftige Symbolentfernung",
                        "level": 50,
                        "value": "Wie Symbol entfernen I, nur kann der Zauberer jeden Spruch entfernen, dessen Stufe niedriger ist als seine eigene (d.h. ein Kleriker der 50. Stufe könnte einen Spruch der 49. Stufe entfernen, nicht aber einen der 50.). Besondere Anmer- kungen 1) Ein Symbol bleibt permanent bestehen, wenn es nicht gebannt wird oder der Stein bewegt wird, auf dem es angebracht ist. 2) Die genaue Größe eines Symbols kann unterschiedlich sein. Wir schlagen zwischen 10cm x 10cm bis zu 30cm x 30cm als Größe vor. 3) Der SL kann festlegen, daß als Angriffsstufe eines Symbols die Stufe des jeweiligen Symbol-Spruchs gilt. Wenn also in ein Symbol X ein erststufiger Spruch eingebettet wird, wäre die Angriffstufe zehn und nicht eins."
                    }
                ]
            },
            {
                "id": "1.9",
                "name": "8.2.10: Wissen",
                "spells": [
                    {
                        "name": "Rückbesinnung",
                        "level": 1,
                        "value": "Gestattet dem Zauberer, sich wortwörtlich an Gespräche oder Schriftstücke zu erinnern, die er bis zu einem Tag pro Stufe vorher gehört oder gelesen hat"
                    },
                    {
                        "name": "Böses entdecken",
                        "level": 2,
                        "value": "Entdeckt das „Böse“ in einem lebenden oder unbelebten Ziel. Der Zauberer kann sich pro Runde auf einen anderen 2m-Radius konzentrieren"
                    },
                    {
                        "name": "Fluch entdecken",
                        "level": 3,
                        "value": "Wie Böses entdecken, nur kann der Zauberer Flüche entdecken"
                    },
                    {
                        "name": "Emotion entdecken",
                        "level": 4,
                        "value": "Wie Böses entdecken, aber der Zauberer kann extreme Emotionen entdecken (Haß, Liebe, Traurigkeit usw.). Zusätzlich erfährt der Zauberer, welche Emotion die stärkste im Ziel ist. Wenn es keine extremen Emotionen gibt (also nur normale Gefühle), dann entdeckt dieser Spruch nichts"
                    },
                    {
                        "name": "Lichtes Wissen I",
                        "level": 5,
                        "value": "Stellt Herkunftsort und Natur eines bestimmten „heiligen“ Gegenstandes fest, der nicht der „Finsternis“ oder dem „Bösen“ geweiht ist. Der Zauberer erhält keine Informationen über besondere Fähigkeiten"
                    },
                    {
                        "name": "Giftkunde",
                        "level": 6,
                        "value": "Stellt die exakte Natur und Art eines Giftes fest und welche Heilmittel dagegen nötig sind. Der Spruch vermittelt nicht die dazu notwendigen Gerätschaften oder Fertigkeiten"
                    },
                    {
                        "name": "Lebenswissen",
                        "level": 8,
                        "value": "Der Zauberer stellt Natur und Art eines beliebigen lebendigen Zieles fest. Er erkennt keine persönlichen Eigenschaften oder Befähigungen, wohl aber Fähigkeiten, die dem Volk des Ziels normalerweise zugeschrieben werden"
                    },
                    {
                        "name": "Fluchkunde",
                        "level": 10,
                        "value": "Der Zauberer kann Natur und Herkunft eines bestimmten Fluches feststellen, einschließlich des Namens der Person, die ihn ausgesprochen hat"
                    },
                    {
                        "name": "Dunkles Wissen I",
                        "level": 11,
                        "value": "Wie Lichtes Wissen I, nur kann der Zauberer die Herkunft und Natur eines Gegenstands feststellen, der der „Finsternis“ oder dem „Bösen“ geweiht ist"
                    },
                    {
                        "name": "Lichtes Wissen II",
                        "level": 12,
                        "value": "Wie Lichtes Wissen I, nur kann der Zauberer die Natur und die Herkunft zweier „heiliger Gegenstände“ herausfinden, oder er kann die Herkunft, die Natur und die genaue Bedeutung eines beliebigen „heiligen Gegenstandes“ erfahren"
                    },
                    {
                        "name": "Emotion analysieren",
                        "level": 15,
                        "value": "Der Zauberer erfährt die Natur und die Ursache der extremen Emotionen eines (belebten oder unbelebten) Ziels. Die Heftigkeit der Emotionen und andere Details können auch herausgefunden werden"
                    },
                    {
                        "name": "Lichtes Wissen III",
                        "level": 17,
                        "value": "Wie Lichtes Wissen I, nur kann der Zauberer die Natur und den Herkunft dreier „heiliger Gegenstände“ herausfinden, oder er kann die Herkunft, die Natur und die genaue Bedeutung eines beliebigen „heiligen Gegenstandes“ herausfinden oder er erfährt das Alter, die Herkunft, die Natur des Gegenstandes und den Namen desjenigen, der ihn erschaffen hat. Zudem findet der Zauberer besondere Fähigkeiten des Gegenstands heraus"
                    },
                    {
                        "name": "Dunkles Wissen II",
                        "level": 18,
                        "value": "Wie Lichtes Wissen II, nur kann der Spruch nur auf Gegenstände angewandt werden, die der „Finsternis“ oder dem „Bösen“ geweiht sind"
                    },
                    {
                        "name": "Weißes Wissen",
                        "level": 19,
                        "value": "Der Zauberer kann die genaue Natur, Herkunft, Bestimmung und Geschichte eines beliebigen „heiligen Gegenstandes“ bestimmen. Der Spruch verschafft dem Zauberer einen bildlichen Eindruck aller Vorbesitzer des Gegenstandes"
                    },
                    {
                        "name": "Dunkles Wissen III",
                        "level": 20,
                        "value": "Wie Lichtes Wissen III, nur kann der Spruch nur auf Gegenstände angewandt werden, die der „Finsternis“ oder dem „Bösen“ geweiht sind"
                    },
                    {
                        "name": "Wahrhaftiges Lebenswissen",
                        "level": 25,
                        "value": "Wie Lebenswissen, nur kann der Zauberer auch besondere Wesenszüge und Fertigkeiten eines beliebigen Ziels bestimmen"
                    },
                    {
                        "name": "Schwarzes Wissen",
                        "level": 30,
                        "value": "Wie Weißes Wissen, nur kann der Spruch nur auf Gegenstände angewandt werden, die der „Finsternis“ oder dem „Bösen“ geweiht sind"
                    },
                    {
                        "name": "Meisterschaft des Weißen Wissens",
                        "level": 50,
                        "value": "Wie Weißes Wissen, nur kann der Zauberer diese Informationen zu allen „heiligen Gegenständen“ in 30m Entfernung erhalten."
                    }
                ]
            }
        ]
    },
    {
        "id": "2",
        "name": "Basisliste Animist",
        "spellLists": [
            {
                "id": "2.0",
                "name": "8.3.1: Bewegung / Sinne der Natur",
                "spells": [
                    {
                        "name": "Auf Katzenpfoten",
                        "level": 1,
                        "value": "Der Zauberer bewegt sich so leise wie eine Katze. Dies gewährt einen Bonus von +20 auf Schleichen"
                    },
                    {
                        "name": "Chamäleonhaut",
                        "level": 2,
                        "value": "Die Haut des Zauberers nimmt die Färbung der Umgebung an. Dies gewährt einen Bonus zwischen +10 und +50 auf Schleichen und Verstecken. Wenn der Zauberer sich bewegt, paßt sich die Färbung an das neue Terrain an. Dieser Spruch betrifft nicht die Kleidung oder die Ausrüstung des Zauberers"
                    },
                    {
                        "name": "Wolfssinne",
                        "level": 3,
                        "value": "Der Geruchssinn und das Gehör des Zauberers verbessern sich (er kann auch schwache Gerüche wahrnehmen und Geräusche in höherem Schallbereich hören). Dies erleichtert alle Wahrnehmungswürfe, in denen nur diese beiden Sinne eine Rolle spielen, um +50 und andere, in denen sie mit anderen zusammenwirken, um +20"
                    },
                    {
                        "name": "Rehflinkheit I",
                        "level": 4,
                        "value": "Der Zauberer kann sich mit doppelter Geschwindigkeit fortbewegen (d.h. mit Laufgeschwindigkeit) und verbraucht dabei nur so viele Erschöpfungspunkte, als würde er gehen"
                    },
                    {
                        "name": "Fledermaussinn",
                        "level": 5,
                        "value": "Verbessert die Fähigkeit des Zauberers, sich fortzubewegen, wenn er nichts sehen kann. Wenn er geblendet wurde oder sonstwie seines Sehsinns beraubt ist, bringt ihm dieser Spruch einen Bonus von +10 bis +50 auf alle Manöverwürfe im Dunkeln. Beachten Sie, daß dieser Spruch die Abzüge für Blindheit nicht aufhebt, er mindert sie nur ab"
                    },
                    {
                        "name": "Otterlungen",
                        "level": 6,
                        "value": "Der Zauberer kann ungefährdet für die Dauer des Spruchs die Luft anhalten"
                    },
                    {
                        "name": "Segelflug I",
                        "level": 7,
                        "value": "Der Zauberer gleitet durch die Luft wie ein Vogel. Das Produkt der Flughöhe und seiner horizontalen Geschwindigkeit muß pro Runde 30 ergeben. Beispielsweise kann er sich 2m pro Runde bewegen, wenn er 15m über dem Boden wäre, oder er könnte sich mit 15m pro Runde bewegen, wenn er sich nur 2m über dem Boden befände. Beachten Sie, daß das Produkt dieser beiden Werte genau 30 sein muß (d.h. der Zauberer kann Höhe und Geschwindigkeit nicht so wählen, daß das Produkt mehr oder weniger als 30 wäre)"
                    },
                    {
                        "name": "Falkenaugen",
                        "level": 8,
                        "value": "Der Zauberer gewinnt die Sehschärfe eines Falken. Dies gibt ihm einen Bonus von +50 auf alle Wahrnehmungswürfe, die nur den Sehsinn beinhalten, und +20 auf andere Wahrnehmungswürfe, wo jener Sinn mit anderen zusammenwirkt"
                    },
                    {
                        "name": "Tigerhaut",
                        "level": 9,
                        "value": "Die Haut des Zauberers bekommt die Widerstandsfähigkeit von der einer Großkatze (effektive RK von 3)"
                    },
                    {
                        "name": "Ebersstärke",
                        "level": 10,
                        "value": "Der Zauberer erlangt die Wildheit eines Keilers. Er erhält einen Bonus von +20 auf seinen OB, aber er kann für die Spruchdauer weder parieren noch Fernkampfwaffen benutzen"
                    },
                    {
                        "name": "Löwenpranken",
                        "level": 11,
                        "value": "Der Zauberer kann mit seinen Händen angreifen, als wären es die Pranken eines Löwen. Er kann für seine Angriffe die Angriffstabelle 11.5: Klaue aus dem Kampfhandbuch auf maximal mittlerer Stufe verwenden. Der Zauberer muß die dazugehörige Angriffsfertigkeit lernen (sprich einen OB erwerben). Die Kosten für die Fertigkeit sind dieselben wie für Waffenloser Kampf • Schlag, die Attributsmodifikatoren sind St/St/Ge"
                    },
                    {
                        "name": "Insektensinn",
                        "level": 12,
                        "value": "Der Zauberer erlangt die Erschütterungswahrnehmung eines Insekts. Er spürt Vibrationen im Boden (und anderem festen Material) im Wirkungsbereich. Er erhält allgemeine Informationen über Bewegungen im Wirkungsbereich und die ungefähre Anzahl der Ziele (± 10%). Setzen Sie die Spruchwirkung als einen besonderen Bonus von +25 bis +100 auf Wahrnehmungswürfe ein (je nachdem, was der Zauberer spüren kann)"
                    },
                    {
                        "name": "Rehflinkheit II",
                        "level": 13,
                        "value": "Wie Rehflinkheit I, nur verdreifacht sich die Geschwindigkeit (d.h. sie wird zu Sprintgeschwindigkeit)"
                    },
                    {
                        "name": "Bärenhaut",
                        "level": 14,
                        "value": "Die Haut des Zauberers bekommt die Widerstandsfähigkeit eines Bären (effektive RK von 8)"
                    },
                    {
                        "name": "Bärenarme",
                        "level": 15,
                        "value": "Der Zauberer wird befähigt, wie ein Bär zu ringen. Er kann für seine Angriffe die Angriffstabelle 11.10: Umklammern aus dem Kampfhandbuch auf maximal mittlerer Stufe verwenden. Der Zauberer muß die dazugehörige Angriffsfertigkeit lernen (sprich einen OB erwerben). Die Kosten für die Fertigkeit sind dieselben wie für Waffenlosen Kampf • Wurf, die Attributsmodifikatoren sind St/Ge/Ge"
                    },
                    {
                        "name": "Segelflug II",
                        "level": 16,
                        "value": "Wie Segelflug I, nur muß das Produkt der Werte gleich 90 sein"
                    },
                    {
                        "name": "Natternfänge",
                        "level": 17,
                        "value": "Der Zauberer erlangt die Fähigkeit, wie eine Giftschlange zuzubeißen. Er kann für diese Angriffe die Angriffstabelle 11.1: Biß (aus dem Kampfhandbuch) bis maximal mittlere Stufe verwenden. Der Zauberer muß die dazugehörige Angriffsfertigkeit lernen (sprich einen OB erwerben). Die Kosten für die Fertigkeit sind dieselben wie für Waffenloser Kampf • Schlag, die Attributsmodifikatoren sind St/St/Ge"
                    },
                    {
                        "name": "Flugdrachenhaut",
                        "level": 18,
                        "value": "Die Haut des Zauberers bekommt die Widerstandsfähigkeit eines Flugdrachens (effektive RK von 12)"
                    },
                    {
                        "name": "Rehflinkheit III",
                        "level": 19,
                        "value": "Wie Rehflinkheit I, nur vervierfacht sich die Geschwindigkeit (d.h. sie wird zu Schneller Sprintgeschwindigkeit)"
                    },
                    {
                        "name": "Ochsenstärke",
                        "level": 20,
                        "value": "Der Zauberer erlangt die Stärke eines Ochsen. Er erhält einen Bonus von +40 auf seinen OB, aber er kann für die Spruchdauer weder parieren noch Fernkampfwaffen benutzen"
                    },
                    {
                        "name": "Wahrhaftiger Segelflug",
                        "level": 25,
                        "value": "Wie Segelflug I, nur muß das Produkt der Werte gleich 150 sein"
                    },
                    {
                        "name": "Wahrhaftige Rehflinkheit",
                        "level": 30,
                        "value": "Wie Rehflinkheit I, nur verfünffacht sich die Geschwindigkeit (d.h. sie wird zu Spurtgeschwindigkeit)"
                    },
                    {
                        "name": "Drachenhaut",
                        "level": 50,
                        "value": "Die Haut des Zauberers bekommt die Widerstandsfähigkeit eines Niederen Drachen (effektive RK von 20)."
                    }
                ]
            },
            {
                "id": "2.1",
                "name": "8.3.2: Kräutermeisterschaft",
                "spells": [
                    {
                        "name": "Kräuterkunde",
                        "level": 1,
                        "value": "Der Zauberer erfährt Wesen, Geschichte und Wert eines bestimmten Heilkrauts. Ist die Pflanze kein Heilkraut, erhält der Zauberer keine Informationen"
                    },
                    {
                        "name": "Wirkung verstärken",
                        "level": 2,
                        "value": "Erlaubt es dem Zauberer, die Wirkung eines beliebigen, wachsenden Heilkrauts zu verdoppeln. Dieser Spruch darf nur einmal pro Heilkraut angewandt werden"
                    },
                    {
                        "name": "Heilkraut finden I",
                        "level": 3,
                        "value": "Erlaubt es dem Zauberer, ein Heilkraut zu finden, das er sucht, egal, welche Hindernisse ihn davon trennen (gibt die genaue Richtung, die Entfernung und die Größe des Vorkommens an)"
                    },
                    {
                        "name": "Sofortwirkende Kräuterheilung",
                        "level": 4,
                        "value": "Erlaubt dem Zauberer, ein Heilkraut sofort wirksam werden zu lassen. Wenn das Heilkraut danach verwendet wird, ist seine förderliche oder schädliche Wirkung sofort zu spüren. Das Heilkraut behält diese Eigenschaft für einen Tag pro Stufe des Zauberers bei"
                    },
                    {
                        "name": "Meisterschaft über Heilkräuter II",
                        "level": 5,
                        "value": "Der Zauberer kann die Wirkung jedes beliebigen (wachsenden oder toten) Heilkrauts verdoppeln"
                    },
                    {
                        "name": "Heilkraut finden III",
                        "level": 6,
                        "value": "Wie Heilkraut finden I, nur liegt die Reichweite bei 90 Metern"
                    },
                    {
                        "name": "Kräutererzeugung",
                        "level": 7,
                        "value": "Der Zauberer kann ein Heilkraut wachen lassen, indem er den richtigen Samen pflanzt. Das Heilkraut ist steril (unfruchtbar, man kann damit also keine weiteren Heilkräuter züchten) und wächst innerhalb von 1-10 Runden"
                    },
                    {
                        "name": "Meisterschaft über Heilkräuter III",
                        "level": 8,
                        "value": "Wie Meisterschaft über Heilkräuter II, nur verdreifacht der Spruch die Wirkung des Heilkrauts"
                    },
                    {
                        "name": "Heilkraut finden V",
                        "level": 9,
                        "value": "Wie Heilkraut finden I, nur liegt die Reichweite bei 150 Metern"
                    },
                    {
                        "name": "Heilkraut reinigen",
                        "level": 10,
                        "value": "Erlaubt dem Zauberer, alle schädliche Gifte, Begleiterscheinungen oder Nebenwirkungen in der Wirkung aller Kräuter in Reichweite zu beseitigen"
                    },
                    {
                        "name": "Meisterschaft über Heilräuter V",
                        "level": 11,
                        "value": "Wie Meisterschaft über Heilkräuter II, nur verfünffacht der Spruch die Wirkung des Heilkrauts"
                    },
                    {
                        "name": "Heilkraut finden X",
                        "level": 13,
                        "value": "Wie Heilkraut finden I, nur liegt die Reichweite bei 2 Kilometern und der Zauberer weiß den genauen Standort, wenn es sich in einem Radius von 3 Metern befindet"
                    },
                    {
                        "name": "Meisterschaft über Heilkräuter X",
                        "level": 15,
                        "value": "Wie Meisterschaft über Heilkräuter II, nur verzehnfacht der Spruch die Wirkung des Heilkrauts"
                    },
                    {
                        "name": "Haltbare, sofortwirkende Kräuterheilung",
                        "level": 17,
                        "value": "Wie Sofortwirkende Kräuterheilung, nur bleibt die Eigenschaft dem Heilkraut für eine Woche pro Stufe des Zauberers erhalten"
                    },
                    {
                        "name": "Heilkraut finden XX",
                        "level": 18,
                        "value": "Wie Heilkraut finden I, nur liegt die Reichweite bei 8 Kilometern, und der Zauberer weiß den genauen Standort, wenn es sich in einem Radius von 8 Metern befindet"
                    },
                    {
                        "name": "Meister-Heilkrautfinden",
                        "level": 20,
                        "value": "Wie Heilkraut finden I, nur liegt die Reichweite bei 30 Kilometern und der Zauberer weiß den genauen Standort, wenn es sich in einem Radius von 30 Metern befindet"
                    },
                    {
                        "name": "Wahrhaftige Wirkungsverstärkung",
                        "level": 25,
                        "value": "Wie Wirkung verstärken, nur wird die Wirkung eines wachsenden Heilkrauts um 100% pro Stufe des Zauberers verstärkt (z.B. würde ein Zauberer der 30. Stufe die Wirkung um 3000%, also um das 30-fache verstärken können)"
                    },
                    {
                        "name": "Wahrhaftige Meisterschaft über Heilkräuter",
                        "level": 30,
                        "value": "Wie Meisterschaft über Heilkräuter II, nur wird die Wirkung eines Heilkrauts um 100% pro Stufe des Zauberers verstärkt (z.B. würde ein Zauberer der 50. Stufe die Wirkung um 5000%, also um das 50-fache verstärken können)"
                    },
                    {
                        "name": "Wahrhaftiges Heilkräuterfinden",
                        "level": 50,
                        "value": "Wie Heilkraut finden I, nur kann der Zauberer eine beliebige Heilkräuterart innerhalb einer Reichweite von 1,5 Kilometern pro Stufe finden (z.B. 75 Kilometer für einen Zauberer der 50. Stufe). Der Standort ist ihm bekannt, wenn er sich in einem Radius von 50 Metern befindet."
                    }
                ]
            },
            {
                "id": "2.2",
                "name": "8.3.3: Pflanzenmeisterschaft",
                "spells": [
                    {
                        "name": "Pflanzenkunde",
                        "level": 1,
                        "value": "Der Zauberer erfährt Wesen, Geschichte und Wert einer bestimmten Pflanze"
                    },
                    {
                        "name": "Schnelles Wachsen I",
                        "level": 2,
                        "value": "Der Zauberer kann die Wachstumsgeschwindigkeit einer Pflanzenart innerhalb des Wirkungsbereichs um das Zehnfache erhöhen"
                    },
                    {
                        "name": "Pflanzensprache",
                        "level": 3,
                        "value": "Erlaubt dem Zauberer, die Sprache einer beliebigen Pflanzenart zu verstehen und zu „sprechen“"
                    },
                    {
                        "name": "Pflanze heilen",
                        "level": 4,
                        "value": "Heilt den Schaden einer Pflanze, die weniger komplex ist als ein Baum (bei besonders schwerem Schaden könnte ein WW die Spruchwirkung verhindern)"
                    },
                    {
                        "name": "Schnelles Wachsen II",
                        "level": 5,
                        "value": "Wie Schnelles Wachsen I, nur wächst die Pflanze 100 Mal schneller"
                    },
                    {
                        "name": "Pflanze finden",
                        "level": 6,
                        "value": "Erlaubt es dem Zauberer, Vertreter einer beliebigen Pflanzenart zu finden, oder er kann herausfinden, welche Pflanzenarten im Wirkungsbereich vorkommen"
                    },
                    {
                        "name": "Pflanzenwachstum II",
                        "level": 7,
                        "value": "Erlaubt dem Zauberer, die Größe einer beliebigen Pflanze zu verdoppeln. Die Pflanze wächst im Lauf eines Tages"
                    },
                    {
                        "name": "Pflanzenkontrolle I",
                        "level": 8,
                        "value": "Der Zauberer kann automatische und/oder mentale Vorgänge in einer beliebigen Pflanze kontrollieren. Er kann auch die Bewegung der Pflanze kontrollieren, aber der Spruch verleiht ihr keine Bewegungsfähigkeit, zu der sie sonst nicht fähig wäre"
                    },
                    {
                        "name": "Schnelles Wachsen III",
                        "level": 9,
                        "value": "Wie Schnelles Wachsen I, nur ist der Wirkungsbereich 30m (Radius) groß, und die Spruchreichweite ist 30m"
                    },
                    {
                        "name": "Pflanzenwachstum III",
                        "level": 10,
                        "value": "Wie Pflanzenwachstum II, nur verdreifacht der Spruch die Größe"
                    },
                    {
                        "name": "Pflanzenkontrolle III",
                        "level": 11,
                        "value": "Wie Pflanzenkontrolle I, nur kann der Zauberer 3 beliebige Pflanzen kontrollieren"
                    },
                    {
                        "name": "Baum heilen",
                        "level": 12,
                        "value": "Wie Pflanze heilen, nur daß der Spruch eine beliebige Pflanze betrifft (auch Bäume)"
                    },
                    {
                        "name": "Pflanzenwachstum V",
                        "level": 13,
                        "value": "Wie Pflanzenwachstum II, nur verfünf­­facht der Spruch die Größe"
                    },
                    {
                        "name": "Schnelles Wachsen IV",
                        "level": 14,
                        "value": "Wie Schnelles Wachsen II, nur ist der Wirkungsbereich 30m groß, und die Spruchreichweite ist 30m"
                    },
                    {
                        "name": "Pflanzenkontrolle V",
                        "level": 15,
                        "value": "Wie Pflanzenkontrolle I, nur kann der Zauberer 5 beliebige Pflanzen kontrollieren"
                    },
                    {
                        "name": "Dornenwand",
                        "level": 16,
                        "value": "Beschwört eine Barriere aus robusten, aber biegsamen Dornen. Sie mißt bis zu 3m x 3m x1,5m. Jeder, der sich durch 30cm dieser Barriere hindurchbewegt, erleidet 1W10 Dolchangriffe (wenn Sie das Buch haben, würfeln Sie Dolchangriffe mit +50 auf der Dolchangriffstabelle im Kampfhandbuch aus). Die Wand muß auf festem Untergrund stehen"
                    },
                    {
                        "name": "Feuer löschen",
                        "level": 17,
                        "value": "Dieser Spruch löscht alles brennende, lebendige Material im Wirkungsbereich"
                    },
                    {
                        "name": "Pflanzenwachstum X",
                        "level": 18,
                        "value": "Wie Pflanzenwachstum II, nur verzehnfacht der Spruch die Größe"
                    },
                    {
                        "name": "Wahrhaftiges Pflanzenwachstum",
                        "level": 20,
                        "value": "Wie Pflanzenwachstum II, nur betrifft der Spruch alle Pflanzen im Wirkungsbereich"
                    },
                    {
                        "name": "Wahrhaftiges Schnellwachstum",
                        "level": 25,
                        "value": "Wie Schnelles Wachsen I, bis auf die Reichweite und den Wirkungsbereich"
                    },
                    {
                        "name": "Wahrhaftige Pflanzenkontrolle",
                        "level": 30,
                        "value": "Wie Pflanzenkontrolle I, nur kann der Zauberer alle Pflanzen im Wirkungsbereich kontrollieren"
                    },
                    {
                        "name": "Pflanze beleben",
                        "level": 50,
                        "value": "Der Zauberer kann eine beliebige Pflanze beleben. Dadurch kann die Pflanze sich langsam bewegen, wobei sie ihre Wurzeln mitnimmt, wenn sie welche hat."
                    }
                ]
            },
            {
                "id": "2.3",
                "name": "8.3.4: Schützende Natur",
                "spells": [
                    {
                        "name": "Form einprägen",
                        "level": 1,
                        "value": "Der Zauberer studiert die Form einer Tier- oder Pflanzenart und prägt sie sich ein, um sie in späteren Sprüchen dieser Liste zu verwenden. Der Zauberer kann sich nur so viele Formen eingeprägt haben, wie er Stufen hat"
                    },
                    {
                        "name": "Elementen widerstehen",
                        "level": 2,
                        "value": "Der Zauberer ist vor natürlicher Hitze bis zu 75° C und natürlicher Kälte bis zu -10°C geschützt (für ihn sind es dann 21°C). Von Temperaturen über 75° C ziehen Sie 50 ab und bei Temperaturen unter 10°C addieren Sie 10, um auf die effektive Temperatur für den Zauberer zu kommen. Zusätzlich erhält der Zauberer einen Bonus von +20 auf alle Widerstandswürfe gegen Hitzesprüche und Hitzeangriffe (+20 DB gegen Feuerelementarund Hitzeangriffe) und genauso +20 auf alle Widerstandswürfe gegen Kältesprüche und Eisangriffe (+20 DB gegen Kälteelementar- und Eisangriffe). Die Wirkungsdauer des Spruch beträgt 10 Minuten pro Stufe, wenn der Zauberer sich nicht bewegt. Wenn er sich bewegt, hält der Spruch nur an, solange er sich konzentriert"
                    },
                    {
                        "name": "Farbnuancen",
                        "level": 3,
                        "value": "Gestattet dem Zauberer, die Farbe eines beliebigen organischen Gegenstandes anzunehmen, wenn er Kontakt mit ihm hat. In vielen Situationen gewährt das einen Bonus von +10 bis +50 (SL-Entscheidung) auf Verstecken (und möglicherweise auf Schleichen)"
                    },
                    {
                        "name": "Pflanzenfassade",
                        "level": 4,
                        "value": "Erlaubt dem Zauberer, als eine beliebige Pflanze zu erscheinen, die er mittels Form einprägen zuvor studiert hat. Seine Größe bleibt unverändert, er riecht nicht wie die Pflanze und fühlt sich auch nicht so an (dies ist also eine rein visuelle Illusion und unterliegt den normalen Illusionsregeln"
                    },
                    {
                        "name": "Lautlose Bewegung",
                        "level": 5,
                        "value": "Der Zauberer kann sich lautlos bewegen, solange er kein Geräusch in mehr als 30cm Entfernung von seinem Körper erzeugt"
                    },
                    {
                        "name": "Unterwasseratmung",
                        "level": 6,
                        "value": "Der Zauberer kann unter Wasser normal atmen. Dieser Spruch wirkt nicht in irgendeiner anderen Flüssigkeit als Wasser"
                    },
                    {
                        "name": "Tierfassade",
                        "level": 7,
                        "value": "Erlaubt dem Zauberer, als ein beliebiges Tier zu erscheinen, das er studiert hat. Der Zauberer behält seine Größe bei und riecht weder wie das Tier noch fühlt er sich so an (dies ist also eine rein visuelle Illusion und unterliegt den normalen Illusionsregeln"
                    },
                    {
                        "name": "Schatten",
                        "level": 8,
                        "value": "Der Zauberer selbst und Gegenstände, die er am Körper trägt, wirken wie ein Schatten und sind damit in dunkler Umgebung fast unsichtbar. In vielen Situation kann das als besonderer Bonus von +25 bis +75 auf Schleichen/Verstecken abgehandelt werden"
                    },
                    {
                        "name": "Schild gegen Organisches I",
                        "level": 9,
                        "value": "Ein einzelner Angriff gegen den Zauberer erleidet in dieser Runde einen Malus von -50. Die Waffe oder der Gegenstand, der oder die den Zauberer treffen sollte, muß ganz organisch (wie etwa von einem Tier) oder zumindest zum Teil organisch sein (wie etwa ein Pfeil)"
                    },
                    {
                        "name": "Pflanzenform I",
                        "level": 10,
                        "value": "Erlaubt dem Zauberer, die Form einer beliebigen Pflanze anzunehmen, die er vorher studiert hat. Er sieht wie die Pflanze aus und fühlt sich auch wie sie an, und er kann seine Größe zwischen 75% und 200% seiner Normalgröße verändern, aber er erlangt keine körperlichen Fähigkeiten der Pflanze. In Abschnitt 5.20 (Seite 42) finden Sie mehr über Gestaltwandel"
                    },
                    {
                        "name": "Schutz vor Elementen",
                        "level": 11,
                        "value": "Der Zauberer ist vor jeder natürlichen Hitze oder Kälte geschützt (so als läge die Temperatur um ihn bei 21° C). Außerdem erhält er einen Bonus von +40 auf alle Widerstandswürfe gegen Feuer-/Eissprüche und Hitze-/Kälteangriffe (+40 DB gegen Elementare Angriffe). Die Wirkungsdauer des Spruchs beträgt 10 Minuten pro Stufe, wenn der Zauberer sich nicht bewegt. Wenn er sich bewegt, hält der Spruch nur an, solange er sich konzentriert"
                    },
                    {
                        "name": "Tiergedanken",
                        "level": 12,
                        "value": "Für die Wirkungsdauer dieses Spruchs wirken die Gedankenmuster des Zauberers wie die eines beliebigen Tieres, das er studiert hat. Der Zauberer kann sich nicht bewegen, solange dieser Spruch aktiv ist"
                    },
                    {
                        "name": "Schild gegen Organisches II",
                        "level": 13,
                        "value": "Wie Schild gegen Organisches I, nur beträgt der Malus -100"
                    },
                    {
                        "name": "Tierform I",
                        "level": 14,
                        "value": "Erlaubt dem Zauberer, die Form eines beliebigen Tieres anzunehmen, das er vorher studiert hat. Er sieht wie das Tier aus, fühlt sich auch wie es an, und er kann seine Größe zwischen 75% und 200% seiner Normalgröße verändern, aber er erlangt keine körperlichen Fähigkeiten des Tieres. In Abschnitt 5.20 (Seite 42) finden Sie mehr über Gestaltwandel"
                    },
                    {
                        "name": "Wahrhaftige Tiergedanken",
                        "level": 15,
                        "value": "Wie Tiergedanken, nur kann sich der Zauberer bewegen. Allerdings muß er sich weiterhin konzentrieren"
                    },
                    {
                        "name": "Pflanzenform II",
                        "level": 16,
                        "value": "Wie Pflanzenform I, nur erlangt der Zauberer auch den Geruch und die körperlichen Fähigkeiten der Pflanze, und er kann seine Größe von 50% bis 400% seiner Normalgröße verändern"
                    },
                    {
                        "name": "Tierform II",
                        "level": 17,
                        "value": "Wie Tierform I, nur erlangt der Zauberer auch den Geruch und die körperlichen Fähigkeiten des Tieres, und er kann seine Größe von 50% bis 400% seiner Normalgröße verändern"
                    },
                    {
                        "name": "Schild gegen Organisches III",
                        "level": 18,
                        "value": "Wie Schild gegen Organisches I, nur verfehlt der Angriff den Zauberer automatisch"
                    },
                    {
                        "name": "Tierform III",
                        "level": 19,
                        "value": "Wie Tierform I, nur erlangt der Zauberer auch den Geruch und die körperlichen Fähigkeiten des Tieres, und er kann seine Größe von 5% bis 4000% seiner Normalgröße verändern"
                    },
                    {
                        "name": "Wahrhaftige Pflanzenform",
                        "level": 20,
                        "value": "Wie Pflanzenform II, nur kann der Zauberer innerhalb der Spruchdauer die Form jeder Pflanze annehmen, die er jemals studiert hat"
                    },
                    {
                        "name": "Wahrhaftige Tierform",
                        "level": 25,
                        "value": "Wie Tierform III, nur kann der Zauberer innerhalb der Spruchdauer die Form jedes Tieres annehmen, das er jemals studiert hat"
                    },
                    {
                        "name": "Wahrhaftige Naturform",
                        "level": 30,
                        "value": "Wie Pflanzenform II und Tierform III gleichzeitig"
                    },
                    {
                        "name": "Wahrhaftiger Schild gegen Organisches",
                        "level": 50,
                        "value": "Während der Spruchdauer kann der Zauberer jeden Angriff negieren (d.h. dafür sorgen, daß er fehlschlägt). Die angreifende Waffe muß mindestens zum Teil organisch sein, und der Zauberer muß den Angriff sehen können."
                    }
                ]
            },
            {
                "id": "2.4",
                "name": "8.3.5: Tiermeisterschaft",
                "spells": [
                    {
                        "name": "Tierschlaf I",
                        "level": 1,
                        "value": "Läßt ein beliebiges Tier (keinen Humanoiden) einschlafen. Der Spruch betrifft keine verzauberten Kreaturen oder welche, die intelligenter sind als normale Tiere"
                    },
                    {
                        "name": "Tier heilen I",
                        "level": 2,
                        "value": "Der Zauberer kann jedes beliebige Tier heilen, dessen Verletzungen nicht tödlich sind und das bis zu 5 Kilo wiegt. Die Heilung dauert 6-600 Minuten"
                    },
                    {
                        "name": "Tiersprache",
                        "level": 3,
                        "value": "Erlaubt es dem Zauberer, die Sprache einer Tierart zu verstehen und zu „sprechen“"
                    },
                    {
                        "name": "Tierschlaf III",
                        "level": 4,
                        "value": "Wie Tierschlaf I, nur läßt der Spruch bis zu 3 Tiere einschlafen"
                    },
                    {
                        "name": "Tierbeherrschung I",
                        "level": 5,
                        "value": "Der Zauberer kann die Aktionen eines beliebigen Tieres kontrollieren"
                    },
                    {
                        "name": "Tier finden",
                        "level": 6,
                        "value": "Der Zauberer kann Angehörige einer beliebigen Tierart finden, oder er kann herausfinden, welche Tierarten es im Wirkungsbereich gibt"
                    },
                    {
                        "name": "Freundlich stimmen",
                        "level": 7,
                        "value": "Alle Tiere innerhalb eines Bereichs von 3 Metern sind dem Zauberer gegenüber freundlich gesonnen. Dieser Spruch verleiht keine Kontrolle über die Tiere"
                    },
                    {
                        "name": "Tier heilen II",
                        "level": 8,
                        "value": "Wie Tier heilen I, nur kann der Spruch ein Tier heilen, das bis zu 75 Kilo wiegt, oder eines, das bis zu fünf Kilo wiegt, von tödlicher Verwundung heilen (er kann das Tier allerdings nicht von den Toten zurückholen)"
                    },
                    {
                        "name": "Tiereinfühlung",
                        "level": 9,
                        "value": "Der Zauberer kann die Gedanken oder Gefühle eines beliebigen Tieres verstehen und/oder sich vorstellen"
                    },
                    {
                        "name": "Tier beschwören I",
                        "level": 10,
                        "value": "Der Zauberer kann ein erststufiges, unintelligentes Tier aus dem Umland beschwören. Zwar kann er auch die Tierart angeben, doch letztendlich entscheidet der SL, welches Tier dem Ruf folgt. Wenn das Tier den Zauberer verstehen kann (z.B. durch Tiersprache), kann es über normale Kommunikation kontrolliert werden. Andernfalls kann die Kontrolle nur durch die Konzentration des Zauberers ausgeübt werden. Wenn das Tier für eine Aufgabe beschworen wurde, die seiner eigenen Wahrnehmung nach nicht gefährlich ist, liegt die Spruchdauer bei 10 Minuten pro Stufe. Wenn es allerdings jemals in eine gefährliche Situation gerät, sinkt die Wirkungsdauer sofort auf eine Runde pro Stufe herab"
                    },
                    {
                        "name": "Tierbeherrschung III",
                        "level": 11,
                        "value": "Der Zauberer kann die Handlungen von 3 beliebigen Tieres kontrollieren"
                    },
                    {
                        "name": "Tier beschwören III",
                        "level": 12,
                        "value": "Wie Tier beschwören I, nur kann der Zauberer zusätzlich 2 der folgenden Optionen wählen: a) die Stufe des beschworenen Tieres ist um eine höher, b) eine weitere erststufige Kreatur wird beschworen oder c) die Wirkungsdauer wird verdoppelt"
                    },
                    {
                        "name": "Tier herbeirufen",
                        "level": 13,
                        "value": "Der Zauberer kann nach einem bekannten, bestimmten Tier rufen. Wenn es dem Tier körperlich möglich ist, wird es zu ihm kommen"
                    },
                    {
                        "name": "Tier wiederbeleben I",
                        "level": 14,
                        "value": "Dieser Spruch bringt ein Tier, das bis zu 5 Kilo wiegt, von den Toten zurück. Das Tier muß einen Wurf (W100, offen) machen, zu dem es seine vorherige Stufe mal 2 zählt. Pro Tag, den das Tier tot war, wird ein Malus von -2 abgezogen. Wenn das Endergebnis mehr als 100 ist, kehrt das Tier von den Toten zurück. Erreicht es 100 nicht, kann es von diesem Zauberer nicht wiederbelebt werden (bis er eine neue Stufe erreicht). Für je 20 Tage pro Tag, an dem das Tier tot war, hat es einen Malus von -20 auf alle Handlungen"
                    },
                    {
                        "name": "Ruf der Wildnis",
                        "level": 15,
                        "value": "Wenn dieser Spruch auf irgendein Haustier gesprochen wird, wird es wieder zum Wildtier. Das Tier wird keinerlei Schwierigkeiten damit haben, sich an die harten Anforderungen der Wildnis anzupassen (und wird nicht wieder ein Haustier sein wollen)"
                    },
                    {
                        "name": "Tierbeherrschung V",
                        "level": 16,
                        "value": "Wie Tierbeherrschung I, nur kann der Zauberer fünf Tiere kontrollieren"
                    },
                    {
                        "name": "Tier heilen III",
                        "level": 17,
                        "value": "Wie Tier heilen I, nur kann der Spruch ein Tier heilen, das bis zu 1,5 Tonnen wiegt, oder eines, das bis zu 75 Kilo wiegt, von tödlicher Verwundung heilen (er kann das Tier allerdings nicht von den Toten zurückholen)"
                    },
                    {
                        "name": "Tier beschwören V",
                        "level": 18,
                        "value": "Wie Tier beschwören III, nur kann der Zauberer 4 Optionen wählen"
                    },
                    {
                        "name": "Tier wiederbeleben II",
                        "level": 19,
                        "value": "Wie Tier wiederbeleben I, nur daß der Modifikator auf den Wurf für die Tage, die das Tier schon tot war, nur -1 ist"
                    },
                    {
                        "name": "Tier beschwören X",
                        "level": 20,
                        "value": "Wie Tier beschwören III, nur können 9 Optionen gewählt werden"
                    },
                    {
                        "name": "Herr der Tiere",
                        "level": 25,
                        "value": "Wie Tierbeherrschung I, nur kann der Zauberer alle Tiere einer festgelegten Art in einem Radius von 3m/Stufe kontrollieren"
                    },
                    {
                        "name": "Tier wiederbeleben III",
                        "level": 30,
                        "value": "Wie Tier wiederbeleben II, nur daß das Ziel sofort von den Toten aufersteht, keine Genesungszeit benötigt und der Spruch eine Reichweite von 30m hat"
                    },
                    {
                        "name": "Wahrhaftige Tierbeschwörung",
                        "level": 50,
                        "value": "Wie Tierbeschwörung I, nur daß der Zauberer für je 2 seiner Stufen eine Option wählen kann."
                    }
                ]
            },
            {
                "id": "2.5",
                "name": "8.3.6: Wissen der Natur",
                "spells": [
                    {
                        "name": "Fallen entdecken",
                        "level": 1,
                        "value": "Der Zauberer hat eine 75%- Chance, im Wirkungsbereich eine Falle zu entdecken. Er kann sich jede Runde auf einen anderen Bereich konzentrieren. Damit dieser Spruch wirkt, müssen sich lebende Pflanzen oder Tiere im Wirkungsbereich befinden"
                    },
                    {
                        "name": "Naturwahrnehmung I",
                        "level": 2,
                        "value": "Der Zauberer kann alle Aktivität von Lebendem im Wirkungsbereich überwachen (d.h. er ist sich auch kleinster Bewegungen bewußt). Solange dieser Spruch anhält, kann sich der Zauberer nicht bewegen"
                    },
                    {
                        "name": "Pfadfinder",
                        "level": 3,
                        "value": "Der Zauberer erfährt, wo in 30m-Umkreis sich Pfade befinden. Er erfährt den nächstgelegenen Punkt jedes dieser Wege, nicht aber deren Verlauf"
                    },
                    {
                        "name": "Magie entdecken",
                        "level": 4,
                        "value": "Der Zauberer hat eine 75%- Chance, aktive Magie im Wirkungsbereich zu entdecken. In jeder Runde kann er sich auf einen anderen Bereich konzentrieren. Damit dieser Spruch wirkt, müssen sich lebende Pflanzen oder Tiere im Wirkungsbereich befinden"
                    },
                    {
                        "name": "Wettervorhersage I",
                        "level": 5,
                        "value": "Gibt eine Chance von 95%, in den folgenden 24 Stunden die Art, den Zeitpunkt und die Schwere des (Un)wetters vorauszusagen"
                    },
                    {
                        "name": "Naturwahrnehmung II",
                        "level": 6,
                        "value": "Wie Naturwahrnehmung I, bis auf den größeren Wirkungsbereich"
                    },
                    {
                        "name": "Wettervorhersage III",
                        "level": 7,
                        "value": "Wie Wettervorhersage I, nur kann der Zauberer das Wetter für 3 Tage voraussagen"
                    },
                    {
                        "name": "Landmarke finden I",
                        "level": 8,
                        "value": "Für die Spruchdauer weiß der Zauberer die Richtung und die Entfernung zu einer beliebigen, einzigartigen landschaftlichen Besonderheit, mit der er vertraut ist. Die Landmarke muß sich innerhalb der Reichweite befinden, sonst liefert der Spruch keine Informationen"
                    },
                    {
                        "name": "Wartende Wahrnehmung I",
                        "level": 9,
                        "value": "Erlaubt dem Zauberer, eine natürliche „Alarmanlage“ im Wirkungsbereich einzurichten. Der Zauberer wird auf jede störende Aktivität dort aufmerksam gemacht"
                    },
                    {
                        "name": "Naturwahrnehmung III",
                        "level": 10,
                        "value": "Wie Naturwahrnehmung I, bis auf den größeren Wirkungsbereich"
                    },
                    {
                        "name": "Wettervorhersage V",
                        "level": 11,
                        "value": "Wie Wettervorhersage I, nur kann der Zauberer das Wetter für 5 Tage voraussagen"
                    },
                    {
                        "name": "Pfadgedächtnis",
                        "level": 12,
                        "value": "Der Zauberer kann sich an die genaue Route einer Reise erinnern"
                    },
                    {
                        "name": "Wartende Wahrnehmung II",
                        "level": 13,
                        "value": "Wie Wartende Wahrnehmung I, bis auf den größeren Wirkungsbereich"
                    },
                    {
                        "name": "Landmarke finden II",
                        "level": 14,
                        "value": "Wie Landmarke finden I, bis auf die höhere Reichweite"
                    },
                    {
                        "name": "Auge der Natur I",
                        "level": 15,
                        "value": "Erlaubt dem Zauberer, Aktivität in einem bekannten Bereich (30m Radius) zu spüren und zu sehen"
                    },
                    {
                        "name": "Naturwahrnehmung V",
                        "level": 16,
                        "value": "Wie Naturwahrnehmung I, bis auf den größeren Wirkungsbereich"
                    },
                    {
                        "name": "Verständigung mit Elementarwesen",
                        "level": 17,
                        "value": "Der Zauberer kann sich mit jeder elementaren Kraft in Reichweite verständigen. Das Elementarwesen muß in der Lage sein, mit ihm zu kommunizieren (d.h. der Spruch selbst verleiht ihm keine Kommunikationsfähigkeit). Zu Elementarwesen zählen alle magisch erschaffenen Elementare, Wassergeister, Waldgeister usw"
                    },
                    {
                        "name": "Vision im Wasser",
                        "level": 18,
                        "value": "Das Ziel dieses Spruchs ist ein kleiner Tümpel, ein natürliches Wasserbecken oder dergleichen. Das Wasser muß ruhig sein (und auch für die Spruchdauer ruhig bleiben). Der Zauberer wählt ein Thema, worauf im Wasser eine Vision erscheint, die mit diesem Thema in Verbindung steht. Die Vision dauert 1-50 Runden"
                    },
                    {
                        "name": "Wahrhaftiges Landmarkenfinden",
                        "level": 19,
                        "value": "Wie Landmarke finden I, bis auf die Reichweite"
                    },
                    {
                        "name": "Auge der Natur II",
                        "level": 20,
                        "value": "Wie Auge der Natur I, bis auf die Reichweite und den Wirkungsbereich"
                    },
                    {
                        "name": "Wahrhaftige Wettervorhersage",
                        "level": 25,
                        "value": "Wie Wettervorhersage I, nur kann der Zauberer das Wetter für einen Tag pro Stufe vorhersagen"
                    },
                    {
                        "name": "Auge der Natur III",
                        "level": 30,
                        "value": "Wie Auge der Natur I, bis auf die Reichweite und den Wirkungsbereich"
                    },
                    {
                        "name": "Auge des Animisten",
                        "level": 50,
                        "value": "Erlaubt dem Zauber, einen Bereich von 30m-Radius zu überwachen, an dem er bereits war und mit dem er vertraut ist (d.h. er meditierte dort einen Tag lang oder hat 30 Tage dort gelebt)."
                    }
                ]
            }
        ]
    },
    {
        "id": "3",
        "name": "Basisliste Kleriker",
        "spellLists": [
            {
                "id": "3.0",
                "name": "8.4.1: Beschwörungen",
                "spells": [
                    {
                        "name": "Beschwörung I",
                        "level": 1,
                        "value": "Der Zauberer kann magisch ein nichtintelligentes Wesen der 1. Stufe aus der Umgebung beschwören. Der Zauberer kann die Art der Kreatur angeben, aber der SL bestimmt die genaue Kreatur, die der Beschwörung folgt. Wenn die Kreatur den Zauberer verstehen kann (z.B. durch Tiersprache), kann die Kreatur durch normale Kommunikation kontrolliert werden. Wenn dies nicht der Fall ist, funktioniert die Kontrolle nur durch ununterbrochene Konzentration des Zauberers. Wenn die Kreatur für eine nicht gefährliche Aufgabe (nach Einschätzung der Kreatur) eingesetzt wird, hält dieser Spruch 10 Minuten pro Stufe. Sollte die Kreatur sich jedoch in Gefahr sehen, fällt die Dauer sofort auf 1 Runde pro Stufe"
                    },
                    {
                        "name": "Beschwörung II",
                        "level": 2,
                        "value": "Wie Beschwörung I, aber der Zauberer kann zusätzlich eine der folgenden Optionen auswählen: a) die Stufe der beschworenen Kreatur wird um 1 erhöht, b) eine weitere Kreatur der ersten Stufe wird beschworen, oder c) die Dauer wird verdoppelt"
                    },
                    {
                        "name": "Beschwörung III",
                        "level": 3,
                        "value": "Wie Beschwörung II, aber 2 Optionen können gewählt werden"
                    },
                    {
                        "name": "Beschwörung VI",
                        "level": 4,
                        "value": "Wie Beschwörung II, aber 3 Optionen können gewählt werden"
                    },
                    {
                        "name": "Beschwörung V",
                        "level": 5,
                        "value": "Wie Beschwörung II, aber 4 Optionen können gewählt werden"
                    },
                    {
                        "name": "Beschwörung VI",
                        "level": 6,
                        "value": "Wie Beschwörung II, aber 5 Optionen können gewählt werden"
                    },
                    {
                        "name": "Beschwörung VII",
                        "level": 7,
                        "value": "Wie Beschwörung II, aber 6 Optionen können gewählt werden"
                    },
                    {
                        "name": "Beschwörung VIII",
                        "level": 8,
                        "value": "Wie Beschwörung II, aber 7 Optionen können gewählt werden"
                    },
                    {
                        "name": "Beschwörung XV",
                        "level": 9,
                        "value": "Wie Beschwörung II, aber 9 Optionen können gewählt werden"
                    },
                    {
                        "name": "Dämonentor I",
                        "level": 10,
                        "value": "Der Zauberer beschwört einen Dämon der Klasse I, der im Verlauf von 2 Runden allmählich erscheint. Der Zauberer kann ihn nur durch Konzentration kontrollieren. Nach Ende der Konzentration verschwindet der Dämon im Laufe von 2 Runden wieder, wobei er bis zu seinem völligen Verschwinden das ihm nächststehende Wesen angreift"
                    },
                    {
                        "name": "Beschwörung X",
                        "level": 11,
                        "value": "Wie Beschwörung II, nur können 14 Optionen gewählt werden"
                    },
                    {
                        "name": "Meister-Beschwörung",
                        "level": 13,
                        "value": "Wie Beschwörung II, nur können 19 Optionen gewählt werden"
                    },
                    {
                        "name": "Dämonentor II",
                        "level": 15,
                        "value": "Wie Dämonentor I, nur kann ein Dämon der Klasse II beschworen werden"
                    },
                    {
                        "name": "Wartende Beschwörung",
                        "level": 17,
                        "value": "Wie Beschwörung X, nur kann die Beschwörung bis zu einen Tag pro Stufe des Zauberers verzögert werden oder bis eine der folgenden Bedingungen sie auslöst (vom Zauberer festgelegt, wenn er diesen Spruch wirkt): bestimmte Bewegungen, bestimmte Geräusche, Berührung oder andere festgelegte Aktionen"
                    },
                    {
                        "name": "Dämonentor III",
                        "level": 20,
                        "value": "Wie Dämonentor I, nur kann ein Dämon der Klasse III beschworen werden"
                    },
                    {
                        "name": "Massen-Beschwörung",
                        "level": 25,
                        "value": "Wie Beschwörung II, nur können so viele Optionen gewählt werden, wie die Stufe des Zauberers beträgt"
                    },
                    {
                        "name": "Wahrhaftige Beschwörung",
                        "level": 30,
                        "value": "Wie Beschwörung I, bis auf die Dauer und darauf daß die Stufe der Kreatur zufallsbestimmt ist"
                    },
                    {
                        "name": "Tor",
                        "level": 50,
                        "value": "Der Zauberer kann ein beliebiges Wesen durch ein „Tor“ zu seinem Standort ziehen. Wenn das Wesen intelligent ist, muß es kommen wollen. Ein intelligentes Wesen wird eine Ahnung von der allgemeinen Gesinnung des Zauberers haben und einen vagen Eindruck von dem Grund für das Tor und seiner Bedeutung für das Tor gewinnen."
                    }
                ]
            },
            {
                "id": "3.1",
                "name": "8.4.2: Kanäle",
                "spells": [
                    {
                        "name": "Weihwasser erzeugen",
                        "level": 1,
                        "value": "Wenn dieser Spruch gewirkt wird, werden bis zu 100ml an klarem, sauberen Wasser in Weihwasser verwandelt. Das Wirken dieses Spruches dauert eine Stunde. Wenn das Wasser nicht in einem sauberen Gefäß gehalten wird, verliert es den Status als Weihwasser"
                    },
                    {
                        "name": "Beruhigen",
                        "level": 2,
                        "value": "Der Zauberer streckt seinen Arm mit geschlossener Faust in Richtung des Ziels aus und leitet Macht von seiner Kraftquelle (normalerweise eine Gottheit) auf das Ziel. Dieses darf daraufhin keine aggressiven/offensiven Aktionen durchführen und kämpft nur, wenn es angegriffen wird"
                    },
                    {
                        "name": "Kanalisieren I",
                        "level": 3,
                        "value": "Ein Spruch der 1. Stufe, den der Zauberer in der nächsten Runde einsetzt, wird magisch an einen anderen Leitmagiekundigen übertragen. Der übermittelte Spruch erreicht sein Ziel an dem Zeitpunkt, an dem er normalerweise wirksam würde, und muß vom Ziel sofort benutzt werden (das Ziel wird dann als Wirker des Spruchs betrachtet). Es gelten alle für den Spruch üblichen Einschränkungen. Der Absender muß das Ziel sehen können oder seinen Standort genau kennen (genaue Richtung und Entfernung oder genauer Ort). Der Empfänger muß exakt wissen, wann der Spruch ihn erreicht (er muß aber nicht wissen, welcher Spruch ankommt). Wartet z.B. ein Kleriker um Mitternacht an einem bestimmten Altar auf einen Spruch, kann ein anderer Zauberer (oder Gott) ihm einen Spruch mittels Kanalisieren I senden (sofern er weiß, wo der Altar steht und die genaue Zeit kennt)"
                    },
                    {
                        "name": "Benommenheit",
                        "level": 5,
                        "value": "Der Zauberer streckt seinen Arm mit geschlossener Faust in Richtung des Ziels aus und leitet Macht von seiner Kraftquelle (normalerweise eine Gottheit) auf das Ziel. Dieses ist dann benommen"
                    },
                    {
                        "name": "Kanalisieren III",
                        "level": 6,
                        "value": "Wie Kanalisieren I, aber für einen Spruch bis zur dritten Stufe"
                    },
                    {
                        "name": "Goldenes Schlummern",
                        "level": 8,
                        "value": "Der Zauberer streckt seinen Arm mit geschlossener Faust in Richtung des Ziels aus und leitet Macht von seiner Kraftquelle (normalerweise eine Gottheit) auf das Ziel. Dieses fällt in tiefen Schlaf. Die erste Minute dieses Schlafs ist magisch (und das Ziel kann nicht normal geweckt werden). Nach der ersten Minute kann das Ziel normal geweckt werden (allerdings wacht es nicht von selbst auf, bis acht Stunden vergangen sind)"
                    },
                    {
                        "name": "Kanalisieren V",
                        "level": 10,
                        "value": "Wie Kanalisieren I, aber für einen Spruch bis zur fünften Stufe"
                    },
                    {
                        "name": "Blenden",
                        "level": 11,
                        "value": "Der Zauberer streckt seinen Arm mit geballter Faust in Richtung des Ziels aus und leitet rohe Kraft aus seiner Machtquelle (normalerweise eine Gottheit) auf das Ziel. Dieses ist dann für die Spruchdauer blind"
                    },
                    {
                        "name": "Kanalisieren VIII",
                        "level": 13,
                        "value": "Wie Kanalisieren I, nur kann ein Spruch bis zur 8. Stufe übermittelt werden"
                    },
                    {
                        "name": "Absolution",
                        "level": 14,
                        "value": "[WW-Mod: -20] Die „Seele“ des Ziels wird aus dem Körper gerissen und geht für die Spruchdauer an den Ort, an den alle „Seelen“ gehen. Die Seele kann nur mittels Leben spenden frühzeitig zurückgeholt werden. Das Ziel ist bewußtlos, bis die Seele zu ihm zurückkehrt. Selbst unterbewußte Handlungen (z.B. Heilung) erleiden einen Malus von -75"
                    },
                    {
                        "name": "Heiliger Schrei",
                        "level": 15,
                        "value": "Alle Wesen, die nicht die Gesinnung (religiöse Überzeugung) des Zauberers teilen, sind betroffen. Alle Ziele, die ihren WW um 40 oder weniger verfehlen, sind eine Runde pro 10 Fehlschlag benommen. Diejenigen, denen der WW um mehr als 40 mißlingt, werden bewußtlos"
                    },
                    {
                        "name": "Gegenstandsrückkehr",
                        "level": 16,
                        "value": "Der Zielgegenstand, der nicht mehr als 5 Kilo wiegt, kehrt an einen festgelegten Ort zurück. Der Zauberer muß zwischen zwei Wirkungsdauern wählen, wenn er den Spruch wirkt. Er kann den Gegenstand zum Bestimmungsort schicken (d.h. teleportieren), wenn er den Spruch wirkt oder er kann bewirken, daß der Gegenstand zu ihm zurückkehrt, wenn sein Besitzer eine besondere Aufgabe bewältigt hat (die festgelegt wird, wenn er den Spruch wirkt)"
                    },
                    {
                        "name": "Kanalisieren X",
                        "level": 17,
                        "value": "Wie Kanalisieren I, nur kann ein Spruch bis zur 10. Stufe übermittelt werden"
                    },
                    {
                        "name": "Zuflucht",
                        "level": 18,
                        "value": "Der Zauberer kehrt zu einem vorher festgelegten Ort zurück (dies ist eine Art von Teleportation). Er muß an diesem Ort mindestens 30 Tage lang gelebt haben (an denen er sich im Schnitt pro Tag 16 Stunden dort aufhielt), damit dieser Ort für ihn zur Zuflucht wird. Jeder Zauberer kann zu jeder Zeit nur einen solchen Ort definiert haben"
                    },
                    {
                        "name": "Zweifache Gegenstandsrückkehr",
                        "level": 19,
                        "value": "Wie Gegenstandsrückkehr, nur bleibt der Gegenstand für eine Runde pro Stufe an dem Ort, den der Zauberer angibt, wenn er den Spruch wirkt. Am Ende dieser Zeit kehrt der Gegenstand dorthin zurück, wo er herkam"
                    },
                    {
                        "name": "Reine Absolution",
                        "level": 20,
                        "value": "Wie Absolution, nur kann die „Seele“ überhaupt nur mittels Leben spenden zurückgeholt werden"
                    },
                    {
                        "name": "Wahrhaftige Zuflucht",
                        "level": 25,
                        "value": "Bis zu einer Runde pro Stufe nachdem der Zauberer Zuflucht wirkte, kann er diesen Spruch anwenden, um auf 6m genau zu dem Punkt zurückzukehren, an dem er Zuflucht wirkte"
                    },
                    {
                        "name": "Meister-Kanalisieren",
                        "level": 30,
                        "value": "Wie Kanalisieren I, nur kann ein Spruch bis zur 20. Stufe übermittelt werden"
                    },
                    {
                        "name": "Heilige Brücke",
                        "level": 50,
                        "value": "Öffnet einen direkten Kanal zur Gottheit des Zauberers. Was dann geschieht, hängt von der Persönlichkeit, den Motiven und der Macht der Gottheit ab. Durch das Tor kann jeder Spruch übermittelt werden, den die Gottheit wirken kann."
                    }
                ]
            },
            {
                "id": "3.2",
                "name": "8.4.3: Meisterschaft des Lebens",
                "spells": [
                    {
                        "name": "Konservierung I",
                        "level": 1,
                        "value": "Der Zauberer kann einen „toten“ Körper konservieren und einen weitergehenden Verfall (also ein Absinken der Attribute) oder weitere Schäden durch vorhandene Wunden verhindern. Das Ziel fällt in ein Koma. Dieser Spruch hindert die Seele des Ziels nicht am Verlassen des Körpers"
                    },
                    {
                        "name": "Leben erhalten I",
                        "level": 2,
                        "value": "Der Zauberer kann die Seele eines „toten“ Körpers daran hindern, diesen zu verlassen, so daß eine Rettung durch Heilung des Körpers möglich ist. Der Spruch muß gewirkt werden, bevor die Seele den Körper verläßt, ansonsten ist eine Rettung nur noch durch Leben spenden möglich (vgl. Grundregelwerk, Seite 92)"
                    },
                    {
                        "name": "Konservierung II",
                        "level": 3,
                        "value": "Wie Konservierung I, bis auf die Dauer"
                    },
                    {
                        "name": "Lebenskraft heilen I",
                        "level": 4,
                        "value": "Das Ziel dieses Spruches ist jegliches Wesen, das einen „Seelenschaden“ erlitten hat. Dem Ziel werden 1W10 Punkte an temporärer (vorher verlorener) Konstitution geheilt. In Abschnitt 24.1 des Grundregelwerks finden Sie weitere Informationen zu Seelenschaden"
                    },
                    {
                        "name": "Leben erhalten II",
                        "level": 5,
                        "value": "Wie Leben erhalten I, bis auf die Dauer"
                    },
                    {
                        "name": "Lebenskraft heilen II",
                        "level": 6,
                        "value": "Wie Lebenskraft heilen I, aber es werden 2W10 Punkte geheilt"
                    },
                    {
                        "name": "Konservierung III",
                        "level": 7,
                        "value": "Wie Konservierung I, bis auf die Dauer"
                    },
                    {
                        "name": "Lebenskraft heilen III",
                        "level": 9,
                        "value": "Wie Lebenskraft heilen I, aber es werden 3W10 Punkte geheilt"
                    },
                    {
                        "name": "Konservierung IV",
                        "level": 10,
                        "value": "Wie Konservierung I, bis auf die Dauer"
                    },
                    {
                        "name": "Leben erhalten III",
                        "level": 11,
                        "value": "Wie Leben erhalten I, bis auf die Dauer"
                    },
                    {
                        "name": "Leben spenden I",
                        "level": 12,
                        "value": "Der Zauberer kann einen Toten wiederauferstehen lassen, indem er seine verlorene Seele zurückbringt. Die Seele des Ziels muß noch immer existieren, und der Tote muß innerhalb des letzen Jahres gestorben sein. Um erfolgreich wiederbelebt werden zu können, muß dem Ziel ein offener W100 gelingen, zu dem er seinen Konstitutionswert (nicht den Modifikator) zählt. Für jeden Tag, den er tot war, wird ein Malus von -10 von dem Wurf abgezogen (wenn das Ziel z.B. 3 Tage tot war, werden vom Wurf 30 abgezogen). Wenn das Endergebnis 100 oder höher ist, ersteht das Ziel wieder auf. Liegt es unter 100, wird das Ziel nicht wiederbelebt (und kann von diesem Zauberer nicht wiederbelebt werden). Für jeden Tag, an dem es tot war, ist das Ziel 100 Tage lang außer Gefecht gesetzt (-100 auf alle Handlungen). Wenn das Ziel z.B. zwei Tage tot war, beträgt die Genesungszeit 200 Tage"
                    },
                    {
                        "name": "Wahrhaftige Lebenskraftheilung",
                        "level": 13,
                        "value": "Wie Lebenskraft heilen I, nur heilt der Zauberer einen Konstitutionspunkt pro Stufe"
                    },
                    {
                        "name": "Konservierung V",
                        "level": 14,
                        "value": "Wie Konservierung I, bis auf die Dauer"
                    },
                    {
                        "name": "Leben spenden II",
                        "level": 15,
                        "value": "Wie Leben spenden I, nur ist der Malus für jeden Tag, an dem das Ziel tot war, nur -5 und die Genesungszeit ist 50 Tage pro Tag, an dem es tot war"
                    },
                    {
                        "name": "Leben erhalten IV",
                        "level": 16,
                        "value": "Wie Leben erhalten I, bis auf die Dauer"
                    },
                    {
                        "name": "Leben spenden III",
                        "level": 17,
                        "value": "Wie Leben spenden I, nur ist der Malus für jeden Tag, an dem das Ziel tot war, nur -2 und die Genesungszeit ist 20 Tage pro Tag, an dem es tot war"
                    },
                    {
                        "name": "Wahrhaftige Konservierung",
                        "level": 18,
                        "value": "Wie Konservierung I, bis auf die Dauer"
                    },
                    {
                        "name": "Wiederherstellung",
                        "level": 19,
                        "value": "Das Ziel dieses Spruchs ist ein Wesen, dessen geistige Fähigkeiten beeinträchtigt wurden (z.B. durch Sprüche der Liste Geistzersetzung). Das Ziel dieses Zaubers erhält verlorene Erfahrung zurück, allerdings nicht immer alle. Für je einen Tag, an dem das Ziel unter dem Zustand litt, erhält es je 1% der Erfahrung nicht zurück. Wenn ein Ziel beispielsweise 10.000 Erfahrungspunkte verlor und 20 Tage brauchte, um einen Kleriker mit diesem Zauber zu finden, würde er nur 8.000 der verlorenen Erfahrungspunkte zurückerhalten"
                    },
                    {
                        "name": "Leben spenden IV",
                        "level": 20,
                        "value": "Wie Leben spenden I, nur ist der Malus für jeden Tag, an dem das Ziel tot war, nur -1 und die Genesungszeit entspricht der Anzahl der Tage, die es tot war"
                    },
                    {
                        "name": "Leben spenden V",
                        "level": 25,
                        "value": "Wie Leben spenden I, nur ist der Malus für jeden zweiten Tag, an dem das Ziel tot war, nur -1 und das Ziel benötigt keine Genesungszeit"
                    },
                    {
                        "name": "Wahrhaftige Wiederherstellung",
                        "level": 30,
                        "value": "Wie Wiederherstellung, nur wird der Geist des Ziels wieder völlig hergestellt (inklusive aller Erfahrung)"
                    },
                    {
                        "name": "Wahrhaftiger Lebenshauch",
                        "level": 50,
                        "value": "Wie Leben spenden I, nur kehrt das Ziel automatisch von den Toten zurück, und es braucht keine Genesungszeit."
                    }
                ]
            },
            {
                "id": "3.3",
                "name": "8.4.4: Schutz",
                "spells": [
                    {
                        "name": "Gebet I",
                        "level": 1,
                        "value": "Das Ziel erhält +5 auf WW und Manöverwürfe. Sobald sich das Ziel mehr als 30 Meter vom Zauberer entfernt, ist der Spruch aufgehoben"
                    },
                    {
                        "name": "Segen I",
                        "level": 2,
                        "value": "Wie Gebet I, aber der Bonus gilt für DB und Manöverwürfe"
                    },
                    {
                        "name": "Widerstand I",
                        "level": 3,
                        "value": "Wie Gebet I, aber der Bonus gilt für WW und DB"
                    },
                    {
                        "name": "Widerstand gegen Hitze I",
                        "level": 4,
                        "value": "Wie Gebet I, aber die Dauer ist 10 Minuten pro Stufe, und das Ziel ist vor natürlicher Hitze bis zu 75°C geschützt (als ob es 21°C wäre). Bei Temperaturen über 75°C ziehen Sie 50°C ab, um die effektive Temperatur für das Ziel zu bestimmen. Das Ziel erhält +20 auf alle WW gegen Hitzesprüche und Hitzeangriffe (+20 DB gegen elementare Feuerund Hitzeangriffe)"
                    },
                    {
                        "name": "Widerstand gegen Kälte I",
                        "level": 5,
                        "value": "Wie Gebet I, aber die Dauer ist 10 Minuten pro Stufe, und das Ziel ist vor natürlicher Kälte bis runter zu -10°C geschützt (als ob es 21°C wäre). Bei Temperaturen unter -10°C addieren Sie 30°C, um die effektive Temperatur für das Ziel zu bestimmen. Das Ziel erhält +20 auf alle WW gegen Kältesprüche und Kälteangriffe (+20 DB gegen elementare Kälte- und Eisangriffe)"
                    },
                    {
                        "name": "Temperatursphäre I",
                        "level": 8,
                        "value": "Alle innerhalb der Sphäre profitieren entweder von Widerstand gegen Hitze I oder von Widerstand gegen Kälte I (dasselbe für alle Ziele). Wenn die Sphäre mehr als 30 Meter vom Zauberer entfernt ist, erlischt sie"
                    },
                    {
                        "name": "Schutzsphäre I",
                        "level": 10,
                        "value": "Alle innerhalb der Sphäre profitieren entweder von Gebet I oder von Segen I oder von Widerstand I (dasselbe für alle Ziele). Wenn die Sphäre mehr als 30 Meter vom Zauberer entfernt ist, erlischt sie"
                    },
                    {
                        "name": "Gebet III",
                        "level": 11,
                        "value": "Wie Gebet I, nur ist der Gesamtbonus 15 und er kann auf 1 - 3 Ziele aufgeteilt werden. Ein Ziel würde einen Sonderbonus von 15 erhalten, 3 Ziele bekämen je einen von 5 usw"
                    },
                    {
                        "name": "Segen III",
                        "level": 12,
                        "value": "Wie Segen I, nur ist der Gesamtbonus 15 und er kann auf ein bis 3 Ziele aufgeteilt werden. Ein Ziel würde einen Sonderbonus von 15 erhalten, 3 Ziele bekämen je einen von 5 usw"
                    },
                    {
                        "name": "Widerstand III",
                        "level": 13,
                        "value": "Wie Widerstand I, nur ist der Gesamtbonus 15 und er kann auf ein bis 3 Ziele aufgeteilt werden. Ein Ziel würde einen Sonderbonus von 15 erhalten, 3 Ziele bekämen je einen von 5 usw"
                    },
                    {
                        "name": "Temperatursphäre II",
                        "level": 15,
                        "value": "Wie Temperatursphäre I, nur ist der Radius 6 Meter groß"
                    },
                    {
                        "name": "Schutzsphäre III",
                        "level": 17,
                        "value": "Wie Schutzsphäre I, nur daß alle innerhalb des Radius die Vorteile von Gebet III oder Segen III oder Widerstand III genießen (dasselbe für alle Ziele)"
                    },
                    {
                        "name": "Gebet V",
                        "level": 18,
                        "value": "Wie Gebet I, nur ist der Gesamtbonus 25 und er kann auf ein bis 5 Ziele aufgeteilt werden. Ein Ziel würde einen Sonderbonus von 25 erhalten, 5 Ziele bekämen je einen von 5 usw"
                    },
                    {
                        "name": "Segen V",
                        "level": 20,
                        "value": "Wie Segen I, nur ist der Gesamtbonus 25 und er kann auf ein bis 5 Ziele aufgeteilt werden. Ein Ziel würde einen Sonderbonus von 25 erhalten, 5 Ziele bekämen je einen von 5 usw"
                    },
                    {
                        "name": "Widerstand V",
                        "level": 25,
                        "value": "Wie Widerstand I, nur ist der Gesamtbonus 25 und er kann auf ein bis 5 Ziele aufgeteilt werden. Ein Ziel würde einen Sonderbonus von 25 erhalten, 5 Ziele bekämen je einen von 5 usw"
                    },
                    {
                        "name": "Schutzsphäre V",
                        "level": 30,
                        "value": "Wie Schutzsphäre I, nur daß alle innerhalb des Radius die Vorteile von Gebet V oder Segen V oder Widerstand V genießen (dasselbe für alle Ziele)"
                    },
                    {
                        "name": "Wahrhaftiger Schutz",
                        "level": 50,
                        "value": "Das Ziel erhält einen Sonderbonus von +30 auf seine Widerstandswürfe, Manöverwürfe und seinen DB, und es werden 30 von allen Elementarangriffen gegen es abgezogen."
                    }
                ]
            },
            {
                "id": "3.4",
                "name": "8.4.5: Vertreibungen",
                "spells": [
                    {
                        "name": "Untote vertreiben V",
                        "level": 1,
                        "value": "Zwingt bis zu 5 Untote zu Flucht oder Zerfall. Alle Untoten haben eine Klasse. Dieser Spruch wirkt auf bis zu 5 Punkte an Untoten (Untote der Klasse I zählen als 1 Punkt, Klasse II als 2 Punkte usw.). Belebte Leichen (Böse Leitmagie, Nekromantie) zählen als Klasse I-Untote und haben keinen WW (sofern der Spruch gelingt, zerfallen sie automatisch). Ansonsten steht jedem Ziel ein WW zu. Wenn der WW um 50 oder weniger fehlschlägt, flieht es (wenn es nicht fliehen kann, erstarrt es). Schlägt der WW um mehr als 50 fehl, zerfällt das Ziel. Ein BasisAngriffswurf gilt für alle Ziele. Sollte für die Untoten keine Klasse angegeben sein, verwenden Sie folgende Tabelle: Stufe Klasse Stufe Klasse Stufe Klasse 1-2 I 6-8 III 13-15 V 3-5 II 9-12 IV 16+ VI Der WW für einen Untoten kann modifiziert werden, indem die Spruchwirkung auf dieses Ziel konzentriert wird. Für jeden zusätzlichen „Punkt“ des Spruches, der (über die normalerweise nötigen Punkte hinaus) auf ein Ziel konzentriert wird, wird dessen WW mit -5 modifiziert. Untote vertreiben V kann also 5 Klasse I-Untote ohne WW-Mod oder einen Klasse I-Untoten mit WW-Mod -20 oder einen Klasse I-Untoten mit WW-Mod -10 und 2 Klasse I-Untote ohne WW-Mod oder eine beliebige andere Kombination von untoten Zielen treffen, solange insgesamt nicht mehr als 5 Punkte an Untoten betroffen sind"
                    },
                    {
                        "name": "Leitmagie aufheben",
                        "level": 2,
                        "value": "Wenn der Zauberer Ziel eines Spruches aus dem Bereich Leitmagie wird, muß dieser „ankommende“ Spruch vor dem Zauberer einen WW durchführen. Dabei benutzt der Spruch als Stufe die desjenigen, der ihn gewirkt hat. Wenn der „ankommende“ Spruch diesen WW besteht, betrifft er den Zauberer von Leitmagie aufheben normal (der Zauberer hat dann noch seinen normalen WW). Wenn nicht, betrifft er den Zauberer nicht"
                    },
                    {
                        "name": "Kanalisieren verhindern I",
                        "level": 3,
                        "value": "Verhindert, daß per Kanalisieren I ein Spruch übertragen oder empfangen wird. Der Kanalisieren I-Spruch hat keinen WW"
                    },
                    {
                        "name": "Fluch neutralisieren I",
                        "level": 4,
                        "value": "[WW-Mod: -20] Hebt einen Fluch während der Dauer dieses Spruches auf. Der Fluch verschwindet aber nicht und setzt wieder ein, sobald die Dauer abgelaufen ist"
                    },
                    {
                        "name": "Kanalisieren verhindern III",
                        "level": 5,
                        "value": "Wie Kanalisieren verhindern I, aber es betrifft Kanalisieren III"
                    },
                    {
                        "name": "Untote vertreiben IX",
                        "level": 6,
                        "value": "Wie Untote vertreiben V, aber 9 Punkte an Untoten werden betroffen"
                    },
                    {
                        "name": "Fluch aufheben",
                        "level": 7,
                        "value": "Wenn der Fluch seinen WW nicht schafft, ist er aufgehoben. Die Stufe des Fluchs ist die Stufe des Zauberers, der ihn ursprünglich gewirkt hat. Sollte das Aufheben nicht funktionieren, kann der Zauberer es erst dann wieder versuchen, wenn er eine Erfahrungsstufe gewonnen hat"
                    },
                    {
                        "name": "Leitmagie bannen I",
                        "level": 8,
                        "value": "Jeder aktive Spruch aus dem Bereich Leitmagie, der auf dem Ziel liegt, muß einen WW durchführen (verwenden Sie dazu als Stufe des Spruches die des ursprünglich ihn wirkenden Zauberers). Wenn der Spruch seinen WW nicht schafft, erlischt er umgehend"
                    },
                    {
                        "name": "Fluch neutralisieren II",
                        "level": 9,
                        "value": "Wie Fluch neutralisieren I, aber der Fluch wird für eine Stunde pro Stufe aufgehoben"
                    },
                    {
                        "name": "Kanalisieren verhindern V",
                        "level": 10,
                        "value": "Wie Kanalisieren verhindern I, aber es betrifft Kanalisieren V"
                    },
                    {
                        "name": "Untote vertreiben XII",
                        "level": 11,
                        "value": "Wie Untote vertreiben V, aber 12 Punkte an Untoten werden betroffen"
                    },
                    {
                        "name": "Kanalisieren verhindern VIII",
                        "level": 12,
                        "value": "Wie Kanalisieren verhindern I, aber es betrifft Kanalisieren-Sprüche bis zu Stufe VIII"
                    },
                    {
                        "name": "Leitmagie bannen V",
                        "level": 14,
                        "value": "Wie Leitmagie bannen I, aber der Spruch betrifft bis zu 5 Ziele"
                    },
                    {
                        "name": "Kanalisieren verhindern X",
                        "level": 15,
                        "value": "Wie Kanalisieren verhindern I, aber es betrifft Kanalisieren-Sprüche bis zu Stufe X"
                    },
                    {
                        "name": "Untote vertreiben XV",
                        "level": 16,
                        "value": "Wie Untote vertreiben V, aber 15 Punkte an Untoten werden betroffen"
                    },
                    {
                        "name": "Wahrhaftige Fluchneutralisation",
                        "level": 18,
                        "value": "Wie Fluch neutralisieren I, aber der Fluch wird für einen Tag pro Stufe aufgehoben"
                    },
                    {
                        "name": "Leitmagie bannen X",
                        "level": 19,
                        "value": "Wie Leitmagie bannen I, aber der Spruch betrifft bis zu zehn Ziele"
                    },
                    {
                        "name": "Wahrhaftige Untotenvertreibung",
                        "level": 20,
                        "value": "Wie Untote vertreiben V, nur zerstört der Spruch automatisch jeden Untoten der Klasse V und niedriger. Untote der Klasse VI fliehen automatisch"
                    },
                    {
                        "name": "Wahrhaftiger Fluchbann",
                        "level": 25,
                        "value": "[WW-Mod: -50] Wie Fluch aufheben, bis auf den WW-Modifikator"
                    },
                    {
                        "name": "Wahrhaftiger Kanälebann",
                        "level": 30,
                        "value": "Wie Kanalisieren verhindern I, nur kann jeder Kanalisieren-Spruch verhindert werden. Sprüche, die mit Heilige Brücke übertragen werden (siehe Basisliste Kleriker: Kanäle), sind nicht betroffen"
                    },
                    {
                        "name": "Kanalisierten Spruch abfangen",
                        "level": 50,
                        "value": "Der Zauberer kann einen kanalisierten Spruch, der innerhalb der Reichweite übermittelt oder empfangen wird, abfangen und selbst anwenden. Derjenige, der den Spruch losschickt, erhält einen WW (die Angriffsstufe dieses Spruchs steht gegen seine Stufe"
                    }
                ]
            },
            {
                "id": "3.5",
                "name": "8.4.6: Wege der Eingebung",
                "spells": [
                    {
                        "name": "Raten",
                        "level": 1,
                        "value": "Wenn er eine Wahl treffen muß, die auf wenigen oder gar keinen Informationen beruht (z.B. welcher Gang am schnellsten ins Freie führt), kann der Zauberer diesen Spruch einsetzen. Der Spielleiter entscheidet dann, welche Wahl er trifft, wobei er die Entscheidung um 25% zugunsten des Zauberers beeinflußt (würfeln Sie also 1W100: 01-25 entspricht einer falschen Entscheidung, 26-100 einer richtigen). Nein, der SL hat keinen WW"
                    },
                    {
                        "name": "Eingebung I",
                        "level": 3,
                        "value": "Der Zauberer erlebt in einer Vision, was in der nächsten Minute wahrscheinlich geschehen wird, wenn er eine bestimmte Handlung durchführt. Die Gottheit erlaubt allerdings diesen Blick in die Zukunft nur einmal pro gegebener Situation. Und Gottheiten sollte man nicht verärgern"
                    },
                    {
                        "name": "Traum I",
                        "level": 4,
                        "value": "Der Zauberer hat einen Traum über ein vor dem Einschlafen festgelegtes Thema. Er muß einen normalen Schlafzyklus durchschlafen (mindestens 4 Stunden), oder der Spruch liefert kein Ergebnis"
                    },
                    {
                        "name": "Eingebung III",
                        "level": 5,
                        "value": "Wie Eingebung I, aber der Zauberer kann 3 Minuten in die Zukunft blicken"
                    },
                    {
                        "name": "Geschichte des Todes",
                        "level": 6,
                        "value": "Der Zauberer erhält eine Vision der Ereignisse um den Tod eines bestimmten Verstorbenen durch dessen Augen. Bei einem Mord sieht er den Täter (wenn das Opfer ihn sah). Der Zauberer darf nicht weiter als 3 Meter vom Leichnam entfernt sein, und der Zeitpunkt des Todes darf nicht weiter als die Anzahl der Erfahrungsstufen des Zauberers in Jahren zurückliegen"
                    },
                    {
                        "name": "Kanal öffnen I",
                        "level": 7,
                        "value": "Der Zauberer kann mit einem bestimmten, ihm bekannten Ziel Kontakt aufnehmen. Dieser Spruch liefert den genauen Aufenthaltsort dieses Ziels (Richtung und Entfernung). Dieser Spruch wird häufig mit einem Kanalisieren-Spruch verknüpft"
                    },
                    {
                        "name": "Eingebung V",
                        "level": 8,
                        "value": "Wie Eingebung I, aber der Zauberer kann 5 Minuten in die Zukunft blicken"
                    },
                    {
                        "name": "Traum III",
                        "level": 10,
                        "value": "Wie Traum I, aber mit bis zu 3 Träumen pro Nacht mit unterschiedlichen Themen"
                    },
                    {
                        "name": "Eingebung X",
                        "level": 11,
                        "value": "Wie Eingebung I, nur kann der Zauberer 10 Minuten in die Zukunft sehen"
                    },
                    {
                        "name": "Zwiesprache I",
                        "level": 12,
                        "value": "Der Zauberer erhält, normalerweise von seiner Gottheit, die Antwort auf eine Ja-Nein-Frage zu einem einzelnen Thema. Dieser Spruch kann maximal einmal pro Tag angewendet werden"
                    },
                    {
                        "name": "Magisches Wasserbecken I",
                        "level": 13,
                        "value": "Das Ziel ist ein kleines Becken mit klarem, sauberen Wasser. Das Wasser muß ruhig sein (und auch während der Spruchdauer ruhig bleiben). Der Zauberer muß ein Thema bestimmen und zu diesem erscheint im Wasser eine Vision. Die Vision dauert normalerweise 5- 50 Runden"
                    },
                    {
                        "name": "Kanal öffnen II",
                        "level": 15,
                        "value": "Wie Kanal öffnen I, bis auf die Reichweite"
                    },
                    {
                        "name": "Magisches Wasserbecken II",
                        "level": 18,
                        "value": "Wie Magisches Wasserbecken I, nur können 2 Themen ausgewählt werden (die Vision dauert 5-50 Runden für jedes davon)"
                    },
                    {
                        "name": "Wahrhaftige Geschichte des Todes",
                        "level": 19,
                        "value": "Der Zauberer erhält eine Vision der Todesumstände eines beliebigen Toten in einer Entfernung von 3 Metern. Der Zauberer versteht den Grund/die Gründe, warum der Tote starb, erfährt wer der Mörder ist (wenn es ein Mord war) und wer letztendlich für den Tod verantwortlich ist (wenn es einen Verantwortlichen gab). Der Leichnam kann beliebig alt sein"
                    },
                    {
                        "name": "Wahrhaftige Zwiesprache",
                        "level": 20,
                        "value": "Wie Zwiesprache I, nur erhält der Zauberer eine detailliertere Antwort (z.B. einen Namen oder einen kurzen Satz) auf eine Frage nach nur einem Konzept"
                    },
                    {
                        "name": "Wahrhaftige Eingebung",
                        "level": 25,
                        "value": "Wie Eingebung I, nur kann der Zauberer seine Stufe in Minuten in die Zukunft sehen"
                    },
                    {
                        "name": "Wahrhaftiges Kanalöffnen",
                        "level": 30,
                        "value": "Wie Kanal öffnen I, nur kann der Zauberer einen Kanal zu einem beliebigen Ziel öffnen, ganz egal, ob er mit dem Wesen bekannt ist oder nicht. Der Zauberer muß das Wesen, das er sucht näher bestimmen (z.B. als Priester einer bestimmten Gottheit oder als Krieger mit blauen Augen usw.)"
                    },
                    {
                        "name": "Hochgebet",
                        "level": 50,
                        "value": "Der Zauberer erhält detaillierte Informationen von seiner Gottheit auf eine Frage zu einem einzelnen Thema."
                    }
                ]
            }
        ]
    },
    {
        "id": "4",
        "name": "Basisliste Paladin",
        "spellLists": [
            {
                "id": "4.0",
                "name": "8.5.1: Exorzismen",
                "spells": [
                    {
                        "name": "Untote vertreiben I",
                        "level": 1,
                        "value": "Bewirkt, daß ein Untoter flieht oder zerfällt. Alle Untoten sind Klassen zugeteilt. Dieser Spruch betrifft bis zu einem Punkt an Untoten (Untote der Klasse I zählen als ein Punkt, die der Klasse II als zwei Punkte usw.). Belebte Leichen (vgl. Böse Leitmagie, Nekromantie) werden als Untote der Klasse I behandelt und erhalten keinen WW (wenn der Spruch gelingt, zerfallen sie automatisch). In Kreaturen & Monster finden sie vollständige Beschreibungen aller Arten von Untoten. Jedem untoten Ziel steht ein WW zu. Wenn der WW um 50 oder weniger fehlschlägt, flieht es (wenn es nicht fliehen kann, verharrt es bewegungslos). Schlägt der WW um mehr als 50 fehl, zerfällt das Ziel. Für alle Ziele gilt ein Basis-Angriffswurf. Sollte für einen Untoten keine Klasse angegeben sein, verwenden Sie folgende Tabelle: Stufe Klasse Stufe Klasse 1-2 I 9-12 IV 3-5 II 13-15 V 6-8 III 16+ VI Der WW für einen Untoten kann modifiziert werden, indem die Spruchwirkung auf ihn konzentriert wird. Für jeden Punkt des Spruches, der dem Ziel über die benötigten hinaus zugewiesen wird, wird dessen WW mit -5 modifiziert. Daher würde Untote vertreiben V fünf Untote der Klasse I ohne WW-Modifikation betreffen oder einen Untoten der Klasse V mit einer Malus von -20 auf dessen WW oder einen Untoten der Klasse II mit einem Malus von -5 auf dessen WW und zwei Untote der Klasse I ohne WW-Modifikation oder auch jede andere Kombination von Zielen, vorausgesetzt, es werden insgesamt nicht mehr als fünf Punke zugewiesen"
                    },
                    {
                        "name": "Untote entdecken",
                        "level": 2,
                        "value": "Entdeckt die Gegenwart von Untoten im Wirkungsbereich. Der Zauberer kann den Wirkungsbereich in jeder Runde um 1,5m verschieben"
                    },
                    {
                        "name": "Untote vertreiben III",
                        "level": 3,
                        "value": "Wie Untote vertreiben I, aber 3 Punkte an Untoten werden betroffen"
                    },
                    {
                        "name": "Dämon vertreiben I",
                        "level": 4,
                        "value": "Solange der Zauberer sich konzentriert, können Dämonen der Klasse I, die sich im Wirkungsbereich befinden, diesen nicht verlassen, und Dämonen der Klasse I, die außerhalb dieses Bereichs sind, können ihn nicht betreten"
                    },
                    {
                        "name": "Untote vertreiben V",
                        "level": 5,
                        "value": "Wie Untote vertreiben I, aber 5 Punkte an Untoten werden betroffen"
                    },
                    {
                        "name": "Dämon vertreiben II",
                        "level": 6,
                        "value": "Wie Dämon vertreiben I, nur betrifft es Dämonen bis zu Klasse II"
                    },
                    {
                        "name": "Dämon verbannen I",
                        "level": 7,
                        "value": "Verbannt den Zieldämon der Klasse I von dieser Existenzebene für die Wirkungsdauer"
                    },
                    {
                        "name": "Fluch neutralisieren I",
                        "level": 8,
                        "value": "[WW-Mod: -20] Hebt für die Dauer des Spruches einen Fluch auf. Der Fluch ist nicht vollends gebannt und setzt wieder ein, sobald die Dauer abgelaufen ist"
                    },
                    {
                        "name": "Dämon vertreiben III",
                        "level": 9,
                        "value": "Wie Dämon vertreiben I, nur betrifft es Dämonen bis zu Klasse III"
                    },
                    {
                        "name": "Untote vertreiben X",
                        "level": 10,
                        "value": "Wie Untote vertreiben I, aber 10 Punkte an Untoten werden betroffen"
                    },
                    {
                        "name": "Dämon verbannen II",
                        "level": 11,
                        "value": "Wie Dämon verbannen II, nur betrifft Dämonen bis zu Klasse II"
                    },
                    {
                        "name": "Untote vertreiben XII",
                        "level": 12,
                        "value": "Wie Untote vertreiben I, aber 12 Punkte an Untoten werden betroffen"
                    },
                    {
                        "name": "Dämon vertreiben IV",
                        "level": 13,
                        "value": "Wie Dämon vertreiben I, nur betrifft es Dämonen bis zu Klasse IV"
                    },
                    {
                        "name": "Fluch neutralisieren II",
                        "level": 14,
                        "value": "Wie Fluch neutralisieren I, bis auf die Wirkungsdauer"
                    },
                    {
                        "name": "Untote vertreiben XV",
                        "level": 15,
                        "value": "Wie Untote vertreiben I, aber 15 Punkte an Untoten werden betroffen"
                    },
                    {
                        "name": "Dämon vertreiben V",
                        "level": 16,
                        "value": "Wie Dämon vertreiben I, nur betrifft es Dämonen bis zu Klasse V"
                    },
                    {
                        "name": "Dämon verbannen III",
                        "level": 17,
                        "value": "Wie Dämon verbannen II, nur betrifft Dämonen bis zu Klasse III"
                    },
                    {
                        "name": "Fluch neutralisieren III",
                        "level": 18,
                        "value": "Wie Fluch neutralisieren I, bis auf die Wirkungsdauer"
                    },
                    {
                        "name": "Dämon vertreiben VI",
                        "level": 19,
                        "value": "Wie Dämon vertreiben I, nur betrifft es Dämonen bis zu Klasse VI"
                    },
                    {
                        "name": "Wahrhaftige Untotenvertreibung",
                        "level": 20,
                        "value": "Wie Untote vertreiben V, nur zerstört der Spruch automatisch jeden Untoten der Klasse V und niedriger. Untote der Klasse VI fliehen automatisch"
                    },
                    {
                        "name": "Wahrhaftige Dämonenvertreibung",
                        "level": 25,
                        "value": "Wie Dämon vertreiben VI, bis auf den Wirkungsbereich"
                    },
                    {
                        "name": "Wahrhaftiger Fluchbann",
                        "level": 30,
                        "value": "[WW-Mod: -50] Hebt einen Fluch auf, wenn diesem sein WW nicht gelingt. Die Stufe des Fluchs ist die Stufe des Zauberers, der ihn ursprünglich gewirkt hat. Wenn es dem Zauberer mißlingt, den Fluch aufzuheben, kann er es erst dann erneut versuchen, wenn er eine Erfahrungsstufe hinzubekommen hat"
                    },
                    {
                        "name": "Wahrhaftige Dämonenverbannung",
                        "level": 50,
                        "value": "Wie Dämon verbannen I, nur betrifft der Spruch einen Dämon bis zur Klasse IV."
                    }
                ]
            },
            {
                "id": "4.1",
                "name": "8.5.2: Handauflegen",
                "spells": [
                    {
                        "name": "Heilung I",
                        "level": 1,
                        "value": "1W10 Treffer des Ziels werden geheilt"
                    },
                    {
                        "name": "Blutung stoppen I",
                        "level": 2,
                        "value": "Gestattet dem Zauberer, die Blutung einer Wunde zu stoppen, durch die das Ziel einen Treffer pro Runde verliert. Das Ziel darf nicht bewegt werden, sonst setzt der Blutverlust wieder in der ursprünglichen Geschwindigkeit ein"
                    },
                    {
                        "name": "Erfrierungen/Verbrennungen I",
                        "level": 3,
                        "value": "Heilt bei einem Ziel und in einem Bereich einen leichten Frostbrand oder eine Verbrennung ersten Grades"
                    },
                    {
                        "name": "Heilung einfacher Brüche",
                        "level": 4,
                        "value": "Erlaubt dem Zauberer, einen einzelnen, einfachen Bruch zu heilen (keine komplexen Brüche, Trümmerbrüche, Gelenkschäden usw.). Die Genesungszeit beträgt einen Tag"
                    },
                    {
                        "name": "Heilung III",
                        "level": 5,
                        "value": "Wie Heilung I, nur werden 3W10 des Ziels geheilt"
                    },
                    {
                        "name": "Benommenheit heilen I",
                        "level": 6,
                        "value": "Heilt eine Runde Benommenheit des Ziels"
                    },
                    {
                        "name": "Heilung komplexer Brüche",
                        "level": 7,
                        "value": "Wie Heilung einfacher Brüche, aber der Zauberer kann auch komplexe Brüche heilen. Die Genesungszeit beträgt einen Tag"
                    },
                    {
                        "name": "Widerstand gegen Krankheiten I",
                        "level": 8,
                        "value": "Während der Spruchdauer erhält das Ziel einen zusätzlichen WW gegen Krankheit(en)"
                    },
                    {
                        "name": "Widerstand gegen Gift I",
                        "level": 9,
                        "value": "Während der Spruchdauer erhält das Ziel einen zusätzlichen WW gegen Gift(e)"
                    },
                    {
                        "name": "Heilung kleiner Blutgefäße",
                        "level": 10,
                        "value": "Erlaubt dem Zauberer, ein verletztes, kleines Blutgefäß vollständig zu heilen (eine Ader, deren Blutung nicht mehr als 4 Treffer/Runde verursacht, keine Hauptschlagadern oder Venen)"
                    },
                    {
                        "name": "Heilung V",
                        "level": 11,
                        "value": "Wie Heilung I, nur werden 5W10 des Ziels geheilt"
                    },
                    {
                        "name": "Muskel-/Sehnenheilung",
                        "level": 12,
                        "value": "Gestattet den Zauberer, einen verletzten Muskel oder eine verletzte Sehne zu heilen (nicht zu ersetzen). Die Genesungszeit beträgt eine Stunde"
                    },
                    {
                        "name": "Erfrierungen/Verbrennungen III",
                        "level": 13,
                        "value": "Wie Erfrierungen/Verbrennungen I, nur kann der Zauberer 3 Bereiche mit schwacher Erfrierung/Verbrennung heilen oder schweren Erfrierungs-/Verbrennungsschaden in einem Bereich (z.B. eine Verbrennung zweiten Grades) oder eine Kombination aus einem Bereich mit leichter und einem mit mittleren Erfrierung/Verbrennung"
                    },
                    {
                        "name": "Benommenheit heilen II",
                        "level": 14,
                        "value": "Wie Benommenheit heilen I, nur kann der Zauberer 2 Runden Benommenheit heilen"
                    },
                    {
                        "name": "Lähmung heilen",
                        "level": 15,
                        "value": "Mit diesem Spruch kann eine Lähmung aufgehoben werden"
                    },
                    {
                        "name": "Heilung X",
                        "level": 16,
                        "value": "Wie Heilung I, nur werden 10W10 des Ziels geheilt"
                    },
                    {
                        "name": "Erfrierungen/Verbrennungen IV",
                        "level": 17,
                        "value": "Wie Erfrierungen/Verbrennungen I, nur kann der Zauberer 4 Bereiche mit leichter Erfrierung/ Verbrennung oder 2 mit mittlerer oder einen mit leichter und einen mit schwerer oder 2 mit leichter und einen mit mittlerer Verbrennung heilen"
                    },
                    {
                        "name": "Krankheit heilen",
                        "level": 18,
                        "value": "Der Zauberer kann das Ziel von einer beliebigen Krankheit heilen"
                    },
                    {
                        "name": "Entgiften",
                        "level": 19,
                        "value": "Der Zauberer kann ein beliebiges Gift aus dem Ziel entfernen"
                    },
                    {
                        "name": "Wahrhaftige Benommenheitsheilung",
                        "level": 20,
                        "value": "Wie Benommenheit heilen I, nur heilt der Spruch sämtliche Benommenheit"
                    },
                    {
                        "name": "Heilung XV",
                        "level": 25,
                        "value": "Wie Heilung XV, nur werden 15W10 des Ziels geheilt"
                    },
                    {
                        "name": "Wahrhaftige Heilung",
                        "level": 30,
                        "value": "Wie Heilung I, nur werden alle Treffer des Ziels geheilt"
                    },
                    {
                        "name": "Wahrhaftiges Handauflegen",
                        "level": 50,
                        "value": "Der Zauberer kann in jeder Runde einen niedrigeren Spruch dieser Liste wirken."
                    }
                ]
            },
            {
                "id": "4.2",
                "name": "8.5.3: Heilige Schilde",
                "spells": [
                    {
                        "name": "Schutzgebet I",
                        "level": 1,
                        "value": "Jeder im Wirkungsbereich, der die Gesinnung des Zauberers teilt (Spielleiterentscheidung), zieht 5 von allen Elementarangriffen gegen sich ab. Zudem erhält er einen Bonus von 5 auf Widerstandswürfe gegen Sprüche. Die Boni gelten nicht für den Zauberer selbst"
                    },
                    {
                        "name": "Aura",
                        "level": 2,
                        "value": "Erzeugt eine strahlende Aura um das Ziel, die es mächtiger erscheinen läßt, was einen Malus von -10 auf alle Angriffe gegen es zur Folge hat"
                    },
                    {
                        "name": "Schild",
                        "level": 3,
                        "value": "Erschafft einen unsichtbaren Energieschild vor dem Zauberer, der wie ein normaler Schild wirkt (zieht 25 von entsprechenden Angriffen ab), aber keine Hand belegt. Dieser Spruch kann nicht mit einem „echten“ Schild kombiniert werden"
                    },
                    {
                        "name": "Flimmern",
                        "level": 4,
                        "value": "Das Ziel erscheint Angreifern verschwommen"
                    },
                    {
                        "name": "Schmerz ertragen I",
                        "level": 5,
                        "value": "Der Zauberer kann 25% seiner Trefferpunkte zusätzlich an Schaden erleiden, bevor er das Bewußtsein verliert. Er steckt diese Treffer immer noch ein, und sie bleiben, wenn der Spruch aufhört zu wirken"
                    },
                    {
                        "name": "Schutzgebet II",
                        "level": 6,
                        "value": "Wie Schutzgebet I, nur sind die Boni 10"
                    },
                    {
                        "name": "Ablenken I",
                        "level": 7,
                        "value": "Der Zauberer kann ein beliebiges Geschoß (oder eine Wurfwaffe) ablenken, das durch den Bereich von 3 Meter um ihn hindurchfliegt (er muß das Geschoß sehen können). Der Angriff mit diesem Geschoß erhält dadurch einen Malus von -100"
                    },
                    {
                        "name": "Wahrhaftige Aura",
                        "level": 8,
                        "value": "Wie Aura, nur läßt der Spruch das Ziel sehr mächtig erscheinen, was einen Malus von -15 auf alle Angriffe gegen es zur Folge hat"
                    },
                    {
                        "name": "Klingenabwehr I",
                        "level": 9,
                        "value": "Der Zauberer kann einen beliebigen Nahkampfangriff abwehren, sofern er ihn sieht (und er innerhalb der Reichweite stattfindet). Der Nahkampfangriff erhält dadurch einen Malus von -50"
                    },
                    {
                        "name": "Schmerz ertragen II",
                        "level": 10,
                        "value": "Wie Schmerz ertragen I, nur kann der Zauberer 50% zusätzlich einstecken"
                    },
                    {
                        "name": "Schutzgebet III",
                        "level": 11,
                        "value": "Wie Schutzgebet I, nur sind die Boni 15"
                    },
                    {
                        "name": "Ablenken II",
                        "level": 12,
                        "value": "Wie Ablenken I, nur kann der Zauberer bis zu 2 Geschosse abwehren"
                    },
                    {
                        "name": "Fehlschuß I",
                        "level": 13,
                        "value": "Der Zauberer kann jedes Schuß- oder Wurfgeschoß ablenken, das durch den Bereich von 3 Metern um ihn hindurchfliegt (er muß in der Lage sein, das Geschoß zu sehen). Dieser Fernkampfangriff verfehlt das Ziel automatisch"
                    },
                    {
                        "name": "Klingenabwehr II",
                        "level": 14,
                        "value": "Wie Klingenabwehr I, nur betrifft der Spruch 2 Angriffe"
                    },
                    {
                        "name": "Schmerz ertragen III",
                        "level": 15,
                        "value": "Wie Schmerz ertragen I, nur kann der Zauberer 75% zusätzlich einstecken"
                    },
                    {
                        "name": "Schutzgebet IV",
                        "level": 16,
                        "value": "Wie Schutzgebet I, nur sind die Boni 20"
                    },
                    {
                        "name": "Ablenken III",
                        "level": 17,
                        "value": "Wie Ablenken I, nur kann der Zauberer bis zu 3 Geschosse abwehren"
                    },
                    {
                        "name": "Fehlschuß III",
                        "level": 18,
                        "value": "Wie Fehlschuß I, nur betrifft der Spruch bis zu 3 Geschosse"
                    },
                    {
                        "name": "Klingenabwehr III",
                        "level": 19,
                        "value": "Wie Klingenabwehr I, nur betrifft der Spruch 3 Angriffe"
                    },
                    {
                        "name": "Schmerz ertragen IV",
                        "level": 20,
                        "value": "Wie Schmerz ertragen I, nur kann der Zauberer 100% zusätzlich einstecken"
                    },
                    {
                        "name": "Wahrhaftiges Schutzgebet",
                        "level": 25,
                        "value": "Wie Schutzgebet I, nur sind die Boni 25"
                    },
                    {
                        "name": "Massen-Ablenken",
                        "level": 30,
                        "value": "Wie Ablenken I, nur kann der Zauberer ein Geschoß pro Stufe abwehren"
                    },
                    {
                        "name": "Wahrhaftige Heilige Schilde",
                        "level": 50,
                        "value": "Der Zauberer kann in jeder Runde einen niedrigeren Spruch dieser Liste wirken."
                    }
                ]
            },
            {
                "id": "4.3",
                "name": "8.5.4: Heilige Waffen",
                "spells": [
                    {
                        "name": "Heiliger Angriff I",
                        "level": 1,
                        "value": "Gewährt dem Zauberer +15 auf seinen Nah- oder Fernkampfangriff in dieser Runde"
                    },
                    {
                        "name": "Rechtschaffener Hieb I",
                        "level": 2,
                        "value": "Nachdem der Zauberer diesen Spruch gewirkt hat, besteht eine Chance, daß sein nächster Fern- oder Nahkampfangriff hinsichtlich kritischer Treffer als „magisch“ gilt (was normalerweise nur bei großen und gewaltigen Wesen wesentlich ist). Die Chance beträgt 10% plus 5% für jede Runde, in der sich der Zauberer konzentriert hat (d.h. betete), direkt bevor er diesen Spruch vorbereitete und wirkte. Der Angriff, auf den sich dieser Spruch bezieht, muß innerhalb von einer Minute pro Stufe darauf folgen, daß dieser Spruch gewirkt wurde"
                    },
                    {
                        "name": "Heilige Stärke I",
                        "level": 3,
                        "value": ""
                    },
                    {
                        "name": "Heiliger Angriff II",
                        "level": 4,
                        "value": "Wie Heiliger Angriff I, nur ist der Bonus +20"
                    },
                    {
                        "name": "Rechtschaffener Hieb II",
                        "level": 5,
                        "value": "Wie Rechtschaffener Hieb I, nur gilt der Angriff als mit einer Mithrilwaffe ausgeführt"
                    },
                    {
                        "name": "Heiliger Fokus",
                        "level": 6,
                        "value": "Wie Rechtschaffener Hieb I, nur gilt der kritische Treffer als „heilig“ und die Chance dafür liegt bei 20% plus 2% für jeden weiteren Magiepunkt, der dafür verwendet wird, diesen Spruch zu wirken. Der Zauberer kann maximal so viele Magiepunkte wie seine Stufenanzahl für diesen Spruch aufwenden. Zum Beispiel hätte ein sechsstufiger Paladin eine 20% Chance, während ein Paladin der 10 Stufe auf eine 28% Chance kommen könnte (indem er 10 Magiepunkte in den Spruch investiert)"
                    },
                    {
                        "name": "Heiliger Angriff III",
                        "level": 7,
                        "value": "Wie Heiliger Angriff I, nur ist der Bonus +25"
                    },
                    {
                        "name": "Rechtschaffener Hieb III",
                        "level": 8,
                        "value": "Wie Rechtschaffener Hieb I, nur gilt der Angriff als „heilig“"
                    },
                    {
                        "name": "Heilige Aura I",
                        "level": 9,
                        "value": "Eine helle, schimmernde Aura umgibt den Zauberer. Alle Kreaturen „der Dunkelheit“ müssen jede Runde einen WW bestehen, oder sie erleiden einen kritischen Treffer der Intensität A (die Art des kritischen Treffers legt der SL danach fest, was es für ein Wesen ist)"
                    },
                    {
                        "name": "Heiliger Angriff IV",
                        "level": 10,
                        "value": "Wie Heiliger Angriff I, nur ist der Bonus +30"
                    },
                    {
                        "name": "Rechtschaffener Hieb IV",
                        "level": 11,
                        "value": "Wie Rechtschaffener Hieb I, nur gilt der Angriff als mit einer gezielt tödlichen Waffe ausgeführt (die Art der Kreatur muß festgelegt werden, wenn der Spruch gewirkt wird)"
                    },
                    {
                        "name": "Heilige Stärke II",
                        "level": 12,
                        "value": "Wie Heilige Stärke I, nur ist der Bonus auf das Stärkeattribut +10 für ein Manöver (+20 auf einen Nahkampf-, +10 auf einen Fernkampfangriff )"
                    },
                    {
                        "name": "Heiliger Angriff V",
                        "level": 13,
                        "value": "Wie Heiliger Angriff I, nur ist der Bonus +35"
                    },
                    {
                        "name": "Heilige Aura II",
                        "level": 15,
                        "value": "Wie Heilige Aura I, nur erleiden die Gegner kritische Treffer der Intensität B"
                    },
                    {
                        "name": "Heiliger Angriff VI",
                        "level": 16,
                        "value": "Wie Heiliger Angriff I, nur ist der Bonus +40"
                    },
                    {
                        "name": "Heilige Stärke III",
                        "level": 17,
                        "value": "Wie Heilige Stärke I, nur ist der Bonus auf das Stärkeattribut +15 für ein Manöver (+30 auf einen Nahkampf-, +15 auf einen Fernkampfangriff )"
                    },
                    {
                        "name": "Heiliger Angriff VII",
                        "level": 19,
                        "value": "Wie Heiliger Angriff I, nur ist der Bonus +45"
                    },
                    {
                        "name": "Wahrhaftige Heilige Aura",
                        "level": 20,
                        "value": "Wie Heilige Aura I, nur erleiden die Gegner kritische Treffer der Intensität C"
                    },
                    {
                        "name": "Wahrhaftiger Heiliger Angriff",
                        "level": 25,
                        "value": "Wie Heiliger Angriff I, nur ist der Bonus +50"
                    },
                    {
                        "name": "Wahrhaftiger Heiliger Fokus",
                        "level": 30,
                        "value": "Wie Heiliger Fokus, nur ist der Angriff automatisch heilig"
                    },
                    {
                        "name": "Heiliger Märtyrer",
                        "level": 50,
                        "value": "Der Zauberer setzt alle im Wirkungsbereich der puren Macht seiner Gottheit aus. Alle im Wirkungsbereich erleiden einen +100 Feuerball-Angriff (auf den Zauberer zentriert). Jeder Trefferpunktschaden wird verdoppelt und der Spruch verursacht einen zusätzlichen gezielt tödlichen kritischen Treffer (hierfür gilt die Spalte Große Kreatur/gezielt tödlicher Treffer auf der Kritischen Spruchtreffertabelle für Kreaturen 13-5, Seite 253). Der Zauberer ist der Mittelpunkt der Explosion und nicht immun gegen den Schaden. Den Zauberer schützen weder Gegenstände, noch Sprüche noch sonst etwas vor dieser Explosion."
                    }
                ]
            },
            {
                "id": "4.4",
                "name": "8.5.5: Wege der Inspiration",
                "spells": [
                    {
                        "name": "Mut",
                        "level": 1,
                        "value": "Während der Spruchdauer steht allen im Wirkungsbereich (einschließlich des Zauberers) ein zweiter WW gegen Furcht- und Panikwirkungen zu. Für den zweiten WW gilt ein zusätzlicher Bonus von +10"
                    },
                    {
                        "name": "Inspiration I",
                        "level": 2,
                        "value": "Der Zauberer inspiriert alle Verbündeten im Wirkungsbereich (sie müssen wissen, daß er da ist). Alle Verbündeten erhalten für die Spruchdauer einen Bonus von +5 auf Angriffe und Bewegungsmanöver. Dieser Spruch wirkt nur im Kampf und in hoch religiösen Augenblicken (z.B. eine rednerische Darbietung kurz vor einer großen Schlacht). Diese Boni gelten nicht für den Zauberer"
                    },
                    {
                        "name": "Stimme der Freundschaft",
                        "level": 3,
                        "value": "Solange sie miteinander sprechen, wird das Ziel dieses Spruchs den Zauberer für einen guten Freund halten und glauben, daß er ganz in seinem Interesse handelt"
                    },
                    {
                        "name": "Inspiration II",
                        "level": 4,
                        "value": "Wie Inspiration I, nur sind die Boni +10"
                    },
                    {
                        "name": "Stimme der Vernunft",
                        "level": 5,
                        "value": "Solange der Zauberer spricht, glaubt das Ziel, daß die Vorstellungen und Darlegungen, denen der Zauberer Ausdruck verleiht, richtig und gültig sind"
                    },
                    {
                        "name": "Inspiration III",
                        "level": 6,
                        "value": "Wie Inspiration I, nur sind die Boni +15"
                    },
                    {
                        "name": "Stimme der Besonnenheit",
                        "level": 7,
                        "value": "Solange der Zauberer spricht, ist das Ziel bedachtsamer (weniger unbesonnen) und neigt dazu, den Warnungen des Zauberers ohne Zögern und Zweifel zu folgen"
                    },
                    {
                        "name": "Befehl I",
                        "level": 8,
                        "value": "Das Ziel muß dem Zauberer gehorchen. Allerdings wird es nichts tun, was ihm völlig fremd wäre (z.B. Selbstmord begehen, sich blenden usw.)"
                    },
                    {
                        "name": "Inspiration IV",
                        "level": 9,
                        "value": "Wie Inspiration I, nur sind die Boni +20"
                    },
                    {
                        "name": "Worte der Freundschaft",
                        "level": 10,
                        "value": "Wie Stimme der Freundschaft, nur sind alle betroffen, die den Zauberer hören können"
                    },
                    {
                        "name": "Inspiration V",
                        "level": 11,
                        "value": "Wie Inspiration I, nur sind die Boni +25"
                    },
                    {
                        "name": "Befehl II",
                        "level": 13,
                        "value": "Wie Befehl I, nur sind 2 Ziele betroffen"
                    },
                    {
                        "name": "Worte der Vernunft",
                        "level": 14,
                        "value": "Wie Stimme der Vernunft, nur betrifft der Spruch alle, die den Zauberer hören können"
                    },
                    {
                        "name": "Inspiration VI",
                        "level": 15,
                        "value": "Wie Inspiration I, nur sind die Boni +30"
                    },
                    {
                        "name": "Wahrhaftiger Mut",
                        "level": 16,
                        "value": "Wie Mut, nur gelingt der zweite WW automatisch"
                    },
                    {
                        "name": "Inspiration VII",
                        "level": 17,
                        "value": "Wie Inspiration I, nur sind die Boni +35"
                    },
                    {
                        "name": "Worte der Besonnenheit",
                        "level": 18,
                        "value": "Wie Stimme der Besonnenheit, nur betrifft der Spruch alle, die den Zauberer hören können"
                    },
                    {
                        "name": "Inspiration VIII",
                        "level": 19,
                        "value": "Wie Inspiration I, nur sind die Boni +40"
                    },
                    {
                        "name": "Stimme der Überzeugung",
                        "level": 20,
                        "value": "[WW-Mod.: 50] Nachdem der Zauberer diesen Spruch wirkte, muß er die Wahrheit sagen (soweit er sie weiß). Alle Ziele, deren WW mißlingt, glauben, daß der Zauberer die reine Wahrheit sagt"
                    },
                    {
                        "name": "Wahrhaftige Inspiration I",
                        "level": 25,
                        "value": "Wie Inspiration I, nur sind die Boni +50"
                    },
                    {
                        "name": "Worte der Überzeugung",
                        "level": 30,
                        "value": "Wie Stimme der Überzeugung, nur betrifft der Spruch alle, die den Zauberer hören können"
                    },
                    {
                        "name": "Meisterschaft der Inspiration",
                        "level": 50,
                        "value": "Der Zauberer kann in jeder Runde einen niedrigeren Spruch dieser Liste verwenden."
                    }
                ]
            },
            {
                "id": "4.5",
                "name": "8.5.6: Zwiesprache",
                "spells": [
                    {
                        "name": "Feinde entdecken I",
                        "level": 1,
                        "value": "Entdeckt die Gesamtzahl der „Feinde“ (liefert die ungefähre Richtung und Entfernung). Der Spruch enthüllt auch, welche Feinde am stärksten vertreten sind (deren Gesamtstufe). In jeder Runde kann sich der Zauberer auf einen anderen 15m-Radius konzentrieren"
                    },
                    {
                        "name": "Leitmagie aufheben",
                        "level": 2,
                        "value": "Wenn der Zauberer Ziel eines Spruches aus dem Bereich Leitmagie wird, muß dieser „ankommende“ Spruch vor dem Zauberer einen WW durchführen. Dabei benutzt der Spruch als Stufe die desjenigen, der ihn gewirkt hat. Wenn der „ankommende“ Spruch diesen WW besteht, betrifft er den Wirker von Leitmagie aufheben normal, andernfalls hat er keine Wirkung auf ihn"
                    },
                    {
                        "name": "Essenz aufheben",
                        "level": 3,
                        "value": "Wie Leitmagie aufheben, nur sind Sprüche aus dem Bereich Essenz betroffen"
                    },
                    {
                        "name": "Mentalismus aufheben",
                        "level": 4,
                        "value": "Wie Leitmagie aufheben, nur sind Sprüche aus dem Bereich Mentalismus betroffen"
                    },
                    {
                        "name": "Traum I",
                        "level": 5,
                        "value": "Der Zauberer hat einen Traum über ein Thema, das er kurz bevor er einschläft festlegt. Er muß einen normalen Schlafzyklus durchschlafen (mindestens 4 Stunden), damit der Spruch wirkt"
                    },
                    {
                        "name": "Feindessprache",
                        "level": 6,
                        "value": "Für die Dauer dieses Spruches kann der Zauberer die Sprache eines „Feindes“ mit einem Rang von 8 lesen und schreiben"
                    },
                    {
                        "name": "Leitmagie bannen I",
                        "level": 7,
                        "value": "Für jeden Spruch aus dem Bereich Leitmagie, der auf dem Ziel liegt, muß ein WW durchgeführt werden (verwenden Sie dazu als Stufe des Spruches die des Zauberers, der ihn ursprünglich wirkte). Mißlingt der WW, so ist der Spruch gebannt"
                    },
                    {
                        "name": "Essenz bannen I",
                        "level": 8,
                        "value": "Wie Leitmagie bannen I, nur sind Sprüche aus dem Bereich Essenz betroffen"
                    },
                    {
                        "name": "Mentalismus bannen I",
                        "level": 9,
                        "value": "Wie Leitmagie bannen I, nur sind Sprüche aus dem Bereich Mentalismus betroffen"
                    },
                    {
                        "name": "Feinde entdecken II",
                        "level": 10,
                        "value": "Wie Feinde entdecken I, bis auf den Wirkungsbereich"
                    },
                    {
                        "name": "Traum III",
                        "level": 11,
                        "value": "Wie Traum I, nur kann der Zauberer 3 Träume in der Nacht zu verschiedenen Themen haben"
                    },
                    {
                        "name": "Geschichte des Todes",
                        "level": 12,
                        "value": "Der Zauberer sieht in einer Vision durch die Augen eines bestimmten Verstorbenen die Umstände seines Todes. Wenn der Tote ermordet wurde, sieht er den Täter (falls das Opfer in sah). Der Zauberer darf nicht weiter als 3 Meter vom Leichnam entfernt sein, und der Tod darf nicht länger als die Stufe des Zauberers in Jahren zurückliegen"
                    },
                    {
                        "name": "Kanal öffnen I",
                        "level": 13,
                        "value": "Der Zauberer kann mit einem beliebigen Ziel Kontakt aufnehmen, mit dem er bekannt ist. Dieser Spruch liefert den genauen Aufenthaltsort des anderen (Richtung und Entfernung). Dieser Spruch wird häufig mit einem Kanalisieren-Spruch verbunden (siehe Spruchliste Kanäle, Seite 87)"
                    },
                    {
                        "name": "Nullsphäre Leitmagie I",
                        "level": 14,
                        "value": "Wie Leitmagie bannen, bis auf den Wirkungsbereich, der auf den Zauberer zentriert ist. Wenn die Sphäre auf einen wirksamen Leitmagiespruch trifft, muß ihm ein WW gelingen (mit einem Sonderbonus von +30) oder er wird aufgehoben (und nicht gebannt), solange er innerhalb des Sphärenradius wirksam ist"
                    },
                    {
                        "name": "Nullsphäre Essenz I",
                        "level": 15,
                        "value": "Wie Nullsphäre Leitmagie, nur betrifft die Sphäre Essenzsprüche"
                    },
                    {
                        "name": "Nullsphäre Mentalismus I",
                        "level": 16,
                        "value": "Wie Nullsphäre Leitmagie, nur betrifft die Sphäre Mentalismussprüche"
                    },
                    {
                        "name": "Zwiesprache I",
                        "level": 17,
                        "value": "Der Zauberer erhält, normalerweise von seiner Gottheit, die Antwort auf eine Ja-Nein-Frage zu einem einzelnen Thema. Dieser Spruch kann maximal einmal pro Tag angewendet werden"
                    },
                    {
                        "name": "Wahrhaftige Geschichte des Todes",
                        "level": 19,
                        "value": "Der Zauberer erhält eine Vision der Todesumstände eines beliebigen Toten in einer Entfernung von drei Metern. Der Zauberer versteht den Grund/die Gründe, warum der Tote starb, erfährt wer der Mörder ist (wenn es ein Mord war) und wer letztendlich für den Tod verantwortlich ist (wenn es einen Verantwortlichen gab). Der Leichnam kann beliebig alt sein"
                    },
                    {
                        "name": "Wahrhaftige Feindentdeckung",
                        "level": 20,
                        "value": "Wie Feind entdecken I, bis auf den Wirkungsbereich und die Reichweite"
                    },
                    {
                        "name": "Wahrhaftige Zwiesprache",
                        "level": 25,
                        "value": "Wie Zwiesprache I, nur erhält der Zauberer eine detailliertere Antwort (z.B. einen Namen oder einen kurzen Satz) auf eine Frage nach nur einem Konzept"
                    },
                    {
                        "name": "Wahrhaftiges Kanalöffnen",
                        "level": 30,
                        "value": "Wie Kanal öffnen I, nur kann der Zauberer einen Kanal zu einem beliebigen Ziel öffnen, ganz egal, ob er mit dem Wesen bekannt ist oder nicht. Der Zauberer muß das Wesen, das er sucht, näher bestimmen (z.B. als Priester einer bestimmten Gottheit oder als Krieger mit blauen Augen usw.)"
                    },
                    {
                        "name": "Hochgebet",
                        "level": 50,
                        "value": "Der Zauberer erhält detaillierte Informationen von seiner Gottheit auf eine Frage zu einem einzelnen Thema."
                    }
                ]
            }
        ]
    },
    {
        "id": "5",
        "name": "Basisliste Waldläufer",
        "spellLists": [
            {
                "id": "5.0",
                "name": "8.6.1: Beschwörungen der Natur",
                "spells": [
                    {
                        "name": "Nahrung",
                        "level": 1,
                        "value": "Ein Tier kommt mit etwas Nahrung zum Zauberer: mit Beeren, Nüssen oder Wurzelknollen (etwas Pflanzlichem). Das Tier läßt die Nahrung vor dem Zauberer fallen und verschwindet wieder in der Wildnis"
                    },
                    {
                        "name": "Wärme",
                        "level": 2,
                        "value": "Ein Tier mit dichtem Fell kommt zum Zauberer und legt sich in seiner Nähe nieder. Das Tier läßt zu, daß sich der Zauberer (und nur er) neben ihm hinlegt und sich wärmt"
                    },
                    {
                        "name": "Führer",
                        "level": 3,
                        "value": "Ein Tier kommt zum Zauberer, das den Weg zu einem bestimmten Ort kennt. Er führt den Zauberer dorthin, solange der sich auf den Ort konzentriert"
                    },
                    {
                        "name": "Wächter",
                        "level": 4,
                        "value": "Ein Tier, das groß genug ist, um mittlere Angriffe ausführen zu können, kommt zum Zauberer. Es wird versuchen, den Zauberer vor Angriffen zu schützen. Wenn der Zauberer die Gegend verläßt, in der er den Spruch gewirkt hat, begleitet das Tier ihn nicht (d.h. es verläßt ihn)"
                    },
                    {
                        "name": "Reittier",
                        "level": 5,
                        "value": "Ein großes Tier kommt zum Zauberer und dient ihm als Reittier"
                    },
                    {
                        "name": "Jäger",
                        "level": 6,
                        "value": "Wie Nahrung, aber das Tier bringt dem Zauberer frisch erlegte Beute (Fleisch)"
                    },
                    {
                        "name": "Sinn",
                        "level": 7,
                        "value": "Ein Tier. bei dem ein Sinn stärker ausgeprägt ist als beim Zauberer, kommt zu ihm. Während der Wirkungsdauer des Spruches nimmt das Tier für ihn mit diesem Sinn wahr. Der Zauberer kann sich konzentrieren, damit ihm das Tier übermittelt, was es wahrgenommen hat"
                    },
                    {
                        "name": "Gruppe",
                        "level": 9,
                        "value": "Eine Gruppe Tiere kommt zum Zauberer und bleibt in der Nähe des Bereichs, wo der Spruch gewirkt wurde. Diese Tiere müssen normalerweise als Gruppe unterwegs sein (wie Wölfe, Rehe, Vögel, usw.)"
                    },
                    {
                        "name": "Massen-Beschwörung",
                        "level": 10,
                        "value": "Der Zauberer kann einen beliebigen Spruch niedrigerer Stufe dieser Liste anwenden, aber ein Tier pro Stufe erscheint"
                    },
                    {
                        "name": "Pflanzen verbreiten I",
                        "level": 12,
                        "value": "Durch diesen Spruch überwächst der Boden mit Gras und kleinen Pflanzen anderer Arten. Die Pflanzen muß es im Wirkungsbereich bereits geben. Der Spruch läßt sie sich nur vermehren und schneller wachsen"
                    },
                    {
                        "name": "Nebelgebet",
                        "level": 13,
                        "value": "Der Zauberer betet zu seiner Gottheit um Regen. Es besteht eine Chance von 2% pro Stufe des Zauberers, daß das Gebet erhört wird. Siehe Anmerkung 6 unten"
                    },
                    {
                        "name": "Regengebet",
                        "level": 14,
                        "value": "Wie Nebelgebet, nur erbittet der Zauberer leichten Regen"
                    },
                    {
                        "name": "Pflanzen verbreiten II",
                        "level": 15,
                        "value": "Wie Pflanzen verbreiten, nur verbreitet der Spruch auch Schößlinge und kleine Bäume"
                    },
                    {
                        "name": "Sturmgebet",
                        "level": 16,
                        "value": "Wie Nebelgebet, nur erbittet der Zauberer einen starken Donnersturm"
                    },
                    {
                        "name": "Hagelgebet",
                        "level": 17,
                        "value": "Wie Nebelgebet, nur erbittet der Zauberer einen Hagelsturm"
                    },
                    {
                        "name": "Gewittergebet",
                        "level": 19,
                        "value": "Wie Nebelgebet, nur erbittet der Zauberer einen Gewittersturm"
                    },
                    {
                        "name": "Wirbelsturmgebet",
                        "level": 20,
                        "value": "Wie Nebelgebet, nur erbittet der Zauberer ein Wetter, das zu einem Wirbelsturm führt"
                    },
                    {
                        "name": "Klarwettergebet",
                        "level": 25,
                        "value": "Wie Nebelgebet, nur erbittet der Zauberer klares Wetter"
                    },
                    {
                        "name": "Wahrhaftiges Wettergebet",
                        "level": 30,
                        "value": "Wie Nebelgebet, nur gewährt die Gottheit das Wetter, das dem derzeitigen Ziel des Zauberer am vorteilhaftesten ist"
                    },
                    {
                        "name": "Gebetsmeisterschaft",
                        "level": 50,
                        "value": "Wie jeder andere GebetsSpruch auf dieser Liste, nur liegt die Chance bei 95%, daß das Wetter eintritt."
                    }
                ]
            },
            {
                "id": "5.1",
                "name": "8.6.2: Meisterschaft der Pfade",
                "spells": [
                    {
                        "name": "Pfadkunde",
                        "level": 1,
                        "value": "Der Zauberer erfährt Anfang und „Ziel“ des nächsten Pfades im Wirkungsbereich"
                    },
                    {
                        "name": "Nachtsicht",
                        "level": 2,
                        "value": "Der Zauberer kann in einer normaler Nacht 30 Meter weit wie am Tag sehen. Vgl. Abschnitt 5.12 (Seite 39)"
                    },
                    {
                        "name": "Spuren verfolgen I",
                        "level": 3,
                        "value": "Der Zauberer erhält einen besonderen Bonus von +50 auf alle „Spuren verfolgen“- Manöver"
                    },
                    {
                        "name": "Geschichte des Pfades",
                        "level": 4,
                        "value": "Der Zauberer gewinnt eine bildhafte Vorstellung all derer, die einen bestimmten Pfad innerhalb der letzten Stunde(n)/Stufe benutzt haben"
                    },
                    {
                        "name": "Pfadmeister I",
                        "level": 5,
                        "value": "Der Zauberer erfährt die Lage aller Pfade in 2km-Umkreis. Der Zauber liefert den nächsten Punkt des Pfades, nicht aber dessen Verlauf"
                    },
                    {
                        "name": "Spurenkunde",
                        "level": 6,
                        "value": "Der Zauberer erfährt, wo eine untersuchte Spur/Fährte beginnt und gewinnt eine bildhafte Vorstellung von dem, der sie hinterließ. Der Spruch liefert einen Bonus von +25 auf spätere Versuche, den Spuren dieses Wesens zu folgen"
                    },
                    {
                        "name": "Hinterhalt erkennen I",
                        "level": 7,
                        "value": "Der Zauberer ist sich aller Wesen im Wirkungsbereich bewußt, die feindliche Absichten gegen ihn hegen. Die Feindseligkeit muß sich ausdrücklich gegen ihn richten und aktiv sein (d.h. das Wesen beabsichtigt aggressive Handlungen auszuführen) und nicht nur passiv (keine Handlung ist geplant)"
                    },
                    {
                        "name": "Wesen der Wanderer",
                        "level": 8,
                        "value": "Der Zauberer erhält einen optischen und akustischen Eindruck aller Wesen, die sich seit bis zu 1 Stunde/Stufe in höchstens 15m Abstand an einem bestimmten Objekt vorbeibewegt haben. Wenn mehr als ein Wesen an dem Objekt vorbeikam, erhält der Zauberer ein Bild pro Runde, beginnend mit dem ältesten"
                    },
                    {
                        "name": "Pfadmeister V",
                        "level": 9,
                        "value": "Wie Pfadmeister I, nur ist die Reichweite 8km"
                    },
                    {
                        "name": "Tiersprache",
                        "level": 10,
                        "value": "Erlaubt es dem Zauberer, die Sprache einer Tierart zu verstehen und zu „sprechen“"
                    },
                    {
                        "name": "Spurenanalyse",
                        "level": 11,
                        "value": "Der Zauberer gewinnt eine bildhafte Vorstellung aller Wesen, die Spuren in diesem Gebiet hinterließen. Damit erhält er einen besonderen Bonus von +50, wenn er später die Spuren eines dieser Wesen verfolgen will. Wenn mehr als ein Wesen Spuren hinterließ, sieht der Zauberer ein Bild pro Runde, beginnend mit dem ältesten"
                    },
                    {
                        "name": "Pflanzensprache",
                        "level": 12,
                        "value": "Erlaubt es dem Zauberer, die Sprache einer Pflanzenart zu verstehen und zu „sprechen“"
                    },
                    {
                        "name": "Pfadmeister XX",
                        "level": 13,
                        "value": "Wie Pfadneister I, bis auf die Reichweite"
                    },
                    {
                        "name": "Hinterhalt erkennen II",
                        "level": 14,
                        "value": "Wie Hinterhalt erkennen I, nur ist der Wirkungsbereich ein 30m- Radius"
                    },
                    {
                        "name": "Steinsprache",
                        "level": 15,
                        "value": "Der Zauberer kann mit einem beliebigen Stein kommunizieren, sofern dieser auf irgendeine Weise belebt ist (z.B. könnte der Zauberer mit einem heiligen Stein sprechen, dem Intelligenz zu eigen ist)"
                    },
                    {
                        "name": "Spuren verfolgen II",
                        "level": 16,
                        "value": "Wie Spuren verfolgen I, nur ist der Bonus +75"
                    },
                    {
                        "name": "Hinterhalt erkennen III",
                        "level": 17,
                        "value": "Wie Hinterhalt erkennen I, nur ist der Wirkungsbereich ein 50m-Radius"
                    },
                    {
                        "name": "Wahrhaftige Pfade",
                        "level": 19,
                        "value": "Wie Pfadmeister I, nur hat der Spruch eine Reichweite von 1,5km pro Stufe, und der Zauberer kann auch deren Verlauf innerhalb der Reichweite feststellen"
                    },
                    {
                        "name": "Wahrhaftiges Hinterhalterkennen",
                        "level": 20,
                        "value": "Wie Hinterhalt erkennen I, nur ist der Wirkungsbereich ein Radius von 3m pro Stufe"
                    },
                    {
                        "name": "Pfad kennen",
                        "level": 25,
                        "value": "Erlaubt dem Zauberer, den richtigen Pfad zu seinem gewählten Bestimmungsort zu bestimmen (und auch den Verlauf dieses Pfads). Beispielsweise weiß er immer den besten Weg nach Angor"
                    },
                    {
                        "name": "Wahrhaftiges Spurenverfolgen",
                        "level": 30,
                        "value": "Wie Spuren verfolgen I, nur hebt dieser Spruch alle Fährte verbergen/Spuren verwischen-Sprüche auf (außer Wahrhaftiges Spurenverwischen/Fährteverbergen) und gewährt dem Spurenleser einen Bonus von +100 auf Spuren verfolgen"
                    },
                    {
                        "name": "Spuren voraus",
                        "level": 50,
                        "value": "Läßt den Zauberer den genauen Verlauf der Spuren im Wirkungsbereich erkennen (d.h. genau wo und wie sie verlaufen). Dieser Spruch hebt Wahrhaftiges Spurenverwischen/ Fährteverbergen nicht auf."
                    }
                ]
            },
            {
                "id": "5.2",
                "name": "8.6.3: Täuschungen der Natur",
                "spells": [
                    {
                        "name": "Chamäleon",
                        "level": 1,
                        "value": "Gestattet dem Zauberer, die Farbe eines bestimmten organischen Gegenstandes anzunehmen, wenn er Kontakt mit ihm hat. In vielen Situationen liefert dies einen Bonus von +10 bis +50 (SLEntscheidung) auf Verstecken (und möglicherweise auf Schleichen)"
                    },
                    {
                        "name": "Schattierung",
                        "level": 2,
                        "value": "Alle Schatten im Wirkungsbereich vertiefen sich. Dies hat einen Bonus von +25 auf Verstecken (und +10 auf Schleichen) zur Folge"
                    },
                    {
                        "name": "Flüssigkeit einfrieren",
                        "level": 3,
                        "value": "Bis zu 30l Flüssigkeit pro Stufe können mit einer Geschwindigkeit von 30l pro Runde eingefroren werden. Eine Abkühlung unter -30°C ist dabei nicht möglich. Flüssigkeiten, deren Gefrierpunkt unter -30°C liegt, werden nur abgekühlt. Dies funktioniert grundsätzlich nur bei leblosen Flüssigkeiten (also kein Blut im lebenden Körper)"
                    },
                    {
                        "name": "Lautlose Bewegung",
                        "level": 4,
                        "value": "Der Zauberer kann sich lautlos bewegen, solange er kein Geräusch in einer Entfernung von mehr als 30cm von seinem Körper erzeugt. In vielen Situationen liefert dies einen Bonus von +10 bis +50 (SL-Entscheidung) auf Schleichen und/oder Verstecken"
                    },
                    {
                        "name": "Verhüllen",
                        "level": 5,
                        "value": "Der Zauberer geht in der Umgebung auf. Dies liefert einen Bonus von +75 auf Verstecken. Der Zauberer darf sich allerdings nicht bewegen (wahrnehmbar), ansonsten verliert er diesen Bonus"
                    },
                    {
                        "name": "Licht",
                        "level": 6,
                        "value": "Beleuchtet einen 3m-Radius um den berührten Punkt"
                    },
                    {
                        "name": "Dunkelheit I",
                        "level": 7,
                        "value": "Taucht ein Gebiet von 3m-Radius um den berührten Punkt in natürliche Dunkelheit. Vgl. Abschnitt 5.12 (Seite 39)"
                    },
                    {
                        "name": "Schatten",
                        "level": 8,
                        "value": "Der Zauberer und die Objekte an seiner Person erscheinen nur noch als Schatten und sind dadurch in Dunkelheit nahezu unsichtbar. In vielen Situationen sollte dies einen Bonus von +25 bis +75 (SL-Entscheidung) auf Schleichen und/oder Verstecken ergeben"
                    },
                    {
                        "name": "Form einprägen",
                        "level": 9,
                        "value": "Der Zauberer studiert die Form einer Tieroder Pflanzenart und prägt sie sich ein, um sie mit späteren Sprüchen dieser Liste zu verwenden. Der Zauberer kann nur so viele Formen eingeprägt haben, wie er Stufen hat"
                    },
                    {
                        "name": "Pflanzenfassade",
                        "level": 10,
                        "value": "Der Zauberer erscheint als eine Pflanzenart, die er mit Form einprägen zuvor studiert hat. Seine Größe bleibt unverändert, und er riecht nicht nach der Pflanze und fühlt sich auch nicht so an (dies ist also eine rein visuelle Illusion und unterliegt den normalen Illusionsregeln, vgl. Abschnitt 5.14, Seite 40)"
                    },
                    {
                        "name": "Tiergedanken",
                        "level": 11,
                        "value": "Für die Wirkungsdauer dieses Spruchs wirken die Gedankenmuster des Zauberers wie die eines beliebigen Tieres, das er studiert hat. Der Zauberer kann sich nicht bewegen, solange dieser Spruch aktiv ist"
                    },
                    {
                        "name": "Wahrhaftiges Formstudium",
                        "level": 12,
                        "value": "Wie Form einprägen, nur kann der Zauberer ein bestimmtes Tier oder eine bestimmte Pflanze studieren. Zum Beispiel könnte er sich den Hund des Holzfällers einprägen (und nicht nur generell einen Hund)"
                    },
                    {
                        "name": "Tierfassade",
                        "level": 13,
                        "value": "Erlaubt dem Zauberer, als ein beliebiges Tier zu erscheinen, das er studiert hat. Der Zauberer behält seine Größe bei und riecht weder wie das Tier noch fühlt er sich so an (dies ist also eine rein visuelle Illusion und unterliegt den normalen Illusionsregeln"
                    },
                    {
                        "name": "Wahrhaftige Tiergedanken",
                        "level": 15,
                        "value": "Wie Tiergedanken, nur kann sich der Zauberer bewegen, auch wenn er sich weiter konzentrieren muß"
                    },
                    {
                        "name": "Pflanzenform I",
                        "level": 16,
                        "value": "Erlaubt dem Zauberer, die Form einer beliebigen Pflanze anzunehmen, die er vorher studiert hat. Er sieht wie die Pflanze aus, fühlt sich auch wie sie an, und er kann seine Größe zwischen 75% und 200% seiner Normalgröße verändern, aber er erlangt keine körperlichen Fähigkeiten der Pflanze. In Abschnitt 5.20 (Seite 42) finden Sie mehr über Gestaltwandel"
                    },
                    {
                        "name": "Tierform I",
                        "level": 18,
                        "value": "Erlaubt dem Zauberer, die Form eines beliebigen Tieres anzunehmen, das er vorher studiert hat. Er sieht wie das Tier aus, fühlt sich auch wie es an und er kann seine Größe zwischen 75% und 200% seiner Normalgröße verändern, aber er erlangt keine körperlichen Fähigkeiten des Tieres. In Abschnitt 5.20 (Seite 42) finden Sie mehr über Gestaltwandel"
                    },
                    {
                        "name": "Pflanzenform II",
                        "level": 20,
                        "value": "Wie Pflanzenform I, nur nimmt der Zauberer auch den Geruch und die körperlichen Fähigkeiten der Pflanze an. Der Zauberer kann seine Größe auf 50-400% seiner Normalgröße verändern"
                    },
                    {
                        "name": "Tierform II",
                        "level": 25,
                        "value": "Wie Tierform I, nur erlangt der Zauberer auch den Geruch und die körperlichen Fähigkeiten des Tieres und er kann seine Größe von 50% bis 400% seiner Normalgröße verändern"
                    },
                    {
                        "name": "Wahrhaftige Pflanzenform",
                        "level": 30,
                        "value": "Wie Pflanzenform II, nur kann der Zauberer innerhalb der Spruchdauer die Form jeder Pflanze annehmen, die er jemals studiert hat"
                    },
                    {
                        "name": "Wahrhaftige Tierform",
                        "level": 50,
                        "value": "Wie Tierform II, nur kann der Zauberer innerhalb der Spruchdauer die Form jedes Tieres, das er jemals studiert hat annehmen."
                    }
                ]
            },
            {
                "id": "5.3",
                "name": "8.6.4: Wege der Natur",
                "spells": [
                    {
                        "name": "Falle entdecken",
                        "level": 1,
                        "value": "Der Zauberer hat eine 75%- Chance, eine Falle im Wirkungsbereich zu entdecken. Er kann sich jede Runde auf einen anderen Bereich konzentrieren. Damit dieser Spruch wirkt, müssen sich lebende Pflanzen oder Tiere im Wirkungsbereich befinden"
                    },
                    {
                        "name": "Wasser finden I",
                        "level": 2,
                        "value": "Der Zauberer erfährt den Ort der nächsten natürlichen Frischwasserquelle, zu Tage tretendes Grundwasser (mehr als 4 Liter) usw. Er erfährt auch die ungefähre Menge und Qualität dieses Wassers"
                    },
                    {
                        "name": "Entzünden",
                        "level": 3,
                        "value": "Entfacht ein Feuer mit einem Radius von 30cm, das brennt, solange es Nahrung findet. Ziele im Wirkungsbereich (30cm-Radius) erleiden einen kritischen Hitzeschaden der Intensität A"
                    },
                    {
                        "name": "Nahrung finden I",
                        "level": 5,
                        "value": "Der Zauberer erfährt den Ort, die Art und ungefähre Menge genießbarer Nahrung (z.B. tote Tiere, Pflanzen usw.). Es muß mindestens ein halbes Kilo Nahrung vorhanden sein"
                    },
                    {
                        "name": "Wasser reinigen I",
                        "level": 6,
                        "value": "Erlaubt es dem Zauberer, 5 Liter Wasser pro Stufe zu reinigen"
                    },
                    {
                        "name": "Unterschlupf finden I",
                        "level": 7,
                        "value": "Der Zauberer erfährt Standort, Art und ungefähre Größe aller wasserdichten, überdachten Räume von mehr als 3m³ Platz mit einem Zugang von außen, der mindestens 60cm durchmißt"
                    },
                    {
                        "name": "Geringere Fallen",
                        "level": 8,
                        "value": "Dieser Spruch erzeugt eine kleine, normale Falle (magisch erschaffen), die Schaden bis zu einem kritischen Treffer der Stufe B anrichtet (der Zauberer muß beim Wirken festlegen, ob es Schnitt-, Stich- oder Schlagschaden sein soll). Die Falle kann einen Durchmesser von 1 bis 3 Meter haben. Es dauert 3 Runden pro Meter Durchmesser, bis die Falle steht"
                    },
                    {
                        "name": "Wettervorhersage I",
                        "level": 9,
                        "value": "Der Zauberer hat ein 95%-Chance, die Zeit, die Art und die Schwere des kommenden Wetters in den nächsten 24 Stunden zu erkennen"
                    },
                    {
                        "name": "Naturwahrnehmung I",
                        "level": 10,
                        "value": "Gestattet dem Zauberer, alle bewegten Aktivitäten in dem Wirkungsbereich zu überwachen (d.h. er ist sich jeder Bewegung bewußt, auch kleinen). Während der Konzentration kann sich der Zauberer nicht bewegen"
                    },
                    {
                        "name": "Wasser finden II",
                        "level": 11,
                        "value": "Wie Wasser finden I, nur hat der Spruch eine Reichweite von 15km"
                    },
                    {
                        "name": "Wartende Wahrnehmung I",
                        "level": 12,
                        "value": "Erlaubt dem Zauberer, eine natürliche „Alarmanlage“ im Wirkungsbereich einzurichten. Der Zauberer wird auf jede störende Aktivität dort aufmerksam gemacht"
                    },
                    {
                        "name": "Nahrung finden II",
                        "level": 13,
                        "value": "Wie Nahrung finden I, nur ist die Reichweite 15km"
                    },
                    {
                        "name": "Stärkere Fallen",
                        "level": 14,
                        "value": "Wie Geringere Fallen, nur kann die Falle Schaden bis zu kritischen Treffern der Intensität E zufügen"
                    },
                    {
                        "name": "Unterschlupf finden II",
                        "level": 15,
                        "value": "Wie Unterschlupf finden I, nur ist die Reichweite 15km"
                    },
                    {
                        "name": "Naturwahrnehmung III",
                        "level": 16,
                        "value": "Wie Naturwahrnehmung I, bis auf den Wirkungsbereich"
                    },
                    {
                        "name": "Wahrhaftiges Wasserfinden",
                        "level": 17,
                        "value": "Findet die nächstgelegene Frischwasserquelle (wie sie in Wasser finden I definiert wurde). Dieser Spruch liefert nur die Richtung und die Entfernung und gibt keinen Aufschluß über die Menge oder Qualität des Wassers"
                    },
                    {
                        "name": "Wahrhaftiges Nahrungfinden",
                        "level": 18,
                        "value": "Findet die nächstgelegene Nahrungsquelle (wie sie in Nahrung finden I definiert wurde). Dieser Spruch liefert nur die Richtung und die Entfernung und gibt keinen Aufschluß darüber, wieviel Nahrung vorhanden ist oder welche Qualität sie hat"
                    },
                    {
                        "name": "Wahrhaftiger Unterschlupf",
                        "level": 19,
                        "value": "Findet den nächstgelegenen Unterschlupf (wie er in Unterschlupf finden I definiert wurde). Dieser Spruch liefert nur die Richtung und die Entfernung und nicht, wie groß der Unterschlupf ist oder wie er beschaffen ist"
                    },
                    {
                        "name": "Naturwahrnehmung V",
                        "level": 20,
                        "value": "Wie Naturwahrnehmung I, bis auf den Wirkungsbereich"
                    },
                    {
                        "name": "Wettervorhersage V",
                        "level": 25,
                        "value": "Wie Wettervorhersage I, nur kann der Zauberer das Wetter für 5 Tage voraussagen"
                    },
                    {
                        "name": "Wartende Wahrnehmung II",
                        "level": 30,
                        "value": "Wie Wartende Wahrnehmung I, nur ist der Radius 15m groß"
                    },
                    {
                        "name": "Wahrhaftige Naturwahrnehmung",
                        "level": 50,
                        "value": "Wie Naturwahrnehmung I, bis auf den Wirkungsbereich."
                    }
                ]
            },
            {
                "id": "5.4",
                "name": "8.6.5: Wege des Wanderns",
                "spells": [
                    {
                        "name": "Steinlauf",
                        "level": 1,
                        "value": "Der Zauberer kann über nahezu horizontale Stein- oder Erdflächen laufen, als bewege er sich auf ebener Erde. Er verbraucht Erschöpfungspunkte wie beim Gehen"
                    },
                    {
                        "name": "Astgang",
                        "level": 2,
                        "value": "Der Zauberer kann über Äste (durchaus hoch in Bäumen) gehen, als bewege er sich auf ebener Erde"
                    },
                    {
                        "name": "Schwimmen",
                        "level": 3,
                        "value": "Das Ziel kann schwimmen, ohne Energie zu verbrauchen (also ohne Erschöpfungspunkte zu verlieren)"
                    },
                    {
                        "name": "Wassergang",
                        "level": 4,
                        "value": "Der Zauberer kann über Wasser gehen, als bewege er sich auf ebener, trockener Erde. Dieser Spruch funktioniert nicht bei aufgewühltem Wasser"
                    },
                    {
                        "name": "Sandlauf",
                        "level": 5,
                        "value": "Der Zauberer kann über sandige Oberflächen laufen, als bewege er sich auf ebener Erde. Er verbraucht Erschöpfungspunkte wie beim Gehen"
                    },
                    {
                        "name": "Astlauf",
                        "level": 6,
                        "value": "Wie Astgang, aber der Zauberer kann sich mit doppelter Gehgeschwindigkeit bewegen (also Laufen). Er verbraucht Erschöpfungspunkte wie beim Gehen"
                    },
                    {
                        "name": "Spurlos fortbewegen",
                        "level": 7,
                        "value": "Der Zauberer kann gehen, ohne eine Fährte oder andere sichtbare Anzeichen seiner Anwesenheit zu hinterlassen"
                    },
                    {
                        "name": "Fährte verbergen I",
                        "level": 8,
                        "value": "Der Zauberer kann die Fährte eines bestimmten Lebewesens verbergen. Dieser Spruch kann mit Spurlos fortbewegen kombiniert werden, dann verbraucht der Zauberer trotzdem nur 50% seiner Aktivität (er kann sich also auf beide Sprüche zur selben Zeit konzentrieren)"
                    },
                    {
                        "name": "Wasserlauf",
                        "level": 9,
                        "value": "Wie Wassergang, aber der Zauberer kann sich mit doppelter Gehgeschwindigkeit bewegen (also Laufen). Er verbraucht Erschöpfungspunkte wie beim Gehen"
                    },
                    {
                        "name": "Fährte verbergen II",
                        "level": 10,
                        "value": "Wie Fährte verbergen I, aber es werden die Spuren von zwei Lebewesen verborgen"
                    },
                    {
                        "name": "Wahrhaftig Schwimmen",
                        "level": 11,
                        "value": "Wie Schwimmen, nur kann der Zauberer so schnell schwimmen wie er laufen würde. Er verbraucht dabei so viele Erschöpfungspunkte als würde er gehen"
                    },
                    {
                        "name": "Fährte verbergen V",
                        "level": 12,
                        "value": "Wie Fährte verbergen I, nur kann der Zauberer die Spuren von 5 Wesen verwischen"
                    },
                    {
                        "name": "Wahrhaftig Laufen",
                        "level": 13,
                        "value": "Wie jeder andere LaufSpruch oben, nur kann immer einer dieser Sprüche in einer Runde angewandt werden (d.h. der Zauberer könnte erst auf Sand laufen, dann auf Wasser, dann auf Ästen usw.)"
                    },
                    {
                        "name": "Wahrhaftig Spurlos Fortbewegen",
                        "level": 14,
                        "value": "Wie Spurlos fortbewegen, nur muß sich der Zauberer nicht konzentrieren"
                    },
                    {
                        "name": "Organisches Verschmelzen",
                        "level": 15,
                        "value": "Das Ziel kann mit totem oder lebendigem organischen Material verschmelzen. Während es so verschmolzen ist, kann es sich nicht bewegen und nimmt nichts wahr. Wenn es wieder hervorkommt, kann es das auf einer beliebigen Seite des Materials tun. Das Ziel kann sich nicht durch Material hindurchbewegen, das breiter ist als sein eigener Körper plus 60cm"
                    },
                    {
                        "name": "Fährte verbergen X",
                        "level": 16,
                        "value": "Wie Fährte verbergen I, nur kann der Zauberer die Spuren von 10 Wesen verwischen"
                    },
                    {
                        "name": "Spurlos laufen",
                        "level": 17,
                        "value": "Wie Spurlos fortbewegen, nur kann sich der Zauberer mit doppelter Geschwindigkeit fortbewegen (d.h. laufen)"
                    },
                    {
                        "name": "Fährte verbergen XV",
                        "level": 18,
                        "value": "Wie Fährte verbergen I, nur kann der Zauberer die Spuren von 15 Wesen verwischen"
                    },
                    {
                        "name": "Wahrhaftig Spurlos Laufen",
                        "level": 19,
                        "value": "Wie Wahrhaftig Spurlos Fortbewegen, nur kann sich der Zauberer mit doppelter Geschwindigkeit fortbewegen (d.h. laufen)"
                    },
                    {
                        "name": "Vollendetes organisches Verschmelzen",
                        "level": 20,
                        "value": "Wie Verschmelzen mit Organischem, nur kann sich das Ziel in dem Material umdrehen und die Welt draußen wahrnehmen"
                    },
                    {
                        "name": "Fährte verbergen XX",
                        "level": 25,
                        "value": "Wie Fährte verbergen I, nur kann der Zauberer die Spuren von 20 Wesen verwischen"
                    },
                    {
                        "name": "Wahrhaftiges Organisches Verschmelzen",
                        "level": 30,
                        "value": "Wie Vollendetes Organisches Verschmelzen, nur kann das Ziel Sprüche wirken, während es verschmolzen ist"
                    },
                    {
                        "name": "Wahrhaftiges Fährtenverbergen",
                        "level": 50,
                        "value": "Wie Fährte verbergen I, nur kann der Zauberer entweder seine eigenen Spuren völlig verwischen oder er kann die Spuren einer Anzahl von Wesen verwischen, die seiner Stufe entspricht. Besondere Anmerkungen In Abschnitt 5.6 (Seite 37) finden Sie Näheres zu Belastungsgrenzen für Bewegungssprüche."
                    }
                ]
            },
            {
                "id": "5.5",
                "name": "8.6.6: Widerstandskraft",
                "spells": [
                    {
                        "name": "Widerstand gegen Hitze",
                        "level": 1,
                        "value": "Das Ziel ist vor natürlicher Hitze bis zu 75°C geschützt (als ob es 21°C wäre). Bei Temperaturen über 75°C ziehen Sie 50°C ab, um die effektive Temperatur für das Ziel zu bestimmen. Das Ziel erhält +20 auf alle WW gegen Hitzesprüche und Hitzeangriffe (+20 DB gegen elementare Feuerund Hitzeangriffe). Wenn sich das Ziel mehr als 3 Meter vom Zauberer entfernt, ist der Spruch aufgehoben"
                    },
                    {
                        "name": "Widerstand gegen Kälte",
                        "level": 2,
                        "value": "Das Ziel ist vor natürlicher Kälte bis herab zu -10°C geschützt (als ob es 21°C wäre). Bei Temperaturen unter -10°C addieren Sie 30°C, um die effektive Temperatur für das Ziel zu bestimmen. Das Ziel erhält +20 auf alle WW gegen Kältesprüche und Kälteangriffe (+20 DB gegen elementare Kälte- und Eisangriffe). Wenn sich das Ziel mehr als 3 Meter vom Zauberer entfernt, ist der Spruch aufgehoben"
                    },
                    {
                        "name": "Widerstand I",
                        "level": 3,
                        "value": "Der Zauberer erhält einen besonderen Bonus von +5 auf WW und DB"
                    },
                    {
                        "name": "Segen I",
                        "level": 4,
                        "value": "Der Zauberer erhält einen besonderen Bonus von +5 auf Manöverwürfe und DB"
                    },
                    {
                        "name": "Gebet I",
                        "level": 5,
                        "value": "Der Zauberer erhält einen besonderen Bonus von +5 auf WW und Manöverwürfe"
                    },
                    {
                        "name": "Reinigung",
                        "level": 7,
                        "value": "Sterilisiert 3 Liter (3 dm³) eines beliebigen festen oder flüssigen Materials pro Stufe. Dieser Zauber hat keine Wirkung auf inaktive Giftstoffe und fügt Wesen von mehr als 5mm Länge einen Schaden zu"
                    },
                    {
                        "name": "Widerstand II",
                        "level": 8,
                        "value": "Wie Widerstand I, aber der Bonus ist +10"
                    },
                    {
                        "name": "Segen II",
                        "level": 9,
                        "value": "Wie Segen I, aber der Bonus ist +10"
                    },
                    {
                        "name": "Gebet II",
                        "level": 10,
                        "value": "Wie Gebet I, aber der Bonus ist +10"
                    },
                    {
                        "name": "Schutz vor Elementen",
                        "level": 11,
                        "value": "Der Zauberer ist vor jeder natürlichen Hitze oder Kälte geschützt (so als läge die Temperatur um ihn bei 21°C). Außerdem erhält er einen Bonus von +40 auf alle Widerstandswürfe gegen Feuer-/Eissprüche und Hitze-/Kälteangriffe (+40 DB gegen Elementare Angriffe). Die Wirkungsdauer des Spruchs beträgt 10 Minuten pro Stufe, wenn der Zauberer sich nicht bewegt. Wenn er sich bewegt, hält der Spruch nur an, solange er sich konzentriert"
                    },
                    {
                        "name": "Widerstand III",
                        "level": 13,
                        "value": "Wie Widerstand I, nur ist der Bonus +15"
                    },
                    {
                        "name": "Segen III",
                        "level": 14,
                        "value": "Wie Segen I, nur ist der Bonus +15"
                    },
                    {
                        "name": "Gebet III",
                        "level": 15,
                        "value": "Wie Gebet I, nur ist der Bonus +15"
                    },
                    {
                        "name": "Widerstand IV",
                        "level": 17,
                        "value": "Wie Widerstand I, nur ist der Bonus +20"
                    },
                    {
                        "name": "Segen IV",
                        "level": 18,
                        "value": "Wie Segen I, nur ist der Bonus +20"
                    },
                    {
                        "name": "Gebet IV",
                        "level": 19,
                        "value": "Wie Gebet I, nur ist der Bonus +20"
                    },
                    {
                        "name": "Krankheit austreiben",
                        "level": 20,
                        "value": "Durch diesen Spruch kann das Ziel versuchen, eine beliebige Krankheit abzuschütteln. Dazu erhält es einen weiteren WW mit einem besonderen Bonus von +50. Pro Krankheit und Ziel kann dieser Spruch nur einmal gewirkt werden, bis der Zauberer eine neue Stufe erreicht (siehe Abschnitt 5.3, Seite 36)"
                    },
                    {
                        "name": "Fluch austreiben",
                        "level": 25,
                        "value": "Für den Fluch wird ein WW durchgeführt (die Stufe des Zauberers ist die Angriffsstufe, die ursprüngliche Angriffsstufe des Fluches ist nun die Zielstufe). Wenn dieser WW mißlingt, ist der Fluch gebannt. Pro Fluch und Ziel kann dieser Spruch nur einmal gewirkt werden, bis der Zauberer eine neue Stufe erreicht (siehe Abschnitt 5.3, Seite 36)"
                    },
                    {
                        "name": "Gift austreiben",
                        "level": 30,
                        "value": "Durch diesen Spruch kann das Ziel versuchen, die Wirkung eines beliebigen Gifts abzuschütteln. Dazu erhält es einen weiteren WW mit einem besonderen Bonus von +50. Pro Gift und Ziel kann dieser Spruch nur einmal gewirkt werden, bis der Zauberer eine neue Stufe erreicht (siehe Abschnitt 5.3, Seite 36)"
                    },
                    {
                        "name": "Widerstandskraft",
                        "level": 50,
                        "value": "Der Zauberer erhält einen besonderen Bonus von +25 auf seinen DB, seine Widerstands- und seine Manöverwürfe. Besondere Anmerkungen 1) Die Boni aus Segen, Gebet und Widerstand addieren sich nicht. 2) In Abschnitt 5.21 (Seite 42) finden Sie weitere Informationen zu Flüchen. 3) In Abschnitt 5.3 (Seite 36) finden Sie weitere Informationen zu wiederholten Versuchen beim Entfernen von Krankheiten, Giften und Flüchen."
                    }
                ]
            }
        ]
    },
    {
        "id": "6",
        "name": "Böse Leitmagie",
        "spellLists": [
            {
                "id": "6.0",
                "name": "8.7.1: Dunkles Wissen",
                "spells": [
                    {
                        "name": "Rückbesinnung",
                        "level": 1,
                        "value": "Gestattet dem Zauberer, sich wortwörtlich an Gespräche oder Schriftstücke zu erinnern, die er bis zu einem Tag pro Stufe vorher gehört oder gelesen hat"
                    },
                    {
                        "name": "Gutes entdecken",
                        "level": 2,
                        "value": "Entdeckt das „wahre Gute“ in einem belebten oder unbelebten Ziel. In jeder Runde kann sich der Zauberer auf einen anderen 2m-Radius konzentrieren"
                    },
                    {
                        "name": "Segen entdecken",
                        "level": 3,
                        "value": "Wie Gutes entdecken, nur entdeckt der Spruch einen Segen in einem belebten oder unbelebten Ziel"
                    },
                    {
                        "name": "Emotion entdecken",
                        "level": 4,
                        "value": "Der Spruch entdeckt extreme Emotionen im Geist eines lebendigen Ziels oder in einem Gegenstand, der im Zustand extremer Emotion geschaffen wurde. In jeder Runde kann sich der Zauberer auf einen anderen 2m-Radius konzentrieren"
                    },
                    {
                        "name": "Dunkles Wissen I",
                        "level": 5,
                        "value": "Der Zauberer kann den Herkunftsort und die Natur eines beliebigen Gegenstands des „Bösen“ oder der „Finsternis“ erfahren. Der Zauberer kann keine besonderen Eigenschaften herausfinden"
                    },
                    {
                        "name": "Heiliges entdecken",
                        "level": 6,
                        "value": "Wie Gutes entdecken, nur entdeckt der Spruch „heilige“ Gegenstände und der Wirkungsbereich ist ein 3m-Radius"
                    },
                    {
                        "name": "Traum I",
                        "level": 8,
                        "value": "Der Zauberer hat einen Traum über ein Thema, das er kurz bevor er einschläft festlegt"
                    },
                    {
                        "name": "Segensgeschichte",
                        "level": 10,
                        "value": "Der Zauberer erfährt den Urheber, den Ursprung und die gesamte Geschichte eines Segens. Er findet auch die Art des Segens und welche Macht er hat"
                    },
                    {
                        "name": "Dunkles Wissen II",
                        "level": 11,
                        "value": "Wie Dunkles Wissen I, nur kann der Zauberer den Herkunftsort und die Natur zweier beliebiger Gegenstände der Finsternis oder des Bösen herausfinden, oder er erfährt den Herkunftsort, die Natur und die genaue Bedeutung eines beliebigen Gegenstandes der Finsternis oder des Bösen"
                    },
                    {
                        "name": "Traum II",
                        "level": 12,
                        "value": "Wie Traum I, nur kann der Zauberer bis zu 2 Träume pro Nacht zu unterschiedlichen Themen haben"
                    },
                    {
                        "name": "Emotion analysieren",
                        "level": 13,
                        "value": "Der Zauberer kann den Ursprung und die Natur von aktiven, extremem Emotionen herausfinden, die er in einem beliebigen (belebten oder unbelebten) Ziel antrifft. Auch die Tiefe der Emotion und andere Einzelheiten über sie kann er erfahren"
                    },
                    {
                        "name": "Dunkles Wissen III",
                        "level": 14,
                        "value": "Wie Dunkles Wissen I, nur kann der Zauberer den Herkunftsort und die Natur dreier beliebiger Gegenstände der Finsternis oder des Bösen herausfinden, oder er erfährt das Alter, den Herkunftsort, die Natur, die genaue Bedeutung und den Namen des Schöpfers eines beliebigen Gegenstandes der Finsternis oder des Bösen. Er erfährt auch die besonderen Fähigkeiten des Gegenstandes"
                    },
                    {
                        "name": "Traum III",
                        "level": 15,
                        "value": "Wie Traum I, nur kann der Zauberer bis zu 3 Träume pro Nacht zu unterschiedlichen Themen haben"
                    },
                    {
                        "name": "Lichtes Wissen I",
                        "level": 16,
                        "value": "Wie Dunkles Wissen I, nur kann der Zauber den Herkunftsort und die Natur eines beliebigen Gegenstands des „Lichts“ oder des „Guten“ bestimmen"
                    },
                    {
                        "name": "Lichtes Wissen II",
                        "level": 19,
                        "value": "Wie Lichtes Wissen I, nur kann der Zauber den Herkunftsort und die Natur zweier beliebigen Gegenstände des „Lichts“ oder des „Guten“ bestimmen, oder er erfährt die Natur, den Herkunftsort und die genaue Bedeutung eines Gegenstandes des Lichts oder des Guten"
                    },
                    {
                        "name": "Schwarzes Wissen",
                        "level": 20,
                        "value": "Der Zauberer kann die genaue Natur, Herkunft, Bestimmung und Geschichte eines beliebigen Gegenstands des Bösen oder der Finsternis bestimmen. Der Spruch verschafft dem Zauberer einen bildlichen Eindruck aller Vorbesitzer des Gegenstandes"
                    },
                    {
                        "name": "Lichtes Wissen III",
                        "level": 25,
                        "value": "Wie Lichtes Wissen I, nur kann der Zauberer den Herkunftsort und die Natur dreier beliebiger Gegenstände des Guten oder des Lichts herausfinden, oder er erfährt das Alter, den Herkunftsort, die Natur, die genaue Bedeutung und den Namen des Schöpfers eines beliebigen Gegenstandes des Lichts oder des Guten. Er erfährt auch die besonderen Fähigkeiten des Gegenstandes"
                    },
                    {
                        "name": "Weißes Wissen",
                        "level": 30,
                        "value": "Wie Schwarzes Wissen, nur kann der Spruch nur auf Gegenstände des Guten oder des Lichts gewirkt werden"
                    },
                    {
                        "name": "Meisterschaft des Schwarzen Wissens",
                        "level": 50,
                        "value": "Wie Schwarzes Wissen, nur kann der Zauberer diese Informationen zu allen Gegenständen des Bösen und der Finsternis innerhalb von 30m erlangen."
                    }
                ]
            },
            {
                "id": "6.1",
                "name": "8.7.2: Finstere Kanäle",
                "spells": [
                    {
                        "name": "Finstere Benommenheit",
                        "level": 2,
                        "value": "[WW-Mod.: -10] Der Zauberer streckt seinen Arm mit geballter Faust in Richtung des Ziels aus und leitet rohe Kraft aus seiner Machtquelle (normalerweise eine Gottheit) auf das Ziel. Dieses ist dann benommen"
                    },
                    {
                        "name": "Kanalisieren I",
                        "level": 3,
                        "value": "Wenn dieser Spruch eingesetzt wird, wird der erststufige Spruch, den der Zauberer in der nächsten Runde zu wirken beginnt, magisch an einen anderen Leitmagiekundigen übertragen. Der kanalisierte Spruch erreicht sein Ziel, sobald er normalerweise wirksam würde, und muß von ihm sofort angewandt werden (das Ziel gilt dann als Wirker des Spruchs). Für den übermittelten Spruch gelten alle üblichen Einschränkungen. Der Absender muß das Ziel sehen können oder seinen Standort genau kennen (genaue Richtung und Entfernung oder genauer Aufenthaltsort). Der Empfänger muß exakt wissen, wann der Spruch ihn erreicht (er muß aber nicht wissen, welcher Spruch ankommt). Wartet z.B. ein Kleriker um Mitternacht an einem bestimmten Altar auf einen Spruch, kann ein anderer Zauberer, der das weiß, Kanalisieren verwenden, um ihm einen Spruch zu schicken"
                    },
                    {
                        "name": "Finsterer Schlaf",
                        "level": 5,
                        "value": "[WW-Mod.: -10] Der Zauberer streckt seinen Arm mit geballter Faust in Richtung des Ziels aus und leitet rohe Kraft aus seiner Machtquelle (normalerweise eine Gottheit) auf das Ziel, das daraufhin in einen tiefen, magischen Schlaf sinkt"
                    },
                    {
                        "name": "Kanalisieren III",
                        "level": 6,
                        "value": "Wie Kanalisieren I, nur kann ein Spruch bis zur 3. Stufe übermittelt werden"
                    },
                    {
                        "name": "Kanal öffnen I",
                        "level": 7,
                        "value": "Der Zauberer kann mit einem beliebigen Ziel Kontakt aufnehmen, mit dem er bekannt ist. Dieser Spruch liefert den genauen Aufenthaltsort des anderen (Richtung und Entfernung). Dieser Spruch wird häufig mit einem Kanalisieren-Spruch verbunden"
                    },
                    {
                        "name": "Finstere Blendung",
                        "level": 8,
                        "value": "[WW-Mod.: -10] Der Zauberer streckt seinen Arm mit geballter Faust in Richtung des Ziels aus und leitet rohe Kraft aus seiner Machtquelle (normalerweise eine Gottheit) auf das Ziel. Dieses ist dann blind"
                    },
                    {
                        "name": "Schwarze Leitmagie I",
                        "level": 10,
                        "value": "Der Zauberer kann einen Schwarze Leitmagie I-Spruch anwenden (siehe Abschnitt 5.23, Seite 43)"
                    },
                    {
                        "name": "Kanalisieren V",
                        "level": 11,
                        "value": "Wie Kanalisieren I, nur kann ein Spruch bis zur 5. Stufe übermittelt werden"
                    },
                    {
                        "name": "Absolution",
                        "level": 13,
                        "value": "[WW-Mod: -20] Die „Seele“ des Ziels wird aus dem Körper gerissen und geht für die Spruchdauer an den Ort, an den alle „Seelen“ gehen. Die Seele kann nur mittels Leben spenden frühzeitig zurückgeholt werden. Das Ziel ist bewußtlos, bis die Seele zu ihm zurückkehrt. Selbst unterbewußte Handlungen (z.B. wie alle Heilsprüche und unterbewußte Sprüche) erleiden einen Malus von -75, während die Seele fort ist"
                    },
                    {
                        "name": "Schwarze Leitmagie II",
                        "level": 15,
                        "value": "Wie Schwarze Leitmagie I, nur kann ein Schwarze Leitmagie II-Spruch gewirkt werden (siehe Abschnitt 5.23, Seite 43)"
                    },
                    {
                        "name": "Kanal öffnen II",
                        "level": 16,
                        "value": "Wie Kanal öffnen I, bis auf die Reichweite"
                    },
                    {
                        "name": "Kanalisieren VII",
                        "level": 17,
                        "value": "Wie Kanalisieren I, nur kann ein Spruch bis zur 5. Stufe übermittelt werden"
                    },
                    {
                        "name": "Kanalisieren X",
                        "level": 19,
                        "value": "Wie Kanalisieren I, nur kann ein Spruch bis zur 10. Stufe übermittelt werden"
                    },
                    {
                        "name": "Wahrhaftige Absolution",
                        "level": 20,
                        "value": "Wie Absolution, nur kann die „Seele“ überhaupt nur mittels Leben spenden zurückgeholt werden"
                    },
                    {
                        "name": "Schwarze Leitmagie III",
                        "level": 25,
                        "value": "Wie Schwarze Leitmagie I, nur kann ein Schwarze Leitmagie III-Spruch gewirkt werden (siehe Abschnitt 5.23, Seite 43)"
                    },
                    {
                        "name": "Finstere Absolution",
                        "level": 30,
                        "value": "Wie Wahrhaftige Absolution, nur wird die „Seele“ völlig vernichtet"
                    },
                    {
                        "name": "Unheiliges Tor",
                        "level": 50,
                        "value": "Öffnet einen direkten Kanal zur Gottheit des bösen Klerikers. Was dann geschieht, hängt von der Persönlichkeit, den Motiven und der Macht der Gottheit ab. Durch das Tor kann jeder Spruch übermittelt werden, den die Gottheit wirken kann."
                    }
                ]
            },
            {
                "id": "6.2",
                "name": "8.7.3: Flüche",
                "spells": [
                    {
                        "name": "Fluch entdecken",
                        "level": 1,
                        "value": "Stellt fest, ob ein Fluch auf einem Gegenstand oder einer Person liegt"
                    },
                    {
                        "name": "Nachtsichtfluch",
                        "level": 2,
                        "value": "Das Ziel kann nachts sehen als wäre es taghell, aber am Tag nur als wäre es finsterste Nacht"
                    },
                    {
                        "name": "Geschwürfluch",
                        "level": 4,
                        "value": "Das Ziel kann nur Brot und Milchprodukte essen. Alles andere verschlimmert das Geschwür (falls der WW mißlingt), und das Ziel ist 1-10 Stunden lang außer Gefecht gesetzt"
                    },
                    {
                        "name": "Dakes Fluch",
                        "level": 5,
                        "value": "Das Ziel kann sich selbst nicht schneller als mit Gehgeschwindigkeit fortbewegen (er kann schneller getragen werden oder schneller reiten)"
                    },
                    {
                        "name": "Grüne Zunge",
                        "level": 6,
                        "value": "Das Ziel kann nur grüne Blätter essen. Ißt es etwas anderes (und besteht seinen WW nicht), so ist es für 1-10 Stunden außer Gefecht gesetzt"
                    },
                    {
                        "name": "Fluch des Meeres",
                        "level": 7,
                        "value": "Das Ziel wird niemals freiwillig schwimmen, ins Wasser gehen (nicht einmal baden) oder ein Boot besteigen"
                    },
                    {
                        "name": "Furds Fluch",
                        "level": 8,
                        "value": "Alle Fehlschlags- und Patzerbereiche des Ziels (also die für Waffenangriffe, Sprüchewirken und Fertigkeiten) werden verdoppelt"
                    },
                    {
                        "name": "Exkommunikation",
                        "level": 9,
                        "value": "Das Ziel verliert alle Magiepunkte (MP) für Leitmagie. Er kann keine Leitmagiesprüche wirken (nicht einmal über Spruchvermehrer). Ein Dualmagiekundiger der Leitmagie (d.h. ein Hexenmeister oder Heiler) würde nur die Hälfte seiner MP verlieren. Ein Charakter, der unter diesem Fluch leidet, leidet durch diesen Magiepunktverlust nicht unter Erschöpfung"
                    },
                    {
                        "name": "Gelehrsamkeit Mins",
                        "level": 10,
                        "value": "Das Ziel kann nur seine Muttersprache lesen und schreiben"
                    },
                    {
                        "name": "Shar Bus Fluch",
                        "level": 11,
                        "value": "Das Ziel wird steril (unfruchtbar) und impotent"
                    },
                    {
                        "name": "Machtverlust",
                        "level": 12,
                        "value": "Das Ziel verliert alle 10 Minuten einen Magiepunkt. Magiepunkte können normal zurückerlangt werden (normalerweise durch Schlaf ), aber sobald sie wieder da sind, schwinden sie wieder"
                    },
                    {
                        "name": "Schönheit Arraers",
                        "level": 13,
                        "value": "Das Aussehen des Ziels wird auf das mögliche Maximum angehoben (und ein wenig darüber hinaus). Wer das unverhüllte Gesicht des Ziels sieht oder sich ihm auf 1m nähert (und die passende sexuelle Vorliebe hat und seinen WW nicht schafft), wird versuchen, von dem Ziel Besitz zu ergreifen und es davonzutragen (er oder sie wird auch kämpfen, wenn es nötig wird). Für bestimmte Personen wird der WW modifiziert (Eunuchen, Hedonisten, Nymphomanen, Senioren, Frigide, Mathematiker)"
                    },
                    {
                        "name": "Blutgerinnselfluch",
                        "level": 14,
                        "value": "Das Blut des Ziels dickt im Bereich eines Schnitts oder einer Wunde (der/die mindestens mit einem Treffer pro Runde blutet) ein und führt zu einem Blutgerinnsel. Das Gerinnsel stoppt die Blutzufuhr zu dem Bereich, der über die betroffene Ader versorgt wird, und nach 2-20 Minuten verliert das Ziel diesen Teil des Körpers durch den systemischen Schaden (d.h. eine Wunde am Oberschenkel könnte den Verlust eines Beins bedeuten, eine im Nacken wäre tödlich)"
                    },
                    {
                        "name": "Widerwärtigkeit Orns",
                        "level": 15,
                        "value": "Das Aussehen des Ziels sinkt auf 1. Wenn eine Person das unverhüllte Gesicht des Ziels sieht (oder ihm auf 1m nahe kommt), muß sie einen WW durchführen. Mißlingt der um 51 oder mehr, so greift sie das Ziel an. Selbst wenn dem Betrachter sein WW gelingt, empfindet er eine starke Abneigung (d.h. Verachtung) gegenüber dem Ziel. Wenn beispielsweise ein Ziel nach Hause kommt, nachdem es erfolgreich verflucht wurde, so könnte seine Mutter zwar widerstehen (sie bekommt einen riesigen Bonus auf den Wurf ), aber sie wird ihn vielleicht trotzdem nur in der Scheune schlafen lassen und ihm das Essen auf der Türschwelle servieren"
                    },
                    {
                        "name": "Olis Fluch",
                        "level": 16,
                        "value": "Das Ziel lügt 50% der Zeit, egal, was das Thema ist"
                    },
                    {
                        "name": "Penths Fluch",
                        "level": 18,
                        "value": "Das Ziel kann nur die Wahrheit sagen"
                    },
                    {
                        "name": "Aufbrechende Wunde",
                        "level": 19,
                        "value": "Einmal am Tag (zu einem zufälligen Zeitpunkt) schmerzt eine alte Wunde das Ziel. Bei neuen Charakteren handeln Sie dies in 50% der Fälle als einen Kritischen Schlagschaden der Intensität A ab und in den anderen 50% als 1W10 Treffer. Alternativ kann der SL auch eine bestimmte alte Wunde wieder aufbrechen lassen"
                    },
                    {
                        "name": "Tödliche Eile",
                        "level": 20,
                        "value": "Das Ziel bewegt sich so schnell es kann, bis es vor Erschöpfung stirbt. Es kann zurückgehalten werden, aber es läuft wieder los, sobald es freikommt"
                    },
                    {
                        "name": "Freundesmörder",
                        "level": 25,
                        "value": "Jedesmal, wenn das Ziel in einer Kampfsituation in der Nähe von Freunden ist und diese innerhalb von 3m um es sind, besteht eine Wahrscheinlichkeit von 10% (nicht kumulativ), daß es einen der Freunde angreift (zufällig bestimmt) und versucht, ihn umzubringen. Als Freund zählt in diesem Sinne jeder Gefährte oder Vertraute"
                    },
                    {
                        "name": "Wahrhaftige Exkommunikation",
                        "level": 30,
                        "value": "Wie Exkommunikation, nur bleibt die Wirkung bestehen, bis sie aufgehoben wird"
                    },
                    {
                        "name": "Finstere Gedanken",
                        "level": 50,
                        "value": "Das Ziel kann keine „böse“ Kreatur angreifen, es beherrscht alle böse Sprachen, und es gehorcht den Befehlen jeder beliebigen bösen Person, die ihm 10 Stufen oder mehr voraus ist."
                    }
                ]
            },
            {
                "id": "6.3",
                "name": "8.7.4: Krankheit",
                "spells": [
                    {
                        "name": "Erkältung",
                        "level": 1,
                        "value": "Das Ziel bekommt eine Erkältung. Bestimmen Sie mit einem W100, wie schwer sie ist (hoch ist schlecht für das Ziel)"
                    },
                    {
                        "name": "Grausicht",
                        "level": 2,
                        "value": "Das Ziel ist farbenblind. Handeln Sie das als einen Malus von -10 auf sämtliche Wahrnehmungswürfe ab, in denen der Seesinn eine Rolle spielt"
                    },
                    {
                        "name": "Geruchsinnsverlust",
                        "level": 3,
                        "value": "Das Ziel hat keinen Geruchssinn. Das Ziel kann nichts allein über den Geruchssinn wahrnehmen und es erleidet einen besonderen Malus von -25 auf alle Wahrnehmungsmanöver, in denen Riechen neben anderen Sinnen eine Rolle spielt (nur -3 auf Aufmerksamkeit)"
                    },
                    {
                        "name": "Gehörverlust",
                        "level": 4,
                        "value": "Das Ziel hat keinen Gehörsinn. Das Ziel kann nichts allein über das Gehör wahrnehmen und es erleidet einen besonderen Malus von -25 auf alle Wahrnehmungsmanöver, in denen Hören neben anderen Sinnen eine Rolle spielt (nur -3 auf Aufmerksamkeit)"
                    },
                    {
                        "name": "Zungenfäule",
                        "level": 5,
                        "value": "Im Laufe einer Woche verfault die Zunge des Ziels. Wenn die Zunge ganz weg ist, kann es nicht sprechen"
                    },
                    {
                        "name": "Asthma",
                        "level": 6,
                        "value": "Das Ziel bekommt starkes Asthma. Für jede Runde körperlicher Anstrengung (Nahkampf, Laufen, Bogenschießen, Rudern etc.) erleidet es einen Malus von -5 (kumulativ) auf alle Aktionen, bei denen es sich körperlich anstrengen muß. Wenn der Malus - 100 erreicht, wird das Ziel bewußtlos. Pro Malus von -5 braucht es 3 Runden zur Erholung"
                    },
                    {
                        "name": "Lepra",
                        "level": 7,
                        "value": "Das Ziel bekommt Lepra. Dadurch verliert es allmählich das Gefühl in den Extremitäten und die Blutzirkulation dort endet. An jedem Tag erleidet das Ziel einen (kumulativen) Malus von -1 auf alle Wahrnehmungsmanöver, in denen der Tastsinn eine Rolle spielt (maximal -25). Zudem sinkt sein Aussehen um -1 pro Tag (bis zu einem Minimum von 1). Nachdem es eine Woche an Lepra litt, wird aller Trefferschaden gegen das Ziel halbiert (damit wird der Verlust des Gefühls in bestimmten Körperteilen verdeutlicht)"
                    },
                    {
                        "name": "Leichte Allergie",
                        "level": 8,
                        "value": "Das Ziel wird gegen eine Substanz (nicht sich selbst) leicht allergisch. In ihrer Gegenwart ist das Ziel auf 80% der Aktionsfähigkeit beschränkt"
                    },
                    {
                        "name": "Wurzelfäule",
                        "level": 9,
                        "value": "Die Wurzeln einer beliebigen Pflanze verdorren und sterben, und es können keine neuen Wurzeln wachsen. Die Pflanze stirbt letztendlich"
                    },
                    {
                        "name": "Bluter",
                        "level": 10,
                        "value": "Das Ziel wird zum Bluter. Die Blutung aller Wunden (Treffer/Rnd) und Treffer werden verdoppelt. Alle kritischen Treffer gegen das Ziel fügen mit einer Wahrscheinlichkeit von 50% einen weiteren Treffer pro Runde zu. Für Heilung müssen die doppelten Kosten gezahlt werden"
                    },
                    {
                        "name": "Malaria",
                        "level": 11,
                        "value": "Das Ziel zieht sich Malaria zu. Nach dem ersten Anfall mit Fieber, Delirium, Koma und Handlungsunfähigkeit (die 2W10+1 Tage dauert), leidet das Ziel unter zufälligen „Rückfällen“, die dem ersten Anfall ähneln (Wahrscheinlichkeit von 5% pro Monat). Wenn das Ziel während des ersten Anfalls nicht in Behandlung ist, besteht eine Wahrscheinlichkeit von 99%, daß es stirbt (wenn es ordentlich gepflegt wird, sinkt diese Wahrscheinlichkeit auf 1%)"
                    },
                    {
                        "name": "Hand des Verdorrens",
                        "level": 12,
                        "value": "Der Zauberer kann eine beliebige Pflanze, die er berührt, sofort töten"
                    },
                    {
                        "name": "Epilepsie",
                        "level": 13,
                        "value": "Das Ziel wird zum Epileptiker. In einer Streßsituation besteht eine Wahrscheinlichkeit von 5%, daß es einen epileptischen Anfall hat. Wenn jemand das Ziel versorgt (d.h. es festhält und ihm einen passenden Gegenstand in den Mund legt), ist die Wahrscheinlichkeit nur 1%, daß es stirbt. Falls das nicht der Fall ist, liegt sie bei 5%"
                    },
                    {
                        "name": "Lungenentzündung",
                        "level": 14,
                        "value": "Das Ziel bekommt eine Lungenentzündung. Wenn es warm gehalten ist und 2 Wochen völlig bewegungslos bleibt, stirbt es nur mit einer Wahrscheinlichkeit von 25% (wird es nicht behandelt, liegt sie bei 50%). Die Wahrscheinlichkeit, daß das Ziel stirbt, sinkt um 5% für je 10 Punkte, die seine Konstitution höher als 50 ist (auf ein Minimum von 1%)"
                    },
                    {
                        "name": "Starke Allergie",
                        "level": 15,
                        "value": "Wie Leichte Allergie, nur ist das Ziel in jeder Runde auf 60% seiner Aktionsfähigkeit beschränkt"
                    },
                    {
                        "name": "Träger I",
                        "level": 16,
                        "value": "Das Ziel leider unter einer der Krankheiten dieser Liste (Stufe 5 oder niedriger), die der Zauberer bestimmt. Zusätzlich ist das Ziel ansteckend. Alle, die mit ihm in Kontakt kommen (2m-Radius) müssen einen WW ablegen (mit einem besonderen Modifikator von +25, wenn sie es berühren sinkt er auf +0, bei intimen Kontakt ist es ein Malus von -25). Wenn dem Träger der WW gelingt, leidet er selbst nicht unter den Symptomen, ist aber noch immer ein Krankheitsträger. Leute, die sich anstecken, sind selbst nicht ansteckend"
                    },
                    {
                        "name": "Elephantiasis",
                        "level": 17,
                        "value": "Das Ziel bekommt Elephantiasis. Eine seiner Gliedmaßen (nicht sein Kopf ) schwillt auf bis zu fünffache Größe an. Die genauen Auswirkungen legt der SL fest (aber die Gliedmaße sollte komplett nutzlos werden)"
                    },
                    {
                        "name": "Träger II",
                        "level": 19,
                        "value": "Wie Träger I, nur kann der Zauberer jede Krankheit dieser Liste auswählen (10. Stufe oder niedriger)"
                    },
                    {
                        "name": "Leukämie",
                        "level": 20,
                        "value": "Das Ziel bekommt Leukämie. Er wird täglich um 2% schwächer (-2/Tag auf alle Aktionen in jeder Runde, kumulativ). Wenn als Abzug 100% erreicht wird, ist das Ziel tot"
                    },
                    {
                        "name": "Träger III",
                        "level": 25,
                        "value": "Wie Träger I, nur kann der Zauberer jede Krankheit dieser Liste auswählen (15. Stufe oder niedriger)"
                    },
                    {
                        "name": "Tollwut",
                        "level": 30,
                        "value": "Das Ziel bekommt die Tollwut. Nach 21 Tagen ohne Symptome bricht die Krankheit aus. Die Organe des Ziels ziehen sich zusammen, es hat Schaum vorm Mund und wird sehr gewalttätig. Jeder, den das Ziel beißt oder kratzt, muß einen WW bestehen, sonst steckt er sich an. Das Ziel stirbt 5-7 Tage, nachdem die Krankheit ausbrach"
                    },
                    {
                        "name": "Seuche",
                        "level": 50,
                        "value": "Das Ziel erkrankt an einer Seuche. Wenn sein WW mißlingt, stirbt es in 95% der Fälle (innerhalb von 10 Minuten). In den übrigen 5% glaubt es, daß es der Seuche widerstand (und es leidet unter keinerlei Symptomen), wird aber zu einem Träger. Jeder, der sich dem Träger auf 2m nähert muß einen WW bestehen (+25 WW"
                    }
                ]
            },
            {
                "id": "6.4",
                "name": "8.7.5: Nekromantie",
                "spells": [
                    {
                        "name": "Tote beleben I",
                        "level": 1,
                        "value": "Der Zauberer kann bewirken, daß eine beliebige Leiche (mit +/-50% seiner eigenen Masse) aufsteht und sich bewegt. Der Zauberer muß sich konzentrieren, damit die Leiche Aktionen ausführt. Wenn er aufhört, sich zu konzentrieren, bleibt die Leiche bewegungslos stehen. Die Leiche kann Manöver mit einem Malus von -25 ausführen und mit einem OB von -20 im Nahkampf angreifen. Die Leiche kann nicht länger als einen Tag tot sein. Verwenden Sie die Daten für Untote aus Kreaturen & Monster, nur hat der Untote eine Bewegungsrate von 25 und einen OB von -20"
                    },
                    {
                        "name": "Untote kontrollieren I",
                        "level": 2,
                        "value": "Der Zauberer kann einen Untoten der Klasse I kontrollieren. Wenn dieser Spruch gewirkt wird, besteht eine Wahrscheinlichkeit von 2% pro Klasse des Untoten, daß er widersteht"
                    },
                    {
                        "name": "Untoten beherrschen",
                        "level": 3,
                        "value": "[WW Mod.: -25] Der Zauber kann 1 Stufe an Untoten pro Erfahrungsstufe beherrschen. Dieser Spruch muß auf jeden Untoten einzeln gewirkt werden. Ein beherrschter Untoter kann kontrolliert werden, ohne daß der Zauberer sich darauf konzentrieren muß. Wenn der Untote irgendwann mehr als 3m pro Stufe vom Zauberer entfernt ist, ist der Spruch gebannt. Wenn dieser Spruch gewirkt wird, besteht eine Wahrscheinlichkeit von 5% pro Klasse des Untoten, daß er dem Spruch widersteht"
                    },
                    {
                        "name": "Tote beleben II",
                        "level": 4,
                        "value": "Wie Tote beleben I, nur kann der Zauberer 2 Leichen kontrollieren (mit den o.g. Einschränkungen) oder eine Leiche mit einem Malus von -15 auf Manöver und einem OB von -10"
                    },
                    {
                        "name": "Untote erschaffen I",
                        "level": 5,
                        "value": "Wenn er eine Leiche zu Verfügung hat, die weniger als eine Woche tot ist, kann der Zauberer sie in einen Untoten der Klasse I verwandeln. Der Untote greift das Lebwesen an, das ihm am nächsten ist (wenn er nicht kontrolliert wird), aber er kann keine anderen Aktionen ausführen, als sich zu dem anderen Wesen hinzubewegen und es anzugreifen. Wenn er kontrolliert wird, kann er alles tun (sofern es seine Fähigkeiten erlauben), was der Zauberer ihm befielt. Untote können gebannt oder vertrieben werden, oder man hackt sie schlichtweg in kleine, handliche Stücke"
                    },
                    {
                        "name": "Untote kontrollieren II",
                        "level": 6,
                        "value": "Wie Untote kontrollieren I, nur kann ein Untoter der Klasse II kontrolliert werden oder 2 Untote der Klasse I"
                    },
                    {
                        "name": "Tote beleben III",
                        "level": 7,
                        "value": "Wie Tote beleben I, nur kann der Zauberer 3 Leichen kontrollieren oder eine Leiche mit einem Malus von -5 auf Manöver und einem Nahkampf-OB von +0"
                    },
                    {
                        "name": "Untote erschaffen II",
                        "level": 8,
                        "value": "Wie Untote erschaffen I, nur kann ein Untoter der Klasse II erschaffen werden oder zwei der Klasse I"
                    },
                    {
                        "name": "Untote kontrollieren III",
                        "level": 9,
                        "value": "Wie Untote kontrollieren I , nur kann ein Untoter der Klasse III kontrolliert werden oder drei der Klasse I oder einer der Klasse I und einer der Klasse II"
                    },
                    {
                        "name": "Tote beleben IV",
                        "level": 10,
                        "value": "Wie Tote beleben I, nur kann der Zauberer vier Leichen mit den Grundabzügen kontrollieren oder eine Leiche mit einem Bonus von +5 auf Manöver und einem Nahkampf-OB von +10"
                    },
                    {
                        "name": "Untote erschaffen III",
                        "level": 11,
                        "value": "Wie Untote erschaffen I, nur kann ein Untoter der Klasse III erschaffen werden oder drei der Klasse I oder einer der Klasse II und einer der Klasse I"
                    },
                    {
                        "name": "Tote beleben V",
                        "level": 12,
                        "value": "Wie Tote beleben I, nur kann der Zauberer 5 Leichen mit den Grundabzügen kontrollieren oder eine Leiche mit einem Bonus von +10 (Manöver) und einem Nahkampf-OB von +20"
                    },
                    {
                        "name": "Untote kontrollieren IV",
                        "level": 13,
                        "value": "Wie Untote kontrollieren I , nur kann ein Untoter der Klasse IV kontrolliert werden oder 4 der Klasse I oder 2 Untote der Klasse II oder einer der Klasse I und einer der Klasse III oder zwei der Klasse I und einer der Klasse I"
                    },
                    {
                        "name": "Tote beleben VI",
                        "level": 14,
                        "value": "Wie Tote beleben I, nur kann der Zauberer 6 Leichen mit den Grundabzügen kontrollieren oder eine Leiche mit einem Bonus von +15 (Manöver) und einem Nahkampf-OB von +30"
                    },
                    {
                        "name": "Untote erschaffen IV",
                        "level": 15,
                        "value": "Wie Untote erschaffen I, nur kann ein Untoter der Klasse IV erschaffen werden oder 4 der Klasse I oder 2 der Klasse II oder einer der Klasse III und einer der Klasse I oder einer der Klasse II und 2 der Klasse I"
                    },
                    {
                        "name": "Untote befehligen",
                        "level": 17,
                        "value": "Jeder Untote, der gerade beherrscht wird (mit Untote beherrschen), folgt einfachen, leicht verständlichen Befehlen. Dieser Spruch hebt den Spruch Untote beherrschen auf. Wenn er alle Befehle befolgt hat (was er bis zu einem Tag pro Zaubererstufe versucht), wird er wieder zu einem normalen Untoten (d.h. er greift das Lebewesen an, das ihm am nächsten ist)"
                    },
                    {
                        "name": "Untote kontrollieren V",
                        "level": 19,
                        "value": "Wie Untote kontrollieren I, nur kann ein Untoter der Klasse V kontrolliert werden oder 5 der Klasse I usw"
                    },
                    {
                        "name": "Untote erschaffen V",
                        "level": 20,
                        "value": "Wie Untote erschaffen I, nur kann ein Untoter der Klasse V erschaffen werden oder 5 der Klasse I oder einer der Klasse IV und einer der Klasse I usw"
                    },
                    {
                        "name": "Wahrhaftige Untotenkontrolle",
                        "level": 25,
                        "value": "Wie Untote kontrollieren I, nur kann der Zauberer jeden beliebigen Untoten kontrollieren, oder er kontrolliert einen Untoten der Klasse V oder einer niedrigeren, ohne sich konzentrieren zu müssen, oder er kontrolliert alle Untoten der Klasse III oder einer niedrigeren innerhalb eines Radius von 30m. Wenn er nur einen einzigen Untoten kontrolliert, steigt die Spruchreichweite auf 90m an"
                    },
                    {
                        "name": "Ritual der Schwarzen Ewigkeit",
                        "level": 30,
                        "value": "Dieses Ritual gilt als finsterste Magie. Wenn ein Zauberer es durchführt, wird er zu einem Todesfürst, einem der bösesten Untoten. Während des Rituals werden die lebenswichtigen Organe des Zauberers in ein bereitstehendes Gefäß (ein Glas, eine Schachtel o.ä) übertragen. Wenn der Spruch erfolgreich ist (Mißerfolg führt zum Tod), wird der Zauberer allein von Magie aufrechterhalten und steht zwischen den Reichen des Lebens und des Todes. Er kann nur unwiderruflich vernichtet werden, wenn das Gefäß mit seinen Organen zerstört wird. In Kreaturen und Monster finden Sie typische Werte für einen Todesfürsten"
                    },
                    {
                        "name": "Wahrhaftige Untotenerschaffung",
                        "level": 50,
                        "value": "Wie Untote erschaffen I, nur kann der Zauberer jeden beliebigen Untoten erschaffen, den es in der verwendeten Spielwelt gibt (Ringgeister, Vampire usw.)."
                    }
                ]
            },
            {
                "id": "6.5",
                "name": "8.7.6: Verwunden",
                "spells": [
                    {
                        "name": "Verwunden I",
                        "level": 1,
                        "value": "Verursacht W10 Treffer Schaden"
                    },
                    {
                        "name": "Krampf",
                        "level": 2,
                        "value": "Läßt einen Muskel des Ziels krampfen. Das Ziel verliert pro 10 Fehlschlag je 10% seiner Aktionsfähigkeit"
                    },
                    {
                        "name": "Blutung I",
                        "level": 3,
                        "value": "Das Ziel blutet mit einem Treffer pro Runde"
                    },
                    {
                        "name": "Verwunden III",
                        "level": 4,
                        "value": "Wie Verwunden I, nur verursacht der Spruch 3W10 Treffer Schaden"
                    },
                    {
                        "name": "Sinnesorganschaden I",
                        "level": 5,
                        "value": "Eine äußeres Sinnesorgan (Auge, Nase, Ohr usw.) wird verletzt. Der Feind muß ohne das Organ auskommen, bis es geheilt wird. Zudem erleidet er pro 10 Fehlschlag einen Malus von -10 auf alle Aktionen, die das Organ zum Teil gebrauchen (und -100 auf die, die das Organ direkt brauchen)"
                    },
                    {
                        "name": "Bruch I",
                        "level": 6,
                        "value": "Eines der Gliedmaßen des Ziels erleidet einen einfachen Bruch"
                    },
                    {
                        "name": "Blutung III",
                        "level": 7,
                        "value": "Wie Blutung I, nur blutet das Ziel mit 3 Treffern pro Runde"
                    },
                    {
                        "name": "Verwunden V",
                        "level": 8,
                        "value": "Wie Verwunden I, nur verursacht der Spruch 5W10 Treffer Schaden"
                    },
                    {
                        "name": "Sinnesorganschaden II",
                        "level": 9,
                        "value": "Wie Sinnesorganschaden I, nur sind 2 Organe betroffen"
                    },
                    {
                        "name": "Lähmung",
                        "level": 10,
                        "value": "Der Bereich des Ziels, den der Zauberer berührt, ist gelähmt"
                    },
                    {
                        "name": "Verwunden VII",
                        "level": 11,
                        "value": "Wie Verwunden I, nur verursacht der Spruch 7W10 Treffer Schaden"
                    },
                    {
                        "name": "Seele verzehren I",
                        "level": 12,
                        "value": "Das Ziel verliert 1W10 Punkte Konstitution. Wenn seine Konstitution auf 0 oder niedriger sinkt, wird er zu einem erschaffenen Untoten der Klasse I"
                    },
                    {
                        "name": "Kraft abzapfen I",
                        "level": 13,
                        "value": "In jeder Runde, in der sich der Zauberer konzentriert (und sich nicht weiter als 1m von ihm entfernt), verliert das Ziel einen Treffer. Für jeden Punkt, den das Ziel verliert, erhält der Zauberer einen hinzu (bis zu seinem Treffermaximum)"
                    },
                    {
                        "name": "Blutung V",
                        "level": 14,
                        "value": "Wie Blutung I, nur blutet das Ziel mit 5 Treffern pro Runde"
                    },
                    {
                        "name": "Verwunden X",
                        "level": 15,
                        "value": "Wie Verwunden I, nur verursacht der Spruch 10W10 Treffer Schaden"
                    },
                    {
                        "name": "Kraft abzapfen II",
                        "level": 16,
                        "value": "Wie Kraft abzapfen I, nur zapft der Spruch 2 Treffer pro Runde ab"
                    },
                    {
                        "name": "Seele verzehren II",
                        "level": 18,
                        "value": "Wie Seele verzehren I, nur verliert das Ziel 2W10 Punkte Konstitution, und es wird zu einem erschaffenen Untoten der Klasse II, wenn seine Konstitution auf 0 (oder niedriger) sinkt"
                    },
                    {
                        "name": "Verwunden XV",
                        "level": 20,
                        "value": "Wie Verwunden I, nur verursacht der Spruch 15W10 Treffer Schaden"
                    },
                    {
                        "name": "Wahrhaftige Seelenverzehrung",
                        "level": 25,
                        "value": "Wie Seele verzehren I, nur verliert das Ziel einen Punkt Konstitution pro Stufe des Zauberers und es wird zu einem erschaffenen Untoten der Klasse III, wenn seine Konstitution auf 0 (oder niedriger) sinkt"
                    },
                    {
                        "name": "Wahrhaftige Blutung",
                        "level": 30,
                        "value": "Wie Blutung I, nur blutet das Ziel mit einem Treffer pro Runde für je 5 Stufen des Zauberers"
                    },
                    {
                        "name": "Wahrhaftiges Verwunden",
                        "level": 50,
                        "value": "Wie Verwunden I, nur verliert das Ziel alle seiner Trefferpunkte und steckt zusätzlich einen Treffer pro Stufe des Zauberers ein."
                    }
                ]
            }
        ]
    },
    {
        "id": "7",
        "name": "Offene Essenz",
        "spellLists": [
            {
                "id": "7.0",
                "name": "9.1.1: Elementare Schilde",
                "spells": [
                    {
                        "name": "Schutz vor Licht",
                        "level": 1,
                        "value": "Das Ziel ist vollkommen geschützt gegen natürliches Licht (inklusive Blendung, Sonnenbrand und temporärer Erblindung, aber nicht Blitze). Dies ergibt eine besondere Modifikation von +10 auf alle WW gegen Licht (Elektrizität) und +10 auf den DB des Ziels gegen elementare Elektrizitäts-Angriffe"
                    },
                    {
                        "name": "Schutz vor Hitze",
                        "level": 2,
                        "value": "Wie Schutz vor Licht, schützt aber gegen natürliche Hitze von bis zu 95°C, und die Modifikatoren gelten für Hitze"
                    },
                    {
                        "name": "Schutz vor Kälte",
                        "level": 3,
                        "value": "Wie Schutz vor Licht, schützt aber gegen natürliche Kälte von bis zu -30°C, und die Modifikatoren gelten für Kälte"
                    },
                    {
                        "name": "Schutzsphäre Licht",
                        "level": 4,
                        "value": "Wie Schutz vor Licht, aber mit Wirkung auf alle Lebewesen innerhalb eines Umkreises von 3 Metern um das Ziel"
                    },
                    {
                        "name": "Schutzsphäre Hitze",
                        "level": 5,
                        "value": "Wie Schutz vor Hitze, aber it Wirkung auf alle Lebewesen innerhalb eines Umkreises von 3 Metern um das Ziel"
                    },
                    {
                        "name": "Schutzsphäre Kälte",
                        "level": 6,
                        "value": "Wie Schutz vor Kälte, aber mit Wirkung auf alle Lebewesen innerhalb eines Umkreises von 3 Metern um das Ziel"
                    },
                    {
                        "name": "Lichtpanzer",
                        "level": 8,
                        "value": "Wie Schutz vor Licht, aber mit Schutz gegen jede Art von natürlichem Licht und Elektrizität. Die Modifikatoren sind +20 auf den WW und DB gegen Angriffe"
                    },
                    {
                        "name": "Hitzepanzer",
                        "level": 9,
                        "value": "Wie Lichtpanzer, aber mit Wirkung gegen Hitze"
                    },
                    {
                        "name": "Kältepanzer",
                        "level": 10,
                        "value": "Wie Lichtpanzer, aber mit Wirkung gegen Kälte"
                    },
                    {
                        "name": "Lichtpanzersphäre",
                        "level": 11,
                        "value": "Wie Lichtpanzer, aber die Wirkung erstreckt sich auf alle Wesen innerhalb eines Radius von 3m"
                    },
                    {
                        "name": "Hitzepanzersphäre",
                        "level": 12,
                        "value": "Wie Hitzepanzer, aber die Wirkung erstreckt sich auf alle Wesen innerhalb eines Radius von 3m"
                    },
                    {
                        "name": "Kältepanzersphäre",
                        "level": 13,
                        "value": "Wie Kältepanzer, aber die Wirkung erstreckt sich auf alle Wesen innerhalb eines Radius von 3m"
                    },
                    {
                        "name": "Blitzpanzer",
                        "level": 15,
                        "value": "Wir Lichtpanzer, aber der Spruch verringert auch den Trefferpunktschaden durch Elektrizität (durch Schockstrahlen und Blitzschläge) um die Hälfte und senkt die kritischen Treffer um eine Stufe herab (kritische Treffer der Intensität A werden vernachlässigt, aus B-Treffern werden A-Treffer, aus C-Treffern B-Treffer usw.)"
                    },
                    {
                        "name": "Feuerpanzer",
                        "level": 17,
                        "value": "Wie Hitzepanzer, nur sind Hitze- und Feuersprüche betroffen (d.h. Feuerstrahlen und Feuerbälle)"
                    },
                    {
                        "name": "Eispanzer",
                        "level": 19,
                        "value": "Wie Kältepanzer, nur sind Kälte- und Eissprüche betroffen (d.h. Eisstrahlen und Kältekugeln)"
                    },
                    {
                        "name": "Massen-Lichtpanzer",
                        "level": 20,
                        "value": "Wie Lichtpanzer, nur kann der Spruch die Stufe des Zauberers an Zielen betreffen"
                    },
                    {
                        "name": "Massen-Hitzepanzer",
                        "level": 25,
                        "value": "Wie Hitzepanzer, nur kann der Spruch die Stufe des Zauberers an Zielen betreffen"
                    },
                    {
                        "name": "Massen-Kältepanzer",
                        "level": 30,
                        "value": "Wie Kältepanzer, nur kann der Spruch die Stufe des Zauberers an Zielen betreffen"
                    },
                    {
                        "name": "Wahrhaftige Rüstung",
                        "level": 50,
                        "value": "Wie Blitzpanzer, Feuerpanzer und Eispanzer gleichzeitig."
                    }
                ]
            },
            {
                "id": "7.1",
                "name": "9.1.2: Hand der Essenz",
                "spells": [
                    {
                        "name": "Vibration I",
                        "level": 1,
                        "value": "Läßt ein Objekt von bis zu 500g Masse vibrieren"
                    },
                    {
                        "name": "Bleiben I",
                        "level": 2,
                        "value": "Übt einen Druck von 500g auf ein Wesen oder Objekt aus. Das Ziel kann auf diese Weise nicht bewegt werden, und der Druck wirkt nur in eine Richtung"
                    },
                    {
                        "name": "Telekinese I",
                        "level": 3,
                        "value": "Der Zauberer kann ein Objekt mit bis zu 500g Masse mit einer Geschwindigkeit von bis zu 30cm pro Sekunde (etwa 1 km/h) bewegen (ohne Beschleunigung). Endet die Konzentration des Zauberers vor dem Ende der Wirkungsdauer, so bleibt das Objekt in der Luft schweben, als stünde es unter einem entsprechenden Bleiben-Spruch"
                    },
                    {
                        "name": "Vibration II",
                        "level": 4,
                        "value": "Wie Vibration I, allerdings mit bis zu 2,5kg Masse"
                    },
                    {
                        "name": "Bleiben II",
                        "level": 5,
                        "value": "Wie Bleiben I, allerdings mit bis zu 2,5kg Masse"
                    },
                    {
                        "name": "Telekinese II",
                        "level": 6,
                        "value": "Wie Telekinese I, allerdings mit bis zu 2,5kg Masse"
                    },
                    {
                        "name": "Vibration III",
                        "level": 7,
                        "value": "Wie Vibration I, allerdings mit bis zu 10kg Masse"
                    },
                    {
                        "name": "Bleiben III",
                        "level": 8,
                        "value": "Wie Bleiben I, allerdings mit bis zu 10kg Masse"
                    },
                    {
                        "name": "Vibration IV",
                        "level": 9,
                        "value": "Wie Vibration I, allerdings mit bis zu 25kg Masse"
                    },
                    {
                        "name": "Zielen",
                        "level": 10,
                        "value": "Durch Konzentration auf den Geist des Schützen und auf den Flug eines Geschosses kann der Zauberer den Angriffswurf dieses Geschosses um +50 erhöhen. Der Zauberer muß sich konzentrieren, den Schützen berühren und das Geschoß während der gesamten Runde sehen, in der es abgefeuert wird"
                    },
                    {
                        "name": "Telekinese III",
                        "level": 11,
                        "value": "Wie Telekinese I, allerdings kann die Masse bis zu 10kg betragen 12. Bleiben IV"
                    },
                    {
                        "name": "Massen-Vibration I",
                        "level": 13,
                        "value": "Wie Vibration I, nur kann der Zauberer seine Stufe an Gegenständen (mit jeweils 2,5kg Gewicht) vibrieren lassen (sie müssen sich alle innerhalb des Sichtbereichs des Zauberers befinden)"
                    },
                    {
                        "name": "Telekinese IV",
                        "level": 14,
                        "value": "Wie Telekinese I, allerdings kann die Massen bis zu 25kg betragen"
                    },
                    {
                        "name": "Bleiben V",
                        "level": 15,
                        "value": "Wie Bleiben I, allerdings kann die Masse bis zu 50kg betragen"
                    },
                    {
                        "name": "Schleudern I",
                        "level": 16,
                        "value": "Der Zauberer kann ein Objekt (dessen Flug innerhalb von 3 Metern Entfernung zum Zauberer beginnt und das 500g oder weniger wiegt) mit genug Kraft schleudern, daß es als Angriff gilt. Der Angriff wird auf der Angriffstabelle 10.79: Schleuder (aus dem Kampfhandbuch, Seite 223) abgewickelt und hat eine Reichweite von maximal 90m. Der OB des Zauberers ist sein Fertigkeitswert in Gezielte Sprüche: Schleudern. Wenn Ihnen das Kampfhandbuch nicht zur Verfügung steht, verwenden Sie bitte die Angriffstabelle: Schockstrahl (mit einer maximalen Reichweite von 90m)"
                    },
                    {
                        "name": "Telekinese V",
                        "level": 17,
                        "value": "Wie Telekinese I, allerdings kann die Masse bis zu 50kg betragen"
                    },
                    {
                        "name": "Massen-Vibration III",
                        "level": 19,
                        "value": "Wie Massen-Vibration I, nur können die Objekte eine Masse von bis zu 10 kg haben"
                    },
                    {
                        "name": "Meister-Zielen",
                        "level": 20,
                        "value": "Wie Zielen, nur beträgt der Bonus auf den Fernkampfangriff +100"
                    },
                    {
                        "name": "Wahrhaftiges Bleiben",
                        "level": 25,
                        "value": "Wie Bleiben I, nur kann die Masse bis zu 5kg pro Stufe des Zauberers betragen"
                    },
                    {
                        "name": "Starke Telekinese",
                        "level": 30,
                        "value": "Wie Telekinese I, allerdings kann die Masse bis zu 5kg pro Stufe des Zauberers betragen"
                    },
                    {
                        "name": "Wahrhaftiges Zielen",
                        "level": 50,
                        "value": "Wie Zielen, nur verursacht der Fernkampfangriff automatisch Maximalschaden. Wenn das Ziel ein großes oder gewaltiges Wesen ist, gilt dieser Angriff als gezielt tödlich."
                    }
                ]
            },
            {
                "id": "7.2",
                "name": "9.1.3: Kleine Illusionen",
                "spells": [
                    {
                        "name": "Bauchreden",
                        "level": 1,
                        "value": "Der Zauberer kann sprechen, und seine Stimme erklingt von einem beliebigen Punkt innerhalb von 30 Metern (der Punkt muß in seinem Sichtfeld liegen)"
                    },
                    {
                        "name": "Trugbild Geräusch/Licht",
                        "level": 2,
                        "value": "Erzeugt ein einfaches, unbewegliches Trugbild oder unbewegliche Geräusche in einem Bereich von bis zu 3 Metern Radius"
                    },
                    {
                        "name": "Trugbild Geschmack/Geruch",
                        "level": 3,
                        "value": "Erzeugt unbewegliche Gerüche oder unbeweglichen Geschmack in einem Bereich von bis zu 3 Metern Radius"
                    },
                    {
                        "name": "Illusion II",
                        "level": 4,
                        "value": "Erzeugt ein einfaches, unbewegliches Trugbild/Szene in einem Bereich von bis zu 3 Metern Radius. Eine der folgenden Optionen kann zusätzlich mit ausgewählt werden: a) ein zusätzlicher Sinn kann hinzugefügt werden (jedoch nicht der Tastsinn oder Präsenz), b) die Dauer kann verdoppelt werden, c) die Reichweite kann verdoppelt werden, oder d) der Radius des Wirkungsbereiches kann verdoppelt werden. Alle Teile des Wirkungsbereiches müssen innerhalb der Reichweite liegen (und im Sichtbereich des Zauberers)"
                    },
                    {
                        "name": "Phantasma I",
                        "level": 5,
                        "value": "Erstellt das Trugbild eines Objekts oder Lebewesens, das sich während der Konzentration des Zauberers nach Wunsch bewegt. Bricht die Konzentration ab, erstarrt das Trugbild, bleibt aber bestehen. Wenn der Zauberer die Konzentration wieder aufnimmt, kann er das Trugbild erneut bewegen (sofern die Dauer nicht abgelaufen ist). Das Bild kann jede Größe haben, solange es in den Radius paßt"
                    },
                    {
                        "name": "Mirakel Licht I",
                        "level": 6,
                        "value": "Verändert das sichtbare Aussehen eines Objektes. Das Ziel darf nicht mehr Masse als 5kg pro Stufe haben"
                    },
                    {
                        "name": "Verzögerte Illusion II",
                        "level": 7,
                        "value": "Wie Illusion II, aber die Illusion kann um bis zu 24 Stunden verzögert werden. Beim Wirken des Spruches entscheidet sich der Zauberer, was die Illusion auslöst. Er hat dabei die Wahl aus: a) Zeitperiode, b) bestimmte Bewegungen, c) bestimmte Geräusche, d) bestimmte Gerüche, oder e) ein bestimmter Geschmack. Wenn ein Sinn als Auslöser verwendet wird, muß dieser in der Illusion enthalten sein"
                    },
                    {
                        "name": "Illusion III",
                        "level": 8,
                        "value": "Wie Illusion II, aber zwei Optionen können gewählt werden"
                    },
                    {
                        "name": "Phantasma II",
                        "level": 9,
                        "value": "Wie Phantasma I, aber es kann eine der folgenden Optionen ausgewählt werden: a) ein zusätzlicher Sinn kann hinzugefügt werden (jedoch nicht der Tastsinn oder Präsenz), b) die Dauer kann verdoppelt werden, c) die Reichweite kann verdoppelt werden, d) der Radius des Wirkungsbereiches kann verdoppelt werden, e) ein weiteres Trugbild kann erzeugt und unabhängig vom ersten bewegt werden (alle Trugbilder müssen sich jedoch zu jeder Zeit vollständig in der Reichweite und im Sichtbereich des Zauberers befinden), oder f ) wenige sich wiederholende Geräusche, Bewegungen usw. können hinzugefügt werden, die keine Konzentration erfordern (der entsprechende Sinn muß in der Illusion enthalten sein)"
                    },
                    {
                        "name": "Verzögertes Phantasma II",
                        "level": 10,
                        "value": "Wie Phantasma II, aber es kann wie in Verzögerter Illusion II aufgeschoben werden. Das Phantasma bewegt sich und handelt, wenn es beim Wirken des Spruches ein einfaches Kommando erhalten hat. Alternativ kann es eine kurze Rede halten (wenn Geräusch einer der Sinne ist)"
                    },
                    {
                        "name": "Verzögerte Illusion III",
                        "level": 11,
                        "value": "Wie Verzögerte Illusion II, nur können zwei Optionen gewählt werden. In den Anmerkungen finden Sie einige Hinweise dazu, wie sich diese Optionen miteinander kombinieren lassen"
                    },
                    {
                        "name": "Phantasma III",
                        "level": 12,
                        "value": "Wie Phantasma II, nur können zwei Optionen gewählt werden. In den Anmerkungen finden Sie einige Hinweise dazu, wie sich diese Optionen miteinander kombinieren lassen"
                    },
                    {
                        "name": "Illusion V",
                        "level": 13,
                        "value": "Wie Illusion II, nur können vier Optionen gewählt werden."
                    },
                    {
                        "name": "Verzögerte Illusion IV",
                        "level": 14,
                        "value": "Wie Verzögerte Illusion II, nur können drei Optionen gewählt werden"
                    },
                    {
                        "name": "Verzögertes Phantasma III",
                        "level": 15,
                        "value": "Wie Verzögertes Phantasma II, nur können zwei Optionen gewählt werden"
                    },
                    {
                        "name": "Verzögerte Illusion V",
                        "level": 16,
                        "value": "Wie Verzögerte Illusion II, nur können vier Optionen gewählt werden"
                    },
                    {
                        "name": "Phantasma IV",
                        "level": 17,
                        "value": "Wie Phantasma II, nur können drei Optionen gewählt werden"
                    },
                    {
                        "name": "Verzögerte Phantasma IV",
                        "level": 18,
                        "value": "Wie Verzögertes Phantasma II, nur können drei Optionen gewählt werden"
                    },
                    {
                        "name": "Illusion VII",
                        "level": 19,
                        "value": "Wie Illusion II, nur können sechs Optionen gewählt werden"
                    },
                    {
                        "name": "Verzögerte Illusion VI",
                        "level": 20,
                        "value": "Wie Verzögerte Illusion II, nur können fünf Optionen gewählt werden"
                    },
                    {
                        "name": "Phantasma V",
                        "level": 25,
                        "value": "Wie Phantasma II, nur können vier Optionen gewählt werden"
                    },
                    {
                        "name": "Illusion X",
                        "level": 30,
                        "value": "Wie Illusion II, nur können neun Optionen gewählt werden"
                    },
                    {
                        "name": "Phantasma X",
                        "level": 50,
                        "value": "Wie Phantasma II, nur können neun Optionen gewählt werden."
                    }
                ]
            },
            {
                "id": "7.3",
                "name": "9.1.4: Meisterschaft der Runen",
                "spells": [
                    {
                        "name": "Spruchspeicher",
                        "level": 2,
                        "value": "Der Zauberer kann diesen Spruch auf jeden Spruch anwenden, den er speichern möchte. Der zu speichernde Spruch muß innerhalb einer Minute gewirkt werden, nachdem der Spruchspeicher gewirkt wurde. Der gespeicherte Spruch kann dann später als ein unverzüglicher Spruch ausgelöst werden. Der Spruchspeicher-Spruch kostet dieselbe Anzahl an Magiepunkten, wie der zu speichernde Spruch. Während sich ein Spruch im Speicher befindet, kann kein anderer Spruch gewirkt werden"
                    },
                    {
                        "name": "Rune I",
                        "level": 3,
                        "value": "Mit diesem Spruch wird ein anderer Spruch auf ein speziell vorbereitetes Blatt Papier oder Pergament („Runenpapier“) geschrieben. Diese Rune kann dann benutzt werden, um den geschriebenen Spruch als einen unverzüglichen Spruch auszulösen. Der zu schreibende Spruch muß innerhalb einer Minute gewirkt werden, nachdem die Rune gewirkt wurde. Mit Rune I kann man nur Sprüche der ersten Stufe schreiben. Die Rune kann so gewirkt werden, daß der geschriebene Spruch den Leser betrifft"
                    },
                    {
                        "name": "Rune II",
                        "level": 6,
                        "value": "Wie Rune I, aber es können Sprüche bis zur zweiten Stufe geschrieben werden"
                    },
                    {
                        "name": "Rune III",
                        "level": 8,
                        "value": "Wie Rune I, aber es können Sprüche bis zur dritten Stufe geschrieben werden"
                    },
                    {
                        "name": "Rune V",
                        "level": 10,
                        "value": "Wie Rune I, aber es können Sprüche bis zur fünften Stufe geschrieben werden"
                    },
                    {
                        "name": "Zeichen des Schocks",
                        "level": 11,
                        "value": "[WW-Mod.: -20] Ein Zeichen kann auf eine beliebige, unbewegliche Oberfläche geschrieben werden und betrifft das Wesen, das es auslöst. Ein Zeichen kann durch eine der folgenden Bedingungen ausgelöst werden (welche es ist, legt der Zauberer fest, wenn er den Spruch wirkt): a) eine festgelegte Zeitspanne ist abgelaufen, b) es tauchen innerhalb eines Umkreises von 6m festgelegte Bewegungen auf, c) es treten innerhalb eines Umkreises von 6m festgelegte Geräusche auf, d) das Zeichen wird berührt, e) das Zeichen wird gelesen. Das Zeichen erlischt, wenn einem Wesen der WW gegen es mißlingt. Durch Zeichen des Schocks fällt das Ziel in einen Schockzustand, der pro 10 Fehlschlag 10 Minuten anhält (behandeln Sie das, als wäre das Ziel benommen, nur wird es in Folge dieses Schocks nie bewußtlos)"
                    },
                    {
                        "name": "Rune VI",
                        "level": 12,
                        "value": "Wie Rune I, aber es können Sprüche bis zur 6. Stufe geschrieben werden"
                    },
                    {
                        "name": "Zeichen der Furcht",
                        "level": 13,
                        "value": "Wie Zeichen des Schocks, nur flieht das Ziel 1 Minute pro 5 Fehlschlag vor dem Zeichen. Der WW des Ziels ist gegen Essenz, nicht gegen Furcht"
                    },
                    {
                        "name": "Rune VII",
                        "level": 14,
                        "value": "Wie Rune I, aber es können Sprüche bis zur 7. Stufe geschrieben werden"
                    },
                    {
                        "name": "Zeichen des Schlafes",
                        "level": 15,
                        "value": "Wie Zeichen des Schocks, nur sinkt das Ziel in einen magischen Schlaf, aus dem es 10 Minuten pro 10 Fehlschlag nicht erweckt werden kann"
                    },
                    {
                        "name": "Rune VIII",
                        "level": 16,
                        "value": "Wie Rune I, aber es können Sprüche bis zur 8. Stufe geschrieben werden"
                    },
                    {
                        "name": "Zeichen der Blendung",
                        "level": 17,
                        "value": "Wie Zeichen des Schocks, nur ist das Ziel 1 Stunde lang pro 10 Fehlschlag geblendet"
                    },
                    {
                        "name": "Rune IX",
                        "level": 18,
                        "value": "Wie Rune I, aber es können Sprüche bis zur 9. Stufe geschrieben werden"
                    },
                    {
                        "name": "Zeichen der Lähmung",
                        "level": 19,
                        "value": "Wie Zeichen des Schocks, nur ist das Ziel 1 Stunde lang pro 10 Fehlschlag gelähmt"
                    },
                    {
                        "name": "Rune X",
                        "level": 20,
                        "value": "Wie Rune I, aber es können Sprüche bis zur 10. Stufe geschrieben werden"
                    },
                    {
                        "name": "Meister-Forschen",
                        "level": 25,
                        "value": "Siehe Abschnitt 5.0 (Seite 35)"
                    },
                    {
                        "name": "Meister-Rune",
                        "level": 30,
                        "value": "Wie Rune I, aber es können Sprüche bis zur 20. Stufe geschrieben werden"
                    },
                    {
                        "name": "Massen-Zeichen",
                        "level": 50,
                        "value": "Wie ein beliebiger Zeichenspruch, nur kann der Spruch die Stufe des Zauberers an Zielen betreffen, bevor er erlischt."
                    }
                ]
            },
            {
                "id": "7.4",
                "name": "9.1.5: Physische Verbesserung",
                "spells": [
                    {
                        "name": "Lebende Waage",
                        "level": 1,
                        "value": "Der Zauberer kann die exakten Dimensionen, die Masse und/oder das Gewicht eines Objekts bestimmen"
                    },
                    {
                        "name": "Listige Ohren",
                        "level": 2,
                        "value": "Das Ziel erhält ein doppelt so gutes Gehör. Dies bringt ihm einen besonderen Bonus von +50 auf Fertigkeiten der Gruppen Wahrnehmung • Suchen und Wahrnehmung • Sinne, sofern es dabei auf das Gehör ankommt (oder +5 auf die Fertigkeit Aufmerksamkeit). Wenn neben dem Gehör auch andere Sinne für die Fertigkeit wichtig sind, reduziert sich der Bonus auf +25 (+3 bei Aufmerksamkeit)"
                    },
                    {
                        "name": "Balancieren",
                        "level": 3,
                        "value": "Liefert einen Bonus von +50 auf ein einzelnes langsames Manöver, für das Balance erforderlich ist (z.B. das Gehen auf einem 8cm breiten Balken)"
                    },
                    {
                        "name": "Nachtsicht",
                        "level": 4,
                        "value": "Das Ziel kann in einer normalen Nacht 30 Meter weit sehen, als wäre es Tag. Vgl. Abschnitt 5.11 (Seite 39)"
                    },
                    {
                        "name": "Rundumsicht",
                        "level": 5,
                        "value": "Das Ziel hat ein Gesichtsfeld von 300°. Der Bonus für Angriffe aus der Flanke reduziert sich auf +5 und der für Angriffe von hinten auf +15"
                    },
                    {
                        "name": "Schreien",
                        "level": 6,
                        "value": "Die Stimme des Ziels wird auf die dreifache Lautstärke verstärkt. Dies hat keine Auswirkungen auf magische Fähigkeiten, es erlaubt dem Zauber einfach nur, auch aus größerer Entfernung vernehmbar zu sein"
                    },
                    {
                        "name": "Wassersicht",
                        "level": 7,
                        "value": "Wie Nachtsicht, aber das Ziel kann 30 Meter in jedem Gewässer sehen, selbst in schlammigem und trübem Wasser"
                    },
                    {
                        "name": "Kiemen",
                        "level": 8,
                        "value": "Das Ziel kann Wasser atmen, aber keine Luft"
                    },
                    {
                        "name": "Hitzesicht",
                        "level": 9,
                        "value": "Wie Nachtsicht, aber das Ziel kann die verschiedenen Temperaturen auf Oberflächen von Objekten sehen. Man kann mit diesem Spruch nicht durch Dinge hindurchschauen. Die Sicht ist für detaillierte Aktionen wie Karten zeichnen oder Lesen nicht gut genug"
                    },
                    {
                        "name": "Gaslungen",
                        "level": 10,
                        "value": "Wie Kiemen, aber das Ziel kann jedes Gas wie normale Luft atmen"
                    },
                    {
                        "name": "Gift widerstehen",
                        "level": 11,
                        "value": "Verzögert die Wirkung eines Gifts auf das Ziel. Wenn das Gift nicht neutralisiert wird, bevor die Spruchdauer abgelaufen ist, erleidet das Ziel dessen Wirkung dann"
                    },
                    {
                        "name": "Dunkelsicht",
                        "level": 12,
                        "value": "Wie Nachtsicht, aber der Zauberer kann in jeder Dunkelheit sehen. Außerdem funktioniert der Spruch auch ganz ohne Licht"
                    },
                    {
                        "name": "Wandellungen",
                        "level": 15,
                        "value": "Wie Kiemen, nur kann das Ziel nach Belieben Luft, Wasser und/oder jedwedes Gas atmen"
                    },
                    {
                        "name": "Massen-Balancieren",
                        "level": 16,
                        "value": "Wie Balancieren, nur kann der Spruch ein Ziel pro Stufe des Zauberers betreffen"
                    },
                    {
                        "name": "Massen-Nachtsicht",
                        "level": 18,
                        "value": "Wie Nachtsicht, nur kann der Spruch ein Ziel pro Stufe des Zauberers betreffen"
                    },
                    {
                        "name": "Massen-Wassersicht",
                        "level": 19,
                        "value": "Wie Wassersicht, nur kann der Spruch ein Ziel pro Stufe des Zauberers betreffen"
                    },
                    {
                        "name": "Sicht",
                        "level": 20,
                        "value": "Wirkt wie alle Sichtsprüche unterhalb der 15. Stufe gleichzeitig"
                    },
                    {
                        "name": "Massen-Kiemen",
                        "level": 25,
                        "value": "Wie Kiemen, nur kann der Spruch ein Ziel pro Stufe des Zauberers betreffen"
                    },
                    {
                        "name": "Massen-Gaslungen",
                        "level": 30,
                        "value": "Wie Gaslungen, nur kann der Spruch ein Ziel pro Stufe des Zauberers betreffen"
                    },
                    {
                        "name": "Massen-Sicht",
                        "level": 50,
                        "value": "Wie Sicht, nur kann der Spruch ein Ziel pro Stufe des Zauberers betreffen."
                    }
                ]
            },
            {
                "id": "7.5",
                "name": "9.1.6: Spruchbarriere",
                "spells": [
                    {
                        "name": "Schutz I",
                        "level": 1,
                        "value": "Zieht 5 von allen elementaren Angriffen gegen das Ziel ab, und alle WW für das Ziel gegen Sprüche haben einen Bonus von +5"
                    },
                    {
                        "name": "Essenz aufheben",
                        "level": 2,
                        "value": "Wenn der Zauberer Ziel eines Spruches aus dem Bereich Essenz wird, muß dieser „ankommende“ Spruch vor dem Zauberer einen WW durchführen. Dabei benutzt der Spruch als Stufe die desjenigen, der ihn gewirkt hat. Wenn der „ankommende“ Spruch diesen WW besteht, betrifft er den Zauberer von Essenz aufheben normal (der Zauberer hat dann noch seinen normalen WW). Wenn nicht, betrifft er den Zauberer nicht"
                    },
                    {
                        "name": "Schutzsphäre I",
                        "level": 3,
                        "value": "Wie Schutz I, aber er betrifft alle Wesen innerhalb eines Radius von 3 Metern"
                    },
                    {
                        "name": "Mentalismus aufheben",
                        "level": 4,
                        "value": "Wie Essenz aufheben, aber der Zauberer wird vor Sprüchen aus dem Bereich Mentalismus geschützt"
                    },
                    {
                        "name": "Schutz II",
                        "level": 5,
                        "value": "Wie Schutz I, aber die Boni sind +10"
                    },
                    {
                        "name": "Leitmagie aufheben",
                        "level": 6,
                        "value": "Wie Essenz aufheben, aber der Zauberer wird vor Sprüchen aus dem Bereich Leitmagie geschützt"
                    },
                    {
                        "name": "Schutzsphäre II",
                        "level": 7,
                        "value": "Wie Schutzsphäre I, aber die Boni sind +10"
                    },
                    {
                        "name": "Nullsphäre Essenz",
                        "level": 8,
                        "value": "Wie Essenz aufheben, bis auf den Wirkungsbereich, der auf den Zauberer zentriert ist. Wenn die Sphäre auf einen wirksamen Essenzspruch trifft, muß diesem ein WW gelingen (mit einem Sonderbonus von +30), oder er wird aufgehoben (und nicht gebannt, er ist quasi „abgeschaltet“), solange er innerhalb des Sphärenradius wirksam ist"
                    },
                    {
                        "name": "Essenzschild",
                        "level": 9,
                        "value": "Erzeugt einen schimmernden Schild vor dem Zauberer. Alle Basis-Angriffswürfe und elementaren Angriffswürfe für frontale Essenzsprüche gegen ihn erhalten einen Malus von -10. Führt der Zauberer während einer Runde keine anderen Handlungen aus, kann er einen Zauberangriff „parieren“. Sein Parade-Bonus entspricht 10 plus der Anzahl an Fertigkeitsrängen in dieser Liste"
                    },
                    {
                        "name": "Mentalismusschild",
                        "level": 10,
                        "value": "Wie Essenzschild, aber er ist nur gegen Mentalismus effektiv"
                    },
                    {
                        "name": "Schutz III",
                        "level": 11,
                        "value": "Wie Schutz I, aber die Boni sind +15"
                    },
                    {
                        "name": "Nullsphäre Mentalismus",
                        "level": 12,
                        "value": "Wie Bannsphäre Essenz, aber der Spruch schützt vor Mentalismuswirkungen"
                    },
                    {
                        "name": "Leitmagieschild",
                        "level": 13,
                        "value": "Wie Essenzschild, aber er wirkt nur gegen Leitmagie"
                    },
                    {
                        "name": "Spruchschild",
                        "level": 14,
                        "value": "Wie Essenzschild, aber er wirkt gegen zwei der drei Magiebereiche (Wahl des Zauberers)"
                    },
                    {
                        "name": "Schutz IV",
                        "level": 15,
                        "value": "Wie Schutz I, aber die Boni sind +15"
                    },
                    {
                        "name": "Nullsphäre Leitmagie",
                        "level": 16,
                        "value": "Wie Bannsphäre Essenz, aber der Spruch schützt vor Leitmagiewirkungen"
                    },
                    {
                        "name": "Wahrhaftiger Spruchschild",
                        "level": 18,
                        "value": "Wie Essenzschild, nur wirkt er gegen alle drei Magiebereiche"
                    },
                    {
                        "name": "Schutz IV",
                        "level": 19,
                        "value": "Wie Schutz I, aber die Boni sind +25"
                    },
                    {
                        "name": "Essenzwiderstand",
                        "level": 20,
                        "value": "Das Ziel erhält einen Bonus von +50 auf alle WW gegen Essenzsprüche"
                    },
                    {
                        "name": "Mentalismuswiderstand",
                        "level": 25,
                        "value": "Wie Essenzwiderstand, aber der Spruch wirkt nur gegen Menalismussprüche"
                    },
                    {
                        "name": "Leitmagiewiderstand",
                        "level": 30,
                        "value": "Wie Essenzwiderstand, aber der Spruch wirkt nur gegen Leitmagiesprüche"
                    },
                    {
                        "name": "Wahrhaftiger Widerstand",
                        "level": 50,
                        "value": "Wie Essenzwiderstand, nur sind alle drei Magiebereiche betroffen."
                    }
                ]
            },
            {
                "id": "7.6",
                "name": "9.1.7: Wege der Entdeckung",
                "spells": [
                    {
                        "name": "Essenz entdecken",
                        "level": 1,
                        "value": "Entdeckt alle aktiven Sprüche oder magische Gegenstände der Essenz"
                    },
                    {
                        "name": "Mentalismus entdecken",
                        "level": 2,
                        "value": "Wie Essenz entdecken, gilt aber für Mentalismus"
                    },
                    {
                        "name": "Leitmagie entdecken",
                        "level": 3,
                        "value": "Wie Essenz entdecken, gilt aber für Leitmagie"
                    },
                    {
                        "name": "Unsichtbares entdecken",
                        "level": 5,
                        "value": "Wie Essenz entdecken, aber es werden alle unsichtbaren Lebewesen und Gegenstände entdeckt"
                    },
                    {
                        "name": "Fallen entdecken",
                        "level": 6,
                        "value": "Wie Essenz entdecken, jedoch entdeckt man mit diesem Spruch eine Falle mit 75%-Wahrscheinlichkeit (die Komplexität der Falle kann diese Wahrscheinlichkeit modifizieren)"
                    },
                    {
                        "name": "Böses entdecken",
                        "level": 7,
                        "value": "Wie Essenz entdecken, aber es wird entdeckt, ob eine Person böse ist oder ob ein magischer Gegenstand durch das Böse erschaffen oder lange von einer sehr bösen Person benutzt wurde"
                    },
                    {
                        "name": "Wiederfinden I",
                        "level": 8,
                        "value": "Liefert Richtung und Entfernung eines bestimmten Objekts oder Ortes, mit dem der Zauberer vertraut ist oder von dem er eine detaillierte Beschreibung erhalten hat"
                    },
                    {
                        "name": "Macht analysieren I",
                        "level": 10,
                        "value": "Wie Essenz entdecken, liefert aber eine Einschätzung der Machtfülle (Stufe) einer Person, eines magischen Gegenstandes oder Zauberspruchs"
                    },
                    {
                        "name": "Totes entdecken",
                        "level": 11,
                        "value": "Wie Essenz entdecken, nur kann der Spruch Leichen entdecken und herausfinden, ob jemand innerhalb der letzten 24 Stunden innerhalb des Wirkungsbereiches gestorben ist"
                    },
                    {
                        "name": "Wiederfinden III",
                        "level": 12,
                        "value": "Wie Wiederfinden I, nur ist die Reichweite 90m"
                    },
                    {
                        "name": "Spruch entdecken",
                        "level": 15,
                        "value": "Wie Essenz entdecken, nur wird jeder Spruch entdeckt, der im untersuchten Gebiet gewirkt wurde. Liefert den genauen Spruch, der gewirkt wurde"
                    },
                    {
                        "name": "Wiederfinden V",
                        "level": 16,
                        "value": "Wie Wiederfinden I, nur ist die Reichweite 150m"
                    },
                    {
                        "name": "Macht analysieren III",
                        "level": 18,
                        "value": "Wie Macht analysieren I, nur ist die Reichweite 90m"
                    },
                    {
                        "name": "Mächtiges Wiederfinden",
                        "level": 20,
                        "value": "Wie Wiederfinden I, nur ist die Reichweite 2km"
                    },
                    {
                        "name": "Entdeckungsmagie entdecken",
                        "level": 25,
                        "value": "Wie Essenz entdecken, nur kann jede Art von Entdeckungsspruch entdeckt werden, der im untersuchten Gebiet wirkt (liefert den genauen Spruch)"
                    },
                    {
                        "name": "Wahrhaftiges Entdecken",
                        "level": 30,
                        "value": "In jeder Runde kann einer der niedrigstufigeren Entdecken-Sprüche angewandt werden"
                    },
                    {
                        "name": "Wahrhaftiges Wiederfinden",
                        "level": 50,
                        "value": "Wie Wiederfinden I, nur ist die Reichweite 1,5 km pro Stufe."
                    }
                ]
            },
            {
                "id": "7.7",
                "name": "9.1.8: Wege der Forschung",
                "spells": [
                    {
                        "name": "Textanalyse I",
                        "level": 2,
                        "value": "Der Zauberer kann einen Text in einer ihm unbekannten Sprache lesen, versteht jedoch nur seine Grundzüge. Dies entspricht Fertigkeitsrang 2 in einer geschriebenen Sprache"
                    },
                    {
                        "name": "Steinanalyse",
                        "level": 3,
                        "value": "Liefert Natur und Herkunft eines naturbelassenen Steins und bei einem bearbeiten, wann und wie er erlangt und bearbeitet wurde"
                    },
                    {
                        "name": "Metallanalyse",
                        "level": 4,
                        "value": "Wie Steinanalyse, aber für Metalle"
                    },
                    {
                        "name": "Gasanalyse",
                        "level": 5,
                        "value": "Wie Steinanalyse, aber für Gase"
                    },
                    {
                        "name": "Textanalyse II",
                        "level": 7,
                        "value": "Wie Textanalyse I, liefert jedoch eine komplette technische Analyse (Vokabular und Syntax), allerdings ohne Verständnis von Redewendungen, Nebenbedeutungen oder kulturellen Bezügen. Dies entspricht Fertigkeitsrang 5 in einer geschriebenen Sprache"
                    },
                    {
                        "name": "Flüssigkeitsanalyse",
                        "level": 8,
                        "value": "Wie Steinanalyse, aber für Flüssigkeiten"
                    },
                    {
                        "name": "Verständnis",
                        "level": 10,
                        "value": "Liefert wichtige Einzelheiten zur Konstruktion und zum Zweck eines Gegenstandes (aber nicht seine Fähigkeiten)"
                    },
                    {
                        "name": "Spruchanalyse",
                        "level": 11,
                        "value": "Analysiert einen aktiven Spruch und liefert so seine Dauer, die Liste, von der er stammt, und die Spruchart (aber nicht die Stufe oder genau, was es für ein Spruch ist)"
                    },
                    {
                        "name": "Todesanalyse",
                        "level": 14,
                        "value": "Liefert Informationen über den Tod eines Wesens (die Waffe oder der Spruch, mit der/ dem er getötet wurde, wie lange er her ist)"
                    },
                    {
                        "name": "Textanalyse III",
                        "level": 15,
                        "value": "Wie Textanalyse I, allerdings liefert der Spruch alles außer Andeutungen (d.h. die Antwort auf Rätsel würde nicht gleich mitgewußt werden). Dieser Spruch verleiht dem Zauberer die Entsprechung eines Fertigkeitsrangs von 8 in einer geschriebenen Sprache"
                    },
                    {
                        "name": "Macht erkennen",
                        "level": 16,
                        "value": "Wie Spruchanalyse, nur wirkt er auch auf Sprüche/Kräfte, die gerade nicht aktiv sind. Es kann ein Gegenstand, eine Person oder ein Ort darauf untersucht werden, ob er magisch ist und aus welchem Bereich die Magie stammt, und der Spruch vermittelt eine grobe Vorstellung von der Herkunft und der zugrundeliegenden Struktur dieser Magie"
                    },
                    {
                        "name": "Übermittlung",
                        "level": 17,
                        "value": "Sein Bewußtsein löst sich vom Körper des Zauberers (der während der Spruchdauer inaktiv ist) und kann in jeder Minute 1,5 km weit reisen. Allerdings kann es sich nur 3m pro Minute weit bewegen, wenn es durch einen Festkörper hindurchgeht oder die Welt wahrnimmt. Wenn der Spruch erlischt, bevor der Zauberer in seinen Körper zurückkehrte, kommt er mit einer festen Geschwindigkeit von 150m pro Runde zu ihm zurück, und wenn er ihn erreicht hat, muß ihm ein um -50 erschwerter WW gelingen, sonst stirbt er (die Angriffstufe entspricht der Anzahl der säumigen Runden)"
                    },
                    {
                        "name": "Todesverständnis",
                        "level": 18,
                        "value": "Wie Todesanalyse, nur erhält der Zauberer eine bildhafte Vorstellung des Mörders und den ungefähren Grund für den Tod (z.B. Rache, Raub, Unfall usw.)"
                    },
                    {
                        "name": "Analyse",
                        "level": 20,
                        "value": "Alle niedrigeren Sprüche (außer Übermittlung) können zusammen auf einen Gegenstand, eine Person oder einen Ort angewandt werden"
                    },
                    {
                        "name": "Massen-Analyse",
                        "level": 25,
                        "value": "Wie Analyse, nur kann pro Runde ein Gegenstand untersucht werden"
                    },
                    {
                        "name": "Wahrhaftige Machterkennung",
                        "level": 30,
                        "value": "Wie Macht erkennen, nur liefert der Spruch die Herkunft, den Schöpfer und den genauen Zweck"
                    },
                    {
                        "name": "Wahrhaftige Übermittlung",
                        "level": 50,
                        "value": "Wie Übermittlung, nur bewegt sich das Bewußtsein mit einer Geschwindigkeit von 15km pro Minute (15m, wenn es durch Festkörper hindurch geht und wenn es wahrnimmt). B e s o n d e r e Anmerkungen Siehe Abschnitt 5.13 (Seite 39) für Genaueres zu Sprüchen."
                    }
                ]
            },
            {
                "id": "7.8",
                "name": "9.1.9: Wege des Öffnens",
                "spells": [
                    {
                        "name": "Schloß",
                        "level": 1,
                        "value": "Der Zauberer kann ein beliebiges Schloß verschließen, das er innerhalb von 30 Metern sieht (das Schloß ist nur normal verschlossen und kann auf normale Weise geöffnet werden)"
                    },
                    {
                        "name": "Magisches Schloß",
                        "level": 2,
                        "value": "Eine Tür oder ein Behälter kann auf magische Weise verschlossen werden. Während der Dauer des Spruchs kann die Tür nur durch Einschlagen oder durch einen Bannspruch geöffnet werden"
                    },
                    {
                        "name": "Schloßkunde",
                        "level": 3,
                        "value": "Liefert dem Zauberer einen Bonus von +20 auf Versuche, das untersuchte Schloß zu knacken und einen Bonus von +10 für jeden, dem der Zauberer das Schloß erklärt"
                    },
                    {
                        "name": "Öffnen I",
                        "level": 4,
                        "value": "Beim Einsatz dieses Zaubers gegen ein Schloß besteht eine 20%-Chance, daß sich ein normales Schloß öffnet, und eine 45%-Chance, daß sich ein Magisches Schloß öffnet. Mit einer Wahrscheinlichkeit von 10% löst der Spruch Fallen an dem Schloß aus. Die Würfe sind offen und werden durch die Qualität des Schlosses modifiziert"
                    },
                    {
                        "name": "Fallenkunde",
                        "level": 5,
                        "value": "Wie Schloßkunde, bezieht sich aber auf das Entschärfen von Fallen"
                    },
                    {
                        "name": "Entschärfen I",
                        "level": 6,
                        "value": "Wie Öffnen I, die Chancen beziehen sich aber auf das Entschärfen von Fallen. Es gibt eine 10%-Chance, daß die zu entschärfende Falle hierbei ausgelöst wird"
                    },
                    {
                        "name": "Verkeilen",
                        "level": 7,
                        "value": "Eine Tür dehnt sich aus und verklemmt sich im Türrahmen. Würfeln Sie 1W100, um die Schwere der Verkeilung festzustellen (bei einer 01 klemmt die Tür nur leicht, während man sie bei einer 100 keinesfalls mehr öffnen kann)"
                    },
                    {
                        "name": "Schwächen",
                        "level": 8,
                        "value": "Reduziert die Stabilität einer Tür um 50%. Alle Manöver, mit denen die Tür eingeschlagen werden sollen, bekommen einen besonderen Bonus von +50"
                    },
                    {
                        "name": "Gefängnis öffnen I",
                        "level": 9,
                        "value": "Wenn dieser Spruch gewirkt wird, gibt es eine 20%-Chance, daß alle Schlösser im Wirkungsbereich aufgeschlossen werden (45%-Chance bei Magisches Schloß). Würfeln Sie einzeln für jedes Schloß im Wirkungsbereich. Die Würfe sind offen und werden durch die Qualität der Schlösser modifiziert"
                    },
                    {
                        "name": "Öffnen II",
                        "level": 10,
                        "value": "Wie Öffnen I, aber die Chance ist 40% (90% bei Magisches Schloß)"
                    },
                    {
                        "name": "Tür auflösen I",
                        "level": 11,
                        "value": "Löst eine nicht-magische Tür, die bis zu 15cm tief, 3m hoch und 3m breit ist, in Luft auf. Wenn die Tür tiefer als 15cm ist, werden die ersten 15cm aufgelöst. Der Spruch hat nur auf etwas Wirkung, das als Tür genutzt wird (d.h. nicht auf einen Wandabschnitt)"
                    },
                    {
                        "name": "Entschärfen II",
                        "level": 12,
                        "value": "Wie Entschärfen I, aber die Chance ist 40% (90% bei magischen Fallen)"
                    },
                    {
                        "name": "Besseres Magisches Schloß",
                        "level": 13,
                        "value": "Wie Magisches Schloß, nur hält dieser Spruch eine Stunde pro Stufe lang an, und die Wahrscheinlichkeit, daß ein Öffnen-Spruch funktioniert, wird um 20% gesenkt"
                    },
                    {
                        "name": "Wahrhaftiges Schloß",
                        "level": 14,
                        "value": "Wie Magisches Schloß, nur kann man die Türe nicht auf normale Weise einschlagen"
                    },
                    {
                        "name": "Tür auflösen II",
                        "level": 15,
                        "value": "Wie Tür auflösen I, nur kann die Tür bis zu 60cm x 6m x 6m groß sein"
                    },
                    {
                        "name": "Gefängnis öffnen II",
                        "level": 16,
                        "value": "Wie Gefängnis öffnen I, aber die Chance ist 40% (90% bei einem Magischen Schloß)"
                    },
                    {
                        "name": "Tür auflösen III",
                        "level": 17,
                        "value": "Wie Tür auflösen I, nur kann die Tür bis zu 1m x 15m x 15m groß sein"
                    },
                    {
                        "name": "Wahrhaftiges magisches Schloß",
                        "level": 18,
                        "value": "Wie Magisches Schloß, nur ist die Spruchdauer 1 Tag pro Stufe und die Chance, daß ein Öffnen (oder Gefängnis Öffnen)"
                    },
                    {
                        "name": "Wahrhaftige Türauflösung",
                        "level": 19,
                        "value": "Wie Tür auflösen I, nur wird eine beliebige, einzelne Tür in Luft aufgelöst"
                    },
                    {
                        "name": "Neues Tor",
                        "level": 20,
                        "value": "Eine Tür (2,5m x 2m) wird in einer beliebigen Wand geschaffen, die bis zu 15cm pro Stufe tief ist"
                    },
                    {
                        "name": "Schlössermeister",
                        "level": 25,
                        "value": "Verleiht dem Zauberer eine Chance von 90%, ein Schloß zu öffnen. Der Wurf ist offen, und die Qualität des Schlosses kann den Wurf beeinflussen"
                    },
                    {
                        "name": "Fallenmeister",
                        "level": 30,
                        "value": "Wie Schlössermeister, nur gilt die Chance dafür, Fallen zu entschärfen"
                    },
                    {
                        "name": "Torspalter",
                        "level": 50,
                        "value": "Der Zauberer kann in jeder Runde einen der niedrigstufigeren Sprüche dieser Liste anwenden."
                    }
                ]
            },
            {
                "id": "7.9",
                "name": "9.1.10: Wege der Wahrnehmung",
                "spells": [
                    {
                        "name": "Präsenz",
                        "level": 2,
                        "value": "Der Zauberer ist sich der Gegenwart aller denkenden/intelligenten Wesen in einem Umkreis von 5 Metern bewußt"
                    },
                    {
                        "name": "Lauschen I",
                        "level": 3,
                        "value": "Der Zauberer kann einen Punkt in einer Entfernung von bis zu 3 Metern bestimmen, von dem aus er dann hört, als stünde er dort"
                    },
                    {
                        "name": "Langes Ohr I",
                        "level": 5,
                        "value": "Der Hörpunkt des Zauberers kann unabhängig von seinem Körper bis zu 30 Meter von ihm fortbewegt werden (mit einer Geschwindigkeit von 3 Meter pro Runde). Der Zauberer muß allerdings in der Lage sein, den neuen Hörpunkt auch körperlich zu erreichen (er kann seinen Hörpunkt also nicht durch eine Wand oder geschlossene Tür bewegen)"
                    },
                    {
                        "name": "Sehen I",
                        "level": 6,
                        "value": "Wie Lauschen I, aber der Zauberer sieht von dem unbeweglichen Punkt aus (die Sicht kann rotieren)"
                    },
                    {
                        "name": "Langes Auge I",
                        "level": 7,
                        "value": "Wie Langes Ohr I, aber auf die Sicht des Zauberers bezogen. Der Sichtpunkt kann sich drehen"
                    },
                    {
                        "name": "Lauschen II",
                        "level": 8,
                        "value": "Wie Lauschen I, aber mit einer Reichweite von 30 Metern"
                    },
                    {
                        "name": "Telepathie",
                        "level": 10,
                        "value": "Der Zauberer kann oberflächliche Gedanken des Ziels empfangen. Gelingt dem Ziel aber der WW mit mehr als 25, bemerkt es den Versuch, die Gedanken zu lesen"
                    },
                    {
                        "name": "Sehen II",
                        "level": 11,
                        "value": "Wie Sehen I, nur hat der Spruch eine Reichweite von 30m"
                    },
                    {
                        "name": "Langes Ohr II",
                        "level": 12,
                        "value": "Wie Langes Ohr I, nur hat der Spruch eine Reichweite von 90m"
                    },
                    {
                        "name": "Lauschen III",
                        "level": 14,
                        "value": "Wie Lauschen I, nur hat der Spruch eine Reichweite von 150m"
                    },
                    {
                        "name": "Langes Auge II",
                        "level": 15,
                        "value": "Wie Langes Auge I, nur hat der Spruch eine Reichweite von 90m"
                    },
                    {
                        "name": "Sehen III",
                        "level": 18,
                        "value": "Wie Sehen I, nur hat der Spruch eine Reichweite von 150m"
                    },
                    {
                        "name": "Lauschen IV",
                        "level": 20,
                        "value": "Wie Lauschen I, nur hat der Spruch eine Reichweite von 1,5 km pro Stufe"
                    },
                    {
                        "name": "Sehen IV",
                        "level": 25,
                        "value": "Wie Sehen I, nur hat der Spruch eine Reichweite von 1,5 km pro Stufe"
                    },
                    {
                        "name": "Wahrhaftiges Lauschen",
                        "level": 30,
                        "value": "Wie Lauschen I, nur ist die Reichweite unbegrenzt (der Zauberer muß den Ort des gewünschten Punktes aber genau angeben können, indem er die Entfernung und die Richtung nennt)"
                    },
                    {
                        "name": "Wahrhaftiges Sehen",
                        "level": 50,
                        "value": "Wie Wahrhaftiges Lauschen, nur kann der Zauberer sehen und nicht hören."
                    }
                ]
            }
        ]
    },
    {
        "id": "8",
        "name": "Geschlossene Essenz",
        "spellLists": [
            {
                "id": "8.0",
                "name": "9.2.1: Magische Brücke",
                "spells": [
                    {
                        "name": "Springen",
                        "level": 1,
                        "value": "Gestattet es dem Ziel, in der Runde, in der der Spruch gewirkt wird, bis zu 15 Meter weit oder 6 Meter hoch zu springen"
                    },
                    {
                        "name": "Landen",
                        "level": 2,
                        "value": "Gestattet es dem Ziel, bei einem Sturz über bis zu 6 Meter pro Stufe des Zauberers sicher zu landen und bei tieferen Stürzen die Folgen entsprechend zu mildern"
                    },
                    {
                        "name": "Versetzen I",
                        "level": 3,
                        "value": "Der Zauberer teleportiert das Ziel an einen bis zu 30 Meter entfernten Ort. Es dürfen sich keine Hindernisse auf direkter Linie zwischen Start- und Zielpunkt befinden. Als Hindernis gilt hierbei alles, was das Ziel nicht körperlich durchqueren kann (eine geschlossene Tür ist ein Hindernis, eine Fallgrube nicht)"
                    },
                    {
                        "name": "Levitation",
                        "level": 4,
                        "value": "Erlaubt es dem Ziel, sich bis zu 3 Meter pro Runde senkrecht auf und ab zu bewegen. Dieser Spruch vermittelt keine Möglichkeiten zur horizontalen Bewegung"
                    },
                    {
                        "name": "Fliegen I",
                        "level": 5,
                        "value": "Das Ziel kann mit bis zu 25 Meter pro Runde fliegen (entspricht 9 km/h). Während Fliegen aktiv ist, ist normale Bewegung (also Gehen, Laufen usw.) nicht erlaubt"
                    },
                    {
                        "name": "Portal",
                        "level": 6,
                        "value": "Öffnet einen frei passierbaren Durchgang der Maße 1m x 2m x 1m in jeglicher festen Materie. Wenn die Dauer ausläuft, formt sich die Materie schlagartig zurück. Jeder, der noch innerhalb des Portals steht, wird an seinen Ausgangspunkt versetzt"
                    },
                    {
                        "name": "Fliegen II",
                        "level": 7,
                        "value": "Wie Fliegen I, aber mit einer Geschwindigkeit von 50 Metern pro Runde (entspricht 18 km/h)"
                    },
                    {
                        "name": "Dimensionstür I",
                        "level": 8,
                        "value": "Wie Versetzen I, aber das Ziel kann durch Hindernisse hindurch teleportieren, indem die exakte Distanz angegeben wird. Wenn der Zielpunkt in fester oder flüssiger Materie liegt, bewegt sich das Ziel nicht, statt dessen ist es für 1W10 Runden benommen (die Magiepunkte sind aber dennoch ausgegeben)"
                    },
                    {
                        "name": "Versetzen III",
                        "level": 9,
                        "value": "Wie Versetzen I, aber die Reichweite ist 100 Meter"
                    },
                    {
                        "name": "Teleportation I",
                        "level": 10,
                        "value": "Wie Dimensionstür I, aber mit einer Reichweite von 15km pro Stufe. Eine Teleportation kann ziemlich risikoreich sein, abhängig davon, wie gut der Zauberer den Zielort kennt. Es gibt die folgenden Chancen für einen Fehlschlag: Unbekannter Zielort (nur durch Beschreibung bekannt) = 50%, kurz dagewesen (bis zu einer Stunde Aufenthalt) = 25%, studiert (24 Stunden Aufenthalt) = 10%, ausführlich studiert (7 Tage) = 1%, dort gelebt (mindestens 1 Jahr) = 0,01%. Falls die Teleportation fehlschlägt, bestimmen Sie zunächst die Richtung der Abweichung (zufällig). Die Größe der Abweichung ist dann 1W100 (offen) in Metern. Dies kann zu extremen und durchaus tödlichen Unfällen führen… 11. Fliegen III"
                    },
                    {
                        "name": "Dimensionstür III",
                        "level": 12,
                        "value": "Wie Dimensionstür I, nur kann sich das Ziel 90m weit bewegen"
                    },
                    {
                        "name": "Teleport III",
                        "level": 13,
                        "value": "Wie Teleport I, nur können 3 Ziele zum gleichen Ort gebracht werden"
                    },
                    {
                        "name": "Wahrhaftiges Portal",
                        "level": 14,
                        "value": "Wie Portal, nur kann das Portal 1m x 2m groß und bis zu 1,5m pro Stufe tief sein"
                    },
                    {
                        "name": "Dimensionstür V",
                        "level": 15,
                        "value": "Wie Dimensionstür I, nur kann sich das Ziel 150 Meter weit bewegen"
                    },
                    {
                        "name": "Teleport V",
                        "level": 16,
                        "value": "Wie Teleport I, nur können 5 Ziele zum gleichen Ort gebracht werden"
                    },
                    {
                        "name": "Wahrhaftiges Fliegen",
                        "level": 17,
                        "value": "Wie Fliegen I, aber das Ziel bewegt sich mit einer Geschwindigkeit von 150 Metern pro Runde (entspricht 54 km/h)"
                    },
                    {
                        "name": "Teleport X",
                        "level": 18,
                        "value": "Wie Teleport I, nur können 10 Ziele zum gleichen Ort gebracht werden"
                    },
                    {
                        "name": "Massen-Versetzen",
                        "level": 19,
                        "value": "Wie Versetzen I, nur kann der Spruch die Stufe des Zauberers an Zielen bewegen"
                    },
                    {
                        "name": "Meister-Teleportation",
                        "level": 20,
                        "value": "Wie Teleportation I, nur können 20 Ziele bewegt werden"
                    },
                    {
                        "name": "Massen-Dimensionstür",
                        "level": 25,
                        "value": "Wie Dimensionstür, nur können die Stufe des Zauberers an Zielen 90 Meter weit bewegt werden"
                    },
                    {
                        "name": "Massen-Teleportation",
                        "level": 30,
                        "value": "Wie Teleportation I, nur kann der Spruch die Stufe des Zauberers an Zielen bewegen"
                    },
                    {
                        "name": "Wahrhaftige Teleportation",
                        "level": 50,
                        "value": "Wie Teleportation I, nur ist die Bewegungsweite unbegrenzt."
                    }
                ]
            },
            {
                "id": "8.1",
                "name": "9.2.2: Meisterschaft der Beschwörung",
                "spells": [
                    {
                        "name": "Vertrauter",
                        "level": 1,
                        "value": "Der Zauberer kann sich auf ein Tier einstimmen (von tierischer Intelligenz und nicht mehr als 10% der Masse des Zauberers), das dann als sein Vertrauter dient. Der Zauberer muß das Tier auf normalem Wege erhalten und den Spruch einmal pro Tag für eine Woche auf das Tier wirken (2 Stunden Konzentration pro Tag). Danach kann er den Vertrauten kontrollieren und durch Konzentration dessen Sinne benutzen, sofern sich der Vertraute innerhalb von 15m/Stufe befindet. Wird der Vertraute getötet, gilt für zwei Wochen auf alle Aktionen des Zauberers ein Malus von -25"
                    },
                    {
                        "name": "Beschwörung I",
                        "level": 2,
                        "value": "Der Zauberer kann umgehend ein nicht-intelligentes Wesen der 1. Stufe beschwören. Wenn die Kreatur den Zauberer verstehen kann, kann die Kreatur durch normale Kommunikation kontrolliert werden. Wenn dies nicht der Fall ist, funktioniert die Kontrolle nur durch ununterbrochene Konzentration des Zauberers. Der Zauberer kann die Art der Kreatur angeben, aber der SL bestimmt die genaue Kreatur, die der Beschwörung folgt (sie sollte in der Umgebung vorkommen). Wenn die Kreatur für eine nicht gefährliche Aufgabe (nach Einschätzung der Kreatur) eingesetzt wird, hält dieser Spruch 10 Minuten pro Stufe. Sollte die Kreatur sich jedoch in Gefahr sehen, fällt die Dauer sofort auf 1 Runde pro Stufe"
                    },
                    {
                        "name": "Begleiter",
                        "level": 3,
                        "value": "Der Zauberer kann ein semi-intelligentes Wesen zu seinem Begleiter machen. Dieser Begleiter darf nicht mehr als 50% der Masse des Zauberers haben und darf nicht intelligenter als der Zauberer sein. Die Beziehung zwischen dem Zauberer und dem Begleiter ist nicht magisch (und der Zauberer muß sich anstrengen, die Beziehung gut und freundlich zu halten, oder der Begleiter verläßt ihn). Man kann sich die Beziehung wie die von Eltern zu ihrem Kind vorstellen. Der Begleiter wird fast immer einem „Tu das nicht“-Kommando folgen (z.B. „Trink nicht diesen Trank!“), aber er kann einen WW durchführen, um einem „Tu das“-Kommando zu widerstehen (z.B. „Geh, und klau dem Huhn die Eier.“)"
                    },
                    {
                        "name": "Beschwörung II",
                        "level": 5,
                        "value": "Wie Beschwörung I, aber der Zauberer kann zusätzlich eine der folgenden Optionen auswählen: a) die Stufe der beschworenen Kreatur wird um 1 erhöht, b) eine weitere Kreatur der ersten Stufe wird beschworen, oder c) die Dauer wird verdoppelt"
                    },
                    {
                        "name": "Dämonenkontrolle I",
                        "level": 6,
                        "value": "Erlaubt es dem Zauberer, einen Dämonen von der Klasse I während der Wirkungsdauer zu kontrollieren. Beim Wirken des Spruches gibt es eine Chance von 2% pro Klasse des Dämonen, daß er die Kontrollbefehle generell ignorieren kann"
                    },
                    {
                        "name": "Beschwörung III",
                        "level": 7,
                        "value": "Wie Beschwörung II, aber 2 Optionen können gewählt werden"
                    },
                    {
                        "name": "Geringeres Dämonentor I",
                        "level": 8,
                        "value": "Der Zauberer beschwört einen Dämon, der binnen 1W10+1 Runden allmählich erscheint. Der SL sollte 1W100 (nicht offen) würfeln, um die Klasse des Dämonen zu bestimmen: 01-60: Dämon Klasse I, 61-90: Dämon Klasse II, 91-100: Dämon Klasse III. Wenn ein Dämon nicht kontrolliert wird, bevor er vollständig erschienen ist, wird er angreifen. Mehr Details dazu finden Sie in Abschnitt 5.22 (Seite 42)"
                    },
                    {
                        "name": "Beschwörung V",
                        "level": 9,
                        "value": "Wie Beschwörung II, aber 4 Optionen können gewählt werden"
                    },
                    {
                        "name": "Dämonenkontrolle II",
                        "level": 10,
                        "value": "Wie Dämonenkontrolle I, es können aber Dämonen der Klasse I und II kontrolliert werden"
                    },
                    {
                        "name": "Beschwörung X",
                        "level": 11,
                        "value": "Wie Beschwörung II, aber 9 Optionen können gewählt werden"
                    },
                    {
                        "name": "Feenvolk beschwören",
                        "level": 12,
                        "value": "Nachdem dieser Spruch gewirkt wurde, wird der Zauberer von beliebigen Landgeistern oder Hausgeistern aus der Umgebung besucht (wann genau der Besuch stattfindet ist unterschiedlich). Die beschworenen Feenwesen gleichen dem Zauberer in seiner Wesensart. Was genau bei ihrem Besuch geschieht, kann unterschiedlich sein (SL-Entscheidung)"
                    },
                    {
                        "name": "Dämonenkontrolle III",
                        "level": 13,
                        "value": "Wie Dämonenkontrolle I, es können aber Dämonen der Klasse I, II und III kontrolliert werden"
                    },
                    {
                        "name": "Wahrhaftiger Begleiter",
                        "level": 14,
                        "value": "Wie Begleiter, aber der Begleiter kann jede Größe haben"
                    },
                    {
                        "name": "Verzögerte Beschwörung",
                        "level": 15,
                        "value": "Wie Beschwörung X, nur kann die Ankunft des oder der beschworenen Kreatur(en) bis zu einem Tag pro Stufe lang verzögert werden, oder, bis sie durch eine der folgenden Bedingungen ausgelöst wird (den Auslöser legt der Zauberer fest, wenn er diesen Spruch wirkt): bestimmte Bewegungen, bestimmte Geräusche, Berührung oder andere festgelegte Aktionen. Der Zauberer kann beim Wirken eine einzelne Aufgabe festlegen, die die beschworene Kreatur(en) ausführen soll(en), wenn sie erscheint/erscheinen"
                    },
                    {
                        "name": "Meister-Beschwörung",
                        "level": 16,
                        "value": "Wie Beschwörung II, nur können 19 Optionen gewählt werden"
                    },
                    {
                        "name": "Geringeres, wartendes Tor",
                        "level": 17,
                        "value": "Wie Verzögerte Beschwörung, nur ist die Beschwörung ein Geringeres Dämonentor"
                    },
                    {
                        "name": "Mächtiges Dämonentor",
                        "level": 18,
                        "value": "Wie Geringeres Dämonentor, nur kann ein Dämon der Klasse III, IV, V oder VI beschworen werden. Würfeln Sie mit einem W 100, um die Klasse zu bestimmen: 01-60: Dämon Klasse III, 61-85: Dämon Klasse IV, 86-95: Dämon Klasse V und 96- 100: Dämon Klasse VI"
                    },
                    {
                        "name": "Dämonenkontrolle IV",
                        "level": 19,
                        "value": "Wie Dämonenkontrolle I, es können aber Dämonen der Klasse I, II, III und IV kontrolliert werden"
                    },
                    {
                        "name": "Massen-Beschwörung",
                        "level": 20,
                        "value": "Wie Beschwörung II, nur hat der Zauberer seine Stufe an Optionen zur Verfügung"
                    },
                    {
                        "name": "Dämon beherrschen II",
                        "level": 25,
                        "value": "Wie Dämonenkontrolle II, nur ist keine Konzentration notwendig. Es besteht eine Wahrscheinlichkeit von 5% pro Klasse des Dämonen, daß er nicht beherrscht werden kann"
                    },
                    {
                        "name": "Wartendes Tor",
                        "level": 30,
                        "value": "Wie Verzögerte Beschwörung, nur wirkt es wie ein Mächtiges Dämonentor"
                    },
                    {
                        "name": "Dämonenkontrolle V",
                        "level": 50,
                        "value": "Wie Dämonenkontrolle I, es können aber Dämonen der Klasse I,II, III, IV und V kontrolliert werden."
                    }
                ]
            },
            {
                "id": "8.2",
                "name": "9.2.3: Meisterschaft des Geistes",
                "spells": [
                    {
                        "name": "Schlaf V",
                        "level": 1,
                        "value": "Die Ziele fallen in einen natürlichen Schlaf. Der Zauberer kann eine Zahl von Zielen ins Reich der Träume schicken, deren Stufen zusammen 5 ergeben. Der Zauberer muß alle Ziele sehen. Beim Wirken des Spruches muß eine Zielpriorität festgelegt werden (also treffe Ziel 1, wenn Stufen übrig sind, dann treffe Ziel 2 usw.). Die ersten 2 Runden sind magischer Schlaf (das Ziel kann nicht auf normale Weise geweckt werden), danach ist es normaler Schlaf"
                    },
                    {
                        "name": "Bezaubern",
                        "level": 2,
                        "value": "Ein humanoides Ziel hält den Zauberer für einen guten Freund"
                    },
                    {
                        "name": "Schlaf VII",
                        "level": 3,
                        "value": "Wie Schlaf V, aber es können bis zu 7 Stufen betrof­fen werden"
                    },
                    {
                        "name": "Verwirren",
                        "level": 4,
                        "value": "Das Ziel ist nicht in der Lage, Entscheidungen zu treffen oder eine Handlung einzuleiten. Das Ziel kämpft aber weiter, wenn es sich bereits im Kampf befindet, und es kämpft zur Selbstverteidigung"
                    },
                    {
                        "name": "Suggestion",
                        "level": 5,
                        "value": "Das Ziel führt eine ihm suggerierte Handlung aus, sofern sie nicht im Widerspruch zu seiner Natur steht (d.h. kein Selbstmord, keine Selbstblendung usw.)"
                    },
                    {
                        "name": "Schlaf X",
                        "level": 6,
                        "value": "Wie Schlaf V, aber es können bis zu 10 Stufen betroffen werden"
                    },
                    {
                        "name": "Halten",
                        "level": 7,
                        "value": "Das humanoide Ziel hat nur 25% Aktivität pro Runde"
                    },
                    {
                        "name": "Kontrollieren",
                        "level": 8,
                        "value": "Das Ziel muß dem Zauberer während der Wirkungsdauer gehorchen. Es führt Befehle aus, sofern sie nicht im Widerspruch zu seiner Natur stehen (d.h. kein Selbstmord, keine Selbstblendung usw.)"
                    },
                    {
                        "name": "Meister-Schlaf",
                        "level": 9,
                        "value": "Wie Schlaf V, aber es können bis zu 20 Stufen betroffen werden"
                    },
                    {
                        "name": "Wahrhaftiges Bezaubern",
                        "level": 10,
                        "value": "Wie Bezaubern, es wirkt aber bei jeder denkenden Kreatur"
                    },
                    {
                        "name": "Queste",
                        "level": 11,
                        "value": "Dem Ziel wird ein Auftrag erteilt. Ein Scheitern hierin führt zu einer Strafe, die der Spielleiter festlegt (der Auftrag darf die Fähigkeiten des Ziels nicht übersteigen). Wenn das Ziel den Auftrag ignoriert, erleidet es die gleiche Strafe wie für ein Scheitern"
                    },
                    {
                        "name": "Wort der Benommenheit",
                        "level": 12,
                        "value": "[WW-Mod.: -10] Das Ziel ist pro Fehlschlag von 10 eine Runde lang benommen"
                    },
                    {
                        "name": "Wort der Pein",
                        "level": 13,
                        "value": "[WW-Mod.: -10] Wie Wort der Benommenheit, aber das Ziel erleidet bei nicht geschafftem WW 50% seiner verbleibenden Trefferpunke als Schaden 14. Wahrhaftiges Halten"
                    },
                    {
                        "name": "Wort des Schlafes",
                        "level": 15,
                        "value": "[WW-Mod.: -10] Wie Wort der Benommenheit, nur fällt das Ziel in einen natürlichen Schlaf. Die erste Minute dieses Schlafs ist magisch"
                    },
                    {
                        "name": "Wort des Haders",
                        "level": 16,
                        "value": "[WW-Mod.: -10] Wie Wort der Benommenheit, nur wird das Ziel für 1 Tag pro Fehlschlag von 10 mit niemandem zusammenarbeiten oder sich einigen können"
                    },
                    {
                        "name": "Wort des Herbeirufens",
                        "level": 17,
                        "value": "[WW-Mod.: -10] Das Ziel wird gezwungen, zum Zauberer zu kommen und sich ihm zuzuwenden. (Es kämpft sich zur Not bis dahin durch.) Wenn es dem Zauberer gegenübersteht, bleibt es 1 Runde pro Fehlschlag von 10 bewegungslos stehen. Während der Spruchdauer darf sich der Zauberer nicht bewegen, sonst erlischt der Spruch"
                    },
                    {
                        "name": "Wartendes Wort",
                        "level": 18,
                        "value": "[WW-Mod.: -10] Ein beliebiger der WortSprüche oben kann so gewirkt werden, daß er zu einem bestimmten Zeitpunkt ausgelöst wird, oder wenn sich in einem festgelegten 3mRadius etwas bewegt"
                    },
                    {
                        "name": "Wort des Todes",
                        "level": 19,
                        "value": "[WW-Mod.: -10] Das Ziel erleidet die Auswirkungen eines Kritischen Treffers der Intensität E"
                    },
                    {
                        "name": "Wahrhaftige Queste",
                        "level": 20,
                        "value": "Wie Queste, nur erleidet das Ziel fünf kritische Treffer der Intensität E, wenn es versagt (die Art der kritischen Treffer wird per Zufall bestimmt)"
                    },
                    {
                        "name": "Satz",
                        "level": 25,
                        "value": "[WW-Mod.: -10] Wie Wort der Benommenheit, nur können drei beliebige Wort-Sprüche in der gleichen Runde gewirkt werden (für jedes gilt ein eigener WW). Wenn es dreimal der gleiche Spruch ist und alle drei WW scheitern, ist die Wirkung des Wortes permanent"
                    },
                    {
                        "name": "Massen-Wort",
                        "level": 30,
                        "value": "[WW-Mod.: -10] Wie Wort der Benommenheit, nur kann jeder Wort-Spruch verwendet werden, und das Wort betrifft die Stufe des Zauberers an Zielen (Vorgehensweise wie bei Schlaf V)"
                    },
                    {
                        "name": "Meisterschaft über den Geist",
                        "level": 50,
                        "value": "Der Zauberer kann pro Runde einen Spruch dieser Liste verwenden (10. Stufe oder niedriger)."
                    }
                ]
            },
            {
                "id": "8.3",
                "name": "9.2.4: Meisterschaft der Schilde",
                "spells": [
                    {
                        "name": "Verzauberter Schild",
                        "level": 1,
                        "value": "Ein nicht-magischer, nichtmetallischer Schild wird temporär verzaubert, so daß es seinem Träger einen Bonus von +10 auf den DB gibt"
                    },
                    {
                        "name": "Schild",
                        "level": 2,
                        "value": "Richtet einen unsichtbaren Schutzschild vor dem Zauberer auf, der wie ein normales Schild wirkt (zieht 25 von den passenden Angriffen ab), aber keine Hand belegt. Dieser Spruch kann nicht mit einem echten Schild kombiniert werden"
                    },
                    {
                        "name": "Flimmern",
                        "level": 3,
                        "value": "Das Ziel erscheint Angreifern verschwommen, dies bewirkt einen Abzug von -10 auf Angriffe gegen das Ziel"
                    },
                    {
                        "name": "Verzauberte Roben",
                        "level": 4,
                        "value": "Eine Robe wird temporär verzaubert, so daß sie ihrem Träger einen Bonus von +10 auf den DB gibt"
                    },
                    {
                        "name": "Ablenken I",
                        "level": 5,
                        "value": "Der Zauberer kann jedes Schußoder Wurfgeschoß ablenken, das ihn innerhalb von 30 Metern passiert (er muß in der Lage sein, das Geschoß zu sehen). Der Angriff mit diesem Geschoß erhält dadurch einen Malus von -100"
                    },
                    {
                        "name": "Verzaubertes Leder",
                        "level": 6,
                        "value": "Eine nicht-magische Lederrüstung (normalerweise ein Wams) wird temporär verzaubert, so daß sie ihrem Träger einen Bonus von +10 auf den DB gibt"
                    },
                    {
                        "name": "Klingenabwehr I",
                        "level": 7,
                        "value": "Der Zauberer kann einen beliebigen Nahkampfangriff abwehren, sofern er ihn sieht (und er innerhalb der Reichweite stattfindet). Der Nahkampfangriff erhält dadurch einen Malus von -50"
                    },
                    {
                        "name": "Ablenken II",
                        "level": 9,
                        "value": "Wie Ablenken I, wirkt aber gegen bis zu zwei Geschosse"
                    },
                    {
                        "name": "Fehlschuß I",
                        "level": 10,
                        "value": "Der Zauberer kann jedes Schußoder Wurfgeschoß ablenken, das ihn innerhalb von 30 Metern passiert (er muß in der Lage sein, das Geschoß zu sehen). Der Angriff mit diesem Geschoß verfehlt das Ziel automatisch"
                    },
                    {
                        "name": "Klingenabwehr II",
                        "level": 11,
                        "value": "Wie Klingenabwehr I, nur kann der Spruch 2 Nahkampfangriffe betreffen"
                    },
                    {
                        "name": "Ablenken III",
                        "level": 13,
                        "value": "Wie Ablenken I, nur kann der Spruch 3 Geschosse betreffen"
                    },
                    {
                        "name": "Fehlschuß II",
                        "level": 15,
                        "value": "Wie Fehlschuß I, nur kann der Spruch 2 Geschosse betreffen"
                    },
                    {
                        "name": "Klingenabwehr III",
                        "level": 17,
                        "value": "Wie Klingenabwehr I, nur kann der Spruch 3 Nahkampfangriffe betreffen"
                    },
                    {
                        "name": "Geschoßumkehr",
                        "level": 18,
                        "value": "Ein Geschoß, das durch den Bereich von 30 Metern um den Zauberer hindurchfliegt, wird umgekehrt und greift den Schützen an. Für den Angriff gilt ein OB von +5 (es kommen keine anderen DB- oder OB-Modifikatoren hinzu)"
                    },
                    {
                        "name": "Fehlschuß III",
                        "level": 19,
                        "value": "Wie Fehlschuß I, nur kann der Spruch 3 Geschosse betreffen"
                    },
                    {
                        "name": "Massen-Ablenken",
                        "level": 20,
                        "value": "Wie Ablenken I, nur kann der Spruch die Stufe des Zauberers an Zielen betreffen"
                    },
                    {
                        "name": "Massen-Klingenabwehr",
                        "level": 25,
                        "value": "Wie Klingenabwehr I, nur kann der Spruch die Stufe des Zauberers an Angriffen betreffen"
                    },
                    {
                        "name": "Massen-Fehlschuß",
                        "level": 30,
                        "value": "Wie Massen-Ablenken, nur schlagen die Angriffe automatisch fehl"
                    },
                    {
                        "name": "Wahrhaftige Geschoßumkehr",
                        "level": 50,
                        "value": "Wie Geschoßumkehr, nur werden alle Geschoße, die den Bereich von 30m um den Zauberer durchfliegen, umgekehrt. Jedes Geschoß greift seinen Schützen mit einem OB von +20 an."
                    }
                ]
            },
            {
                "id": "8.4",
                "name": "9.2.5: Stärkung der Magie",
                "spells": [
                    {
                        "name": "Spezialeffekte",
                        "level": 1,
                        "value": "Der Zauberer kann kleinere visuelle, Geruchsoder Audioeffekte zu dem nächsten Spruch hinzufügen, den er wirkt. Die Wirkung des Spruchs wird dadurch keineswegs verändert, aber möglicherweise macht man mehr Eindruck"
                    },
                    {
                        "name": "Verlängerung II",
                        "level": 2,
                        "value": "Verdoppelt die Wirkungsdauer des nächsten vom Zauberer (innerhalb einer Minute) eingesetzten Spruchs. Die Effekte von verschiedenen Verlängerungs-Zaubern addieren sich nicht"
                    },
                    {
                        "name": "Ausweitung I",
                        "level": 4,
                        "value": "Erhöht die Reichweite des nächsten vom Zauberer (innerhalb einer Minute) eingesetzten Spruchs um 15 Meter. Die Effekte von verschiedenen Ausweitungs-Zaubern addieren sich nicht"
                    },
                    {
                        "name": "Verlängerung III",
                        "level": 5,
                        "value": "Wie Verlängerung II, aber die Dauer wird verdreifacht"
                    },
                    {
                        "name": "Sofortige Ausweitung I",
                        "level": 6,
                        "value": "Wie Ausweitung I, aber der ausgeweitete Spruch ist unverzüglich"
                    },
                    {
                        "name": "Vergrößerter Radius I",
                        "level": 7,
                        "value": "Vergrößert den Wirkungsbereich des nächsten vom Zauberer (innerhalb einer Minute) eingesetzten Spruchs um 2 Meter. Die Effekte von verschiedenen Vergrößerter Radius-Zaubern addieren sich nicht"
                    },
                    {
                        "name": "Ausweitung II",
                        "level": 8,
                        "value": "Wie Ausweitung I, aber die Reichweite erhöht sich um 30 Meter"
                    },
                    {
                        "name": "Verlängerung IV",
                        "level": 9,
                        "value": "Wie Verlängerung II, aber die Dauer wird vervierfacht"
                    },
                    {
                        "name": "Sofortige Ausweitung II",
                        "level": 10,
                        "value": "Wie Ausweitung II, aber der Spruch ist unverzüglich"
                    },
                    {
                        "name": "Vergrößerter Radius II",
                        "level": 11,
                        "value": "Wie Vergrößerter Radius I, nur vergrößert sich der Wirkungsbereich um 3m"
                    },
                    {
                        "name": "Ausweitung III",
                        "level": 12,
                        "value": "Wie Ausweitung I, aber die Reichweite erhöht sich um 60 Meter"
                    },
                    {
                        "name": "Verlängerung V",
                        "level": 13,
                        "value": "Wie Verlängerung II, aber die Dauer wird verfünffacht"
                    },
                    {
                        "name": "Sofortige Ausweitung III",
                        "level": 14,
                        "value": "Wie Sofortige Ausweitung I, aber die Reichweite erhöht sich um 60 Meter"
                    },
                    {
                        "name": "Vergrößerter Radius III",
                        "level": 15,
                        "value": "Wie Vergrößerter Radius II, nur vergrößert sich der Wirkungsbereich um 5m"
                    },
                    {
                        "name": "Ausweitung IV",
                        "level": 16,
                        "value": "Wie Ausweitung I, aber die Reichweite erhöht sich um 90 Meter"
                    },
                    {
                        "name": "Verlängerung X",
                        "level": 17,
                        "value": "Wie Verlängerung II, aber die Dauer wird verzehnfacht"
                    },
                    {
                        "name": "Sofortige Ausweitung IV",
                        "level": 18,
                        "value": "Wie Sofortige Ausweitung I, aber die Reichweite erhöht sich um 90 Meter"
                    },
                    {
                        "name": "Vergrößerter Radius IV",
                        "level": 19,
                        "value": "Wie Vergrößerter Radius II, nur vergrößert sich der Wirkungsbereich um 6m"
                    },
                    {
                        "name": "Ausweitung V",
                        "level": 20,
                        "value": "Wie Ausweitung I, aber die Reichweite erhöht sich um 150 Meter"
                    },
                    {
                        "name": "Deutliche Verlängerung",
                        "level": 25,
                        "value": "Wie Verlängerung II, aber die Dauer wird auf 12 Stunden angehoben"
                    },
                    {
                        "name": "Wahrhaftige Verlängerung",
                        "level": 30,
                        "value": "Wie Verlängerung II, aber die Dauer wird auf 24 Stunden angehoben"
                    },
                    {
                        "name": "Permanent",
                        "level": 50,
                        "value": "Wie Verlängerung II, aber die Spruchdauer wird permanent. Für jeden Zauberer kann zu jeder Zeit immer nur einen permanenter Spruch wirksam sein."
                    }
                ]
            },
            {
                "id": "8.5",
                "name": "9.2.6: Wandel von Lebendigem",
                "spells": [
                    {
                        "name": "Selbstverkleinerung",
                        "level": 1,
                        "value": "Der Zauberer kann seine Masse (und damit normalerweise auch seine Größe) um 50% verkleinern, er behält aber seine ursprüngliche Stärke"
                    },
                    {
                        "name": "Selbstvergrößerung",
                        "level": 2,
                        "value": "Der Zauberer kann seine Masse (und damit normalerweise auch seine Größe) um 50% vergrößern, seine Stärke steigt aber nicht (außer für Bewegungen)"
                    },
                    {
                        "name": "Gestalt einprägen",
                        "level": 3,
                        "value": "Gestattet dem Zauberer, die Gestalt eines anderen Lebewesens für die spätere Nutzung von Wahrhaftige Verwandlung zu studieren"
                    },
                    {
                        "name": "Volksverwandlung",
                        "level": 5,
                        "value": "Der Zauberer kann die Gestalt des Ziels in die eines anderen humanoiden Volkes verwandeln. Diese Gestalt kann nicht genau festgelegt werden, das Erscheinungsbild ist zufällig. Das Ziel kann beispielsweise die Gestalt eines Zwerges annehmen, nicht aber die des Königs der Zwerge. Dieser Spruch gibt dem Ziel nur die physische Gestalt, nicht besondere Fähigkeiten oder Volksboni (z.B. sieht das Ziel, das zu einem Zwerg wird, nicht automatisch so gut im Dunkeln wie ein Zwerg)"
                    },
                    {
                        "name": "Verkleinerung",
                        "level": 7,
                        "value": "Wie Selbstverkleinerung, aber mit einer Verkleinerung um 10% der Körpermasse des Zauberers pro Stufe (maximal um 90% der Masse des Ziels) und der Möglichkeit, diesen Spruch auf beliebiges lebendes oder ehemals lebendes Material zu wirken"
                    },
                    {
                        "name": "Vergrößerung",
                        "level": 10,
                        "value": "Wie Verkleinerung, aber mit Vergrößerung um 10% der Körpermasse des Zauberers pro Stufe"
                    },
                    {
                        "name": "Verwandlung",
                        "level": 11,
                        "value": "Wie Volksverwandlung, aber dem Ziel kann eine beliebige organische Gestalt gegeben werden, solange deren Masse zwischen 50% und 200% seiner eigenen liegt. Das Ziel erhält keine besonderen Fähigkeiten durch die Verwandlung"
                    },
                    {
                        "name": "Wahrhaftige Verwandlung",
                        "level": 13,
                        "value": "Wie Verwandlung, nur kann die Gestalt die eines bestimmten Wesens sein, das vorher mittels Gestalt einprägen studiert wurde"
                    },
                    {
                        "name": "Steter Wandel",
                        "level": 15,
                        "value": "Wie Wahrhaftige Verwandlung, nur kann der Zauberer jederzeit während der Spruchdauer eine andere Gestalt annehmen, indem er sich pro Verwandlung eine Runde konzentriert"
                    },
                    {
                        "name": "Verschmelzen",
                        "level": 17,
                        "value": "Das Ziel kann mit beliebigem festen, unbelebten Material verschmelzen. Wenn es verschmolzen ist, kann das Ziel sich weder bewegen noch nimmt es etwa wahr. Wenn es das Material verläßt, kann es auf jeder Seite davon heraustreten. Das Ziel kann sich nicht durch Material hindurchbewegen, das tiefer ist als sein eigener Körper plus 60 cm. Der Zauberer kann bis zu einer Stunde pro Stufe in dem Material bleiben und herauskommen, wann er will. Alle anderen müssen nach Ablauf einer gesetzten First wieder hervorkommen (der Zauberer legt die Frist fest, wenn der den Spruch wirkt"
                    },
                    {
                        "name": "Unverwundbarkeit",
                        "level": 19,
                        "value": "Alle kritischen Treffer gegen das Ziel werden um eine Intensitätsstufe gesenkt (ein Kritischer Treffer der Intensität A wird als A-Treffer behandelt aber mit einem Abzug von -20)"
                    },
                    {
                        "name": "Durchdringen",
                        "level": 20,
                        "value": "Das Ziel kann sich durch alles unbelebte Material mit einer Dicke von bis zu 50cm pro Stufe bewegen. Es braucht je eine Minute für 1m"
                    },
                    {
                        "name": "Massen-Vergrößerung",
                        "level": 25,
                        "value": "Wie Vergrößerung, nur werden die Stufe des Zauberers an Zielen um bis zu 50% der Masse des Zauberers vergrößert. Für alle Ziele gilt der gleiche Prozentsatz"
                    },
                    {
                        "name": "Massen-Verwandlung",
                        "level": 30,
                        "value": "Wie Verwandlung, nur kann der Spruch eine Anzahl von Zielen bis zu der Stufe des Zauberers verwandeln. Alle Ziele müssen die gleiche Gestalt annehmen"
                    },
                    {
                        "name": "Massen-Verschmelzen",
                        "level": 50,
                        "value": "Wie Verschmelzen, nur sind bis zu der Stufe des Zauberers an Zielen betroffen. Alle Ziele müssen nach einer festgelegten Frist wieder hervorkommen. Wenn der Zauberer selbst auch eines der Ziele ist, kann er zu einem beliebigen Zeitpunkt herauskommen, und alle anderen Ziele schließen sich an. Besondere Anmerkungen In Abschnitt 5.20 (S. 42) finden Sie mehr darüber, welche Fertigkeiten erlangt/ beibehalten werden, wenn eine neue Gestalt angenommen wird."
                    }
                ]
            },
            {
                "id": "8.6",
                "name": "9.2.7: Wege der Bannung",
                "spells": [
                    {
                        "name": "Essenz aufheben I",
                        "level": 1,
                        "value": "Wenn der Zauberer Ziel eines Spruches aus dem Bereich Essenz wird, muß dieser „ankommende“ Spruch vor dem Zauberer einen WW durchführen. Dabei benutzt der Spruch als Stufe die desjenigen, der ihn gewirkt hat. Wenn der „ankommende“ Spruch diesen WW besteht, betrifft er den Zauberer von Essenz aufheben normal (der Zauberer hat dann noch seinen normalen WW). Wenn nicht, betrifft er den Zauberer nicht"
                    },
                    {
                        "name": "Mentalismus aufheben I",
                        "level": 2,
                        "value": "Wie Essenz aufheben I, betrifft aber Sprüche aus dem Bereich Mentalismus"
                    },
                    {
                        "name": "Leitmagie aufheben I",
                        "level": 3,
                        "value": "Wie Essenz aufheben I, betrifft aber Sprüche aus dem Bereich Leitmagie"
                    },
                    {
                        "name": "Essenz bannen I",
                        "level": 4,
                        "value": "Jeder aktive Spruch aus dem Bereich Essenz, der auf dem Ziel liegt, muß einen WW durchführen (verwenden Sie dazu als Stufe des Spruches die des ursprünglich ihn wirkenden Zauberers). Wenn der Spruch seinen WW nicht schafft, erlischt er umgehend"
                    },
                    {
                        "name": "Mentalismus bannen I",
                        "level": 5,
                        "value": "Wie Essenz bannen I, betrifft aber Sprüche aus dem Bereich Mentalismus"
                    },
                    {
                        "name": "Leitmagie bannen I",
                        "level": 6,
                        "value": "Wie Essenz bannen I, betrifft aber Sprüche aus dem Bereich Leitmagie"
                    },
                    {
                        "name": "Nullsphäre Essenz I",
                        "level": 7,
                        "value": "Wie Essenz aufheben I, bis auf den Wirkungsbereich (zentriert auf den Zauberer). Wenn der Radius auf einen bereits existierenden Essenz-Spruch trifft, muß dieser Spruch einen WW mit +30 schaffen, anderenfalls wird er so lange aufgehoben (nicht gebannt, quasi abgeschaltet), wie er sich innerhalb des Radius befindet"
                    },
                    {
                        "name": "Nullsphäre Mentalismus I",
                        "level": 8,
                        "value": "Wie Nullsphäre Essenz I, betrifft aber Sprüche aus dem Bereich Mentalismus"
                    },
                    {
                        "name": "Nullsphäre Leitmagie I",
                        "level": 9,
                        "value": "Wie Nullsphäre Essenz I, betrifft aber Sprüche aus dem Bereich Leitmagie"
                    },
                    {
                        "name": "Nullsphäre Essenz V",
                        "level": 10,
                        "value": "Wie Nullsphäre Essenz I, aber der Radius ist 15 Meter"
                    },
                    {
                        "name": "Nullsphäre Mentalismus V",
                        "level": 11,
                        "value": "Wie Nullsphäre Mentalismus I, aber der Radius ist 15 Meter"
                    },
                    {
                        "name": "Nullsphäre Leitmagie V",
                        "level": 12,
                        "value": "Wie Nullsphäre Leitmagie I, aber der Radius ist 15 Meter"
                    },
                    {
                        "name": "Nullsphäre Essenz X",
                        "level": 14,
                        "value": "Wie Nullsphäre Essenz I, aber der Radius ist 30 Meter"
                    },
                    {
                        "name": "Nullsphäre Mentalismus X",
                        "level": 15,
                        "value": "Wie Nullsphäre Mentalismus I, aber der Radius ist 30 Meter 16. Nullsphäre Leitmagie X"
                    },
                    {
                        "name": "Essenz versagen",
                        "level": 17,
                        "value": "Das Ziel hat 24 Stunden lang keine Essenzmagiepunkte mehr und kann daher keine Essenzsprüche wirken (auch nicht über Bonusgegenstände). Der Spruch kann auch auf Gegenstände angewandt werden, die normalerweise Sprüche wirken können. Dualmagiekundige, deren einer Magiebereich Essenz ist, haben nur noch die Hälfte ihrer Magiepunkte zur Verfügung"
                    },
                    {
                        "name": "Mentalismus versagen",
                        "level": 18,
                        "value": "Wie Essenz versagen, nur ist der Magiebereich Mentalismus betroffen"
                    },
                    {
                        "name": "Leitmagie versagen",
                        "level": 19,
                        "value": "Wie Leitmagie versagen, nur ist der Magiebereich Leitmagie betroffen"
                    },
                    {
                        "name": "Wahrhaftige Aufheben",
                        "level": 20,
                        "value": "Wie Essenz aufheben, nur sind alle drei Magiebereiche betroffen"
                    },
                    {
                        "name": "Wahrhaftiger Essenzbann",
                        "level": 25,
                        "value": "Wie Essenz bannen, nur ist der Radius 100m"
                    },
                    {
                        "name": "Wahrhaftiger Bann",
                        "level": 30,
                        "value": "Wie Essenz bannen, aber alle drei Magiebereiche sind betroffen"
                    },
                    {
                        "name": "Wahrhaftige Nullsphäre",
                        "level": 50,
                        "value": "Wie Nullsphäre Essenz V, nur sind alle 3 Magiebereiche betroffen."
                    }
                ]
            },
            {
                "id": "8.7",
                "name": "9.2.8: Wege der Geschwindigkeit",
                "spells": [
                    {
                        "name": "Laufen I",
                        "level": 1,
                        "value": "Das Ziel kann laufen (doppelte Gehgeschwindigkeit) und verliert dabei Erschöpfungspunkte, als ob es nur gehen würde. Wenn das Ziel einmal das Laufen beendet oder eine andere Aktion durchführt, endet dieser Spruch sofort"
                    },
                    {
                        "name": "Schnelligkeit I",
                        "level": 2,
                        "value": "Das Ziel kann das Doppelte der normalen Handlungen ausführen (hat also 200% Aktivität pro Runde), es muß aber direkt im Anschluß eine Runde pro beschleunigter Runde mit der Hälfte auskommen (Erholungsrunden, 50% Aktivität)"
                    },
                    {
                        "name": "Schnell lesen",
                        "level": 3,
                        "value": "Das Ziel kann 10 Seiten pro Minute lesen und verstehen (sofern es die Sprache beherrscht)"
                    },
                    {
                        "name": "Schnelligkeit II",
                        "level": 4,
                        "value": "Wie Schnelligkeit I, aber die Dauer ist 2 Runden für ein Ziel oder 1 Runde für zwei Ziele"
                    },
                    {
                        "name": "Sprint I",
                        "level": 5,
                        "value": "Wie Laufen I, aber das Ziel kann sich dreimal so schnell bewegen (also sprinten)"
                    },
                    {
                        "name": "Blitzschnell I",
                        "level": 6,
                        "value": "Das Ziel kann das Doppelte der normalen Handlungen ausführen (hat also 200% Aktivität pro Runde), eine Erholungsrunde wird nicht fällig"
                    },
                    {
                        "name": "Schnelligkeit III",
                        "level": 7,
                        "value": "Wie Schnelligkeit I, aber es können 3 Runden zwischen ein bis drei Zielen aufgeteilt werden (in jeder beliebigen Kombination)"
                    },
                    {
                        "name": "Blitzschnell II",
                        "level": 8,
                        "value": "Wie Blitzschnell I, aber die Dauer ist 2 Runden für ein Ziel oder 1 Runde für zwei Ziele"
                    },
                    {
                        "name": "Schneller Sprint",
                        "level": 9,
                        "value": "Wie Laufen I, aber das Ziel kann sich viermal so schnell bewegen (also schnell sprinten)"
                    },
                    {
                        "name": "Schnelligkeit V",
                        "level": 10,
                        "value": "Wie Schnelligkeit I, aber es können 5 Runden zwischen ein bis fünf Zielen aufgeteilt werden (in jeder beliebigen Kombination)"
                    },
                    {
                        "name": "Laufen III",
                        "level": 11,
                        "value": "Wie Laufen I, nur kann der Spruch 3 Ziele betreffen"
                    },
                    {
                        "name": "Blitzschnell III",
                        "level": 12,
                        "value": "Wie Blitzschnell I, aber die Dauer von 3 Runden kann auf ein bis drei Ziele aufgeteilt werden (in jeder beliebigen Kombination)"
                    },
                    {
                        "name": "Sprint III",
                        "level": 14,
                        "value": "Wie Sprint I, nur kann der Spruch 3 Ziele betreffen"
                    },
                    {
                        "name": "Blitzschnell V",
                        "level": 15,
                        "value": "Wie Blitzschnell I, aber die Dauer von 5 Runden kann auf ein bis fünf Ziele aufgeteilt werden (in jeder beliebigen Kombination)"
                    },
                    {
                        "name": "Laufen V",
                        "level": 16,
                        "value": "Wie Laufen I, nur kann der Spruch 5 Ziele betreffen"
                    },
                    {
                        "name": "Schnelligkeit X",
                        "level": 17,
                        "value": "Wie Schnelligkeit I, aber die Dauer von 10 Runden kann zwischen ein bis zehn Zielen aufgeteilt werden (in jeder beliebigen Kombination)"
                    },
                    {
                        "name": "Sprint V",
                        "level": 18,
                        "value": "Wie Sprint I, nur kann der Spruch 5 Ziele betreffen"
                    },
                    {
                        "name": "Blitzschnell X",
                        "level": 20,
                        "value": "Wie Blitzschnell I, aber die Dauer von 10 Runden kann auf ein bis 10 Ziele aufgeteilt werden (in jeder beliebigen Kombination)"
                    },
                    {
                        "name": "Massen-Laufen",
                        "level": 25,
                        "value": "Wie Laufen I, nur kann der Spruch die Stufe des Zauberers an Zielen betreffen"
                    },
                    {
                        "name": "Massen-Schnelligkeit",
                        "level": 30,
                        "value": "Wie Schnelligkeit I, nur entspricht die Dauer insgesamt der Stufe des Zauberers in Runden und sie kann maximal auf seine Stufe an Zielen aufgeteilt werden (in jeder beliebigen Kombination)"
                    },
                    {
                        "name": "Massen-Blitzschnell",
                        "level": 50,
                        "value": "Wie Blitzschnell I, nur entspricht die Dauer insgesamt der Stufe des Zauberers in Runden und sie kann maximal auf seine Stufe an Zielen aufgeteilt werden (in jeder beliebigen Kombination)."
                    }
                ]
            },
            {
                "id": "8.8",
                "name": "9.2.9: Wege der Unsichtbarkeit",
                "spells": [
                    {
                        "name": "Transparenz I",
                        "level": 2,
                        "value": "Ein einzelnes Objekt wird unsichtbar (1 Gewand, 1 nackter Körper usw.), bis entweder 24 Stunden verstrichen sind, oder bis das Ziel von einem harten Schlag getroffen wird (von einer Waffe getroffen wird, Sturz usw.), oder bis das Ziel eine gewalttätige Handlung ausführt (z.B. einen Angriff )"
                    },
                    {
                        "name": "Unsichtbarkeit I",
                        "level": 4,
                        "value": "Wie Transparenz I, aber alles in 30cm Umkreis um das Ziel ist unsichtbar, solange es sich vollständig in diesem Radius aufhält und keine der unter Transparenz I genannten Abbruchbedingungen eintritt"
                    },
                    {
                        "name": "Unsichtbarkeit II",
                        "level": 6,
                        "value": "Wie Unsichtbarkeit I, aber der Radius kann von 0 bis zu 30cm variieren (wird beim Wirken festgelegt). Dadurch kann das unsichtbare Ziel schwieriger zu erkennen sein"
                    },
                    {
                        "name": "Unsichtbarkeitssphäre I",
                        "level": 8,
                        "value": "Wie Unsichtbarkeit I, aber der Radius ist 3 Meter"
                    },
                    {
                        "name": "Transparenz III",
                        "level": 10,
                        "value": "Wie Transparenz I, es können aber 3 Objekte betroffen werden"
                    },
                    {
                        "name": "Unsichtbarkeitssphäre II",
                        "level": 11,
                        "value": "Wie Unsichtbarkeitssphäre I, nur kann der Radius bis zu 3m groß sein (wird beim Wirken festgelegt)"
                    },
                    {
                        "name": "Transparenz V",
                        "level": 13,
                        "value": "Wie Transparenz I, nur können 5 Objekte betroffen sein"
                    },
                    {
                        "name": "Aufgeilte Unsichtbarkeit",
                        "level": 15,
                        "value": "Wie Unsichtbarkeit I, nur können zwei voneinander unabhängige Ziele betroffen werden (mit je einem eigenen Unsichtbarkeitsradius)"
                    },
                    {
                        "name": "Transparenz X",
                        "level": 17,
                        "value": "Wie Transparenz I, nur können 10 Objekte betroffen sein"
                    },
                    {
                        "name": "Aufgeteilte Unsichtbarkeitssphäre",
                        "level": 18,
                        "value": "Wie Unsichtbarkeitssphäre I, nur können zwei voneinander unabhängige Ziele betroffen werden, und die beiden Radien können je bis zu 3m groß sein (wird beim Wirken festgelegt)"
                    },
                    {
                        "name": "Unsichtbarkeitssphäre III",
                        "level": 20,
                        "value": "Wie Unsichtbarkeit I, aber der Radius kann bis zu 6m groß sein (wird beim Wirken festgelegt)"
                    },
                    {
                        "name": "Massen-Transparenz",
                        "level": 25,
                        "value": "Wie Transparenz I, nur kann der Spruch die Stufe des Zauberers an Objekten betreffen"
                    },
                    {
                        "name": "Massen-Unsichtbarkeit",
                        "level": 30,
                        "value": "Wie Unsichtbarkeit I, nur kann der Spruch die Stufe des Zauberers an Zielen betreffen. Jedes Ziel hat seinen eigenen Unsichtbarkeitsradius"
                    },
                    {
                        "name": "Wahrhaftige Unsichtbarkeit",
                        "level": 50,
                        "value": "Wie Unsichtbarkeit II, aber nur der Zauberer ist betroffen. Wenn er angreift, wird er nur in der Runde direkt nach dem Angriff sichtbar. Harte Schläge heben diese Unsichtbarkeit nicht auf."
                    }
                ]
            },
            {
                "id": "8.9",
                "name": "9.2.10: Zügel der Magie",
                "spells": [
                    {
                        "name": "Spruchspeicher",
                        "level": 1,
                        "value": "Der Zauberer kann diesen Spruch auf jeden Spruch anwenden, den er speichern möchte. Der zu speichernde Spruch muß innerhalb einer Minute gewirkt werden, nachdem der Spruchspeicher gewirkt wurde. Der gespeicherte Spruch kann dann später als ein unverzüglicher Spruch ausgelöst werden. Der Spruchspeicher-Spruch kostet dieselbe Anzahl an Magiepunkten, wie der zu speichernde Spruch. Während sich ein Spruch im Speicher befindet, kann kein anderer Spruch gewirkt werden"
                    },
                    {
                        "name": "Wirken identifizieren",
                        "level": 2,
                        "value": "Wenn das Ziel dieses Spruchs in diesem Moment einen Spruch wirkt, erfährt der Zauberer den Magiebereich und die Spruchklasse"
                    },
                    {
                        "name": "Verzögerter Zauber I",
                        "level": 3,
                        "value": "Dieser Spruch attackiert einen anderen Angriffsspruch, welcher einen WW machen muß (indem er die Stufe seines Zauberers als seine Stufe benutzt). Wenn der WW erfolgreich ist, greift er sein Originalziel wie beabsichtigt an, anderenfalls wird der Spruch um eine Runde verschoben. Wenn das Ziel des so verzögerten Spruches sich um mehr als 6 Meter inzwischen bewegt hat, greift der verzögerte Spruch ein zufällig bestimmtes Ziel innerhalb von 3 Metern um den Original-Zielpunkt an. Sollte kein mögliches Ziel mehr da sein, verpufft der Spruch ohne Wirkung. Wenn er nun nicht auf das Originalziel wirkt, erhält ein BasisSpruchangriff einen Malus von -20 und ein elementarer Angriffsspruch -30"
                    },
                    {
                        "name": "Spruchablenkung I",
                        "level": 5,
                        "value": "Der Zauberer kann einen elementaren Angriffsspruch ablenken. Dieser Spruch macht einen WW (indem er die Stufe seines Zauberers als seine Stufe benutzt). Wenn der WW erfolgreich ist, greift er sein Originalziel wie beabsichtigt an, anderenfalls wird der Angriffswurf mit -10 pro 10 Fehlschlag modifiziert"
                    },
                    {
                        "name": "Verzögerter Zauber II",
                        "level": 6,
                        "value": "Wie Verzögerter Zauber I, der Angriffsspruch kann aber um bis zu zwei Runden aufgehalten werden"
                    },
                    {
                        "name": "Spruchablenkung II",
                        "level": 8,
                        "value": "Wie Spruchablenkung I, aber der Angriffswurf wird mit -20 pro 10 Fehlschlag modifiziert"
                    },
                    {
                        "name": "Verzögerter Zauber III",
                        "level": 9,
                        "value": "Wie Verzögerter Zauber I, der Angriffsspruch kann aber um bis zu drei Runden aufgehalten werden"
                    },
                    {
                        "name": "Spruchreflexion I",
                        "level": 10,
                        "value": "Der anvisierte elementare Angriffsspruch muß einen WW durchführen (indem er die Stufe seines Zauberers als seine Stufe benutzt) mit +20 zu seinen Gunsten. Wenn der WW erfolgreich ist, greift er sein Originalziel wie beabsichtigt an, anderenfalls wird der Spruch auf seinen Zauberer zurückgeworfen und greift ihn mit +0 OB an"
                    },
                    {
                        "name": "Spruchablenkung III",
                        "level": 11,
                        "value": "Wie Spruchablenkung I, aber der Angriffswurf wird mit -30 pro 10 Fehlschlag modifiziert"
                    },
                    {
                        "name": "Verzögerter Zauber IV",
                        "level": 12,
                        "value": "Wie Verzögerter Zauber I, der Angriffsspruch kann aber um bis zu 4 Runden aufgehalten werden"
                    },
                    {
                        "name": "Entliehene Macht",
                        "level": 13,
                        "value": "Der Zauberer kann sich Magiepunkte aus den kommenden Tagen borgen. Wenn dieser Spruch gewirkt wird, erhält der Zauberer alle seine Magiepunkte (bis zum Maximum) zurück. Auch die Magiepunktkosten für diesen Spruch können daraus bestritten werden. Jedesmal, wenn ein Zauberer diesen Spruch wirkt, verliert er an den beiden folgenden Tagen (der normalen Dauer dieses Spruchs) alle Magiepunkte. Außerdem erleidet er 10% seiner maximalen Trefferpunkte an Schaden. Zusätzlich wirkt er während der Spruchdauer alle Sprüche so, als hätte er eine Stufe weniger. Dieser Spruch kann mehrmals gewirkt werden (und die Magiepunkte vieler künftiger Tage ausleihen), aber die Wirkung ist kumulativ. Beispielsweise würde ein Zauberer alle MP für 4 Tage verlieren und Sprüche wirken, als hätte er 2 Stufen weniger, wenn er diesen Spruch zweimal wirkt. Alle Abzüge bleiben, bis die Spruchdauer abgelaufen ist. Am Ende der Spruchdauer muß der Zauberer für jedes Mal, daß er diesen Spruch wirkte, 10 zusammenhängende Stunden lang schlafen"
                    },
                    {
                        "name": "Spruchablenkung IV",
                        "level": 14,
                        "value": "Wie Spruchablenkung I, aber der Angriffswurf wird mit -40 pro 10 Fehlschlag modifiziert"
                    },
                    {
                        "name": "Verzögerter Zauber V",
                        "level": 15,
                        "value": "Wie Verzögerter Zauber I, der Angriffsspruch kann aber um bis zu 5 Runden aufgehalten werden"
                    },
                    {
                        "name": "Spruchreflexion II",
                        "level": 16,
                        "value": "Wie Spruchreflexion I, nur ist der OB für den umgedrehten Spruch die Hälfte seines ursprünglichen"
                    },
                    {
                        "name": "Spruchablenkung V",
                        "level": 17,
                        "value": "Wie Spruchablenkung I, aber der Angriffswurf wird mit -50 pro 10 Fehlschlag modifiziert"
                    },
                    {
                        "name": "Verzögerter Zauber X",
                        "level": 18,
                        "value": "Wie Verzögerter Zauber I, der Angriffsspruch kann aber um bis zu 10 Runden aufgehalten werden"
                    },
                    {
                        "name": "Meister-Zauberverzögerung",
                        "level": 20,
                        "value": "Wie Verzögerter Zauber I, der Angriffsspruch kann aber um bis zu 20 Runden aufgehalten werden"
                    },
                    {
                        "name": "Wahrhaftige Spruchablenkung",
                        "level": 25,
                        "value": "Wie Spruchablenkung I, nur kann der Spruch um bis zu 90° in eine beliebige Richtung umgelenkt werden (der Zauberer dieses Ablenkungsspruchs kann ein neues Ziel angeben, das dann mit der Hälfte des ursprünglichen OB des Angriffsspruchs angegriffen wird)"
                    },
                    {
                        "name": "Wahrhaftige Zauberverzögerung",
                        "level": 30,
                        "value": "Wie Verzögerter Zauber I, der Angriffsspruch kann aber um bis zu 1 Runde pro Stufe aufgehalten werden"
                    },
                    {
                        "name": "Wahrhaftige Spruchreflexion",
                        "level": 50,
                        "value": "Wie Spruchreflexion I, nur werden alle Sprüche innerhalb eines Radius von 30m um den Zauberer zurückgeworfen."
                    }
                ]
            }
        ]
    },
    {
        "id": "9",
        "name": "Basisliste Illusionist",
        "spellLists": [
            {
                "id": "9.0",
                "name": "9.3.1: Geist und Sinne formen",
                "spells": [
                    {
                        "name": "Illusion entdecken",
                        "level": 1,
                        "value": "Der Zauberer kann einen Gegenstand oder Ort (bis zu einem Radius von 2m) überprüfen und feststellen, ob er eine Illusion ist oder ob er mit einer belegt wurde"
                    },
                    {
                        "name": "Unsichtbares entdecken",
                        "level": 2,
                        "value": "Entdeckt alle unsichtbaren Gegenstände oder Wesen innerhalb des Wirkungsbereichs. Der Zauberer kann sich in jeder Runde auf einen neuen 2m-Radius konzentrieren. Alle Angriffe gegen etwas so Entdecktes sind mit -50 modifiziert. In Abschnitt 5.5 (Seite 37) finden Sie Regeln zur Unsichtbarkeit"
                    },
                    {
                        "name": "Volk kaschieren",
                        "level": 3,
                        "value": "Im Bezug auf geistige oder magische Erkennung erscheint das Ziel als Angehöriger des Volks, das der Zauberer wählt"
                    },
                    {
                        "name": "Macht kaschieren I",
                        "level": 4,
                        "value": "Wie Volk kaschieren, nur wird die Stufe des Ziels als um eine Stufe (höher oder niedriger) dargestellt"
                    },
                    {
                        "name": "Trugbild Präsenz",
                        "level": 5,
                        "value": "Erschafft im Bezug auf Entdeckungsmagie eine falsche Präsenz im Wirkungsbereich"
                    },
                    {
                        "name": "Beruf kaschieren I",
                        "level": 6,
                        "value": "Wie Volk kaschieren, nur kann der Beruf des Ziels falsch dargestellt werden"
                    },
                    {
                        "name": "Macht kaschieren III",
                        "level": 7,
                        "value": "Wie Macht kaschieren I, nur kann die Stufe als um 3 niedriger oder höher dargestellt werden"
                    },
                    {
                        "name": "Machtausstrahlung mindern",
                        "level": 9,
                        "value": "Wie Macht kaschieren I, nur kann die Machtausstrahlung eines Gegenstandes so verringert werden, daß die Macht schwächerer Gegenstände verborgen bleibt und starke Gegenstände als schwache erscheinen (bezogen auf Sprüche wie Essenz entdecken, Macht erkennen, Leitmagie entdecken)"
                    },
                    {
                        "name": "Macht kaschieren V",
                        "level": 10,
                        "value": "Wie Macht kaschieren I, nur kann die Stufe als um 5 niedriger oder höher dargestellt werden"
                    },
                    {
                        "name": "Desillusion I",
                        "level": 11,
                        "value": "Eine Illusion im Wirkungsbereich verschwindet (nur für den Zauberer)"
                    },
                    {
                        "name": "Wahrhaftige Illusionsentdeckung",
                        "level": 12,
                        "value": "Wie Illusion entdecken I, nur kann sich der Zauberer in jeder Runde auf einen anderen Gegenstand oder Ort konzentrieren"
                    },
                    {
                        "name": "Macht kaschieren X",
                        "level": 13,
                        "value": "Wie Macht kaschieren I, nur kann die Stufe als um 10 niedriger oder höher dargestellt werden"
                    },
                    {
                        "name": "Desillusion III",
                        "level": 14,
                        "value": "Wie Desillusion I, nur verschwinden bis zu drei Illusionen im Wirkungsbereich"
                    },
                    {
                        "name": "Kaschieren",
                        "level": 15,
                        "value": "Versieht ein Ziel mit allen niedrigstufigen Kaschieren-Sprüche gleichzeitig (aber nur mit einem der Macht kaschieren-Sprüche)"
                    },
                    {
                        "name": "Präsenz aufheben I",
                        "level": 16,
                        "value": "Wie Volk kaschieren, nur wirkt das Ziel, als hätte es keine Präsenz"
                    },
                    {
                        "name": "Desillusion V",
                        "level": 17,
                        "value": "Wie Desillusion I, nur schwinden bis zu fünf Illusionen im Wirkungsbereich"
                    },
                    {
                        "name": "Präsenz aufheben III",
                        "level": 18,
                        "value": "Wie Präsenz aufheben I, nur betrifft der Spruch bis zu drei Ziele"
                    },
                    {
                        "name": "Wahrhaftige Desillusion",
                        "level": 19,
                        "value": "Wie Desillusion I, nur verschwinden alle Illusionen im Wirkungsbereich"
                    },
                    {
                        "name": "Präsenz aufheben III",
                        "level": 20,
                        "value": "Wie Präsenz aufheben I, nur betrifft der Spruch bis zu drei Ziele"
                    },
                    {
                        "name": "Wahrhaftiges Kaschieren",
                        "level": 25,
                        "value": "Wie Kaschieren, bis auf die Spruchdauer"
                    },
                    {
                        "name": "Meister-Präsenz aufheben",
                        "level": 30,
                        "value": "Wie Präsenz aufheben I, nur kann der Spruch bis zu 20 Ziele betreffen"
                    },
                    {
                        "name": "Massen-Kaschieren",
                        "level": 50,
                        "value": "Wie Kaschieren, nur kann der Spruch die Stufe des Zauberers an Zielen betreffen."
                    }
                ]
            },
            {
                "id": "9.1",
                "name": "9.3.2: Licht formen",
                "spells": [
                    {
                        "name": "Trugbild Licht",
                        "level": 1,
                        "value": "Erzeugt ein einfaches, unbewegliches Trugbild oder eine Kulisse mit einem Radius von bis zu 3 Metern"
                    },
                    {
                        "name": "Lichtstrahl",
                        "level": 2,
                        "value": "Aus der Handfläche des Zauberers entspringt ein Lichtkegel (wie der einer Taschenlampe) mit einer effektiven Reichweite von 15 Meter. Wenn der Zauberer seine Hand zur Faust ballt, schaltet er das Licht „aus“. Öffnet er sie wieder, ist das Licht wieder da (sofern die Dauer noch nicht abgelaufen ist)"
                    },
                    {
                        "name": "Licht kontrollieren I",
                        "level": 3,
                        "value": "Der Zauberer kann die Intensität des Lichts im Wirkungsbereich kontrollieren. Sie kann zwischen Taghelle und Dunkelheit (natürliche) reichen und auch in verschiedenen Bereichen des Radius unterschiedlich sein"
                    },
                    {
                        "name": "Lichtblitz",
                        "level": 4,
                        "value": "Verursacht einen grellen Lichtblitz mit einem Radius von 3 Metern. Alle innerhalb des Radius sind pro Fehlschlag von 5 eine Runde lang benommen"
                    },
                    {
                        "name": "Schockstrahl I",
                        "level": 5,
                        "value": "Ein Strahl intensiven, geladenen Lichts schießt aus der Handfläche des Zauberers hervor. Das Ergebnis wird auf der Schockstrahl-Angriffstabelle ausgewürfelt"
                    },
                    {
                        "name": "Mirakel Licht",
                        "level": 6,
                        "value": "Verändert das sichtbare Erscheinungsbild eines Objektes. Das Ziel darf nicht mehr Masse als 5kg pro Stufe haben. Beachten Sie, daß sich kein anderer Aspekt verändert"
                    },
                    {
                        "name": "Blind",
                        "level": 9,
                        "value": "Erschafft einen dunklen Bereich um den Kopf des Ziels, der ihn blind macht. Er kann mit Purem Licht aufgehoben werden. Der Wirkungsbereich bewegt sich mit dem Ziel mit"
                    },
                    {
                        "name": "Licht kontrollieren V",
                        "level": 10,
                        "value": "Wie Licht kontrollieren I, nur ist der Wirkungsbereich ein Radius von 15 Metern"
                    },
                    {
                        "name": "Pures Licht",
                        "level": 11,
                        "value": "Hebt alle magische Dunkelheit in einem 30mRadius auf und erhellt den Wirkungsbereich taghell"
                    },
                    {
                        "name": "Lichtgelände",
                        "level": 12,
                        "value": "Das gesamte Gelände um Wirkungsbereich erscheint anders als es tatsächlich ist. Der Zauberer kann festlegen, inwiefern es anders wirkt. Beispielsweise könnte einige kleine Bäumchen aussehen wie hohe Bäume. Beachten Sie, daß nur sichtbare Aspekte des Geländes sich verändern"
                    },
                    {
                        "name": "Signallicht I",
                        "level": 13,
                        "value": "Ein Lichtstrahl (beliebiger Farbe) entspringt der Handfläche des Zauberers. Der Strahl kann bis zu 2 km lang sein"
                    },
                    {
                        "name": "Pure Dunkelheit",
                        "level": 14,
                        "value": "Verdunkelt einen 30m-Radius. Kein nichtmagisches Licht kann diese Dunkelheit durchdringen, und magisches Licht (außer Pures Licht) muß einen WW bestehen"
                    },
                    {
                        "name": "Licht kontrollieren X",
                        "level": 15,
                        "value": "Wie Licht kontrollieren I, nur ist der Wirkungsbereich ein Radius von 30 Metern"
                    },
                    {
                        "name": "Schockstrahl III",
                        "level": 16,
                        "value": "Wie Schockstrahl I, nur hat der Spruch eine Reichweite von 100 Metern"
                    },
                    {
                        "name": "Signallicht V",
                        "level": 18,
                        "value": "Wie Signallicht I, nur kann der Strahl bis zu 8 km lang sein"
                    },
                    {
                        "name": "Blitzschlag I",
                        "level": 20,
                        "value": "Wie Schockstrahl, nur wird ein Blitzschlag abgeschossen. Der Angriff wird auf der Blitzschlagtabelle abgehandelt"
                    },
                    {
                        "name": "Weitgehende Lichtkontrolle",
                        "level": 25,
                        "value": "Wie Licht kontrollieren I, nur ist der Wirkungsbereich ein 150m-Radius"
                    },
                    {
                        "name": "Blitzschlag III",
                        "level": 30,
                        "value": "Wie Blitzschlag I, nur hat der Spruch eine Reichweite von 100 Metern"
                    },
                    {
                        "name": "Wahrhaftige Lichtkontrolle",
                        "level": 50,
                        "value": "Wie Licht kontrollieren I, nur hat der Spruch einen Wirkungsbereich von 30 Metern Radius pro Stufe."
                    }
                ]
            },
            {
                "id": "9.2",
                "name": "9.3.3: Meisterschaft der Illusion",
                "spells": [
                    {
                        "name": "Illusion II",
                        "level": 1,
                        "value": "Erzeugt ein einfaches, unbewegliches Trugbild oder eine Kulisse im Wirkungsbereich. Eine der folgenden Optionen kann zusätzlich mit ausgewählt werden: a) ein zusätzlicher Sinn kann hinzugefügt werden (der entsprechende Trugbild-Spruch muß bekannt sein), b) die Dauer kann verdoppelt werden, c) die Reichweite kann verdoppelt werden, oder d) der Radius des Wirkungsbereiches kann verdoppelt werden. Alle Teile des Wirkungsbereiches müssen innerhalb der Reichweite liegen (und im Sichtbereich des Zauberers)"
                    },
                    {
                        "name": "Phantasma I",
                        "level": 2,
                        "value": "Erstellt das Trugbild eines Objekts oder Lebewesens, das sich , solange sich der Zauberer konzentriert, nach Wunsch bewegt. Bricht die Konzentration ab, erstarrt das Trugbild, bleibt aber bestehen. Wenn der Zauberer die Konzentration wieder aufnimmt, kann er das Trugbild erneut bewegen (sofern die Dauer nicht abgelaufen ist). Das Bild kann jede Größe haben, solange es in den Radius paßt"
                    },
                    {
                        "name": "Illusion III",
                        "level": 3,
                        "value": "Wie Illusion II, aber es können zwei Optionen gewählt werden. Unten in den Anmerkungen finden Sie Richtlinien dazu, wie sich diese Optionen miteinander kombinieren lassen"
                    },
                    {
                        "name": "Verzögerte Illusion II",
                        "level": 4,
                        "value": "Wie Illusion II, aber die Illusion kann um bis zu 24 Stunden verzögert werden. Beim Wirken des Spruches entscheidet sich der Zauberer, was die Illusion auslöst. Er hat dabei die Wahl aus: a) einer Zeitperiode, b) bestimmten Bewegungen, c) bestimmten Geräuschen, d) einer bestimmten Berührung, e) bestimmten Gerüchen, f ) einem bestimmter Geschmack oder g) einem bestimmten Präsenz-Spruch, der im Wirkungsbereich gewirkt wird. Wenn ein Sinn als Auslöser verwendet wird, muß dieser in der Illusion abgedeckt sein"
                    },
                    {
                        "name": "Phantasma II",
                        "level": 5,
                        "value": "Wie Phantasma I, aber es kann eine der folgenden Optionen ausgewählt werden: a) ein zusätzlicher Sinn kann hinzugefügt werden (der entsprechende Trugbild-Spruch muß bekannt sein), b) die Dauer kann verdoppelt werden, c) die Reichweite kann verdoppelt werden, d) der Radius des Wirkungsbereiches kann verdoppelt werden, e) ein weiteres Trugbild kann erzeugt und unabhängig vom ersten bewegt werden (alle Trugbilder müssen sich jedoch zu jeder Zeit vollständig in der Reichweite und im Sichtbereich des Zauberers befinden), oder f ) begrenzt viele, sich wiederholende Geräusche, Bewegungen usw. können hinzugefügt werden, die keine Konzentration erfordern (der entsprechende Sinn muß von der Illusion abgedeckt sein)"
                    },
                    {
                        "name": "Illusion V",
                        "level": 6,
                        "value": "Wie Illusion III, nur können vier Optionen gewählt werden"
                    },
                    {
                        "name": "Verzögertes Phantasma II",
                        "level": 7,
                        "value": "Wie Phantasma II, aber es kann wie in Verzögerter Illusion II aufgeschoben werden. Das Phantasma bewegt sich und handelt, wenn es beim Wirken des Spruches einen einfachen Steuerbefehl erhalten hat (wie „greif an“, „renn“ usw.). Alternativ kann es eine kurze Rede halten (wenn Geräusch einer der abgedeckten Sinne ist)"
                    },
                    {
                        "name": "Verzögerte Illusion III",
                        "level": 8,
                        "value": "Wie Verzögerte Illusion II, nur können zwei Optionen gewählt werden. In den Anmerkungen finden Sie einige Hinweise dazu, wie sich diese Optionen miteinander kombinieren lassen"
                    },
                    {
                        "name": "Phantasma IV",
                        "level": 9,
                        "value": "Wie Phantasma I, nur können drei beliebige Optionen gewählt werden"
                    },
                    {
                        "name": "Illusion VII",
                        "level": 10,
                        "value": "Wie Illusion II, nur können sechs beliebige Optionen gewählt werden"
                    },
                    {
                        "name": "Verzögertes Phantasma III",
                        "level": 11,
                        "value": "Wie Verzögertes Phantasma II, nur können zwei beliebige Optionen gewählt werden"
                    },
                    {
                        "name": "Phantasma IV",
                        "level": 12,
                        "value": "Wie Phantasma II, nur können drei beliebige Optionen gewählt werden"
                    },
                    {
                        "name": "Verzögerte Illusion V",
                        "level": 13,
                        "value": "Wie Verzögerte Illusion II, nur können vier beliebige Optionen gewählt werden"
                    },
                    {
                        "name": "Phantasma V",
                        "level": 14,
                        "value": "Wie Phantasma II, nur können vier beliebige Optionen gewählt werden"
                    },
                    {
                        "name": "Illusion X",
                        "level": 15,
                        "value": "Wie Illusion II, nur können neun beliebige Optionen gewählt werden"
                    },
                    {
                        "name": "Verzögertes Phantasma V",
                        "level": 16,
                        "value": "Wie Verzögertes Phantasma II, nur können vier beliebige Optionen gewählt werden"
                    },
                    {
                        "name": "Phantasma VII",
                        "level": 17,
                        "value": "Wie Phantasma II, nur können sechs beliebige Optionen gewählt werden"
                    },
                    {
                        "name": "Verzögerte Illusion VII",
                        "level": 18,
                        "value": "Wie Verzögerte Illusion II, nur können sechs beliebige Optionen gewählt werden"
                    },
                    {
                        "name": "Geländeillusion",
                        "level": 19,
                        "value": "Das gesamte Gelände im Wirkungsbereich erscheint anders als es wirklich ist (Geländefühlung muß bekannt sein). Der Zauberer legt fest, wie sich das Gelände unterscheidet. Beispielsweise könnte eine Lichtung im Wald als Waldstück erscheinen, in dem die Bäume dicht stehen"
                    },
                    {
                        "name": "Phantasma X",
                        "level": 20,
                        "value": "Wie Phantasma II, nur können neun beliebige Optionen gewählt werden"
                    },
                    {
                        "name": "Verzögerte Illusion X",
                        "level": 25,
                        "value": "Wie Verzögerte Illusion II, nur können neun beliebige Optionen gewählt werden"
                    },
                    {
                        "name": "Wahrhaftige Illusion",
                        "level": 30,
                        "value": "Wie Illusion X, nur ist die Wirkung permanent (bis sie gebannt wird)"
                    },
                    {
                        "name": "Wahrhaftige Phantasma",
                        "level": 50,
                        "value": "Wie Phantasma X, nur ist die Wirkung permanent (bis sie gebannt wird)."
                    }
                ]
            },
            {
                "id": "9.3",
                "name": "9.3.4: Schall formen",
                "spells": [
                    {
                        "name": "Trugbild Geräusch",
                        "level": 1,
                        "value": "Erschafft in einem Bereich von bis zu 3m Radius einfache, unbewegliche Geräusche"
                    },
                    {
                        "name": "Stille I",
                        "level": 2,
                        "value": "Erschafft einen 3m-Radius, in und aus dem Schall nicht dringen kann. Wenn der Mittelpunkt des Stilleradius auf einem beweglichen Gegenstand oder Wesen liegt, bewegt er sich mit diesem. Daraus ergibt sich ein Sonderbonus von +25 auf Schleichen. Vgl. Abschnitt 5.19 (Seite 42)"
                    },
                    {
                        "name": "Geräusche kontrollieren I",
                        "level": 3,
                        "value": "Der Zauberer kann die Lautstärke der Geräusche im Wirkungsbereich kontrollieren. Sie kann von völliger Stille bis zu einem sehr lauten Schrei reichen und in unterschiedlichen Teilen des Wirkungsbereichs verschieden sein"
                    },
                    {
                        "name": "Donnerschlag",
                        "level": 4,
                        "value": "Dicht an den Ohren des Ziels ertönt ein Donnerschlag. Das Ziel ist pro Fehlschlag von 5 eine Runde lang benommen"
                    },
                    {
                        "name": "Geräusche kontrollieren V",
                        "level": 5,
                        "value": "Wie Geräusche kontrollieren I, nur ist der Radius 15 Meter groß"
                    },
                    {
                        "name": "Mirakel Geräusch",
                        "level": 6,
                        "value": "Die Geräusche eines Objektes verändern sich für die Spruchdauer. Das Ziel darf nicht mehr Masse als 5kg pro Stufe haben. Beachten Sie, daß sich kein anderer Aspekt verändert"
                    },
                    {
                        "name": "Taub",
                        "level": 7,
                        "value": "Das Ziel kann keine Geräusche hören, die von weiter als 15cm von seinen Ohren herrühren und niemand, der weiter als 15cm von ihm weg ist, kann es sprechen hören"
                    },
                    {
                        "name": "Stille V",
                        "level": 8,
                        "value": "Wie Stille I, nur ist der Radius 15 Meter groß"
                    },
                    {
                        "name": "Schwacher Ultraschall",
                        "level": 9,
                        "value": "Alle Wesen (außer dem Zauberer) innerhalb des Wirkungsbereichs, die Ultraschall hören können, sind pro Fehlschlag von 10 eine Runde lang benommen. Tiere, die Ultraschall hören können, brechen in Panik aus und ergreifen die Flucht. Solange sich ein Wesen im Wirkungsbereich aufhält, muß es jede Runde einen WW ablegen"
                    },
                    {
                        "name": "Geräusche kontrollieren V",
                        "level": 10,
                        "value": "Wie Geräusche kontrollieren I, nur ist der Radius 30 Meter groß"
                    },
                    {
                        "name": "Donnerschlagssphäre",
                        "level": 11,
                        "value": "Wie Donnerschlag, nur ist jeder im Wirkungsbereich betroffen"
                    },
                    {
                        "name": "Geländegeräusche",
                        "level": 12,
                        "value": "Die Geräusche im gesamten Wirkungsbereich klingen anders als sie es normalerweise täten. Der Zauberer legt fest, wie sich die Geräusche unterscheiden. Beispielsweise könnte auf einem offenen Feld das Blätterrauschen eines Waldes zu hören sein. Beachten Sie, daß sich nur die hörbaren Aspekte des Geländes ändern"
                    },
                    {
                        "name": "Stille X",
                        "level": 13,
                        "value": "Wie Stille I, nur ist der Radius 30 Meter groß"
                    },
                    {
                        "name": "Taubheitssphäre",
                        "level": 14,
                        "value": "Wie Taub, nur sind alle in einem Radius von 3 Metern betroffen"
                    },
                    {
                        "name": "Mächtige Geräuschkontrolle",
                        "level": 15,
                        "value": "Wie Geräusche kontrollieren I, nur ist der Radius 3 Meter pro Stufe groß"
                    },
                    {
                        "name": "Fern-Stille",
                        "level": 16,
                        "value": "Wie Stille I, bis auf die höhere Reichweite"
                    },
                    {
                        "name": "Fern-Geräuschkontrolle",
                        "level": 17,
                        "value": "Wie Geräusche kontrollieren I, bis auf die höhere Reichweite"
                    },
                    {
                        "name": "Fern-Donnerschlag",
                        "level": 18,
                        "value": "Wie Donnerschlag, bis auf die höhere Reichweite"
                    },
                    {
                        "name": "Fern-Taubheit",
                        "level": 19,
                        "value": "Wie Taub, bis auf die höhere Reichweite"
                    },
                    {
                        "name": "Massen-Taubheit",
                        "level": 20,
                        "value": "Wie Taub, nur kann der Spruch die Stufe des Zauberers an Zielen betreffen"
                    },
                    {
                        "name": "Massen-Stille",
                        "level": 25,
                        "value": "Wie Stille I, aber mit einem Ziel pro Stufe des Zauberers mit je einem Stilleradius von 30cm"
                    },
                    {
                        "name": "Wahrhaftige Geräuschkontrolle",
                        "level": 30,
                        "value": "Wie Geräusche kontrollieren I, nur ist der Radius 6m/St und der Zauberer muß sich nicht konzentrieren"
                    },
                    {
                        "name": "Starker Ultraschall",
                        "level": 50,
                        "value": "Wie Schwacher Ultraschall, nur ist jeder (außer dem Zauberer), in einem Radius von 30 Metern betroffen. Jeder, dessen WW um mehr als 40 fehlschlägt, verliert das Bewußtsein. Jeder, dessen WW um mehr als 75 fehlschlägt, stirbt."
                    }
                ]
            },
            {
                "id": "9.4",
                "name": "9.3.5: Tastsinn / Geschmack / Geruch",
                "spells": [
                    {
                        "name": "Trugbild Geruch",
                        "level": 1,
                        "value": "Füllt den Wirkungsbereich mit einigen unbeweglichen Gerüchen. Diese Gerüche sind real (kein WW) und normalerweise kann jemand nur herausfinden, daß es sich um eine Illusion handelt, indem er Sprüche einsetzt oder einen anderen Sinn als den Geruchssinn"
                    },
                    {
                        "name": "Schlag I",
                        "level": 2,
                        "value": "Das Ziel wird von der Entsprechung eines Faustschlags getroffen (der Angriff ist unsichtbar, wenn er nicht von einem Phantasma oder einer Illusion begleitet wird, das/die den Sehsinn mit anspricht). Behandeln Sie dies als einen Waffenlosen Angriff des Rangs I. Für diesen Spruch kann die Fertigkeit Gezielte Sprüche ausgebildet werden"
                    },
                    {
                        "name": "Trugbild Geschmack",
                        "level": 3,
                        "value": "Wie Trugbild Geruch, nur können verschiedene Geschmäcker erzeugt werden"
                    },
                    {
                        "name": "Tränenwolke I",
                        "level": 4,
                        "value": "Erzeugt eine Wolke aus giftigem Gas mit einem Radius von 3 Metern, die alle benommen werden läßt, denen ein WW mißlingt (alle Ziele müssen in jeder Runde, in der sie sich in der Wolke aufhalten, einen WW ablegen). Die Wolke treibt mit dem Wind dahin. Ziele, denen der WW mißlingt, sind pro Fehlschlag von 10 eine Runde lang benommen"
                    },
                    {
                        "name": "Trugbild Tastsinn I",
                        "level": 5,
                        "value": "Wie Trugbild Geruch, nur können alle Objekte und Oberflächen in einem Radius von 3 Metern so verändert werden, daß sie sich anders anfühlen, als sie wirklich sind. Ein Schlag gegen ein Objekt oder eine Oberfläche hebt den Spruch nur für dieses Objekt oder diese Oberfläche auf"
                    },
                    {
                        "name": "Tastsinns/Geruchs/Geschmacks-Mirakel",
                        "level": 6,
                        "value": "Der Spruch verändert während seiner Wirkungsdauer wie ein Objekt (das bis zu 5 Kilo pro Stufe wiegen kann) riecht, schmeckt oder wie sich seine Oberfläche anfühlt. Beachten Sie, daß sich keine sichtbaren Aspekte des Objekts ändern"
                    },
                    {
                        "name": "Schlag III",
                        "level": 7,
                        "value": "Wie Schlag I, nur ist die Reichweite 100m"
                    },
                    {
                        "name": "Tränenwolke II",
                        "level": 9,
                        "value": "Wie Tränenwolke I, nur hat sie einen Radius von 6 Metern"
                    },
                    {
                        "name": "Trugbild Tastsinn III",
                        "level": 10,
                        "value": "Wie Trugbild Tastsinn I, nur muß ein Objekt auf dem ein Trugbild Tastsinn III liegt, dreimal einen Schlag erhalten, damit das Trugbild aufgehoben wird"
                    },
                    {
                        "name": "Schlag V",
                        "level": 11,
                        "value": "Wie Schlag I, nur ist die Reichweite 150m"
                    },
                    {
                        "name": "Geländefühlung",
                        "level": 12,
                        "value": "Das gesamte Gelände im Wirkungsbereich fühlt sich anders an, als es ist. Der Zauberer legt fest, in wie fern es anders ist. Zum Beispiel könnte sich glatter Boden steinig anfühlen oder steiniger Boden glatt"
                    },
                    {
                        "name": "Massen-Geruch/Geschmack",
                        "level": 13,
                        "value": "Der Zauberer kann seiner Stufe an Objekten je eigenen Geschmack und Geruch verleihen"
                    },
                    {
                        "name": "Tränenwolke V",
                        "level": 14,
                        "value": "Wie Tränenwolke I, nur hat sie einen Radius von 15m"
                    },
                    {
                        "name": "Trugbild Tastsinn V",
                        "level": 15,
                        "value": "Wie Trugbild Tastsinn I, nur muß das Objekt 5 Schläge erhalten"
                    },
                    {
                        "name": "Massen-Trugbild Tastsinn",
                        "level": 16,
                        "value": "Der Zauberer kann bei seiner Stufe an Gegenständen verändern, wie sich ihre Oberfläche anfühlt"
                    },
                    {
                        "name": "Trugbild Tastsinn VIII",
                        "level": 18,
                        "value": "Wie Trugbild Tastsinn I, nur muß das Objekt 7 Schläge erhalten"
                    },
                    {
                        "name": "Trugbild Tastsinn X",
                        "level": 20,
                        "value": "Wie Trugbild Tastsinn I, nur muß das Objekt 10 Schläge erhalten"
                    },
                    {
                        "name": "Wahrhaftiges Geruchstrugbild",
                        "level": 25,
                        "value": "Wie Trugbild Geruch, nur kann einem Objekt dauerhaft ein Geruch gegeben werden"
                    },
                    {
                        "name": "Wahrhaftiges Geschmackstrugbild",
                        "level": 30,
                        "value": "Wie Trugbild Geschmack, nur kann einem Objekt dauerhaft ein Geschmack gegeben werden"
                    },
                    {
                        "name": "Wahrhaftiges Tastsinnstrugbild",
                        "level": 50,
                        "value": "Wie Trugbild Tastsinn I, nur kann ein Objekt sich dauerhaft anders anfüllen, als es wirklich ist."
                    }
                ]
            },
            {
                "id": "9.5",
                "name": "9.3.6: Täuschungen",
                "spells": [
                    {
                        "name": "Flimmern",
                        "level": 1,
                        "value": "Das Ziel erscheint Angreifern verschwommen"
                    },
                    {
                        "name": "Schatten",
                        "level": 2,
                        "value": "Der Ziel und Gegenstände, die er am Körper trägt, wirken wie ein Schatten und sind damit in dunkler Umgebung fast unsichtbar. In vielen Situation kann das als besonderer Bonus zwischen +25 und +75 auf Schleichen/Verstecken abgehandelt werden"
                    },
                    {
                        "name": "Fassade I",
                        "level": 3,
                        "value": "Eine begrenzte Illusion läßt das Ziel wie einen Angehörigen eines beliebigen Humanoidenvolks aussehen (±20% seiner eigenen Größe). Die Illusion bewegt sich mit dem Ziel"
                    },
                    {
                        "name": "Zeichen",
                        "level": 4,
                        "value": "[WW-Mod.: -50] Der Zauberer kann dem Ziel einfache Sachverhalte per Zeichensprache übermitteln (ja, nein, Hunger, Abschied usw.). Für das Ziel wirkt es, als spräche der Zauberer seine Sprache"
                    },
                    {
                        "name": "Verschieben I",
                        "level": 5,
                        "value": "Das Ziel scheint leicht von seinem eigentlichen Aufenthaltsort versetzt zu sein. Angriffe auf es schlagen mit einer Wahrscheinlichkeit von 10% fehl. Jedesmal, wenn das Ziel wegen dieses Spruchs verfehlt wurde, sinkt die Wahrscheinlichkeit um 5%"
                    },
                    {
                        "name": "Fassade II",
                        "level": 6,
                        "value": "Wie Fassade I, nur kann die Illusion einen weiteren Sinn abdecken"
                    },
                    {
                        "name": "Doppelgängerfassade I",
                        "level": 7,
                        "value": "Wie Fassade I, nur kann das Ziel aussehen wie eine bestimmte Person. Der Zauberer muß die Person mindestens eine Minute lang konzentriert beobachtet haben"
                    },
                    {
                        "name": "Fassade III",
                        "level": 8,
                        "value": "Wie Fassade I, nur kann die Illusion zwei weitere Sinne abdecken"
                    },
                    {
                        "name": "Doppelgängerfassade II",
                        "level": 9,
                        "value": "Wie Doppelgängerfassade I, nur verfügt das Ziel über einen weiteren Aspekt (oder Wesenszug) der Person, wie etwa deren Stimme. Außerdem muß der Zauberer die Person mindestens 2 Minuten konzentriert beobachtet haben"
                    },
                    {
                        "name": "Verschieben II",
                        "level": 10,
                        "value": "Wie Verschieben I, nur liegt die Wahrscheinlichkeit, daß Angriffe fehlschlagen, bei 20%"
                    },
                    {
                        "name": "Falsches Abbild",
                        "level": 11,
                        "value": "Erschafft ein Ebenbild des Zauberers, das der nach Wunsch bewegen kann, wenn er sich konzentriert, und das ansonsten genau das tut, was er auch tut. Das Abbild muß im Wirkungsbereich bleiben"
                    },
                    {
                        "name": "Doppelgängerfassade III",
                        "level": 12,
                        "value": "Wie Doppelgängerfassade I, nur verfügt das Ziel über zwei weitere Aspekte (oder Wesenszüge) der Person. Außerdem muß der Zauberer die Person mindestens 3 Minuten konzentriert studieren. Beispielsweise ließe sich die Stimme und der Geruch der Person nachbilden"
                    },
                    {
                        "name": "Massen-Flimmern",
                        "level": 13,
                        "value": "Wie Flimmern, nur kann der Spruch die Stufe des Zauberers an Zielen betreffen"
                    },
                    {
                        "name": "Fassade V",
                        "level": 14,
                        "value": "Wie Fassade I, nur kann die Illusion alle Sinne abdecken (außer Präsenz)"
                    },
                    {
                        "name": "Verschieben III",
                        "level": 15,
                        "value": "Wie Verschieben I, nur liegt die Wahrscheinlichkeit, daß Angriffe fehlschlagen, bei 30%"
                    },
                    {
                        "name": "Doppelgängerfassade IV",
                        "level": 16,
                        "value": "Wie Doppelgängerfassade I, nur verfügt das Ziel über drei weitere Aspekte (oder Wesenszüge) der Person. Außerdem muß der Zauberer die Person mindestens 4 Minuten konzentriert studieren. Beispielsweise ließe sich die Stimme, der Geruch der Person und eine subtile Eigenheit nachbilden"
                    },
                    {
                        "name": "Doppelgängerstudium",
                        "level": 17,
                        "value": "Der Zauberer kann diesen Spruch wirken und weiß dann sofort alles, was er für die Doppelgänger-Sprüche von einer Person wissen muß (damit muß er die Person nicht mehr beobachten, bevor er einen dieser Sprüche verwendet)"
                    },
                    {
                        "name": "Wahrhaftige Doppelgängerfassade",
                        "level": 19,
                        "value": "Wie Doppelgängerfassade I, nur verfügt das Ziel über alle Aspekte (oder Wesenszüge) der Person. Außerdem muß der Zauberer die Person mindestens 5 Minuten konzentriert studieren. Wenn das Ziel unter der Wirkung dieses Spruchs steht, werden selbst engste Freunde und Partner der Person es schwer haben, die Fassade zu durchschauen"
                    },
                    {
                        "name": "Verschieben IV",
                        "level": 20,
                        "value": "Wie Verschieben I, nur liegt die Wahrscheinlichkeit, daß Angriffe fehlschlagen, bei 40%"
                    },
                    {
                        "name": "Massen-Fassade",
                        "level": 25,
                        "value": "Wie Fassade I, nur kann der Spruch die Stufe des Zauberers an Zielen betreffen"
                    },
                    {
                        "name": "Verschieben V",
                        "level": 30,
                        "value": "Wie Verschieben I, nur liegt die Wahrscheinlichkeit, daß Angriffe fehlschlagen, bei 50%"
                    },
                    {
                        "name": "Wechselnde Fassade",
                        "level": 50,
                        "value": "Wie Fassade V, nur kann der Zauberer die Fassade jede Runde in eine andere wechseln lassen."
                    }
                ]
            }
        ]
    },
    {
        "id": "10",
        "name": "Basisliste Magier",
        "spellLists": [
            {
                "id": "10.0",
                "name": "9.4.1: Gesetz des Eises",
                "spells": [
                    {
                        "name": "Gefrieren",
                        "level": 1,
                        "value": "Kühlt 30 Liter Flüssigkeit pro Stufe mit einer Geschwindigkeit von 30 Litern pro Runde Konzentration bis zum Gefrierpunkt. Die Temperatur fällt aber nicht unter -30°C (Flüssigkeiten mit einem niedrigeren Gefrierpunkt frieren also nicht ein). Dies funktioniert nicht bei dem Blut eines Lebewesens in seinen Adern"
                    },
                    {
                        "name": "Abkühlen",
                        "level": 2,
                        "value": "Kühlt 30 Liter (30dm³) pro Stufe eines festen, unbelebten, nichtmetallischen Materials mit 30 Litern pro Runde Konzentration auf bis zu -30°C ab"
                    },
                    {
                        "name": "Kältebarriere",
                        "level": 3,
                        "value": "Erzeugt eine durchsichtige Wand intensiver Kälte bis zu 3m x 3m x 30cm. Passieren der Wand verursacht einen kritischen Kältetreffer der Intensität A (kein WW)"
                    },
                    {
                        "name": "Tiefkühlen",
                        "level": 5,
                        "value": "Wie Abkühlen, bis auf die Dauer, und das Material kann mit einer Rate von 25°C pro Runde auf bis zu -130°C abgekühlt werden. Der Zauberer muß sich während der Abkühlphase konzentrieren (ohne Konzentration hält das Material die Temperatur für die Spruchdauer)"
                    },
                    {
                        "name": "Eisstrahl I",
                        "level": 6,
                        "value": "Aus der Handfläche des Zauberers schießt ein Eisstrahl. Der Angriff wird auf der Angriffstabelle: Eisstrahl 12-4 (Seite 237) ausgewürfelt"
                    },
                    {
                        "name": "Kältekugel II",
                        "level": 7,
                        "value": "Eine 30cm große Kältekugel schießt aus der Hand des Zauberers. Wenn sie ihr Ziel erreicht, explodiert sie in einem 6-Meter-Radius. Der Angriff wird auf der Angriffstabelle: Kältekugel 12-7 (Seite 243) ausgewürfelt"
                    },
                    {
                        "name": "Eisbarriere",
                        "level": 8,
                        "value": "Erzeugt eine bis zu 3m x 3m x (60cm an der Basis, 30cm an der Oberkante) große Eiswand. Man kann sie durch Schmelzen, Einschlagen oder Umstürzen überwinden (wenn sie nicht an einer festen Oberfläche lehnt)"
                    },
                    {
                        "name": "Kälteruf I",
                        "level": 9,
                        "value": "Wie Kältebarriere, erzeugt aber einen Kältewürfel mit bis zu 3 Metern Kantenlänge. Es dauert eine vollständige Runde, bis der Würfel geformt und effektiv ist. Jeder, der durch den Würfel hindurchgeht oder im Innern gefangen wird, erleidet einen kritischen Kältetreffer der Intensität A für jede Runde, in der er sich innerhalb des Würfels aufhält"
                    },
                    {
                        "name": "Kältekreis",
                        "level": 10,
                        "value": "Wie Kältebarriere, aber die Barriere ist 3 Meter hoch und formt einen 12 Meter durchmessenden Kreis (Dicke 1,80m) um den Zauberer. Der Kreis bewegt sich nicht mit dem Zauberer"
                    },
                    {
                        "name": "Eisstrahl III",
                        "level": 11,
                        "value": "Wie Eisstrahl I, nur ist die Reichweite 100 Meter"
                    },
                    {
                        "name": "Wasser zu Eis",
                        "level": 12,
                        "value": "Pro Stufe des Zauberers werden augenblicklich 300 Liter Wasser in Eis verwandelt"
                    },
                    {
                        "name": "Metall tiefkühlen",
                        "level": 13,
                        "value": "Wie Tiefkühlen, nur kühlt der Spruch Metal bis zu einem Punkt ab, an dem es extrem spröde wird (nur einen Gegenstand). Unter normalen Umständen senkt das die Waffenstärke (wenn festgestellt wird, ob sie zerbricht) um 50. Zusätzlich wird die Bruchzahl um 5 erhöht (auf maximal 10). In jeder Minute danach sinkt der Bruchfaktor wieder um 1 und die Waffenstärke um 5, bis die normalen Wert erreicht wurden (d.h. die Waffe erwärmt sich wieder normal)"
                    },
                    {
                        "name": "Kälteruf II",
                        "level": 14,
                        "value": "Wie Kälteruf I, nur hat der Würfel eine Kantenlänge von bis zu 6m und die Spruchreichweite ist 6m"
                    },
                    {
                        "name": "Eisstrahl V",
                        "level": 15,
                        "value": "Wie Eisstrahl I, nur ist die Reichweite 150 Meter"
                    },
                    {
                        "name": "Eistriade",
                        "level": 16,
                        "value": "Drei Eisstrahlen schießen aus der Handfläche des Zauberers. Sie können in bis zu drei unterschiedliche Ziele einschlagen (solange sie alle in einem Winkel von 60° stehen und der Zauberer sie alle sehen kann). Der Zauberer kann für einen der Angriffe seinen Fertigkeitswert für Gezielte Sprüche (Eisstrahl) verwenden, die anderen haben einen OB von +0"
                    },
                    {
                        "name": "Kälteruf V",
                        "level": 18,
                        "value": "Wie Kälteruf I, nur hat der Würfel eine Kantenlänge von bis zu 15m und die Spruchreichweite ist 30m"
                    },
                    {
                        "name": "Kältekugel IV",
                        "level": 20,
                        "value": "Wie Kältekugel II, nur ist der Wirkungsbereich ein Radius von 12 Metern und die Reichweite ist 100 Meter"
                    },
                    {
                        "name": "Regen zu Schnee",
                        "level": 25,
                        "value": "Verwandelt allen Regen in einem Bereich von 2 Kilometern um den Zauberer in Schnee. Der Wirkungsbereich schrumpft für je 10°C über dem Gefrierpunkt um 150 Meter"
                    },
                    {
                        "name": "Wahrhaftige Kälte",
                        "level": 30,
                        "value": "Verursacht, daß die Temperatur alle 10 Minuten um 2 Grad fällt. Insgesamt kann die Temperatur um die Stufe des Zauberers mal 2 gesenkt werden"
                    },
                    {
                        "name": "Kältemeisterschaft",
                        "level": 50,
                        "value": "Der Zauberer kann in jeder Runde einen der niedrigstufigeren Sprüche dieser Liste anwenden."
                    }
                ]
            },
            {
                "id": "10.1",
                "name": "9.4.2: Gesetz der Erde",
                "spells": [
                    {
                        "name": "Verzaubertes Seil",
                        "level": 1,
                        "value": "Hält der Zauberer ein Seil, kann er es dazu bringen, sich in voller Länge in beliebiger Richtung (innerhalb des Wirkungsbereiches) zu bewegen und Knoten zu binden. Es kann nicht dazu benutzt werden, Wesen anzugreifen oder zu fesseln"
                    },
                    {
                        "name": "Erde lockern",
                        "level": 2,
                        "value": "Lockert 3 Kubikmeter Erde auf (wie ein Pflug)"
                    },
                    {
                        "name": "Erdbarriere",
                        "level": 4,
                        "value": "Erzeugt eine bis zu 3m x 3m x (1m an der Basis, 30cm an der Oberkante) große Wand fester Erde. Man kann sich durch diese Barriere hindurchgraben"
                    },
                    {
                        "name": "Spalte",
                        "level": 5,
                        "value": "Alle Risse und Fehler in einem bis zu 3m x 3m x 3m großen Teil beliebigen toten Materials dehnen sich bis zum Äußersten"
                    },
                    {
                        "name": "Reparieren",
                        "level": 6,
                        "value": "Der Zauberer kann einen einfachen Bruch oder Schaden in einem kleinen (bis zu 1kg Masse) anorganischen Objekt oder mehrere Brüche, Risse oder Schäden in einem größeren (bis zu 5kg) unbelebten organischen Objekt reparieren. Alle Teile des Objekts müssen sich innerhalb eines Radius von 3 Metern befinden"
                    },
                    {
                        "name": "Steinbarriere",
                        "level": 7,
                        "value": "Wie Erdbarriere, aber die Barriere besteht aus bis zu 3m x 3m x 30cm Stein. Man kann sich mit Werkzeugen durcharbeiten"
                    },
                    {
                        "name": "Erddornen",
                        "level": 8,
                        "value": "Durch diesen Spruch wird der Wirkungsbereich mit 15 bis 30cm langen Dornen und Klingen gespickt. Die genaue Zusammensetzung hängt von dem Untergrund ab. Der Wirkungsbereich muß horizontal auf eine Oberfläche gelegt werden (funktioniert also nicht an einer Wand). Die meisten Tiere und Kreaturen kann man nicht dazu bringen, diesen Bereich zu durchqueren. Jeder, der den Wirkungsbereich durchqueren will, muß pro 2 Meter einen Manöverwurf durchführen (mindestens äußerst schwer). Fällt jemand im Wirkungsbereich hin, erleidet er einen kritischen Stichtreffer der Intensität A"
                    },
                    {
                        "name": "Stein zu Erde",
                        "level": 9,
                        "value": "Verwandelt drei Kubikmeter Stein in feste Erde. Die Umwandlung erfolgt langsam über einen Zeitraum von 3 Runden"
                    },
                    {
                        "name": "Wahrhaftige Erdbarriere",
                        "level": 10,
                        "value": "Wie Erdbarriere, aber mit permanenter Dauer"
                    },
                    {
                        "name": "Erde zu Schlamm",
                        "level": 11,
                        "value": "Wie Stein zu Erde, nur verwandelt der Spruch Erde in weichen Schlamm"
                    },
                    {
                        "name": "Erde zu Stein",
                        "level": 12,
                        "value": "Wie Stein zu Erde, nur verwandelt der Spruch feste Erde in massiven Stein und lose Erde in Schotter"
                    },
                    {
                        "name": "Wahrhaftige Steinbarriere",
                        "level": 13,
                        "value": "Wie Steinbarriere, aber mit permanenter Dauer"
                    },
                    {
                        "name": "Schlamm zu Erde",
                        "level": 14,
                        "value": "Wie Stein zu Erde, nur verwandelt der Spruch Schlamm in feste Erde"
                    },
                    {
                        "name": "Erde vernichten",
                        "level": 15,
                        "value": "Löst drei Kubikmeter Erde auf (es bleibt nichts zurück)"
                    },
                    {
                        "name": "Barrieren verschmelzen",
                        "level": 16,
                        "value": "Verbindet zwei sich berührende Barrieren miteinander (die Nahtstelle kann bis zu 6m lang sein) oder verschmilzt einen Bereich von Steinblöcken miteinander (bis zu 3m³)"
                    },
                    {
                        "name": "Stein zu Schlamm",
                        "level": 17,
                        "value": "Wie Stein zu Erde, nur verwandelt der Spruch Stein in Schlamm"
                    },
                    {
                        "name": "Gebogene Barriere",
                        "level": 18,
                        "value": "Wie Wahrhaftige Steinwand, nur kann die Wand auch bis zu halbkreisförmig gebogen sein"
                    },
                    {
                        "name": "Stein vernichten",
                        "level": 20,
                        "value": "Wie Erde vernichten, nur ist Stein betroffen"
                    },
                    {
                        "name": "Metall vernichten",
                        "level": 25,
                        "value": "Wie Erde vernichten, nur vernichtet der Spruch bis zu 30 Liter Metall"
                    },
                    {
                        "name": "Erschütterungen",
                        "level": 30,
                        "value": "Verursacht ein sehr leichtes Erdbeben, das ein schäbiges Bauwerk einstürzen lassen kann (was sehr furchterregend sein kann). Das Beben erreicht ungefähr 5,5 auf der Richterskala"
                    },
                    {
                        "name": "Erdmeisterschaft",
                        "level": 50,
                        "value": "Der Zauberer kann in jeder Runde einen der niedrigstufigeren Sprüche dieser Liste anwenden."
                    }
                ]
            },
            {
                "id": "10.2",
                "name": "9.4.3: Gesetz des Feuers",
                "spells": [
                    {
                        "name": "Sieden",
                        "level": 1,
                        "value": "Bringt 30 Liter Flüssigkeit pro Stufe (kein Blut in einem lebenden Körper) mit einer Rate von 30 Litern pro Runde zum Kochen"
                    },
                    {
                        "name": "Erwärmen",
                        "level": 2,
                        "value": "Erwärmt 30 Liter pro Stufe eines festen, unbelebten, nichtmetallischen Materials mit 30 Litern pro Runde Konzentration auf bis zu 40°C"
                    },
                    {
                        "name": "Zündeln",
                        "level": 3,
                        "value": "Läßt Holz augenblicklich entflammen. Es darf bis zu 30cm von der Hand des Zauberers entfernt sein"
                    },
                    {
                        "name": "Feuerbarriere",
                        "level": 4,
                        "value": "Erzeugt eine undurchsichtige Wand aus Feuer (bis zu 3m x 3m x 2m). Durchschreiten verursacht einen kritischen Hitzetreffer der Intensität A (kein WW)"
                    },
                    {
                        "name": "Erhitzen",
                        "level": 5,
                        "value": "Wie Erwärmen, bis auf die Dauer, und das Material kann mit einer Rate von 25°C pro Runde auf bis zu 250°C erhitzt werden. Der Zauberer muß sich während der Aufwärmphase konzentrieren (ohne Konzentration hält das Material die Temperatur für die Spruchdauer)"
                    },
                    {
                        "name": "Feuerstrahl I",
                        "level": 6,
                        "value": "Aus der Handfläche des Zauberers schießt ein Feuerstrahl. Der Angriff wird auf der Angriffstabelle: Feuerstrahl 12-6 (Seite 241) ausgewürfelt"
                    },
                    {
                        "name": "Flammenruf I",
                        "level": 7,
                        "value": "Wie Feuerbarriere, erzeugt aber einen Flammenwürfel mit bis zu 3 Metern Kantenlänge. Es dauert eine vollständige Runde, bis der Würfel geformt und effektiv ist. Jeder, der durch den Würfel hindurchgeht oder im Innern gefangen wird, erleidet einen kritischen Hitzetreffer der Intensität A für jede Runde, in der er sich innerhalb des Würfels aufhält"
                    },
                    {
                        "name": "Feuerball",
                        "level": 8,
                        "value": "Ein 30cm großer Feuerball schießt aus der Hand des Zauberers. Wenn er sein Ziel erreicht, explodiert er in einem 3 Meter-Radius. Der Angriff wird auf der Angriffstabelle: Feuerball 12-5 (S. 239) ausgewürfelt"
                    },
                    {
                        "name": "Entzünden",
                        "level": 9,
                        "value": "Der Zauberer wählt eine Art von Lichtquelle aus, die entzündet oder gelöscht werden soll (z.B. Kerzen, Fackeln, Kamine, Lampen usw.). Dieser Spruch betrifft alle Lichtquellen der spezifizierten Art im Wirkungsbereich"
                    },
                    {
                        "name": "Flammenkreis",
                        "level": 10,
                        "value": "Wie Feuerbarriere, aber die Barriere ist 3 Meter hoch und formt einen 6 Meter durchmessenden Kreis (Dicke 1,80m) um den Zauberer. Der Kreis bewegt sich nicht mit dem Zauberer"
                    },
                    {
                        "name": "Feuerstrahl III",
                        "level": 11,
                        "value": "Wie Feuerstrahl I, nur ist die Reichweite 100 Meter"
                    },
                    {
                        "name": "Flammenruf II",
                        "level": 12,
                        "value": "Wie Flammenruf I, nur hat der Würfel eine Kantenlänge von bis zu 6m und die Spruchreichweite ist 6m"
                    },
                    {
                        "name": "Verzögerter Flammenruf",
                        "level": 13,
                        "value": "Wie Flammenruf I, nur kann die Wirkung um bis zu 24 Stunden verzögert werden. Die Wirkung kann durch eine Bedingung ausgelöst werden (vom Zauberer festgelegt, wenn er den Spruch wirkt): abgelaufene Zeitspanne, bestimmte Bewegungen, bestimmte Geräusche, Berührung, Gewalt in dem Bereich usw"
                    },
                    {
                        "name": "Feuersturm",
                        "level": 14,
                        "value": "Wie Flammenruf, nur regnet es kleine Feuerbälle innerhalb eines Würfels mit 3m Kantenlänge, die allen, die ihn durchqueren (oder in ihn geraten) einen kritischen Hitzetreffer der Intensität B zufügen"
                    },
                    {
                        "name": "Brennendes Metall",
                        "level": 15,
                        "value": "Läßt einen Metallgegenstand in Flammen ausbrechen. Der Gegenstand kann eine Masse von bis zu 500g pro Stufe haben. Trägt ein Wesen den Gegenstand am Körper, erhält es einen WW. Wenn dieser WW fehlschlägt, steckt das Wesen automatisch einen kritischen Hitzetreffer ein, dessen Intensität davon abhängt, wo am Körper es den Gegenstand trug. Wenn der Gegenstand in Kontakt mit bloßer Haut lag, erleidet das Wesen einen Hitzetreffer der Intensität C. Wenn der Gegenstand durch Stoff vom Wesen getrennt war, ist es einer der Intensität B. In allen anderen Fällen ist es ein kritischer Hitzetreffer der Intensität A"
                    },
                    {
                        "name": "Flammentriade",
                        "level": 16,
                        "value": "Drei Feuerstrahlen schießen aus der Handfläche des Zauberers. Sie können in bis zu drei unterschiedliche Ziele einschlagen (solange sie alle in einem Winkel von 60° stehen und der Zauberer sie alle sehen kann). Der Zauberer kann für einen der Angriffe seinen Fertigkeitswert für Gezielte Sprüche (Feuerstrahl) verwenden, die anderen haben einen OB von +0"
                    },
                    {
                        "name": "Feuerstrahl V",
                        "level": 17,
                        "value": "Wie Feuerstrahl I, nur ist die Reichweite 150 Meter"
                    },
                    {
                        "name": "Verzögerter Feuersturm",
                        "level": 18,
                        "value": "Wie Verzögerter Flammenruf, nur kann ein Feuersturm verzögert werden"
                    },
                    {
                        "name": "Flammenruf V",
                        "level": 19,
                        "value": "Wie Flammenruf I, nur hat der Würfel eine Kantenlänge von bis zu 15m und die Spruchreichweite ist 15m"
                    },
                    {
                        "name": "Winkelfeuer",
                        "level": 20,
                        "value": "Wie Feuerstrahl III, nur kann der Zauberer den Strahl eine Wende von 90° machen lassen, bevor er in das Ziel einschlägt (der Zauberer muß wissen, wo das Ziel ist). Der OB für den Strahl wird nach einer solchen Wende halbiert"
                    },
                    {
                        "name": "Verfolgendes Feuer",
                        "level": 25,
                        "value": "Wie Winkelfeuer, nur kann der Strahl sich so oft drehen wie nötig und auch durch Öffnungen hindurch (mit einem größeren Radius als 15cm), um das Ziel zu treffen"
                    },
                    {
                        "name": "Brennender Stein",
                        "level": 30,
                        "value": "Wie Brennendes Metall, nur ist eine Steinoberfläche von bis zu 30m² betroffen. Jeder, der sich durch diesen Bereich hindurchbewegt oder in ihm gefangen ist, erleidet pro Runde, in der er sich im Wirkungsbereich befindet, einen kritischen Hitzetreffer der Intensität C durch die einen Meter hohen Flammen"
                    },
                    {
                        "name": "Feuermeisterschaft",
                        "level": 50,
                        "value": "Der Zauberer kann in jeder Runde einen der niedrigstufigeren Sprüche dieser Liste anwenden."
                    }
                ]
            },
            {
                "id": "10.3",
                "name": "9.4.4: Gesetz des Lichts",
                "spells": [
                    {
                        "name": "Lichtstrahl",
                        "level": 1,
                        "value": "Aus der Handfläche des Zauberers entspringt ein Lichtkegel (wie der einer Taschenlampe) mit einer effektiven Reichweite von 15m. Wenn der Zauberer die Hand zur Faust ballt, wird das Licht „ausgeschaltet“. Öffnet er sie wieder, ist das Licht wieder da (sofern die Dauer noch nicht abgelaufen ist)"
                    },
                    {
                        "name": "Schockstrahl I",
                        "level": 2,
                        "value": "Ein Strahl intensiven, geladenen Lichts bricht aus der Handfläche des Zauberers. Die Ergebnisse dieses Angriffs werden mittels der Angriffstabelle: Schockstrahl 12-8 (Seite 245) bestimmt"
                    },
                    {
                        "name": "Licht I",
                        "level": 3,
                        "value": "Beleuchtet 3m Umkreis um den berührten Punkt"
                    },
                    {
                        "name": "Schattierung",
                        "level": 4,
                        "value": "Alle Schatten im Wirkungsbereich vertiefen sich. Daraus ergibt sich ein Bonus von +25 auf Verstecken und +10 auf Schleichen"
                    },
                    {
                        "name": "Lichtblitz",
                        "level": 5,
                        "value": "Erzeugt einen grellen Lichtblitz mit einem Radius von 3 Metern. Alle Wesen innerhalb des Radius sind für 1 Runde/5 Fehlschlag benommen"
                    },
                    {
                        "name": "Dunkelheit I",
                        "level": 6,
                        "value": "Wie Licht I, aber der Radius ist so dunkel wie in einer dunklen Nacht. Vgl. Abschnitt 5.12 (Seite 39)"
                    },
                    {
                        "name": "Licht V",
                        "level": 7,
                        "value": "Wie Licht I, aber der Radius kann bis zu 15 Metern betragen (der genaue Radius kann durch eine Runde Konzentration geändert werden)"
                    },
                    {
                        "name": "Schockstrahl III",
                        "level": 8,
                        "value": "Wie Schockstrahl I, aber mit einer Reichweite von 100 Metern"
                    },
                    {
                        "name": "Dunkelheit V",
                        "level": 9,
                        "value": "Wie Dunkelheit I, aber der Radius kann bis zu 15 Metern betragen (der genaue Radius kann durch eine Runde Konzentration geändert werden)"
                    },
                    {
                        "name": "Blitzschlag I",
                        "level": 10,
                        "value": "Wie Schockstrahl I, es wird aber ein Blitzstrahl verschossen. Die Ergebnisse dieses Angriffs werden mittels der Angriffstabelle: Blitzschlag 12-3 (Seite 235) bestimmt"
                    },
                    {
                        "name": "Wartendes Licht",
                        "level": 11,
                        "value": "Dieser Spruch kann in Verbindung mit jedwedem Licht- oder Dunkelheits-Spruch gewirkt werden (d.h. zunächst wird dieser Spruch gewirkt und dann, innerhalb der nächsten Minute, ein Licht/Dunkelheits-Spruch. Dieser Spruch kann die Wirkung des anderen dann um bis zu 24 Stunden verzögern. Sie wird dann durch eine der folgenden Bedingungen ausgelöst (vom Zauberer festgelegt): Verstreichen einer Zeitspanne, bestimmte Bewegungen, bestimmte Geräusche, Berührung oder Gewalt in dem Bereich usw"
                    },
                    {
                        "name": "Schockstrahl V",
                        "level": 12,
                        "value": "Wie Schockstrahl I, aber mit einer Reichweite von 150 Metern"
                    },
                    {
                        "name": "Signallicht V",
                        "level": 13,
                        "value": "Ein Lichtstrahl (beliebiger Farbe) entspringt der Handfläche des Zauberers. Der Strahl kann bis zu 8 km lang sein"
                    },
                    {
                        "name": "Blitzschlag III",
                        "level": 15,
                        "value": "Wie Blitzschlag I, nur ist die Reichweite 100m"
                    },
                    {
                        "name": "Pures Licht",
                        "level": 17,
                        "value": "Wie Licht I, nur ist der Radius 30 Meter groß, und dieses Licht hebt auch alle magische Dunkelheit auf. Magische Dunkelheit im Wirkungsbereich wird zurückkehren, wenn die Spruchdauer abgelaufen ist"
                    },
                    {
                        "name": "Pure Dunkelheit",
                        "level": 18,
                        "value": "Wie Dunkelheit I, nur ist der Radius 30 Meter groß und kein nicht-magisches Licht kann diese Dunkelheit durchdringen. Licht im Wirkungsbereich wird zurückkehren, wenn die Spruchdauer abgelaufen ist"
                    },
                    {
                        "name": "Signallicht X",
                        "level": 19,
                        "value": "Wie Signallicht V, nur kann der Lichtstrahl bis zu 15km lang sein"
                    },
                    {
                        "name": "Blitzschlag V",
                        "level": 20,
                        "value": "Wie Blitzschlag I, nur ist die Reichweite 150m"
                    },
                    {
                        "name": "Winkelblitzschlag",
                        "level": 25,
                        "value": "Wie Blitzschlag III, nur kann der Zauberer den Blitzschlag eine Wende von 90° machen lassen, bevor er in das Ziel einschlägt (der Zauberer muß wissen, wo das Ziel ist). Der OB für den Blitzschlag wird nach einer solchen Wende halbiert"
                    },
                    {
                        "name": "Verfolgender Blitzschlag",
                        "level": 30,
                        "value": "Wie Winkelblitzschlag, nur kann sich der Blitzschlag so oft drehen wie nötig und auch durch Öffnungen hindurch (mit einem größeren Radius als 15cm), um das Ziel zu treffen"
                    },
                    {
                        "name": "Lichtmeisterschaft",
                        "level": 50,
                        "value": "Der Zauberer kann in jeder Runde einen der niedrigstufigeren Sprüche dieser Liste anwenden."
                    }
                ]
            },
            {
                "id": "10.4",
                "name": "9.4.5: Gesetz des Wassers",
                "spells": [
                    {
                        "name": "Kondensation",
                        "level": 1,
                        "value": "Kondensiert 30 Liter Wasser aus der Umgebungsluft. Das Wasser kondensiert allmählich in der Hand des Zauberers und kann in passende Behälter geleitet werden"
                    },
                    {
                        "name": "Nebel",
                        "level": 2,
                        "value": "Erzeugt dichten Nebel mit einem Radius von 3 Metern pro Stufe des Zauberers. Vgl. Abschnitt 5.12 (Seite 39)"
                    },
                    {
                        "name": "Wasserbarriere",
                        "level": 3,
                        "value": "Erzeugt eine 3m x 3m x 30cm messende Wand aus Wasser. Alle Bewegungen durch diese Barriere werden um 80% reduziert. Angriffe durch diese Barriere erhalten einen Malus von -80"
                    },
                    {
                        "name": "Wasserstrahl I",
                        "level": 4,
                        "value": "Ein druckvoller Strahl Wasser springt aus der Handfläche des Zauberers. Die Ergebnisse dieses Angriffs werden mittels der Angriffstabelle: Wasserstrahl 12-9 (Seite 247) bestimmt"
                    },
                    {
                        "name": "Entnebeln",
                        "level": 5,
                        "value": "Löst jeglichen Nebel im Wirkungsbereich auf. Wenn ein Nebelgebiet nicht komplett aufgelöst wird (weil das Nebelgebiet größer als der Wirkungsbereich ist), füllt der Nebel den entnebelten Bereich mit einer Rate von 5 Metern alle 1 bis 5 Minuten wieder auf"
                    },
                    {
                        "name": "Wasser beruhigen",
                        "level": 8,
                        "value": "Das Wasser innerhalb des Radius wird beruhigt. Wellen werden um bis zu 6 Meter im Zentrum gesenkt (weniger außen)"
                    },
                    {
                        "name": "Wahrhaftige Wasserbarriere",
                        "level": 10,
                        "value": "Wie Wasserbarriere, bis auf die Dauer"
                    },
                    {
                        "name": "Wasserstrahl III",
                        "level": 11,
                        "value": "Wie Wasserstrahl I, nur ist die Reichweite 100m"
                    },
                    {
                        "name": "Regen",
                        "level": 13,
                        "value": "Wenn Wolken am Himmel stehen, regnet es die Wirkungsdauer des Spruches über (im Freien)"
                    },
                    {
                        "name": "Wasserstrahl V",
                        "level": 15,
                        "value": "Wie Wasserstrahl I, nur ist die Reichweite 150m"
                    },
                    {
                        "name": "Wassertriade",
                        "level": 16,
                        "value": "Drei Wasserstrahlen schießen aus der Handfläche des Zauberers. Sie können in bis zu drei unterschiedliche Ziele einschlagen (solange sie alle in einem Winkel von 60° stehen und der Zauberer sie alle sehen kann). Der Zauberer kann für einen der Angriffe seinen Fertigkeitswert für Gezielte Sprüche (Wasserstrahl) verwenden, die anderen haben einen OB von +0"
                    },
                    {
                        "name": "Strömung lenken",
                        "level": 17,
                        "value": "Der Wirkungsbereich dieses Spruchs ist das Wasser direkt um das Boot herum, auf dem der Zauberer sich befindet. Solange sich der Zauberer konzentriert, kann er die Geschwindigkeit des Boots um 15m pro Runde (ungefähr 5 km/h) erhöhen"
                    },
                    {
                        "name": "Wahrhaftige Wasserberuhigung",
                        "level": 18,
                        "value": "Wie Wasser beruhigen, nur werden Wellen in der Mitte um 15m gesenkt und der Zauberer muß sich nicht konzentrieren"
                    },
                    {
                        "name": "Strudel",
                        "level": 20,
                        "value": "Erschafft einen 15m breiten Strudel, der alle Gegenstände ohne eigenen Antrieb innerhalb von 150 Metern Entfernung an sich zieht (der Zauberer muß sich 2 Minuten konzentrieren, damit der Strudel entsteht). Gegenständen mit Antrieb steht ein Manöverwurf zu, um dem Sog zu entkommen"
                    },
                    {
                        "name": "Wasser teilen",
                        "level": 25,
                        "value": "Der Zauberer kann 30m tiefes Wasser teilen, so daß eine Art Durchgang entsteht, der 30m pro Stufe lang sein kann und am Grund drei Meter breit ist (an der Wasseroberfläche 15 Meter) 30. Meeresturm"
                    },
                    {
                        "name": "Wassermeisterschaft",
                        "level": 50,
                        "value": "Der Zauberer kann in jeder Runde einen der niedrigstufigeren Sprüche dieser Liste anwenden."
                    }
                ]
            },
            {
                "id": "10.5",
                "name": "9.4.6: Gesetz des Windes",
                "spells": [
                    {
                        "name": "Brise",
                        "level": 1,
                        "value": "Erzeugt für die Wirkungsdauer eine leichte Brise (Windgeschwindigkeit bis zu 6m/rnd), solange der Zauberer sich konzentriert. Jegliche Gase im Wirkungsbereich werden durch die Brise bewegt"
                    },
                    {
                        "name": "Luftbarriere",
                        "level": 2,
                        "value": "Erzeugt eine Barriere aus sich drehender Luft mit den Ausmaßen bis zu 3m x 3m x 1m. Die Barriere reduziert alle Bewegung durch sie hindurch um 50%. Zusätzlich erleiden Angriffe durch die Barriere einen Malus von -50"
                    },
                    {
                        "name": "Schlummernebel",
                        "level": 3,
                        "value": "Indem er sich konzentriert, entfernt der Zauberer den größten Teil des Sauerstoffs aus dem Wirkungsbereich. Nachdem er sich drei Runden lang konzentriert hat, müssen alle Ziele im Wirkungsbereich einen WW durchführen, bei Fehlschlag schlafen sie ein (für 1 Runde pro 10 Fehlschlag). Alle Feuerzauber im Wirkungsbereich erleiden einen Malus von -20 (oder sind 20% weniger effektiv bei Nicht-Angriffssprüchen)"
                    },
                    {
                        "name": "Wolke der Benommenheit I",
                        "level": 4,
                        "value": "Erzeugt eine Wolke mit 1 Meter Radius aus geladenen Gaspartikeln. In der ersten und zweiten Runde erleiden alle in ihr einen kritischen Elektrizitätstreffer der Intensität C, in der dritten und vierten Runde einen der Intensität B und in der fünften und sechsten Runde einen der Intensität A. Nach 6 Runden löst sich die Wolke auf. Die Wolke bewegt sich mit dem Wind, es dauert eine Runde, bis sie sich geformt hat (jeder im Radius kann sich mittels eines Manöverwurfs in dieser Runde aus ihr herausbewegen)"
                    },
                    {
                        "name": "Luftbremse I",
                        "level": 5,
                        "value": "Bringt im Wirkungsbereich alle Luftbewegungen mit Windgeschwindigkeiten bis zu 50km/h zum Stehen und verlangsamt stärkere Winde um 50km/h"
                    },
                    {
                        "name": "Wolke der Benommenheit II",
                        "level": 6,
                        "value": "Wie Wolke der Benommenheit I, aber der Radius ist 3 Meter"
                    },
                    {
                        "name": "Vakuum I",
                        "level": 7,
                        "value": "Erschafft ein fast vollständiges Vakuum. Jeder im Wirkungsbereich muß einen erfolgreichen WW durchführen, ansonsten erleidet er einen kritischen Aufpralltreffer der Intensität B, weil die Luft plötzlich zurückströmt. Sie sollten diesen Spruch nicht gegen Ihre Freunde einsetzen (siehe Seite 142 „Amras Kunst“)"
                    },
                    {
                        "name": "Luftbremse II",
                        "level": 8,
                        "value": "Wie Luftbremse I, aber mit einem Radius von 6 Metern"
                    },
                    {
                        "name": "Schlummerwolke",
                        "level": 9,
                        "value": "Wie Schlummernebel, bis auf die Dauer, und sie driftet mit dem Wind"
                    },
                    {
                        "name": "Wolke der Benommenheit III",
                        "level": 10,
                        "value": "Wie Wolke der Benommenheit I, aber der Radius ist 6 Meter"
                    },
                    {
                        "name": "Todeswolke",
                        "level": 11,
                        "value": "Wie Wolke der Benommenheit I, nur verursacht sie in der ersten und zweiten Runde einen kritischen Treffer der Intensität E, in der dritten und vierten einen der Intensität D, in der fünften und sechsten einen der Intensität C, in der siebten und achten einen der Intensität B und in der neunten und zehnten schließlich einen der Intensität A"
                    },
                    {
                        "name": "Vakuum II",
                        "level": 12,
                        "value": "Wie Vakuum I, aber mit einem Radius von 3 Metern"
                    },
                    {
                        "name": "Luftbremse X",
                        "level": 13,
                        "value": "Wie Luftbremse I, aber mit einem Radius von 30 Metern"
                    },
                    {
                        "name": "Wirbelwind",
                        "level": 14,
                        "value": "Ein Wirbelwind mit einem Radius von 3 Metern wird erschaffen. Der Wind fügt allen, die sich in seinem Bereich aufhalten einen kritischen Aufpralltreffer der Intensität A zu (in jeder Runde). Alle Bewegungen in oder durch den Wirbelwind sind um 80% reduziert. Der Zauberer kann sich in jeder Runde 30cm durch den Wirbelwind bewegen"
                    },
                    {
                        "name": "Todeswolke II",
                        "level": 15,
                        "value": "Wie Todeswolke I, aber mit einem Radius von 3 Metern"
                    },
                    {
                        "name": "Vakuum IV",
                        "level": 17,
                        "value": "Wie Vakuum I, aber mit einem Radius von 6 Metern"
                    },
                    {
                        "name": "Starkes Vakuum",
                        "level": 18,
                        "value": "Wie Vakuum I, nur fügt es einen kritischen Aufpralltreffer der Intensität D zu"
                    },
                    {
                        "name": "Wahrhaftige Benommenheitswolke",
                        "level": 19,
                        "value": "Wie Wolke der Benommenheit I, aber der Zauberer kann sie mittels Konzentration in jeder Runde 3m weit und bis zu 30m von sich weg bewegen"
                    },
                    {
                        "name": "Wind ausrichten",
                        "level": 20,
                        "value": "Erlaubt dem Zauberer, im Wirkungsbereich die Windrichtung zu ändern"
                    },
                    {
                        "name": "Heftiger Wind",
                        "level": 25,
                        "value": "Der Zauberer muß seine Arme ausbreiten, dann strömt heftiger Wind von ihnen weg und breitet sich aus, bis er in 100m Entfernung einen Radius von 8 Metern erreicht hat. Alle in diesem Windkegel erleiden einen kritischen Aufpralltreffer der Intensität B"
                    },
                    {
                        "name": "Sturm",
                        "level": 30,
                        "value": "Beschwört die Naturgewalten zu einem heftigen Sturm. Dieser Sturm beinhaltet starken Regen, Windgeschwindigkeiten zwischen 40 und 100 km/h, Blitze (per Zufall) und einen Schneesturm (wenn das Klima paßt). Der Sturm kann um bis zu 1 Stunde pro Stufe des Zauberers verzögert werden"
                    },
                    {
                        "name": "Windmeisterschaft",
                        "level": 50,
                        "value": "Der Zauberer kann in jeder Runde einen der niedrigstufigeren Sprüche dieser Liste anwenden."
                    }
                ]
            }
        ]
    },
    {
        "id": "11",
        "name": "Basisliste Mönch",
        "spellLists": [
            {
                "id": "11.0",
                "name": "9.5.1: Ausweichen",
                "spells": [
                    {
                        "name": "Schwingen I",
                        "level": 1,
                        "value": "Erlaubt dem Zauberer, 3m weit vertikal oder horizontal zu springen, ein festes Objekt zu greifen, daran zu schwingen, um dann (bis zu 6m von dem Gegenstand weg) perfekt zu landen. Das Objekt könnte ein Baum, ein Ast, ein Seil, ein Kronleuchter usw. sein"
                    },
                    {
                        "name": "Schnelligkeit I",
                        "level": 2,
                        "value": "Das Ziel kann doppelt so schnell handeln (hat also 200% Aktivität pro Runde), es muß aber direkt im Anschluß eine Runde pro beschleunigter Runde mit der Hälfte auskommen (Erholungsrunden, 50% Aktivität)"
                    },
                    {
                        "name": "Ausweichen I",
                        "level": 3,
                        "value": "Erlaubt dem Zauberer, einem Nah- oder Fernkampfangriff (keinem Spruchangriff ) auszuweichen, der in der gleichen Runde stattfindet, in der er diesen Spruch wirkt. Der Zauberer muß den Angriff sehen können (er darf nicht von hinten kommen oder unsichtbar sein) und er muß genug Platz haben, um ihm ausweichen zu können. Durch den Spruch erfährt der Angriff einen Malus von -50"
                    },
                    {
                        "name": "Schwingen III",
                        "level": 4,
                        "value": "Wie Schwingen I, nur kann der Zauberer drei solche Manöver in schneller Folge ausführen"
                    },
                    {
                        "name": "Salto I",
                        "level": 5,
                        "value": "Läßt den Zauberer einen Salto in eine beliebige Richtung schlagen und bis zu 3 Meter entfernt landen (mit beliebiger Blickrichtung)"
                    },
                    {
                        "name": "Blitzschnell I",
                        "level": 6,
                        "value": "Wie Schnelligkeit I, nur sind keine Runden mit halber Aktivität nötig"
                    },
                    {
                        "name": "Schnelligkeit III",
                        "level": 7,
                        "value": "Wie Schnelligkeit I, nur ist die Spruchdauer 3 Runden"
                    },
                    {
                        "name": "Ausweichen III",
                        "level": 8,
                        "value": "Wie Ausweichen I, nur kann der Zauberer 3 Angriffen ausweichen"
                    },
                    {
                        "name": "Schwingen V",
                        "level": 9,
                        "value": "Wie Schwingen I, nur kann der Zauberer fünf solche Manöver in schneller Folge ausführen"
                    },
                    {
                        "name": "Schnelligkeit V",
                        "level": 10,
                        "value": "Wie Schnelligkeit I, nur ist die Spruchdauer 5 Runden"
                    },
                    {
                        "name": "Salto III",
                        "level": 11,
                        "value": "Wie Salto I, nur kann der Zauberer drei Salti in schneller Folge schlagen"
                    },
                    {
                        "name": "Blitzschnell III",
                        "level": 12,
                        "value": "Wie Blitzschnell I, nur ist die Spruchdauer 3 Runden"
                    },
                    {
                        "name": "Ausweichen IV",
                        "level": 13,
                        "value": "Wie Ausweichen I, nur kann der Zauberer 4 Angriffen ausweichen"
                    },
                    {
                        "name": "Schnelligkeit VII",
                        "level": 15,
                        "value": "Wie Schnelligkeit I, nur ist die Spruchdauer 7 Runden"
                    },
                    {
                        "name": "Blitzschnell IV",
                        "level": 16,
                        "value": "Wie Blitzschnell I, nur ist die Spruchdauer 4 Runden"
                    },
                    {
                        "name": "Großer Salto",
                        "level": 17,
                        "value": "Wie Salto I, nur trägt der Salto den Zauberer bis zu 30cm pro Stufe weit"
                    },
                    {
                        "name": "Ausweichen V",
                        "level": 18,
                        "value": "Wie Ausweichen I, nur kann der Zauberer 5 Angriffen ausweichen"
                    },
                    {
                        "name": "Schnelligkeit X",
                        "level": 19,
                        "value": "Wie Schnelligkeit I, nur ist die Spruchdauer 10 Runden"
                    },
                    {
                        "name": "Blitzschnell V",
                        "level": 20,
                        "value": "Wie Blitzschnell I, nur ist die Spruchdauer 5 Runden"
                    },
                    {
                        "name": "Wahrhaftiges Ausweichen",
                        "level": 25,
                        "value": "Wie Ausweichen I, nur kann der Zauberer allen Angriffen ausweichen"
                    },
                    {
                        "name": "Blitzschnell X",
                        "level": 30,
                        "value": "Wie Blitzschnell I, nur ist die Spruchdauer 10 Runden"
                    },
                    {
                        "name": "Wahrhaftige Mönchsbewegung",
                        "level": 50,
                        "value": "Der Zauberer kann in jeder Runde einen der niedrigstufigeren Sprüche anwenden (außer Schnelligkeits- und Blitzschnell-Sprüchen)."
                    }
                ]
            },
            {
                "id": "11.1",
                "name": "9.5.2: Geist über Materie",
                "spells": [
                    {
                        "name": "Körperwaffe I",
                        "level": 1,
                        "value": "Der Zauberer erhält einen besonderen Bonus von +5 auf Waffenlose Angriffe"
                    },
                    {
                        "name": "Fokuskampf II",
                        "level": 2,
                        "value": "Der Zauberer erhält einen besonderen Bonus von +20 auf alle Fokus-Fertigkeiten außer Fokus Verteidigung"
                    },
                    {
                        "name": "Geschoßmeister II",
                        "level": 3,
                        "value": "Der Zauberer erhält einen besonderen Bonus von +20 auf alle Manöver, um Geschoßangriffe abzuwehren, abzublocken oder zu parieren"
                    },
                    {
                        "name": "Bruchtest I",
                        "level": 5,
                        "value": "Der Zauberer kann einen unbelebten Gegenstand schlagen und ihm Schaden zufügen (ohne selbst welchen zu erleiden). Der Zauberer führt einen normalen Waffenlosen Schlag gegen den Gegenstand aus. Zusätzlich besteht eine Chance, daß der getroffene Gegenstand zerbricht, wenn er irgendwelche Fehler hat (z.B. Risse, Brüche usw.). Die Chance ist 10% plus je 5% pro Schwere des Kritischen Treffers, den der Angriff verursachte (z.B. Kritischer A-Treffer: 15%, kritischer BTreffer: 20% etc.)"
                    },
                    {
                        "name": "Fokuskampf III",
                        "level": 6,
                        "value": "Wie Fokuskampf II, nur ist der Bonus +30"
                    },
                    {
                        "name": "Körperwaffe II",
                        "level": 7,
                        "value": "Wie Körperwaffe I, nur ist der Bonus +10"
                    },
                    {
                        "name": "Geschoßmeister III",
                        "level": 8,
                        "value": "Wie Geschoßmeister II, nur ist der Bonus +30"
                    },
                    {
                        "name": "Körperrüstung III",
                        "level": 9,
                        "value": "Für die Spruchdauer wird der Zauberer behandelt, als hätte er Rüstungsklasse 3 (der Spruch wirkt nur, wenn der Zauberer gar keine Rüstung trägt)"
                    },
                    {
                        "name": "Löwenherz",
                        "level": 10,
                        "value": "Der Zauberer kann die Auswirkungen des ersten kritischen Treffers, den er einsteckt, ignorieren. Wenn der Spruch ausläuft, setzen diese Wirkungen normal ein. Es kann immer nur eine Wunde auf diese Weise ignoriert werden (der Zauberer kann nicht mehr als einen Löwenherz-Spruch gleichzeitig aktiv haben)"
                    },
                    {
                        "name": "Fokuskampf IV",
                        "level": 11,
                        "value": "Wie Fokuskampf II, nur ist der Bonus +40"
                    },
                    {
                        "name": "Bruchtest II",
                        "level": 12,
                        "value": "Wie Bruchtest I, nur ist die Chance, daß der Gegenstand zerbricht, 25% plus 5% pro Schwere des kritischen Treffers"
                    },
                    {
                        "name": "Körperwaffe III",
                        "level": 13,
                        "value": "Wie Körperwaffe I, nur ist der Bonus +15"
                    },
                    {
                        "name": "Geschoßmeister IV",
                        "level": 14,
                        "value": "Wie Geschoßmeister II, nur ist der Bonus +40"
                    },
                    {
                        "name": "Fokuskampf V",
                        "level": 15,
                        "value": "Wie Fokuskampf II, nur ist der Bonus +50"
                    },
                    {
                        "name": "Körperrüstung IV",
                        "level": 16,
                        "value": "Für die Spruchdauer wird der Zauberer behandelt, als hätte er Rüstungsklasse 4 (der Spruch wirkt nur, wenn der Zauberer gar keine Rüstung trägt)"
                    },
                    {
                        "name": "Bruchtest III",
                        "level": 17,
                        "value": "Wie Bruchtest I, nur ist die Chance, daß der Gegenstand zerbricht, 40% plus 5% pro Schwere des kritischen Treffers"
                    },
                    {
                        "name": "Geschoßmeister V",
                        "level": 18,
                        "value": "Wie Geschoßmeister II, nur ist der Bonus +50"
                    },
                    {
                        "name": "Körperwaffe IV",
                        "level": 19,
                        "value": "Wie Körperwaffe I, nur ist der Bonus +20"
                    },
                    {
                        "name": "Wahrhaftiger Fokuskampf",
                        "level": 20,
                        "value": "Wie Fokuskampf II, nur ist der Bonus +75"
                    },
                    {
                        "name": "Wahrhaftige Körperwaffe",
                        "level": 25,
                        "value": "Wie Körperwaffe I, nur ist der Bonus +30"
                    },
                    {
                        "name": "Wahrhaftiger Bruchtest",
                        "level": 30,
                        "value": "Wie Bruchtest I, nur ist die Chance, daß der Gegenstand zerbricht, 50% plus 10% pro Schwere des kritischen Treffers"
                    },
                    {
                        "name": "Geist über Materie",
                        "level": 50,
                        "value": "Der Zauberer kann in jeder Runde einen niedrigstufigeren Spruch dieser Liste anwenden."
                    }
                ]
            },
            {
                "id": "11.2",
                "name": "9.5.3: Körper erneuern",
                "spells": [
                    {
                        "name": "Blutung stoppen I",
                        "level": 1,
                        "value": "Verringert die Blutung des Zauberers um 1 pro Runde, solange er sich konzentriert oder unbeweglich ist. Beispielsweise würde dieser Spruch eine Blutung von 4 Treffern pro Runde auf eine von 3 Treffern pro Runde verringern. Wenn der Zauberer mehrere blutende Wunden hat, betrifft das nur eine davon"
                    },
                    {
                        "name": "Gerinnung I",
                        "level": 2,
                        "value": "Wie Blutung stoppen I, nur hört die Blutung nach einer Stunde ganz auf. Wenn der Zauberer bewußtlos ist, funktioniert der Spruch auch ohne Konzentration"
                    },
                    {
                        "name": "Benommenheit heilen I",
                        "level": 3,
                        "value": "Der Zauberer wird von 1 Runde angesammelter Benommenheit geheilt"
                    },
                    {
                        "name": "Regenerieren I",
                        "level": 4,
                        "value": "Heilt einen Treffer pro Minute, solange sich der Zauberer konzentriert. Wenn der Zauberer bewußtlos ist, funktioniert der Spruch auch ohne Konzentration"
                    },
                    {
                        "name": "Blutung stillen I",
                        "level": 5,
                        "value": "Wie Gerinnung I, nur hört die Blutung sofort auf"
                    },
                    {
                        "name": "Bruchheilung",
                        "level": 6,
                        "value": "Wenn sich der Zauberer unter der Wirkung dieses Spruchs an 1-10 Tagen (je nach Schwere des Bruchs) jeweils 2 Stunden lang konzentriert, kann er einen Knochenbruch heilen (keinen Trümmerbruch oder zerstörten Knochen)"
                    },
                    {
                        "name": "Muskel-/Sehnenheilung",
                        "level": 7,
                        "value": "Wie Bruchheilung, nur können gerissene oder verletzte Muskeln oder Sehnen geheilt werden"
                    },
                    {
                        "name": "Gerinnung III",
                        "level": 8,
                        "value": "Wie Gerinnung I, nur kann die Blutung um 3 Treffer pro Runde verringert werden"
                    },
                    {
                        "name": "Benommenheit heilen III",
                        "level": 9,
                        "value": "Wie Benommenheit I, nur können 3 Runden Benommenheit geheilt werden"
                    },
                    {
                        "name": "Gift widerstehen",
                        "level": 10,
                        "value": "Verzögert die Wirkung eines Gifts, solange sich der Zauberer konzentriert"
                    },
                    {
                        "name": "Regenerieren II",
                        "level": 11,
                        "value": "Wie Regenerieren I, nur heilt der Spruch 2 Treffer pro Minute"
                    },
                    {
                        "name": "Vene/Arterie heilen",
                        "level": 12,
                        "value": "Wie Bruchheilung, nur wird eine Vene oder Arterie geheilt"
                    },
                    {
                        "name": "Blutung stillen III",
                        "level": 13,
                        "value": "Wie Blutung stillen I, nur kann eine Blutung von 3 Treffern pro Runde gestillt werden"
                    },
                    {
                        "name": "Wahrhaftige Bruchheilung",
                        "level": 14,
                        "value": "Wie Bruchheilung, nur erfordert die Heilung nur eine zweistündige Konzentration an einem Tag"
                    },
                    {
                        "name": "Wahrhaftige Muskel-/Sehnenheilung",
                        "level": 15,
                        "value": "Wie Wahrhaftige Brucheilung, nur können gerissene oder verletzte Muskeln oder Sehnen geheilt werden"
                    },
                    {
                        "name": "Heilung leichter Nervenschäden",
                        "level": 16,
                        "value": "Heilt leichten Schaden an einem Nerv und erfordert eine eintägige Genesungszeit. Als ein leichter Nervenschaden gilt jeder Nervenschaden, der sich in einem Abzug von bis zu -20 äußert"
                    },
                    {
                        "name": "Auge/Ohr heilen",
                        "level": 17,
                        "value": "Wenn sich der Zauberer unter der Wirkung dieses Spruchs an 1-10 Tagen (je nach Schwere der Verletzung) jeweils 2 Stunden konzentriert, kann er einen beliebigen Schaden am Außenohr (auch den Verlust des Ohrs) oder leichte Augenschäden (Hornhautabschürfung, Fremdkörper im Auge) heilen"
                    },
                    {
                        "name": "Selbstanfügen",
                        "level": 18,
                        "value": "Erlaubt dem Zauberer, eine abgetrennte Gliedmaße wieder anzufügen"
                    },
                    {
                        "name": "Krankheit neutralisieren",
                        "level": 19,
                        "value": "Dieser Spruch hat eine 50% Chance, eine beliebige Krankheit zu neutralisieren (modifiziert durch die Gefährlichkeit der Krankheit), wenn der Zauberer bewußtlos ist oder sich eine Stunde lang darauf konzentriert. Auf jeden Fall verzögert der Spruch den Krankeitsausbruch, solange sich der Zauberer konzentriert"
                    },
                    {
                        "name": "Gift neutralisieren",
                        "level": 20,
                        "value": "Dieser Spruch hat eine 50% Chance, eine beliebige Krankheit zu neutralisieren (modifiziert durch die Giftstärke), wenn der Zauberer bewußtlos ist oder sich eine Stunde lang darauf konzentriert. Auf jeden Fall verzögert der Spruch die Giftwirkung, solange sich der Zauberer konzentriert"
                    },
                    {
                        "name": "Wahrhaftige Gerinnung",
                        "level": 25,
                        "value": "Wie Gerinnung I, nur wird jegliche Blutung gestoppt und die Spruchwirkung ist dauerhaft, wenn sich der Zauberer pro Treffer Blutung eine Minute lang auf die Heilung konzentriert"
                    },
                    {
                        "name": "Wahrhaftige Gift-/Krankheitsneutralisierung",
                        "level": 30,
                        "value": "Wie Gift neutralisieren und Krankheit neutralisieren gleichzeitig, nur ist die Chance für die Neutralisation 100% (modifiziert)"
                    },
                    {
                        "name": "Wahrhaftige Erneuerung",
                        "level": 50,
                        "value": "Wenn er in Trance ist (durch Selbstbewahrung auf der Liste Körperkontrolle), kann er jeden der niedrigstufigeren Heilsprüche auf dieser Liste anwenden, um sich selbst zu heilen."
                    }
                ]
            },
            {
                "id": "11.3",
                "name": "9.5.4: Körperkontrolle",
                "spells": [
                    {
                        "name": "Balancieren",
                        "level": 1,
                        "value": "Verleiht einen Bonus von +50 auf ein einzelnes langsames Manöver, für das Balance erforderlich ist (z.B. auf einem 8cm breiten Balken entlanggehen)"
                    },
                    {
                        "name": "Winden",
                        "level": 2,
                        "value": "Erlaubt dem Zauberer seine Muskeln, Gliedmaßen und seinen Oberkörper leicht zu verändern, wodurch er sich aus Fesseln befreien kann und durch schmale Öffnungen gelangen kann. Der Spruch verleiht einen besonderen Bonus von +25 -+50 auf die Fertigkeit Entfeßlungskünstler"
                    },
                    {
                        "name": "Konzentration II",
                        "level": 3,
                        "value": "Gibt einen Bonus von +20 auf ein beliebiges Manöver. In der Runde, in der das Manöver ausgeführt wird, kann keine andere Aktion unternommen werden"
                    },
                    {
                        "name": "Schmerz ertragen I",
                        "level": 4,
                        "value": "Der Zauberer kann 25% seiner Trefferpunkte zusätzlich an Schaden erleiden, bevor er das Bewußtsein verliert. Er steckt diese Treffer immer noch ein, und sie bleiben, wenn der Spruch aufhört zu wirken"
                    },
                    {
                        "name": "Gesicht wandeln",
                        "level": 5,
                        "value": "Erlaubt es dem Zauberer, die Form seines Gesichts so zu verändern, daß er jemandem anderen ähnelt"
                    },
                    {
                        "name": "Kiemen",
                        "level": 6,
                        "value": "Der Zauberer kann für die Spruchdauer Wasser atmen, aber keine Luft"
                    },
                    {
                        "name": "Konzentration III",
                        "level": 7,
                        "value": "Wie Konzentration I, nur ist der Bonus +30"
                    },
                    {
                        "name": "Stärke II",
                        "level": 8,
                        "value": "Im Nahkampf fügt der Zauberer doppelten Trefferpunktschaden zu, und sein Stärkebonus ist verdoppelt"
                    },
                    {
                        "name": "Schmerz ertragen II",
                        "level": 9,
                        "value": "Wie Schmerz ertragen I, nur kann der Zauberer 50% seiner Trefferpunkte zusätzlich einstecken"
                    },
                    {
                        "name": "Körper wandeln",
                        "level": 10,
                        "value": "Wie Gesicht wandeln, nur kann der Zauberer seine Gestalt so verändern, daß sie von der Größe und Form her der eines Angehörigen eines gewünschten humanoiden Volks gleicht (sie kann nur maximal 25% von der Masse des Zauberers abweichen)"
                    },
                    {
                        "name": "Konzentration IV",
                        "level": 11,
                        "value": "Wie Konzentration I, nur ist der Bonus +40"
                    },
                    {
                        "name": "Stärke III",
                        "level": 12,
                        "value": "Wie Stärke II, nur werden die Trefferpunkte, die der Zauberer zufügt, und sein Stärkebonus verdreifacht"
                    },
                    {
                        "name": "Aufwachen",
                        "level": 13,
                        "value": "Läßt den Zauberer aus jedem unnatürlichen Schlaf (z.B. durch einen Schlafspruch, eine Schlafdroge usw.) aufwachen. Der Zauberer braucht dazu eine Runde"
                    },
                    {
                        "name": "Gaslungen",
                        "level": 14,
                        "value": "Wie Kiemen, aber der Zauberer kann jedes Gas wie normale Luft atmen"
                    },
                    {
                        "name": "Schmerz ertragen III",
                        "level": 15,
                        "value": "Wie Schmerz ertragen I, nur kann der Zauberer 75% seiner Trefferpunkte zusätzlich einstecken"
                    },
                    {
                        "name": "Konzentration V",
                        "level": 16,
                        "value": "Wie Konzentration I, nur ist der Bonus +50"
                    },
                    {
                        "name": "Mönchsschlaf",
                        "level": 17,
                        "value": "Dieser Spruch halbiert die Zeitspanne, die normalerweise nötig ist, um sich auszuruhen. Beispielsweise würde der Zauberer nach einem normalen Tag nur 4 Stunden Schlaf benötigen, statt der normalen 8. Der Spruch bleibt während des gesamten Schlafes wirksam"
                    },
                    {
                        "name": "Schmerz ertragen IV",
                        "level": 18,
                        "value": "Wie Schmerz ertragen I, nur kann der Zauberer 100% seiner Trefferpunkte zusätzlich einstecken"
                    },
                    {
                        "name": "Meditativer Schlaf",
                        "level": 19,
                        "value": "Während er normal schläft, kann der Zauberer Wahrnehmungswürfe ohne Abzüge machen (solange für sie keine Sicht nötig ist)"
                    },
                    {
                        "name": "Selbstbewahrung",
                        "level": 20,
                        "value": "Wenn er einen tödlichen Treffer erleidet, fällt der Zauberer in einen Scheintodzustand, bis er geheilt oder sein Gehirn zerstört wird"
                    },
                    {
                        "name": "Wahrhaftiger Mönchsschlaf",
                        "level": 25,
                        "value": "Wie Mönchsschlaf und Meditativer Schlaf gleichzeitig"
                    },
                    {
                        "name": "Stärke IV",
                        "level": 30,
                        "value": "Wie Stärke II, nur werden die Trefferpunkte, die der Zauberer zufügt, und sein Stärkebonus vervierfacht"
                    },
                    {
                        "name": "Wahrhaftiges Schmerzertragen",
                        "level": 50,
                        "value": "Wie Schmerz ertragen I, nur ignoriert der Zauberer jeden Schmerz, also auch alle Abzüge (d.h. negative Modifikatoren auf Aktionen) durch Wunden, und seine gesamten Trefferpunkte entsprechen seinen normalen Trefferpunkten plus seiner Konstitution (auf einer Skala von 1-100). Wenn er diese Maximalgrenze überschreitet, wird er nicht bewußtlos, sondern stirbt durch systemischen Schock."
                    }
                ]
            },
            {
                "id": "11.4",
                "name": "9.5.5: Mönchsbrücke",
                "spells": [
                    {
                        "name": "Springen I",
                        "level": 1,
                        "value": "Gestattet es dem Ziel, in der Runde, in der der Spruch gewirkt wird, bis zu 15 Meter weit oder 6 Meter hoch zu springen"
                    },
                    {
                        "name": "Landen",
                        "level": 2,
                        "value": "Gestattet es dem Ziel, bei einem Sturz von bis zu 6 Meter pro Stufe des Zauberers sicher zu landen. Stürzt es aus noch größerer Höhe, werden die 6m pro Stufe abgezogen, bevor die Schwere des Schadens bestimmt wird"
                    },
                    {
                        "name": "Bodenhaftung",
                        "level": 3,
                        "value": "Der Zauberer kann auf rutschigen, unsicheren Untergrund (Sand, Eis usw.) genauso laufen, wie auf hartem, sicheren"
                    },
                    {
                        "name": "Gehen auf Kanten",
                        "level": 4,
                        "value": "Das Ziel kann auf ebenen, schmalen Oberflächen (Mindestbreite 6cm) so laufen als liefe er auf normalem Boden"
                    },
                    {
                        "name": "Springen III",
                        "level": 5,
                        "value": "Wie Springen I, nur kann der Zauberer drei mal kurz hintereinander so springen. Jeder der Sprünge muß in einem Winkel von 90° zum vorangehenden sein"
                    },
                    {
                        "name": "Punktdrehung I",
                        "level": 6,
                        "value": "Erlaubt dem Zauberer, eine 180°-Drehung auszuführen, ohne abbremsen zu müssen oder das Gleichgewicht zu verlieren (dieser Spruch kann mit jedem Laufen/Lauf-Spruch zusammen verwendet werden)"
                    },
                    {
                        "name": "Levitation",
                        "level": 7,
                        "value": "Erlaubt es dem Ziel, sich bis zu 3 Meter pro Runde senkrecht auf und ab zu bewegen. Jedwede waagerechte Bewegung muß anders erreicht werden"
                    },
                    {
                        "name": "Wahrhaftiges Landen",
                        "level": 8,
                        "value": "Wie Landen, nur landet der Zauberer in 99% der Fälle sicher"
                    },
                    {
                        "name": "Gehen auf Wänden",
                        "level": 9,
                        "value": "Der Zauberer kann auf festen Oberflächen, die bis 90° abgewinkelt sind, so laufen wie auf normalem Boden"
                    },
                    {
                        "name": "Großer Sprung",
                        "level": 10,
                        "value": "Wie Springen I, nur kann der Zauberer bis zu 3m pro Stufe hoch oder 1,5m pro Stufe weit springen"
                    },
                    {
                        "name": "Punktdrehung III",
                        "level": 11,
                        "value": "Wie Punktdrehung I, nur kann der Zauberer drei solcher Drehungen in einer Runde ausführen"
                    },
                    {
                        "name": "Wandsalto",
                        "level": 12,
                        "value": "Wenn innerhalb von 3m Entfernung eine Wand ist, kann der Zauberer an ihr hochspringen, sich abstoßen und bis zu 8m entfernt von ihr landen (mit beliebiger Blickrichtung"
                    },
                    {
                        "name": "Laufen an Wänden",
                        "level": 13,
                        "value": "Wie Gehen an Wänden, nur kann der Zauberer laufen"
                    },
                    {
                        "name": "Versetzen I",
                        "level": 14,
                        "value": "Der Zauberer teleportiert sich an einen bis zu 30 Meter entfernten Ort. Es dürfen sich keine Hindernisse auf direkter Linie zwischen Start- und Zielpunkt befinden. Als Hindernis gilt hierbei alles, was der Zauberer nicht körperlich durchqueren könnte (eine geschlossene Tür ist ein Hindernis, eine Fallgrube nicht)"
                    },
                    {
                        "name": "Brisenlauf",
                        "level": 15,
                        "value": "Der Zauberer kann auf der Luft laufen, wenn Wind weht. Allerdings kann er nicht gegen den Wind anrennen und wenn er in eine andere Richtung läuft, wird seine Bewegungsrate durch die Windgeschwindigkeit beeinflußt (es wirkt wie der Wind auf ein Segelboot)"
                    },
                    {
                        "name": "Laufen auf Flüssigkeiten",
                        "level": 16,
                        "value": "Der Zauberer läuft auf einer beliebigen Flüssigkeitsoberfläche wie auf ebenem Boden"
                    },
                    {
                        "name": "Versetzen III",
                        "level": 18,
                        "value": "Wie Versetzen I, nur ist die Reichweite 100m"
                    },
                    {
                        "name": "Wahrhaftiger Brisenlauf",
                        "level": 19,
                        "value": "W ie Brisenlauf, nur kann der Zauberer auch gegen die Windrichtung laufen, und seine Bewegungsrate bleibt von der Windgeschwindigkeit unbeeinflußt"
                    },
                    {
                        "name": "Gehen an Decken",
                        "level": 20,
                        "value": "Der Zauber kann auf jeder festen Oberfläche laufen wie auf normalem Boden (auch Decken)"
                    },
                    {
                        "name": "Laufen an Decken",
                        "level": 25,
                        "value": "Wie Gehen an Decken, nur kann der Zauberer laufen"
                    },
                    {
                        "name": "Wahrhaftiges Laufen",
                        "level": 30,
                        "value": "Der Zauberer kann in jeder Runde einen beliebigen niedrigstufigeren Laufen/Lauf-Spruch anwenden"
                    },
                    {
                        "name": "Mönchsbrücke",
                        "level": 50,
                        "value": "Der Zauberer kann in jeder Runde einen beliebigen niedrigstufigeren Spruch auf dieser Liste anwenden. Besondere Anmerkungen In Abschnitt 5.6 (Seite 37) finden Sie weitere Informationen zu Belastungsgrenzen bei Bewegungssprüchen."
                    }
                ]
            },
            {
                "id": "11.5",
                "name": "9.5.6: Mönchssinne",
                "spells": [
                    {
                        "name": "Listige Ohren",
                        "level": 1,
                        "value": "Der Zauberer erhält ein doppelt so gutes Gehör. Dadurch erlangt er einen besonderen Bonus von +50 auf Fertigkeiten der Gruppen Wahrnehmung • Suchen und Wahrnehmung • Sinne, sofern dabei nur das Gehör eine Rolle spielt, wenn auch andere Sinne beteiligt sind, sinkt er auf +25"
                    },
                    {
                        "name": "Nachtsicht",
                        "level": 2,
                        "value": "Der Zauberer kann in einer normalen Nacht 30 Meter weit sehen, als wäre es Tag. Vgl. Abschnitt 5.12 (Seite 39)"
                    },
                    {
                        "name": "Rundumsicht",
                        "level": 3,
                        "value": "Der Zauberer hat ein Gesichtsfeld von 300°. Der Bonus für Angriffe aus der Flanke gegen ihn reduziert sich auf +5 und der für Angriffe von hinten auf +15"
                    },
                    {
                        "name": "Geruchssinn",
                        "level": 4,
                        "value": "Der Zauberer erlangt einen ausgesprochen guten Geruchssinn. Dies drückt sich in einem Bonus von +50 auf Wahrnehmungswürfe aus, in denen nur der Geruchssinn eine Rolle spielt, wenn auch andere Sinne beteiligt sind, sinkt er auf +25"
                    },
                    {
                        "name": "Wassersicht",
                        "level": 5,
                        "value": "Der Zauberer kann in Wasser, selbst in schlammigem und trübem, 30 Meter weit sehen"
                    },
                    {
                        "name": "Nebelsicht",
                        "level": 6,
                        "value": "Der Zauberer kann in jeder Art von Niederschlag (auch in dichtem Nebel) sehen wie bei klarem Himmel am Tag"
                    },
                    {
                        "name": "Fühlen",
                        "level": 7,
                        "value": "Der Zauberer bekommt einen besonders guten Tastsinn. Dadurch erhält er einen Bonus von +25 auf alle Aktionen, die vom Tastsinn abhängen (z.B. Schlösser öffnen, Fallen entschärfen usw.)"
                    },
                    {
                        "name": "Dunkelsicht",
                        "level": 8,
                        "value": "Wie Nachtsicht, aber der Zauberer kann in jeder Dunkelheit sehen. Außerdem funktioniert der Spruch auch ganz ohne Licht"
                    },
                    {
                        "name": "Unsichtbares entdecken",
                        "level": 9,
                        "value": "Entdeckt Unsichtbares im Wirkungsbereich. Der Zauberer kann sich in jeder Runde auf einen anderen 2mRadius konzentrieren"
                    },
                    {
                        "name": "Illusion entdecken",
                        "level": 10,
                        "value": "Der Zauberer kann einen Gegenstand oder Ort (bis zu einem Radius von 2m) überprüfen und feststellen, ob er eine Illusion ist oder mit einer belegt wurde"
                    },
                    {
                        "name": "Wahrhaftiger Geruchssinn",
                        "level": 11,
                        "value": "Wie Geruchssinn, nur kann der Zauberer auch ganz schwache Gerüche wahrnehmen (d.h. nach 48 Stunden, nach starkem Regen, durch Schnee)"
                    },
                    {
                        "name": "Desillusion",
                        "level": 12,
                        "value": "Eine Illusion im Wirkungsbereich erlischt allein für den Zauberer"
                    },
                    {
                        "name": "Wahrhaftiges Fühlen",
                        "level": 13,
                        "value": "Wie Fühlen, nur ist der Bonus +50"
                    },
                    {
                        "name": "Holzsicht",
                        "level": 14,
                        "value": "Der Zauberer kann durch Holz hindurchsehen, das bis zu 3cm pro Stufe dick sein kann"
                    },
                    {
                        "name": "Unsichtbares sehen",
                        "level": 15,
                        "value": "Der Zauberer kann dort Unsichtbares sehen, wo er überhaupt etwas sehen kann. Zusätzlich erleidet er keine Abzüge im Kampf gegen unsichtbare Ziele (da sie für ihn nicht unsichtbar sind)"
                    },
                    {
                        "name": "Weitsicht",
                        "level": 17,
                        "value": "Wie jeder der anderen Sichtsprüche auf dieser Liste, nur ohne Reichweitebeschränkung. (D.h. der Zauberer kann so weit sehen, wie er es normal könnte)"
                    },
                    {
                        "name": "Illusionssicht",
                        "level": 18,
                        "value": "Der Zauberer sieht sichtbare Illusionen nicht. Dies betrifft keinen der anderen Sinne"
                    },
                    {
                        "name": "Steinsicht",
                        "level": 19,
                        "value": "Wie Holzsicht, nur kann der Zauberer durch Stein sehen"
                    },
                    {
                        "name": "Mönchssicht",
                        "level": 20,
                        "value": "Wie alle niedrigstufigeren Sicht-Sprüche gleichzeitig"
                    },
                    {
                        "name": "Eisensicht",
                        "level": 25,
                        "value": "Wie Holzsicht, nur kann der Zauberer durch Eisen (oder Stahl) sehen"
                    },
                    {
                        "name": "Metallsicht",
                        "level": 30,
                        "value": "Wie Holzsicht, nur kann der Zauberer durch jedes Metall sehen"
                    },
                    {
                        "name": "Mönchssinne",
                        "level": 50,
                        "value": "Der Zauberer kann in jeder Runde einen beliebigen niedrigstufigeren Spruch auf dieser Liste anwenden."
                    }
                ]
            }
        ]
    },
    {
        "id": "12",
        "name": "Basisliste Trickser",
        "spellLists": [
            {
                "id": "12.0",
                "name": "9.6.1: Beeinflussung",
                "spells": [
                    {
                        "name": "Schlaf III",
                        "level": 1,
                        "value": "Die Ziele fallen in einen natürlichen Schlaf. Der Zauberer kann eine Zahl von Zielen ins Reich der Träume schicken, deren Stufen zusammen 3 ergeben. Der Zauberer muß alle Ziele sehen. Beim Wirken des Spruches muß eine Zielpriorität festgelegt werden (also treffe Ziel 1, wenn Stufen übrig sind, dann treffe Ziel 2 usw.). Die ersten 2 Runden sind magischer Schlaf (das Ziel kann nicht auf normale Weise geweckt werden), danach ist es normaler Schlaf"
                    },
                    {
                        "name": "Tiere bezaubern",
                        "level": 2,
                        "value": "Die Tiere halten den Zauberer für einen guten Freund"
                    },
                    {
                        "name": "Bezaubern",
                        "level": 3,
                        "value": "Ein humanoides Ziel hält den Zauberer für einen guten Freund"
                    },
                    {
                        "name": "Schlaf V",
                        "level": 4,
                        "value": "Wie Schlaf III, aber es können bis zu 5 Stufen betroffen werden"
                    },
                    {
                        "name": "Suggestion",
                        "level": 5,
                        "value": "Das Ziel führt eine ihm suggerierte Handlung aus, sofern sie nicht im Widerspruch zu seiner Natur steht (d.h. kein Selbstmord, keine Selbstblendung usw.)"
                    },
                    {
                        "name": "Telepathie I",
                        "level": 6,
                        "value": "Der Zauberer kann oberflächliche Gedanken des Ziels empfangen. Gelingt dem Ziel aber der WW mit mehr als 25, bemerkt es den Versuch, die Gedanken zu lesen"
                    },
                    {
                        "name": "Schlaf VII",
                        "level": 7,
                        "value": "Wie Schlaf III, aber es können bis zu 7 Stufen betroffen werden"
                    },
                    {
                        "name": "Halten",
                        "level": 8,
                        "value": "Das humanoide Ziel hat nur 25% Aktivität pro Runde"
                    },
                    {
                        "name": "Größeres Bezaubern",
                        "level": 9,
                        "value": "Wie Bezaubern, aber es betrifft ein Ziel pro (angefangene) 5 Stufen des Zauberers. Hat der Zauberer beispielsweise die Stufe 11, so betrifft dieser Spruch drei Ziele"
                    },
                    {
                        "name": "Schlaf X",
                        "level": 10,
                        "value": "Wie Schlaf III, aber es können bis zu 10 Stufen betroffen werden"
                    },
                    {
                        "name": "Starke Suggestion",
                        "level": 11,
                        "value": "Wie Suggestion, aber es betrifft ein Ziel pro (angefangene) 5 Stufen des Zauberers. Hat der Zauberer beispielsweise die Stufe 11, so betrifft dieser Spruch drei Ziele"
                    },
                    {
                        "name": "Kontrollieren",
                        "level": 12,
                        "value": "Das humanoide Ziel muß dem Zauberer gehorchen. Allerdings führt er keine Handlungen aus, die ihm völlig fremd wären (d.h. kein Selbstmord, keine Selbstblendung usw.)"
                    },
                    {
                        "name": "Schlaf XII",
                        "level": 13,
                        "value": "Wie Schlaf III, aber es können bis zu 12 Stufen betroffen werden"
                    },
                    {
                        "name": "Mächtiges Halten",
                        "level": 14,
                        "value": "Wie Halten, aber es betrifft ein Ziel pro (angefangene) 5 Stufen des Zauberers. Hat der Zauberer beispielsweise die Stufe 11, so betrifft dieser Spruch drei Ziele"
                    },
                    {
                        "name": "Telepathie II",
                        "level": 15,
                        "value": "Wie Telepathie I, abgesehen von der Reichweite"
                    },
                    {
                        "name": "Schlaf XV",
                        "level": 16,
                        "value": "Wie Schlaf III, aber es können bis zu 15 Stufen betroffen werden"
                    },
                    {
                        "name": "Mächtiges Kontrollieren",
                        "level": 18,
                        "value": "Wie Kontrollieren, aber es betrifft ein Ziel pro (angefangene) 5 Stufen des Zauberers. Hat der Zauberer beispielsweise die Stufe 11, so betrifft dieser Spruch drei Ziele"
                    },
                    {
                        "name": "Queste",
                        "level": 19,
                        "value": "Dem Ziel wird ein Auftrag erteilt. Ein Scheitern hierin führt zu einer Strafe, die der Spielleiter festlegt (der Auftrag darf die Fähigkeiten des Ziels nicht übersteigen). Wenn das Ziel den Auftrag ignoriert, erleidet es die gleiche Strafe wie für ein Scheitern"
                    },
                    {
                        "name": "Meister-Schlaf",
                        "level": 20,
                        "value": "Wie Schlaf III, aber es können bis zu 20 Stufen betroffen werden"
                    },
                    {
                        "name": "Wahrhaftiger Schlaf",
                        "level": 25,
                        "value": "Wie Schlaf III, nur kann der Spruch die Stufe des Zauberers an Zielen betreffen"
                    },
                    {
                        "name": "Wahrhaftige Telepathie",
                        "level": 30,
                        "value": "Wie Telepathie I, abgesehen von der Reichweite"
                    },
                    {
                        "name": "Wahrhaftige Queste",
                        "level": 50,
                        "value": "Wie Queste, nur erleidet das Ziel fünf kritische Treffer der Intensität E, wenn es versagt (die Art der kritischen Treffer wird per Zufall bestimmt)."
                    }
                ]
            },
            {
                "id": "12.1",
                "name": "9.6.2: Gesetz des Diebes",
                "spells": [
                    {
                        "name": "Reichtum schätzen",
                        "level": 1,
                        "value": "Der Zauberer bekommt ein Gefühl dafür, für wie reich sich das Ziel hält. Bedenken Sie, daß dies sich drastisch zu den tatsächlichen Geldmitteln des Ziels unterscheiden kann (der Reichtum kann auch Land, Nutztiere usw. beinhalten)"
                    },
                    {
                        "name": "Taschen wiegen",
                        "level": 2,
                        "value": "Der Zauberer erfährt ungefähr, wieviel Geld das Ziel bei sich trägt"
                    },
                    {
                        "name": "Ziel markieren",
                        "level": 3,
                        "value": "Der Zauberer markiert ein Ziel auf magische Weise, um es später mittels Ziel finden wiederzufinden. Der Zauberer kann nur jeweils ein Ziel markiert haben"
                    },
                    {
                        "name": "Käufer finden I",
                        "level": 4,
                        "value": "Gibt die Richtung und Entfernung zur nächsten Person im Wirkungsbereich an, die ein bestimmtes Objekt erwerben möchte. Der Zauberer muß das Objekt beim Wirken des Spruches berühren. Gibt es keine solche Person, liefert der Spruch kein Ergebnis"
                    },
                    {
                        "name": "Ziel finden",
                        "level": 5,
                        "value": "Der Zauberer erfährt die genaue Richtung und Entfernung zu seinem markierten Ziel, sofern es sich im Wirkungsbereich aufhält"
                    },
                    {
                        "name": "Juwelen/Metalle",
                        "level": 6,
                        "value": "Der Zauberer kann den Wert von Juwelen und Metallen mit einem Fehler von ±10% des tatsächlichen Werts abschätzen. Er kann den Wert sogar kulturspezifisch abschätzen. Dieser Spruch bewertet jedoch nur das Material, nicht die Handwerksarbeit"
                    },
                    {
                        "name": "Objekt schätzen",
                        "level": 7,
                        "value": "Wie Juwelen/Metalle, aber er gilt für alle Objekte, und hier wird die Handwerksarbeit mit berücksichtigt. Nicht jedoch eventuelle magische Fähigkeiten"
                    },
                    {
                        "name": "Käufer finden II",
                        "level": 8,
                        "value": "Liefert die Richtung und Entfernung zur nächsten Person im Wirkungsbereich, die das Objekt haben will und auch zum gegenwärtigen Zeitpunkt in seinen Besitz bekommen will. Der Zauberer muß das Objekt berühren. Gibt es keine solche Person, liefert der Spruch kein Ergebnis"
                    },
                    {
                        "name": "Macht erkennen",
                        "level": 9,
                        "value": "Entdeckt magische Macht in einem Gegenstand (aber nicht den Magiebereich oder weitere Einzelheiten)"
                    },
                    {
                        "name": "Gegenstandsanalyse I",
                        "level": 10,
                        "value": "Der Zauberer hat eine Chance von 10%, die magischen Fähigkeiten eines Gegenstands zu bestimmen (würfeln Sie einmal pro Fähigkeit). Wenn dieser Spruch einmal auf einen Gegenstand angewendet wurde, kann er auf diesen Gegenstand erst dann wieder gewirkt werden, wenn der Zauberer eine neue Stufe erreicht hat"
                    },
                    {
                        "name": "Besitzer finden I",
                        "level": 11,
                        "value": "Der Zauberer weiß, wo sich der Besitzer eines bestimmten Objekts aufhält (er muß den Gegenstand zu dem Zeitpunkt berühren, wenn er den Spruch wirkt). Der Besitzer muß sich innerhalb des Wirkungsbereichs befinden. Hinsichtlich dieses Spruchs gilt derjenige als Besitzer, dem der Gegenstand „rechtmäßig“ gehört. Der SL muß festlegen, was rechtmäßigen Besitz in seiner Welt ausmacht (z.B. der Schöpfer des Gegenstands, der Käufer eines geschaffenen Gegenstands, der Besitzer usw.)"
                    },
                    {
                        "name": "Käufer finden III",
                        "level": 12,
                        "value": "Liefert die Richtung und Entfernung zur nächsten Person, die das Objekt haben will, zur Zeit in seinen Besitz kommen will und bereit ist, es ohne Gewaltanwendung zu bekommen. Der Zauberer muß das Objekt zu dem Zeitpunkt berühren, wenn er den Spruch wirkt. Gibt es keine solche Person, liefert der Spruch kein Ergebnis"
                    },
                    {
                        "name": "Wahrhaftiges Schätzen",
                        "level": 13,
                        "value": "Wie Objekt schätzen, nur kann jedes Objekt geschätzt werden (auch Vieh, Häuser, Boote usw.)"
                    },
                    {
                        "name": "Bedeutung",
                        "level": 14,
                        "value": "Findet heraus, ob der untersuchte Gegenstand irgendeine kulturelle oder historische Bedeutung hat (aber nicht genau, welche es ist)"
                    },
                    {
                        "name": "Besitzer finden II",
                        "level": 15,
                        "value": "Wie Besitzer finden I, bis auf den Wirkungsbereich"
                    },
                    {
                        "name": "Käufer finden IV",
                        "level": 16,
                        "value": "Liefert die Richtung und Entfernung zur nächsten Person, die das Objekt haben will, zur Zeit in seinen Besitz kommen will, bereit ist, es ohne Gewaltanwendung zu bekommen und den besten Preis dafür zahlt. Der Zauberer muß das Objekt zu dem Zeitpunkt berühren, wenn er den Spruch wirkt. Gibt es keine solche Person, liefert der Spruch kein Ergebnis"
                    },
                    {
                        "name": "Herkunft",
                        "level": 18,
                        "value": "Liefert den ungefähren Herkunftsort eines Gegenstands, das Volk, das ihn schuf und wann er geschaffen wurde (±100 Jahre)"
                    },
                    {
                        "name": "Besitzer finden III",
                        "level": 19,
                        "value": "Wie Besitzer finden I, bis auf den Wirkungsbereich"
                    },
                    {
                        "name": "Besitzervision",
                        "level": 20,
                        "value": "Der Zauberer erlangt eine bildliche Vorstellung von dem Besitzer des Gegenstands"
                    },
                    {
                        "name": "Gegenstandsvision",
                        "level": 25,
                        "value": "Liefert eine Vision eines bedeutsamen Ereignisses aus der Vergangenheit des Gegenstands"
                    },
                    {
                        "name": "Wahrhaftige Herkunft",
                        "level": 30,
                        "value": "Wie Herkunft, nur liefert der Spruch den genauen Herkunftsort, das Wesen, das ihn schuf und wann er geschaffen wurde"
                    },
                    {
                        "name": "Wahrhaftiges Besitzerfinden",
                        "level": 50,
                        "value": "Wie Besitzerfinden I, bis auf den Wirkungsbereich."
                    }
                ]
            },
            {
                "id": "12.2",
                "name": "9.6.3: Mechanik",
                "spells": [
                    {
                        "name": "Maschinenkunde",
                        "level": 1,
                        "value": "Dieser Spruch analysiert eine „Maschine“ und gibt dem Zauberer eine Vorstellung ihres Zwecks und Anwendung. Der Zauberer erhält dadurch einen Bonus von +20 für die Bedienung dieser Maschine"
                    },
                    {
                        "name": "Feinabstimmung",
                        "level": 2,
                        "value": "Wenn dieser Spruch auf eine Maschine gewirkt wird, kehrt die Effizienz dieser Maschine zum Ausgangszustand zurück. Wenn man diesen Spruch also beispielsweise auf ein rostiges Schloß wirkt, arbeitet das Schloß danach, als wäre es wie neu und ohne Rost"
                    },
                    {
                        "name": "Verklemmen I",
                        "level": 3,
                        "value": "Dieser Spruch hat eine Chance von 50%, den Zielmechanismus zu verklemmen (z.B. Schloß, Falle, Maschine usw.). Wenn er verklemmt ist, hat er nur eine Chance von 5%, normal zu arbeiten, wenn er ausgelöst wird (prüfen Sie dies jedesmal, wenn der Mechanismus gebraucht/ausgelöst wird). Wenn dieser Spruch beispielsweise auf eine Druckplatte im Boden gewirkt wird (die ein Fallgitter auslöst), dann gibt es jedesmal eine Chance von 5%, daß der Mechanismus ausgelöst wird, wenn jemand über die Bodenplatte geht"
                    },
                    {
                        "name": "Öffnen I",
                        "level": 4,
                        "value": "Beim Einsatz dieses Zaubers gegen ein Schloß besteht eine 30%-Chance, daß sich ein normales Schloß öffnet. Öffnet das Schloß nicht, besteht eine 10%-Chance, etwaige mit dem Schloß in Verbindung stehende Fallen auszulösen. Die Würfe sind offen und werden durch die Qualität des Schlosses modifiziert"
                    },
                    {
                        "name": "Falle entschärfen I",
                        "level": 5,
                        "value": "Wie Öffnen I, die Chancen beziehen sich aber auf das Entschärfen von Fallen. Es gibt eine 10%-Chance, daß die zu entschärfende Falle hierbei ausgelöst wird"
                    },
                    {
                        "name": "Bedienen I",
                        "level": 6,
                        "value": "Wie Öffnen I, aber dieser Spruch hat eine Chance von 30%, eine nicht-magische Maschine während der Wirkungsdauer im normalen Umfang zu bedienen. Nach der Wirkungsdauer läuft die Maschine so lange weiter, wie die Gesetze der Physik es zulassen. Wenn mit diesem Spruch beispielsweise ein Rad gedreht wurde, dann verlangsamt es sich nach der Wirkungsdauer durch Reibung und stoppt schließlich"
                    },
                    {
                        "name": "Aktive Magie erkennen",
                        "level": 7,
                        "value": "Während der Wirkungsdauer ist sich der Zauberer jeglicher aktiven Magie im Wirkungsbereich bewußt. Er weiß nicht, um was für Magie es sich handelt, oder wo sie sich befindet"
                    },
                    {
                        "name": "Verklemmen II",
                        "level": 8,
                        "value": "Wie Verklemmen I, aber die Chance ist 70% (und mit 4% Wahrscheinlichkeit funktioniert der verklemmte Mechanismus normal)"
                    },
                    {
                        "name": "Öffnen II",
                        "level": 9,
                        "value": "Wie Öffnen I, aber die Chance ist 50% (und nur 8% für eventuelle Fallen)"
                    },
                    {
                        "name": "Falle entschärfen II",
                        "level": 10,
                        "value": "Wie Falle entschärfen I, aber die Chance ist 50% (8% Auslösung)"
                    },
                    {
                        "name": "Bedienen II",
                        "level": 11,
                        "value": "Wie Bedienen I, aber die Chance, die Maschine zu bedienen, liegt bei 50%"
                    },
                    {
                        "name": "Verklemmen III",
                        "level": 12,
                        "value": "Wie Verklemmen I, aber die Chance ist 90% (und mit 3% Wahrscheinlichkeit funktioniert der verklemmte Mechanismus normal)"
                    },
                    {
                        "name": "Öffnen III",
                        "level": 13,
                        "value": "Wie Öffnen I, aber die Chance ist 70% (mit nur 6% Wahrscheinlichkeit wird eine verbundene Falle ausgelöst)"
                    },
                    {
                        "name": "Falle entschärfen III",
                        "level": 14,
                        "value": "Wie Falle entschärfen I, aber die Chance ist 70% (mit 6% Wahrscheinlichkeit wird die Falle ausgelöst )"
                    },
                    {
                        "name": "Bedienen III",
                        "level": 15,
                        "value": "Wie Bedienen I, aber die Chance, die Maschine zu bedienen, liegt bei 70%"
                    },
                    {
                        "name": "Verklemmen IV",
                        "level": 16,
                        "value": "Wie Verklemmen I, aber die Chance ist 100% (und mit 2% Wahrscheinlichkeit funktioniert der verklemmte Mechanismus normal)"
                    },
                    {
                        "name": "Öffnen IV",
                        "level": 17,
                        "value": "Wie Öffnen I, aber die Chance ist 90% (mit nur 4% Wahrscheinlichkeit wird eine verbundene Falle ausgelöst)"
                    },
                    {
                        "name": "Falle entschärfen IV",
                        "level": 18,
                        "value": "Wie Falle entschärfen I, aber die Chance ist 90% (mit 4% Wahrscheinlichkeit wird die Falle ausgelöst )"
                    },
                    {
                        "name": "Bedienen IV",
                        "level": 19,
                        "value": "Wie Bedienen I, aber die Chance, die Maschine zu bedienen, liegt bei 90%"
                    },
                    {
                        "name": "Wahrhaftiges Verklemmen",
                        "level": 20,
                        "value": "Wie Verklemmen III, aber alle Mechanismen im Wirkungsbereich sind betroffen"
                    },
                    {
                        "name": "Wahrhaftiges Öffnen",
                        "level": 25,
                        "value": "Wie Öffnen III, aber alle Schößer im Wirkungsbereich sind betroffen"
                    },
                    {
                        "name": "Wahrhaftiges Fallenentschärfen",
                        "level": 30,
                        "value": "Wie Falle entschärfen III, aber alle Fallen im Wirkungsbereich sind betroffen"
                    },
                    {
                        "name": "Wahrhaftiges Bedienen",
                        "level": 50,
                        "value": "Wie Bedienen III, aber alle Maschinen im Wirkungsbereich sind betroffen."
                    }
                ]
            },
            {
                "id": "12.3",
                "name": "9.6.4: Meisterschaft der Bewegung",
                "spells": [
                    {
                        "name": "Laufen",
                        "level": 1,
                        "value": "Der Zauberer kann laufen (doppelte Gehgeschwindigkeit) und verliert dabei Erschöpfungspunkte, als ob er nur gehen würde. Wenn er einmal das Laufen beendet oder eine andere Aktion durchführt, endet dieser Spruch sofort"
                    },
                    {
                        "name": "Weitsprung",
                        "level": 2,
                        "value": "Der Zauberer kann (von jeder Anfangsgeschwindigkeit aus) bis zu 3 Meter plus 1,50 Meter pro Stufe horizontal oder 1 Meter pro Stufe vertikal springen. Er landet immer sicher, wenn er mittels dieses Spruches springt"
                    },
                    {
                        "name": "Landen",
                        "level": 3,
                        "value": "Gestattet es dem Zauberer, bei einem Sturz über bis zu 6 Meter pro Stufe sicher zu landen und bei tieferen Stürzen die Folgen entsprechend zu mildern"
                    },
                    {
                        "name": "Schattenschritte",
                        "level": 4,
                        "value": "Alle Bewegungen des Zauberers erfolgen in kompletter Stille, sofern er sich nicht schneller als gehend bewegt"
                    },
                    {
                        "name": "Unterwasserbewegung",
                        "level": 5,
                        "value": "Der Zauberer kann sich unter Wasser wie auf Land ohne Einschränkungen bewegen"
                    },
                    {
                        "name": "Balancieren I",
                        "level": 6,
                        "value": "Durch diesen Spruch bekommt der Zauberer einen Bonus von +50 auf alle Bewegungsmanöver, die Balance erfordern und im Gehen durchgeführt werden"
                    },
                    {
                        "name": "Spinnenschritt",
                        "level": 7,
                        "value": "Der Zauberer kann sich über jede feste Oberfläche bis zu einem Winkel von 90° bewegen (halbe Gehgeschwindigkeit), solange er zu jeder Zeit mindestens mit drei Gliedmaßen Kontakt zu der Oberfläche hält (z.B. eine Hand und beide Füße)"
                    },
                    {
                        "name": "Klippensprung",
                        "level": 8,
                        "value": "Der Zauberer kann sicher durch die Luft fliegen (bis zu 15 Meter pro Stufe), sofern Wasser mit ausreichender Tiefe vorhanden ist (1 Meter pro 15 Meter Flug), in das er dann sicher fällt"
                    },
                    {
                        "name": "Spurlos gehen",
                        "level": 9,
                        "value": "Der Zauberer kann sich gehend bewegen, ohne Spuren oder andere sichtbare Zeichen seiner Anwesenheit zu hinterlassen"
                    },
                    {
                        "name": "Wahrhaftiger Spinnenschritt",
                        "level": 10,
                        "value": "Wie Spinnenschritt, der Zauberer jedoch kann sich über jede Oberfläche bewegen (inklusive beispielsweise der Zimmerdecke)"
                    },
                    {
                        "name": "Schweben",
                        "level": 11,
                        "value": "Dieser Spruch erlaubt es dem Zauberer, in der Luft zu schweben. Während er schwebt, ist der Zauberer den herrschenden Winden ausgeliefert und kann seinen Flug nicht kontrollieren, wenn er dazu nicht andere Hilfsmittel zur Verfügung hat (ein Seil oder eine Wand, an der er sich entlang tatstet, indem er gezogen wird o.ä.)"
                    },
                    {
                        "name": "Spinnengehen",
                        "level": 12,
                        "value": "Wie Spinnenschritt, nur kann sich der Zauberer mit normaler Gehgeschwindigkeit fortbewegen und muß nur mit zwei Gliedmaßen Kontakt zur Wand halten"
                    },
                    {
                        "name": "Balancieren II",
                        "level": 13,
                        "value": "Wie Balancieren I, nur kann sich der Zauberer mit doppelter Gehgeschwindigkeit bewegen (also Laufgeschwindigkeit)"
                    },
                    {
                        "name": "Schattenlandung",
                        "level": 14,
                        "value": "Der Zauberer fällt in 99% der Fälle sicher aus beliebiger Höhe und landet völlig lautlos"
                    },
                    {
                        "name": "Spinnenlaufen",
                        "level": 15,
                        "value": "Wie Spinnengehen, nur kann sich der Zauberer mit doppelter Gehgeschwindigkeit bewegen (also Laufgeschwindigkeit)"
                    },
                    {
                        "name": "Segelflug I",
                        "level": 16,
                        "value": "Der Zauberer gleitet durch die Luft wie ein Vogel. Das Produkt der Flughöhe und seiner horizontalen Geschwindigkeit darf pro Runde 30 nicht übersteigen. Beispielsweise kann er sich 2m pro Runde bewegen, wenn er 15m über dem Boden wäre oder er könnte sich mit 15m pro Runde bewegen, wenn er nur 2m über dem Boden befände. Beachten Sie, daß das Produkt dieser beiden Werte genau 30 sein muß (d.h. der Zauberer kann Höhe und Geschwindigkeit nicht so wählen, daß das Produkt mehr oder weniger als 30 wäre)"
                    },
                    {
                        "name": "Balancieren III",
                        "level": 18,
                        "value": "Wie Balancieren I, nur kann sich der Zauberer mit dreifacher Gehgeschwindigkeit bewegen (also Sprintgeschwindigkeit)"
                    },
                    {
                        "name": "Wahrhaftiges Spinnengehen",
                        "level": 20,
                        "value": "Wie Spinnengehen, aber der Zauberer kann sich über jede Oberfläche bewegen (inklusive beispielsweise der Zimmerdecke)"
                    },
                    {
                        "name": "Gehen auf Wind",
                        "level": 25,
                        "value": "Das Ziel kann auf ruhigem Wind gehen, wobei er sich auf einer Höhe fortbewegt (der Zauberer kann sich vertikal bewegen, allerdings nur soweit seine eigenen Möglichkeiten ihm das erlauben, der Spruch verleiht keine vertikale Bewegungsfähigkeit)"
                    },
                    {
                        "name": "Wahrhaftiges Balancieren",
                        "level": 30,
                        "value": "Wie Balancieren I, nur kann sich der Zauberer mit jeder beliebigen Geschwindigkeit bewegen"
                    },
                    {
                        "name": "Meisterschaft der Bewegung",
                        "level": 50,
                        "value": "Der Zauberer kann in jeder Runde einen der niedrigstufigeren Sprüche dieser Liste anwenden."
                    }
                ]
            },
            {
                "id": "12.4",
                "name": "9.6.5: Meisterschaft des Versteckens",
                "spells": [
                    {
                        "name": "Schatten",
                        "level": 1,
                        "value": "Der Zauberer und die Objekte an seiner Person erscheinen nur noch als Schatten und sind dadurch in Dunkelheit nahezu unsichtbar. In vielen Situationen sollte dies einen Bonus von +25 bis +75 (SL-Entscheidung) auf Schleichen und/oder Verstecken ergeben"
                    },
                    {
                        "name": "Transparenz III",
                        "level": 2,
                        "value": "Bis zu drei Objekte werden unsichtbar (z.B. 1 Gewand, 1 nackter Körper und 1 Waffe), bis entweder 24 Stunden verstrichen sind, oder bis das Ziel von einem harten Schlag getroffen wird (von einer Waffe getroffen werden, Sturz usw.), oder bis das Ziel eine gewalttätige Handlung ausführt (z.B. einen Angriff )"
                    },
                    {
                        "name": "Verstecken I",
                        "level": 3,
                        "value": "Ein unbelebtes Objekt nimmt das sichtbare Äußere eines ähnlichen Objektes an. Beispielsweise kann ein kleiner roter Schlüssel wie ein blauer Löffel erscheinen. Die Ausmaße können um nicht mehr als 100% der tatsächlichen Größe variieren. Dies ist eine visuelle Illusion (und kann als solche entdeckt werden), vgl. Abschnitt 5.14 (Seite 40)"
                    },
                    {
                        "name": "Objekt finden",
                        "level": 4,
                        "value": "Erlaubt es dem Zauberer, ein beliebiges, unbelebtes Objekt zu finden. Der Zauberer muß dazu in der Lage sein, das Objekt eindeutig zu beschreiben"
                    },
                    {
                        "name": "Dunkelheit",
                        "level": 5,
                        "value": "Erzeugt ein Gebiet der Dunkelheit in 1 Metern Umkreis pro Stufe um den berührten Punkt"
                    },
                    {
                        "name": "Geheimnis I",
                        "level": 6,
                        "value": "Ein unbelebtes Objekt nimmt die sichtbare und fühlbare Erscheinung eines ähnlichen Objektes an. Beispielsweise kann ein Kristallkelch wie ein Holzbecher erscheinen. Die Dimensionen können um nicht mehr als 100% der tatsächlichen Größe variieren. Dies ist eine Illusion (und kann als solche entdeckt werden)"
                    },
                    {
                        "name": "Transparenz V",
                        "level": 7,
                        "value": "Wie Transparenz III, aber bis zu 5 Objekte können betroffen werden"
                    },
                    {
                        "name": "Verschieben I",
                        "level": 8,
                        "value": "Das Ziel scheint leicht verschoben von dem tatsächlichen Aufenthaltsort zu sein. Angriffe schlagen mit einer Wahrscheinlichkeit von 10% fehl. Jedesmal, wenn das Ziel wegen diesem Spruch verfehlt wurde, sinkt die Wahrscheinlichkeit um 5%"
                    },
                    {
                        "name": "Verstecken III",
                        "level": 9,
                        "value": "Wie Verstecken I, aber bis zu 3 Objekte können betroffen werden"
                    },
                    {
                        "name": "Transparenz X",
                        "level": 10,
                        "value": "Wie Transparenz III, aber bis zu 10 Objekte können betroffen werden"
                    },
                    {
                        "name": "Verschieben II",
                        "level": 11,
                        "value": "Wie Verschieben I, nur liegt die Wahrscheinlichkeit, daß Angriffe fehlschlagen, bei 20%"
                    },
                    {
                        "name": "Geheimnis III",
                        "level": 12,
                        "value": "Wie Geheimnis I, aber bis zu 3 Objekte können betroffen werden"
                    },
                    {
                        "name": "Transparenz XV",
                        "level": 13,
                        "value": "Wie Transparenz III, aber bis zu 15 Objekte können betroffen werden"
                    },
                    {
                        "name": "Verstecken V",
                        "level": 15,
                        "value": "Wie Verstecken I, aber bis zu 5 Objekte können betroffen werden"
                    },
                    {
                        "name": "Meister-Transparenz",
                        "level": 16,
                        "value": "Wie Transparenz III, aber bis zu 20 Objekte können betroffen werden"
                    },
                    {
                        "name": "Geheimnis V",
                        "level": 17,
                        "value": "Wie Geheimnis I, aber bis zu 5 Objekte können betroffen werden"
                    },
                    {
                        "name": "Verschieben III",
                        "level": 18,
                        "value": "Wie Verschieben I, nur liegt die Wahrscheinlichkeit, daß Angriffe fehlschlagen, bei 30%"
                    },
                    {
                        "name": "Verstecken X",
                        "level": 20,
                        "value": "Wie Verstecken I, aber bis zu 10 Objekte können betroffen werden"
                    },
                    {
                        "name": "Wahrhaftige Transparenz",
                        "level": 25,
                        "value": "Wie Transparenz III, aber bis zu 20 Objekte können betroffen werden"
                    },
                    {
                        "name": "Geheimnis X",
                        "level": 30,
                        "value": "Wie Geheimnis I, aber bis zu 10 Objekte können betroffen werden"
                    },
                    {
                        "name": "Meisterschaft im Verstecken",
                        "level": 50,
                        "value": "Wie Verstecken I, aber der Spruch verbirgt eine Anzahl an Objekten bis zur Stufe des Zauberers."
                    }
                ]
            },
            {
                "id": "12.5",
                "name": "9.6.6: Sinne",
                "spells": [
                    {
                        "name": "Listige Ohren",
                        "level": 1,
                        "value": "Der Zauberer erhält ein doppelt so gutes Gehör. Dies bringt ihm einen besonderen Bonus von +50 auf Fertigkeiten der Gruppen Wahrnehmung • Suchen und Wahrnehmung • Sinne, sofern es dabei auf das Gehör ankommt (oder +5 auf die Fertigkeit Aufmerksamkeit). Wenn neben dem Gehör auch andere Sinne für die Fertigkeit wichtig sind, reduziert sich der Bonus auf +25 (+3 bei Aufmerksamkeit)"
                    },
                    {
                        "name": "Nachtsicht",
                        "level": 2,
                        "value": "Der Zauberer kann in einer normalen Nacht 30 Meter weit sehen, als wäre es Tag. Vgl. Abschnitt 5.12 (Seite 39)"
                    },
                    {
                        "name": "Geruchssinn",
                        "level": 3,
                        "value": "Wie Listige Ohren, aber der Zauberer bekommt einen besonders guten Geruchssinn, und die Boni gelten für Wahrnehmungsfertigkeiten, bei denen es auf das Riechen ankommt"
                    },
                    {
                        "name": "Sinnesmarkierung",
                        "level": 4,
                        "value": "Ein Ort wird markiert, so daß der Zauberer ihn später mit einem Fernsinn-Spruch wiederfinden kann. Die Markierung wird automatisch gefunden, wenn der Zauberer einen Fernsinn-Spruch wirkt, sofern die Markierung in Reichweite ist. Man kann die Markierung auf jedes beliebige unbelebte Objekt setzen, aber man kann nicht mehr Markierungen haben, als man Stufen hat"
                    },
                    {
                        "name": "Fernsinn I",
                        "level": 5,
                        "value": "Der Zauberer kann einen seiner Sinne auswählen, der dann an einer markierten Stelle innerhalb der Reichweite eingesetzt wird (vgl. Sinnesmarkierung). Der Zauberer kann jede Wahrnehmungsfertigkeit oder Eigenschaften an der Markierung einsetzen, die er vor dem Wirken dieses Spruches hatte (wenn er z.B. Nachtsicht vorher auf sich gewirkt hat, hat er sie auch bei seinem Fernsinn). Der entfernte Sinn kann beliebig gedreht werden. Während der Zauberer durch die Markierung wahrnimmt, kann er sich nicht bewegen und muß sich konzentrieren"
                    },
                    {
                        "name": "Rundumsicht",
                        "level": 6,
                        "value": "Der Zauberer hat ein Gesichtsfeld von 300°. Der Bonus für Angriffe aus der Flanke reduziert sich auf +5 und der für Angriffe von hinten auf +15"
                    },
                    {
                        "name": "Fühlen",
                        "level": 7,
                        "value": "Der Zauberer bekommt einen besonders guten Tastsinn. Dies bringt ihm einen Bonus von +25 auf alle Aktionen, die vom Tastsinn abhängen (z.B. Schlösser öffnen, Fallen entschärfen usw.)"
                    },
                    {
                        "name": "Wassersicht",
                        "level": 8,
                        "value": "Wie Nachtsicht, aber der Zauberer kann 30 Meter in jedem Gewässer sehen, selbst in schlammigen und trüben Wasser"
                    },
                    {
                        "name": "Dunkelsicht",
                        "level": 9,
                        "value": "Wie Nachtsicht, aber der Zauberer kann durch jede Dunkelheit sehen. Es ist kein Licht nötig"
                    },
                    {
                        "name": "Fernsinn II",
                        "level": 10,
                        "value": "Wie Fernsinn I, aber der Zauberer kann bis zu zwei Sinne an die Markierung senden"
                    },
                    {
                        "name": "Holzsicht",
                        "level": 11,
                        "value": "Der Zauberer kann durch Holz hindurchsehen, das bis zu 3cm pro Stufe dick sein kann"
                    },
                    {
                        "name": "Lichtsicht",
                        "level": 12,
                        "value": "Der Zauberer kann in jedem Licht sehen (auch in blendend hellem oder grellem). Dieser Spruch funktioniert nicht ohne Licht"
                    },
                    {
                        "name": "Besserer Fernsinn I",
                        "level": 14,
                        "value": "Wie Fernsinn I, aber der Zauberer kann sich bewegen, auch wenn er sich weiterhin konzentrieren muß"
                    },
                    {
                        "name": "Weitreichender Fernsinn I",
                        "level": 15,
                        "value": "Wie Fernsinn I, bis auf die Reichweite"
                    },
                    {
                        "name": "Steinsicht",
                        "level": 16,
                        "value": "Wie Holzsicht, nur kann der Zauberer durch Stein sehen"
                    },
                    {
                        "name": "Besserer Fernsinn II",
                        "level": 18,
                        "value": "Wie Fernsinn II, aber der Zauberer kann sich bewegen, auch wenn er sich weiterhin konzentrieren muß"
                    },
                    {
                        "name": "Eisensicht",
                        "level": 19,
                        "value": "Wie Holzsicht, nur kann der Zauberer durch Eisen (oder Stahl) sehen"
                    },
                    {
                        "name": "Weitreichender Fernsinn II",
                        "level": 20,
                        "value": "Wie Fernsinn II, bis auf die Reichweite"
                    },
                    {
                        "name": "Wahrhaftige Sicht",
                        "level": 25,
                        "value": "Wie alle Sichtsprüche dieser Liste auf einmal"
                    },
                    {
                        "name": "Wahrhaftige Sinne",
                        "level": 30,
                        "value": "Der Zauberer steht gleichzeitig unter der Wirkung von Listige Ohren, Geruchssinn, Tastsinn und aller Sichtsprüche"
                    },
                    {
                        "name": "Meisterschaft der Sinne",
                        "level": 50,
                        "value": "Der Zauberer kann in jeder Runde einen der niedrigstufigeren Sprüche dieser Liste verwenden."
                    }
                ]
            }
        ]
    },
    {
        "id": "13",
        "name": "Böse Essenz",
        "spellLists": [
            {
                "id": "13.0",
                "name": "9.7.1: Dunkelheit",
                "spells": [
                    {
                        "name": "Dunkelheit II",
                        "level": 1,
                        "value": "Erzeugt in einem Bereich mit einem Radius von bis zu 6m um den berührten Punkt Dunkelheit. Die Dunkelheit gleicht der in einer wirklich dunklen Nacht. Wenn der berührte Punkt auf einem beweglichen Ziel liegt, bewegt sich die Dunkelheit mit diesem. Siehe Abschnitt 5.12 (Seite 39)"
                    },
                    {
                        "name": "Nachtsicht",
                        "level": 2,
                        "value": "Das Ziel kann in normaler Dunkelheit bis zu 30m weit sehen, als wäre es Tag"
                    },
                    {
                        "name": "Dunkelheit kontrollieren II",
                        "level": 3,
                        "value": "Der Zauberer kann den Grad der Dunkelheit in dem Gebiet steuern, aber er kann sie nicht stärker aufhellen, als sie normal wäre"
                    },
                    {
                        "name": "Dunkelheit X",
                        "level": 5,
                        "value": "Wie Dunkelheit II, nur ist der Radius 30m"
                    },
                    {
                        "name": "Dunkelsicht",
                        "level": 6,
                        "value": "Wie Nachtsicht, nur kann das Ziel in jeder Dunkelheit sehen (auch in magischer)"
                    },
                    {
                        "name": "Dunkelheit kontrollieren V",
                        "level": 7,
                        "value": "Wie Dunkelheit kontrollieren II, nur sind Reichweite und Wirkungsbereich je 15m groß"
                    },
                    {
                        "name": "Schatten formen",
                        "level": 8,
                        "value": "Der Zauberer kann entweder Schattenfiguren als optische Illusion oder echte Schatten erschaffen (so viele wie die Stufe des Zauberers). Sie bewegen sich, wenn er sich konzentriert. Siehe Abschnitt 5.14 (Seite 40) für Näheres über Illusionen"
                    },
                    {
                        "name": "Geringe Dunkelheit",
                        "level": 9,
                        "value": "Wie Dunkelheit II, nur ist der Radius 100m groß"
                    },
                    {
                        "name": "Geringe Pure Dunkelheit",
                        "level": 10,
                        "value": "Erzeugt in einem Radius von 6m Pure Dunkelheit. Kein nicht-magisches Licht kann hier bestehen und magischem Licht (außer Purem Licht) muß ein WW gelingen, sonst vergeht es"
                    },
                    {
                        "name": "Dunkelheit kontrollieren X",
                        "level": 11,
                        "value": "Wie Dunkelheit kontrollieren II, nur sind Reichweite und Wirkungsbereich je 30m groß"
                    },
                    {
                        "name": "Wahrhaftige Nachtsicht",
                        "level": 12,
                        "value": "Wie Nachtsicht, nur kann das Ziel so weit sehen, wie ihm das bei Tageslicht möglich wäre"
                    },
                    {
                        "name": "Pure Dunkelheit",
                        "level": 13,
                        "value": "Wie Geringe Pure Dunkelheit, nur ist der Radius 30m"
                    },
                    {
                        "name": "Mittlere Dunkelheit",
                        "level": 14,
                        "value": "Wie Dunkelheit II, nur ist der Radius 150m"
                    },
                    {
                        "name": "Dunkelheitswolken I",
                        "level": 15,
                        "value": "Erzeugt eine Wolke aus Dunkelheit mit einem Radius von 30 Metern, die mit dem Wind treibt. Die Intensität der Dunkelheit kann von einem bedeckten Tag bis zu nächtlicher Dunkelheit reichen"
                    },
                    {
                        "name": "Massen-Nachtsicht",
                        "level": 16,
                        "value": "Wie Nachtsicht, nur ist die Stufe des Zauberers an Zielen betroffen"
                    },
                    {
                        "name": "Weite Pure Dunkelheit",
                        "level": 17,
                        "value": "Wie Geringe Pure Dunkelheit, nur ist der Wirkungsbereich ein Radius von 60 Metern"
                    },
                    {
                        "name": "Massen-Dunkelsicht",
                        "level": 18,
                        "value": "Wie Dunkelsicht, nur ist die Stufe des Zauberers an Zielen betroffen"
                    },
                    {
                        "name": "Dunkelheitswolken II",
                        "level": 19,
                        "value": "Wie Dunkelheitswolken I, bis auf den Wirkungsbereich"
                    },
                    {
                        "name": "Weite Dunkelheit",
                        "level": 20,
                        "value": "Wie Dunkelheit II, nur ist der Wirkungsbereich ein Radius von 300 Metern"
                    },
                    {
                        "name": "Wahrhaftige Pure Dunkelheit",
                        "level": 25,
                        "value": "Wie Geringe Pure Dunkelheit, nur ist der Wirkungsbereich ein Radius von 100 Metern"
                    },
                    {
                        "name": "Wahrhaftige Dunkelheit",
                        "level": 30,
                        "value": "Wie Dunkelheit II, nur ist der Wirkungsbereich ein Radius von 30 Metern pro Stufe des Zauberers"
                    },
                    {
                        "name": "Wahrhaftige Dunkelheitswolken",
                        "level": 50,
                        "value": "Wie Dunkelheitswolken I, nur ist der Radius 1,5km pro Stufe des Zauberers."
                    }
                ]
            },
            {
                "id": "13.1",
                "name": "9.7.2: Entitäten beschwören",
                "spells": [
                    {
                        "name": "Elementar beschwören I",
                        "level": 2,
                        "value": "Der Zauberer beschwört einen Elementaren Diener (eine Entität der Klasse I), der im Lauf zweier Runde allmählich erscheint. Wenn er bis dahin nicht kontrolliert oder beherrscht wird (normalerweise durch einen der Sprüche dieser Liste), greift er wahllos Ziele an, bis er nach 2-20 Stunden langsam verschwindet"
                    },
                    {
                        "name": "Entität kontrollieren I",
                        "level": 3,
                        "value": "Ermöglicht dem Zauberer, eine Entität der Klasse I völlig zu kontrollieren (die Wahrscheinlichkeit, daß sie sich nicht kontrollieren läßt, entspricht ihrer Klasse x 2%). Die Entität verschwindet, wenn der Zauberer aufhört, sich zu konzentrieren. Sie spricht nicht mit dem Beschwörer"
                    },
                    {
                        "name": "Elementar beschwören II",
                        "level": 4,
                        "value": "Wie Elementar beschwören I, nur wird ein Schwacher Elementar (eine Entität der Klasse II) beschworen"
                    },
                    {
                        "name": "Geringeres Dämonentor",
                        "level": 5,
                        "value": "Der Zauberer beschwört einen Dämon, der im Lauf von 2 Runden allmählich erscheint. Bestimmen Sie mit einem (nicht offenen) Prozentwurf die Klasse. Bei einem Ergebnis von 01-60 ist es einer der Klasse I, bei 61-90 einer der Klasse II, bei 91-100 einer der Klasse III. Wenn der Dämon nicht kontrolliert oder beherrscht wird (normalerweise durch einen der Sprüche dieser Liste) bis er völlig materialisiert ist, erleidet der Zauberer die in Abschnitt 5.22 (Seite 42) angegebenen Auswirkungen"
                    },
                    {
                        "name": "Entität beherrschen I",
                        "level": 6,
                        "value": "Wie Entität kontrollieren I, nur muß sich der Zauberer nicht konzentrieren, um die Entität zu kontrollieren. Die Wahrscheinlichkeit für einen Fehlschlag ist 5 mal die Klasse der Entität. Die Entität bleibt und gehorcht dem Zauberer, bis der Zauberer getötet wird oder die Entität außerhalb der Reichweite ist, oder bis der Zauberer sie entläßt. Ein Wesen kann immer nur maximal zwei Entitäten beherrschen. Informationen kann der Zauberer nur erhalten, wenn er die Sprüche der Bösen Essenzliste Finstere Kontakte verwendet"
                    },
                    {
                        "name": "Entität kontrollieren II",
                        "level": 7,
                        "value": "Wie Entität kontrollieren I, nur können Entitäten der Klasse I und II kontrolliert werden"
                    },
                    {
                        "name": "Elementar beschwören III",
                        "level": 8,
                        "value": "Wie Elementar beschwören I, nur wird ein Wächterelementar (eine Entität der Klasse III) beschworen"
                    },
                    {
                        "name": "Entität beherrschen II",
                        "level": 9,
                        "value": "Wie Entität beherrschen I, nur können Entitäten der Klasse I und II kontrolliert werden"
                    },
                    {
                        "name": "Entität kontrollieren III",
                        "level": 10,
                        "value": "Wie Entität kontrollieren I, nur können Entitäten der Klasse I bis III kontrolliert werden"
                    },
                    {
                        "name": "Elementar beschwören IV",
                        "level": 11,
                        "value": "Wie Elementar beschwören I, nur wird ein Starker Elementar (eine Entität der Klasse IV) beschworen"
                    },
                    {
                        "name": "Mächtiges Dämonentor",
                        "level": 12,
                        "value": "Wie Geringeres Dämonentor, nur kann ein Dämon der Klasse III-VI beschworen werden: (01-60) Klasse III, (61-85) Klasse IV, (86-95) Klasse V, (96-100) Klasse VI"
                    },
                    {
                        "name": "Entität beherrschen III",
                        "level": 13,
                        "value": "Wie Entität beherrschen I, nur können Entitäten der Klasse I bis IV beherrscht werden"
                    },
                    {
                        "name": "Entität kontrollieren IV",
                        "level": 14,
                        "value": "Wie Entität kontrollieren I, nur können Entitäten der Klasse I bis IV kontrolliert werden"
                    },
                    {
                        "name": "Entität beherrschen IV",
                        "level": 15,
                        "value": "Wie Entität beherrschen I, nur können Entitäten der Klasse I bis IV beherrscht werden"
                    },
                    {
                        "name": "Elementar befehligen",
                        "level": 16,
                        "value": "Das Ziel dieses Spruchs ist ein beliebiger, beherrschter Elementar. Dem Elementar kann ein einfacher, gradliniger Auftrag erteilt werden, und es wird versuchen, ihn zu erfüllen (innerhalb der Spruchdauer). Wenn die Spruchdauer abläuft, kehrt der Elementar auf seine Ebene zurück"
                    },
                    {
                        "name": "Elementar einsperren",
                        "level": 17,
                        "value": "Das Ziel dieses Spruches ist ein beliebiger, beherrschter Elementar. Der Elementar wird in einem Objekt eingeschlossen (es kann nur um 50% von der Größe des Elementars abweichen). Der Elementar wird durch einen bestimmten Auslöser freigesetzt (den der Zauberer festlegt, wenn er den Spruch wirkt). Mögliche Auslöser wären: Berührung des Objekts, Nähe zum Objekt, bestimmte Worte, die gesprochen werden usw"
                    },
                    {
                        "name": "Entität befehligen",
                        "level": 18,
                        "value": "Wie Elementar befehligen, nur wirkt es auf eine beliebige beherrschte Entität"
                    },
                    {
                        "name": "Entität einsperren",
                        "level": 19,
                        "value": "Wie Elementar einsperren"
                    },
                    {
                        "name": "Entität kontrollieren V",
                        "level": 20,
                        "value": "Wie Entität kontrollieren I, nur können Entitäten der Klasse I bis V kontrolliert werden"
                    },
                    {
                        "name": "Entität beherrschen V",
                        "level": 25,
                        "value": "Wie Entität beherrschen I, nur können Entitäten der Klasse I bis V beherrscht werden"
                    },
                    {
                        "name": "Entität kontrollieren VI",
                        "level": 30,
                        "value": "Wie Entität kontrollieren I, nur können Entitäten der Klasse I bis VI kontrolliert werden"
                    },
                    {
                        "name": "Entität beherrschen VI",
                        "level": 50,
                        "value": "Wie Entität beherrschen I, nur können Entitäten der Klasse I bis VI beherrscht werden."
                    }
                ]
            },
            {
                "id": "13.2",
                "name": "9.7.3: Finstere Beschwörungen",
                "spells": [
                    {
                        "name": "Vertrauter",
                        "level": 1,
                        "value": "Der Zauberer kann sich auf ein Tier einstimmen (von tierischer Intelligenz und nicht mehr als 10% der Masse des Zauberers), das dann als sein Vertrauter dient. Der Zauberer muß das Tier auf normalem Wege erhalten und den Spruch einmal pro Tag für eine Woche auf das Tier wirken (2 Stunden Konzentration pro Tag). Danach kann er den Vertrauten kontrollieren und durch Konzentration dessen Sinne benutzen, sofern sich der Vertraute innerhalb von 15m/Stufe befindet. Wird der Vertraute getötet, hat der Zauberer für zwei Wochen auf alle Aktionen einen Malus von -25"
                    },
                    {
                        "name": "Beschwörung I",
                        "level": 2,
                        "value": "Der Zauberer kann unverzüglich eine erststufige Kreatur beschwören, die er dann kontrollieren kann. Wenn die Kreatur den Zauberer verstehen kann (also durch Tiersprache), kann er sie durch normale Kommunikation kontrollieren. Andernfalls funktioniert die Kontrolle über Konzentration des Zauberers. Der Zauberer kann angeben, was für eine Kreatur er ungefähr beschwören will, doch was tatsächlich erscheint, sollte der SL bestimmen (wählen Sie eine aus, die in dem Gebiet normalerweise vorkommt). Wenn das Tier für eine Aufgabe beschworen wurde, die seiner eigenen Wahrnehmung nach nicht gefährlich ist, liegt die Spruchdauer bei 10 Minuten pro Stufe. Wenn es allerdings jemals in eine gefährliche Situation gerät, sinkt die Wirkungsdauer sofort auf eine Runde pro Stufe herab"
                    },
                    {
                        "name": "Investitur I",
                        "level": 3,
                        "value": "Dieser Spruch wird auf den Vertrauten des Zauberers gewirkt. Allerdings muß der Vertraute zu einer Tierart gehören, die normalerweise mit dem „Bösen“ assoziiert wird (d.h. ein Reptil, eine Fledermaus, ein Rabe usw.). Dieser Spruch überträgt einen Teil des Lebens auf das Tier. Er muß einen Monat lang jeden Tag auf den Vertrauten gewirkt werden (jeweils 2 Stunden Konzentration). Das Tier behält alle seine Fähigkeiten bei und bekommt besondere dazu. Der Vertraute wird zu einer unförmigen Version des Tiers, das er einmal war (fratzenhafter). Mit einer Reichweite von 75m pro Stufe kann der Zauberer die Umwelt durch die Sinne der Kreatur wahrnehmen. Die RK der Kreatur ändert sich zu 4 und sie erhält einen besonderen Bonus von +10 auf ihren DB und OB. Der Zauberer kann durch seinen Vertrauten Sprüche wirken, als ob er da wäre, wo das Tier ist (Sprüche der Kategorie „selbst“ kann er auch auf den Vertrauten wirken"
                    },
                    {
                        "name": "Beschwörung II",
                        "level": 4,
                        "value": "Wie Beschwörung I, nur kann der Zauberer zusätzlich eine der folgenden Optionen wählen: a) die Stufe des beschworenen Wesens ist um eine höher, b) eine weitere erststufige Kreatur wird beschworen oder c) die Wirkungsdauer wird verdoppelt"
                    },
                    {
                        "name": "Binden II",
                        "level": 5,
                        "value": "Der Zauberer kann eine Kreatur binden (tierische Intelligenz, bis zu zweitstufig). Die gebundene Kreatur muß den Befehlen des Zauberers gehorchen (der Zauberer muß sich nicht konzentrieren). Der Zauberer kann immer nur seine Stufe an Kreaturen gebunden haben. Wenn die Kreatur jemals außerhalb der Reichweite ist, erlischt der Spruch"
                    },
                    {
                        "name": "Beschwörung III",
                        "level": 6,
                        "value": "Wie Beschwörung II, nur können 2 Optionen gewählt werden"
                    },
                    {
                        "name": "Gebundenen befehligen II",
                        "level": 7,
                        "value": "Das Ziel des Spruchs ist eine mit Binden gebundene Kreatur (mit tierischer Intelligenz und maximal zweitstufig). Der Zauberer kann der Kreatur einen einfachen, geradlinigen Auftrag geben und sie muß versuchen, ihn zu erfüllen. Die Kreatur wird ihr Bestes geben, um die Aufgabe zu erfüllen (in der Spruchdauer). Wenn die Spruchdauer erlischt, ist die Kreatur wieder ungebunden"
                    },
                    {
                        "name": "Beschwörung V",
                        "level": 8,
                        "value": "Wie Beschwörung II, nur können 4 Optionen gewählt werden"
                    },
                    {
                        "name": "Binden V",
                        "level": 9,
                        "value": "Wie Binden II, nur kann eine bis zu fünfstufige Kreatur gebunden werden"
                    },
                    {
                        "name": "Beschwörung VII",
                        "level": 10,
                        "value": "Wie Beschwörung II, nur können 6 Optionen gewählt werden"
                    },
                    {
                        "name": "Investitur II",
                        "level": 11,
                        "value": "Das Ziel dieses Spruchs ist ein Vertrauter, auf den Investitur I erfolgreich gewirkt wurde. Mit diesem Spruch geht mehr des Zauberers auf den Vertrauten über. Der Zauberer muß diesen Spruch 6 Monate lang jeden Tag wirken (2 Stunden pro Tag). Der Zauberer kann die Sinne des Vertrauten benutzen, wenn der bis zu 300m pro Stufe weg ist und Sprüche durch ihn wirken, wenn er 60m pro Stufe weit weg ist. Die RK des Vertrauten erhöht sich auf 11, er erhält einen Bonus von +20 auf seinen ursprünglichen DB und einen Bonus von +30 auf den OB, er erlangt einen Giftangriff, den er zusammen mit seinem normalen Angriff verwendet (Biß, Stich usw.). Er macht seine WW mit Dreivierteln der Stufe des Zauberers oder seiner eigenen Stufe, wenn die höher ist. Seine Erscheinung wird noch grotesker (passend zur Wesensart des Zauberers"
                    },
                    {
                        "name": "Beschwörung X",
                        "level": 12,
                        "value": "Wie Beschwörung II, nur können 9 Optionen gewählt werden"
                    },
                    {
                        "name": "Binden X",
                        "level": 13,
                        "value": "Wie Binden II, nur kann eine bis zu zehntstufige Kreatur gebunden werden"
                    },
                    {
                        "name": "Beschwörung XII",
                        "level": 14,
                        "value": "Wie Beschwörung II, nur können 11 Optionen gewählt werden"
                    },
                    {
                        "name": "Gebundenen befehligen X",
                        "level": 15,
                        "value": "Wie Gebunden befehligen II, nur ist eine bis zu zehnstufige Kreatur betroffen"
                    },
                    {
                        "name": "Beschwörung XV",
                        "level": 16,
                        "value": "Wie Beschwörung II, nur können 14 Optionen gewählt werden"
                    },
                    {
                        "name": "Binden XV",
                        "level": 17,
                        "value": "Wie Binden II, nur kann eine bis zu fünfzehnstufige Kreatur gebunden werden"
                    },
                    {
                        "name": "Beschwörung XVII",
                        "level": 18,
                        "value": "Wie Beschwörung II, nur können 16 Optionen gewählt werden"
                    },
                    {
                        "name": "Investitur III",
                        "level": 19,
                        "value": "Wie Investitur II, nur wird der Vertraute noch stärker zu einem Teil des Zauberers. Investitur II muß bereits abgeschlossen worden sein und dann muß der Zauberer ein Jahr lang jeden Tag diesen Spruch auf den Vertrauten wirken (jeden Tag 2 Stunden). Der Zauberer kann die Sinne des Vertrauten benutzen, wenn der bis zu 1,5km pro Stufe weg ist, kann Sprüche durch ihn wirken, wenn er 300m pro Stufe weit weg ist. Die RK der Kreatur erhöht sich auf 12. Er erhält einen Bonus von +50 auf den ursprünglichen DB und von +50 auf den ursprünglichen OB. Es erhält einen schwächeren Odemangriff (zusätzlich zu seinen normalen Angriffen). Er führt seine WW mit der Stufe des Zauberers aus (oder mit seiner eigenen, wenn die höher ist). Seine Gestalt wird völlig grotesk und man kann ihn nicht mehr mit dem Tier in Verbindung bringen, das er einmal war. Wenn der Vertraute allerdings stirbt, verliert der Zauberer 75% seiner Magie- und seiner Trefferpunkte für 1-5 Wochen (die auf keine Weise zurückerlangt werden können, bis die Zeit verstrichen ist)"
                    },
                    {
                        "name": "Meister-Beschwörung",
                        "level": 20,
                        "value": "Wie Beschwörung II, nur können 19 Optionen gewählt werden"
                    },
                    {
                        "name": "Wahrhaftiges Binden",
                        "level": 25,
                        "value": "Wie Binden II, nur kann der Spruch jede Kreatur binden"
                    },
                    {
                        "name": "Wahrhaftiger Gebundenenbefehl",
                        "level": 30,
                        "value": "Wie Gebundenen befehligen II, nur kann eine Kreatur einer beliebigen Stufe betroffen werden"
                    },
                    {
                        "name": "Beschwörungsmeisterschaft",
                        "level": 50,
                        "value": "Der Zauberer kann einmal pro Runde einen der niedrigstufigeren Sprüche dieser Liste anwenden."
                    }
                ]
            },
            {
                "id": "13.3",
                "name": "9.7.4: Finstere Kontakte",
                "spells": [
                    {
                        "name": "Analyse erzwingen III",
                        "level": 2,
                        "value": "Zwingt einen Dämon der Klasse I, II oder III, der anwesend ist (oder kontaktiert wurde), einen Gegenstand zu analysieren. Die Chance, daß ein Dämon jede Eigenschaft des Gegenstandes richtig bestimmt, hängt von seiner Klasse ab. Dämonen der Klasse I und II haben eine Chance von 0%, die der Klasse III eine von 10%. Dämonen der Klasse IV haben eine 30%-Chance. Dämonen der Klasse V haben eine 60%-Chance. Dämonen der Klasse IV haben eine 90%- Chance. Zusätzlich zur normalen Fehlschlagswahrscheinlichkeit mißlingt dieser Spruch bei einem Prozentwurf, wenn er niedriger als oder gleich der Klasse des Dämonen ist (d.h. gegen einen Dämonen der Klasse III schlägt der Spruch bei einem Wurf von 01-03 um). Siehe Abschnitt 13-6 (Seite 254) für die Ergebnisse des Spruchfehlers"
                    },
                    {
                        "name": "Niederer dämonischer Kontakt",
                        "level": 3,
                        "value": "Der Zauberer nimmt Verbindung mit einem Dämonen auf (es dauert 2 Runden, bis der Kontakt hergestellt ist). Machen Sie einen Prozentwurf, um die Klasse der Dämonen zu ermitteln, der kontaktiert wird. Bei einem Ergebnis zwischen 01 und 60 wird ein Dämon der Klasse I kontaktiert"
                    },
                    {
                        "name": "Informationen erzwingen III",
                        "level": 5,
                        "value": "Wie Analyse erzwingen III, nur kann der Dämon gezwungen werden, eine Ja-Nein-Frage zu beantworten, zu der die Antwort in jemandes ungeschützten Verstand liegt. Die Chance, daß die Frage erfolgreich beantwortet wird, ist genauso wie bei Analyse erzwingen III, aber die Fehlschlagswahrscheinlichkeit ist 3 mal die Dämonenklasse"
                    },
                    {
                        "name": "Suche erzwingen III",
                        "level": 7,
                        "value": "Wie Analyse erzwingen III, nur kann der Dämon gezwungen werden, nach einer bestimmten Person, einem bestimmten Ort oder bestimmten Ding zu suchen. Der Dämon sucht, allerdings nicht in unserer Existenzebene. Wenn er die Person, den Ort oder das Ding gefunden hat, gibt er den Standort weiter. Die Chance, daß die Frage erfolgreich beantwortet wird, ist genauso wie bei Analyse erzwingen III, aber die Fehlschlagswahrscheinlichkeit ist 5 mal die Dämonenklasse"
                    },
                    {
                        "name": "Höherer dämonischer Kontakt",
                        "level": 10,
                        "value": "Wie Niederer dämonischer Kontakt, nur führen Sie einen Prozentwurf aus, um die Klasse des kontaktierten Dämonen zu bestimmen. Bei einem Ergebnis zwischen 01 und 60 wird ein Dämon der Klasse III kontaktiert"
                    },
                    {
                        "name": "Analyse erzwingen IV",
                        "level": 11,
                        "value": "Wie Analyse erzwingen III, nur können Dämonen der Klassen I"
                    },
                    {
                        "name": "Informationen erzwingen IV",
                        "level": 13,
                        "value": "Wie Informationen erzwingen III, nur können Dämonen der Klassen I"
                    },
                    {
                        "name": "Suche erzwingen IV",
                        "level": 14,
                        "value": "Wie Suche erzwingen III, nur können Dämonen der Klassen I"
                    },
                    {
                        "name": "Analyse erzwingen V",
                        "level": 15,
                        "value": "Wie Analyse erzwingen III, nur können Dämonen der Klassen I"
                    },
                    {
                        "name": "Dämonenverbindung (Analyse)",
                        "level": 16,
                        "value": "Wie Dämonenverbindung (Information), nur wirkt der Spruch wie ein Höherer dämonischer Kontakt und danach ein Analyse erzwingen IV"
                    },
                    {
                        "name": "Dämonenverbindung (Information)",
                        "level": 18,
                        "value": "Erzeugt eine permanente Verbindung zur Dämonenwelt. Das Ziel des Spruches muß ein großes Objekt oder ein Ort sein. Wird es aktiviert, wirkt es als Höherer dämonischer Kontakt und dann als Informationen erzwingen IV. Der Zielort oder -gegenstand kann einmal pro Tag aktiviert werden. Beispielsweise könnte der Spruch auf einen großen Spiegel gewirkt werden. Jemand kann diesen Spiegel einmal pro Tag benutzen, um die Antwort auf eine Frage zur halten („Spieglein, Spieglein an der Wand....“)"
                    },
                    {
                        "name": "Informationen erzwingen V",
                        "level": 19,
                        "value": "Wie Informationen erzwingen III, nur können Dämonen der Klassen I"
                    },
                    {
                        "name": "Dämonenverbindung (Suche)",
                        "level": 20,
                        "value": "Wie Dämonenverbindung (Information), nur wirkt der Spruch wie ein Höherer dämonischer Kontakt und danach ein Suche erzwingen IV"
                    },
                    {
                        "name": "Suche erzwingen V",
                        "level": 25,
                        "value": "Wie Suche erzwingen III, nur können Dämonen der Klassen I"
                    },
                    {
                        "name": "Analyse erzwingen VI",
                        "level": 30,
                        "value": "Wie Analyse erzwingen III, nur können Dämonen der Klassen I"
                    },
                    {
                        "name": "Informationen erzwingen VI",
                        "level": 50,
                        "value": "Wie Informationen erzwingen III, nur können Dämonen der Klassen I"
                    }
                ]
            },
            {
                "id": "13.4",
                "name": "9.7.5: Körperlicher Verfall",
                "spells": [
                    {
                        "name": "Schmerz",
                        "level": 1,
                        "value": "Das Ziel hat Schmerzen und erleidet 20% seiner verbleibenden Treffer als Schaden"
                    },
                    {
                        "name": "Beeinträchtigen I",
                        "level": 2,
                        "value": "Eines des körperlichen Attribute (Eigenschaften) des Ziels wird temporär um einen W10 gesenkt. Es wird nur das Temporäre Attribut gesenkt. Zu körperlichen Attributen gehören Stärke, Geschicklichkeit, Reaktion, Konstitution, Charisma und Selbstdisziplin (eines davon wird zufällig ausgewählt). Wenn die Spruchdauer ausläuft, wird das Attribut um genau den Wert angehoben, um den es gesenkt wurde (bis das Potential des Attributs erreicht ist)"
                    },
                    {
                        "name": "Pein",
                        "level": 3,
                        "value": "Wie Schmerz, aber die Pein wirkt natürlich und verringert die Treffer des Ziels um 10%, bis sie geheilt wird (der Zauberer muß die Art der Pein angegeben). Das Ziel ist sich nicht bewußt, daß der Spruch auf ihn gesprochen wurde, weil die Wirkung schleichend eintritt (das Ziel verliert einen Treffer pro Minute). Der SL sollte die Pein als etwas Natürliches beschreiben und kann sich entscheiden, dem Spieler nicht zu sagen, daß die Trefferpunkte des Spielers verringert wurden)"
                    },
                    {
                        "name": "Nervenüberlastung",
                        "level": 4,
                        "value": "Wie Schmerz, nur erleidet das Ziel 40% seiner verbleibenden Trefferpunkte als Schaden"
                    },
                    {
                        "name": "Eigenschaftsverfall I",
                        "level": 5,
                        "value": "Wie Beeinträchtigen I, nur sind die temporäreren und die potentiellen Attribute betroffen"
                    },
                    {
                        "name": "Beeinträchtigen III",
                        "level": 6,
                        "value": "Wie Beeinträchtigen I, nur ist der Schwund 3W10"
                    },
                    {
                        "name": "Stechen",
                        "level": 7,
                        "value": "Wie Pein, nur werden die Treffer um 20% verringert"
                    },
                    {
                        "name": "Agonie",
                        "level": 9,
                        "value": "Wie Schmerz, nur erleidet das Ziel 60% seiner verbleibenden Trefferpunkte als Schaden"
                    },
                    {
                        "name": "Eigenschaftsverfall II",
                        "level": 10,
                        "value": "Wie Eigenschaftsverfall I, nur ist der Schwund 2W10"
                    },
                    {
                        "name": "Beeinträchtigen V",
                        "level": 11,
                        "value": "Wie Beeinträchtigen I, nur ist der Schwund 5W10"
                    },
                    {
                        "name": "Krampf",
                        "level": 12,
                        "value": "Wie Pein, nur werden die Treffer um 40% verringert"
                    },
                    {
                        "name": "Massen-Schmerz",
                        "level": 13,
                        "value": "Wie Schmerz, nur kann die Stufe des Zauberers an Zielen betroffen werden"
                    },
                    {
                        "name": "Qual",
                        "level": 14,
                        "value": "Wie Schmerz, nur erleidet das Ziel 90% seiner verbleibenden Trefferpunkte als Schaden"
                    },
                    {
                        "name": "Eigenschaftsverfall III",
                        "level": 15,
                        "value": "Wie Eigenschaftsverfall I, nur ist der Schwund 3W10"
                    },
                    {
                        "name": "Massen-Beeinträchtigen I",
                        "level": 16,
                        "value": "Wie Beeinträchtigen I, nur ist die Stufe des Zauberers an Zielen betroffen"
                    },
                    {
                        "name": "Massen-Nervenüberlastung",
                        "level": 18,
                        "value": "Wie Nervenüberlastung, nur ist die Stufe des Zauberers an Zielen betroffen"
                    },
                    {
                        "name": "Massen-Eigenschaftsverfall I",
                        "level": 19,
                        "value": "Wie Eigenschaftsverfall I, nur ist die Stufe des Zauberers an Zielen betroffen"
                    },
                    {
                        "name": "Beeinträchtigen X",
                        "level": 20,
                        "value": "Wie Beeinträchtigen I, nur ist der Schwund 10W10"
                    },
                    {
                        "name": "Massen-Agonie",
                        "level": 25,
                        "value": "Wie Agonie, nur ist die Stufe des Zauberers an Zielen betroffen"
                    },
                    {
                        "name": "Eigenschaftsverfall V",
                        "level": 30,
                        "value": "Wie Eigenschaftsverfall I, nur ist der Schwund 5W10"
                    },
                    {
                        "name": "Wahrhaftiger Eigenschaftsverfall",
                        "level": 50,
                        "value": "Wie Eigenschaftsverfall I, nur wird ein körperliches Attribut auf 1 gesenkt."
                    }
                ]
            },
            {
                "id": "13.5",
                "name": "9.7.6: Materienzerrüttung",
                "spells": [
                    {
                        "name": "Eis vernichten I",
                        "level": 1,
                        "value": "Verwandelt 3m³ Eis in Wasserdampf"
                    },
                    {
                        "name": "Erde zu Staub I",
                        "level": 2,
                        "value": "Verwandelt 0,3m³ Erde in feinen Staub"
                    },
                    {
                        "name": "Spalte",
                        "level": 3,
                        "value": "Alle Risse und Fehler in einem bis zu 27m³ großen Teil eines beliebigen toten Materials dehnen sich bis zum Äußersten. Siehe Abschnitt 5.7 (Seite 38)"
                    },
                    {
                        "name": "Stein pulverisieren",
                        "level": 4,
                        "value": "Verwandelt 0,3m³ Stein in feines Pulver"
                    },
                    {
                        "name": "Eis vernichten X",
                        "level": 5,
                        "value": "Wie Eis vernichten I, nur sind bis zu 30m³ betroffen"
                    },
                    {
                        "name": "Zerrüttung I",
                        "level": 6,
                        "value": "Verwandelt 0,03m³ eines beliebigen anorganischen Materials (es muß ein Objekt sein) in feinen Staub"
                    },
                    {
                        "name": "Erde zu Staub X",
                        "level": 7,
                        "value": "Wie Erde zu Staub I, nur sind bis zu 30m³ betroffen"
                    },
                    {
                        "name": "Zerbersten",
                        "level": 8,
                        "value": "Ein anorganischer Gegenstand von bis zu 0,03 Kubikmeter zerbirst. Alle innerhalb eines Radius von 1,5m erleiden einen kritischen Aufpralltreffer der Intensität A und derjenige, der den Gegenstand hielt, einen der Intensität C. Gegenstände aus Metall erhalten einen besonderen Bonus von +30 auf den WW"
                    },
                    {
                        "name": "Stein pulverisieren X",
                        "level": 9,
                        "value": "Wie Stein pulverisieren I, nur sind bis zu 3m³ betroffen"
                    },
                    {
                        "name": "Wahrhaftige Eisvernichtung",
                        "level": 10,
                        "value": "Wie Eis vernichten I, nur sind pro Stufe des Zauberers 3m³ betroffen"
                    },
                    {
                        "name": "Zerrüttung X",
                        "level": 11,
                        "value": "Wie Zerrüttung I, nur sind bis zu 0,03m³ betroffen"
                    },
                    {
                        "name": "Wahrhaftiges Erde-zu-Staub",
                        "level": 12,
                        "value": "Wie Erde zu Staub, nur sind bis zu 30m³ betroffen"
                    },
                    {
                        "name": "Risse",
                        "level": 13,
                        "value": "Läßt in 3m³ eines anorganischen, nicht-metallnen Materials Risse entstehen"
                    },
                    {
                        "name": "Wahrhaftiges Steinpulversieren",
                        "level": 14,
                        "value": "Wie Stein pulverisieren I, nur sind bis zu 30m³ betroffen"
                    },
                    {
                        "name": "Zerfall I",
                        "level": 15,
                        "value": "Läßt 0,03m³ eines anorganischen Materials zu nichts zerfallen"
                    },
                    {
                        "name": "Fern-Materienzerrüttung",
                        "level": 17,
                        "value": "Wie ein beliebiger Spruch dieser Liste der 10. oder einer niedrigeren Stufe, nur ist die Reichweite 100m"
                    },
                    {
                        "name": "Zerfall X",
                        "level": 19,
                        "value": "Wie Zerfall I, nur sind 0,3m² betroffen"
                    },
                    {
                        "name": "Massen-Erde-zu-Staub",
                        "level": 20,
                        "value": "Wie Erde zu Staub I, nur sind bis zu 3m³ pro Stufe des Zauberers betroffen"
                    },
                    {
                        "name": "Massen-Steinpulverisierung",
                        "level": 25,
                        "value": "Wie Stein pulverisieren I, nur sind bis zu 3m³ pro Stufe des Zauberers betroffen"
                    },
                    {
                        "name": "Massen-Zerrüttung",
                        "level": 30,
                        "value": "Wie Zerrüttung I, nur können so viele Objekte (mit je bis zu 0,03m³) betroffen sein, wie der Zauberer Stufen hat, und der Spruch hat eine Reichweite von 30 Metern"
                    },
                    {
                        "name": "Wahrhaftiger Zerfall",
                        "level": 50,
                        "value": "Wie Zerfall I, nur sind Objekte bis zu 3m³ betroffen und die Reichweite ist 100m. B e s o n d e r e Anmerkungen In Abschnitt 5.24 (Seite 44) finden Sie Näheres zum Gebrauch böser Spruchlisten."
                    }
                ]
            }
        ]
    },
    {
        "id": "14",
        "name": "Offener Mentalismus",
        "spellLists": [
            {
                "id": "14.0",
                "name": "10.1.1: Abwehr von Angriffen",
                "spells": [
                    {
                        "name": "Geschoß umkehren",
                        "level": 1,
                        "value": "Der Zauberer kann jedes Schuß- oder Wurfgeschoß ablenken, das ihn innerhalb von 30 Metern passiert (er muß in der Lage sein, das Geschoß zu sehen). Der Angriff mit diesem Geschoß erhält dadurch einen Malus von -20"
                    },
                    {
                        "name": "Klinge umkehren",
                        "level": 2,
                        "value": "Wie Geschoß umkehren, gilt aber für Nahkampfangriffe"
                    },
                    {
                        "name": "Schild",
                        "level": 3,
                        "value": "Richtet einen unsichtbaren Schutzschild vor dem Zau-berer auf, der wie ein normales Schild wirkt (zieht 25 von den passenden Angriffen ab), aber keine Hand belegt. Dieser Spruch kann nicht mit einem echten Schild kombiniert werden"
                    },
                    {
                        "name": "Ablenken I",
                        "level": 5,
                        "value": "Wie Geschoß umkehren, aber der Malus ist -100"
                    },
                    {
                        "name": "Klingenabwehr I",
                        "level": 6,
                        "value": "Der Zauberer kann einen beliebigen Nahkampfangriff abwehren, sofern er ihn sieht (und er innerhalb der Reichweite stattfindet). Der Nahkampfangriff erhält dadurch einen Malus von -50"
                    },
                    {
                        "name": "Fehlschuß I",
                        "level": 8,
                        "value": "Der Zauberer kann jedes Schuß- oder Wurfgeschoß ablenken, das ihn innerhalb von 30 Metern passiert (er muß in der Lage sein, das Geschoß zu sehen). Der Angriff mit diesem Geschoß verfehlt das Ziel automatisch"
                    },
                    {
                        "name": "Windstille",
                        "level": 10,
                        "value": "Erzeugt ein Gebiet absoluter Windstille mit einer Ausdehnung von 3cm/ St um den Zauberer, in das kein Gas von außen eindringen kann. Normalerweise verbraucht eine Person den gesamten Sauerstoff im Laufe der Wirkungsdauer (1 Minute pro Stufe)"
                    },
                    {
                        "name": "Ablenken II",
                        "level": 11,
                        "value": "Wie Ablenken I, nur sind 2 Geschosse betroffen"
                    },
                    {
                        "name": "Spruch ablenken I",
                        "level": 13,
                        "value": "Lenkt einen elementaren Angriffsspruch auf den Zauberer ab. Der Angriffswurf erleidet so einen Malus von -50 (er muß im Sichtfeld des Zauberers sein)"
                    },
                    {
                        "name": "Klingenabwehr II",
                        "level": 15,
                        "value": "Wie Klingenabwehr I, nur sind 2 Nahkampfangriffe betroffen"
                    },
                    {
                        "name": "Ablenken III",
                        "level": 18,
                        "value": "Wie Ablenken I, nur sind 3 Geschosse betroffen"
                    },
                    {
                        "name": "Spruch ablenken II",
                        "level": 20,
                        "value": "Wie Spruch ablenken I, nur sind 2 elementare Angriffssprüche betroffen"
                    },
                    {
                        "name": "Klingenabwehr III",
                        "level": 25,
                        "value": "Wie Klingenabwehr I, nur sind 3 Nahkampfangriffe betroffen"
                    },
                    {
                        "name": "Spruch ablenken II",
                        "level": 30,
                        "value": "Wie Spruch ablenken I, nur sind 3 elementare Angriffssprüche betroffen"
                    },
                    {
                        "name": "Wahrhaftiges Ablenken",
                        "level": 50,
                        "value": "Wie Ablenken I, Klingenabwehr I und Spruch ablenken I, nur können drei beliebige Angriffe abgewehrt werden."
                    }
                ]
            },
            {
                "id": "14.1",
                "name": "10.1.2: Brillanz",
                "spells": [
                    {
                        "name": "Lichtstrahl",
                        "level": 1,
                        "value": "Aus der Handfläche des Zauberers entspringt ein Lichtkegel (wie der einer Taschenlampe) mit einer effektiven Reichweite von 15m. Wenn der Zauberer die Hand zur Faust ballt, wird das Licht „ausgeschaltet“. Öffnet er sie wieder, ist das Licht wieder da (sofern die Dauer noch nicht abgelaufen ist)"
                    },
                    {
                        "name": "Glimmen",
                        "level": 2,
                        "value": "Erzeugt einen kleinen Lichtpunkt mit 3cm Durchmesser, der sanft glimmt. Er bietet genug Licht für Nachtsicht, aber nicht ausreichend Licht für Personen ohne Nachtsicht, die sich im Dunkeln bewegen wollen"
                    },
                    {
                        "name": "Licht I",
                        "level": 3,
                        "value": "Beleuchtet 3m-Umkreis um den berührten Punkt"
                    },
                    {
                        "name": "Aura",
                        "level": 4,
                        "value": "Erzeugt eine leuchtende Aura um den Zauberer, die ihn mächtiger erscheinen läßt und zu einem Malus von -5 auf alle Angriffe gegen ihn führt"
                    },
                    {
                        "name": "Lichtblitz",
                        "level": 5,
                        "value": "[WW-Mod -10] Erzeugt einen grellen Lichtblitz mit einem Radius von 3 Metern. Alle Wesen innerhalb des Radius sind für 1 Runde/10 Fehlschlag benommen"
                    },
                    {
                        "name": "Schockstrahl",
                        "level": 6,
                        "value": "Ein Strahl intensiven, geladenen Lichts bricht aus der Handfläche des Zauberers. Die Ergebnisse dieses Angriffs werden mittels der Angriffstabelle: Schockstrahl 12-8 (Seite 245) bestimmt"
                    },
                    {
                        "name": "Dunkelheit I",
                        "level": 7,
                        "value": "Wie Licht I, aber der Radius ist so dunkel wie in einer dunklen Nacht. Vgl. Abschnitt 5.12 (Seite 38)"
                    },
                    {
                        "name": "Wahrhaftige Aura",
                        "level": 8,
                        "value": "Wie Aura, aber der Zauberer erscheint extrem mächtig, und der Malus ist -15"
                    },
                    {
                        "name": "Licht V",
                        "level": 10,
                        "value": "Wie Licht I, aber der Radius ist 15 Meter"
                    },
                    {
                        "name": "Dunkelheit V",
                        "level": 11,
                        "value": "Wie Dunkelheit I, nur ist der Radius 15 Meter"
                    },
                    {
                        "name": "Färbung",
                        "level": 13,
                        "value": "Läßt ein beliebiges Objekt von bis zu 30 Kubikmetern in einer beliebigen Farbe aufleuchten"
                    },
                    {
                        "name": "Signallicht",
                        "level": 15,
                        "value": "Ein Lichtstrahl (beliebiger Farbe) entspringt der Handfläche des Zauberers. Der Strahl kann bis zu 2 km lang sein"
                    },
                    {
                        "name": "Weite Dunkelheit",
                        "level": 16,
                        "value": "Wie Dunkelheit, nur ist der Radius 30m pro Stufe"
                    },
                    {
                        "name": "Pures Licht",
                        "level": 18,
                        "value": "Wie Licht I, nur ist der Radius 30 Meter groß, und das Licht ist hell wie volles Tageslicht. Alle magische Dunkelheit wird für die Spruchdauer aufgehoben"
                    },
                    {
                        "name": "Pure Dunkelheit",
                        "level": 19,
                        "value": "Verdunkelt einen 30m-Radius. Kein nichtmagisches Licht kann diese Dunkelheit durchdringen und magisches Licht (außer Purem Licht) muß einen WW bestehen, sonst erlischt es"
                    },
                    {
                        "name": "Sonnenfeuer",
                        "level": 20,
                        "value": "Bündelt das Sonnenlicht wie eine Linse, die zunächst auf einen festen Punkt gerichtet sein muß. Nach einer Runde kann sie mit einer Geschwindigkeit von 30cm pro Runde bewegt werden. Das Sonnenfeuer brennt sich durch einen Durchmesser von 30cm mit einer Geschwindigkeit von 30cm (bei Holz), 10cm (bei Stein) bzw. 3cm (bei Metall) pro Runde. Dieser Spruch kann nicht sinnvoll im Kampf eingesetzt werden (da Gegner problemlos ausweichen können). Wenn der Spruch allerdings auf einen Gegner angewandt wird, der sich nicht bewegen kann, sehen Sie bei Feuerhand nach, wie der Schaden ermittelt wird"
                    },
                    {
                        "name": "Wahrhaftiges Sonnenfeuer",
                        "level": 25,
                        "value": "Wie Sonnenfeuer, nur wird kein Sonnenlicht benötigt"
                    },
                    {
                        "name": "Feuerhand",
                        "level": 30,
                        "value": "Wie Sonnenfeuer, nur ist die Reichweite 15cm von der offenen Handfläche des Zauberers entfernt, wo der Fokus liegt (der Arm des Zauberers ist immun) und der Punkt kann 3m pro Runde bewegt werden. Der Spruch kann im Nahkampf verwendet werden und verursacht dort Treffer wie ein Feuerstrahl (Angriffstabelle: Feuerstrahl 12-6, Seite 241) mit doppeltem Trefferpunktschaden. Der OB ist 30 zuzüglich des Fertigkeitsbonus, den der Zauberer in Gezielte Sprüche für diese Liste erworben hat. Wenn dem Zauberer ein Spruchfehler unterläuft (01-02 UM), erleidet er einen automatischen kritischen Hitzetreffer der Intensität C"
                    },
                    {
                        "name": "Wahrhaftige Feuerhand",
                        "level": 50,
                        "value": "Wie Feuerhand, nur ist kein Sonnenlicht nötig."
                    }
                ]
            },
            {
                "id": "14.2",
                "name": "10.1.3: Entdeckungen",
                "spells": [
                    {
                        "name": "Mentalismus entdecken",
                        "level": 1,
                        "value": "Entdeckt alle aktiven Sprüche oder magischen Gegenstände aus dem Bereich Mentalismus"
                    },
                    {
                        "name": "Essenz entdecken",
                        "level": 2,
                        "value": "Wie Mentalismus entdecken, bezieht sich aber auf den Bereich der Essenz"
                    },
                    {
                        "name": "Leitmagie entdecken",
                        "level": 3,
                        "value": "Wie Mentalismus entdecken, bezieht sich aber auf den Bereich der Leitmagie"
                    },
                    {
                        "name": "Emotion entdecken",
                        "level": 4,
                        "value": "Wie Mentalismus entdecken, aber der Zauberer kann extreme Emotionen entdecken (Haß, Liebe, Traurigkeit usw.). Wenn es keine extremen Emotionen gibt (also nur normale Gefühle), dann entdeckt dieser Spruch nichts"
                    },
                    {
                        "name": "Unsichtbares entdecken",
                        "level": 5,
                        "value": "Wie Mentalismus entdecken, aber es werden alle unsichtbaren Lebewesen und Gegenstände entdeckt"
                    },
                    {
                        "name": "Böses entdecken",
                        "level": 6,
                        "value": "Wie Mentalismus entdecken, aber dieser Spruch entdeckt das „Böse“ in einem lebenden oder unbelebten Ziel"
                    },
                    {
                        "name": "Fallen entdecken",
                        "level": 7,
                        "value": "Wie Mentalismus entdecken, jedoch entdeckt man mit diesem Spruch eine Falle mit 75%-Wahrscheinlichkeit (die Komplexität der Falle kann diese Wahrscheinlichkeit modifizieren)"
                    },
                    {
                        "name": "Macht analysieren I",
                        "level": 8,
                        "value": "Wie Mentalismus entdecken, liefert aber eine Einschätzung der Machtfülle (Stufe) einer Person, eines magischen Gegenstandes oder Zauberspruchs"
                    },
                    {
                        "name": "Macht bestimmen",
                        "level": 10,
                        "value": "Wie Mentalismus entdecken, aber es wird die allgemeine Spruchklasse (in einem Gegenstand oder gewirkten Spruch) analysiert und von welcher Liste der Spruch stammt. Im Falle einer Person liefert dieser Spruch den Beruf dieser Person"
                    },
                    {
                        "name": "Macht analysieren II",
                        "level": 11,
                        "value": "Wie Macht analysieren I, nur ist die Reichweite 30m und der Wirkungsbereich ein Radius von 3 Metern"
                    },
                    {
                        "name": "Unsichtbares sehen",
                        "level": 13,
                        "value": "Wie Unsichtbares entdecken, nur kann der Zauberer überall auch Unsichtbares sehen, wo er überhaupt etwas sehen könnte. Zusätzlich erleidet er keine Abzüge im Kampf gegen unsichtbare Ziele (da sie für ihn nicht unsichtbar sind)"
                    },
                    {
                        "name": "Spruch entdecken",
                        "level": 15,
                        "value": "Wie Mentalismus entdecken, nur entdeckt der Zauberer jeden Spruch, der jemals in dem untersuchten Gebiet gesprochen wurde. Der Zauberer erfährt die Klasse des Spruchs und von welcher Liste er stammt.16. Macht analysieren III"
                    },
                    {
                        "name": "Spruch bestimmen",
                        "level": 18,
                        "value": "Wie Macht bestimmen, nur erfährt der Zauberer die genaue Klasse jedes Spruchs, der im Wirkungsbereich gewirkt wird"
                    },
                    {
                        "name": "Wahrhaftige Machtanalyse",
                        "level": 20,
                        "value": "Wie oben, nur ist die Reichweite 1,5 Kilometer und der Wirkungsbereich ein Radius von 100 Metern"
                    },
                    {
                        "name": "Wiederfinden",
                        "level": 25,
                        "value": "Liefert die Richtung und Entfernung zu jedem bestimmten Gegenstand oder Ort, mit dem der Zauberer vertraut ist oder von dem er eine genaue Beschreibung hat"
                    },
                    {
                        "name": "Wahrhaftiges Entdecken",
                        "level": 30,
                        "value": "Wie Mentalismus entdecken, allerdings kann einmal pro Runde jedweder andere Entdecken-Spruch dieser Liste angewendet werden"
                    },
                    {
                        "name": "Gewahrwerden",
                        "level": 50,
                        "value": "Der Zauberer kann alle niedrigstufigeren Endeckungsspruch dieser Liste (außer Wiederfinden) gleichzeitig anwenden"
                    }
                ]
            },
            {
                "id": "14.3",
                "name": "10.1.4: Forschung",
                "spells": [
                    {
                        "name": "Gefühl",
                        "level": 1,
                        "value": "Liefert eine grundlegende Vorstellung vom Zweck des untersuchten Gegenstandes (wenn er einen Zweck hat)"
                    },
                    {
                        "name": "Macht entdecken",
                        "level": 2,
                        "value": "Zeigt an, ob ein Objekt magische Macht enthält, nicht aber Menge oder Bereich. Der Zauberer kann sich jede Runde auf ein weiteres Objekt konzentrieren"
                    },
                    {
                        "name": "Herkunft",
                        "level": 3,
                        "value": "Liefert eine grobe Vorstellung vom Herkunftsort eines Objekts"
                    },
                    {
                        "name": "Fluch entdecken",
                        "level": 5,
                        "value": "Stellt fest, ob ein Fluch auf einem Gegenstand liegt"
                    },
                    {
                        "name": "Machtkunde",
                        "level": 6,
                        "value": "Zeigt Ursprung der Macht eines magischen Gegenstands"
                    },
                    {
                        "name": "Steinkunde",
                        "level": 7,
                        "value": "Zeigt an, wo, wann und wie ein bestimmter Stein bearbeitet wurde"
                    },
                    {
                        "name": "Gegenstandsvision",
                        "level": 8,
                        "value": "Liefert die Vision eines wichtigen Ereignisses in der Vergangenheit des untersuchten Gegenstands"
                    },
                    {
                        "name": "Forschen",
                        "level": 10,
                        "value": "Liefert wichtige Details über Herstellung und Zweck eines Objekts (nicht aber über spezifische Fähigkeiten magischer Gegenstände)"
                    },
                    {
                        "name": "Vergangenheitsvision I",
                        "level": 11,
                        "value": "Der Zauberer sieht in einer Vision bis zu 1 Stunde pro Stufe in die Vergangenheit. Die gewünschte Zeit kann auf 30 Minuten genau angegeben werden. Die Vision muß von einem Gegenstand oder einem Ort handeln. Die Vision kann bis zu 1 Minute pro Stufe andauern, so lange sich der Zauberer konzentriert und inaktiv bleibt"
                    },
                    {
                        "name": "Gegenstandskunde",
                        "level": 13,
                        "value": "Liefert die Hauptfähigkeiten und -kräfte eines Gegenstands"
                    },
                    {
                        "name": "Erinnerung an den Tod",
                        "level": 15,
                        "value": "Der Zauberer sieht in einer Vision, wie jemand starb, und ein Bild seines Mörders. Der Spruch muß innerhalb von 24 Stunden nach dem Tod oder in der Gegenwart der Leiche gewirkt werden"
                    },
                    {
                        "name": "Vergangenheit festhalten",
                        "level": 17,
                        "value": "Wenn dieser Spruch direkt vor Vergangenheitsvision gewirkt wird, kann der Zauberer das Augenmerk auf ein bestimmtes Ereignis in der Vergangenheit richten, das er dann mit Vergangenheitsvision untersucht"
                    },
                    {
                        "name": "Gegenstandsanalyse",
                        "level": 19,
                        "value": "Liefert einen kompletten Überblick über die Erstellung, die Kräfte und den Zweck des Gegenstands (das kann abgewandelt werden, wenn der Gegenstand ausgesprochen mächtig ist)"
                    },
                    {
                        "name": "Vergangenheitsvision II",
                        "level": 20,
                        "value": "Wie Vergangenheitsvision I, nur reicht sie bis zu einem Tag pro Stufe in die Vergangenheit (mit einer Abweichung von ± einer Stunde), und sie kann bis zu 10 Minuten pro Stufe andauern.  25. Vergangenheitsvision III"
                    },
                    {
                        "name": "Vergangenheitsvision IV",
                        "level": 30,
                        "value": "Wie Vergangenheitsvision I, nur reicht sie bis zu ein Jahr pro Stufe in die Vergangenheit (mit einer Abweichung von ± einer Woche), und sie kann bis zu fünf Stunden pro Stufe andauern"
                    },
                    {
                        "name": "Wahrhaftige Vergangenheitsvision",
                        "level": 50,
                        "value": "Wie Vergangenheitsvision I, nur reicht sie bis zu zehn Jahre pro Stufe in die Vergangenheit (mit einer Abweichung von ± einem Monat), und sie kann bis zu zehn Stunden pro Stufe andauern (jede Stunde der Vergangenheit dauert 10 Echtzeitminuten)."
                    }
                ]
            },
            {
                "id": "14.4",
                "name": "10.1.5: Illusionen",
                "spells": [
                    {
                        "name": "Brechung",
                        "level": 1,
                        "value": "Läßt ein unbelebtes Objekt von bis zu 30m³ um 3 Meter neben seinem tatsächlichen Standort erscheinen"
                    },
                    {
                        "name": "Trugbild Geräusch/Licht",
                        "level": 3,
                        "value": "Erzeugt ein einfaches, unbewegliches Trugbild oder unbewegliche Geräusche in einem Bereich von bis zu 3 Metern Radius"
                    },
                    {
                        "name": "Illusion II",
                        "level": 5,
                        "value": "Erzeugt ein einfaches, unbewegliches Trugbild/Szene in einem Bereich von bis zu 3 Metern Radius. Eine der folgenden Optionen kann zusätzlich mit ausgewählt werden: a) ein zusätzliches Geräusch kann hinzugefügt werden, b) die Dauer kann verdoppelt werden, c) die Reichweite kann verdoppelt werden, oder d) der Radius des Wirkungsbereiches kann verdoppelt werden. Alle Teile des Wirkungsbereiches müssen innerhalb der Reichweite liegen"
                    },
                    {
                        "name": "Phantasma I",
                        "level": 6,
                        "value": "Erstellt das Trugbild eines Objekts oder Lebewesens, das sich während der Konzentration des Zauberers nach Wunsch bewegt. Bricht die Konzentration ab, erstarrt das Trugbild, bleibt aber bestehen. Wenn der Zauberer die Konzentration wieder aufnimmt, kann er das Trugbild erneut bewegen (sofern die Dauer nicht abgelaufen ist). Das Bild kann jede Größe haben, solange es in den Radius paßt"
                    },
                    {
                        "name": "Mirakel Licht I",
                        "level": 7,
                        "value": "Verändert das sichtbare Aussehen eines Objektes. Das Ziel darf nicht mehr Masse als 5kg pro Stufe haben"
                    },
                    {
                        "name": "Illusion III",
                        "level": 8,
                        "value": "Wie Illusion II, aber zwei Optionen können gewählt werden"
                    },
                    {
                        "name": "Verzögerte Illusion I",
                        "level": 10,
                        "value": "Wie Trugbild Geräusch/Licht, aber die Illusion kann um bis zu 24 Stunden verzögert werden. Beim Wirken des Spruches entscheidet sich der Zauberer, was die Illusion auslöst. Er hat dabei die Wahl aus: a) Zeitperiode, b) bestimmte Bewegungen oder c) bestimmte Geräusche"
                    },
                    {
                        "name": "Illusion IV",
                        "level": 11,
                        "value": "Wie Illusion II, aber drei Optionen können gewählt werden"
                    },
                    {
                        "name": "Phantasma II",
                        "level": 12,
                        "value": "Wie Phantasma I, aber es kann eine der folgenden Optionen ausgewählt werden: a) ein zusätzlicher Sinn kann hinzugefügt werden, b) die Dauer kann verdoppelt werden, c) der Radius der Kugel, die den Wirkungsbereich umfaßt, kann verdoppelt werden, d) die Reichweite kann verdoppelt werden, e) ein weiteres Trugbild kann erzeugt und unabhängig vom ersten bewegt werden (alle Trugbilder müssen sich jedoch zu jeder Zeit vollständig in der Reichweite und im Sichtbereich des Zauberers befinden)"
                    },
                    {
                        "name": "Verzögerte Illusion II",
                        "level": 14,
                        "value": "Eine Illusion II, nur kann sie wie eine Verzögerte Illusion I aufgeschoben werden"
                    },
                    {
                        "name": "Illusion V",
                        "level": 15,
                        "value": "Wie Illusion II, aber es können vier Optionen gewählt werden"
                    },
                    {
                        "name": "Phantasma III",
                        "level": 17,
                        "value": "Wie Phantasma II, aber es können zwei Optionen gewählt werden"
                    },
                    {
                        "name": "Verzögerte Illusion III",
                        "level": 19,
                        "value": "Eine Illusion III, nur kann sie wie eine Verzögerte Illusion I aufgeschoben werden"
                    },
                    {
                        "name": "Illusion VII",
                        "level": 20,
                        "value": "Wie Illusion II, aber es können sechs Optionen gewählt werden"
                    },
                    {
                        "name": "Verzögerte Illusion V",
                        "level": 25,
                        "value": "Eine Illusion V, nur kann sie wie eine Verzögerte Illusion I aufgeschoben werden"
                    },
                    {
                        "name": "Illusion X",
                        "level": 30,
                        "value": "Wie Illusion II, aber es können neun Optionen gewählt werden"
                    },
                    {
                        "name": "Phantasma V",
                        "level": 50,
                        "value": "Wie Phantasma II, aber es können vier Optionen gewählt werden."
                    }
                ]
            },
            {
                "id": "14.5",
                "name": "10.1.6: Selbstheilung",
                "spells": [
                    {
                        "name": "Gerinnen I",
                        "level": 2,
                        "value": "Gestattet dem Zauberer, Blutverlust um 1 Treffer/Runde zu reduzieren, solange er sich konzentriert oder nicht bewegt. Der Effekt ist nach einer Stunde permanent. Wenn der Zauberer bewußtlos ist, funktioniert dieser Spruch auch ohne Konzentration"
                    },
                    {
                        "name": "Gerinnen III",
                        "level": 4,
                        "value": "Wie Gerinnen I, aber die Blutung wird um 3 Treffer/Runde reduziert"
                    },
                    {
                        "name": "Regenerieren I",
                        "level": 5,
                        "value": "Reduziert die Treffer des Zauberers während der Konzentrationsdauer um 1 Treffer/ Minute. Bei Bewußtlosigkeit des Zauberers funktioniert dieser Spruch automatisch ohne Konzentration"
                    },
                    {
                        "name": "Richten von Brüchen",
                        "level": 6,
                        "value": "Indem man sich mit diesem Spruch 2 Stunden konzentriert, wird ein gebrochener Knochen geheilt (aber kein gesplitterter oder zerstörter Knochen)"
                    },
                    {
                        "name": "Blutung stillen I",
                        "level": 7,
                        "value": "Wie Gerinnen I, aber der Effekt ist sofort permanent"
                    },
                    {
                        "name": "Muskeln/Sehnen heilen",
                        "level": 8,
                        "value": "Wie Richten von Brüchen, aber beschädigte Muskeln oder Sehnen können geheilt werden"
                    },
                    {
                        "name": "Heilung leichter Nervenschäden",
                        "level": 10,
                        "value": "Gestattet es dem Zauberer, leichten Schaden an einem Nerv zu heilen. Genesungszeit: 1 Tag. Leichter Schaden wird definiert als Nervenschaden, der einen Malus von bis zu -20 hervorruft"
                    },
                    {
                        "name": "Auge/Ohr heilen",
                        "level": 11,
                        "value": "Wenn sich der Zauberer unter der Wirkung dieses Spruchs an 1-10 Tagen (je nach Schwere der Verletzung) jeweils 2 Stunden konzentriert, kann er einen beliebigen Schaden am Außenohr (auch den Verlust des Ohrs) oder leichte Augenschäden (Hornhautabschürfung, Fremdkörper im Auge) heilen"
                    },
                    {
                        "name": "Vene/Arterie heilen",
                        "level": 12,
                        "value": "Wie Richten von Brüchen, nur wird eine Vene oder Arterie geheilt"
                    },
                    {
                        "name": "Regenerieren II",
                        "level": 13,
                        "value": "Wie Regenerieren I, nur werden pro Minute 2 Treffer geheilt"
                    },
                    {
                        "name": "Selbstbewahrung",
                        "level": 15,
                        "value": "Wenn er einen tödlichen Treffer erleidet, fällt der Zauberer in einen Scheintodzustand, bis er geheilt oder sein Gehirn zerstört wird"
                    },
                    {
                        "name": "Selbstanfügen",
                        "level": 17,
                        "value": "Erlaubt dem Zauberer, eine abgetrennte Gliedmaße wieder anzufügen"
                    },
                    {
                        "name": "Wahrhaftiges Regenerieren",
                        "level": 20,
                        "value": "Wie Regenerieren I, nur wird ein Treffer pro Runde geheilt"
                    },
                    {
                        "name": "Gliedmaßenregeneration",
                        "level": 25,
                        "value": "Wenn sich der Zauberer an 10-100 Tagen jeweils 2 Stunden konzentriert, kann er eine Gliedmaße regenerieren"
                    },
                    {
                        "name": "Organregeneration",
                        "level": 30,
                        "value": "Nachdem ein beliebiges Organ (außer dem Gehirn) zerstört wurde, kann der Zauberer zuerst Selbstbewahrung und dann diesen Spruch wirken. Das Organ hat sich nach 10-100 Tagen völliger Inaktivität regeneriert"
                    },
                    {
                        "name": "Wahrhaftige Regeneration",
                        "level": 50,
                        "value": "Wie Organregeneration, nur wird aller Schaden (mit Ausnahme des Gehirns) in 10-100 Tagen ausgeheilt."
                    }
                ]
            },
            {
                "id": "14.6",
                "name": "10.1.7: Tarnung",
                "spells": [
                    {
                        "name": "Flimmern",
                        "level": 1,
                        "value": "Der Zauberer erscheint Angreifern verschwommen, dies bewirkt einen Abzug von -10 auf Angriffe gegen den Zauberer"
                    },
                    {
                        "name": "Schatten",
                        "level": 2,
                        "value": "Der Zauberer und die Objekte an seiner Person erscheinen nur noch als Schatten und sind dadurch in Dunkelheit nahezu unsichtbar. In vielen Situationen sollte dies einen Bonus von +25 bis +75 (SL-Entscheidung) auf Schleichen und/oder Verstecken ergeben"
                    },
                    {
                        "name": "Transparenz",
                        "level": 3,
                        "value": "Ein einzelnes Objekt wird unsichtbar (1 Gewand, 1 nackter Körper usw.), bis entweder 24 Stunden verstrichen sind, oder bis das Ziel von einem harten Schlag getroffen wird (von einer Waffe getroffen werden, Sturz usw.), oder bis das Ziel eine gewalttätige Handlung ausführt (z.B. einen Angriff )"
                    },
                    {
                        "name": "Tarnung I",
                        "level": 4,
                        "value": "[WW-Mod -50] Das Ziel macht einen WW. Schlägt dieser fehl, ist der Zauberer für dieses Ziel unsichtbar, alle anderen sehen ihn normal. Wenn der Zauberer offensichtliche Aktionen ausführt (z.B. Sprechen, ein Objekt bewegen usw.), darf das Ziel einen erneuten WW durchführen (der SL kann diesen WW mittels Boni beeinflussen, abhängig davon, wie offensichtlich die Aktion war). Wenn der Zauberer das Ziel angreift, darf es einen erneuten WW mit einem Bonus von +50 durchführen. Wenn der Zauberer sich konzentriert (50% Aktivität), kann er die Wirkung dieses Spruches beliebig ausdehnen (solange er die Konzentration nicht nach Ablauf der Wirkungsdauer unterbricht)"
                    },
                    {
                        "name": "Fassade I",
                        "level": 5,
                        "value": "Dies ist eine begrenzte Illusion, mit der der Zauberer wie eine beliebige humanoide Figur (±20% seiner Größe) aussehen kann. In Abschnitt 5.14 (Seite 40) finden Sie mehr zu Illusionen"
                    },
                    {
                        "name": "Tarnung III",
                        "level": 6,
                        "value": "Wie Tarnung I, aber der Zauberer kann bis zu 3 Ziele beeinflussen (ein Basis-Angriffswurf für alle Ziele)"
                    },
                    {
                        "name": "Tarnsphäre I",
                        "level": 7,
                        "value": "Wie Tarnung I, aber jedes Ziel im Wirkungsbereich muß einen WW ablegen (ein Basis-Angriffswurf für alle Ziele). Wenn ein Ziel einmal den WW geschafft hat, muß es für diesen Spruch keinen weiteren WW ausführen"
                    },
                    {
                        "name": "Tarnung V",
                        "level": 8,
                        "value": "Wie Tarnung I, aber der Zauberer kann bis zu 5 Ziele beeinflussen (ein Basis-Angriffswurf für alle Ziele)"
                    },
                    {
                        "name": "Tarnsphäre II",
                        "level": 9,
                        "value": "Wie Tarnsphäre I, bis auf den Wirkungsbereich"
                    },
                    {
                        "name": "Schattenmentalist I",
                        "level": 10,
                        "value": "Erzeugt einen Doppelgänger des Zauberers. Wenn er sich konzentriert, kann er den Doppelgänger beliebig steuern, anderenfalls bewegt er sich exakt synchron. Der Doppelgänger kann sich nur innerhalb der Reichweite aufhalten. Wenn sich der Zauberer konzentriert, kann er mit dem Doppelgänger „verschmelzen“ und sich wieder aufteilen (so daß es schwierig ist, den echten Zauberer zu ermitteln)"
                    },
                    {
                        "name": "Fassade II",
                        "level": 11,
                        "value": "Wie Fassade I, nur kann die Illusion auch Geräusche und Stimmen beinhalten"
                    },
                    {
                        "name": "Tarnung X",
                        "level": 12,
                        "value": "Wie Tarnung I, aber der Zauberer kann bis zu 10 Ziele beeinflussen (ein Basis-Angriffswurf für alle Ziele)"
                    },
                    {
                        "name": "Tarnsphäre III",
                        "level": 13,
                        "value": "Wie Tarnsphäre I, bis auf den Wirkungsbereich"
                    },
                    {
                        "name": "Verschieben I",
                        "level": 14,
                        "value": "Das Ziel scheint leicht von seinem eigentlichen Aufenthaltsort versetzt zu sein. Angriffe auf es schlagen mit einer Wahrscheinlichkeit von 10% fehl. Jedesmal, wenn das Ziel wegen dieses Spruchs verfehlt wurde, sinkt die Wahrscheinlichkeit um 5%"
                    },
                    {
                        "name": "Camouflage",
                        "level": 15,
                        "value": "Der Zauberer und Gegenstände, die er am Körper trägt, nehmen die sichtbare Beschaffenheit, die Farbe und die Form der Umgebung an. Wenn er sich nicht bewegt, ist der Zauberer fast unsichtbar (ein besonderer Bonus von +200 auf Verstecken) und er erhält einen besonderen Bonus von +50 auf Schleichen (wenn er sich konzentriert). Dieser Spruch ist nicht mit Schatten kumulativ"
                    },
                    {
                        "name": "Tarnung XX",
                        "level": 16,
                        "value": "Wie Tarnung I, aber der Zauberer kann bis zu 20 Ziele beeinflussen (ein Basis-Angriffswurf für alle Ziele)"
                    },
                    {
                        "name": "Verschieben II",
                        "level": 18,
                        "value": "Wie Verschieben I, nur besteht eine 20%-Wahrscheinlichkeit, daß Angriffe erfolglos bleiben"
                    },
                    {
                        "name": "Tarnsphäre V",
                        "level": 19,
                        "value": "Wie Tarnsphäre I, bis auf den Wirkungsbereich"
                    },
                    {
                        "name": "Schattenmentalist II",
                        "level": 20,
                        "value": "Wie Schattenmentalist I, nur entstehen zwei Doppelgänger"
                    },
                    {
                        "name": "Verschieben III",
                        "level": 25,
                        "value": "Wie Verschieben I, nur besteht eine 30%- Wahrscheinlichkeit, daß Angriffe erfolglos bleiben"
                    },
                    {
                        "name": "Wahrhaftige Camouflage",
                        "level": 30,
                        "value": "Wie Camouflage, nur muß sich der Zauberer nicht konzentrieren, wenn er sich bewegt, und der Bonus auf Schleichen ist +75"
                    },
                    {
                        "name": "Wahrhaftige Tarnung",
                        "level": 50,
                        "value": "Wie Tarnung I, aber der Zauberer kann seine Stufe an Zielen tarnen, und die Reichweite ist nur durch seine Sichtweite beschränkt."
                    }
                ]
            },
            {
                "id": "14.7",
                "name": "10.1.8: Vorahnung",
                "spells": [
                    {
                        "name": "Geschoß ahnen",
                        "level": 1,
                        "value": "Der Zauberer ist sich jedes Geschosses bewußt, das diese Runde auf ihn abgefeuert wird. Wenn er sich zur Zeit bewegen kann, bekommt er gegen einen Fernangriff seiner Wahl einen Bonus von +50 auf seinen DB. Der Zauberer bewegt sich zumindest leicht, um dem Angriff auszuweichen"
                    },
                    {
                        "name": "Schlag ahnen",
                        "level": 2,
                        "value": "Wie Geschoß ahnen, betrifft aber Nahkampfangriffe"
                    },
                    {
                        "name": "Raten",
                        "level": 3,
                        "value": "Wenn er eine Wahl treffen muß, die auf wenigen oder gar keinen Informationen beruht (z.B. welcher Gang am schnellsten ins Freie führt), kann der Zauberer diesen Spruch einsetzen. Der Spielleiter entscheidet dann, welche Wahl er trifft, wobei er die Entscheidung um 25% zugunsten des Zauberers beeinflußt (würfeln Sie also 1W100: 01-25 entspricht einer falschen Entscheidung, 26-100 einer richtigen). Nein, der SL hat keinen WW"
                    },
                    {
                        "name": "Spruch ahnen",
                        "level": 4,
                        "value": "Wie Geschoß ahnen, betrifft aber Spruchangriffe. Der Zauberer erhält einen Bonus von +50 auf seinen DB gegen gezielte elementare Angriffssprüche oder +20 gegen einen elementaren Flächenangriff, oder ein Basis-Spruchangriff gegen ihn erhält -10 auf den Wurf"
                    },
                    {
                        "name": "Eingebung I",
                        "level": 5,
                        "value": "Der Zauberer erlebt in einer Vision, was in der nächsten Minute wahrscheinlich geschehen wird, wenn er eine bestimmte Handlung durchführt"
                    },
                    {
                        "name": "Feindschaft ahnen",
                        "level": 6,
                        "value": "Der Zauberer ist sich jedes Wesens im Wirkungsbereich bewußt, das feindliche Absichten gegen ihn hegt. Diese Feindschaft muß ausdrücklich gegen den Zauberer gerichtet sein, ansonsten verrät dieser Spruch nichts. Die Feindschaft muß aktiv sein, d.h. aggressive Aktionen müssen geplant sein. Passiver Haß gegen den Zauberer wird nicht enthüllt"
                    },
                    {
                        "name": "Traum I",
                        "level": 8,
                        "value": "Der Zauberer hat einen Traum über ein vor dem Einschlafen festgelegtes Thema. Er muß einen normalen Schlafzyklus durchschlafen (mindestens 4 Stunden), oder der Spruch liefert kein Ergebnis. Dieser Spruch kann nur einmal pro Nacht eingesetzt werden"
                    },
                    {
                        "name": "Raumgefühl I",
                        "level": 9,
                        "value": "Der Zauberer erhält eine Vision, die ihm zeigt, was sich innerhalb der letzten 1min/St in einem Raum oder an einem Ort zugetragen hat. Die Raumgröße ist beschränkt auf den Wirkungsbereich"
                    },
                    {
                        "name": "Vorahnung",
                        "level": 10,
                        "value": "Gibt die wahrscheinlichste Aktion eines Wesens (das Ziel) in der nächsten Runde an. Details erfährt man aber nicht (man erkennt z.B. einen Nahkampfangriff oder einen Zaubereinsatz, aber nicht, wer angegriffen wird oder um welchen Spruch es sich handelt). Der Zauberer kann so seine Aktion in der nächsten Runde ansagen, nachdem er die Aktion des Ziels kennt. Beachten Sie, daß das Ziel seine Aktionen auch noch widerrufen kann (unter Berücksichtigung der entsprechenden Abzüge)"
                    },
                    {
                        "name": "Eingebung II",
                        "level": 11,
                        "value": "Wie Eingebung I, nur kann der Zauberer 2 Minuten in die Zukunft sehen"
                    },
                    {
                        "name": "Raumgefühl II",
                        "level": 12,
                        "value": "Wie Raumgefühl I, nur reicht die Vision bis zu eine Stunde pro Stufe in die Vergangenheit"
                    },
                    {
                        "name": "Wahrhaftige Feindschaftsahnung",
                        "level": 13,
                        "value": "Wie Feindschaft ahnen, bis auf den Wirkungsbereich, die Dauer und die Reichweite"
                    },
                    {
                        "name": "Traum II",
                        "level": 14,
                        "value": "Wie Traum I, nur kann der Zauberer bis zu 2 Träume pro Nacht zu verschiedenen Themen haben"
                    },
                    {
                        "name": "Spruchvorahnung",
                        "level": 15,
                        "value": "Wie Vorahnung, nur wenn die Aktion ist, daß ein Spruch gewirkt wird, so erfährt der Zauberer, welcher Spruch es ist und welches Ziel er hat"
                    },
                    {
                        "name": "Raumgefühl III",
                        "level": 16,
                        "value": "Wie Raumgefühl I, nur reicht die Vision bis zu einen Tag pro Stufe in die Vergangenheit"
                    },
                    {
                        "name": "Traum III",
                        "level": 17,
                        "value": "Wie Traum I, nur kann der Zauberer bis zu 3 Träume pro Nacht zu verschiedenen Themen haben"
                    },
                    {
                        "name": "Wahrhaftiges Raumgefühl",
                        "level": 19,
                        "value": "Wie Raumgefühl I, nur reicht die Vision bis zu eine Woche pro Stufe in die Vergangenheit"
                    },
                    {
                        "name": "Wahrhaftige Eingebung",
                        "level": 20,
                        "value": "Wie Eingebung I, nur kann er bis zu eine Minute pro Stufe in die Zukunft sehen"
                    },
                    {
                        "name": "Wahrhaftige Vorahnung",
                        "level": 25,
                        "value": "Wie Vorahnung, nur kann der Zauberer die Aktion aller Wesen vorhersagen, die nicht mehr als 30m von ihm entfernt sind"
                    },
                    {
                        "name": "Traum V",
                        "level": 30,
                        "value": "Wie Traum I, nur kann der Zauberer bis zu 5 Träume pro Nacht zu beliebigen Themen haben"
                    },
                    {
                        "name": "Wahrhaftige Spruchvorahnung",
                        "level": 50,
                        "value": "Wie Wahrhaftige Spruchvorahnung, nur erfährt der Zauberer Sprucharten und -ziele. Besondere Anmer- kungen 1) Wenn der Zauberer Raten benutzt, muß er eine begrenzte Anzahl an Optionen zur Verfügung haben. Nachdem der Spruch gewirkt wurde, darf der Zauberer kein weiteres Raten für dieselbe Information wirken, bevor er seinen Rang in der Spruchliste erhöht hat. 2) Bei Träumen sollte der SL Symbolik einsetzen (vgl. Abschnitt 5.16, Seite 40). 3) In Abschnitt 5.13 (Seite 39) finden Sie mehr zu Informationssprüchen."
                    }
                ]
            },
            {
                "id": "14.8",
                "name": "10.1.9: Widerstand gegen Magie",
                "spells": [
                    {
                        "name": "Schutz I",
                        "level": 1,
                        "value": "Zieht 5 von allen elementaren Angriffen gegen den Zauberer ab, und alle WW für den Zauberer gegen Sprüche haben einen Bonus von +5"
                    },
                    {
                        "name": "Mentalismus aufheben",
                        "level": 2,
                        "value": "Wenn der Zauberer Ziel eines Spruches aus dem Bereich Mentalismus wird, muß dieser „ankommende“ Spruch vor dem Zauberer einen WW durchführen. Dabei benutzt der Spruch als Stufe die desjenigen, der ihn gewirkt hat. Wenn der „ankommende“ Spruch diesen WW besteht, betrifft er den Zauberer von Mentalismus aufheben normal (der Zauberer hat dann noch seinen normalen WW). Wenn nicht, betrifft er den Zauberer nicht"
                    },
                    {
                        "name": "Essenz aufheben",
                        "level": 4,
                        "value": "Wie Mentalismus aufheben, betrifft aber Sprüche aus dem Bereich Essenz"
                    },
                    {
                        "name": "Schutz II",
                        "level": 5,
                        "value": "Wie Schutz I, aber die Boni sind 10"
                    },
                    {
                        "name": "Leitmagie aufheben",
                        "level": 6,
                        "value": "Wie Mentalismus aufheben, betrifft aber Sprüche aus dem Bereich Leitmagie"
                    },
                    {
                        "name": "Mentalismusschild",
                        "level": 8,
                        "value": "Erzeugt einen schimmernden Schild vor dem Zauberer. Alle Basis-Angriffswürfe für frontale Mentalismussprüche (Basis- und elementar) gegen ihn erhalten einen Malus von -10. Führt der Zauberer während einer Runde keine anderen Handlungen aus, kann er einen Zauberangriff „parieren“. Sein Parade-Bonus entspricht 10 plus der Anzahl an Fertigkeitsrängen in dieser Liste"
                    },
                    {
                        "name": "Essenzschild",
                        "level": 10,
                        "value": "Wie Geistesschild, es ist aber nur gegen Essenzsprüche effektiv"
                    },
                    {
                        "name": "Schutz III",
                        "level": 11,
                        "value": "Wie Schutz I, nur sind die Boni 15"
                    },
                    {
                        "name": "Leitmagieschild",
                        "level": 13,
                        "value": "Wie Mentalismusschild, er wirkt aber nur gegen Leitmagiesprüche"
                    },
                    {
                        "name": "Spruchschild",
                        "level": 15,
                        "value": "Wie Mentalismusschild, aber er wirkt gegen zwei beliebige der drei Magiebereiche"
                    },
                    {
                        "name": "Schutz V",
                        "level": 17,
                        "value": "Wie Schutz I, aber die Boni sind 25"
                    },
                    {
                        "name": "Wahrhaftiger Spruchschild",
                        "level": 19,
                        "value": "Wie Leitmagieschild, nur wirkt der Schild gegen alle Sprüche"
                    },
                    {
                        "name": "Mentalismuswiderstand",
                        "level": 20,
                        "value": "Verleiht einen besonderen Bonus von +50 auf alle Widerstandswürfe gegen Mentalismussprüche"
                    },
                    {
                        "name": "Essenzwiderstand",
                        "level": 25,
                        "value": "Wie Mentalismuswiderstand, wirkt aber nur gegen Essenzsprüche"
                    },
                    {
                        "name": "Leitmagiewiderstand",
                        "level": 30,
                        "value": "Wie Mentalismuswiderstand, wirkt aber nur gegen Leitmagiesprüche"
                    },
                    {
                        "name": "Wahrhaftiger Widerstand",
                        "level": 50,
                        "value": "Wie Mentalismuswiderstand, aber er wirkt gegen zwei beliebige der drei Magiebereiche."
                    }
                ]
            },
            {
                "id": "14.9",
                "name": "10.1.10: Widerstand gegen Schaden",
                "spells": [
                    {
                        "name": "Widerstand gegen Hitze",
                        "level": 1,
                        "value": "Der Zauberer ist vor natürlicher Hitze bis zu 75°C geschützt (als ob es 21°C wäre). Bei Temperaturen über 75°C ziehen Sie 50°C ab, um die effektive Temperatur für den Zauberer zu bestimmen. Der Zauberer erhält +20 auf alle WW gegen Hitzesprüche und Hitzeangriffe (+20 DB gegen elementare Feuer- und Hitzeangriffe)"
                    },
                    {
                        "name": "Widerstand gegen Kälte",
                        "level": 2,
                        "value": "Der Zauberer ist vor natürlicher Kälte bis runter zu -10°C geschützt (als ob es 21°C wäre). Bei Temperaturen unter -10°C addieren Sie 30°C, um die effektive Temperatur für den Zauberer zu bestimmen. Der Zauberer erhält +20 auf alle WW gegen Kältesprüche und Kälteangriffe (+20 DB gegen elementare Kälte- und Eisangriffe)"
                    },
                    {
                        "name": "Zähigkeit I",
                        "level": 5,
                        "value": "Der Zauberer kann zusätzliche 25% seiner Trefferpunkte aushalten (runden Sie ab), bevor er bewußtlos wird. Die Treffer erhält er aber dennoch, und sie wirken voll, wenn der Spruch ausläuft"
                    },
                    {
                        "name": "Benommenheit heilen I",
                        "level": 6,
                        "value": "Heilt eine Runde Benommenheit"
                    },
                    {
                        "name": "Widerstand gegen Gift",
                        "level": 7,
                        "value": "Hält das Gift so lange auf, wie der Zauberer sich konzentriert"
                    },
                    {
                        "name": "Zähigkeit II",
                        "level": 10,
                        "value": "Wie Zähigkeit I, aber der Zauberer hält 50% zusätzliche Treffer aus"
                    },
                    {
                        "name": "Benommenheit heilen III",
                        "level": 11,
                        "value": "Wie Benommenheit heilen I, nur werden 3 Runden Benommenheit geheilt"
                    },
                    {
                        "name": "Gift neutralisieren",
                        "level": 12,
                        "value": "Dieser Spruch hat eine 50% Chance, ein beliebiges Gift zu neutralisieren (modifiziert durch die Giftstärke), wenn der Zauberer bewußtlos ist oder sich eine Stunde lang darauf konzentriert. Auf jeden Fall verzögert der Spruch die Giftwirkung, solange sich der Zauberer konzentriert"
                    },
                    {
                        "name": "Aufwachen",
                        "level": 14,
                        "value": "Läßt den Zauberer aus jedem unnatürlichen Schlaf (z.B. durch einen Schlafspruch, eine Schlafdroge usw.) erwachen. Der Zauberer braucht eine Runde, um aufzuwachen"
                    },
                    {
                        "name": "Zähigkeit III",
                        "level": 15,
                        "value": "Wie Zähigkeit I, aber der Zauberer hält 75% zusätzliche Treffer aus"
                    },
                    {
                        "name": "Wahrhaftiger Hitzewiderstand",
                        "level": 17,
                        "value": "Wie Widerstand gegen Hitze, nur ist der Zauberer immun gegen natürliche Hitze und erleidet durch Hitzesprüche nur 50% des normalen Schadens"
                    },
                    {
                        "name": "Wahrhaftiger Kältewiderstand",
                        "level": 18,
                        "value": "Wie Widerstand gegen Kälte, nur ist der Zauberer immun gegen natürliche Kälte und erleidet durch Kältesprüche nur 50% des normalen Schadens"
                    },
                    {
                        "name": "Zähigkeit IV",
                        "level": 20,
                        "value": "Wie Zähigkeit I, aber der Zauberer hält 100% zusätzliche Treffer aus"
                    },
                    {
                        "name": "Wahrhaftige Giftneutralisierung",
                        "level": 25,
                        "value": "Wie Gift neutralisieren, nur wird das Gift mit einer Wahrscheinlichkeit von 100% (modifiziert) neutralisiert"
                    },
                    {
                        "name": "Wahrhaftiges Aufwachen",
                        "level": 30,
                        "value": "Wie Aufwachen, nur gibt es keine Verzögerung, und der Spruch gilt auch für normalen Schlaf und kann so eingestellt werden, daß ihn eine beliebige Aktivität auslöst (z.B. Angriff, Gefahr usw.)"
                    },
                    {
                        "name": "Wahrhaftige Zähigkeit",
                        "level": 50,
                        "value": "Wie Zähigkeit IV, nur kann der Zauberer alle Schmerzen ignorieren. Er bleibt aktiv, bis er mehr als das Zweifache seiner Trefferpunkte + seiner temporären Konstitution erlitt. Er kann alle Abzüge durch Wunden vernachlässigen (d.h. negative Modifikatoren auf Aktionen). Wenn er diese Grenze überschreitet, wird er nicht bewußtlos, sondern stirbt durch den systemischen Schock."
                    }
                ]
            }
        ]
    },
    {
        "id": "15",
        "name": "Geschlossener Mentalismus",
        "spellLists": [
            {
                "id": "15.0",
                "name": "10.2.1: Bewegung",
                "spells": [
                    {
                        "name": "Springen",
                        "level": 1,
                        "value": "Gestattet es dem Zauberer, in der Runde, in der der Spruch gewirkt wird, bis zu 15 Meter weit oder 6 Meter hoch zu springen"
                    },
                    {
                        "name": "Landen",
                        "level": 2,
                        "value": "Gestattet es dem Zauberer, bei einem Sturz über bis zu 6 Meter pro Stufe sicher zu landen und bei tieferen Stürzen die Folgen entsprechend zu mildern"
                    },
                    {
                        "name": "Levitation I",
                        "level": 3,
                        "value": "Erlaubt es dem Zauberer, sich bis zu 3 Meter pro Runde senkrecht auf und ab zu bewegen. Dieser Spruch vermittelt keine Möglichkeiten zur horizontalen Bewegung"
                    },
                    {
                        "name": "Federleicht",
                        "level": 4,
                        "value": "Der Zauberer wird gewichtslos, hat aber keine magische Kontrolle über seine Bewegung, er wird also vom Wind weggeweht. Am Ende der Wirkungsdauer kehrt das Gewicht langsam zurück"
                    },
                    {
                        "name": "Unterwasserbewegung",
                        "level": 5,
                        "value": "Der Zauberer kann sich unter Wasser wie auf Land ohne Einschränkungen bewegen"
                    },
                    {
                        "name": "Fliegen I",
                        "level": 6,
                        "value": "Der Zauberer kann mit bis zu 5 Meter pro Runde fliegen (entspricht 1,8 km/h)"
                    },
                    {
                        "name": "Levitation V",
                        "level": 7,
                        "value": "Wie Levitation I, aber die Geschwindigkeit ist 15 Meter pro Runde"
                    },
                    {
                        "name": "Klippensprung",
                        "level": 8,
                        "value": "Der Zauberer kann sicher durch die Luft fliegen (bis zu 15 Meter pro Stufe), sofern Wasser mit ausreichender Tiefe vorhanden ist (1 Meter pro 15 Meter Flug), in das er dann sicher fällt"
                    },
                    {
                        "name": "Verschmelzen",
                        "level": 10,
                        "value": "Der Zauberer kann in feste, unbelebte Materie hinein „verschmelzen“. Während er verschmolzen ist, kann er sich weder bewegen noch etwas wahrnehmen. Wenn der Zauberer aus dem Material wieder hervorkommt, kann er auf beliebiger Seite hervorkommen. Er kann sich nicht durch Material bewegen, das dicker als die eigene Körperdicke plus 60cm ist, und er kann jederzeit innerhalb der Wirkungsdauer wieder hervorkommen"
                    },
                    {
                        "name": "Fliegen II",
                        "level": 11,
                        "value": "Wie Fliegen I, nur ist die Geschwindigkeit 25m pro Runde (9 km/h)"
                    },
                    {
                        "name": "Wahrhaftiges Landen",
                        "level": 12,
                        "value": "Wie Landen, nur landet er bei 99% aller beliebigen Stürzen sicher"
                    },
                    {
                        "name": "Levitation XX",
                        "level": 13,
                        "value": "Wie Levitation I, aber die Geschwindigkeit ist 60 Meter pro Runde"
                    },
                    {
                        "name": "Hindurchdringen",
                        "level": 14,
                        "value": "Der Zauberer kann sich durch alles unbelebte Material mit einer Dicke von bis zu 30cm pro Stufe bewegen. Er braucht je eine Minute für 60cm"
                    },
                    {
                        "name": "Fliegen III",
                        "level": 15,
                        "value": "Wie Fliegen I, nur ist die Geschwindigkeit 100m pro Runde (36 km/h)"
                    },
                    {
                        "name": "Vollendetes Verschmelzen",
                        "level": 18,
                        "value": "Wie Verschmelzen, nur kann sich der Zauberer in dem Material drehen und er kann die Umgebung wahrnehmen, wenn er sich innerhalb von 15cm von der Oberfläche befindet"
                    },
                    {
                        "name": "Wahrhaftiges Verschmelzen",
                        "level": 20,
                        "value": "Wie Vollendetes Verschmelzen, nur kann der Zauberer Sprüche auf sich selbst wirken, während er verschmolzen ist"
                    },
                    {
                        "name": "Fliegen IV",
                        "level": 25,
                        "value": "Wie Fliegen I, nur ist die Geschwindigkeit 130m pro Runde (ca. 47 km/h)"
                    },
                    {
                        "name": "Wahrhaftiges Hindurchdringen",
                        "level": 30,
                        "value": "Wie Hindurchdringen, nur kann sich der Zauberer mit einer Geschwindigkeit von 3m pro Runde durch so viel Material bewegen, wie er es während der Wirkungsdauer bewerkstelligen kann"
                    },
                    {
                        "name": "Meister der Bewegung",
                        "level": 50,
                        "value": "Der Zauberer kann in jeder Runde eine der Fähigkeiten verwenden, die einer der Sprüche dieser Liste verleiht."
                    }
                ]
            },
            {
                "id": "15.1",
                "name": "10.2.2: Geschwindigkeit",
                "spells": [
                    {
                        "name": "Laufen",
                        "level": 1,
                        "value": "Der Zauberer kann laufen (doppelte Gehgeschwindigkeit) und verliert dabei Erschöpfungspunkte, als ob er nur gehen würde. Wenn der Zauberer einmal das Laufen beendet oder eine andere Aktion durchführt, endet dieser Spruch sofort"
                    },
                    {
                        "name": "Schnell lesen",
                        "level": 2,
                        "value": "Der Zauberer kann 10 Seiten pro Minute lesen und verstehen (sofern er die Sprache beherrscht)"
                    },
                    {
                        "name": "Schnelligkeit I",
                        "level": 3,
                        "value": "Der Zauberer kann das Doppelte der normalen Handlungen ausführen (hat also 200% Aktivität pro Runde), er muß aber direkt im Anschluß eine Runde pro beschleunigter Runde mit der Hälfte auskommen (Erholungsrunden, 50% Aktivität)"
                    },
                    {
                        "name": "Schnelligkeit II",
                        "level": 5,
                        "value": "Wie Schnelligkeit I, aber auf 2 beschleunigte Runden folgen 2 Erholungsrunden"
                    },
                    {
                        "name": "Blitzschnell I",
                        "level": 6,
                        "value": "Der Zauberer kann das Doppelte der normalen Handlungen ausführen (hat also 200% Aktivität pro Runde), eine Erholungsrunde wird nicht fällig"
                    },
                    {
                        "name": "Schnelligkeit III",
                        "level": 7,
                        "value": "Wie Schnelligkeit I, aber auf 3 beschleunigte Runden folgen 3 Erholungsrunden"
                    },
                    {
                        "name": "Sprint",
                        "level": 8,
                        "value": "Wie Laufen, aber der Zauberer kann sich dreimal so schnell bewegen (also sprinten)"
                    },
                    {
                        "name": "Blitzschnell II",
                        "level": 9,
                        "value": "Wie Blitzschnell I, gilt aber für 2 Runden"
                    },
                    {
                        "name": "Schnelles Schwimmen",
                        "level": 10,
                        "value": "Wie Laufen, aber der Zauberer schwimmt mit doppelter Geschwindigkeit"
                    },
                    {
                        "name": "Schnelligkeit V",
                        "level": 11,
                        "value": "Wie Schnelligkeit I, aber die Dauer ist 5 Runden"
                    },
                    {
                        "name": "Blitzschnell III",
                        "level": 12,
                        "value": "Wie Blitzschnell I, gilt aber für 3 Runden"
                    },
                    {
                        "name": "Blitzschnell V",
                        "level": 15,
                        "value": "Wie Blitzschnell I, gilt aber für 5 Runden"
                    },
                    {
                        "name": "Schneller Sprint",
                        "level": 17,
                        "value": "Wie Laufen, nur kann sich der Zauberer mit vierfacher Gehgeschwindigkeit bewegen"
                    },
                    {
                        "name": "Schnelligkeit X",
                        "level": 20,
                        "value": "Wie Schnelligkeit I, aber die Dauer ist 10 Runden"
                    },
                    {
                        "name": "Blitzschnell X",
                        "level": 25,
                        "value": "Wie Blitzschnell I, gilt aber für 10 Runden"
                    },
                    {
                        "name": "Wahrhaftige Schnelligkeit",
                        "level": 30,
                        "value": "Wie Schnelligkeit I, nur hält der Spruch an, bis der Zauberer schläft, sich ausruht oder den Spruch aufhebt (die Maximaldauer ist 8 Stunden)"
                    },
                    {
                        "name": "Wahrhaftig Blitzschnell",
                        "level": 50,
                        "value": "Wie Blitzschnell I, nur hält der Spruch an, bis der Zauberer schläft, sich ausruht oder den Spruch aufhebt (die Maximaldauer ist 8 Stunden)."
                    }
                ]
            },
            {
                "id": "15.2",
                "name": "10.2.3: Kontrolle des Geistes",
                "spells": [
                    {
                        "name": "Speichern",
                        "level": 1,
                        "value": "Der Zauberer kann diesen Spruch auf jeden Spruch anwenden, den er speichern möchte. Der zu speichernde Spruch muß innerhalb einer Minute gewirkt werden, nachdem Speichern gewirkt wurde. Der gespeicherte Spruch kann dann später als ein unverzüglicher Spruch ausgelöst werden. Der Speichern-Spruch kostet dieselbe Anzahl an Magiepunkten, wie der zu speichernde Spruch. Während sich ein Spruch im Speicher befindet, kann kein anderer Spruch gewirkt werden"
                    },
                    {
                        "name": "Präsenz",
                        "level": 2,
                        "value": "Der Zauberer ist sich der Gegenwart aller denkenden/ intelligenten Wesen in einem Umkreis von 6 Metern bewußt"
                    },
                    {
                        "name": "Innere Barriere I",
                        "level": 3,
                        "value": "Der Zauberer bekommt einen besonderen Bonus von +5 auf seinen WW gegen geistige Angriffe"
                    },
                    {
                        "name": "Erinnern",
                        "level": 5,
                        "value": "Erlaubt dem Zauberer Zugriff auf sein Gedächtnis, als hätte er ein photographisches Gedächtnis. Alle Fertigkeiten, für die Gedächtnis wichtig ist, bekommen einen besonderen Bonus. Wenn Gedächtnis als eines der Attribute der Fertigkeit vorkommt (Kategorie Wissenschaft/Analytisch), ist dieser Bonus +10. Wenn Gedächtnis sogar zweimal vorkommt (Kategorie Wissen), ist der Bonus +25. Bei einer direkten GD-Probe ist der Bonus +50"
                    },
                    {
                        "name": "Volk kaschieren",
                        "level": 6,
                        "value": "Bei mentalen oder magischen Erkennungen (Entdeckungszauber) erscheint der Zauberer als das Volk, als das er erscheinen möchte (sofern er das Volk kennt)"
                    },
                    {
                        "name": "Beobachtung",
                        "level": 7,
                        "value": "Der Zauberer gewinnt durch intensive Beobachtung einer Person oder eines Objekts besondere Einsichten oder Wissen. Dies gibt ihm einen Bonus von +50 auf die Fertigkeiten in der Gruppe Wahrnehmung • Suchen für die Dauer des Spruchs"
                    },
                    {
                        "name": "Innere Barriere II",
                        "level": 8,
                        "value": "Wie Innere Barriere I, aber der Bonus ist +10"
                    },
                    {
                        "name": "Beruf kaschieren",
                        "level": 9,
                        "value": "Wie Volk kaschieren, aber der Beruf des Zauberers kann wie ein beliebiger Beruf erscheinen, der ihm bekannt ist"
                    },
                    {
                        "name": "Folgerung",
                        "level": 10,
                        "value": "Der Zauberer kann bekannte Fakten kombinieren und daraus Schlüsse ziehen. Alle Fertigkeiten, für die Logik wichtig ist, bekommen einen besonderen Bonus. Wenn Logik als eines der Attribute der Fertigkeit vorkommt (Kategorie Wissen), ist dieser Bonus +10. Wenn Logik sogar zweimal vorkommt (Kategorie Wissenschaft/ Analytisch), ist der Bonus +25. Bei einer direkten Lo-Probe ist der Bonus +50"
                    },
                    {
                        "name": "Macht kaschieren",
                        "level": 11,
                        "value": "Wie Volk kaschieren, nur wird die Stufe des Ziels falsch dargestellt (von der ersten Stufe bis zum Doppelten seiner tatsächlichen Stufe)"
                    },
                    {
                        "name": "Entschlossenheit",
                        "level": 12,
                        "value": "Der Zauberer kann sich in einer Situation oder während eines Manövers stark konzentrieren und kontrollieren. Alle Fertigkeiten, für die Selbstdisziplin wichtig ist, bekommen einen besonderen Bonus. Wenn Selbstdisziplin als eines der Attribute der Fertigkeit vorkommt (Kategorie Wahrnehmung • Suchen), ist dieser Bonus +10. Wenn Selbstdisziplin sogar zweimal vorkommt (Kategorie Selbstkontrolle), ist der Bonus +25. Sind alle drei Attribute der Fertigkeit Selbstdisziplin, ist es also eine direkte SD-Probe, so ist der Bonus +50"
                    },
                    {
                        "name": "Innere Barriere III",
                        "level": 13,
                        "value": "Wie Innere Barriere I, aber der Bonus ist +15"
                    },
                    {
                        "name": "Präsenz aufheben",
                        "level": 15,
                        "value": "Wie Volk kaschieren, nur wirkt der Zauberer, als hätte er keine Präsenz (er kann also durch Präsenz-Sprüche nicht gefunden werden)"
                    },
                    {
                        "name": "Innere Barriere V",
                        "level": 16,
                        "value": "Wie Innere Barriere I, aber der Bonus ist +25"
                    },
                    {
                        "name": "Vollständige Erinnerung",
                        "level": 17,
                        "value": "Wie Erinnern, nur stellt sich die Erinnerung fast automatisch ein, und die besonderen Boni sind +20, +50 und +100"
                    },
                    {
                        "name": "Kaschieren",
                        "level": 18,
                        "value": "Erlaubt dem Zauberer, alle niedrigstufigen Kaschieren-Sprüche gleichzeitig zu verwenden. Präsenz aufheben zählt nicht dazu"
                    },
                    {
                        "name": "Wahrhaftige Innere Barriere",
                        "level": 19,
                        "value": "Wie Innere Barriere I, aber der Bonus ist +50"
                    },
                    {
                        "name": "Wahrhaftige Beobachtung",
                        "level": 20,
                        "value": "Wie Beobachtung, nur bemerkt der Zauberer selbst in komplexen Situationen so gut wie jedes Detail. Der besondere Bonus ist +100"
                    },
                    {
                        "name": "Wahrhaftige Folgerung",
                        "level": 25,
                        "value": "Wie Folgerung, nur kommt der Zauberer fast automatisch zu seinen Schlüssen, und die besonderen Boni sind +20, +50 und +100"
                    },
                    {
                        "name": "Wahrhaftige Entschlossenheit",
                        "level": 30,
                        "value": "Wie Entschlossenheit, nur ist die Konzentration/Kontrolle nahezu vollkommen, und die besonderen Boni sind +20, +50 und +100"
                    },
                    {
                        "name": "Spiegelgeist",
                        "level": 50,
                        "value": "Der Geist des Zauberers wirft alle geistigen Angriffe auf den Angreifer zurück, der dann einen WW gegen seinen eigenen Spruch machen muß."
                    }
                ]
            },
            {
                "id": "15.3",
                "name": "10.2.4: Manipulation von Festkörpern",
                "spells": [
                    {
                        "name": "Stein erwärmen",
                        "level": 1,
                        "value": "Erwärmt 30 Liter (30dm³) pro Stufe Stein mit 30 Litern pro Runde Konzentration auf bis zu 40°C. Ohne Konzentration hält der Stein seine Temperatur bis zum Ablauf der Wirkungsdauer"
                    },
                    {
                        "name": "Metall erwärmen",
                        "level": 2,
                        "value": "Wie Stein erwärmen, aber 100cm³ Metall pro Stufe können erwärmt werden"
                    },
                    {
                        "name": "Erwärmen",
                        "level": 3,
                        "value": "Erwärmt 30 Liter pro Stufe eines festen, unbelebten, nichtmetallischen Materials mit 30 Litern pro Runde Konzentration auf bis zu 40°C"
                    },
                    {
                        "name": "Stein erhitzen",
                        "level": 4,
                        "value": "Wie Stein erwärmen, bis auf die Dauer, und der Stein kann mit einer Rate von 25°C pro Runde auf bis zu 250°C erhitzt werden. Der Zauberer muß sich während der Aufwärmphase konzentrieren (ohne Konzentration hält der Stein die Temperatur für die Spruchdauer). Der Zauberer muß den Stein nur beim Wirken des Spruchs berühren"
                    },
                    {
                        "name": "Metall erhitzen",
                        "level": 5,
                        "value": "Wie Stein erhitzen, aber 100cm³ Metall pro Stufe können erhitzt werden"
                    },
                    {
                        "name": "Erhitzen",
                        "level": 6,
                        "value": "Wie Stein erhitzen, betrifft aber jedes feste, unbelebte, nichtmetallische Material"
                    },
                    {
                        "name": "Abkühlen",
                        "level": 7,
                        "value": "Kühlt 30 Liter pro Stufe eines festen, unbelebten, nichtmetallischen Materials mit 30 Litern pro Runde Konzentration auf bis zu -30°C (ohne Konzentration hält das Material die Temperatur für die Spruchdauer)"
                    },
                    {
                        "name": "Tiefkühlen",
                        "level": 9,
                        "value": "Wie Abkühlen, bis auf die Dauer, und das Material kann mit einer Rate von 25°C pro Runde auf bis zu -130°C abgekühlt werden. Der Zauberer muß sich während der Abkühlphase konzentrieren"
                    },
                    {
                        "name": "Spalte",
                        "level": 10,
                        "value": "Alle Risse und Fehler in einem bis zu 3m x 3m x 3m großen Teil beliebigen toten Materials dehnen sich bis zum Äußersten"
                    },
                    {
                        "name": "Schmelzen",
                        "level": 11,
                        "value": "Wie Erhitzen, nur ist dem Temperaturanstieg nur durch den Schmelzpunkt des Festkörpers eine Grenze gesetzt. Der Spruch betrifft 100ml Metall oder 30 Liter eines beliebigen anderen Materials (pro Stufe)"
                    },
                    {
                        "name": "Zerbröckeln",
                        "level": 13,
                        "value": "Wie Spalte, nur zerfällt ein rissiges Material zu Staub"
                    },
                    {
                        "name": "Bogenbruch",
                        "level": 14,
                        "value": "Zerbricht ein Stück Holz, das einen Durchmesser von bis zu 30cm hat"
                    },
                    {
                        "name": "Steintür",
                        "level": 15,
                        "value": "Erschafft einen 1m x 2m x 30cm großen Durchgang durch Stein"
                    },
                    {
                        "name": "Metalltür",
                        "level": 16,
                        "value": "Wie Steintür, nur kann der Durchgang durch Metall gehen"
                    },
                    {
                        "name": "Klingenbruch",
                        "level": 17,
                        "value": "Wie Bogenbruch, nur kann ein Stück Metall zerbrochen werden. Der Spruch betrifft Metalle von bis zu 30cm Durchmesser"
                    },
                    {
                        "name": "Schloßbruch",
                        "level": 18,
                        "value": "Läßt ein Schloß zerbrechen. Das Schloß kann in offenem oder verschlossenem Zustand zerstört werden (dabei ist es egal, ob es geschlossen oder offen war, als der Spruch gewirkt wurde)"
                    },
                    {
                        "name": "Feststofftür",
                        "level": 19,
                        "value": "Wie Steintür, nur kann der Durchgang durch einen beliebigen unbelebten Feststoff gehen und er mißt 1m x 2m bei einer Tiefe von 30cm pro Stufe bei Stein und 8cm pro Stufe bei jedem anderen Material"
                    },
                    {
                        "name": "Stein formen",
                        "level": 20,
                        "value": "Der Zauberer kann 30 Liter Stein formen, als wäre es Kitt oder Ton. Am Ende der Spruchdauer härtet das Material bis zu seiner normalen Festigkeit aus"
                    },
                    {
                        "name": "Metall formen",
                        "level": 25,
                        "value": "Wie Stein formen, nur kann der Zauberer Metall formen"
                    },
                    {
                        "name": "Feststoff formen",
                        "level": 30,
                        "value": "Wie Stein formen, nur kann der Zauberer jeden beliebigen unbelebten Feststoff formen"
                    },
                    {
                        "name": "Feststoffwandel",
                        "level": 50,
                        "value": "Kann 30g eines unbelebten Feststoffs in einen anderen, nicht-magischen Feststoff verwandeln, von dem der Zauberer eine Probe hat. Dieser Spruch erfordert 8 Stunden zusammenhängende, ununterbrochene Konzentration. Ja, dieser Spruch würde einen mittelalterlichen Alchemisten sehr glücklich machen."
                    }
                ]
            },
            {
                "id": "15.4",
                "name": "10.2.5: Manipulation von Flüssigkeit",
                "spells": [
                    {
                        "name": "Wasser kochen",
                        "level": 1,
                        "value": "Bringt 30 Liter Flüssigkeit pro Stufe (kein Blut in einem lebenden Körper) mit einer Rate von 30 Litern pro Runde Konzentration zum Kochen. Der Zauberer ist gegen die Hitze immun"
                    },
                    {
                        "name": "Wasser gefrieren",
                        "level": 2,
                        "value": "Wie Wasser kochen, die Flüssigkeit kann aber bis zum Gefrierpunkt heruntergekühlt werden"
                    },
                    {
                        "name": "Wasser reinigen",
                        "level": 3,
                        "value": "Wie Wasser kochen, aber die Flüssigkeit wird von allen Sedimenten befreit"
                    },
                    {
                        "name": "Entsalzen",
                        "level": 5,
                        "value": "Wie Wasser kochen, aber alle gelösten Substanzen werden aus der Flüssigkeit entfernt"
                    },
                    {
                        "name": "Wasserbarriere",
                        "level": 6,
                        "value": "Erzeugt eine 3m x 3m x 30cm messende Wand aus rotierendem Wasser (eine Wasserquelle muß innerhalb von 3 Metern vorhanden sein). Alle Bewegungen durch diese Barriere werden um 80% reduziert. Angriffe durch diese Barriere erhalten einen Malus von -80"
                    },
                    {
                        "name": "Verdunsten",
                        "level": 7,
                        "value": "Wie Wasser kochen, aber die Flüssigkeit verdunstet mit einer Rate von 30 Litern pro Runde Konzentration"
                    },
                    {
                        "name": "Wasserkorridor I",
                        "level": 8,
                        "value": "Erzeugt einen Korridor durch Flüssigkeiten bis zu 30 Metern lang, 1 Meter breit und 3 Meter tief (muß oben offen sein)"
                    },
                    {
                        "name": "Wasserstrahl",
                        "level": 9,
                        "value": "Ein druckvoller Strahl Wasser springt aus der Handfläche des Zauberers (eine Wasserquelle muß innerhalb von 3 Metern vorhanden sein). Die Ergebnisse dieses Angriffs werden mittels der Angriffstabelle: Wasserstrahl 12-9 (Seite 247) bestimmt"
                    },
                    {
                        "name": "Gebogene Wasserbarriere",
                        "level": 10,
                        "value": "Wie Wasserbarriere, aber die Barriere hat die maximalen Maße von 3m x 6m x 30cm und kann zu einem Halbkreis gebogen werden"
                    },
                    {
                        "name": "Wasser beruhigen",
                        "level": 11,
                        "value": "Das Wasser im Wirkungsbereich wird beruhigt. In der Mitte verlieren Wellen 6m an Höhe und am Rand entsprechend weniger. Das hebt die Auswirkungen der Strömung im Wirkungsbereich auf"
                    },
                    {
                        "name": "Wahrhaftige Wasserbarriere",
                        "level": 13,
                        "value": "Wie Wasserbarriere, nur ist die Wirkungsdauer festgelegt"
                    },
                    {
                        "name": "Wasserkorridor III",
                        "level": 15,
                        "value": "Wie Wasserkorridor I, nur kann er bis zu 100m x 1m x 15m groß sein"
                    },
                    {
                        "name": "Strudel",
                        "level": 17,
                        "value": "Erschafft einen 6m breiten Strudel, der alle Gegenstände ohne eigenen Antrieb innerhalb von 60 Metern Entfernung an sich zieht. Gegenstände mit Antrieb können ein sehr schweres Manöver ausführen, um dem Sog des Strudels zu entkommen"
                    },
                    {
                        "name": "Welle",
                        "level": 18,
                        "value": "Erschafft eine Welle, die sich vom Zauberer wegbewegt. Sie ist pro Stufe 30cm hoch und 3m pro Stufe breit"
                    },
                    {
                        "name": "Wasserblase",
                        "level": 19,
                        "value": "Erschafft eine Luftblase (3m-Radius) um den Zauberer und andere. Die Blase trägt sie bis zu 30m in Wasser hinein (die Luft wird erneuert). Der Zauberer muß sich konzentrieren, um die Blase zu bewegen (ohne Konzentration steigt sie einfach zur Wasseroberfläche hoch). Wenn die Spruchdauer abläuft, steigt die Blase langsam zur Oberfläche hoch. Alles, was in der Blase ist, steigt mit ihr hoch. Sobald sie die Oberfläche erreicht hat, platzt sie"
                    },
                    {
                        "name": "Wahrhaftige Wasserberuhigung",
                        "level": 20,
                        "value": "Wie Wasser beruhigen, nur ist der Wirkungsbereich 30m pro Stufe und die Wellenhöhe sinkt um 15m"
                    },
                    {
                        "name": "Wahrhaftiger Wasserkorridor",
                        "level": 25,
                        "value": "Wie Wasserkorridor, nur kann der Korridor bis zu 30m pro Stufe lang, 2m breit und 30m tief sein"
                    },
                    {
                        "name": "Wahrhaftige Wasserblase",
                        "level": 30,
                        "value": "Wie Wasserblase, nur hat sie einen Radius von 6 Metern und die Tiefe ist unbeschränkt"
                    },
                    {
                        "name": "Wassermeisterschaft",
                        "level": 50,
                        "value": "Der Zauberer kann in jeder Runde einen der niedrigstufigeren Sprüche dieser Liste mit einer Reichweite von 3m pro Stufe anwenden."
                    }
                ]
            },
            {
                "id": "15.5",
                "name": "10.2.6: Manipulation von Gas",
                "spells": [
                    {
                        "name": "Kondensation",
                        "level": 1,
                        "value": "Kondensiert 30 Liter Wasser aus der Umgebungsluft. Das Wasser kondensiert allmählich in der Hand des Zauberers und kann in passende Behälter geleitet werden"
                    },
                    {
                        "name": "Luft erwärmen",
                        "level": 2,
                        "value": "Wärmt 30 Liter Luft (alle Gase) pro Stufe auf bis zu 50°C über normal"
                    },
                    {
                        "name": "Nebel I",
                        "level": 3,
                        "value": "Erzeugt dichten Nebel mit einem Radius von 3 Metern. Die Sichtweite sinkt auf 1 Meter. Vgl. Abschnitt 5.12 (Seite 39)"
                    },
                    {
                        "name": "Luftbarriere",
                        "level": 4,
                        "value": "Erzeugt eine Barriere aus sich drehender Luft mit den Ausmaßen bis zu 3m x 3m x 1m. Die Barriere reduziert alle Bewegung durch sie hindurch um 50%. Zusätzlich erleiden Angriffe durch die Barriere einen Malus von -50"
                    },
                    {
                        "name": "Luftbremse I",
                        "level": 5,
                        "value": "Bringt im Wirkungsbereich alle Luftbewegungen mit Windgeschwindigkeiten bis zu 50km/h zum Stehen und verlangsamt stärkere Winde um 50km/h"
                    },
                    {
                        "name": "Vakuum I",
                        "level": 6,
                        "value": "Erschafft ein fast vollständiges Vakuum. Jeder im Wirkungsbereich muß einen erfolgreichen WW durchführen, ansonsten erleidet er einen kritischen Aufpralltreffer der Intensität A, weil die Luft plötzlich zurückströmt"
                    },
                    {
                        "name": "Nebel V",
                        "level": 7,
                        "value": "Wie Nebel I, aber der Radius ist 15 Meter"
                    },
                    {
                        "name": "Entnebeln V",
                        "level": 8,
                        "value": "Löst jeglichen Nebel im Wirkungsbereich auf"
                    },
                    {
                        "name": "Gebogene Luftbarriere",
                        "level": 9,
                        "value": "Wie Luftbarriere, aber die Barriere hat die maximalen Maße von 3m x 6m x 1m und kann zu einem Halbkreis gebogen werden"
                    },
                    {
                        "name": "Wahrhaftige Luftbarriere",
                        "level": 10,
                        "value": "Wie Luftbarriere, aber die Wirkungsdauer ist 1 Minute pro Stufe, und Konzentration ist nicht erforderlich"
                    },
                    {
                        "name": "Nebel X",
                        "level": 11,
                        "value": "Wie Nebel I, aber der Radius ist 30 Meter"
                    },
                    {
                        "name": "Luftbremse V",
                        "level": 12,
                        "value": "Wie Luftbremse I, nur ist der Radius 15 Meter"
                    },
                    {
                        "name": "Entnebeln X",
                        "level": 13,
                        "value": "Wie Entnebeln V, aber der Radius ist 30 Meter"
                    },
                    {
                        "name": "Vakuum II",
                        "level": 14,
                        "value": "Wie Vakuum I, nur ist der Radius 3 Meter"
                    },
                    {
                        "name": "Gas in Luft",
                        "level": 15,
                        "value": "Alle Gase in einem Radius von 3m werden in atembare Luft verwandelt"
                    },
                    {
                        "name": "Wirbelwind",
                        "level": 17,
                        "value": "Erzeugt einen Wirbelwind um den Zauberer. Der Wirbelwind bewegt sich mit dem Zauberer und hat einen Radius von 3 Metern. Kein Fernkampfangriff kann ihn durchdringen und jede Bewegung oder Nahkampf (außer dem des Zauberers) durch ihn hindurch oder in ihn hinein ist um 80% erschwert"
                    },
                    {
                        "name": "Vakuum IV",
                        "level": 18,
                        "value": "Wie Vakuum I, nur ist der Radius 6 Meter"
                    },
                    {
                        "name": "Sauerstoffanreicherung",
                        "level": 20,
                        "value": "Reichert in einem 15m-Radius die Luft mit Sauerstoff an. Alle im Wirkungsbereich erhalten einen besonderen Bonus von +20 auf ihre OB und alle Feuerangriffe dort fügen doppelten Schaden zu"
                    },
                    {
                        "name": "Wahrhaftiger Nebel",
                        "level": 25,
                        "value": "Wie Nebel I, nur ist die Dauer eine Stunde pro Stufe und der Wirkungsbereich ist 30m pro Stufe"
                    },
                    {
                        "name": "Wahrhaftiges Entnebeln",
                        "level": 30,
                        "value": "Wie Entnebeln V, nur ist der Radius 30 Meter pro Stufe"
                    },
                    {
                        "name": "Wolkenmeister",
                        "level": 50,
                        "value": "Der Zauberer hat völlige Kontrolle über die Wolken im Wirkungsbereich (auch über Nebel). Er kann Sturmwolken regnen lassen, aber er kann sie nicht erschaffen."
                    }
                ]
            },
            {
                "id": "15.6",
                "name": "10.2.7: Manipulation des Körpers",
                "spells": [
                    {
                        "name": "Balancieren",
                        "level": 1,
                        "value": "Liefert einen Bonus von +50 auf ein einzelnes langsames Manöver, für das Balance erforderlich ist (z.B. das Gehen auf einem 8cm breiten Balken)"
                    },
                    {
                        "name": "Winden",
                        "level": 2,
                        "value": "Erlaubt Glieder zu verrenken, Muskeln zusammenzuziehen usw., um sich aus Fesseln und Handschellen zu befreien oder durch schmale Öffnungen zu zwängen. Gibt einen besonderen Bonus von +25 bis +50 auf die Fertigkeit Entfeßlungskünstler"
                    },
                    {
                        "name": "Gesicht wandeln",
                        "level": 3,
                        "value": "Erlaubt es dem Zauberer, die Form seines Gesichts zu verändern. Er kann sich dabei an einer bestimmten Person orientieren, aber die Veränderung wird nicht exakt sein"
                    },
                    {
                        "name": "Kiemen",
                        "level": 5,
                        "value": "Der Zauberer kann Wasser atmen, aber keine Luft"
                    },
                    {
                        "name": "Volksverwandlung",
                        "level": 7,
                        "value": "Der Zauberer kann seine Gestalt in die eines anderen humanoiden Volkes verwandeln. Diese Gestalt kann nicht genau festgelegt werden, das Erscheinungsbild ist zufällig. Er kann beispielsweise die Gestalt eines Zwerges annehmen, nicht aber die des Königs der Zwerge. Dieser Spruch gibt dem Zauberer nur die physische Gestalt, nicht besondere Fähigkeiten oder Volksboni (z.B. sieht der Zauberer, der zu einem Zwerg wird, nicht automatisch so gut im Dunkeln wie ein Zwerg). Die Größe des Zauberers darf nur um maximal ±25% verändert werden"
                    },
                    {
                        "name": "Gaslungen",
                        "level": 8,
                        "value": "Wie Kiemen, aber das Ziel kann jedes Gas wie normale Luft atmen"
                    },
                    {
                        "name": "Starker Gesichtswandel",
                        "level": 10,
                        "value": "Wie Gesicht wandeln, hält aber eine Stunde pro Stufe an"
                    },
                    {
                        "name": "Wandellungen",
                        "level": 11,
                        "value": "Wie Kiemen, nur kann das Ziel nach Belieben Luft, Wasser und/oder jedwedes Gas atmen"
                    },
                    {
                        "name": "Verwandlung",
                        "level": 13,
                        "value": "Wie Volksverwandlung, aber der Zauberer kann eine beliebige organische Gestalt annehmen, solange deren Masse zwischen 50% und 200% seiner eigenen liegt. Das Ziel erhält keine besondere Fähigkeiten durch die Verwandlung"
                    },
                    {
                        "name": "Festform",
                        "level": 15,
                        "value": "Der Zauberer ist wie aus besonders dichtem Stein gemacht (er kann sich nicht bewegen und keine Sprüche wirken)"
                    },
                    {
                        "name": "Gestaltwandel",
                        "level": 18,
                        "value": "Wie Verwandlung, nur kann der Zauberer jederzeit während der Spruchdauer eine andere Gestalt annehmen. Die Verwandlung dauert jeweils eine Runde Konzentration"
                    },
                    {
                        "name": "Wasserform",
                        "level": 20,
                        "value": "Der Zauberer nimmt die Form einer flüssigen Masse an, die genausogut durch Ritzen sickern kann wie Wasser. Als Flüssigkeit kann er sich mit einer Geschwindigkeit von 15km/h bewegen. Er kann aber in dieser Gestalt keine Sprüche wirken"
                    },
                    {
                        "name": "Nebelform",
                        "level": 25,
                        "value": "Der Zauberer nimmt die Form von Nebel an und kann so mit einer Geschwindigkeit von 30 km/h fliegen. Er kann durch Risse hindurchdringen, sich so weit ausdehnen, daß er fast unsichtbar ist usw. Der Zauberer kann in dieser Form keine Sprüche wirken"
                    },
                    {
                        "name": "Formenmeister",
                        "level": 30,
                        "value": "Wie Wasserform und Nebelform, nur kann er zwischen beiden Formen hin und her wechseln. Er braucht eine Runde Konzentration, um von einer in die andere Form überzugehen"
                    },
                    {
                        "name": "Verwandlungsmeister",
                        "level": 50,
                        "value": "Wie Verwandlung und Formenmeister, nur kann er beliebig zwischen all diesen Formen hin und her wechseln. Für jeden Formwandel braucht er eine Runde Konzentration. Der Zauberer kann dabei jede Masse zwischen 10% und 1000% seiner eigenen annehmen."
                    }
                ]
            },
            {
                "id": "15.7",
                "name": "10.2.8: Meisterschaft der Sinne",
                "spells": [
                    {
                        "name": "Listige Ohren",
                        "level": 1,
                        "value": "Der Zauberer erhält ein doppelt so gutes Gehör. Dies bringt ihm einen besonderen Bonus von +50 auf Fertigkeiten der Gruppen Wahrnehmung • Suchen und Wahrnehmung • Sinne, sofern es dabei auf das Gehör ankommt (oder +5 auf die Fertigkeit Aufmerksamkeit). Wenn neben dem Gehör auch andere Sinne für die Fertigkeit wichtig sind, reduziert sich der Bonus auf +25 (+3 bei Aufmerksamkeit)"
                    },
                    {
                        "name": "Nachtsicht",
                        "level": 2,
                        "value": "Der Zauberer kann in einer normalen Nacht 30 Meter weit sehen, als wäre es Tag. Zumindest ein wenig Restlicht ist nötig, damit dieser Spruch funktioniert. Vgl. Abschnitt 5.12 (Seite 39)"
                    },
                    {
                        "name": "Rundumsicht",
                        "level": 3,
                        "value": "Der Zauberer hat ein Gesichtsfeld von 300°. Der Bonus für Angriffe aus der Flanke reduziert sich auf +5 und der für Angriffe von hinten auf +15"
                    },
                    {
                        "name": "Illusion entdecken",
                        "level": 4,
                        "value": "Der Zauberer kann einen Ort oder ein Objekt (bis zu einem 2m-Radius) prüfen, ob es sich dabei um eine Illusion handelt oder ob eine Illusion auf dem Raum oder Objekt liegt"
                    },
                    {
                        "name": "Wassersicht",
                        "level": 5,
                        "value": "Wie Nachtsicht, aber das Ziel kann 30 Meter unter Wasser (und anderen Flüssigkeiten) sehen"
                    },
                    {
                        "name": "Geruchssinn",
                        "level": 6,
                        "value": "Wie Listige Ohren, aber der Zauberer bekommt einen besonders guten Geruchssinn, und die Boni gelten für Wahrnehmungsfertigkeiten, bei denen es auf das Riechen ankommt"
                    },
                    {
                        "name": "Nebelsicht",
                        "level": 7,
                        "value": "Wie Nachtsicht, aber dieser Spruch wirkt bei jeglichem Niederschlag (auch Schnee) oder in jedem Gas oder Nebel"
                    },
                    {
                        "name": "Fühlen",
                        "level": 8,
                        "value": "Der Zauberer bekommt einen besonders guten Tastsinn. Dies bringt ihm einen Bonus von +25 auf alle Aktionen, die vom Tastsinn abhängen (z.B. Schlösser öffnen, Fallen entschärfen usw.)"
                    },
                    {
                        "name": "Dunkelsicht",
                        "level": 9,
                        "value": "Wie Nachtsicht, aber der Zauberer kann durch jede Dunkelheit (auch magische) sehen. Es ist kein Licht nötig"
                    },
                    {
                        "name": "Mentalistenohr",
                        "level": 10,
                        "value": "Der Zauberer kann einen Punkt bis zu 30 Meter pro Stufe entfernt wählen. Er hört dann so, als wäre er an diesem Punkt (es dürfen sich keine Objekte wie Wände zwischen ihm und diesem Punkt befinden). Er muß an dem Punkt vorher schon einmal gewesen sein, und der Punkt muß in seiner Sichtlinie sein"
                    },
                    {
                        "name": "Mentalistenauge",
                        "level": 11,
                        "value": "Wie Mentalistenohr, nur kann der Zauberer von dem Punkt aus sehen, statt zu hören"
                    },
                    {
                        "name": "Desillusion",
                        "level": 12,
                        "value": "Für die Spruchdauer erlischt eine Illusion im Wirkungsbereich (nur für den Zauberer). Der Zauberer muß wissen, daß etwas eine Illusion ist, bevor er diesen Spruch wirkt"
                    },
                    {
                        "name": "Wahrhaftige Illusionsentdeckung",
                        "level": 13,
                        "value": "Wie Illusion entdecken, nur kann der Zauberer ein Objekt oder einen Ort pro Stufe untersuchen"
                    },
                    {
                        "name": "Sicht",
                        "level": 14,
                        "value": "Wie alle niedrigstufigeren Sicht-Sprüche gleichzeitig"
                    },
                    {
                        "name": "Wahrhaftige Nachtsicht",
                        "level": 15,
                        "value": "Wie Nachtsicht, nur ist die Reichweite die normaler Sicht bei Tag"
                    },
                    {
                        "name": "Wahrhaftige Desillusion",
                        "level": 17,
                        "value": "Wie Desillusion, nur erlöschen alle Illusionen innerhalb der Reichweite für den Zauberer. Der Zauberer muß sich keiner dieser Illusionen bewußt sein, bevor er den Spruch wirkt"
                    },
                    {
                        "name": "Wahrhaftige Wassersicht",
                        "level": 18,
                        "value": "Wie Wassersicht, nur ist die Reichweite die normaler Sicht bei Tag"
                    },
                    {
                        "name": "Wahrhaftige Nebelsicht",
                        "level": 19,
                        "value": "Wie Nebelsicht, nur ist die Reichweite die normaler Sicht bei Tag"
                    },
                    {
                        "name": "Wahrhaftige Sicht",
                        "level": 20,
                        "value": "Wie alle niedrigstufigeren Wahrhaftige SichtSprüche gleichzeitig"
                    },
                    {
                        "name": "Wahrhaftiges Mentalistenohr",
                        "level": 25,
                        "value": "Wie Mentalistenohr, nur ist die Reichweite 1,5 Kilometer pro Stufe"
                    },
                    {
                        "name": "Wahrhaftiges Mentalistenauge",
                        "level": 30,
                        "value": "Wie Mentalistenauge, nur ist die Reichweite 1,5 Kilometer pro Stufe"
                    },
                    {
                        "name": "Sinnesverschmelzung",
                        "level": 50,
                        "value": "Der Zauberer kann seine Sinne mit denen einer Zielperson verschmelzen, deren genauer Standort ihm bekannt ist. Der genaue Standort kann vorher vereinbart werden. Wenn das Ziel nicht an dem festgelegten Standort ist, muß der Zauberer die MP für den Spruch dennoch ausgeben."
                    }
                ]
            },
            {
                "id": "15.8",
                "name": "10.2.9: Telekinese",
                "spells": [
                    {
                        "name": "Telekinese I",
                        "level": 1,
                        "value": "Der Zauberer kann ein Objekt mit bis zu 500g Masse mit einer Geschwindigkeit von bis zu 30cm pro Sekunde (etwa 1 km/h) bewegen (ohne Beschleunigung). Endet die Konzentration des Zauberers vor dem Ende der Wirkungsdauer, so bleibt das Objekt in der Luft schweben, als stünde es unter einem entsprechenden BleibenSpruch"
                    },
                    {
                        "name": "Bleiben II",
                        "level": 2,
                        "value": "Übt einen Druck von 2,5kg auf ein Wesen oder Objekt aus. Das Ziel kann auf diese Weise nicht bewegt werden, und der Druck wirkt nur in eine Richtung"
                    },
                    {
                        "name": "Telekinese II",
                        "level": 3,
                        "value": "Wie Telekinese I, aber die Gewichtsgrenze liegt bei 2,5kg"
                    },
                    {
                        "name": "Bleiben III",
                        "level": 4,
                        "value": "Wie Bleiben II, aber die Druckgrenze liegt bei 12kg"
                    },
                    {
                        "name": "Starkes Bleiben II",
                        "level": 5,
                        "value": "Wie Bleiben II, aber es können entweder zwei Objekte mit 2,5kg Gesamtdruck belastet werden, oder Bleiben II kann auf 60 Meter Reichweite genutzt werden"
                    },
                    {
                        "name": "Starke Telekinese II",
                        "level": 6,
                        "value": "Wie Telekinese II, aber es können entweder zwei Objekte mit 2,5kg Gesamtgewicht bewegt werden, oder Telekinese II kann auf 60 Meter Reichweite genutzt werden"
                    },
                    {
                        "name": "Telekinese III",
                        "level": 7,
                        "value": "Wie Telekinese I, aber die Gewichtsgrenze liegt bei 12kg"
                    },
                    {
                        "name": "Bleiben IV",
                        "level": 8,
                        "value": "Wie Bleiben II, aber die Druckgrenze liegt bei 25kg"
                    },
                    {
                        "name": "Telekinese IV",
                        "level": 9,
                        "value": "Wie Telekinese I, aber die Gewichtsgrenze liegt bei 25kg"
                    },
                    {
                        "name": "Schleudern I",
                        "level": 10,
                        "value": "Der Zauberer kann ein Objekt schleudern (dessen Flug innerhalb von 3 Metern Entfernung zum Zauberer beginnt und das 500g oder weniger wiegt), um damit einen Angriff auf der Angriffstabelle 10.79: Schleuder (Kampfhandbuch, Seite 223) durchzuführen. Behandeln Sie dies wie einen Angriff mit der Schleuder, kurze Reichweite 3m-30m, mittlere 31m bis 60m und lange Reichweite 61m bis 90m. Der OB des Zauberers ist sein Fertigkeitswert in Gezielte Sprüche: Schleudern"
                    },
                    {
                        "name": "Bleiben V",
                        "level": 11,
                        "value": "Wie Bleiben II, aber die Druckgrenze liegt bei 50kg"
                    },
                    {
                        "name": "Telekinese V",
                        "level": 12,
                        "value": "Wie Telekinese I, aber die Gewichtsgrenze liegt bei 50kg"
                    },
                    {
                        "name": "Schleudern II",
                        "level": 13,
                        "value": "Wie Schleudern I, nur kann das Objekt bis zu 2,5kg wiegen, und es fügt doppelten Trefferpunktschaden zu"
                    },
                    {
                        "name": "Bleiben VI",
                        "level": 14,
                        "value": "Wie Bleiben II, aber die Druckgrenze liegt bei 100kg"
                    },
                    {
                        "name": "Starkes Bleiben III",
                        "level": 15,
                        "value": "Wie Starkes Bleiben II, aber es können entweder drei Objekte mit 12kg Gesamtdruck belastet werden, oder Bleiben III kann mit einer Reichweite von 100 Metern genutzt werden"
                    },
                    {
                        "name": "Starke Telekinese III",
                        "level": 16,
                        "value": "Wie Telekinese I, aber es können entweder drei Objekte mit 12kg Gesamtgewicht bewegt werden, oder Telekinese II kann mit einer Reichweite von 100 Metern genutzt werden"
                    },
                    {
                        "name": "Telekinese VI",
                        "level": 17,
                        "value": "Wie Telekinese I, aber die Gewichtsgrenze liegt bei 100kg"
                    },
                    {
                        "name": "Schleudern III",
                        "level": 18,
                        "value": "Wie Schleudern I, nur kann das Objekt bis zu 12kg wiegen, und es fügt dreifachen Trefferpunktschaden zu"
                    },
                    {
                        "name": "Wahrhaftiges Bleiben",
                        "level": 19,
                        "value": "Wie Bleiben II, aber die Druckgrenze liegt bei 10kg pro Stufe"
                    },
                    {
                        "name": "Wahrhaftige Telekinese",
                        "level": 20,
                        "value": "Wie Telekinese I, aber die Gewichtsgrenze liegt bei 10kg pro Stufe"
                    },
                    {
                        "name": "Starkes Schleudern III",
                        "level": 25,
                        "value": "Wie Schleudern I, nur kann das Objekt, das geschleudert werden soll, aus einer Entfernung von bis zu 100m vom Zauberer aus losfliegen, oder der Zauberer schleudert 3 Objekte, die 30m von ihm entfernt losfliegen (auf das gleiche Ziel)"
                    },
                    {
                        "name": "Schleudern IV",
                        "level": 30,
                        "value": "Wie Schleudern I, nur kann das Objekt bis zu 25kg wiegen, und es fügt vierfachen Trefferpunktschaden zu, und der OB hat einen Bonus von +50"
                    },
                    {
                        "name": "Telekinesemeisterschaft",
                        "level": 50,
                        "value": "Der Zauberer kann in jeder Runde einen beliebigen niedrigstufigeren Spruch dieser Liste mit einer Reichweite von 100m verwenden."
                    }
                ]
            },
            {
                "id": "15.9",
                "name": "10.2.10: Tor des Geistes",
                "spells": [
                    {
                        "name": "Objekt versetzen I",
                        "level": 2,
                        "value": "Der Zauberer teleportiert ein unbelebtes Objekt an einen bis zu 30 Meter entfernten Ort. Es dürfen sich keine Hindernisse auf direkter Linie zwischen Start- und Zielpunkt befinden. Als Hindernis gilt hierbei alles, was das Objekt nicht physikalisch durchqueren kann (eine geschlossene Tür ist ein Hindernis, eine Fallgrube nicht). Das Objekt darf maximal 0,5kg pro Stufe des Zauberers wiegen"
                    },
                    {
                        "name": "Dimensionstür Objekt I",
                        "level": 4,
                        "value": "Wie Objekt versetzen I, aber das Objekt kann durch Hindernisse hindurch teleportieren, indem die exakte Distanz angegeben wird. Wenn der Zielpunkt in fester oder flüssiger Materie liegt, bewegt sich das Ziel nicht (die Magiepunkte sind aber dennoch ausgegeben)"
                    },
                    {
                        "name": "Versetzen I",
                        "level": 5,
                        "value": "Der Zauberer teleportiert sich an einen bis zu 30 Meter entfernten Ort. Es dürfen sich keine Hindernisse auf direkter Linie zwischen Startund Zielpunkt befinden. Als Hindernis gilt hierbei alles, was der Zauberer nicht körperlich durchqueren kann (eine geschlossene Tür ist ein Hindernis, eine Fallgrube nicht)"
                    },
                    {
                        "name": "Objekt versetzen III",
                        "level": 6,
                        "value": "Wie Objekt versetzen I, aber das Objekt kann bis zu 100 Meter weit teleportiert werden"
                    },
                    {
                        "name": "Dimensionstür Objekt V",
                        "level": 7,
                        "value": "Wie Dimensionstür Objekt I, bis auf die Reichweite"
                    },
                    {
                        "name": "Versetzen III",
                        "level": 8,
                        "value": "Wie Versetzen I, aber der Zauberer kann sich bis zu 100 Meter weit teleportieren"
                    },
                    {
                        "name": "Objekt versetzen V",
                        "level": 9,
                        "value": "Wie Objekt versetzen I, aber das Objekt kann bis zu 150 Meter weit teleportiert werden"
                    },
                    {
                        "name": "Geringere Dimensionstür",
                        "level": 10,
                        "value": "Wie Versetzen I, aber der Zauberer kann sich 15 Meter weit teleportieren, und er kann durch Hindernisse hindurch springen, indem die exakte Distanz angegeben wird. Wenn der Zielpunkt in fester oder flüssiger Materie liegt, bewegt er sich nicht, statt dessen ist er für 1W10 Runden benommen (die Magiepunkte sind aber dennoch ausgegeben)"
                    },
                    {
                        "name": "Versetzen V",
                        "level": 11,
                        "value": "Wie Versetzen I, nur kann sich der Zauberer 150 Meter weit bewegen"
                    },
                    {
                        "name": "Dimensionstür I",
                        "level": 12,
                        "value": "Wie Geringere Dimensionstür, nur kann sich der Zauberer 30m weit bewegen"
                    },
                    {
                        "name": "Dimensionstür Objekt X",
                        "level": 13,
                        "value": "Wie Dimensionstür Objekt I, bis auf die Reichweite"
                    },
                    {
                        "name": "Meister-Versetzen",
                        "level": 15,
                        "value": "Wie Versetzen I, aber der Zauberer kann sich 30m pro Stufe und bis zu 600m weit insgesamt bewegen"
                    },
                    {
                        "name": "Dimensionstür III",
                        "level": 16,
                        "value": "Wie Dimensionstür I, nur kann sich der Zauberer 100m weit bewegen"
                    },
                    {
                        "name": "Dimensionstür V",
                        "level": 18,
                        "value": "Wie Dimensionstür I, nur kann sich der Zauberer 150m weit bewegen"
                    },
                    {
                        "name": "Tor des Geistes I",
                        "level": 20,
                        "value": "Wenn der Zauberer geistig Kontakt mit einem Ziel (einem denkfähigen Wesen) aufgenommen hat, das bereit ist mitzuwirken, so kann er sich zu dessen Standort teleportieren oder das Ziel zu seinem teleportieren. Die Teleportation kann nicht fehlschlagen und bis zu 1,5km weit reichen"
                    },
                    {
                        "name": "Wahrhaftiges Versetzen",
                        "level": 25,
                        "value": "Wie Versetzen I, nur ist die Bewegung nur durch die Hindernisregel beschränkt (auf einer flachen Ebene könnte sie bis zum Horizont gehen)"
                    },
                    {
                        "name": "Tor des Geistes II",
                        "level": 30,
                        "value": "Wie Tor des Geistes I, nur ist Obergrenze für die Bewegungsweite 15km pro Stufe"
                    },
                    {
                        "name": "Wahrhaftiges Tor des Geistes",
                        "level": 50,
                        "value": "Wie Tor des Geistes I, nur ist die Bewegungsweite unbeschränkt."
                    }
                ]
            }
        ]
    },
    {
        "id": "16",
        "name": "Basisliste Barde",
        "spellLists": [
            {
                "id": "16.0",
                "name": "10.3.1: Legenden",
                "spells": [
                    {
                        "name": "Erinnern",
                        "level": 1,
                        "value": "Erlaubt dem Zauberer Zugriff auf sein Gedächtnis, als hätte er ein photographisches Gedächtnis. Alle Fertigkeiten, für die Gedächtnis wichtig ist, bekommen einen besonderen Bonus. Wenn Gedächtnis als eines der Attribute der Fertigkeit vorkommt (Kategorie Wissenschaft/Analytisch), ist dieser Bonus +10. Wenn Gedächtnis sogar zweimal vorkommt (Kategorie Wissen), ist der Bonus +25. Bei einer direkten GD-Probe ist der Bonus +50"
                    },
                    {
                        "name": "Sprache lernen II",
                        "level": 2,
                        "value": "Verdoppelt die Rate, in der der Zauberer eine Sprache lernen kann. Wenn er diesen Spruch bei einem Stufenaufstieg einsetzt, erlernt er für jeden gelernten Fertigkeitsrang in einer Sprache tatsächlich zwei Fertigkeitsränge"
                    },
                    {
                        "name": "Sprachkunde",
                        "level": 3,
                        "value": "Gibt an, in welcher Sprache ein Text verfaßt ist, sowie den Autor, sofern dieser wichtig ist oder der Zauberer bereits eines seiner Werke kennt"
                    },
                    {
                        "name": "Geisteskunde I",
                        "level": 4,
                        "value": "Der Zauberer sondiert die Gedanken eines Ziels und kann sich ein wenig des Wissens des Ziels (bewußt und unbewußt) zu einem sehr spezifischen Thema aneignen. Für jede Information gibt es eine Chance von 10%, daß der Zauberer sie erfährt (würfeln Sie für eine Information pro Runde)"
                    },
                    {
                        "name": "Studieren II",
                        "level": 5,
                        "value": "Der Zauberer liest mit doppelter Geschwindigkeit (2 Seiten pro Minute, so lange dieser Spruch aktiv ist)"
                    },
                    {
                        "name": "Sprache lernen III",
                        "level": 7,
                        "value": "Wie Sprache lernen II, aber jeder Rang wird verdreifacht"
                    },
                    {
                        "name": "Geisteskunde III",
                        "level": 8,
                        "value": "Wie Geisteskunde I, aber pro Information gibt es hier eine Chance von 30%"
                    },
                    {
                        "name": "Studieren III",
                        "level": 10,
                        "value": "Wie Studieren II, aber der Zauberer kann mit dreifacher Geschwindigkeit lesen (also 3 Seiten pro Minute)"
                    },
                    {
                        "name": "Textursprung",
                        "level": 11,
                        "value": "Der Zauberer kann einen Textabschnitt lesen und feststellen, ob es eine Übersetzung ist. Wenn das der Fall ist, weiß er auch was die Quellsprache war und kann den Autoren benennen, wenn er erwähnenswert bekannt ist oder wenn der Zauberer mit seinem Werk vertraut ist"
                    },
                    {
                        "name": "Sprache lernen IV",
                        "level": 12,
                        "value": "Wie Sprache lernen II, aber jeder Rang wird vervierfacht"
                    },
                    {
                        "name": "Geisteskunde V",
                        "level": 13,
                        "value": "Wie Geisteskunde I, aber der Zauberer hat eine Chance von 50% pro Information"
                    },
                    {
                        "name": "Studieren V",
                        "level": 15,
                        "value": "Wie Studieren II, aber der Zauberer kann mit fünffacher Geschwindigkeit lesen (also 5 Seiten pro Minute)"
                    },
                    {
                        "name": "Studieren X",
                        "level": 17,
                        "value": "Wie Studieren II, aber der Zauberer kann mit zehnfacher Geschwindigkeit lesen (also 10 Seiten pro Minute)"
                    },
                    {
                        "name": "Geisteskunde VII",
                        "level": 18,
                        "value": "Wie Geisteskunde I, aber der Zauberer hat eine Chance von 70% pro Information"
                    },
                    {
                        "name": "Wahrhaftiges Studieren",
                        "level": 20,
                        "value": "Wie Studieren II, nur kann der Zauberer Seiten mit einem kurzen Blick darauf lesen"
                    },
                    {
                        "name": "Sprache lernen V",
                        "level": 25,
                        "value": "Wie Sprache lernen II, aber jeder Rang wird verfünffacht"
                    },
                    {
                        "name": "Wahrhaftige Geisteskunde",
                        "level": 30,
                        "value": "Wie Geisteskunde I, nur erlangt der Zauberer alles Wissen"
                    },
                    {
                        "name": "Wahrhaftiges Sprachenlernen",
                        "level": 50,
                        "value": "Wenn der Zauberer Zugang zu einem Wesen hat, das eine bestimmte Sprache spricht, kann er diese Sprache so gut lernen, wie jenes Wesen sie beherrscht. Er muß es dazu berühren und sich 8 aufeinander folgende Stunden lang konzentrieren."
                    }
                ]
            },
            {
                "id": "16.1",
                "name": "10.3.3: Kontrolle des Schalls",
                "spells": [
                    {
                        "name": "Ruhe I",
                        "level": 1,
                        "value": "Erzeugt einen Bereich mit Radius 30cm um den Zauberer herum, durch dessen äußere Grenze sich kein Schall bewegen kann. Dies bringt +25 auf Schleichen"
                    },
                    {
                        "name": "Geräuschbeherrschung I",
                        "level": 2,
                        "value": "Der Zauberer kann den Schall im Wirkungsbereich manipulieren. Er kann beliebige Geräusche erzeugen, und auf seinen Wunsch sind sie auch außerhalb des Wirkungsbereichs hörbar"
                    },
                    {
                        "name": "Stille I",
                        "level": 4,
                        "value": "Wie Ruhe I, aber der Wirkungsbereich ist ein 3mRadius"
                    },
                    {
                        "name": "Geräuschbeherrschung II",
                        "level": 5,
                        "value": "Wie Geräuschbeherrschung I, aber der Wirkungsbereich ist ein 3m-Radius"
                    },
                    {
                        "name": "Donnerschlag",
                        "level": 6,
                        "value": "Direkt an den Ohren des Ziels kracht ein Donnerschlag los. Das Ziel ist für die Wirkungsdauer benommen"
                    },
                    {
                        "name": "Taub",
                        "level": 7,
                        "value": "Das Ziel kann keine Geräusche hören, die von weiter als 15cm von seinen Ohren herrühren"
                    },
                    {
                        "name": "Spalte",
                        "level": 8,
                        "value": "Bestimmte Schallwellen bewirken, daß alle Risse und Fehler in einem bis zu 3m x 3m x 3m großen Teil beliebigen toten Materials sich bis zum Äußersten dehnen"
                    },
                    {
                        "name": "Stille III",
                        "level": 10,
                        "value": "Wie Ruhe I, aber der Wirkungsbereich ist ein 15mRadius"
                    },
                    {
                        "name": "Geräuschbeherrschung III",
                        "level": 11,
                        "value": "Wie Geräuschbeherrschung I, aber der Wirkungsbereich ist ein 30m-Radius"
                    },
                    {
                        "name": "Splitterexplosion",
                        "level": 13,
                        "value": "Läßt ein nicht-metallnes, unbelebtes Objekt (mit bis zu 30 Litern Volumen) zerbersten. Alle innerhalb eines Radius von 2m erleiden einen kritischen Aufpralltreffer der Intensität A (derjenige, der es hält, einen der Intensität C)"
                    },
                    {
                        "name": "Wartende Geräusche",
                        "level": 14,
                        "value": "Der Zauberer kann sich auf eine bestimmte Geräuschfolge konzentrieren und diese dann um bis zu 24 Stunden verzögern oder bis ein bestimmtes Geräusch sie auslöst"
                    },
                    {
                        "name": "Geräuschbeherrschung IV",
                        "level": 15,
                        "value": "Wie Geräuschbeherrschung I, aber der Wirkungsbereich ein Radius von 3m pro Stufe des Zauberers"
                    },
                    {
                        "name": "Fern-Donnerschlag",
                        "level": 16,
                        "value": "Wie Donnerschlag, bis auf die Reichweite"
                    },
                    {
                        "name": "Geisteslied",
                        "level": 18,
                        "value": "Alle Ziele (auch Tiere) im Wirkungsbereich werden durch Ultraschall benommen"
                    },
                    {
                        "name": "Zerbröckeln",
                        "level": 20,
                        "value": "Wie Spalte, nur zerfällt rissiges Material zu Staub. In Abschnitt 5.7 (Seite 38) finden sie Näheres zu Materialbeständigkeit und Rissen"
                    },
                    {
                        "name": "Wahrhaftige Stille",
                        "level": 25,
                        "value": "Wie Stille I, nur ist der Wirkungsbereich ein 30m-Radius"
                    },
                    {
                        "name": "Wahrhaftiges Geisteslied",
                        "level": 30,
                        "value": "Wie Geisteslied, bis auf den Wirkungsbereich"
                    },
                    {
                        "name": "Wahrhaftige Geräuschbeherrschung",
                        "level": 50,
                        "value": "Wie Geräuschbeherrschung I, nur können die Geräusche programmiert und (bis zu 24 Stunden) verzögert werden. Es kann mehr als ein Geräusch gleichzeitig sein, und die Geräusche sind jederzeit veränderbar."
                    }
                ]
            },
            {
                "id": "16.2",
                "name": "10.3.4: Projektion des Schalls",
                "spells": [
                    {
                        "name": "Weites Flüstern I",
                        "level": 1,
                        "value": "Das Flüstern des Zauberers kann an einem von ihm bestimmten Punkt innerhalb der Reichweite gehört werden"
                    },
                    {
                        "name": "Schreien II",
                        "level": 2,
                        "value": "Die Stimme des Zauberers wird doppelt so laut. Dies benutzt man häufig, um zu großen Menschenmengen zu sprechen"
                    },
                    {
                        "name": "Liedverstärkung II",
                        "level": 3,
                        "value": "Verdoppelt beim Einsatz vor einem Zauber der Liste Lieder der Kontrolle dessen Reichweite. Der Spruch muß innerhalb einer Minute nach Liedverstärkung II gewirkt werden"
                    },
                    {
                        "name": "Lied II",
                        "level": 4,
                        "value": "Gestattet dem Zauberer, mit einem Spruch der Liste Lieder der Kontrolle zwei Ziele zu beeinflussen. Der Spruch muß innerhalb einer Minute nach Lied II gewirkt werden"
                    },
                    {
                        "name": "Weites Flüstern III",
                        "level": 5,
                        "value": "Wie Weites Flüstern I, aber die Reichweite ist 100 Meter"
                    },
                    {
                        "name": "Schreien V",
                        "level": 6,
                        "value": "Wie Schreien II, aber die Verstärkung ist fünffach"
                    },
                    {
                        "name": "Großes Lied I",
                        "level": 7,
                        "value": "Wie Lied II, aber jeder innerhalb von einem 3m-Radius um den Zauberer kann beeinflußt werden"
                    },
                    {
                        "name": "Liedverstärkung III",
                        "level": 8,
                        "value": "Wie Liedverstärkung II, aber die Reichweite wird verdreifacht"
                    },
                    {
                        "name": "Weites Flüstern V",
                        "level": 9,
                        "value": "Wie Weites Flüstern I, aber die Reichweite ist 150 Meter"
                    },
                    {
                        "name": "Lied III",
                        "level": 10,
                        "value": "Wie Lied II, aber es können 3 Ziele beeinflußt werden"
                    },
                    {
                        "name": "Leises Lied",
                        "level": 11,
                        "value": "Wenn der Spruch mit einem Spruch der Liste Lieder der Kontrolle gewirkt wird, hört niemand außer dem Ziel (bzw. den Zielen) das Lied. Der Spruch von der Liste Lieder der Kontrolle muß innerhalb einer Minute gewirkt werden, nachdem dieser Spruch abgeschlossen wurde"
                    },
                    {
                        "name": "Liedverstärkung IV",
                        "level": 12,
                        "value": "Wie Liedverstärkung II, aber die Reichweite wird vervierfacht"
                    },
                    {
                        "name": "Weites Flüstern V",
                        "level": 13,
                        "value": "Wie Weites Flüstern I, aber die Reichweite ist 300 Meter"
                    },
                    {
                        "name": "Lied V",
                        "level": 14,
                        "value": "Wie Lied II, aber es können 5 Ziele betroffen werden"
                    },
                    {
                        "name": "Großes Lied V",
                        "level": 15,
                        "value": "Wie Großes Lied I, aber der Wirkungsbereich ist ein 15m-Radius"
                    },
                    {
                        "name": "Liedverstärkung V",
                        "level": 16,
                        "value": "Wie Liedverstärkung II, aber die Reichweite wird verfünffacht"
                    },
                    {
                        "name": "Wahrhaftig weites Flüstern",
                        "level": 17,
                        "value": "Wie Weites Flüstern I, nur ist die Reichweite 30m pro Stufe"
                    },
                    {
                        "name": "Lied X",
                        "level": 18,
                        "value": "Wie Lied II, aber es können 10 Ziele betroffen werden"
                    },
                    {
                        "name": "Liedverstärkung VII",
                        "level": 20,
                        "value": "Wie Liedverstärkung II, aber die Reichweite wird versiebenfacht"
                    },
                    {
                        "name": "Wahrhaftig großes Lied",
                        "level": 25,
                        "value": "Wie Großes Lied I, aber der Wirkungsbereich ist ein Radius von 1,5m pro Stufe"
                    },
                    {
                        "name": "Liedverstärkung X",
                        "level": 30,
                        "value": "Wie Liedverstärkung II, aber die Reichweite wird verzehnfacht"
                    },
                    {
                        "name": "Liedermeister",
                        "level": 50,
                        "value": "Während der Spruchdauer kann pro Runde einer der Sprüche hier gewirkt werden. Lieder der Kontrolle müssen unabhängig hiervon gewirkt werden (und verbrauchen so einen Teil der Spruchdauer) und kosten zusätzliche Magiepunkte."
                    }
                ]
            },
            {
                "id": "16.3",
                "name": "10.3.5: Wege der Unterhaltung",
                "spells": [
                    {
                        "name": "Rampenlicht",
                        "level": 1,
                        "value": "Der Zauberer wird von einem hellen Lichtkreis beleuchtet. Beim Wirken des Spruches benennt der Zauberer seine „Vorderseite“, und das Licht kommt dann aus dieser Richtung. Durch Konzentration kann der Zauberer seine „Vorderseite“ wechseln (das Licht schaltet sich dann ab und ein neues geht aus der neuen Richtung kommend an)"
                    },
                    {
                        "name": "Licht dämpfen",
                        "level": 2,
                        "value": "Alle nichtmagischen Lichtquellen im Wirkungsbereich werden auf die Leuchtstärke von weichem Kerzenlicht gedämpft"
                    },
                    {
                        "name": "Lärm dämpfen",
                        "level": 3,
                        "value": "Während der Wirkungsdauer sind alle Geräusche im Wirkungsbereich nicht lauter als ein Flüstern. Der Zauberer ist dagegen immun. Zusätzlich kann er bis zu ein weiteres Ziel pro Stufe benennen, das dann auch immun ist. Indem er sich eine Runde konzentriert, kann er die neuen Ziele hinzufügen"
                    },
                    {
                        "name": "Fanfare",
                        "level": 4,
                        "value": "Eine musikalische Fanfare erklingt. Der Zauberer kann ein Instrument bestimmen (das dann die Fanfare bzw. den Tusch spielt) pro angefangenen 5 Erfahrungsstufen. Die Lautstärke kann nicht über die natürliche Lautstärke der Instrumente hinausgehen"
                    },
                    {
                        "name": "Schausteller I",
                        "level": 5,
                        "value": "Der Zauberer erhält einen besonderen Bonus von +5 auf alle Fertigkeiten, die mit Auftritten zu tun haben (in der Gruppe Kunst • Aktiv)"
                    },
                    {
                        "name": "Kunststück",
                        "level": 6,
                        "value": "Der Zauberer kann ein Ziel (bis zu 0.5kg pro Stufe des Zauberers) verschwinden lassen. Der Zauberer muß einen Ort bestimmen, an dem das Ziel wieder auftaucht (dieser Ort muß in seiner Sichtlinie liegen). Das Objekt wird beim Auslösen dieses Spruches dann an diesen Ort teleportiert"
                    },
                    {
                        "name": "Fesseln I",
                        "level": 7,
                        "value": "Das Ziel dieses Spruchs ist von dem Zauberer gefesselt (solange er auftritt oder für die Spruchdauer, das kürzere gilt). Während das Ziel gefesselt ist, hat es nur 20% Aktivität pro Runde"
                    },
                    {
                        "name": "Versteckte Tasche",
                        "level": 8,
                        "value": "Der Zauberer kann ein unbelebtes Objekt (bis zu 30 Liter Volumen pro Stufe) in einen beliebigen Behälter legen. Die Öffnung des Behälters muß für das Objekt groß genug sein. Wird der Behälter auf normale Weise untersucht, erscheint er leer (auch tastend). Der Zauberer kann das Objekt jederzeit aus dem Behälter hervorholen, es wird dann wieder sichtbar. Wenn die Wirkungsdauer abgelaufen ist, erscheint es wieder normal in dem Behälter"
                    },
                    {
                        "name": "Beleuchtung",
                        "level": 9,
                        "value": "Der Zauberer kann farbiges Licht erzeugen, das den Wirkungsbereich beleuchtet. Indem er sich konzentriert, kann er die Farbe des Lichts wechseln. Das Licht kann jede beliebige Form annehmen, aber es beleuchtet nie mehr als den Wirkungsbereich. Beispielsweise können mehrere leuchtende Kugeln in verschiedenen Farben sich um die Füße des Zauberers drehen, oder fünf rote Strahlen tanzen über den Körper des Zauberers"
                    },
                    {
                        "name": "Schausteller II",
                        "level": 10,
                        "value": "Wie Schausteller I, aber der Bonus ist +10"
                    },
                    {
                        "name": "Musik",
                        "level": 11,
                        "value": "Der Zauberer kann eine Musik abspielen lassen, die klingt, als würde er sie spielen (und er muß sie auch mindestens einmal gespielt haben). Die Musik spielt während der Spruchdauer fortlaufend. Wenn das Musikstück endet, bevor die Spruchdauer abgelaufen ist, wird es so oft wie nötig wiederholt. Der Zauberer kann auch Gesang statt der Musik abspielen lassen"
                    },
                    {
                        "name": "Fesseln V",
                        "level": 12,
                        "value": "Wie Fesseln I, nur sind 5 Ziele betroffen"
                    },
                    {
                        "name": "Freiwilliger aus dem Publikum",
                        "level": 13,
                        "value": "Das Ziel dieses Spruches wird für die Spruchdauer alles tun, was ihm der Zauberer befiehlt. Wenn das Ziel dem Zauberer zuvor schon einmal als „Freiwilliger“ zur Verfügung stand, erleidet es einen WW-Malus von -1 pro Gelegenheit, an dem es erfolgreich Spruchziel war. Wenn die Handlung(en) der Natur des Ziels entgegengesetzt ist/ sind, kann er einen weiteren WW mit einem besondern Modifikator von +50 ausführen"
                    },
                    {
                        "name": "Bezaubernder Assistent",
                        "level": 14,
                        "value": "Das Aussehen des Spruchziels (das auch der Zauberer selbst sein kann) wird verbessert. Behandeln Sie das als einen zeitweiligen Bonus von +25 auf Aussehen (bis zu einem Maximum von 101). Wenn das Aussehen des Ziels so auf über 100 steigt, lenkt das alle ab, die das Ziel sehen (behandeln Sie das als einen besonderen Modifikator von -10 auf alle Wahrnehmungsfertigkeitsmanöver, solange das Ziel im Sichtfeld ist). Dieser Spruch wertet sowohl das Aussehen des Gesichts/Körpers wie das der Kleidung auf. Es kann sich bei dem Ziel um einen Mann oder eine Frau handeln. Lassen Sie sich nicht von der Spruchbezeichnung verwirren"
                    },
                    {
                        "name": "Schausteller III",
                        "level": 15,
                        "value": "Wie Schausteller I, aber der Bonus ist +15"
                    },
                    {
                        "name": "Orchester",
                        "level": 16,
                        "value": "Wie Musik, nur kann der Zauberer ein Instrument pro je 5 angefangene Erfahrungsstufen aussuchen. Alle Instrumente (und Gesang) klingen so, als würde der Zauberer sie gleichzeitig spielen"
                    },
                    {
                        "name": "Fesseln X",
                        "level": 17,
                        "value": "Wie Fesseln I, nur sind 10 Ziele betroffen"
                    },
                    {
                        "name": "Verschwinden lassen",
                        "level": 18,
                        "value": "Wie Kunststück, nur kann der Spruch ein beliebiges Ziel betreffen, dessen Masse nicht größer ist als die des Zauberers"
                    },
                    {
                        "name": "Schausteller IV",
                        "level": 20,
                        "value": "Wie Schausteller I, aber der Bonus ist +20"
                    },
                    {
                        "name": "Massen-Fesseln",
                        "level": 25,
                        "value": "Wie Fesseln I, nur sind die Stufe des Zauberers an Zielen betroffen"
                    },
                    {
                        "name": "Wahrhaftiges Verschwindenlassen",
                        "level": 30,
                        "value": "Wie Verschwinden lassen, nur kann ein beliebiges Lebewesen oder ein unbelebtes Objekt betroffen sein, das bis zu 50k pro Stufe des Zauberers wiegt"
                    },
                    {
                        "name": "Wahrhaftiger Schausteller",
                        "level": 50,
                        "value": "Wie Schausteller I, aber der Bonus ist +25."
                    }
                ]
            },
            {
                "id": "16.4",
                "name": "10.3.6: Wissen um Gegenstände",
                "spells": [
                    {
                        "name": "Juwelen/Metalle schätzen",
                        "level": 1,
                        "value": "Der Zauberer kann den Wert von Juwelen und Metallen mit einem Fehler von ±10% des tatsächlichen Werts abschätzen. Er kann den Wert sogar kulturspezifisch abschätzen. Dieser Spruch bewertet jedoch nur das Material, nicht die Handwerksarbeit"
                    },
                    {
                        "name": "Objekt schätzen",
                        "level": 2,
                        "value": "Wie Juwelen/Metalle, aber er gilt für alle Objekte, und hier wird die Handwerksarbeit mit berücksichtigt. Nicht jedoch eventuelle magische Fähigkeiten"
                    },
                    {
                        "name": "Macht erkennen",
                        "level": 3,
                        "value": "Entdeckt magische Macht in einem Gegenstand (aber nicht den Magiebereich oder weitere Einzelheiten). Jede Runde kann durch Konzentration ein weiteres Objekt untersucht werden"
                    },
                    {
                        "name": "Gegenstandsanalyse I",
                        "level": 4,
                        "value": "Der Zauberer hat eine Chance von 10%, die magischen Fähigkeiten eines Gegenstands zu bestimmen (würfeln Sie einmal pro Fähigkeit). Wenn dieser Spruch einmal auf einen Gegenstand angewendet wurde, kann er auf diesen Gegenstand erst dann wieder gewirkt werden, wenn der Zauberer eine neue Stufe erreicht hat"
                    },
                    {
                        "name": "Wahrhaftiges Schätzen",
                        "level": 5,
                        "value": "Wie Objekt schätzen, aber wirklich alles kann abgeschätzt werden (Tiere, Häuser, Boote, usw.)"
                    },
                    {
                        "name": "Bedeutung",
                        "level": 6,
                        "value": "Hiermit kann der Zauberer herausfinden, ob das untersuchte Objekt eine kulturelle oder historische Bedeutung hat, allerdings nicht, welche genau"
                    },
                    {
                        "name": "Gegenstandsanalyse II",
                        "level": 7,
                        "value": "Wie Gegenstandsanalyse I, aber pro Fähigkeit ist die Chance hier 20%"
                    },
                    {
                        "name": "Herkunft",
                        "level": 8,
                        "value": "Liefert die Ursprungsgegend des untersuchten Gegenstands, das Volk, das ihn hergestellt hat, und wann er hergestellt wurde (mit einem Fehler von ±100 Jahren)"
                    },
                    {
                        "name": "Gegenstandsvision",
                        "level": 9,
                        "value": "Gibt dem Zauberer eine Vision des wichtigsten Ereignisses in der Vergangenheit des Gegenstands. Dieses Ereignis kann sich aber nicht vor mehr als 1 Stunde pro Stufe des Zauberers abgespielt haben"
                    },
                    {
                        "name": "Gegenstandsanalyse III",
                        "level": 10,
                        "value": "Wie Gegenstandsanalyse I, aber pro Fähigkeit ist die Chance hier 30%"
                    },
                    {
                        "name": "Fluch entdecken",
                        "level": 11,
                        "value": "Stellt fest, ob ein Fluch auf einem Gegenstand liegt"
                    },
                    {
                        "name": "Wahrhaftige Bedeutung",
                        "level": 13,
                        "value": "Wie Bedeutung, nur ermittelt der Spruch die genaue kulturelle und historische Bedeutung"
                    },
                    {
                        "name": "Gegenstandsanalyse IV",
                        "level": 15,
                        "value": "Wie Gegenstandsanalyse I, aber pro Fähigkeit ist die Chance hier 40%"
                    },
                    {
                        "name": "Todeskunde",
                        "level": 16,
                        "value": "Zeigt in einer Vision, wie jemand starb, und liefert ein Bild des Mörders. Wenn dieser Spruch gewirkt wird, muß der Zauberer ein Objekt berühren, das für den Tod bedeutsam war (die Mordwaffe, die Leiche usw.)"
                    },
                    {
                        "name": "Wahrhaftige Gegenstandsvision",
                        "level": 17,
                        "value": "Wie Gegenstandsvision, nur ohne zeitliche Beschränkung"
                    },
                    {
                        "name": "Gegenstandsanalyse V",
                        "level": 18,
                        "value": "Wie Gegenstandsanalyse I, aber pro Fähigkeit ist die Chance hier 50%"
                    },
                    {
                        "name": "Gegenstandsanalyse VI",
                        "level": 20,
                        "value": "Wie Gegenstandsanalyse I, aber pro Fähigkeit ist die Chance hier 60%"
                    },
                    {
                        "name": "Wahrhaftige Herkunft",
                        "level": 25,
                        "value": "Wie Herkunft, nur liefert der Spruch den genauen Herkunftsort, das Wesen, das den Gegenstand hergestellt hat, und wann der Gegenstand erschaffen wurde"
                    },
                    {
                        "name": "Gegenstandsanalyse VII",
                        "level": 30,
                        "value": "Wie Gegenstandsanalyse I, aber pro Fähigkeit ist die Chance hier 70%"
                    },
                    {
                        "name": "Wahrhaftige Gegenstandsanalyse",
                        "level": 50,
                        "value": "Wie Gegenstandsanalyse I, aber der Spruch bestimmt alle Fähigkeiten automatisch."
                    }
                ]
            }
        ]
    },
    {
        "id": "17",
        "name": "Basisliste Magent",
        "spellLists": [
            {
                "id": "17.0",
                "name": "10.4.1: Assassinenmeisterschaft",
                "spells": [
                    {
                        "name": "Verborgenes Objekt I",
                        "level": 1,
                        "value": "Das Zielobjekt (das nicht größer sein kann als ein Dolch) wird so getarnt, daß es aussieht wie ein Stück der Kleidung oder der Haut des Zauberers. Das ist eine Illusion, die auf alle Sinne wirkt (auch auf den Tastsinn), und kann als Illusion entdeckt werden. Das Objekt bleibt verborgen, bis es von seinem Aufbewahrungsort entfernt wird oder bis die Spruchdauer abgelaufen ist"
                    },
                    {
                        "name": "Sündenbock studieren",
                        "level": 2,
                        "value": "[WW Mod:-50] Wenn dieser Spruch auf eine Person gewirkt wird, bleibt er 24 Stunden lang aktiv. Nachdem diese 24 Stunden abgelaufen sind (aber bevor 24 weitere Stunden vorüber sind) muß der Zauberer diesen Spruch noch einmal auf die gleiche Person wirken. Während der Spruch aktiv ist, sammelt er Informationen über die Aktivitäten der Person. Wenn der Spruch das zweite Mal gewirkt wird, werden diese Informationen dem Zauberer enthüllt. Er benötigt die Informationen für andere Sprüche dieser Liste und für Sprüche anderer Listen (wie die Spruchlisten Irreleiten und Verkleidungsmeisterschaft). Der Zauberer kann immer nur einen „Sündenbock“ studiert haben"
                    },
                    {
                        "name": "Gezielter Angriff I",
                        "level": 3,
                        "value": "Der Zauberer erhält einen Bonus von +25 auf den nächsten Angriff (innerhalb von einer Minute, nachdem er diesen Spruch wirkte)"
                    },
                    {
                        "name": "Offener Hinterhalt I",
                        "level": 4,
                        "value": "Wenn der Zauberer seinen nächsten Angriff (innerhalb von einer Minute, nachdem er diesen Spruch wirkte) „von hinten“ oder „seitlich“ (von der Flanke) ausführt, kann er seine Fertigkeit Hinterhalt mit einem Bonus von +1 (auf die Anzahl der Ränge) verwenden (selbst wenn das Ziel des Zauberers gewahr ist)"
                    },
                    {
                        "name": "Anvisieren I",
                        "level": 5,
                        "value": "Bis zu einer Minute, nachdem dieser Spruch gewirkt wird, kann der Zauberer einen Fernkampfangriff auf ein unbewegliches Ziel (oder auf eines, das sich vorhersehbar bewegt) ausführen. Der Würfelwurf, um einen etwaigen kritischen Treffer zu bestimmen, kann um 1 nach oben oder unten modifiziert werden (wie bei der Fertigkeit Hinterhalt)"
                    },
                    {
                        "name": "Beweismittel erschaffen I",
                        "level": 6,
                        "value": "Der Zauberer kann mit diesem Spruch ein einzelnes Beweismittel (nicht beweglich) erschaffen, das auf den derzeit studierten Sündenbock verweist (siehe Sündenbock studieren). Das könnte ein Fingerabdruck, ein Fußabdruck usw. sein (aber immer etwas, was normalerweise nicht vom Tatort entfernt werden kann). Das Beweismittel sollte als Indizienbeweis gelten (d.h. mit einem guten Alibi könnte der Sündenbock aus dem Schneider sein)"
                    },
                    {
                        "name": "Verstecktes Objekt II",
                        "level": 7,
                        "value": "Wie Verstecktes Objekt I, nur kann ein Objekt verborgen werden, das so groß sein kann wie ein Schwert"
                    },
                    {
                        "name": "Gezielter Angriff II",
                        "level": 8,
                        "value": "Wie Gezielter Angriff I, nur ist der Bonus +50"
                    },
                    {
                        "name": "Offener Hinterhalt II",
                        "level": 9,
                        "value": "Wie Offener Hinterhalt I, nur ist der Modifikator +2"
                    },
                    {
                        "name": "Anvisieren II",
                        "level": 10,
                        "value": "Wie Anvisieren I, nur ist der Modifikator 2"
                    },
                    {
                        "name": "Blitzschnelle Reaktionen",
                        "level": 11,
                        "value": "Der Zauberer erhält einen Bonus von +10 auf seinen nächsten Initiativewurf"
                    },
                    {
                        "name": "Beweismittel erschaffen II",
                        "level": 12,
                        "value": "Wie Beweismittel erschaffen I, nur werden zwei Beweismittel erschaffen"
                    },
                    {
                        "name": "Gezielter Angriff III",
                        "level": 13,
                        "value": "Wie Gezielter Angriff I, nur ist der Bonus +75"
                    },
                    {
                        "name": "Offener Hinterhalt III",
                        "level": 14,
                        "value": "Wie Offener Hinterhalt I, nur ist der Modifikator +3"
                    },
                    {
                        "name": "Anvisieren III",
                        "level": 15,
                        "value": "Wie Anvisieren I, nur ist der Modifikator 3"
                    },
                    {
                        "name": "Wahrhaftig verborgenes Objekt",
                        "level": 16,
                        "value": "Wie Verstecktes Objekt I, nur kann das Objekt jede Größe haben (solange die größte Abmessung kleiner ist als der Zauberer selbst)"
                    },
                    {
                        "name": "Opfer studieren",
                        "level": 17,
                        "value": "Wie Sündenbock studieren, nur wird die Informationen gesammelt, um sie später mit einem der Vernichtenden Angriff-Sprüche auf dieser Liste zu verwenden"
                    },
                    {
                        "name": "Beweismittel erschaffen III",
                        "level": 18,
                        "value": "Wie Beweismittel erschaffen I, nur werden drei Beweismittel erschaffen"
                    },
                    {
                        "name": "Wahrhaftiger gezielter Angriff",
                        "level": 19,
                        "value": "Wie Gezielter Angriff I, nur ist der Bonus +100"
                    },
                    {
                        "name": "Vernichtender Angriff",
                        "level": 20,
                        "value": "Innerhalb von einer Minute, nachdem dieser Spruch gewirkt wird, gilt der nächste Angriff auf ein studiertes Opfer (siehe Opfer studieren auf dieser Liste) als gezielt tödlich. Der Angriff muß stattfinden, bevor die Dauer dieses Spruchs abgelaufen ist"
                    },
                    {
                        "name": "Wahrhaftig offener Hinterhalt",
                        "level": 25,
                        "value": "Wie Offener Hinterhalt I, nur ist der Modifikator +5"
                    },
                    {
                        "name": "Wahrhaftiges Anvisieren",
                        "level": 30,
                        "value": "Wie Anvisieren I, nur ist der Modifikator 5"
                    },
                    {
                        "name": "Wahrhaftig vernichtender Angriff",
                        "level": 50,
                        "value": "Wie Vernichtender Angriff, nur gelten alle Angriffe auf das Opfer (insbesondere auch von anderen Angreifern als dem Zauberer) als gezielt tödlich (für die Spruchdauer)."
                    }
                ]
            },
            {
                "id": "17.1",
                "name": "10.4.2: Entrinnen",
                "spells": [
                    {
                        "name": "Schloßkunde",
                        "level": 1,
                        "value": "Der Spruch liefert dem Zauberer einen Bonus von +20 auf Versuche, das untersuchte Schloß zu knacken. Wenn er das Schloß einem anderen erklärt, erhält derjenige einen Bonus von +10"
                    },
                    {
                        "name": "Öffnen I",
                        "level": 2,
                        "value": "Dieser Spruch hat eine 30%-Chance, ein nicht-magisches Schloß zu öffnen. Wenn sich das Schloß nicht öffnet, besteht eine Wahrscheinlichkeit von 10%, daß Fallen ausgelöst werden, die mit dem Schloß verbunden sind. Die Würfe sind offen und werden durch die Qualität des Schlosses modifiziert"
                    },
                    {
                        "name": "Entknebeln",
                        "level": 3,
                        "value": "Jede kleinere Bedeckung aus organischem Material am Kopf des Zaubers wird gelöst. Dazu gehören alle Knebel und Augenbinden"
                    },
                    {
                        "name": "Objekt versetzen I",
                        "level": 4,
                        "value": "Der Zauberer teleportiert ein unbelebtes Objekt an einen bis zu 30 Meter entfernten Ort. Es dürfen sich keine Hindernisse auf direkter Linie zwischen Start- und Zielpunkt befinden. Als Hindernis gilt hierbei alles, was das Objekt nicht körperlich durchqueren kann (eine geschlossene Tür ist ein Hindernis, eine Fallgrube nicht). Das Objekt darf maximal 0,5kg pro Stufe des Zauberers wiegen"
                    },
                    {
                        "name": "Öffnen II",
                        "level": 5,
                        "value": "Wie Öffnen I, aber die Chance ist 50% (mit nur 8% Wahrscheinlichkeit wird eine Falle ausgelöst)"
                    },
                    {
                        "name": "Losbinden",
                        "level": 6,
                        "value": "Alle Seile (oder ähnliche Fesseln), mit denen der Zauberer gefesselt ist, werden gelöst. Beachten Sie, daß für diesen Spruch der übliche Abzug dafür gilt, daß der Zauberer keine Hand frei hat (falls seine Hände gefesselt wurden). Dies stört einen Magenten als Nutzer des Mentalismus allerdings keineswegs, denn im Bereich Mentalismus ist dieser Abzug 0"
                    },
                    {
                        "name": "Geringere Dimensionstür",
                        "level": 7,
                        "value": "Der Zauberer kann sich 15 Meter weit teleportieren. Er kann durch Hindernisse hindurch springen, wenn er die exakte Distanz und Richtung angibt. Wenn der Zielpunkt in fester oder flüssiger Materie liegt, bewegt er sich nicht, statt dessen ist er für 1W10 Runden benommen (die Magiepunkte sind aber dennoch ausgegeben)"
                    },
                    {
                        "name": "Öffnen III",
                        "level": 8,
                        "value": "Wie Öffnen I, aber die Chance ist 70% (mit nur 6% Wahrscheinlichkeit wird eine Falle ausgelöst)"
                    },
                    {
                        "name": "Entfesseln",
                        "level": 9,
                        "value": "Der Zauberer hat eine 75%-Chance, abschließbare Handschellen oder entsprechende Fesseln zu öffnen (das wird je nach Qualität des Schlosses modifiziert)"
                    },
                    {
                        "name": "Versetzen I",
                        "level": 10,
                        "value": "Der Zauberer teleportiert sich an einen bis zu 30 Meter entfernten Ort. Es dürfen sich keine Hindernisse auf direkter Linie zwischen Start- und Zielpunkt befinden. Als Hindernis gilt hierbei alles, was der Zauberer nicht körperlich durchqueren kann (eine geschlossene Tür ist ein Hindernis, eine Fallgrube nicht)"
                    },
                    {
                        "name": "Hindurchdringen",
                        "level": 11,
                        "value": "Der Zauberer kann sich mit einer Geschwindigkeit von bis zu 1,5m pro Minute durch alles unbelebte Material bewegen"
                    },
                    {
                        "name": "Dimensionstür Objekt",
                        "level": 12,
                        "value": "Wie Objekt versetzen I, aber das Objekt kann durch Hindernisse hindurch teleportieren, indem die exakte Entfernung und Richtung angegeben wird. Wenn der Zielpunkt in fester oder flüssiger Materie liegt, bewegt sich das Ziel nicht (die Magiepunkte sind aber dennoch ausgegeben)"
                    },
                    {
                        "name": "Öffnen IV",
                        "level": 13,
                        "value": "Wie Öffnen I, aber die Chance ist 90% (mit nur 4% Wahrscheinlichkeit wird eine Falle ausgelöst)"
                    },
                    {
                        "name": "Dimensionstür I",
                        "level": 14,
                        "value": "Wie Geringere Dimensionstür, nur kann sich der Zauberer 30m weit bewegen"
                    },
                    {
                        "name": "Wahrhaftiges Entfesseln",
                        "level": 15,
                        "value": "Wie Entfesseln, nur wirkt der Spruch auch auf feste Fesseln (d.h. welche, die zusammengenietet wurden)"
                    },
                    {
                        "name": "Versetzen II",
                        "level": 16,
                        "value": "Wie Versetzen I, nur kann sich der Zauberer 60m weit bewegen"
                    },
                    {
                        "name": "Abflachen",
                        "level": 18,
                        "value": "Der Zauberer wird auf der Seite abgeflacht, bis er zweidimensional ist. So kann er durch Ritzen schlüpfen (und von der Seite nicht gesehen werden)"
                    },
                    {
                        "name": "Dimensionstür II",
                        "level": 19,
                        "value": "Wie Geringere Dimensionstür, nur kann sich der Zauberer 60m weit bewegen"
                    },
                    {
                        "name": "Wahrhaftiges Hindurchdringen",
                        "level": 20,
                        "value": "Wie Hindurchdringen, nur ist die Geschwindigkeit 3m pro Minute"
                    },
                    {
                        "name": "Portal",
                        "level": 25,
                        "value": "Öffnet einen Durchgang von 1m x 2m x 1m in jeglicher festen Oberfläche. Wenn die Dauer ausläuft, formt sich die Materie zurück. Jeder, der noch innerhalb des Portals steht, wird an seinen Ausgangspunkt versetzt"
                    },
                    {
                        "name": "Wahrhaftiges Öffnen",
                        "level": 30,
                        "value": "Wie Öffnen I, nur werden alle Schlösser im Wirkungsbereich geöffnet"
                    },
                    {
                        "name": "Teleportation I",
                        "level": 50,
                        "value": "Wie Dimensionstür I, aber mit einer Reichweite von 15km pro Stufe. Je nachdem, wie gut der Zauberer den Zielort kennt, kann dieser Spruch ziemlich riskant sein. Es bestehen folgende Wahrscheinlichkeiten für einen Fehlschlag: Unbekannter Zielort (nur durch Beschreibung bekannt) = 50%, kurz dagewesen (bis zu einer Stunde Aufenthalt) = 25%, studiert (24 Stunden Aufenthalt) = 10%, ausführlich studiert (7 Tage) = 1%, dort gelebt (mindestens 1 Jahr) = 0,01%. Ein offener W100 liefert die Abweichung in Metern (die Richtung sollten Sie nach dem Zufallsprinzip bestimmen)."
                    }
                ]
            },
            {
                "id": "17.2",
                "name": "10.4.3: Geheimnisse einholen",
                "spells": [
                    {
                        "name": "Kopieren I",
                        "level": 1,
                        "value": "Der Spruch kopiert ein Dokument, das der Zauberer untersucht. Der Zauberer konzentriert sich nur und berührt mit der einen Hand das Dokument und mit der anderen ein leeres Blatt. Die Kopie ist nicht exakt (d.h. es ist keine Fälschung). Beachten Sie, daß der Zauberer das Dokument nicht lesen können muß. Alternativ kann er auch eine Szene, die er sieht, in Schwarzweiß auf eine Seite übertragen. Der Vorgang dauert 1 Minute pro Seite oder Szene"
                    },
                    {
                        "name": "Lauschen",
                        "level": 2,
                        "value": "Der Zauberer kann einen Punkt bestimmen, der bis zu 3m weit entfernt sein kann, und hört dann so, als stünde er dort (es können Hindernisse wie Wände im Weg sein)"
                    },
                    {
                        "name": "Duplikat I",
                        "level": 3,
                        "value": "Dieser Spruch fertigt eine gehärtete Tonkopie eines kleinen, dreidimensionalen Objekts an (bis zu 15cm x 15cm x 15cm). Der Spruch erfordert, daß der Zauberer genug Ton für die Kopie (in einem 1 zu 1 Maßstab) hat. Der Ton muß anfänglich weich sein (der Spruch härtet ihn aus). Der Vorgang erfordert eine Minute Konzentration"
                    },
                    {
                        "name": "Sinnesmarkierung",
                        "level": 4,
                        "value": "Ein Ort wird markiert, so daß der Zauberer ihn später mit einem Fernsinn-Spruch wiederfinden kann. Die Markierung wird automatisch gefunden, wenn der Zauberer einen Fernsinn-Spruch wirkt, sofern sie in Reichweite ist. Die Markierung kann auf jedes beliebige unbelebte Objekt gesetzt werden, aber der Zauberer kann nicht mehr Markierungen haben, als er Stufen hat"
                    },
                    {
                        "name": "Kopieren II",
                        "level": 5,
                        "value": "Wie Kopieren I, nur braucht der Spruch vier Runden, um eine Seite/Szene zu kopieren"
                    },
                    {
                        "name": "Fernsinn I",
                        "level": 6,
                        "value": "Der Zauberer kann einen seiner Sinne auswählen, der dann an einer „Markierung“ innerhalb der Reichweite eingesetzt wird (vgl. Sinnesmarkierung). Der Zauberer kann jede Wahrnehmungsfertigkeit oder Eigenschaften an der Markierung einsetzen, über die er zu diesem Zeitpunkt verfügt (wenn er z.B. Nachtsicht vorher auf sich gewirkt hat, hat er auch an der Markierung Nachtsicht). Die Ausrichtung des Sinns kann beliebig gedreht werden. Während der Zauberer durch die Markierung wahrnimmt, kann er sich nicht bewegen und muß sich konzentrieren"
                    },
                    {
                        "name": "Beweismittel finden I",
                        "level": 7,
                        "value": "Wenn er diesen Spruch wirkt, weiß der Zauberer, welche Beweismittel es am Tatort gibt (falls welche da sind), die auf den derzeit studierten Sündenbock verweisen (siehe Sündenbock studieren auf der Liste Assassinenmeisterschaft). Wenn es ein Beweismittel gibt, ist es ein Indizienbeweis, aber es wird darauf hinweisen, daß der Sündenbock am Tatort war, als ein Verbrechen geschah. Dieser Spruch liefert nur die Richtung und Entfernung zu dem Beweismittel und eine Beschreibung von ihm. Er gibt aber nicht darüber Aufschluß, warum es auf den Sündenbock verweist"
                    },
                    {
                        "name": "Sehen",
                        "level": 8,
                        "value": "Wie Lauschen, aber der Zauberer kann von dem festgesetzten Punkt aus sehen (die Sicht kann rotieren)"
                    },
                    {
                        "name": "Duplikat II",
                        "level": 9,
                        "value": "Wie Duplikat I, nur wirkt er auch auf Gegenstände, die bis zu 1m x 1m x 1m groß sind"
                    },
                    {
                        "name": "Kopieren III",
                        "level": 10,
                        "value": "Wie Kopieren I, nur braucht der Spruch zwei Runden, um eine Seite/Szene zu kopieren"
                    },
                    {
                        "name": "Fernsinn II",
                        "level": 11,
                        "value": "Wie Fernsinn I, aber der Zauberer kann der Markierung bis zu zwei Sinne zuweisen"
                    },
                    {
                        "name": "Holzsicht",
                        "level": 12,
                        "value": "Der Zauberer kann durch Holz hindurchsehen, das bis zu 3cm pro Stufe dick sein kann"
                    },
                    {
                        "name": "Beweismittel finden II",
                        "level": 13,
                        "value": "Wie Beweismittel finden I, nur werden zwei Beweismittel gefunden und sie sind belastend (d.h. nicht nur Indizienbeweise)"
                    },
                    {
                        "name": "Duplikat III",
                        "level": 14,
                        "value": "Wie Duplikat I, nur wirkt er auch auf Gegenstände, die bis zu 2m x 2m x 2m groß sind"
                    },
                    {
                        "name": "Kopieren IV",
                        "level": 15,
                        "value": "Wie Kopieren I, nur braucht der Spruch eine Runde, um eine Seite/Szene zu kopieren"
                    },
                    {
                        "name": "Besserer Fernsinn I",
                        "level": 16,
                        "value": "Wie Fernsinn I, aber der Zauberer kann sich bewegen, während der Spruch wirkt (auch wenn er sich weiterhin konzentrieren muß)"
                    },
                    {
                        "name": "Steinsicht",
                        "level": 17,
                        "value": "Wie Holzsicht, nur kann der Zauberer durch Stein sehen"
                    },
                    {
                        "name": "Beweismittel finden III",
                        "level": 18,
                        "value": "Wie Beweismittel finden I, nur werden drei Beweismittel gefunden und sie „beweisen“, daß der Sündenbock schuldig ist"
                    },
                    {
                        "name": "Besserer Fernsinn II",
                        "level": 19,
                        "value": "Wie Fernsinn II, aber der Zauberer kann sich bewegen, während der Spruch wirkt (auch wenn er sich weiterhin konzentrieren muß)"
                    },
                    {
                        "name": "Eisensicht",
                        "level": 20,
                        "value": "Wie Holzsicht, nur kann der Zauberer durch Eisen (oder Stahl) sehen"
                    },
                    {
                        "name": "Weitreichender Fernsinn I",
                        "level": 25,
                        "value": "Wie Fernsinn I, bis auf die Reichweite"
                    },
                    {
                        "name": "Kopieren V",
                        "level": 30,
                        "value": "Wie Kopieren I, nur braucht der Spruch eine Runde, um zwei Seiten/Szenen zu kopieren"
                    },
                    {
                        "name": "Wahrhaftiges Kopieren",
                        "level": 50,
                        "value": "Wie Kopieren I, nur kopiert der Spruch ein beliebiges gebundenes Buch auf eine entsprechende Anzahl von Blättern (die nicht gebunden sein müssen). Außerdem muß der Zauberer das Material nicht untersuchen (er wirkt einfach den Spruch und kann ihn laufen lassen). Der Spruch paust 5 Seiten pro Runde ab (und kann sogar farbige Bilder kopieren)."
                    }
                ]
            },
            {
                "id": "17.3",
                "name": "10.4.4: Giftmeisterschaft",
                "spells": [
                    {
                        "name": "Giftkunde",
                        "level": 1,
                        "value": "Der Zauberer weiß, welche Art Gift(e) nötig sind, um eine bestimmte Wirkung zu erzielen. Der SL kann es für angemessen befinden, dem Zauberer einen Bonus von +25 auf die Fertigkeit Giftkunde zu geben"
                    },
                    {
                        "name": "Widerstand gegen Gift I",
                        "level": 2,
                        "value": "Für die Spruchdauer erhält der Zauberer einen zusätzlichen WW gegen Gift(e)"
                    },
                    {
                        "name": "Gift auftragen I",
                        "level": 3,
                        "value": "Dieser Spruch sorgt dafür, daß eine Dosis Gift an einer unbelebten, festen Oberfläche haftet. Das Gift läßt normal nach"
                    },
                    {
                        "name": "Gift aufbereiten V",
                        "level": 4,
                        "value": "Dieser Spruch bereitet ein Gift (bis zur 5. Stufe) magisch auf. Dieser Spruch erfordert normalerweise 1W100 Minuten Konzentration, um abgeschlossen werden zu können. Beachten Sie, daß der Zauberer den Rohstoff für das Gift haben muß, um diesen Spruch zu wirken (d.h. der Spruch erschafft das Gift nicht, sondern bereitet es nur auf )"
                    },
                    {
                        "name": "Gift analysieren",
                        "level": 5,
                        "value": "Der Zauberer kann ein Gift analysieren, um festzustellen, wie es sich auswirkt und welches Gegengift nötig ist"
                    },
                    {
                        "name": "Giftwirkung verzögern",
                        "level": 6,
                        "value": "Während der Spruchdauer sind alle Auswirkungen eines einfachen Gifts aufgehoben. Beachten Sie, daß der Zauberer das Gift noch immer im Körper hat und es normal anschlägt, wenn die Dauer abgelaufen ist (auch wenn er den Spruch noch einmal wirken kann, um die Wirkung weiter hinauszuzögern)"
                    },
                    {
                        "name": "Gift übertragen I",
                        "level": 7,
                        "value": "Der Zauberer kann eine Dosis Gift von einem Ziel, das er berührt, auf sich übertragen. Wenn ein Gefährte beispielsweise von einem Giftpfeil getroffen wird, kann der Zauberer ihn berühren und das Gift auf sich übertragen (wo er dessen Wirkung verzögern oder es neutralisieren kann)"
                    },
                    {
                        "name": "Gift auftragen II",
                        "level": 8,
                        "value": "Wie Gift auftragen I, nur sind zwei Dosen betroffen (auch wenn sie auf unterschiedliche Oberflächen aufgebracht werden können)"
                    },
                    {
                        "name": "Gift neutralisieren",
                        "level": 9,
                        "value": "Wenn der Zauberer sich konzentriert, kann dieser Spruch mit einer Wahrscheinlichkeit von 50% das Gift in ihm neutralisieren (modifiziert nach der Giftstufe). Auf jeden Fall wird die Wirkung des Giftes um die Spruchdauer verzögert"
                    },
                    {
                        "name": "Gift aufbereiten X",
                        "level": 10,
                        "value": "Wie Gift aufbereiten V, nur sind Gifte bis zu Stufe 10 betroffen"
                    },
                    {
                        "name": "Blutkontaktgift",
                        "level": 11,
                        "value": "Der Zauberer kann jedes Gift, das er berührt, in ein Blutkontaktgift verwandeln. Das Gift wird nun wirksam, wenn es in den Blutkreislauf des Opfers eingebracht wird (egal welche Wirkweise es normalerweise hat)"
                    },
                    {
                        "name": "Gift auftragen III",
                        "level": 12,
                        "value": "Wie Gift auftragen I, nur sind bis zu drei Dosen Gift betroffen"
                    },
                    {
                        "name": "Wahrhaftige Giftneutralisation",
                        "level": 13,
                        "value": "Wie Gift neutralisieren, nur wird das Gift mit hundertprozentiger Wahrscheinlichkeit neutralisiert (modifiziert durch die Giftstufe)"
                    },
                    {
                        "name": "Gift übertragen II",
                        "level": 14,
                        "value": "Der Zauberer kann eine einzelne Dosis eines Gifts von einem beliebigen berührten Ziel auf ein beliebiges anderes berührtes Ziel übertragen"
                    },
                    {
                        "name": "Giftige Berührung",
                        "level": 15,
                        "value": "Durch diesen Spruch kann der Zauberer die Hände des Ziels mit Gift überziehen. Das Ziel wird nicht von dem Gift betroffen"
                    },
                    {
                        "name": "Wahrhaftige Giftaufbereitung",
                        "level": 16,
                        "value": "Wie Gift aufbereiten V, nur sind alle Gifte betroffen"
                    },
                    {
                        "name": "Gift auftragen IV",
                        "level": 17,
                        "value": "Wie Gift auftragen I, nur sind bis zu vier Dosen Gift betroffen"
                    },
                    {
                        "name": "Kontaktgift",
                        "level": 18,
                        "value": "Wie Blutkontaktgift, nur wird das Gift in ein Kontaktgift verwandelt (ein Gift, das das Opfer betrifft, wenn es mit dessen Haut in Berührung kommt"
                    },
                    {
                        "name": "Gift übertragen III",
                        "level": 19,
                        "value": "Der Zauberer kann eine einzelne Dosis eines Gifts von einem beliebigen berührten Ziel auf ein beliebiges anderes Ziel innerhalb der Spruchreichweite übertragen"
                    },
                    {
                        "name": "Giftatem",
                        "level": 20,
                        "value": "Der Zauberer kann eine einzelne Dosis Gift schlucken. Für die Spruchdauer betrifft ihn das Gift nicht. Innerhalb der Spruchdauer kann er das Gift auf ein beliebiges, einzelnes Ziel übertragen. Das Ziel darf dabei nicht weiter als zwei Meter weg sein, und der Zauberer muß das Gift mit dem Mund übertragen können (durch einen Kuß, ein Flüstern, indem er spuckt usw). Das Ziel erhält einen WW, um dem Spruch zu entgehen (zusätzlich zu dem WW gegen das Gift)"
                    },
                    {
                        "name": "Giftblick",
                        "level": 25,
                        "value": "Wie Giftatem, nur kann der Zauberer das Gift auf ein beliebiges Ziel innerhalb der Reichweite übertragen. Der Zauberer muß einen offensichtlichen, böse starrenden Blick auf das Ziel werfen können. Das Ziel erhält einen WW, um dem Spruch zu entgehen (zusätzlich zu dem WW gegen das Gift)"
                    },
                    {
                        "name": "Giftwolke",
                        "level": 30,
                        "value": "Der Zauberer kann ein Gift in eine neblige Wolke auflösen. Der Nebel hat pro Dosis des Gifts einen Radius von 30 Zentimetern. Das Gift verbleibt normal in dem Bereich, bis die Spruchdauer abgelaufen ist (d.h. es ist dem Wind usw. ausgesetzt). Wenn die Dauer erlischt, verzieht sich das Gift"
                    },
                    {
                        "name": "Giftsicht",
                        "level": 50,
                        "value": "Wie Giftblick, bis auf die Reichweite."
                    }
                ]
            },
            {
                "id": "17.4",
                "name": "10.4.5: Irreleiten",
                "spells": [
                    {
                        "name": "Falscher Ausweis",
                        "level": 1,
                        "value": "[WW Mod.: -20] Das Ziel denkt, daß sich der Zauberer für die gegenwärtige Situation ordentlich ausweisen kann (das könnte er durch ein Paßwort oder durch Dokumente tun)"
                    },
                    {
                        "name": "Transparenz I",
                        "level": 2,
                        "value": "Ein einzelnes Objekt wird unsichtbar (1 Gewand, 1 nackter Körper usw.), bis entweder 24 Stunden verstrichen sind oder bis das Ziel von einem harten Schlag getroffen wird (indem es von einer Waffe getroffen wird, stürzt o.ä..) oder bis das Ziel eine gewalttätige Handlung ausführt (z.B. einen Angriff )"
                    },
                    {
                        "name": "Augenzeuge III",
                        "level": 3,
                        "value": "[WW Mod.: -20] Bis zu drei Zeugen werden den Zauberer als jemanden anderen identifizieren (alle drei werden ihn gleich beschreiben)"
                    },
                    {
                        "name": "Tarnung III",
                        "level": 4,
                        "value": "[WW-Mod -50] Der Zauberer wird für die Spruchziele unsichtbar. Andere sehen ihn normal. Wenn der Zauberer eine Aktion ausführt, die deutlich bemerkbar ist (z.B. spricht, ein Objekt bewegt usw.), darf das Ziel einen erneuten WW durchführen (der SL kann diesen WW mittels Boni beeinflussen, abhängig davon, wie offensichtlich die Aktion war). Wenn der Zauberer das Ziel angreift, steht diesem ein erneuter WW mit einem Bonus von +50 zu. Wenn der Zauberer sich konzentriert (50% Aktivität), kann er die Wirkung dieses Spruches beliebig ausdehnen (solange er die Konzentration nicht nach Ablauf der Wirkungsdauer unterbricht)"
                    },
                    {
                        "name": "Irreführung I",
                        "level": 5,
                        "value": "Die Wahrnehmung des Ziels ist für die Spruchdauer verzerrt. Es erhält einen Malus von -10 auf alle Manöver für Fertigkeiten der Gruppe Wahrnehmung • Suchen (auch auf Orientierungswürfe)"
                    },
                    {
                        "name": "Transparenz II",
                        "level": 6,
                        "value": "Wie Transparenz I, nur sind 2 Objekte betroffen"
                    },
                    {
                        "name": "Tarnung V",
                        "level": 7,
                        "value": "Wie Tarnung III, nur sind 5 Ziele betroffen"
                    },
                    {
                        "name": "Augenzeuge V",
                        "level": 8,
                        "value": "Wie Augenzeuge III, nur sind 5 Ziele betroffen"
                    },
                    {
                        "name": "Tarnsphäre I",
                        "level": 9,
                        "value": "[WW Mod.:-50] Wie Tarnung III, aber jedes Ziel im Wirkungsbereich muß einen WW ablegen (ein Basis-Angriffswurf für alle Ziele). Wenn ein Ziel einmal den WW geschafft hat, muß es gegen diesen Spruch keinen weiteren WW ausführen"
                    },
                    {
                        "name": "Irreführung III",
                        "level": 10,
                        "value": "Wie Irreführung I, nur sind die Abzüge -30"
                    },
                    {
                        "name": "Tarnung X",
                        "level": 11,
                        "value": "Wie Tarnung III, nur sind 10 Ziele betroffen"
                    },
                    {
                        "name": "Verschieben I",
                        "level": 12,
                        "value": "Der Zauberer scheint leicht von seinem eigentlichen Aufenthaltsort versetzt zu sein. Angriffe auf ihn schlagen mit einer Wahrscheinlichkeit von 10% fehl (keine normalen WW). Jedesmal, wenn ein Gegner ihn wegen dieses Spruchs verfehlt, sinkt die Wahrscheinlichkeit um 5%"
                    },
                    {
                        "name": "Augenzeuge X",
                        "level": 13,
                        "value": "Wie Augenzeuge III, nur sind 10 Ziele betroffen"
                    },
                    {
                        "name": "Tarnsphäre II",
                        "level": 14,
                        "value": "Wie Tarnsphäre I, bis auf den Wirkungsbereich"
                    },
                    {
                        "name": "Irreführung V",
                        "level": 15,
                        "value": "Wie Irreführung I, nur sind die Abzüge -50"
                    },
                    {
                        "name": "Tarnung XX",
                        "level": 16,
                        "value": "Wie Tarnung III, nur sind 20 Ziele betroffen"
                    },
                    {
                        "name": "Massen-Augenzeuge",
                        "level": 18,
                        "value": "Wie Augenzeuge III, nur ist ein Ziel pro Stufe des Zauberers betroffen"
                    },
                    {
                        "name": "Tarnsphäre III",
                        "level": 19,
                        "value": "Wie Tarnsphäre I, bis auf den Wirkungsbereich"
                    },
                    {
                        "name": "Wahrhaftige Irreführung",
                        "level": 20,
                        "value": "Wie Irreführung I, nur sind die Abzüge -100"
                    },
                    {
                        "name": "Verschieben II",
                        "level": 25,
                        "value": "Wie Verschieben I, nur ist die Fehlschlagschance 20%"
                    },
                    {
                        "name": "Wahrhaftige Tarnung",
                        "level": 30,
                        "value": "Wie Tarnung III, nur kann der Spruch die Stufe des Zauberers an Zielen betreffen und die Reichweite ist nur durch das Sichtfeld des Zauberers beschränkt"
                    },
                    {
                        "name": "Wahrhaftiger Augenzeuge",
                        "level": 50,
                        "value": "[WW Mod.: -50] Wie Augenzeuge III, nur ist jeder betroffen, der den Zauberer sieht."
                    }
                ]
            },
            {
                "id": "17.5",
                "name": "10.4.6: Verkleidungsmeisterschaft",
                "spells": [
                    {
                        "name": "Verkleidung studieren",
                        "level": 1,
                        "value": "Zauberer studiert eine Person, um sie später für einen der Verkleidungssprüche auf dieser Liste zu verwenden. Der Zauberer kann immer nur seine Stufe an Verkleidungen studiert haben"
                    },
                    {
                        "name": "Mirakel Licht",
                        "level": 2,
                        "value": "Verändert das sichtbare Erscheinungsbild eines Objektes. Das Ziel darf nicht mehr Masse als 5kg pro Stufe haben"
                    },
                    {
                        "name": "Fassade I",
                        "level": 3,
                        "value": "Eine begrenzte Illusion läßt den Zauberer wie einen Angehörigen eines beliebigen Humanoidenvolks aussehen (± 20% seiner eigenen Größe). Die Illusion bewegt sich mit dem Zauberer"
                    },
                    {
                        "name": "Schattenassassine",
                        "level": 4,
                        "value": "Alle Taten, die während der Spruchwirkung begangen werden, wirken für Erkenntnissprüche „schattenhaft“. Alle Informationen über den Zauberer sind für Erkenntnissprüche in Schatten gehüllt. Wenn beispielsweise Erinnerung an den Tod auf den Mordtatort gewirkt wird, könnte der Spruch eine Schattengestalt zeigen, die die Taten verübt (liefert aber keine Details über deren Identität)"
                    },
                    {
                        "name": "Volk kaschieren",
                        "level": 5,
                        "value": "Im Bezug auf geistige oder magische Erkennung erscheint das Ziel als Angehöriger eines beliebigen Volks, das er wählt (welches Volk es ist, muß der Zauberer festlegen, wenn er den Spruch wirkt)"
                    },
                    {
                        "name": "Fassade II",
                        "level": 6,
                        "value": "Wie Fassade I, nur wird ein weiterer Sinn abgedeckt"
                    },
                    {
                        "name": "Verkleidung I",
                        "level": 7,
                        "value": "Der Zauberer verändert sich körperlich und nimmt die Gestalt einer studierten Person an. Dies ist eine rein körperliche Verwandlung. Der Zauberer muß bereits Verkleidung studieren auf diese Person gewirkt haben"
                    },
                    {
                        "name": "Unbekannter Assassine",
                        "level": 8,
                        "value": "Wie Schattenassassine, nur wird keinerlei Information über der Zauberer enthüllt. Wenn beispielsweise Erinnerung an den Tod auf den Mordtatort gewirkt wird, könnte der Spruch zeigen, wie das Opfer mit einem Messer in der Brust zusammenbricht (er liefert aber keine Spur des Assassinen)"
                    },
                    {
                        "name": "Fassade III",
                        "level": 9,
                        "value": "Wie Fassade I, nur werden zwei weitere Sinne abgedeckt"
                    },
                    {
                        "name": "Verkleidung II",
                        "level": 10,
                        "value": "Wie Verkleidung I, nur nimmt der Zauberer auch die stimmlichen Eigenheiten der Person an (d.h. er klingt wie sie)"
                    },
                    {
                        "name": "Beruf kaschieren I",
                        "level": 11,
                        "value": "Wie Volk kaschieren, nur kann der Beruf des Ziels falsch dargestellt werden"
                    },
                    {
                        "name": "Geistzunge",
                        "level": 12,
                        "value": "Der Zauberer kann sich gedanklich mit einem beliebigen denkenden Wesen unterhalten. Dem Ziel kommt das vor wie normale (d.h. mündliche) Kommunikation"
                    },
                    {
                        "name": "Verkleidung III",
                        "level": 13,
                        "value": "Wie Verkleidung II, nur übernimmt der Zauberer auch offensichtliche Eigenheiten der Person. Wenn diese beispielsweise ein Linkshänder ist, wird auch der Zauberer zum Linkshänder, humpelt die Person, dann tut das auch der Zauberer"
                    },
                    {
                        "name": "FassadeV",
                        "level": 14,
                        "value": "Wie Fassade I, nur werden alle Sinne abgedeckt"
                    },
                    {
                        "name": "Macht kaschieren",
                        "level": 15,
                        "value": "Wie Volk kaschieren, nur kann der Zauberer seine Stufe anders erscheinen lassen (von der ersten bis zum Doppelten seiner tatsächlichen Stufe)"
                    },
                    {
                        "name": "Verkleidung IV",
                        "level": 16,
                        "value": "Wie Verkleidung II, nur übernimmt der Zauberer auch subtile Eigenheiten der Person. Damit kann er außer von den engsten Vertrauten kaum noch erkannt werden"
                    },
                    {
                        "name": "Präsenz aufheben",
                        "level": 17,
                        "value": "Wie Volk kaschieren, nur wirkt das Ziel so, als hätte es keine Präsenz (für Sprüche, die Präsenz entdecken)"
                    },
                    {
                        "name": "Falscher Assassine",
                        "level": 18,
                        "value": "Wie Schattenassassine, nur wirken alle Taten, die begangen werden, während dieser Spruch wirksam ist, so, als würde der derzeit studierte Sündenbock sie begehen (siehe Sündenbock studieren auf der Liste Assassinenmeisterschaft)"
                    },
                    {
                        "name": "Verkleidung V",
                        "level": 19,
                        "value": "Wie Verkleidung II, nur übernimmt der Zauberer auch ausgesprochen subtile Eigenheiten der Person"
                    },
                    {
                        "name": "Kaschieren",
                        "level": 20,
                        "value": "Wie alle Kaschieren-Sprüche dieser Liste gleichzeitig"
                    },
                    {
                        "name": "Unentdeckt",
                        "level": 25,
                        "value": "Der Zauberer und Objekte, die er am Körper trägt, können nicht durch Entdeckungssprüche gefunden werden"
                    },
                    {
                        "name": "Wahrhaftiges Kaschieren",
                        "level": 30,
                        "value": "Wie Kaschieren, nur muß sich der Zauberer nicht konzentrieren"
                    },
                    {
                        "name": "Verkleidungsmeister",
                        "level": 50,
                        "value": "Der Zauberer kann einmal pro Runde einen der niedrigstufigeren Sprüche dieser Liste verwenden."
                    }
                ]
            }
        ]
    },
    {
        "id": "18",
        "name": "Basisliste Mentalist",
        "spellLists": [
            {
                "id": "18.0",
                "name": "10.5.1: Kontrolle der Sinne",
                "spells": [
                    {
                        "name": "Ablenkung",
                        "level": 1,
                        "value": "Für alle Handlungen des Zieles gilt ein Malus von -30"
                    },
                    {
                        "name": "Taube Glieder",
                        "level": 2,
                        "value": "Ein zufälliges Körperglied des Zieles wird taub und nutzlos. Wenn es sich dabei um ein Bein handelt, verliert das Ziel 40% seiner Bewegung. Wenn es sich um einen Arm handelt, gilt ein Malus von -40 auf Nah- und Fernkampfangriffe, wenn dieser Arm dazu eingesetzt wird"
                    },
                    {
                        "name": "Verschwommene Sicht",
                        "level": 3,
                        "value": "Alle Fernkampfangriffe des Ziels haben einen OB-Malus von -100, alle sonstigen Handlungen haben einen Malus von -50"
                    },
                    {
                        "name": "Sinneskontrolle I",
                        "level": 4,
                        "value": "Führt zu Sinnestäuschungen eines der Sinne Geruch, Geschmack oder Tastsinn (z.B. ein stinkender Geruch, salziger Geschmack oder ein Jucken)"
                    },
                    {
                        "name": "Geräuschangriff",
                        "level": 5,
                        "value": "Ein lautes Geräusch führt dazu, daß das Ziel benommen ist"
                    },
                    {
                        "name": "Gehörkontrolle",
                        "level": 6,
                        "value": "Das Ziel hört, was der Zauberer es hören lassen will"
                    },
                    {
                        "name": "Patzer",
                        "level": 7,
                        "value": "Das Ziel verpatzt den Einsatz einer Waffe oder eines Gegenstandes in seiner Hand. Das Ergebnis wird durch einen Wurf auf der entsprechenden Patzertabelle festgestellt"
                    },
                    {
                        "name": "Sichtkontrolle",
                        "level": 8,
                        "value": "Das Ziel sieht, was der Zauberer es sehen lassen will"
                    },
                    {
                        "name": "Sichtangriff",
                        "level": 9,
                        "value": "Das Ziel wird von einem grellen Lichtblitz geblendet, so daß es nichts mehr sehen kann"
                    },
                    {
                        "name": "Nervenschock",
                        "level": 10,
                        "value": "Der Körper des Ziels wird taub. Dies führt zu einem Malus von -75 auf alle Handlungen, und das Ziel ist benommen"
                    },
                    {
                        "name": "Halluzination",
                        "level": 11,
                        "value": "Das Ziel sieht einen Gegner, der nicht da ist, und muß mit ihm kämpfen, bis es ihn besiegt hat (d.h. bis er genug Schaden eingesteckt hat, um zu Boden zu gehen). Der Gegner hat die gleichen Fähigkeiten wie das Ziel, fügt ihm aber keinen Schaden zu (d.h. er schlägt immer daneben)"
                    },
                    {
                        "name": "Spottende Halluzination",
                        "level": 12,
                        "value": "Wie Halluzination, aber der imaginäre Gegner greift niemals an. Er verspottet den Charakter nur (und wehrt alle Angriffe auf sich ab)"
                    },
                    {
                        "name": "Sinneskontrolle II",
                        "level": 13,
                        "value": "Wie Sinneskontrolle I, nur sind bis zu 2 Sinne betroffen (darunter auch der Sehsinn und das Gehör)"
                    },
                    {
                        "name": "Sinnesüberlastung",
                        "level": 15,
                        "value": "Dieser Spruch überlädt die Sinne des Ziels. Wenn dessen WW um 50 oder weniger mißlingt, ist er für die Spruchdauer benommen. Geht der WW um mehr als 50 daneben, so wird er bewußtlos"
                    },
                    {
                        "name": "Sinneskontrolle III",
                        "level": 16,
                        "value": "Wie Sinneskontrolle II, nur sind 3 beliebige Sinne betroffen"
                    },
                    {
                        "name": "Sinneskontrolle IV",
                        "level": 18,
                        "value": "Wie Sinneskontrolle II, nur sind 4 beliebige Sinne betroffen"
                    },
                    {
                        "name": "Sinnesberaubung",
                        "level": 19,
                        "value": "Das Ziel wird aller Sinne beraubt, d.h. es hat überhaupt keine Sinneseindrücke. Pro Tag einer solchen Beraubung besteht eine Wahrscheinlichkeit von 5% (kumulativ), daß es vorübergehend den Verstand verliert"
                    },
                    {
                        "name": "Sinneskontrolle V",
                        "level": 20,
                        "value": "Wie Sinneskontrolle II, nur sind alle Sinne betroffen"
                    },
                    {
                        "name": "Fern-Kontrolle",
                        "level": 25,
                        "value": "Wie Sinnenskontrolle V, nur ist die anfängliche Reichweite 100m. Sobald der Spruch gewirkt wurde, kann der Zauberer die Sinneseindrücke, die das Ziel bekommt, mit einer Reichweite von bis zu 1,5km pro Stufe des Zauberers kontrollieren"
                    },
                    {
                        "name": "Wahrhaftige Sinneskontrolle",
                        "level": 30,
                        "value": "Wie FernKontrolle, nur kann der Zauberer die Sinneseindrücke „programmieren“ (d.h. Sinneseindruck X stellt sich ein, wenn das Ziel Punkt Y erreicht), und er muß sich nur konzentrieren, während er die Eindrücke programmiert, und danach ist die Dauer 10 Minuten pro Stufe des Zauberers"
                    },
                    {
                        "name": "Private Welt",
                        "level": 50,
                        "value": "Das Ziel lebt in seiner eigenen Fantasiewelt, die der Zauberer völlig kontrolliert, wenn er sich konzentriert. Solange es sich in dieser Fantasie befindet, empfängt es keinerlei Sinneseindrücke von der wirklichen Welt."
                    }
                ]
            },
            {
                "id": "18.1",
                "name": "10.5.2: Mentaler Angriff",
                "spells": [
                    {
                        "name": "Schlag I",
                        "level": 1,
                        "value": "Das Ziel ist benommen"
                    },
                    {
                        "name": "Zögern",
                        "level": 2,
                        "value": "Das Ziel zögert bei jeder nicht-defensiven Handlung. Es erleidet einen Malus von -20 auf die Initiative und muß mit wenigstens der Hälfte seines OB parieren"
                    },
                    {
                        "name": "Geringerer Schmerz",
                        "level": 3,
                        "value": "Das Ziel erleidet 25% seiner verbleibenden Trefferpunkte als Schaden (also 25% der Trefferpunkte, die es zu diesem Zeitpunkt noch hat)"
                    },
                    {
                        "name": "Schock A",
                        "level": 4,
                        "value": "Das Ziel erleidet einen kritischen Elektrizitätstreffer der Intensität A"
                    },
                    {
                        "name": "Schlag III",
                        "level": 5,
                        "value": "Wie Schlag I, bis auf die Dauer"
                    },
                    {
                        "name": "Lähmen I",
                        "level": 7,
                        "value": "Das Ziel ist vollständig gelähmt"
                    },
                    {
                        "name": "Schock B",
                        "level": 8,
                        "value": "Wie Schock A, aber der kritische Treffer hat Intensität B"
                    },
                    {
                        "name": "Größerer Schmerz",
                        "level": 9,
                        "value": "Wie Geringerer Schmerz, aber es werden 50% der verbleibenden Trefferpunkte abgezogen"
                    },
                    {
                        "name": "Gedankenschrei I",
                        "level": 10,
                        "value": "Jeder (mit Ausnahme des Zauberers) im Wirkungsbereich ist benommen, sofern kein WW geschafft wird"
                    },
                    {
                        "name": "Schlag V",
                        "level": 11,
                        "value": "Wie Schlag I, bis auf die Dauer. 12 Lähmen III"
                    },
                    {
                        "name": "Schock C",
                        "level": 13,
                        "value": "Wie Schock A, aber es ist ein kritischer Elektrizitätstreffer der Intensität C"
                    },
                    {
                        "name": "Gedankenschrei II",
                        "level": 15,
                        "value": "Wie Gedankenschrei I, nur ist der Wirkungsbereich ein Radius von 15 Metern"
                    },
                    {
                        "name": "Schock D",
                        "level": 16,
                        "value": "Wie Schock A, aber es ist ein kritischer Elektrizitätstreffer der Intensität D"
                    },
                    {
                        "name": "Lähmen V",
                        "level": 17,
                        "value": "Wie Lähmen I, nur ist die Dauer 5 Runden pro Fehlschlag von 10"
                    },
                    {
                        "name": "Schlag X",
                        "level": 18,
                        "value": "Wie Schlag I, bis auf die Dauer"
                    },
                    {
                        "name": "Gedankenschrei III",
                        "level": 19,
                        "value": "Wie Gedankenschrei I, nur ist der Wirkungsbereich ein Radius von 30 Metern"
                    },
                    {
                        "name": "Schock E",
                        "level": 20,
                        "value": "Wie Schock A, aber es ist ein kritischer Elektrizitätstreffer der Intensität E"
                    },
                    {
                        "name": "Mächtiger Schrei",
                        "level": 25,
                        "value": "Wie Gedankenschrei I, nur ist der Wirkungsbereich ein Radius von 15 Metern und jedes Ziel, dessen WW um mehr als 50 fehlschlägt, ist acht Stunden lang bewußtlos"
                    },
                    {
                        "name": "Wahrhaftiger Gedankenschrei",
                        "level": 30,
                        "value": "Wie Gedankenschrei I, nur ist der Wirkungsbereich ein Radius von 100 Metern"
                    },
                    {
                        "name": "Wahrhaftiger Schrei",
                        "level": 50,
                        "value": "Wie Gedankenschrei II, nur werden die Ziele bewußtlos, deren WW um 1-50 fehlschlug, und die, deren WW um mehr als 50 daneben ging, sterben. Für Mentalismuszauberer wird der Rettungswurf um -20 modifiziert."
                    }
                ]
            },
            {
                "id": "18.2",
                "name": "10.5.3: Mentale Kommunikation",
                "spells": [
                    {
                        "name": "Mentalistenzunge",
                        "level": 1,
                        "value": "Der Zauberer kann sich gedanklich mit einem anderen Mentalismusnutzer unterhalten"
                    },
                    {
                        "name": "Geist vorbereiten I",
                        "level": 2,
                        "value": "Der Zauberer versinkt in einem Tranceähnlichen Zustand, um sich als Ziel für einen Geistzunge-Spruch vorzubereiten. Während dieser Spruch bei ihm aktiv ist, ist die Reichweite von eingehenden Geistzunge-Sprüchen verzehnfacht"
                    },
                    {
                        "name": "Geistzunge I",
                        "level": 3,
                        "value": "Der Zauberer kann sich gedanklich mit einem beliebigen denkenden Wesen unterhalten. Sie müssen sich entweder sehen können, oder der Zauberer kennt den genauen Aufenthaltsort des Ziels, oder der Zauberer wendet Geistfokus an, um das Ziel zu finden (das Ziel muß auf jeden Fall in Reichweite sein)"
                    },
                    {
                        "name": "Geistfokus",
                        "level": 4,
                        "value": "Wenn dieser Spruch innerhalb einer Minute vor einem Geistzunge-Spruch gewirkt wurde, erlaubt er es dem Zauberer, sich auf ein bestimmtes Ziel zu fokussieren (das er zuvor mittels Geist speichern gespeichert hat). Damit funktionieren bestimmte Sprüche, selbst wenn der Zauberer nicht den genauen Aufenthaltsort des Ziels kennt"
                    },
                    {
                        "name": "Geist vorbereiten II",
                        "level": 5,
                        "value": "Wie Geist vorbereiten I, aber die Reichweite des eingehenden Spruchs wird um den Faktor 20 vergrößert"
                    },
                    {
                        "name": "Geistzunge II",
                        "level": 6,
                        "value": "Wie Geistzunge I, aber mit einer Reichweite von 150 Metern"
                    },
                    {
                        "name": "Geist vorbereiten III",
                        "level": 8,
                        "value": "Wie Geist vorbereiten I, aber die Reichweite des eingehenden Spruchs wird um den Faktor 50 vergrößert"
                    },
                    {
                        "name": "Geistsprache I",
                        "level": 9,
                        "value": "Der Zauberer kann Gedanken an alle Ziele im Wirkungsbereich übermitteln. Diese Kommunikation ist einseitig"
                    },
                    {
                        "name": "Geistzunge III",
                        "level": 10,
                        "value": "Wie Geistzunge I, aber mit einer Reichweite von 300 Metern"
                    },
                    {
                        "name": "Geist vorbereiten IV",
                        "level": 11,
                        "value": "Wie Geist vorbereiten I, aber die Reichweite des eingehenden Spruchs wird um das 100fache erhöht"
                    },
                    {
                        "name": "Geistsprache II",
                        "level": 12,
                        "value": "Wie Geistsprache I, nur ist der Wirkungsbereich ein Radius von 30 Metern 13. Freundessprache"
                    },
                    {
                        "name": "Geist vorbereiten V",
                        "level": 14,
                        "value": "Wie Geist vorbereiten I, aber die Reichweite des eingehenden Spruchs wird um das 500fache erhöht"
                    },
                    {
                        "name": "Geistsprache III",
                        "level": 15,
                        "value": "Wie Geistsprache I, nur ist der Wirkungsbereich ein Radius von 100 Metern"
                    },
                    {
                        "name": "Wartende Zunge",
                        "level": 16,
                        "value": "Eine geistige Botschaft von bis zu 25 Wörtern kann verzögert übermittelt werden. Der Auslösebereich darf nicht größer als ein 3m-Radius sein, und der Spruch kann durch eine der folgenden Bedingungen ausgelöst werden: durch einen bestimmten Zeitpunkt innerhalb einer Zeitspanne von 24 Stunden, bestimmte Bewegungen, bestimmte Geräusche, Berührung, dadurch oder daß eine Person, deren Geist gespeichert wurde, den Bereich betritt"
                    },
                    {
                        "name": "Wahrhaftige Geistvorbereitung",
                        "level": 17,
                        "value": "Wie Geist vorbereiten I, aber die Reichweite des eingehenden Spruchs wird um das 1000fache erhöht"
                    },
                    {
                        "name": "Geistzunge IV",
                        "level": 18,
                        "value": "Wie Geistzunge I, aber mit einer Reichweite von 2 Kilometern"
                    },
                    {
                        "name": "Wahrhaftige Freundessprache",
                        "level": 19,
                        "value": "Wie Freundessprache, nur ist der Wirkungsbereich ein Radius von 30 Metern"
                    },
                    {
                        "name": "Wahrhaftige Geistsprache",
                        "level": 20,
                        "value": "Wie Geistsprache I, nur ist der Wirkungsbereich ein Radius von 600 Metern"
                    },
                    {
                        "name": "Wahrhaftige Geistzunge",
                        "level": 25,
                        "value": "Wie Geistzunge I, nur ist die Reichweite 1,5km pro Stufe"
                    },
                    {
                        "name": "Wartende Sprache",
                        "level": 30,
                        "value": "Wie Wartenden Zunge, nur wird die Nachricht an alle innerhalb eines Radius von 100 Metern übermittelt"
                    },
                    {
                        "name": "Weitreichende Geistsprache",
                        "level": 50,
                        "value": "Wie Geistsprache I, nur kann die Reichweite bis zu 1,5km pro Stufe des Zauberers groß sein."
                    }
                ]
            },
            {
                "id": "18.3",
                "name": "10.5.4: Mentale Kontrolle",
                "spells": [
                    {
                        "name": "Frage",
                        "level": 1,
                        "value": "Das Ziel muß eine Frage wahrheitsgemäß beantworten (es muß aber in der Lage sein, die Frage zu verstehen)"
                    },
                    {
                        "name": "Schlaf",
                        "level": 2,
                        "value": "Das Ziel fällt in einen natürlichen Schlaf. Die erste Runde ist magischer Schlaf (das Ziel kann auf normale Weise in dieser Runde nicht geweckt werden)"
                    },
                    {
                        "name": "Bezaubern",
                        "level": 3,
                        "value": "Ein humanoides Ziel hält den Zauberer für einen guten Freund"
                    },
                    {
                        "name": "Beruhigen",
                        "level": 4,
                        "value": "Das Ziel führt keine aggressive/ offensive Handlung aus und kämpft nur, wenn es angegriffen wird"
                    },
                    {
                        "name": "Verwirren",
                        "level": 5,
                        "value": "Das Ziel ist nicht in der Lage, Entscheidungen zu treffen oder eine Handlung einzuleiten. Das Ziel kämpft aber weiter, wenn es sich bereits im Kampf befindet, und es kämpft zur Selbstverteidigung"
                    },
                    {
                        "name": "Furcht",
                        "level": 6,
                        "value": "Das Ziel fürchtet den Zauberer und versucht zu fliehen. Dies bedeutet normalerweise, daß das Ziel mit maximaler Geschwindigkeit vom Zauberer wegläuft"
                    },
                    {
                        "name": "Suggestion",
                        "level": 7,
                        "value": "Das Ziel führt eine ihm suggerierte Handlung aus, sofern sie nicht im Widerspruch zu seiner Natur steht (d.h. kein Selbstmord, keine Selbstblendung usw.)"
                    },
                    {
                        "name": "Handlung einschränken",
                        "level": 8,
                        "value": "Das Ziel wird auf 25% der normalen Handlungsfähigkeit beschränkt"
                    },
                    {
                        "name": "Emotionen",
                        "level": 9,
                        "value": "Ruft beim Ziel jede gewünschte Emotion hervor. Mögliche Emotionen sind: Haß, Liebe, Traurigkeit, Wut usw"
                    },
                    {
                        "name": "Kontrollieren",
                        "level": 10,
                        "value": "Das Ziel muß dem Zauberer während der Wirkungsdauer gehorchen. Es führt Befehle aus, sofern sie nicht im Widerspruch zu seiner Natur stehen (d.h. kein Selbstmord, keine Selbstblendung usw.)"
                    },
                    {
                        "name": "Koma",
                        "level": 11,
                        "value": "[WW-Mod.: +20] Das Ziel fällt in ein Koma"
                    },
                    {
                        "name": "Wahrhaftiges Bezaubern",
                        "level": 12,
                        "value": "Wie Bezaubern, nur wirkt der Spruch auf eine beliebige empfindungsfähige Kreatur"
                    },
                    {
                        "name": "Wahrhaftiges Halten",
                        "level": 14,
                        "value": "Wie Handlung einschränken, nur kann eine beliebige empfindungsfähige Kreatur betroffen werden"
                    },
                    {
                        "name": "Geas",
                        "level": 15,
                        "value": "Dem Ziel wird ein Auftrag erteilt. Wenn er versagt, erleidet es eine vom SL festgesetzten Strafe (die Aufgabe darf die Fähigkeiten des Ziels nicht übersteigen). Wenn das Ziel den Auftrag ignoriert, wird das wie ein Versagen bestraft"
                    },
                    {
                        "name": "Wahrhaftige Handlungseinschränkung",
                        "level": 16,
                        "value": "[WW-Mod.: -20] Das Ziel ist vollständig gelähmt (0% Handlungsfähigkeit)"
                    },
                    {
                        "name": "Gebrochener Geist",
                        "level": 18,
                        "value": "Das Ziel wird zum brabbelnde Idioten. Es kann herumgeführt werden, aber selbst keine Aktion ausführen"
                    },
                    {
                        "name": "Wahrhaftiger Schlaf",
                        "level": 20,
                        "value": "[WWMod.: -20] Das Ziel ist bewußtlos und kann nicht aufgeweckt werden"
                    },
                    {
                        "name": "Wahrhaftiger Geas",
                        "level": 25,
                        "value": "Wie Geas, nur erleidet das Ziel zur Strafe 5 kritische Treffer der Intensität E (welcher Art diese Treffer sind, ist zufallsbestimmt)"
                    },
                    {
                        "name": "Wahrhaftige Gedankenkotrolle",
                        "level": 30,
                        "value": "Wenn der Zauberer sich konzentriert, hat er völlige Kontrolle über den Geist des Ziels. Nachdem der Spruch gewirkt wurde, ist die Reichweite der Kontrolle 1,5km pro Stufe der Zauberers"
                    },
                    {
                        "name": "Geistige Herrschaft",
                        "level": 50,
                        "value": "Wie Wahrhaftige Gedankenkontrolle, nur ist die Dauer permanent (bis sie gebannt wird). Der Zauberer muß sich nur konzentrieren, um Befehle zu geben. Es kann immer nur ein Ziel gleichzeitig auf diese Weise kontrolliert werden."
                    }
                ]
            },
            {
                "id": "18.4",
                "name": "10.5.5: Mentale Wahrnehmung",
                "spells": [
                    {
                        "name": "Präsenz",
                        "level": 1,
                        "value": "Der Zauberer ist sich der Gegenwart aller denkenden/ intelligenten Wesen im Wirkungsbereich bewußt"
                    },
                    {
                        "name": "Spüren I",
                        "level": 2,
                        "value": "Der Zauberer erhält eine grobe Vorstellung von Volk und Stufe eines Wesens, das jedoch zuvor mittels Präsenz oder Wahrhaftige Präsenz entdeckt werden muß"
                    },
                    {
                        "name": "Geist speichern",
                        "level": 3,
                        "value": "Wie Spüren I, aber der Zauberer merkt sich das Gedankenmuster des Zieles. Dieses kann dann später mit anderen Sprüchen (dieser Liste und aus anderen) benutzt werden. Der Zauberer kann nicht mehr Gedankenmuster speichern, als die Summe seiner temporären Attribute Gedächtnis und Charisma (nicht die Boni). Der Zauberer kann ein bestimmtes Gedankenmuster jederzeit löschen (der SL sollte darauf bestehen, daß der Spieler über alle gespeicherten Gedankenmuster Buch führt)"
                    },
                    {
                        "name": "Geistspeicher übertragen",
                        "level": 4,
                        "value": "Der Zauberer kann eine Kopie eines Gedankenmusters an einen anderen Zauberer aus dem Bereich Mentalismus übertragen (dann haben beide Zauberer das Gedankenmuster gespeichert). Das Ziel dieses Spruchs muß den Spruch Geist speichern beherrschen"
                    },
                    {
                        "name": "Spüren III",
                        "level": 5,
                        "value": "Wie Spüren I, aber es werden 3 Ziele auf einmal analysiert (alle Ziele müssen sich innerhalb der Reichweite befinden)"
                    },
                    {
                        "name": "Geist einordnen",
                        "level": 6,
                        "value": "Wie Spüren I, aber der Zauberer erfährt Volk, Beruf und Stufe des Zieles"
                    },
                    {
                        "name": "Finden I",
                        "level": 7,
                        "value": "Der Zauberer erfährt Richtung und Entfernung eines nicht abgeschirmten Geistes (sofern dieser sich innerhalb der Reichweite befindet), dessen Gedankenmuster er durch Geist speichern besitzt"
                    },
                    {
                        "name": "Richtung I",
                        "level": 8,
                        "value": "Der Zauberer erfährt die Richtung eines nicht abgeschirmten Geistes (sofern dieser sich innerhalb der Reichweite befindet), dessen Gedankenmuster er durch Geist speichern besitzt"
                    },
                    {
                        "name": "Wahrhaftige Präsenz",
                        "level": 9,
                        "value": "Wie Präsenz, aber es wirkt auf ein Gebiet von 15 Meter Radius. Der Zauberer kann sich jede Runde auf ein anderes Gebiet konzentrieren"
                    },
                    {
                        "name": "Aufmerksamkeit",
                        "level": 10,
                        "value": "Wie Präsenz, aber der Zauberer erfährt auch grob, was das Ziel für Aktionen ausführt. In einer taktischen Situation kann der Zauberer so seine Aktionen ansagen, nachdem er eine der beabsichtigten Aktionen des Ziels für diese Runde erfahren hat (und in welcher Phase das Ziel dies zu tun gedenkt). Beachten Sie, daß das Ziel seine Aktionen auch noch widerrufen kann (unter Berücksichtigung der entsprechenden Abzüge, vgl. Grundregelwerk, Seite 66)"
                    },
                    {
                        "name": "Richtung II",
                        "level": 11,
                        "value": "Wie Richtung I, nur ist die Reichweite 2km pro Stufe"
                    },
                    {
                        "name": "Fern-Spüren",
                        "level": 12,
                        "value": "Wie Spüren I, nur ist die Reichweite 30m pro Stufe"
                    },
                    {
                        "name": "Spüren V",
                        "level": 13,
                        "value": "Wie Spüren I, aber es werden 5 Ziele auf einmal analysiert (alle Ziele müssen sich innerhalb der Reichweite befinden)"
                    },
                    {
                        "name": "Massen-Spüren",
                        "level": 14,
                        "value": "Wie Spüren I, nur kann der Zauberer ein Ziel pro Runde „erspüren“"
                    },
                    {
                        "name": "Wahrhaftige Geisteinordnung",
                        "level": 15,
                        "value": "Wie Geist einordnen, nur ist die Reichweite 30m pro Stufe"
                    },
                    {
                        "name": "Finden II",
                        "level": 18,
                        "value": "Wie Finden I, nur ist die Reichweite 2km pro Stufe"
                    },
                    {
                        "name": "Spüren X",
                        "level": 19,
                        "value": "Wie Spüren I, aber es werden 10 Ziele auf einmal analysiert (alle Ziele müssen sich innerhalb der Reichweite befinden)"
                    },
                    {
                        "name": "Wahrhaftige Aufmerksamkeit",
                        "level": 20,
                        "value": "Wie Aufmerksamkeit, nur erfährt der Zauberer alle Aktionen des Ziels"
                    },
                    {
                        "name": "Finden III",
                        "level": 25,
                        "value": "Wie Finden I, nur ist Reichweite 10km pro Stufe"
                    },
                    {
                        "name": "Wahrhaftige Richtung",
                        "level": 30,
                        "value": "Wie Richtung I, nur ist die Reichweite unbegrenzt"
                    },
                    {
                        "name": "Wahrhaftiges Finden",
                        "level": 50,
                        "value": "Wie Finden I, nur ist die Reichweite unbegrenzt."
                    }
                ]
            },
            {
                "id": "18.5",
                "name": "10.5.6: Verschmelzung der Gedanken",
                "spells": [
                    {
                        "name": "Einfühlungsvermögen",
                        "level": 1,
                        "value": "Der Zauberer erfährt die grundlegenden Gefühle des Ziels. Pro Runde kann er sich auf ein anderes Ziel konzentrieren"
                    },
                    {
                        "name": "Emotionen lesen",
                        "level": 2,
                        "value": "Der Zauberer erfährt die Emotionen des Ziels im Detail. Pro Runde kann er sich auf ein anderes Ziel konzentrieren"
                    },
                    {
                        "name": "Mentalisten-Austausch",
                        "level": 3,
                        "value": "Erlaubt es zwei Mentalismusnutzern, Gedanken auszutauschen"
                    },
                    {
                        "name": "Fokus",
                        "level": 4,
                        "value": "Wenn dieser Spruch vor (innerhalb einer Minute) einem Geistverbindung-Spruch oder einem Fertige Verbindung-Spruch gewirkt wurde, erlaubt er es dem Zauberer, sich auf ein bestimmtes Ziel zu fokussieren (das er zuvor mittels Geist speichern gespeichert hat). Damit funktionieren bestimmte Sprüche, selbst wenn der Zauberer nicht den genauen Aufenthaltsort des Ziels kennt"
                    },
                    {
                        "name": "Gedanken",
                        "level": 5,
                        "value": "Der Zauberer empfängt die oberflächlichen Gedanken eines Ziels (die Gedanken also, an die das Ziel bewußt denkt, die sich an der „Oberfläche“ befinden). Gelingt der WW des Ziels um mehr als 25, so bemerkt es, daß sich jemand in seinen Gedanken zu schaffen macht. Pro Runde kann er sich auf ein anderes Ziel konzentrieren"
                    },
                    {
                        "name": "Geistverbindung I",
                        "level": 6,
                        "value": "Der Zauberer und das Ziel können Gedanken austauschen. Wenn beide Mentalismusnutzer sind, dann können sie auch Magiepunkte austauschen. Sie müssen sich entweder sehen können, oder der Zauberer kennt den genauen Aufenthaltsort des Ziels, oder der Zauberer wendet Fokus an, um das Ziel zu finden (das Ziel muß auf jeden Fall in Reichweite sein)"
                    },
                    {
                        "name": "Verbindung vorbereiten",
                        "level": 7,
                        "value": "Der Zauberer bereitet sich mit diesem Spruch vor, das Ziel eines Geistverbindung-Spruchs oder eines Fertige Verbindung-Spruchs zu werden. Er erhöht die Reichweite des Verbindungsspruchs: Die Reichweite wird mit der Anzahl an Magiepunkten multipliziert, die der Zauberer in diesen Spruch investiert (wenn er also 18 MP einsetzt, ist die Reichweite 18 mal so weit)"
                    },
                    {
                        "name": "Geistverbindung II",
                        "level": 8,
                        "value": "Wie Geistverbindung I, aber die Reichweite ist 30 Meter"
                    },
                    {
                        "name": "Tiefe Gedanken",
                        "level": 10,
                        "value": "Wie Gedanken, aber der Zauberer erfährt auch die Überlegungen und Denkmuster, auf denen die oberflächlichen Gedanken aufbauen"
                    },
                    {
                        "name": "Fertige Verbindung",
                        "level": 11,
                        "value": "Wie in Geistverbindung I, nur ist die Reichweite anders und das Ziel und der Zauberer müssen vorher verbunden gewesen sein, und der Spruch wirkt unverzüglich"
                    },
                    {
                        "name": "Geisttausch",
                        "level": 13,
                        "value": "Das Ziel und der Zauberer tauschen ihren Geist und ihrer Fähigkeit, Sprüche zu wirken. Das Ziel (im Körper des Zauberers) fällt in ein Koma, falls es nicht auch ein Mentalist ist. Wenn das Ziel den Tausch nicht will, steht ihm jede Stunde ein WW zu"
                    },
                    {
                        "name": "Geist abfragen",
                        "level": 15,
                        "value": "Wie Tiefe Gedanken, nur kann der Zauberer die bewußten Erinnerungen abfragen"
                    },
                    {
                        "name": "Wahrhaftige Geistesverbindung",
                        "level": 18,
                        "value": "Wie Geistesverbindung I, bis auf die Dauer und darauf, daß der Zauberer den Aufenthaltsort mental oder auf andere Art bestimmt haben muß"
                    },
                    {
                        "name": "Geisteserforschung",
                        "level": 20,
                        "value": "Wie in Geist abfragen, nur kann der Zauberer auch die unterbewußten Erinnerungen des Ziels durchsehen (d.h. alle Erfahrungen)"
                    },
                    {
                        "name": "Wahrhaftiger Geisttausch",
                        "level": 25,
                        "value": "Wie Geisttausch, nur hält der Spruch an, bis der Zauberer sich entschließt, zu seinem eigenen Körper zurückzukehren"
                    },
                    {
                        "name": "Gedankendiebstahl",
                        "level": 30,
                        "value": "Der Zauberer kann in jeder Runde einen Gedanken aus dem Geist des Ziels entfernen"
                    },
                    {
                        "name": "Wahrhaftige Fertigverbindung",
                        "level": 50,
                        "value": "Wie in Fertige Verbindung, nur ist die Reichweite unbeschränkt."
                    }
                ]
            }
        ]
    },
    {
        "id": "19",
        "name": "Basisliste Wundheiler",
        "spellLists": [
            {
                "id": "19.0",
                "name": "10.6.1: Blutmeisterschaft",
                "spells": [
                    {
                        "name": "Blutung stoppen III",
                        "level": 1,
                        "value": "Gestattet dem Zauberer, die Blutung einer Wunde zu stoppen, durch die das Ziel drei Treffer pro Runde verliert. Das Ziel kann nicht bewegt werden, oder die Blutung bricht wieder in vorheriger Stärke auf"
                    },
                    {
                        "name": "Gerinnung I",
                        "level": 2,
                        "value": "Gestattet dem Zauberer, die Blutung einer Wunde zu stoppen, durch die das Ziel einen Treffer pro Runde verliert. Das Ziel darf sich eine Stunde lang nur mit Gehgeschwindigkeit bewegen, ansonsten setzt der Blutverlust wieder in der ursprünglichen Geschwindigkeit ein"
                    },
                    {
                        "name": "Blutung stillen I",
                        "level": 3,
                        "value": "Erlaubt es dem Zauberer, die Blutung einer Wunde zu stoppen, durch die das Ziel einen Treffer pro Runde verliert"
                    },
                    {
                        "name": "Gerinnung III",
                        "level": 4,
                        "value": "Wie Gerinnung I, nur kann der Zauberer die Blutung einer Wunde stoppen, durch die das Ziel bis zu 3 Treffer pro Runde insgesamt verliert"
                    },
                    {
                        "name": "Heilung kleiner Blutgefäße",
                        "level": 5,
                        "value": "Erlaubt dem Zauberer, ein verletztes, kleines Blutgefäß vollständig zu heilen (eine Ader, deren Blutung nicht mehr als 4 Treffer/Runde verursacht, keine Hauptschlagadern oder Venen)"
                    },
                    {
                        "name": "Blutung stillen III",
                        "level": 6,
                        "value": "Wie Blutung stillen I, nur daß der Zauberer eine oder mehrere Wunden heilen kann, durch die das Ziel insgesamt 3 Treffer pro Runde verliert. Er kann so 3 Wunden à einem Treffer/Runde oder eine Wunden à 3 Treffer pro Runde oder eine Runde à 2 Treffer pro Runde und eine Wunde à einem Treffer/Runde heilen"
                    },
                    {
                        "name": "Vene heilen",
                        "level": 7,
                        "value": "Der Zauberer kann eine beliebige verletzte Vene heilen. Das Ziel kann sich nicht (aus eigener Kraft) bewegen, ohne daß die Wunde neu aufbricht. Die Genesungszeit beträgt 1-10 Tage"
                    },
                    {
                        "name": "Arterie heilen",
                        "level": 8,
                        "value": "Der Zauberer kann eine beliebige verletzte Arterie heilen. Das Ziel kann sich nicht (aus eigener Kraft) bewegen, ohne daß die Wunde neu aufbricht. Die Genesungszeit beträgt 1-10 Tage, je nachdem, wie groß die Arterie ist und wie schwer sie verletzt ist"
                    },
                    {
                        "name": "Anfügen",
                        "level": 9,
                        "value": "Erlaubt dem Zauberer, ein abgetrenntes Körperglied wieder anzufügen. Damit die Gliedmaße wieder voll funktionstüchtig wird, müssen auch die anderen drei Anfügen-Sprüche des Wundheilers darauf gewirkt werden. Das Körperglied ist nach 10-100 Tagen wieder voll beweglich"
                    },
                    {
                        "name": "Wahrhaftiger Blutungsstop",
                        "level": 10,
                        "value": "Wie Blutung stoppen III, nur daß jeglicher Blutverlust (also Treffer/Runde) durch eine Wunde gestoppt wird"
                    },
                    {
                        "name": "Stasis I",
                        "level": 11,
                        "value": "Das Ziel wird in eine Stasis versetzt, die verhindert, daß es während der Spruchdauer stirbt (d.h. der Körper wird erhalten und die Seele verläßt den Körper nicht). Auch der andere Stasis I-Spruch (auf der Liste Nerven- und Organmeisterschaft) muß mit diesem zusammen gewirkt werden"
                    },
                    {
                        "name": "Wahrhaftige Gerinnung",
                        "level": 12,
                        "value": "Wie Gerinnung I, nur daß jeglicher Blutverlust (also Treffer/Runde) durch eine Wunde gestoppt wird"
                    },
                    {
                        "name": "Blutgerinnsel auflösen",
                        "level": 13,
                        "value": "Erlaubt dem Zauberer, ein beliebiges Blutgerinnsel zu entfernen"
                    },
                    {
                        "name": "Wahrhaftige Blutungsstillung",
                        "level": 15,
                        "value": "Wie Blutung stillen I, nur stillt der Spruch jedwede Blutung und schließt eine beliebige Wunde"
                    },
                    {
                        "name": "Stasis II",
                        "level": 17,
                        "value": "Wie Stasis I, bis auf die Dauer und darauf, daß der andere Stasis II-Spruch (auf der Liste Nerven- und Organmeisterschaft) erforderlich ist"
                    },
                    {
                        "name": "Wahrhaftige Gerinnselauflösung",
                        "level": 19,
                        "value": "Wie Blutgerinnsel auflösen, nur werden alle Gerinnsel im Ziel aufgelöst"
                    },
                    {
                        "name": "Wahrhaftiges Anfügen",
                        "level": 20,
                        "value": "Wie Anfügen, nur muß der Zauberer auch die anderen drei Wahrhaftiges Anfügen-Sprüche wirken, und das Körperglied ist bereits nach 10 Minuten wieder voll funktionstüchtig"
                    },
                    {
                        "name": "Blutregulierung",
                        "level": 25,
                        "value": "Der Zauberer kann den inneren wie äußeren Blutkreislauf des Ziels regulieren und jedweden Blutverlust stoppen. Solange das Ziel bewegungslos bleibt, kann alle Blutung aufgehalten werden, bis die Wunden geheilt werden"
                    },
                    {
                        "name": "Blutauffrischung",
                        "level": 30,
                        "value": "Der Zauberer kann alles Blut ersetzen, das ein beliebiges Ziel verloren hat. Die Genesungszeit beträgt 1-10 Tage"
                    },
                    {
                        "name": "Wahrhaftige Blutheilung",
                        "level": 50,
                        "value": "Der Zauberer kann in jeder Runde einen der niedrigstufigeren Sprüche dieser Liste anwenden."
                    }
                ]
            },
            {
                "id": "19.1",
                "name": "10.6.2: Heilungsmeisterschaft",
                "spells": [
                    {
                        "name": "Heilung I",
                        "level": 1,
                        "value": "1W10 Treffer des Ziels werden geheilt"
                    },
                    {
                        "name": "Benommenheit heilen I",
                        "level": 2,
                        "value": "Das Ziel wird von 1 Runde angesammelter Benommenheit geheilt"
                    },
                    {
                        "name": "Erfrierungen/Verbrennungen I",
                        "level": 3,
                        "value": "Heilt bei einem Ziel in einem Bereich einen leichten Frostbrand oder eine Verbrennung ersten Grades"
                    },
                    {
                        "name": "Regenerieren I",
                        "level": 4,
                        "value": "Verringert den Schaden um einen Treffer pro Minute (das Ziel heilt also einen Treffer pro Minute), solange sich der Zauberer konzentriert. Wenn der Zauberer bewußtlos ist, wirkt der Spruch auch ohne Konzentration"
                    },
                    {
                        "name": "Aufwecken",
                        "level": 5,
                        "value": "Das Ziel wacht sofort auf"
                    },
                    {
                        "name": "Erfrierungen/Verbrennungen II",
                        "level": 6,
                        "value": "Wie Erfrierungen/Verbrennungen I, nur kann der Zauberer 2 Bereiche mit leichter Erfrierung/Verbrennung heilen oder mittleren Erfrierungs-/Verbrennungsschaden in einem Bereich (z.B. eine Verbrennung zweiten Grades)"
                    },
                    {
                        "name": "Heilung V",
                        "level": 7,
                        "value": "Wie Heilung I, nur werden 5W10 Treffer des Ziels geheilt"
                    },
                    {
                        "name": "Benommenheit heilen III",
                        "level": 8,
                        "value": "Wie Benommenheit heilen I, nur können 3 Runden Benommenheit geheilt werden"
                    },
                    {
                        "name": "Erfrierungen/Verbrennungen III",
                        "level": 9,
                        "value": "Wie Erfrierungen/Verbrennungen I, nur kann der Zauberer 3 Bereiche mit leichter Erfrierung/Verbrennung heilen oder schweren Erfrierungs-/Verbrennungsschaden in einem Bereich (z.B. eine Verbrennung dritten Grades) oder eine Kombination aus einem Bereich mit leichter und einem mit mittleren Erfrierung/Verbrennung"
                    },
                    {
                        "name": "Regenerieren II",
                        "level": 10,
                        "value": "Wie Regenerieren I, nur heilen 2 Treffer pro Minute"
                    },
                    {
                        "name": "Heilung X",
                        "level": 11,
                        "value": "Wie Heilung I, nur werden 10W10 Treffer des Ziels geheilt"
                    },
                    {
                        "name": "Erfrierungen/Verbrennungen IV",
                        "level": 12,
                        "value": "Wie Erfrierungen/Verbrennungen I, nur kann der Zauberer 4 Bereiche mit leichter Erfrierung/Verbrennung oder 2 mit mittlerer oder einen mit leichter und einen mit schwerer oder 2 mit leichter und einen mit mittlerer Verbrennung/Erfrierung heilen"
                    },
                    {
                        "name": "Benommenheit heilen V",
                        "level": 13,
                        "value": "Wie Benommenheit heilen I, nur können 5 Runden Benommenheit geheilt werden"
                    },
                    {
                        "name": "Fern-Benommenheitsheilung",
                        "level": 14,
                        "value": "Wie Benommenheit heilen I, nur wird ein Ziel innerhalb von 30m Entfernung vom Zauberer von einer Runde angesammelter Benommenheit befreit"
                    },
                    {
                        "name": "Regenerieren III",
                        "level": 15,
                        "value": "Wie Regenerieren I, nur heilen 3 Treffer pro Minute"
                    },
                    {
                        "name": "Heilung XV",
                        "level": 17,
                        "value": "Wie Heilung I, nur werden 15W10 Treffer des Ziels geheilt"
                    },
                    {
                        "name": "Benommenheit heilen X",
                        "level": 19,
                        "value": "Wie Benommenheit heilen I, nur können 10 Runden angesammelte Benommenheit geheilt werden"
                    },
                    {
                        "name": "Heilung XX",
                        "level": 20,
                        "value": "Wie Heilung I, nur werden 20W10 Treffer des Ziels geheilt"
                    },
                    {
                        "name": "Wahrhaftige Heilung",
                        "level": 25,
                        "value": "Wie Heilung I, nur werden alle Treffer des Ziels geheilt"
                    },
                    {
                        "name": "Wahrhaftige Erfrierungen/Verbrennungen",
                        "level": 30,
                        "value": "Wie Erfrierungen/ Verbrennungen I, nur werden alle Verbrennungen oder Erfrierungen des Ziels geheilt"
                    },
                    {
                        "name": "Wahrhaftige Benommenheitsheilung",
                        "level": 50,
                        "value": "Wie Benommenheit heilen I, nur wird das Ziel von sämtlicher Benommenheit geheilt."
                    }
                ]
            },
            {
                "id": "19.2",
                "name": "10.6.3: Knochenmeisterschaft",
                "spells": [
                    {
                        "name": "Knochenkunde",
                        "level": 1,
                        "value": "Der Zauberer gewinnt ein vollständiges Bild der Knochenschäden sowie der Werkzeuge und Methoden, die zu ihrer Heilung nötig sind. Er erlangt aber nicht die Fertigkeiten oder die Macht, um die Heilung ausführen zu können"
                    },
                    {
                        "name": "Heilung einfacher Brüche",
                        "level": 2,
                        "value": "Erlaubt dem Zauberer, einen einzelnen, einfachen Bruch zu heilen (keine komplexen Brüche, Trümmerbrüche, Gelenkschäden usw.). Die Genesungszeit beträgt einen Tag. Der Spruch wirkt nicht bei Schädelbrüchen"
                    },
                    {
                        "name": "Knorpelheilung",
                        "level": 3,
                        "value": "Erlaubt dem Zauberer, die gesamte Knorpelmasse um ein Gelenk zu heilen. Die Genesungszeit beträgt einen Tag"
                    },
                    {
                        "name": "Heilung komplexer Brüche",
                        "level": 4,
                        "value": "Wie Heilung einfacher Brüche, nur kann der Zauberer auch komplexe Brüche heilen"
                    },
                    {
                        "name": "Gliedmaße erhalten",
                        "level": 5,
                        "value": "Erlaubt dem Zauberer, die Verwesung eines Körpergliedes aufzuhalten (selbst wenn es abgetrennt wurde). Hierzu muß auch der Gliedmaße erhalten-Spruch der Liste Muskelmeisterschaft zusätzlich auf die Gliedmaße gewirkt werden"
                    },
                    {
                        "name": "Schädelbruch heilen",
                        "level": 6,
                        "value": "Erlaubt dem Zauberer, einen einzelnen Schädelbruch (nicht jedoch einen Trümmer-Schädelbruch) zu heilen. Die Genesungszeit beträgt 1-10 Tage"
                    },
                    {
                        "name": "Gelenkheilung",
                        "level": 7,
                        "value": "Erlaubt dem Zauberer, ein einzelnes, gebrochenes (nicht aber zertrümmertes) Gelenk zu heilen. Die Genesungszeit beträgt 1W10 Tage"
                    },
                    {
                        "name": "Wahrhaftige Heilung einfacher Brüche",
                        "level": 8,
                        "value": "Wie Heilung einfacher Brüche, nur tritt die Genesung sofort ein"
                    },
                    {
                        "name": "Anfügen",
                        "level": 9,
                        "value": "Erlaubt dem Zauberer, ein abgetrenntes Körperglied wieder anzufügen. Damit die Gliedmaße wieder voll funktionstüchtig wird, müssen auch die anderen drei Anfügen-Sprüche des Wundheilers darauf gewirkt werden. Das Körperglied ist nach 10-100 Tagen wieder voll beweglich"
                    },
                    {
                        "name": "Wahrhaftige Knorpelheilung",
                        "level": 10,
                        "value": "Wie Knorpelheilung, nur tritt die Genesung sofort ein 11. Wahrhaftige Heilung komplexer Brüche"
                    },
                    {
                        "name": "Wahrhaftige Schädelbrucheilung",
                        "level": 12,
                        "value": "Wie Schädelbruch heilen, nur tritt die Genesung sofort ein 13. Knochentransplantation"
                    },
                    {
                        "name": "Trümmerbruchheilung",
                        "level": 14,
                        "value": "Erlaubt dem Zauberer, einen beliebigen gebrochenen oder zertrümmerten Knochen zu heilen (selbst einen Schädelbruch). Erfordert eine einstündige Operation. Die Genesungszeit beträgt 1-10 Tage"
                    },
                    {
                        "name": "Wahrhaftige Gelenkheilung",
                        "level": 15,
                        "value": "Wie Gelenkheilung, nur tritt die Genesung sofort ein"
                    },
                    {
                        "name": "Schnelle Knochentransplantation",
                        "level": 17,
                        "value": "Wie Knochentransplantation, nur beträgt die Genesungszeit 1-10 Stunden"
                    },
                    {
                        "name": "Schnelle Trümmerbruchheilung",
                        "level": 18,
                        "value": "Wie Trümmerbruchheilung, nur beträgt die Genesungszeit 1-10 Stunden"
                    },
                    {
                        "name": "Wahrhaftiges Anfügen",
                        "level": 20,
                        "value": "Wie Anfügen, nur muß der Zauberer auch die anderen drei Wahrhaftiges Anfügen-Sprüche wirken und das Körperglied ist bereits nach 10 Minuten wieder voll funktionstüchtig"
                    },
                    {
                        "name": "Knorpelregeneration",
                        "level": 25,
                        "value": "Der Zauberer kann einen beliebigen Knorpelbereich regenerieren lassen. Die Genesungszeit beträgt 1-10 Tage"
                    },
                    {
                        "name": "Knochenregeneration",
                        "level": 30,
                        "value": "Der Zauberer kann einen beliebigen Knochen regenerieren lassen. Die Genesungszeit beträgt 1-10 Tage"
                    },
                    {
                        "name": "Wahrhaftige Skelettregeneration",
                        "level": 50,
                        "value": "Der Zauberer kann einen beliebigen Teil eines Skeletts (oder auch das ganze Skelett) einschließlich der Knorpelmasse innerhalb von 1-10 Tagen regenerieren lassen (je nach der Schwere der Schädigung)."
                    }
                ]
            },
            {
                "id": "19.3",
                "name": "10.6.4: Muskelmeisterschaft",
                "spells": [
                    {
                        "name": "Verstauchung heilen",
                        "level": 1,
                        "value": "Der Zauberer kann eine Verstauchung heilen. Erfordert eine einstündige Operation"
                    },
                    {
                        "name": "Muskel-/Sehnenkunde",
                        "level": 2,
                        "value": "Der Zauberer kann sich ein vollständiges Bild aller Muskel- und Sehnenschäden machen und weiß, welche Werkzeuge und Methoden zu ihrer Heilung nötig sind. Er erlangt aber nicht die Fertigkeiten oder die Macht, um die Heilung ausführen zu können"
                    },
                    {
                        "name": "Muskeln heilen I",
                        "level": 3,
                        "value": "Gestattet es dem Zauberer, einen verletzten Muskel zu heilen. Es ist eine einminütige Operation erforderlich. Die Genesungszeit beträgt einen Tag pro Muskel"
                    },
                    {
                        "name": "Sehnen heilen I",
                        "level": 4,
                        "value": "Gestattet es dem Zauberer, eine verletzte Sehne zu heilen. Es ist eine einminütige Operation erforderlich. Die Genesungszeit beträgt einen Tag pro Sehne"
                    },
                    {
                        "name": "Gliedmaße erhalten",
                        "level": 5,
                        "value": "Erlaubt dem Zauberer, die Verwesung eines Körpergliedes aufzuhalten (selbst wenn es abgetrennt wurde). Hierzu muß auch der Gliedmaße erhalten-Spruch der Liste Knochenmeisterschaft zusätzlich auf die Gliedmaße gewirkt werden"
                    },
                    {
                        "name": "Muskeln heilen III",
                        "level": 6,
                        "value": "Wie Muskeln heilen I, nur kann der Zauberer 3 verletzte Muskeln heilen"
                    },
                    {
                        "name": "Sehnen heilen III",
                        "level": 7,
                        "value": "Wie Sehnen heilen I, nur kann der Zauberer 3 verletzte Sehnen heilen"
                    },
                    {
                        "name": "Wahrhaftiges Muskelheilung",
                        "level": 8,
                        "value": "Wie Muskeln heilen I, nur tritt die Genesung sofort ein"
                    },
                    {
                        "name": "Anfügen",
                        "level": 9,
                        "value": "Erlaubt dem Zauberer, ein abgetrenntes Körperglied wieder anzufügen. Damit die Gliedmaße wieder voll funktionstüchtig wird, müssen auch die anderen drei Anfügen-Sprüche des Wundheilers darauf gewirkt werden. Das Körperglied ist nach 10-100 Tagen wieder voll beweglich"
                    },
                    {
                        "name": "Wahrhaftige Sehnenheilung",
                        "level": 10,
                        "value": "Wie Sehnen heilen I, nur tritt die Genesung sofort ein"
                    },
                    {
                        "name": "Weichteilsystem heilen",
                        "level": 11,
                        "value": "Erlaubt dem Zauberer, alle verletzten Muskeln oder Sehnen im Körper des Ziels zu heilen. Dazu ist eine einstündige Operation nötig. Die Genesungszeit beträgt 1-10 Tage"
                    },
                    {
                        "name": "Muskeltransplantation",
                        "level": 12,
                        "value": "Erlaubt dem Zauberer, einen gesunden Muskel zu transplantieren. Dazu ist eine einstündige Operation erforderlich. Die Genesungszeit beträgt 1-10 Tage. Es besteht die Möglichkeit, daß der Körper des Ziels den neuen Muskel abstößt: die Wahrscheinlichkeit dafür liegt bei 10%, wenn der Muskel von einem Angehörigen des gleichen Volks stammt"
                    },
                    {
                        "name": "Muskelregeneration",
                        "level": 14,
                        "value": "Erlaubt dem Zauberer, einen Muskel regenerieren zu lassen. Je nachdem, wieviel Muskelmasse erhalten war, dauert es 1-10 Tage, bis der neue Muskel nachgewachsen ist"
                    },
                    {
                        "name": "Sehnenregeneration",
                        "level": 15,
                        "value": "Erlaubt dem Zauberer, eine Sehne regenerieren zu lassen. Je nachdem wieviel der Sehne erhalten war, dauert es 1-10 Tage, bis die neue Sehne nachgewachsen ist"
                    },
                    {
                        "name": "Schnelle Muskeltransplantation",
                        "level": 17,
                        "value": "Wie Muskeltransplantation, nur beträgt die Genesungszeit 1-10 Stunden"
                    },
                    {
                        "name": "Schnelle Muskelregeneration",
                        "level": 18,
                        "value": "Wie Muskelregeneration, nur beträgt die Genesungszeit 1-10 Stunden"
                    },
                    {
                        "name": "Schnelle Sehnenregeneration",
                        "level": 19,
                        "value": "Wie Sehnenregeneration, nur beträgt die Genesungszeit 1-10 Stunden"
                    },
                    {
                        "name": "Wahrhaftiges Anfügen",
                        "level": 20,
                        "value": "Wie Anfügen, nur muß der Zauberer auch die anderen drei Wahrhaftiges Anfügen-Sprüche wirken und das Körperglied ist bereits nach 10 Minuten wieder voll funktionstüchtig"
                    },
                    {
                        "name": "Wahrhaftige Muskelregeneration",
                        "level": 25,
                        "value": "Wie Muskelregeneration, nur dauert es 10 Minuten, bis der Muskel nachgewachsen ist"
                    },
                    {
                        "name": "Wahrhaftige Sehnenregeneration",
                        "level": 30,
                        "value": "Wie Sehnenregeneration, nur dauert es 10 Minuten, bis der Muskel nachgewachsen ist"
                    },
                    {
                        "name": "Wahrhaftige Weichteilsystemheilung",
                        "level": 50,
                        "value": "Wie Weichteilsystem heilen, nur werden alle Muskeln und Sehnen im Körper des Ziels geheilt (nicht ausgetauscht). Hierzu ist eine zehnminütige Operation erforderlich. Die Genesungszeit beträgt 1-10 Minuten."
                    }
                ]
            },
            {
                "id": "19.4",
                "name": "10.6.5: Nerven- und Organmeisterschaft",
                "spells": [
                    {
                        "name": "Nerven-/Organkunde",
                        "level": 1,
                        "value": "Verschafft dem Zauberer ein vollständiges Bild aller Nerven- und Organschäden und das Wissen, welche Werkzeuge und Methoden zu ihrer Heilung nötig sind. Er erlangt aber nicht die Fertigkeiten oder die Macht, um die Heilung ausführen zu können"
                    },
                    {
                        "name": "Betäuben",
                        "level": 2,
                        "value": "Erlaubt dem Zauberer, das Gefühl in einem bestimmten Körperteil (30cm³) zu verringern oder zu nehmen. Damit kann er (wenn auch mit leichten Nebenwirkungen) Schmerzen verringern (d.h. -10 auf alle Aktionen)"
                    },
                    {
                        "name": "Heilung leichter Nervenschäden",
                        "level": 3,
                        "value": "Heilt leichten Schaden an einem Nerv. Die Genesungszeit beträgt 1-10 Tage. Als ein leichter Nervenschaden gilt jeder Nervenschaden, der sich in einem Abzug von bis zu -20 äußert"
                    },
                    {
                        "name": "Heilung leichter Ohren-/Nasenschäden",
                        "level": 4,
                        "value": "Erlaubt dem Zauberer, jeden äußeren Ohrenschaden oder Nasenschaden (jeweils abgesehen von völligem Verlust) zu heilen. Je nach Schwere des Schadens dauert das 1-60 Minuten"
                    },
                    {
                        "name": "Organ erhalten",
                        "level": 5,
                        "value": "Erlaubt dem Zauberer, den Verfall eines bestimmten Organs (z.B. Auge, Ohr, Leber) aufzuhalten, selbst wenn es sich außerhalb des Körpers befindet"
                    },
                    {
                        "name": "Heilung leichter Augenschäden",
                        "level": 6,
                        "value": "Erlaubt es dem Zauberer, leichte Augenschäden zu heilen (z.B. eine Hornhautabschürfung oder einen Fremdkörper im Auge)"
                    },
                    {
                        "name": "Heilung schwerer Nervenschäden",
                        "level": 7,
                        "value": "Wie Heilung leichter Nervenschäden, aber jeglicher Nervenschaden wird geheilt. Mit diesem Spruch kann man jedoch keine Nerven heilen, die komplett zerstört wurden. Die Genesungszeit beträgt 1-10 Tage"
                    },
                    {
                        "name": "Heilung schwerer Ohrenschäden",
                        "level": 8,
                        "value": "Wie Heilung leichter Ohren-/ Nasenschäden, nur kann der Zauberer jede Verletzung des Innen- oder des Außenohres heilen. Das Gehör kehrt nach 1W10 Tagen zurück. Der komplette Austausch des Innenohres ist hier ausgenommen"
                    },
                    {
                        "name": "Anfügen",
                        "level": 9,
                        "value": "Erlaubt dem Zauberer, ein abgetrenntes Körperglied wieder anzufügen. Damit die Gliedmaße wieder voll funktionstüchtig wird, müssen auch die anderen drei Anfügen-Sprüche des Wundheilers darauf gewirkt werden. Das Körperglied ist nach 10-100 Tagen wieder voll beweglich"
                    },
                    {
                        "name": "Heilung schwerer Augenschäden",
                        "level": 10,
                        "value": "Wie Heilung leichter Augenschäden, nur kann der Zauberer beliebige Augenschäden bis auf den völligen Verlust eines Auges heilen (d.h. die Zerstörung eines Auges verunmöglicht erhaltende Maßnahmen). Die Genesungszeit beträgt 1-10 Tage"
                    },
                    {
                        "name": "Stasis I",
                        "level": 11,
                        "value": "Das Ziel wird in eine Stasis versetzt, die verhindert, daß er während der Spruchdauer stirbt (d.h. der Körper wird erhalten und die Seele verläßt den Körper nicht). Auch der andere Stasis I-Spruch (auf der Liste Blutmeisterschaft) muß mit diesem zusammen gewirkt werden"
                    },
                    {
                        "name": "Wahrhaftige Nervenheilung",
                        "level": 12,
                        "value": "Wie Heilung schwerer Nervenschäden, nur tritt die Genesung sofort ein"
                    },
                    {
                        "name": "Organtransplantation",
                        "level": 13,
                        "value": "Erlaubt dem Zauberer, ein gesundes Organ (nicht das Gehirn oder das Nervensystem) in das Ziel zu verpflanzen. Erfordert eine einstündige Operation. Die Genesungszeit beträgt 1-10 Tage. Es besteht die Möglichkeit, daß der Körper des Ziels das neue Organ abstößt: die Wahrscheinlichkeit dafür liegt bei 10%, wenn das Organ von einem Angehörigen des gleichen Volks stammt"
                    },
                    {
                        "name": "Organ heilen",
                        "level": 14,
                        "value": "Erlaubt dem Zauberer, ein beliebiges Organ (mit Ausnahme des Gehirns und des Nervensystems) zu heilen, das nicht völlig zerstört wurde. Erfordert eine 1-10-stündige Operation. Die Genesungszeit beträgt 1-10 Tage"
                    },
                    {
                        "name": "Heilung leichter Gehirnschäden",
                        "level": 15,
                        "value": "Erlaubt dem Zauberer, leichte Gehirnschäden zu heilen (auch die Folgen eines Komas). Verlorene Erfahrung wird nicht wiederhergestellt (wieviel Prozent dauerhaft verloren sind, hängt von der Schwere des Schadens ab). Erfordert eine einstündige Operation. Die Genesungszeit beträgt 1-10 Tagen"
                    },
                    {
                        "name": "Lähmung heilen",
                        "level": 16,
                        "value": "Erlaubt dem Zauberer, die Lähmung eines Ziels zu heilen (mit einer Genesungszeit von 1-10 Tagen). Die Lähmung muß durch einen Spruch oder durch eine Krankheit verursacht worden sein (nicht durch ein Gift)"
                    },
                    {
                        "name": "Stasis II",
                        "level": 17,
                        "value": "Wie Stasis I, bis auf die Dauer und darauf, daß der andere Stasis II-Spruch (auf der Liste Blutmeisterschaft) erforderlich ist"
                    },
                    {
                        "name": "Schnelle Organtransplantation",
                        "level": 18,
                        "value": "Wie Organtransplantation, nur beträgt die Genesungszeit nur 1-10 Stunden"
                    },
                    {
                        "name": "Wahrhaftiges Anfügen",
                        "level": 20,
                        "value": "Wie Anfügen, nur muß der Zauberer auch die anderen drei Wahrhaftiges Anfügen-Sprüche wirken und das Körperglied ist bereits nach 10 Minuten wieder voll funktionstüchtig"
                    },
                    {
                        "name": "Nervenregeneration",
                        "level": 25,
                        "value": "Erlaubt dem Zauberer, einen Nerv regenerieren zu lassen. Je nachdem, wieviel des Nervs erhalten war, dauert es 1-10 Tage, bis der neue nachgewachsen ist"
                    },
                    {
                        "name": "Organregeneration",
                        "level": 30,
                        "value": "Erlaubt dem Zauberer, ein verlorenes Organ vollständig regenerieren zu lassen. Die Regeneration dauert 1- 10 Stunden. Die Genesungszeit beträgt 1-10 Tage. Das Ziel liegt in einem Koma, während es sich erholt (dieser Spruch kann das Gehirn nicht regenerieren)"
                    },
                    {
                        "name": "Gehirnregeneration",
                        "level": 50,
                        "value": "Erlaubt es dem Zauberer, innerhalb von 1-10 Stunden verlorene Hirnmasse regenerieren zu lassen. Die Genesungszeit beträgt 1-10 Tage (das Ziel liegt in dieser Zeit im Koma). Beachten Sie, daß verlorene Erfahrung nicht wiedererlangt wird (wieviel Prozent dauerhaft verloren sind, kommt auf die Schwere des Schadens an)."
                    }
                ]
            },
            {
                "id": "19.5",
                "name": "10.6.6: Prothesen",
                "spells": [
                    {
                        "name": "Maß nehmen",
                        "level": 1,
                        "value": "Der Zauberer kennt die richtigen Maße, um für das Ziel eine falsche Gliedmaße anzufertigen"
                    },
                    {
                        "name": "Holz formen",
                        "level": 2,
                        "value": "Der Zauberer kann bis zu 60cm³ Holz so formen, als wäre es Ton, wenn er sich konzentriert. Er braucht normalerweise einen Tag (ungefähr 8 Stunden), um eine Holzgliedmaße zu formen. Wenn die Formzeit abgelaufen ist, nimmt das Holz wieder seine normale Festigkeit an"
                    },
                    {
                        "name": "Holz anfügen",
                        "level": 3,
                        "value": "Der Zauberer fügt eine (künstliche) Holzgliedmaße an den Körper des Ziels an. Der Vorgang dauert eine Stunde. Dieser Spruch muß gewirkt werden, bevor die falsche Gliedmaße belebt werden kann"
                    },
                    {
                        "name": "Beleben I",
                        "level": 4,
                        "value": "Läßt den Träger seine falsche Gliedmaße 8 Stunden lang nach Belieben bewegen"
                    },
                    {
                        "name": "Glas formen",
                        "level": 5,
                        "value": "Wie Holz formen, nur betrifft der Spruch Glas. Der Vorgang dauert zwei Tage (ungefähr 8 Stunden pro Tag)"
                    },
                    {
                        "name": "Glas anfügen",
                        "level": 6,
                        "value": "Wie Holz anfügen, nur kann der Zauberer ein Glaskörperteil anfügen"
                    },
                    {
                        "name": "Beleben II",
                        "level": 7,
                        "value": "Wie Beleben I, nur ist die Dauer 24 Stunden"
                    },
                    {
                        "name": "Normales Metall formen",
                        "level": 8,
                        "value": "Wie Holz formen, nur betrifft der Spruch einfache Metalle und der Vorgang dauert 4 Tage (ungefähr 8 Stunden pro Tag)"
                    },
                    {
                        "name": "Normales Metall anfügen",
                        "level": 9,
                        "value": "Wie Holz anfügen, nur kann der Zauberer Körperteil aus normalem Metall anfügen"
                    },
                    {
                        "name": "Künstliches Fleisch",
                        "level": 10,
                        "value": "Dieser Spruch verwandelt Ton in genug künstliches Fleisch, um eine künstliche Gliedmaße zu bedecken (die Gliedmaße muß dem Zauberer zur Verfügung stehen, wenn der Spruch gewirkt wird). Das Fleisch ist nur halbwegs realistisch (ähnlich wie Plastik). Der Vorgang dauert 2 Tage (ungefähr 8 Stunden pro Tag), kann aber bei größeren Gliedmaßen auch länger dauern (SL-Entscheidung)"
                    },
                    {
                        "name": "Beleben III",
                        "level": 11,
                        "value": "Wie Beleben I, nur ist die Dauer eine Woche"
                    },
                    {
                        "name": "Verzauberte Materialien anfügen",
                        "level": 13,
                        "value": "Wie Holz anfügen, nur kann der Zauberer eine Gliedmaße aus verzaubertem Material anfügen (die Gliedmaße selbst muß auf andere Weise hergestellt werden)"
                    },
                    {
                        "name": "Beleben IV",
                        "level": 15,
                        "value": "Wie Beleben I, nur ist die Dauer ein Monat"
                    },
                    {
                        "name": "Beleben V",
                        "level": 17,
                        "value": "Wie Beleben I, nur ist die Dauer 3 Monate"
                    },
                    {
                        "name": "Beleben VI",
                        "level": 19,
                        "value": "Wie Beleben I, nur ist die Dauer 6 Monate"
                    },
                    {
                        "name": "Wahrhaftiges Kunstfleisch",
                        "level": 20,
                        "value": "Wie Künstliches Fleisch, nur kann der Zauberer völlig realistisch wirkendes Fleisch erschaffen und verarbeiten. Der Vorgang dauert 10-100 Tage, je nachdem, wieviel Fleisch nötig ist"
                    },
                    {
                        "name": "Beleben VII",
                        "level": 25,
                        "value": "Wie Beleben I, nur ist die Dauer 1 Jahr"
                    },
                    {
                        "name": "Beleben VIII",
                        "level": 30,
                        "value": "Wie Beleben I, nur ist die Dauer 1 Jahr pro Stufe des Zauberers"
                    },
                    {
                        "name": "Wahrhaftiges Beleben",
                        "level": 50,
                        "value": "Wie Beleben I, nur ist die Dauer permanent."
                    }
                ]
            }
        ]
    },
    {
        "id": "20",
        "name": "Böser Mentalismus",
        "spellLists": [
            {
                "id": "20.0",
                "name": "10.7.1: Geist untergraben",
                "spells": [
                    {
                        "name": "Argwohn",
                        "level": 1,
                        "value": "Das Ziel mißtraut den Aktionen seiner Gefährten (der SL kann Beschreibungen liefern, die auch den Argwohn des Spielers wecken)"
                    },
                    {
                        "name": "Wesenszug zerrütten I",
                        "level": 2,
                        "value": "Einer der Wesenszüge des Ziels wird pervertiert (bis zu einem Übermaß gesteigert). Im Grundregelwerk finden Sie eine vollständige Besprechung der Charaktereigenschaften. Beachten Sie, daß der Charakter einen gemäßigten Wesenszug haben kann (z.B. weder geizig noch verschwenderisch), der dann übersteigert wird"
                    },
                    {
                        "name": "Lügen",
                        "level": 3,
                        "value": "Bei jeder Äußerung besteht eine Wahrscheinlichkeit von 20%, daß das Ziel lügt"
                    },
                    {
                        "name": "Wesenszug zerrütten II",
                        "level": 4,
                        "value": "Wie Wesenszug zerrütten I, nur können 2 Eigenschaften verdorben werden"
                    },
                    {
                        "name": "Betrügen",
                        "level": 5,
                        "value": "Das Ziel versucht, bei allem zu betrügen (bei der Verteilung der Beute, bei Kartenspielen usw.)"
                    },
                    {
                        "name": "Vandale",
                        "level": 6,
                        "value": "Das Ziel verspürt den Drang, leichte Sachschäden zu verursachen. Wenn eine solche Gelegenheit auftaucht, besteht eine 60%-Wahrscheinlichkeit, daß es etwas beschädigt"
                    },
                    {
                        "name": "Stehlen",
                        "level": 7,
                        "value": "Das Ziel wird zum Kleptomanen, und es besteht eine Wahrscheinlichkeit von 10%, daß es etwas stehlen muß, das ihm gefällt (solange das keine Gewalt erfordert)"
                    },
                    {
                        "name": "Wesenszug zerrütten III",
                        "level": 8,
                        "value": "Wie Wesenszug zerrütten I, nur können 3 Eigenschaften verdorben werden"
                    },
                    {
                        "name": "Pyromanie",
                        "level": 9,
                        "value": "Das Ziel ist fasziniert davon, Dinge zu verbrennen. An jedem Tag besteht eine 20%-Wahrscheinlichkeit, daß es versuchen muß, etwas anzuzünden. Es verbrennt etwas, dessen Brand nicht dazu führt, daß Leute oder Tiere verletzt werden (allerdings besteht eine Wahrscheinlichkeit von einem Prozent, daß es sich bei dem Versuch, etwas zu verbrennen, selbst verletzt)"
                    },
                    {
                        "name": "Schwerer Diebstahl",
                        "level": 10,
                        "value": "Wie Stehlen, aber das Ziel setzt Gewalt ein, um zu stehlen"
                    },
                    {
                        "name": "Wesenszug zerrütten V",
                        "level": 11,
                        "value": "Wie Wesenszug zerrütten I, nur können 5 Eigenschaften verdorben werden"
                    },
                    {
                        "name": "Zufällige Wesenzugszerrüttung I",
                        "level": 12,
                        "value": "Wie Wesenszug zerrütten I, nur ist an jedem Tag eine anderer Eigenschaft betroffen (während sich der vorige Wesenzug wieder normalisiert)"
                    },
                    {
                        "name": "Tätlichkeit",
                        "level": 13,
                        "value": "Es besteht eine Wahrscheinlichkeit von 5%, daß das Ziel gegen eine Person tätlich wird, wenn es ihr das erste Mal begegnet (das Ziel muß diese Person tatsächlich treffen"
                    },
                    {
                        "name": "Brandstiftung",
                        "level": 14,
                        "value": "Wie Pyromanie, nur ist es dem Ziel egal, ob Leute (oder Tiere) verletzt werden. Es besteht eine Wahrscheinlichkeit von 5%, daß es sich bei dem Versuch selbst verletzt"
                    },
                    {
                        "name": "Wesenszug zerrütten VII",
                        "level": 15,
                        "value": "Wie Wesenszug zerrütten I, nur können 7 Eigenschaften verdorben werden"
                    },
                    {
                        "name": "Zufällige Wesenzugszerrüttung II",
                        "level": 16,
                        "value": "Wie Wesenszug zerrütten I, nur sind zwei Wesenzüge gleichzeitig betroffen"
                    },
                    {
                        "name": "Verstümmeln",
                        "level": 17,
                        "value": "Wie Tätlichkeit, nur besteht eine Wahrscheinlichkeit von 10%, daß das Ziel versucht, die Person zu verstümmeln"
                    },
                    {
                        "name": "Wesenszug zerrütten X",
                        "level": 18,
                        "value": "Wie Wesenszug zerrütten I, nur können 10 Eigenschaften verdorben werden"
                    },
                    {
                        "name": "Zufällige Wesenzugszerrüttung III",
                        "level": 19,
                        "value": "Wie Wesenszug zerrütten I, nur sind drei Wesenzüge gleichzeitig betroffen"
                    },
                    {
                        "name": "Todschlag",
                        "level": 20,
                        "value": "Wie Tätlichkeit, nur versucht das Ziel, die Person zu töten"
                    },
                    {
                        "name": "Attentat",
                        "level": 25,
                        "value": "Wie Tätlichkeit, nur merkt sich das Ziel die Person und plant, sie umzubringen. Der Spruch hält an, bis das Ziel einen Mordversuch auf die Person verübt hat"
                    },
                    {
                        "name": "Wahrhaftige Wesenszugzerrüttung",
                        "level": 30,
                        "value": "Wie Wesenszug zerrütten I, nur ist die Wirkung permanent"
                    },
                    {
                        "name": "Selbstmord",
                        "level": 50,
                        "value": "Wie Argwohn, nur wird das Ziel immer, wenn es verletzt wurde, erniedrigt wurde oder in etwas versagt, versuchen, sich auf findige Weise umzubringen."
                    }
                ]
            },
            {
                "id": "20.1",
                "name": "10.7.2: Geistesbeherrschung",
                "spells": [
                    {
                        "name": "Geistige Ablenkung",
                        "level": 1,
                        "value": "Das Ziel wird von einem Objekt abgelenkt, das es sich einbildet. Während der Spruchdauer ist das Ziel in jeder Runde auf 70% seiner Aktivität beschränkt"
                    },
                    {
                        "name": "Gedankenkampf",
                        "level": 2,
                        "value": "Der Zauberer und das Ziel sind in geistiger Verbindung gefangen, bis: der Zauberer den Spruch aufhebt oder der Spruch gebannt wird oder entweder der Zauberer oder das Ziel seinen WW um mehr als 30 verfehlt (beide müssen in jeder Runde einen WW ablegen). Während der Spruch aktiv ist, kann weder das Ziel noch der Zauberer irgendeine Aktion ausführen"
                    },
                    {
                        "name": "Geistiges Eindringen",
                        "level": 3,
                        "value": "Wie Gedankenkampf, nur ist das Ziel in geistigem Kampf mit dem Zauberer gefangen. Das Ziel kann nicht handeln, aber dem Zauberer bleiben 50% seiner normalen Aktivität"
                    },
                    {
                        "name": "Dämonische Besessenheit I",
                        "level": 5,
                        "value": "Das Ziel ist von einem Dämonen der Klasse I (Stufe 1-2, siehe Abschnitt 5.22, Seite 42) besessen. Einmal am Tag darf das Ziel einen WW ablegen (die Angriffsstufe entspricht der Stufe des Dämonen), um die Kontrolle zurückzuerlangen. Der Dämon ist blindwütig, wahnsinnig und gemeingefährlich"
                    },
                    {
                        "name": "Seelentausch",
                        "level": 6,
                        "value": "Die Seele des Ziels und die des Zauberers werden ausgewechselt. Der Zauberer kann im Körper des Ziels mit 50% der normalen Aktionsfähigkeit handeln. Das Ziel bleibt im Körper des Zauberers inaktiv. Der Zauberer kann den Spruch jederzeit aufheben (dauert 1 Runde), das Ziel kann den Spruch nur aufheben, wenn ihm ein WW gelingt (es erhält alle 10 Minuten einen). Wenn einer der Körper stirbt, werden beide Seelen zerstört"
                    },
                    {
                        "name": "Beherrschung",
                        "level": 8,
                        "value": "Das Ziel muß dem Zauberer gehorchen. Wenn ihm der Zauberer einen Befehl erteilt, etwas zu tun, das seiner Natur völlig widerstrebt, steht ihm ein weiterer WW mit einem besonderen Bonus von +25 zu"
                    },
                    {
                        "name": "Dämonische Besessenheit II",
                        "level": 10,
                        "value": "Wie Dämonische Besessenheit I, nur ist es ein Dämon der Klasse II"
                    },
                    {
                        "name": "Gedankensklave",
                        "level": 11,
                        "value": "Wie Beherrschung, nur ist das Ziel ein Zombie, bis ihm einer seiner täglichen Widerstandswürfe gelingt. In jeder Runde, in der sich der Zauberer konzentriert, muß das Ziel ihm gehorchen"
                    },
                    {
                        "name": "Verbannung",
                        "level": 13,
                        "value": "Wie Gedankensklave, nur ist der Verstand / die Essenz / die Seele des Ziels in Agonie und das Ziel wird in jeder Runde, in der sich der Zauberer nicht konzentriert, jedermanns mündlichem Befehl gehorchen. Widerstreitende Befehle bewirken, daß das Ziel nichts tut"
                    },
                    {
                        "name": "Dämonische Besessenheit III",
                        "level": 15,
                        "value": "Wie Dämonische Besessenheit I, nur ist es ein Dämon der Klasse III"
                    },
                    {
                        "name": "Verzögerte Beherrschung",
                        "level": 16,
                        "value": "Wie Beherrschung, nur muß das Ziel eine einzelne Aufgabe ausführen. Der Auftrag kann das Ziel aus der Reichweite des Zauberers herausführen, und es muß dennoch versuchen, ihn zu erfüllen"
                    },
                    {
                        "name": "Wahrhaftige verzögerte Beherrschung",
                        "level": 18,
                        "value": "Wie Verzögerte Beherrschung, nur erhält das Ziel nur einen WW pro Woche"
                    },
                    {
                        "name": "Dämonische Besessenheit IV",
                        "level": 19,
                        "value": "Wie Dämonische Besessenheit I, nur ist es ein Dämon der Klasse IV"
                    },
                    {
                        "name": "Wahrhaftiger Gedankensklave",
                        "level": 20,
                        "value": "Wie Gedankensklave, nur muß sich der Zauberer nicht konzentrieren, um das Ziel zu befehligen"
                    },
                    {
                        "name": "Dämonische Besessenheit V",
                        "level": 25,
                        "value": "Wie Dämonische Besessenheit I, nur ist es ein Dämon der Klasse V"
                    },
                    {
                        "name": "Wahrhaftiger Seelentausch",
                        "level": 30,
                        "value": "Wie Seelentausch, nur erhält das Ziel seinen zusätzlichen WW nur einmal im Monat, und seine Chance zu widerstehen sinkt jedesmal um 1 Prozent, wenn sein WW fehlschlägt (und die Aktionsfähigkeit des Zauberers im Körper des Ziels steigt jeweils um 1%)"
                    },
                    {
                        "name": "Wahrhaftige Verbannung",
                        "level": 50,
                        "value": "Wie Verbannung, nur erhält das Ziel nur einmal im Monat seinen WW, und seine Chance zu widerstehen sinkt jedesmal um 1 Prozent, wenn sein WW fehlschlägt."
                    }
                ]
            },
            {
                "id": "20.2",
                "name": "10.7.3: Geisteskrankheit",
                "spells": [
                    {
                        "name": "Insomnie",
                        "level": 1,
                        "value": "Das Ziel hat Schwierigkeiten einzuschlafen. Es hat danach zwei Tage lang einen Malus von -25 auf alle Aktionen (bis es geheilt wird)"
                    },
                    {
                        "name": "Neurose",
                        "level": 2,
                        "value": "Das Ziel hat eine Abneigung gegen etwas bestimmtes, was der Zauberer wählt. Wenn es in die Nähe dieses Objekts kommt, hat es eine 50%-Chance (modifiziert durch den dreifachen Selbstdisziplinbonus), die Kontrolle zu behalten. Wenn dem Ziel das nicht gelingt, können Sie mit einem W100 bestimmen, wie es sich verhalten muß. Bei einem Ergebnis von 1 greift das Ziel es blindwütig an (und versucht, es um jeden Preis zu vernichten). Bei einem Wurfergebnis von 2-11 flieht das Ziel (und bewegt sich dabei mit maximaler Geschwindigkeit von dem Objekt weg). Bei einem Ergebnis von 12 und mehr versucht das Ziel, das Objekt um jeden Preis zu meiden"
                    },
                    {
                        "name": "Schuld",
                        "level": 3,
                        "value": "Das Ziel fühlt sich für eine Tat in seiner Vergangenheit schuldig. Der SL sollte ein einschlägiges Ereignis aus der Vergangenheit des Ziels aussuchen. Es wird nie wieder ähnlich handeln und unternimmt Schritte, sein Schuldgefühl zu lindern (und das begangene Übel wieder gut zu machen)"
                    },
                    {
                        "name": "Paranoia",
                        "level": 4,
                        "value": "Das Ziel glaubt, daß alle außer seinen engsten Vertrauten hinter ihm her sind"
                    },
                    {
                        "name": "Panik",
                        "level": 5,
                        "value": "Wie Insomnie, nur bricht das Ziel in jeder Situation, in der es persönlich in Gefahr ist, in Panik aus und flieht"
                    },
                    {
                        "name": "Phobie",
                        "level": 6,
                        "value": "Das Ziel hat vor etwas Angst, das der Zauberer wählt. Wenn es in die Nähe dieses Objekts kommt, hat es eine 25%-Chance (modifiziert durch das Dreifache des Selbstdisziplinbonus), die Kontrolle zu behalten. Wenn dem Ziel das nicht gelingt, können Sie mit einem (nicht offenen) W100 bestimmen, wie es sich dem Objekt gegenüber verhalten muß. Bei einem Ergebnis von 01-25 flieht es vor dem Objekt (und bewegt sich dabei mit maximaler Geschwindigkeit von ihm weg). Bei einem Ergebnis von 26 und mehr versucht das Ziel, das Objekt um jeden Preis zu meiden"
                    },
                    {
                        "name": "Halluzinieren",
                        "level": 7,
                        "value": "Das Ziel neigt dazu, zu halluzinieren und Dinge anders zu sehen, als sie wirklich sind. Bei jedem größeren Ereignis an einem Tag besteht eine Wahrscheinlichkeit von 10%, daß es halluziniert und große Bedrohungen für kleine hält und kleine Dinge für große Gefahren (ähnlich dem Syndrom, unter dem Don Quixote litt)"
                    },
                    {
                        "name": "Schizophrenie",
                        "level": 8,
                        "value": "Der Zauberer bildet eine zweite Persönlichkeit mit einer anderen „Gesinnung“ aus. An jedem Tag besteht eine Wahrscheinlichkeit von 10%, daß die zweite Persönlichkeit zutage tritt (zu einer zufälligen Tageszeit). Der Zauberer sollte zufällig 1W10 Charakterzüge auswählen, die sich aber deutlich von denen des Ziels unterscheiden müssen"
                    },
                    {
                        "name": "Psychose",
                        "level": 9,
                        "value": "Das Ziel hat eine Psychose, die mit einer bestimmten Art von Objekten zusammenhängt, die der Zauberer bestimmt. Wenn es in die Nähe eines solchen Objekts kommt, hat es eine 25%- Chance (modifiziert durch das Dreifache des Selbstdisziplinbonus), die Kontrolle zu behalten. Wenn dem Ziel das nicht gelingt, können Sie mit einem W100 bestimmen, wie es sich dem Objekt gegenüber verhalten muß. Bei einem Ergebnis von 1-5 greift das Ziel es blindwütig an (und versucht, es um jeden Preis zu vernichten). Bei einem Wurfergebnis von 6-55 flieht das Ziel (und bewegt sich dabei mit maximaler Geschwindigkeit von dem Objekt weg). Bei einem Ergebnis von 56 und mehr versucht das Ziel, das Objekt um jeden Preis zu meiden"
                    },
                    {
                        "name": "Katatonie",
                        "level": 10,
                        "value": "Das Ziel sinkt in einen katatonischen Zustand. In jeder Stunde besteht eine Wahrscheinlichkeit von 25%, daß es eine Stunde lang katatonisch wird"
                    },
                    {
                        "name": "Wahrhaftige Insomnie",
                        "level": 11,
                        "value": "Wie Insomnie, aber das Ziel kann nur schlafen, wenn es unter Drogen oder Spruchwirkungen (etwa einem Schlafzauber) steht. Es addiert +100 zu allen WW gegen Schlafsprüche. Wenn es keinen Schlaf bekommt, wird es allmählich wahnsinnig (was genau geschieht, liegt beim SL)"
                    },
                    {
                        "name": "Wahrhaftige Neurose",
                        "level": 12,
                        "value": "Das Ziel hat eine extreme Abneigung gegen etwas bestimmtes, was der Zauberer wählt. Wenn es in die Nähe dieses Objekts kommt, hat es eine 25%-Chance (modifiziert durch das Dreifache des Selbstdisziplinbonus), die Kontrolle zu behalten. Wenn dem Ziel das nicht gelingt, können Sie mit einem (nicht offenen) W100 bestimmen, wie es sich dem Objekt gegenüber verhalten muß. Bei einem Ergebnis von 1-10 greift das Ziel es blindwütig an (und versucht es um jeden Preis zu vernichten). Bei einem Wurfergebnis von 11-60 flieht das Ziel (und bewegt sich dabei mit maximaler Geschwindigkeit von dem Objekt weg). Bei einem Ergebnis von 61 und mehr versucht das Ziel, das Objekt um jeden Preis zu meiden"
                    },
                    {
                        "name": "Wahrhaftige Schuld",
                        "level": 13,
                        "value": "Wie Schuld, nur muß das Ziel an jedem Tag, an dem sein WW mißlingt, mit entsprechenden Handlungen für seine Schuld büßen (oder es sinkt in eine tiefe Depression)"
                    },
                    {
                        "name": "Starke Paranoia",
                        "level": 15,
                        "value": "Wie Paranoia, nur glaubt das Ziel, daß alle hinter ihm her sind (auch seine engen Vertrauten)"
                    },
                    {
                        "name": "Wahrhaftige Paranoia",
                        "level": 17,
                        "value": "Wie Paranoia, nur pflegt das Ziel mit niemandem länger als eine Stunde pro Tag Umgang"
                    },
                    {
                        "name": "Wahrhaftiges Halluzinieren",
                        "level": 18,
                        "value": "Wie Halluzinieren, nur ist die Wahrscheinlichkeit 20%"
                    },
                    {
                        "name": "Wahrhaftige Psychose",
                        "level": 19,
                        "value": "Das Ziel hat eine Psychose, die mit einer bestimmten Art von Objekten zusammenhängt, die der Zauberer bestimmt. Wenn es in die Nähe eines solchen Objekts kommt, hat es eine 0%-Chance (modifiziert durch das Dreifache des Selbstdisziplinbonus), die Kontrolle zu behalten. Wenn dem Ziel das nicht gelingt, können Sie mit einem W100 bestimmen, wie es sich dem Objekt gegenüber verhalten muß. Bei einem Ergebnis von 1-20 greift das Ziel es blindwütig an (und versucht, es um jeden Preis zu vernichten). Bei einem Wurfergebnis von 21 und mehr flieht das Ziel (und bewegt sich dabei mit maximaler Geschwindigkeit von dem Objekt weg)"
                    },
                    {
                        "name": "Wahrhaftige Schizophrenie",
                        "level": 20,
                        "value": "Wie Schizophrenie, nur ist die zweite Persönlichkeit 50% der Zeit aktiv"
                    },
                    {
                        "name": "Multiple Persönlichkeitstörung",
                        "level": 25,
                        "value": "Wie Schizophrenie, nur bildet das Ziel 1W10+1 zusätzliche Persönlichkeiten aus. Pro Tag besteht eine Wahrscheinlichkeit von 10%, daß eine bisher inaktive Persönlichkeit aktiv wird"
                    },
                    {
                        "name": "Wahrhaftige Katatonie",
                        "level": 30,
                        "value": "Wie Katatonie, nur besteht eine Wahrscheinlichkeit von 95% pro Stunde, daß das Ziel in einen katatonischen Zustand fällt"
                    },
                    {
                        "name": "Wahrhaftige Geisteskrankheit",
                        "level": 50,
                        "value": "Der Zauberer kann das Ziel an einer beliebigen Geisteskrankheit erkranken lassen."
                    }
                ]
            },
            {
                "id": "20.3",
                "name": "10.7.4: Geistige Illusionen",
                "spells": [
                    {
                        "name": "Wirrer Text",
                        "level": 1,
                        "value": "Jeder Text, den das Ziel liest, erscheint ihm wirr (und nicht zu entziffern)"
                    },
                    {
                        "name": "Hypochondrie",
                        "level": 2,
                        "value": "Das Ziel glaubt, daß es sehr krank ist (oder kränker als es tatsächlich ist). Der SL sollte die Schwere der eingebildeten Krankheit danach ausrichten, um wieviel der WW fehlschlug (d.h. wenn der WW um mehr als 50 fehlschlug, könnte das Ziel glauben, es wäre todkrank)"
                    },
                    {
                        "name": "Falscher Sinn I",
                        "level": 3,
                        "value": "Das Ziel nimmt etwas durch einen seiner Sinne falsch war. Es könnte beispielsweise aus dem Augenwinkel etwas sehen oder etwas hören, was nicht da ist. Die Sinnestäuschung kann nicht länger als eine Runde anhalten"
                    },
                    {
                        "name": "Irreführung I",
                        "level": 4,
                        "value": "Die Wahrnehmung des Ziels ist für die Spruchdauer verzerrt. Es erhält einen Malus von -10 auf alle Manöver für Fertigkeiten der Gruppe Wahrnehmung • Suchen (auch auf Orientierungswürfe)"
                    },
                    {
                        "name": "Niederes Phantom",
                        "level": 5,
                        "value": "Das Ziel wird von einer Schattenkreatur angegriffen. Das Wesen ist in Wirklichkeit eine geistige Illusion, die nur das Ziel sehen kann. Die Kreatur greift das Ziel sofort an (im Nahkampf ). Sie hat eine RK von 1, aber den gleichen DB, OB und die gleichen Trefferpunkte wie das Ziel (verwenden Sie den höchsten Nahkampfbonus des Ziels als OB der Kreatur). Wenn das Ziel Sprüche auf sich wirkt (z.B. Blitzschnell), verhält sich das Phantom, als läge der gleiche Spruch auf ihm. Das Wesen ist immun gegen Spruchangriffe. Wenn die Kreatur umgebracht wird (indem man sie tötet oder außer Gefecht setzt), ist der Spruch aufgehoben"
                    },
                    {
                        "name": "Wachtraum I",
                        "level": 6,
                        "value": "Das Ziel sieht Dinge so, als wäre er in einem Traum. Seine Reaktionen sind verlangsamt (es hat einen Malus von -10 auf alle Aktionen). Zusätzlich nimmt es manchmal Dinge anders wahr, als sie wirklich sind. Bei jedem Ereignis sollte der SL erwürfeln, ob es falsch aufgefaßt wird (10% Wahrscheinlichkeit). Beispielsweise könnte das Ziel in einem näherkommenden Pferd ein wildes Tier sehen oder einen anstürmenden Ork für einen Boten mit Neuigkeiten halten. Beachten Sie, daß der Zauberer keine Kontrolle darüber hat, was und wie das Ziel wahrnimmt"
                    },
                    {
                        "name": "Personenverwechslung I",
                        "level": 7,
                        "value": "Das Ziel glaubt, daß die nächste Person, die es sieht, jemand anderes ist. Wenn er den Spruch wirkt, legt der Zauberer fest, was für eine Art Person das Ziel sieht. Beispielsweise könnte es statt der herumschleichenden Gestalt einen Diener sehen, der durch das Palasttor hereinkommt. Wenn die nächste Person das Ziel angreift, wird die Spruchwirkung aufgehoben"
                    },
                    {
                        "name": "Irreführung III",
                        "level": 8,
                        "value": "Wie Irreführung I, nur ist der Abzug -30"
                    },
                    {
                        "name": "Falscher Sinn II",
                        "level": 9,
                        "value": "Wie Falscher Sinn I, nur sind bis zu 2 Sinne betroffen und die Wirkung kann bis zu 2 Runden andauern"
                    },
                    {
                        "name": "Geringeres Phantom",
                        "level": 10,
                        "value": "Wie Niederes Phantom, nur hat die Kreatur eine RK von 3"
                    },
                    {
                        "name": "Wachtraum II",
                        "level": 11,
                        "value": "Wie Wachtraum I, nur erleidet das Ziel einen Abzug von -20 auf alle Aktionen und nimmt mit einer Wahrscheinlichkeit von 20% Dinge falsch wahr"
                    },
                    {
                        "name": "Irreführung V",
                        "level": 12,
                        "value": "Wie Irreführung I, nur ist der Abzug -50"
                    },
                    {
                        "name": "Falscher Sinn III",
                        "level": 13,
                        "value": "Wie Falscher Sinn I, nur sind bis zu 3 Sinne betroffen, und die Wirkung kann bis zu 3 Runden andauern"
                    },
                    {
                        "name": "Personenverwechslung II",
                        "level": 14,
                        "value": "Wie Personenverwechslung I, nur hält das Ziel die nächste Person, die es sieht, für jemanden bestimmten. Zum Beispiel könnte es den Bettler, der den Thronsaal betritt, für den Kämmerer halten"
                    },
                    {
                        "name": "Mächtiges Phantom",
                        "level": 15,
                        "value": "Wie Niederes Phantom, nur hat die Kreatur eine RK von 11"
                    },
                    {
                        "name": "Falscher Sinn IV",
                        "level": 16,
                        "value": "Wie Falscher Sinn I, nur sind bis zu 4 Sinne betroffen, und die Wirkung kann bis zu 4 Runden andauern"
                    },
                    {
                        "name": "Irreführung VII",
                        "level": 17,
                        "value": "Wie Irreführung I, nur ist der Abzug -70"
                    },
                    {
                        "name": "Wachtraum III",
                        "level": 18,
                        "value": "Wie Wachtraum I, nur erleidet das Ziel einen Abzug von -30 auf alle Aktionen und nimmt mit einer Wahrscheinlichkeit von 30% Dinge falsch wahr"
                    },
                    {
                        "name": "Falscher Sinn V",
                        "level": 19,
                        "value": "Wie Falscher Sinn I, nur sind bis zu 5 Sinne betroffen, und die Wirkung kann bis zu 5 Runden andauern"
                    },
                    {
                        "name": "Wahrhaftiges Phantom",
                        "level": 20,
                        "value": "Wie Niederes Phantom, nur hat die Kreatur eine RK von 12"
                    },
                    {
                        "name": "Wahrhaftige Irreführung",
                        "level": 25,
                        "value": "Wie Irreführung I, nur ist der Abzug -100"
                    },
                    {
                        "name": "Wahrhaftige Personenverwechslung",
                        "level": 30,
                        "value": "Wie Personenverwechslung I, nur wird das Ziel die nächste Person, die es sieht, dauerhaft mit jemandem anderen verwechseln. Jedesmal, wenn es diese Person sieht, wird es ihn mit einer Wahrscheinlichkeit von 50% für einen anderen halten"
                    },
                    {
                        "name": "Wahrhaftiger Wachtraum",
                        "level": 50,
                        "value": "Wie Wachtraum III, bis auf die Dauer und darauf, daß das Ziel einen Malus von -40 auf alle Aktionen erleidet und mit 40% Wahrscheinlichkeit Dinge falsch wahrnimmt."
                    }
                ]
            },
            {
                "id": "20.4",
                "name": "10.7.5: Geistiger Tod",
                "spells": [
                    {
                        "name": "Geistige Sperre I",
                        "level": 1,
                        "value": "Die Erinnerung des Ziels an eine Zeitspanne von 20 Minuten wird gelöscht. Nach einer Zeitspanne von bis zu einer Stunde (vom Zauberer festgelegt, wenn er den Spruch wirkt), erinnert sich das Ziel wieder an alles, was während dieser 20 Minuten geschah"
                    },
                    {
                        "name": "Vergessen I",
                        "level": 2,
                        "value": "Das Ziel vergißt 10 zusammenhängende Minuten, die der Zauberer auswählt, völlig"
                    },
                    {
                        "name": "Geistige Leere I",
                        "level": 3,
                        "value": "Der Geist des Ziels ist kurzzeitig völlig leer und es kann nichts tun. Das Ziel wird sich an nichts erinnern, was während dieser Zeit geschieht. Sein Körper verharrt (alle willentlichen Aktionen hören auf )"
                    },
                    {
                        "name": "Vergessen X",
                        "level": 5,
                        "value": "Wie Vergessen I, nur können 100 Minuten gelöscht werden"
                    },
                    {
                        "name": "Geistige Sperre II",
                        "level": 6,
                        "value": "Wie Geistige Lerre I, nur kann bis zu eine Stunde an Erinnerungen um bis zu 24 Stunden verzögert werden"
                    },
                    {
                        "name": "Geistige Leere III",
                        "level": 7,
                        "value": "Wie Geistige Leere I, nur mit einer Spruchdauer von drei Runden"
                    },
                    {
                        "name": "Meister-Vergessen",
                        "level": 9,
                        "value": "Wie Vergessen I, nur können bis zu 200 Minuten gelöscht werden"
                    },
                    {
                        "name": "Geistiger Tod I",
                        "level": 10,
                        "value": "Der Geist des Ziels ist wie in Geistige Leere für je 10 zusammenhängende Minuten an jedem einzelnen Tag völlig leer"
                    },
                    {
                        "name": "Erfahrungsverlust I",
                        "level": 11,
                        "value": "Das Ziel verliert 5% seiner gesammelten Erfahrung (normalerweise Erfahrungspunkte)"
                    },
                    {
                        "name": "Wahrhaftige geistige Sperre",
                        "level": 12,
                        "value": "Wie Geistige Sperre I, nur können eine Stunde pro Stufe an Erfahrungen um bis zu einen Tag pro Stufe aufgeschoben werden"
                    },
                    {
                        "name": "Geistige Leere V",
                        "level": 13,
                        "value": "Wie Geistige Sperre I, nur mit einer Spruchdauer von 5 Runden"
                    },
                    {
                        "name": "Wahrhaftiges Vergessen",
                        "level": 14,
                        "value": "Wie Vergessen I, nur kann eine Stunde pro Stufe gelöscht werden"
                    },
                    {
                        "name": "Geistiger Tod II",
                        "level": 15,
                        "value": "Wie Geistiger Tod I, nur tritt die Leere zweimal pro Tag ein"
                    },
                    {
                        "name": "Geistiger Tod III",
                        "level": 17,
                        "value": "Wie Geistiger Tod I, nur tritt die Leere dreimal pro Tag ein"
                    },
                    {
                        "name": "Geistige Leere X",
                        "level": 18,
                        "value": "Wie Geistige Leere I, nur mit einer Spruchdauer von 10 Runden"
                    },
                    {
                        "name": "Erfahrungsverlust II",
                        "level": 19,
                        "value": "Wie Erfahrungsverlust I, nur sind 10 Prozent verloren"
                    },
                    {
                        "name": "Geistiger Tod V",
                        "level": 20,
                        "value": "Wie Geistiger Tod I, nur tritt die Leere fünfmal pro Tag ein"
                    },
                    {
                        "name": "Erfahrungsverlust III",
                        "level": 25,
                        "value": "Wie Erfahrungsverlust I, nur sind 15 Prozent verloren"
                    },
                    {
                        "name": "Geistiger Tod X",
                        "level": 30,
                        "value": "Wie Geistiger Tod I, nur tritt die Leere zehnmal pro Tag ein"
                    },
                    {
                        "name": "Wahrhaftige Geistesleere",
                        "level": 50,
                        "value": "Wie Geistige Leere I, nur besteht in jeder Runde eine Wahrscheinlichkeit von 5%, daß die Leere eintritt."
                    }
                ]
            },
            {
                "id": "20.5",
                "name": "10.7.6: Geistzersetzung",
                "spells": [
                    {
                        "name": "Geist trüben I",
                        "level": 1,
                        "value": "Eines der geistigen Attribute des Ziels (zufallsbestimmt) wird zeitweilig um 1W10 gesenkt. Nur das temporäre Attribut wird gesenkt, nicht das Potential. Die geistigen Attribute sind: Charisma, Empathie, Intuition, Gedächtnis, Logik und Selbstdisziplin. Wenn die Spruchdauer abgelaufen ist, steigt das Attribut wieder um den gleichen Wert an, um den es verringert wurde (bis zum vollen Potential des Attributs)"
                    },
                    {
                        "name": "Benommen",
                        "level": 2,
                        "value": "Das Ziel ist geistig verwirrt. Pro Runde hat er nur eine 50% Chance, eine Entscheidung zu treffen. Er wird sich aber immer gegen eine direkten Angriff verteidigen"
                    },
                    {
                        "name": "Machtleck I",
                        "level": 3,
                        "value": "Das Ziel verliert sofort 10% seiner verbleibenden Magiepunkte (MP). Sie können normal zurückgewonnen werden (d.h. normalerweise nach einer Schlafphase)"
                    },
                    {
                        "name": "Geist trüben II",
                        "level": 4,
                        "value": "Wie Geist trüben I, nur schwinden 2W10 Attributspunkte"
                    },
                    {
                        "name": "Geistzersetzung I",
                        "level": 5,
                        "value": "Wie Geist trüben I, nur betrifft der Schwund das Potential und das zugehörige temporäre Attribut"
                    },
                    {
                        "name": "Machtleck II",
                        "level": 6,
                        "value": "Wie Machtleck I, nur schwinden 20% der MP"
                    },
                    {
                        "name": "Geist trüben III",
                        "level": 7,
                        "value": "Wie Geist trüben I, nur schwinden 3W10 Attributspunkte"
                    },
                    {
                        "name": "Machtleck III",
                        "level": 8,
                        "value": "Wie Machtleck I, nur schwinden 30% der MP"
                    },
                    {
                        "name": "Geist trüben IV",
                        "level": 9,
                        "value": "Wie Geist trüben I, nur schwinden 4W10 Attributspunkte"
                    },
                    {
                        "name": "Geistzersetzung II",
                        "level": 10,
                        "value": "Wie Geistzersetzung I, nur schwinden 2W10 Attributspunkte"
                    },
                    {
                        "name": "Machtleck IV",
                        "level": 11,
                        "value": "Wie Machtleck I, nur schwinden 40% der MP"
                    },
                    {
                        "name": "Geist trüben V",
                        "level": 12,
                        "value": "Wie , nur schwinden 5W10 Attributspunkte"
                    },
                    {
                        "name": "Machtleck V",
                        "level": 13,
                        "value": "Wie Machtleck I, nur schwinden 50% der MP"
                    },
                    {
                        "name": "Geist trüben VI",
                        "level": 14,
                        "value": "Wie Geist trüben I, nur schwinden 6W10 Attributspunkte"
                    },
                    {
                        "name": "Geistzersetzung III",
                        "level": 15,
                        "value": "Wie Geistzersetzung I, nur schwinden 3W10 Attributspunkte"
                    },
                    {
                        "name": "Machtleck VI",
                        "level": 16,
                        "value": "Wie Machtleck I, nur schwinden 60% der MP"
                    },
                    {
                        "name": "Geistzersetzung IV",
                        "level": 18,
                        "value": "Wie Geistzersetzung I, nur schwinden 4W10 Attributspunkte"
                    },
                    {
                        "name": "Machtleck VII",
                        "level": 19,
                        "value": "Wie Machtleck I, nur schwinden 70% der MP"
                    },
                    {
                        "name": "Geist trüben VIII",
                        "level": 20,
                        "value": "Wie Geist trüben I, nur schwinden 8W10 Attributspunkte"
                    },
                    {
                        "name": "Geist trüben X",
                        "level": 25,
                        "value": "Wie Geist trüben I, nur schwinden 10W10 Attributspunkte"
                    },
                    {
                        "name": "Geistzersetzung V",
                        "level": 30,
                        "value": "Wie Geistzersetzung I, nur schwinden 5W10 Attributspunkte"
                    },
                    {
                        "name": "Wahrhaftige Geistzersetzung",
                        "level": 50,
                        "value": "Wie Geistzersetzung I, nur wird ein geistiges Attribut auf 1 gesenkt."
                    }
                ]
            }
        ]
    },
    {
        "id": "21",
        "name": "Duale Basisliste Heiler",
        "spellLists": [
            {
                "id": "21.0",
                "name": "11.1.1: Läuterung",
                "spells": [
                    {
                        "name": "Übertragung",
                        "level": 1,
                        "value": "Der Zauberer überträgt eine Verwundung oder eine Abhängigkeit vom Ziel auf sich. Die Magiepunktkosten hierfür entsprechen denen des Heilspruchs, der nötig ist, um die Verwundung zu heilen. Übertragung muß für mehrere Verletzungen auch mehrmals gewirkt werden. Wenn mehrere Heilsprüche nötig sind, um eine einzelne Wunde zu heilen, muß dieser Spruch mehrmals gewirkt werden, damit die Heilung vollständig sein kann (auch wenn der Heiler sich entscheiden kann, nicht alle Wunden zu übertragen). Beachten Sie, daß der Heiler den notwendigen Heilspruch nicht kennen muß, bevor er die Wunde auf sich überträgt. Bei Trefferpunktschaden muß sich der Zauberer entscheiden, wie viele Treffer er heilen will und diese dann entsprechend dem Heilspruch übertragen, der alle diese Treffer auf einmal heilen kann. Um ein abgetrenntes Körperglied zu übertragen, muß der Zauberer alle 4 Anfügen-Sprüche beherrschen und er muß 28 Magiepunkte aufwenden (7 für jeden der Anfügen-Sprüche). Allerdings kann er sich entscheiden, nur 7 Magiepunkte auszugeben und das Ziel mit einem Stumpf zurücklassen (z.B. könnte er nur den Anfügen-Spruch aus Wege der Blutheilung wirken). Beispiel: Rana ist eine Heilerin der 10 Stufe und hat 75 Magiepunkte (MP). Ringlin, dem Kämpfer, wurde gerade eine Hand abgetrennt, sein Arm ist verletzt (zwei durchtrennte Muskeln, ein einfacher Knochenbruch), er erlitt 80 Treffer Schaden, verliert in jeder Runde 5 Treffer durch eine Schnittwunde und leidet unter einem ernsten Schädelbruch. Rana muß 8 Übertragungen wirken: eine für die durchtrennten Muskeln (4 MP für Muskel heilen III), vier für die abgetrennte Hand (28 MP für alle Anfügen-Sprüche), eine für den einfachen Bruch (1 MP für Heilung einfacher Brüche), eine für die blutende Wunde (4 MP für Blutung stillen V) und eine für die Treffer (12 MP für Heilen X). Die Gesamtkosten für das Übertragen wären 49 MP. Ringlin wäre alle seine Wunden los, und Rana könnte damit fortfahren, sich selbst zu heilen. Beachten Sie, daß Rana die abgetrennte Hand nicht auf sich übertragen muß (wenn sie es tut, fällt ihre eigene Hand ab). In diesem Fall würde sie genug für einen der Anfügen-Sprüche übertragen (den der Wege der Blutheilung). Ringlin behielte einen Stumpf zurück und hätte eine Hand übrig (die vielleicht später wieder angefügt werden könnte"
                    },
                    {
                        "name": "Reinigung von Krankheit",
                        "level": 2,
                        "value": "Stoppt Infektion und/oder Ausbreitung einer Krankheit, unter der der Zauberer bereits leidet. Es entsteht kein weiterer Schaden in noch unbetroffenen Körperteilen"
                    },
                    {
                        "name": "Reinigung von Gift",
                        "level": 3,
                        "value": "Neutralisiert ein beliebiges Gift im Körper des Zauberers. Aber: Bereits erlittener Schaden wird nicht geheilt"
                    },
                    {
                        "name": "Selbsterhaltung",
                        "level": 4,
                        "value": "Die „Leiche“ des Zauberers wird für die Spruchdauer erhalten. Damit wird weiterer Verfall (auch Attributssenkungen) oder Schaden durch bereits vorhandene Wunden aufgehalten. Der Zauberer fällt ins Koma und Heilsprüche wirken weiter (da sie unterbewußt wirken). Dieser Spruch verhindert nicht, daß die Seele des Zauberers seinen Körper verläßt (d.h. er muß in kurzer Zeit über die Schwelle des Todes hinaus geheilt werden, sonst verläßt seine Seele seinen Körper). Wenn die Seele den Körper verlassen hat, bevor der Körper geheilt wurde, kann nur Leben spenden sie zurückbringen"
                    },
                    {
                        "name": "Abhängigkeit mildern I",
                        "level": 5,
                        "value": "Der Zauberer muß nur einmal alle zwei Wochen würfeln, ob Entzugssymptome eintreten (statt einmal pro Woche)"
                    },
                    {
                        "name": "Abhängigkeit heilen I",
                        "level": 6,
                        "value": "Die Abhängigkeit des Zauberers wird um eine Stufe gesenkt. Im Handbuch für Spielleiter finden sie Näheres zu Abhängigkeit und Entzug"
                    },
                    {
                        "name": "Abhängigkeit mildern II",
                        "level": 7,
                        "value": "Wie Abhängigkeit mildern I, nur muß der Zauberer nur noch einmal pro Monat würfeln"
                    },
                    {
                        "name": "Abhängigkeit heilen II",
                        "level": 8,
                        "value": "Wie Abhängigkeit heilen I, nur wird die Abhängigkeitsstufe um 2 gesenkt"
                    },
                    {
                        "name": "Geisteskrankheit heilen",
                        "level": 10,
                        "value": "Der Zauberer wird von einer beliebigen Geisteskrankheit geheilt"
                    },
                    {
                        "name": "Abhängigkeit heilen III",
                        "level": 11,
                        "value": "Wie Abhängigkeit heilen I, nur wird die Abhängigkeitsstufe um 3 gesenkt"
                    },
                    {
                        "name": "Fernübertragung",
                        "level": 12,
                        "value": "Wie Übertragung, nur kann das Ziel bis zu 30cm pro Stufe vom Zauberer entfernt sein"
                    },
                    {
                        "name": "Krankheit heilen",
                        "level": 13,
                        "value": "Eine Krankheit wird aus dem Körper des Zauberers entfernt"
                    },
                    {
                        "name": "Abhängigkeit heilen IV",
                        "level": 14,
                        "value": "Wie Abhängigkeit heilen I, nur wird die Abhängigkeitsstufe um 4 gesenkt"
                    },
                    {
                        "name": "Vergiftung heilen",
                        "level": 15,
                        "value": "Ein Gift wird aus dem Körper des Zauberers entfernt"
                    },
                    {
                        "name": "Psychose heilen",
                        "level": 16,
                        "value": "Erlaubt dem Zauberer, eine leichte Psychose zu heilen (mit einer Genesungszeit von 1-10 Stunden). Unter leichte Psychosen fallen leichte und mittelschwere Phobien (im Handbuch für Spielleiter finden Sie Näheres zu Geisteskrankheiten)"
                    },
                    {
                        "name": "Abhängigkeit heilen V",
                        "level": 17,
                        "value": "Wie Abhängigkeit heilen I, nur wird die Abhängigkeitsstufe um 5 gesenkt"
                    },
                    {
                        "name": "Wahrhaftige Geisteskrankheitsheilung",
                        "level": 19,
                        "value": "Wie Geisteskrankheit heilen, nur tritt die Genesung sofort ein"
                    },
                    {
                        "name": "Abhängigkeit heilen X",
                        "level": 20,
                        "value": "Wie Abhängigkeit heilen I, nur wird die Abhängigkeitsstufe um 10 gesenkt"
                    },
                    {
                        "name": "Meister-Abhängigkeitsheilung",
                        "level": 25,
                        "value": "Wie Abhängigkeit heilen I, nur wird die Abhängigkeitsstufe um 20 gesenkt"
                    },
                    {
                        "name": "Wahrhaftige Abhängigkeitsheilung",
                        "level": 30,
                        "value": "Wie Abhängigkeit heilen I, nur wird die Abhängigkeitsstufe um 1 pro Stufe gesenkt"
                    },
                    {
                        "name": "Meisterschaft über Abhängigkeit",
                        "level": 50,
                        "value": "Wie Wahrhaftige Abhängigkeitsheilung, nur betrifft der Spruch alle Abhängigkeiten des Zauberers."
                    }
                ]
            },
            {
                "id": "21.1",
                "name": "11.1.2: Wege der Blutheilung",
                "spells": [
                    {
                        "name": "Gerinnung I",
                        "level": 1,
                        "value": "Gestattet dem Zauberer, die Blutung einer Wunde zu stoppen, durch die er einen Treffer pro Runde verliert. Er darf eine Stunde nicht bewegt werden, ansonsten setzt der Blutverlust wieder in der ursprünglichen Geschwindigkeit ein"
                    },
                    {
                        "name": "Blutung stillen I",
                        "level": 2,
                        "value": "Erlaubt es dem Zauberer, die Blutung einer Wunde zu stoppen, durch die er einen Treffer pro Runde verliert"
                    },
                    {
                        "name": "Heilung kleiner Blutgefäße",
                        "level": 3,
                        "value": "Erlaubt dem Zauberer, ein verletztes, kleines Blutgefäß vollständig zu heilen (eine Ader, deren Blutung nicht mehr als 4 Treffer/Runde verursacht, keine Hauptschlagadern oder Venen)"
                    },
                    {
                        "name": "Gerinnung V",
                        "level": 4,
                        "value": "Wie Gerinnung I, nur kann der Zauberer die Blutung einer Wunde stoppen, durch die er bis zu 5 Treffer pro Runde insgesamt verliert"
                    },
                    {
                        "name": "Blutung stillen III",
                        "level": 5,
                        "value": "Wie Blutung stillen I, nur daß der Zauberer eine oder mehrere Wunden heilen kann, durch die er insgesamt 3 Treffer pro Runde verliert. Er kann so 3 Wunden à einem Treffer/Runde oder eine Wunden à 3 Treffer pro Runde oder eine Wunde à 2 Treffer pro Runde und eine Wunde à einem Treffer/ Runde heilen"
                    },
                    {
                        "name": "Heilung großer Blutgefäße I",
                        "level": 6,
                        "value": "Der Zauberer kann ein verletztes Blutgefäß beliebiger Größe heilen, auch durchtrennte Schlagadern oder Venen. Genesungszeit beträgt 1-10 Tage, abhängig von der Schwere der Verletzung"
                    },
                    {
                        "name": "Anfügen",
                        "level": 7,
                        "value": "Erlaubt dem Zauberer, ein abgetrenntes Körperglied wieder anzufügen. Damit die Gliedmaße wieder voll funktionstüchtig wird, müssen die Anfügen-Sprüche aus Wege der Muskelheilung, Wege der Knochenheilung und Wege der Organheilung zusätzlich auf die Gliedmaße gewirkt werden. Das Körperglied ist nach 1-10 Tagen wieder voll beweglich"
                    },
                    {
                        "name": "Massen-Gerinnung",
                        "level": 9,
                        "value": "Wie Gerinnung V, nur kann der Zauberer die Blutung einer Wunde stoppen, die mit bis zu einem Treffer pro Stufe blutet. Beispielsweise könnte ein Heiler der 9. Stufe die Blutung einer Wunde stoppen, die mit 9 Treffern pro Runde blutet"
                    },
                    {
                        "name": "Massen-Blutungsstillung",
                        "level": 10,
                        "value": "Wie Blutung stillen III, nur daß der Zauberer Blutungen von einem Treffer pro Stufe stoppen kann. Beispielsweise könnte ein Heiler der 12. Stufe Blutungen von Wunden stoppen, durch die das Ziel insgesamt 12 Treffer pro Runde verliert"
                    },
                    {
                        "name": "Blutgerinnsel auflösen",
                        "level": 11,
                        "value": "Erlaubt dem Zauberer, ein beliebiges Blutgerinnsel zu entfernen"
                    },
                    {
                        "name": "Heilung großer Blutgefäße III",
                        "level": 13,
                        "value": "Wie Heilung großer Blutgefäße I, nur kann der Zauberer bis zu 3 Venen oder Arterien heilen"
                    },
                    {
                        "name": "Wahrhaftiges Anfügen",
                        "level": 15,
                        "value": "Wie Anfügen, nur muß der Zauberer die anderen 3 Wahrhaftiges Anfügen-Sprüche wirken, und die Genesung tritt sofort ein"
                    },
                    {
                        "name": "Heilung großer Blutgefäße V",
                        "level": 17,
                        "value": "Wie Heilung großer Blutgefäße I, nur kann der Zauberer bis zu 5 Venen oder Arterien heilen"
                    },
                    {
                        "name": "Wahrhaftige Gerinnselauflösung",
                        "level": 19,
                        "value": "Wie Blutgerinnsel auflösen, nur werden alle Gerinnsel aufgelöst"
                    },
                    {
                        "name": "Blutregulierung",
                        "level": 20,
                        "value": "Der Zauberer kann seinen eigenen Blutkreislauf regulieren und jedweden Blutverlust stoppen, ohne dabei Schaden zu nehmen. Der Spruch hält an, solange er regungslos bleibt. Wenn sich der Zauberer bewegt, erlischt der Spruch. Wenn ein Heiler zum Beispiel mit 27 Treffern/Runde blutet, sich hinlegt und diesen Spruch wirkt, so blutet er nicht weiter, solange er sich nicht bewegt, und kann immer noch Sprüche dieser Liste wirken (z.B. Blutung stillen etc.)"
                    },
                    {
                        "name": "Blutauffrischung",
                        "level": 25,
                        "value": "Der Zauberer kann alles Blut ersetzen, das er verloren hat. Die Genesungszeit beträgt 1-10 Stunden"
                    },
                    {
                        "name": "Blutkrankheiten heilen",
                        "level": 30,
                        "value": "Der Zauberer kann eine beliebige Blutkrankheit seines Körpers heilen. Die Genesungszeit beträgt 1-10 Stunden"
                    },
                    {
                        "name": "Wahrhaftige Blutheilung",
                        "level": 50,
                        "value": "Der Zauberer kann in jeder Runde einen der niedrigeren Sprüche dieser Liste anwenden."
                    }
                ]
            },
            {
                "id": "21.2",
                "name": "11.1.3: Wege der Knochenheilung",
                "spells": [
                    {
                        "name": "Heilung einfacher Brüche",
                        "level": 1,
                        "value": "Erlaubt dem Zauberer, einen einzelnen einfachen Bruch zu heilen (keine komplexen Brüche, Trümmerbrüche, Gelenkschäden usw.). Die Genesungszeit beträgt 1-10 Stunden"
                    },
                    {
                        "name": "Knorpelheilung",
                        "level": 2,
                        "value": "Erlaubt dem Zauberer, die gesamte Knorpelmasse um ein Gelenk zu heilen. Die Genesungszeit beträgt 1-2 Stunden"
                    },
                    {
                        "name": "Heilung komplexer Brüche",
                        "level": 3,
                        "value": "Wie Heilung einfacher Brüche, aber der Zauberer kann auch komplexe Brüche heilen"
                    },
                    {
                        "name": "Schädelbruch heilen",
                        "level": 4,
                        "value": "Erlaubt dem Zauberer, einen einzelnen Schädelbruch (nicht jedoch Trümmer-Schädelbrüche) bei sich zu heilen. Die Genesungszeit beträgt je nach Schwere der Verletzung 1- 10 Stunden"
                    },
                    {
                        "name": "Gelenkheilung",
                        "level": 5,
                        "value": "Erlaubt dem Zauberer, ein einzelnes, gebrochenes (nicht aber zertrümmertes) Gelenk zu heilen. Die Genesungszeit beträgt 1-10 Stunden"
                    },
                    {
                        "name": "Wahrhaftige Heilung einfacher Brüche",
                        "level": 6,
                        "value": "Wie Heilung einfacher Brüche, nur tritt die Genesung sofort ein"
                    },
                    {
                        "name": "Anfügen",
                        "level": 7,
                        "value": "Erlaubt dem Zauberer, ein abgetrenntes Körperglied wieder anzufügen. Damit die Gliedmaße wieder voll funktionstüchtig wird, müssen die Anfügen-Sprüche aus Wege der Muskelheilung, Wege der Blutheilung und Wege der Organheilung zusätzlich auf die Gliedmaße gewirkt werden. Das Körperglied ist nach 1-10 Tagen wieder voll beweglich"
                    },
                    {
                        "name": "Wahrhaftige Knorpelheilung",
                        "level": 8,
                        "value": "Wie Knorpelheilung, nur tritt die Genesung sofort ein 9. Wahrhaftige Heilung komplexer Brüche"
                    },
                    {
                        "name": "Wahrhaftige Schädelbruchheilung",
                        "level": 10,
                        "value": "Wie Schädelbruch heilen, nur tritt die Genesung sofort ein"
                    },
                    {
                        "name": "Wahrhaftige Gelenkheilung",
                        "level": 11,
                        "value": "Wie Gelenkheilung, nur tritt die Genesung sofort ein"
                    },
                    {
                        "name": "Trümmerbruchheilung",
                        "level": 12,
                        "value": "Erlaubt dem Zauberer, einen beliebigen gebrochenen oder zertrümmerten Knochen zu heilen. Die Genesungszeit beträgt 1-10 Stunden"
                    },
                    {
                        "name": "Knorpelregeneration",
                        "level": 13,
                        "value": "Der Zauberer kann einen beliebigen Knorpelbereich regenerieren. Die Genesungszeit beträgt 1-10 Stunden"
                    },
                    {
                        "name": "Knochenregeneration",
                        "level": 14,
                        "value": "Der Zauberer kann einen beliebigen Knochen regenerieren. Die Genesungszeit beträgt 1-10 Stunden"
                    },
                    {
                        "name": "Wahrhaftiges Anfügen",
                        "level": 15,
                        "value": "Wie Anfügen, nur muß der Zauberer die anderen 3 Wahrhaftiges Anfügen-Sprüche wirken und die Genesung tritt sofort ein"
                    },
                    {
                        "name": "Schnelle Trümmerbruchheilung",
                        "level": 16,
                        "value": "Wie Trümmerbruchheilung, nur beträgt die Genesungszeit 5-50 Minuten"
                    },
                    {
                        "name": "Schnelle Knorpelregeneration",
                        "level": 17,
                        "value": "Wie Knorpelregeneration, nur beträgt die Genesungszeit 5-50 Minuten"
                    },
                    {
                        "name": "Schädelregeneration",
                        "level": 18,
                        "value": "Wie Knochenregeneration, nur wirkt der Spruch ausschließlich auf den Schädel"
                    },
                    {
                        "name": "Schnelle Knochenregeneration",
                        "level": 19,
                        "value": "Wie Knochenregeneration, nur beträgt die Genesungszeit 5-50 Minuten"
                    },
                    {
                        "name": "Wahrhaftige Trümmerbruchheilung",
                        "level": 20,
                        "value": "Wie Trümmerbruchheilung, nur tritt die Genesung sofort ein"
                    },
                    {
                        "name": "Wahrhaftige Knorpelregeneration",
                        "level": 25,
                        "value": "Wie Knorpelregeneration, nur kann der Zauberer alle Knorpelmasse in seinem Körper regenerieren"
                    },
                    {
                        "name": "Wahrhaftige Knochenregeneration",
                        "level": 30,
                        "value": "Wie Knochenregeneration, nur kann der Zauberer alle verlorenen Knochen in seinem Körper regenerieren, einschließlich seines Schädels. Die Genesungszeit beträgt 1-10 Stunden"
                    },
                    {
                        "name": "Wahrhaftige Skelettregeneration",
                        "level": 50,
                        "value": "Der Zauberer kann alle verlorenen Knochen und/oder Knorpelmasse in seinem Körper regenerieren. Die Genesungszeit tritt sofort ein."
                    }
                ]
            },
            {
                "id": "21.3",
                "name": "11.1.4: Wege der Muskelheilung",
                "spells": [
                    {
                        "name": "Verstauchung heilen",
                        "level": 1,
                        "value": "Der Zauberer kann eine Verstauchung heilen (keine Genesungszeit)"
                    },
                    {
                        "name": "Muskel heilen I",
                        "level": 2,
                        "value": "Der Zauberer kann einen verletzten Muskel heilen. Die Genesungszeit beträgt 5-50 Min"
                    },
                    {
                        "name": "Sehnen heilen I",
                        "level": 3,
                        "value": "Der Zauberer kann eine verletzte Sehne heilen. Die Genesungszeit beträgt 5-50 Min"
                    },
                    {
                        "name": "Muskel heilen III",
                        "level": 4,
                        "value": "Wie Muskel heilen I, nur kann der Zauberer 3 verletzte Muskeln heilen"
                    },
                    {
                        "name": "Sehnen heilen III",
                        "level": 5,
                        "value": "Wie Sehnen heilen I, nur kann der Zauberer 3 verletzte Sehnen heilen"
                    },
                    {
                        "name": "Anfügen",
                        "level": 7,
                        "value": "Erlaubt dem Zauberer, ein abgetrenntes Körperglied wieder anzufügen. Damit die Gliedmaße wieder voll funktionstüchtig wird, müssen die AnfügenSprüche aus Wege der Knochenheilung, Wege der Blutheilung und Wege der Organheilung zusätzlich auf die Gliedmaße gewirkt werden. Das Körperglied ist nach 1-10 Tagen wieder voll beweglich"
                    },
                    {
                        "name": "Wahrhaftige Muskelheilung",
                        "level": 8,
                        "value": "Wie Muskel heilen I, nur tritt die Genesung sofort ein"
                    },
                    {
                        "name": "Wahrhaftige Sehnenheilung",
                        "level": 9,
                        "value": "Wie Sehnen heilen I, nur tritt die Genesung sofort ein"
                    },
                    {
                        "name": "Massen-Muskelheilung",
                        "level": 11,
                        "value": "Der Zauberer kann einen Muskel pro Stufe heilen. Die Genesungszeit beträgt 5-50 Min"
                    },
                    {
                        "name": "Muskelregeneration",
                        "level": 12,
                        "value": "Der Zauberer kann einen beliebigen Muskel regenerieren. Die Genesungszeit beträgt 5-50 Min"
                    },
                    {
                        "name": "Massen-Sehnenheilung",
                        "level": 13,
                        "value": "Der Zauberer kann eine Sehne pro Stufe heilen. Die Genesungszeit beträgt 5-50 Min"
                    },
                    {
                        "name": "Sehnenregeneration",
                        "level": 14,
                        "value": "Der Zauberer kann eine beliebige Sehne regenerieren. Die Genesungszeit beträgt 5-50 Min"
                    },
                    {
                        "name": "Wahrhaftiges Anfügen",
                        "level": 15,
                        "value": "Wie Anfügen, nur muß der Zauberer die anderen 3 Wahrhaftiges Anfügen-Sprüche wirken und die Genesung tritt sofort ein"
                    },
                    {
                        "name": "Schnelle Muskelregeneration",
                        "level": 17,
                        "value": "Wie Muskelregeneration, nur beträgt die Genesungszeit 1-10 Minuten"
                    },
                    {
                        "name": "Schnelle Sehnenregeneration",
                        "level": 19,
                        "value": "Wie Sehnenregeneration, nur beträgt die Genesungszeit 1-10 Minuten"
                    },
                    {
                        "name": "Wahrhaftige Regeneration",
                        "level": 20,
                        "value": "Der Zauber kann einen beliebigen Muskel oder eine beliebige Sehne heilen. Die Genesung tritt sofort ein"
                    },
                    {
                        "name": "Vollständige Muskelregeneration",
                        "level": 25,
                        "value": "Der Zauberer kann alle Muskeln in seinem Körper heilen. Die Genesungszeit beträgt 5-50 Minuten"
                    },
                    {
                        "name": "Vollständige Sehnenregeneration",
                        "level": 30,
                        "value": "Der Zauberer kann alle Sehnen in seinem Körper heilen. Die Genesungszeit beträgt 5-50 Minuten"
                    },
                    {
                        "name": "Wahrhaftige Massen-Heilung (Muskel/Sehnen)",
                        "level": 50,
                        "value": "Wie MassenMuskelheilung, nur kann der Zauberer seine Stufe an Muskeln oder Sehnen heilen. Die Genesung tritt sofort ein."
                    }
                ]
            },
            {
                "id": "21.4",
                "name": "11.1.6: Wege der Organheilung",
                "spells": [
                    {
                        "name": "Nase heilen",
                        "level": 1,
                        "value": "Der Zauberer kann alle Nasenverletzungen außer komplettem Verlust heilen"
                    },
                    {
                        "name": "Heilung leichter Nervenschäden",
                        "level": 2,
                        "value": "Der Zauberer kann leichten Nervenschaden in einem Bereich heilen. Die Genesungszeit beträgt 5-50 Minuten"
                    },
                    {
                        "name": "Heilung leichter Ohrenschäden",
                        "level": 3,
                        "value": "Der Zauberer kann Verletzungen des Außenohrs und auch kompletten Verlusts des Ohres heilen (die Regeneration dauert 5-50 Minuten)"
                    },
                    {
                        "name": "Heilung leichter Augenschäden",
                        "level": 4,
                        "value": "Der Zauberer kann leichte Augenschäden heilen (z.B. Hornhautabschürfung oder Fremdkörper im Auge)"
                    },
                    {
                        "name": "Heilung schwerer Nervenschäden",
                        "level": 5,
                        "value": "Wie Heilung leichter Nervenschäden, aber jeglicher Nervenschaden wird geheilt. Mit diesem Spruch kann der Zauberer jedoch keine Nerven heilen, die komplett zerstört wurden"
                    },
                    {
                        "name": "Heilung schwerer Ohrenschäden",
                        "level": 6,
                        "value": "Wie Heilung leichter Ohrenschäden, aber der Zauberer kann auch Verletzungen des Innenohres heilen (und damit den Gehörsinn wiederherstellen). Die Genesungszeit beträgt 1-10 Stunden"
                    },
                    {
                        "name": "Anfügen",
                        "level": 7,
                        "value": "Erlaubt dem Zauberer, ein abgetrenntes Körperglied wieder anzufügen. Damit die Gliedmaße wieder voll funktionstüchtig wird, müssen die AnfügenSprüche aus Wege der Knochenheilung, Wege der Blutheilung und Wege der Muskelheilung zusätzlich auf die Gliedmaße gewirkt werden. Das Körperglied ist nach 1-10 Tagen wieder voll beweglich"
                    },
                    {
                        "name": "Heilung schwerer Augenschäden",
                        "level": 8,
                        "value": "Wie Heilung leichter Augenschäden, nur kann der Zauberer beliebige Augenschäden außer dem völligen Verlust eines Auges heilen. Die Genesungszeit beträgt 1-10 Stunden"
                    },
                    {
                        "name": "Wahrhaftige Heilung leichter Nervenschäden",
                        "level": 9,
                        "value": "Wie Heilung leichter Nervenschäden, nur tritt die Genesung sofort ein"
                    },
                    {
                        "name": "Organ heilen",
                        "level": 10,
                        "value": "Der Zauberer kann Schaden an einem beliebigen Organ (außer dem Gehirn) heilen, das nicht völlig zerstört wurde. Die Genesungszeit beträgt 1-10 Stunden"
                    },
                    {
                        "name": "Lähmung heilen",
                        "level": 12,
                        "value": "Der Zauber kann jedwede Lähmung heilen. Die Genesungszeit beträgt 1-10 Stunden"
                    },
                    {
                        "name": "Massen-Nervenregeneration",
                        "level": 13,
                        "value": "Der Zauberer kann alle Nerven in seinem Körper regenerieren (außer denen im Gehirnbereich). Die Genesungszeit beträgt 1-10 Stunden"
                    },
                    {
                        "name": "Wahrhaftige Heilung schwerer Nervenschäden",
                        "level": 14,
                        "value": "Wie Heilung schwerer Nervenschäden, die Genesung tritt sofort ein"
                    },
                    {
                        "name": "Wahrhaftiges Anfügen",
                        "level": 15,
                        "value": "Wie Anfügen, nur muß der Zauberer die anderen 3 Wahrhaftiges Anfügen-Sprüche wirken und die Genesung tritt sofort ein"
                    },
                    {
                        "name": "Schnelle Lähmungsheilung",
                        "level": 17,
                        "value": "Wie Lähmung heilen, nur beträgt die Genesungszeit 5-50 Minuten"
                    },
                    {
                        "name": "Schnelle Massen-Nervenregeneration",
                        "level": 18,
                        "value": "Wie Massen-Nervenregeneration, nur beträgt die Genesungszeit 5-50 Minuten"
                    },
                    {
                        "name": "Hirnheilung",
                        "level": 20,
                        "value": "Der Zauberer kann Verletzungen des Gehirns heilen (etwa solche, die durch einen Schädelbruch ausgelöst wurden"
                    },
                    {
                        "name": "Organregeneration",
                        "level": 25,
                        "value": "Der Zauberer kann ein beliebiges inneres oder äußeres Organ regenerieren, nur nicht das Gehirn. Die Genesungszeit beträgt 1-10 Stunden"
                    },
                    {
                        "name": "Wahrhaftige Lähmungsheilung",
                        "level": 30,
                        "value": "Wie Lähmung heilen, nur tritt die Genesung sofort ein"
                    },
                    {
                        "name": "Wiedervereinigung",
                        "level": 50,
                        "value": "Der Zauberer kann seine Seele wieder mit seinem Körper vereinigen, vorausgesetzt, dieser ist ausgeheilt. Um ein totes Ziel wieder zurück ins Leben zu bringen, müßte ein Heiler zunächst alle Wunden des Ziels heilen (ohne sich damit „umzubringen“) und die Seele des Ziels wieder zurückholen, indem er seine eigene aufgibt (für das Ziel wirkt dieser Spruch dann wie Leben spenden IV auf der Basisliste Kleriker, Meisterschaft des Lebens). Während er rein technisch am Leben ist, aber keine Seele hat, wirkt der Heiler, als läge Absolution auf ihm (aus der Basisliste Kleriker Kanäle). Daher ist er zu keiner bewußten Handlung fähig und selbst unterbewußte Handlungen erleiden einen Malus von minus Fünfundsiebzig  Er kann seine eigene Seele durch diesen Spruch wiedererhalten, oder indem ein anderer den passenden Spruch wirkt."
                    }
                ]
            }
        ]
    },
    {
        "id": "22",
        "name": "Duale Basisliste Hexenmeister",
        "spellLists": [
            {
                "id": "22.0",
                "name": "11.2.1: Feststoffzerstörung",
                "spells": [
                    {
                        "name": "Eis schmelzen",
                        "level": 1,
                        "value": "Pro Stufe kann der Zauberer 300 Liter Eis schmelzen"
                    },
                    {
                        "name": "Erde lockern",
                        "level": 2,
                        "value": "Lockert 3 Kubikmeter Erde auf (wie ein Pflug)"
                    },
                    {
                        "name": "Erosion",
                        "level": 3,
                        "value": "Pro Stufe kann der Zauberer 3 Kubikmeter anorganisches Material mit tausendfacher Geschwindigkeit erodieren und verfallen lassen"
                    },
                    {
                        "name": "Spalte",
                        "level": 4,
                        "value": "Alle vorhandenen Risse in einem Bereich von bis zu 3m x 3m x 3m Größe (nicht 27m³) eines Materials dehnen sich so weit aus, wie es geht. Siehe Abschnitt 5.7 (S. 38)"
                    },
                    {
                        "name": "Tür auflösen",
                        "level": 5,
                        "value": "Löst eine nicht-magische Tür, die bis zu 15cm tief, 1m hoch und 1m breit ist, in Luft auf. Wenn die Türe tiefer als 15cm ist, werden die ersten 15cm aufgelöst. Der Spruch hat nur auf Gegenstände Wirkung, die als Tür genutzt werden (d.h. nicht auf einen Wandabschnitt)"
                    },
                    {
                        "name": "Stein zu Erde",
                        "level": 6,
                        "value": "Verwandelt 3 Kubikmeter Stein in zusammengepreßte Erde. Die Verwandlung tritt allmählich ein (sie braucht 3 Runden um vollständig zu sein)"
                    },
                    {
                        "name": "Erde zu Schlamm",
                        "level": 8,
                        "value": "Wie Stein zu Erde, nur verwandelt der Spruch Erde in weichen Schlamm"
                    },
                    {
                        "name": "Korridor",
                        "level": 10,
                        "value": "Erschafft einen Korridor von 1m x 2m , der pro Stufe des Zauberers 30cm tief ist. Er kann sich durch jedes anorganische Material außer Metall graben. Der Korridor entsteht mit einer Geschwindigkeit von 30cm pro Runde, solange sich der Zauberer konzentriert"
                    },
                    {
                        "name": "Zerbersten",
                        "level": 11,
                        "value": "Ein anorganischer Gegenstand von bis zu 30 Litern Volumen zerbirst. Alle innerhalb eines Radius von 1,5m erleiden einen kritischen Aufpralltreffer der Intensität A und derjenige, der den Gegenstand hielt, einen der Intensität C. Gegenstände aus Metall erhalten einen besonderen Bonus von +30 auf den WW"
                    },
                    {
                        "name": "Erde vernichten",
                        "level": 12,
                        "value": "Zerstört 3 Kubikmeter Erde"
                    },
                    {
                        "name": "Stein vernichten",
                        "level": 13,
                        "value": "Wie Erde vernichten, nur betrifft der Spruch Stein"
                    },
                    {
                        "name": "Wahrhaftige Türauflösung",
                        "level": 14,
                        "value": "Wie Tür auflösen, nur wird eine beliebige Tür aufgelöst"
                    },
                    {
                        "name": "Metall vernichten",
                        "level": 15,
                        "value": "Wie Erde vernichten, nur betrifft der Spruch Metall"
                    },
                    {
                        "name": "Fern-Feststoffstörung",
                        "level": 17,
                        "value": "Wie ein beliebiger Spruch der 10. oder einer niedrigeren Stufe auf dieser Liste, nur ist die Reichweite 100m"
                    },
                    {
                        "name": "Tiefer Riß",
                        "level": 19,
                        "value": "Läßt im Boden eine große Spalte entstehen, die bis zu 3m breit, 30m tief und 60m lang sein kann. Sie braucht 2 Runden um sich zu öffnen"
                    },
                    {
                        "name": "Wahrhaftige Feststoffzerstörung",
                        "level": 20,
                        "value": "Wie Erde vernichten, nur zerstört der Spruch 30 Liter pro Stufe eines beliebigen unbelebten Feststoffs"
                    },
                    {
                        "name": "Erschütterungen",
                        "level": 25,
                        "value": "Verursacht ein sehr leichtes Erdbeben, das ein schäbiges Bauwerk einstürzen lassen kann (was sehr furchterregend sein kann). Das Beben erreicht ungefähr 5,5 auf der Richterskala"
                    },
                    {
                        "name": "Große Spalte",
                        "level": 30,
                        "value": "Läßt im Boden eine große Spalte entstehen (bis zu 3m pro Stufe tief, 30cm pro Stufe breit und 6m pro Stufe lang). Der Riß braucht 2 Runden, um sich zu öffnen. Der Zauberer kann sich drei Runden konzentrieren, um ihn wieder zu schließen"
                    },
                    {
                        "name": "Erdbeben",
                        "level": 50,
                        "value": "Der Zauberer kann ein Erdbeben hervorrufen, dessen Epizentrum der Punkt ist, den er berührt. Das Erdbeben kann eine Runde pro Stufe verzögert werden. Mit einem W100 bestimmen Sie die Stärke des Bebens auf der Richterskala: (01-20) = 5,5, (21-45) = 6, (46-65) = 6,5, (66-80) = 7,0, (81-90) = 7,5, (91-95) = 8,0, (96-98) = 8,5, (99-100) = 9,0."
                    }
                ]
            },
            {
                "id": "22.1",
                "name": "11.2.2: Fleischzerstörung",
                "spells": [
                    {
                        "name": "Verstauchung",
                        "level": 1,
                        "value": "Das Ziel erleidet eine Verstauchung in einem zufallsbestimmten Teil einer zufallsbestimmten Gliedmaße. Wenn ein Teil des Beins betroffen ist, ist die Bewegungsfähigkeit des Ziels um 25% eingeschränkt, und es erleidet einen Malus von -10 auf alle Fern- und Nahkampfangriffe. Wenn ein Teil des Arms verstaucht ist, erleidet das Ziel einen Malus von -20 auf Nah- und Fernkampfangriffe"
                    },
                    {
                        "name": "Gliedmaßenschmerz",
                        "level": 2,
                        "value": "Das Ziel verspürt intensiven Schmerz in einem zufallsbestimmten Körperglied. Wenn ein Bein betroffen ist, kann das Ziel nicht gehen (es kann mit 10% seiner normalen Bewegungsrate kriechen). Ist ein Arm betroffen, so kann das Ziel ihn nicht gebrauchen"
                    },
                    {
                        "name": "Reißende Berührung",
                        "level": 3,
                        "value": "Durch die Knochen und das Gewebe des Ziels geht ein Reißen, als wäre es aus großer Höhe gefallen. Wenn das Ziel seinen WW um 1-10 verfehlt hat, erleidet es einen kritischen Aufpralltreffer der Intensität A, sind es 11-20, einen der Intensität B, bei 21-30 ist es ein C-Treffer, bei 31-40 daneben ist es ein kritischer D-Treffer. Wenn dem Ziel der WW um mehr als 41 mißlingt, erleidet es einen kritischen Treffer der Intensität E"
                    },
                    {
                        "name": "Gelenk versteifen",
                        "level": 4,
                        "value": "Eines der Gelenke des Ziels wird steif. Das Ziel leidet unter den Auswirkungen von Gliedmaßenschmerz. Wenn ein Gelenk im Bein in der Bewegung versteift, fällt das Ziel hin. Wird der Arm des Ziels steif, läßt es alles fallen, was es hält"
                    },
                    {
                        "name": "Gliedmaße brechen",
                        "level": 5,
                        "value": "Eine zufallsbestimmte Gliedmaße bricht. Ein gebrochener Arm kann nicht gebraucht werden. Ein gebrochenes Bein hemmt die Bewegung um 50% und das Ziel erleidet im Kampf einen Malus von -75%"
                    },
                    {
                        "name": "Reißen II",
                        "level": 6,
                        "value": "Wie Reißende Berührung, nur liegt die Reichweite bei 6m"
                    },
                    {
                        "name": "Hauttod",
                        "level": 7,
                        "value": "Die Haut des Ziels blättert ab und löst sich am ganzen Körper. Zwar erleidet es keine taktischen Abzüge, aber sein Aussehen sinkt um -50 (minimal auf 1). Der Zustand bleibt, bis der Spruch gebannt wurde, und ein Monat vergangen ist. Magische Heilung kann diese Zeitspanne verringern"
                    },
                    {
                        "name": "Reißen V",
                        "level": 8,
                        "value": "Wie Reißende Berührung, nur liegt die Reichweite bei 15m"
                    },
                    {
                        "name": "Ohrriß",
                        "level": 9,
                        "value": "Eines der Ohren des Ziels (zufällig bestimmt) reißt. Es verliert 50% seines Gehörs, bis es geheilt wurde. Damit erleidet das Ziel eine Malus von -50 auf Wahrnehmungsfertigkeiten (Wahrnehmung • Suchen), die nur das Gehör einbeziehen (oder -5 auf Aufmerksamkeit) und -25 auf Wahrnehmungsfertigkeiten, in denen neben dem Gehör andere Sinne eine Rolle spielen (oder -3 auf Aufmerksamkeit). Wird dieser Spruch zweimal auf das gleiche Ohr gesprochen, ertaubt es"
                    },
                    {
                        "name": "Gliedmaßentod",
                        "level": 10,
                        "value": "Ein Körperglied des Ziels (zufällig bestimmt) verdorrt und stirbt ab. Jeden Tag kann das Ziel diese Gliedmaße 5% weniger gebrauchen. Wenn diese Unfähigkeit 100% erreicht, fällt das Körperglied ab. Schaden bis zu 80% kann durch Blut- und Nervenheilungssprüche geheilt werden, danach muß die Gliedmaße regeneriert werden. Wenn sie ein Bein ist, ist die Bewegung um die Hälfte der Prozent eingeschränkt (d.h. 60% des Beins verdorrt sind, ist die Bewegung um 30% gesenkt). Wenn ein Arm betroffen ist, erleidet das Ziel für jedes Prozent, zu dem der Arm verwittert ist, einen Punkt Malus im Kampf (d.h. wenn der Arm zu 75% verdorrt ist, erleidet das Ziel einen Malus von -75 auf alles im Kampf )"
                    },
                    {
                        "name": "Augenriß",
                        "level": 11,
                        "value": "Wie Ohrriß, nur betrifft der Spruch ein Auge (und die optische Wahrnehmung)"
                    },
                    {
                        "name": "Lungenkollaps",
                        "level": 12,
                        "value": "Einer der Lungenflügel des Ziels kollabiert. Er ist auf 50% seiner Aktionsfähigkeit beschränkt, solange die Lunge nicht geheilt wird"
                    },
                    {
                        "name": "Muskeltod",
                        "level": 13,
                        "value": "Wie Gliedmaßentod, nur ist ein zufällig bestimmter Muskel betroffen (keine Muskelorgane, d.h. nicht das Herz)"
                    },
                    {
                        "name": "Knochentod",
                        "level": 14,
                        "value": "Wie Gliedmaßentod, nur ist ein zufällig bestimmter Knochen betroffen (keine Teil der Wirbelsäule und nicht der Schädel)"
                    },
                    {
                        "name": "Schwarze Leitmagie I",
                        "level": 15,
                        "value": "Der Zauberer kann einen Spruch der Schwarzen Leitmagie anwenden (siehe Abschnitt 5.23, Seite 43) 17. Fern-Fleischzerstörung"
                    },
                    {
                        "name": "Massen-Fleischzerstörung",
                        "level": 19,
                        "value": "Wie ein beliebiger niedrigstufigerer Spruch dieser Liste, nur kann der Zauberer ihn auf ein Ziel pro Stufe wirken"
                    },
                    {
                        "name": "Versteinerung",
                        "level": 20,
                        "value": "Die Knochen des Ziels versteinern allmählich. Das Ziel verliert durch die abnehmende Blutproduktion nach und nach Aktionsfähigkeit (wie bei Gliedmaßentod)"
                    },
                    {
                        "name": "Schwarze Leitmagie II",
                        "level": 25,
                        "value": "Wie Schwarze Leitmagie I, nur kann ein Schwarze Leitmagie II-Spruch verwendet werden"
                    },
                    {
                        "name": "Wahrhaftiges Reißen",
                        "level": 30,
                        "value": "Wie Reißende Berührung, nur liegt die Reichweite bei 100m, und der Spruch verursacht immer einen Kritischen Aufpralltreffer der Intensität E, wenn dem Ziel der WW mißlingt"
                    },
                    {
                        "name": "Schwarze Leitmagie III",
                        "level": 50,
                        "value": "Wie Schwarze Leitmagie I, nur kann ein Schwarze Leitmagie III-Spruch verwendet werden."
                    }
                ]
            },
            {
                "id": "22.2",
                "name": "11.2.3: Flüssigkeitszerstörung",
                "spells": [
                    {
                        "name": "Flüssigkeit verdampfen",
                        "level": 1,
                        "value": "Pro Stufe kann der Zauberer 0,3m³ (=300l) Flüssigkeit verdampfen"
                    },
                    {
                        "name": "Flüssigkeit einfrieren",
                        "level": 2,
                        "value": "Pro Stufe kann der Zauberer 0,3m³ (300l) Flüssigkeit einfrieren. Der Zauberer ist immun gegen die Kälte"
                    },
                    {
                        "name": "Verdampfen I",
                        "level": 3,
                        "value": "Läßt 30m³ Flüssigkeit schnell verdampfen (innerhalb einer Stunde)"
                    },
                    {
                        "name": "Wasser vernichten I",
                        "level": 4,
                        "value": "Vernichtet sofort 3m³ Wasser"
                    },
                    {
                        "name": "Wasser beruhigen",
                        "level": 5,
                        "value": "Das Wasser im Wirkungsbereich wird beruhigt. In der Mitte verliert die Welle 6m an Höhe und am Rand entsprechend weniger"
                    },
                    {
                        "name": "Wasserstrahl I",
                        "level": 6,
                        "value": "Aus der Handfläche des Zauberers schießt ein Wasserstrahl. Die Ergebnisse dieses Angriffs werden mittels der Angriffstabelle: Wasserstrahl 12-9 (Seite 247) bestimmt"
                    },
                    {
                        "name": "Regen verhindern",
                        "level": 7,
                        "value": "Für die Spruchdauer fällt im Wirkungsbereich kein Niederschlag"
                    },
                    {
                        "name": "Wasser entziehen",
                        "level": 8,
                        "value": "Entzieht 30 Litern unbelebtem Material alle Flüssigkeit (normalerweise Wasser)"
                    },
                    {
                        "name": "Verdampfen II",
                        "level": 9,
                        "value": "Wie Verdampfen I, nur sind 300m³ Flüssigkeit betroffen"
                    },
                    {
                        "name": "Wasser vernichten II",
                        "level": 10,
                        "value": "Wie Wasser vernichten I, nur sind 30m³ Wasser betroffen"
                    },
                    {
                        "name": "Wahrhaftige Regenverhinderung",
                        "level": 11,
                        "value": "Wie Regen verhindern, bis auf den Wirkungsbereich und die Spruchdauer"
                    },
                    {
                        "name": "Wahrhaftiger Wasserentzug",
                        "level": 12,
                        "value": "Wie Wasser entziehen, nur sind 300 Liter Material betroffen"
                    },
                    {
                        "name": "Verdampfen III",
                        "level": 13,
                        "value": "Wie Verdampfen I, nur sind 300m³ Wasser betroffen"
                    },
                    {
                        "name": "Wasser vernichten III",
                        "level": 14,
                        "value": "Wie Wasser vernichten I, nur sind 30m³ Wasser betroffen"
                    },
                    {
                        "name": "Stärkere Wasserberuhigung",
                        "level": 15,
                        "value": "Wie Wasser beruhigen, nur wird die Wellenhöhe in der Mitte um 15m gesenkt"
                    },
                    {
                        "name": "Fern-Flüssigkeitszerstörung",
                        "level": 17,
                        "value": "Wie ein beliebiger Spruch der 10. oder einer niedrigeren Stufe auf dieser Liste, nur ist die Reichweite 100m"
                    },
                    {
                        "name": "Austrocknen",
                        "level": 19,
                        "value": "Das Ziel beginnt auszutrocknen und zu verwittern, als wäre in einer windgepeitschten Sandwüste. Seine Aktivität ist sofort um 10% verringert, und es erleidet 1% seiner Gesamttrefferanzahl an Schaden. In jeder Runde, in der sich der Zauberer konzentriert, verliert das Ziel weitere 5 % Aktivität und 1% seiner Gesamttrefferanzahl. Wenn der Zauberer seine Konzentration 28 aufeinanderfolgenden Runden lang aufrechterhält (d.h. wenn der Aktivitätsmalus 150 erreicht), bleibt von einem belebten Ziel nur eine verdorrte Hülle. Wenn der Zauberer in seiner Konzentration gestört wird oder das Ziel den Wirkungsbereich verläßt, bleiben der angesammelte Aktivitätsmalus und der Trefferverlust erhalten. Die Treffer heilen normal, aber von dem Aktivitätsmalus erholt sich das Ziel nur mit einer Rate von 10% pro Tag. Alternativ kann der SL auch gestatten, daß der Aktivitätsmalus durch den Spruch Krankheit heilen (oder einen entsprechenden Spruch) entfernt wird, der gewirkt wird, nachdem alle Treffer geheilt wurden"
                    },
                    {
                        "name": "Feuchtigkeitsentzug",
                        "level": 20,
                        "value": "In jeder Minute, in der sich der Zauberer konzentriert, sinkt die Luftfeuchtigkeit um 1% (bis zu maximal 50%). Die Luftfeuchtigkeit steigt allmählich wieder mit 5% (der ursprünglichen Luftfeuchtigkeit) pro Tag an, bis die ursprüngliche Luftfeuchtigkeit wieder erreicht ist. Beachten Sie, daß diese Veränderung der Luftfeuchtigkeit Auswirkungen auf das Klima in dem Gebiet haben kann (und damit auch auf die Vegetation)"
                    },
                    {
                        "name": "Wahrhaftiges Verdampfen",
                        "level": 25,
                        "value": "Wie Verdampfen I, nur sind 27000m³ Wasser betroffen"
                    },
                    {
                        "name": "Wahrhaftige Wasserberuhigung",
                        "level": 30,
                        "value": "Wie Wasser beruhigen, nur ist der Wirkungsbereich 3km pro Stufe"
                    },
                    {
                        "name": "Wahrhaftiger Feuchtigkeitsentzug",
                        "level": 50,
                        "value": "In jeder Minute, in der sich der Zauberer konzentriert, sinkt die Luftfeuchtigkeit um 5% (bis zu 95%). Sie steigt wieder wie in Feuchtigkeitsentzug. Beachten Sie, daß diese Veränderung der Luftfeuchtigkeit Auswirkungen auf das Klima in dem Gebiet haben kann (und damit auch auf die Vegetation)."
                    }
                ]
            },
            {
                "id": "22.3",
                "name": "11.2.4: Gaszerstörung",
                "spells": [
                    {
                        "name": "Entnebeln",
                        "level": 1,
                        "value": "Löst jeglichen Nebel in einem Radius von 3m/St auf"
                    },
                    {
                        "name": "Luftbremse I",
                        "level": 2,
                        "value": "Verlangsamt die allgemeine Windgeschwindigkeit in einem 3m-Radius um 50km/h (betrifft nicht die Atmung)"
                    },
                    {
                        "name": "Vakuum I",
                        "level": 3,
                        "value": "Erzeugt in einem Radius von 2m ein fast vollständiges Vakuum. Jedem im Radius muß ein WW gelingen, sonst erleidet er einen kritischen Aufpralltreffer der Intensität B durch die Luft, die plötzlich ab- und dann wieder zurückströmt"
                    },
                    {
                        "name": "Sauerstoffentzug I",
                        "level": 4,
                        "value": "Der Zauberer kann in jeder Runde 1% des vorhandenen Sauerstoffs aus einem 3mRadius entziehen"
                    },
                    {
                        "name": "Luftbremse II",
                        "level": 5,
                        "value": "Wie Luftbremse I, nur betrifft der Spruch einen Radius von 6m"
                    },
                    {
                        "name": "Vakuum II",
                        "level": 6,
                        "value": "Wie Vakuum I, nur ist der Radius 3m groß"
                    },
                    {
                        "name": "Sauerstoffentzug II",
                        "level": 7,
                        "value": "Wie Sauerstoffentzug I, nur ist ein Radius von 6m betroffen"
                    },
                    {
                        "name": "Gas zu Luft",
                        "level": 8,
                        "value": "Verwandelt 30 Liter Gas pro Runde in normale Luft, solange sich der Zauberer konzentriert"
                    },
                    {
                        "name": "Luftbremse X",
                        "level": 9,
                        "value": "Wie Luftbremse I, nur betrifft der Spruch einen Radius von 30m"
                    },
                    {
                        "name": "Vakuum IV",
                        "level": 10,
                        "value": "Wie Vakuum I, nur ist der Radius 6m groß"
                    },
                    {
                        "name": "Mittelstarkes Vakuum I",
                        "level": 11,
                        "value": "Wie Vakuum I, nur verursacht der Spruch kritische Aufpralltreffer der Intensität D"
                    },
                    {
                        "name": "Schneller Sauerstoffentzug I",
                        "level": 12,
                        "value": "Wie Sauerstoffentzug I, nur werden pro Runde 5% Sauerstoff entzogen"
                    },
                    {
                        "name": "Sauerstoffentzug V",
                        "level": 13,
                        "value": "Wie Sauerstoffentzug I, nur ist ein Radius von 15m betroffen"
                    },
                    {
                        "name": "Mittelstarkes Vakuum II",
                        "level": 14,
                        "value": "Wie Mittelstarkes Vakuum I, nur ist ein Radius von 3m betroffen"
                    },
                    {
                        "name": "Schneller Sauerstoffentzug II",
                        "level": 15,
                        "value": "Wie Schneller Sauerstoffentzug I, nur ist ein Radius von 6m betroffen"
                    },
                    {
                        "name": "Fern-Gaszerstörung",
                        "level": 17,
                        "value": "Wie ein beliebiger Spruch der 10. oder einer niedrigeren Stufe auf dieser Liste, nur ist die Reichweite 100m"
                    },
                    {
                        "name": "Starker Sauerstoffentzug",
                        "level": 19,
                        "value": "Wie Sauerstoffentzug I, nur ist ein Radius von 6m betroffen, und es werden 10% des Sauerstoffs pro Runde entzogen"
                    },
                    {
                        "name": "Starkes Vakuum",
                        "level": 20,
                        "value": "Wie Vakuum I, nur verursacht der Spruch kritische Aufpralltreffer der Intensität E"
                    },
                    {
                        "name": "Wahrfhaftiger Sauerstoffentzug",
                        "level": 25,
                        "value": "Wie Sauerstoffentzug I, nur ist ein Radius von 6m betroffen, und es werden 20% Sauerstoff pro Runde entzogen"
                    },
                    {
                        "name": "Wahrhaftiges Vakuum",
                        "level": 30,
                        "value": "Wie Starkes Vakuum, nur ist der Radius 3m groß"
                    },
                    {
                        "name": "Implosion",
                        "level": 50,
                        "value": "Zerstört alle Gase in einem einzigen geschlossenen Raum (in der Regel einem Gebäude) von bis zu einer Größe von 30m x 30m x 30m (d.h. von 27000m³). Je nach Bauart des Gebäudes besteht die Möglichkeit, daß es einstürzt. Dann erleidet jeder, der sich dort aufhielt, einen kritischen Aufprallschaden der Intensität D durch herbabstürzende Trümmer. Dies führt zu einer sehr lauten Explosion. Wenn das Gebäude einstürzt, erleiden alle innerhalb eines 30m-Radius einen kritischen Aufprallschaden der Intensität C durch die Explosion."
                    }
                ]
            },
            {
                "id": "22.4",
                "name": "11.2.5: Geistzerstörung",
                "spells": [
                    {
                        "name": "Geringerer Schmerz",
                        "level": 1,
                        "value": "Das Ziel erleidet 25% seiner verbleibenden Trefferpunkte als Schaden (also die, die es noch nicht einstecken mußte). Wenn die Spruchdauer abgelaufen sind, erhält es diese Trefferpunkte zurück, vorausgesetzt es ist nicht gestorben"
                    },
                    {
                        "name": "Schlag I",
                        "level": 2,
                        "value": "Das Ziel ist benommen"
                    },
                    {
                        "name": "Desorientierung",
                        "level": 3,
                        "value": "Das Ziel muß 25 von allen Orientierungs- und Wahrnehmungswürfen abziehen und 5 von allen Initiativewürfen"
                    },
                    {
                        "name": "Gleichgewicht stören",
                        "level": 4,
                        "value": "Das Ziel muß 25 von allen Manöverwürfen abziehen"
                    },
                    {
                        "name": "Verstauchen",
                        "level": 5,
                        "value": "Das Ziel muß 25 von allen Angriffswürfen abziehen"
                    },
                    {
                        "name": "Schlag III",
                        "level": 6,
                        "value": "Wie Schlag I, abgesehen von der Dauer"
                    },
                    {
                        "name": "Größerer Schmerz",
                        "level": 7,
                        "value": "Wie Geringerer Schmerz, aber es werden 50% der verbleibenden Trefferpunkte abgezogen"
                    },
                    {
                        "name": "Vergessen",
                        "level": 8,
                        "value": "Das Ziel vergißt ein Stück seiner Vergangenheit (1 Minute pro Stufe), das der Zauberer aussucht"
                    },
                    {
                        "name": "Wort der Pein",
                        "level": 9,
                        "value": "Wie Größerer Schmerz, nur müssen die Trefferpunkte normal geheilt werden"
                    },
                    {
                        "name": "Hirnschock",
                        "level": 10,
                        "value": "Wie Desorientierung, Gleichgewicht stören und Verstauchen (alles auf einmal)"
                    },
                    {
                        "name": "Geistiger Tod",
                        "level": 11,
                        "value": "Der Geist des Ziels ist 10 (zufällig bestimmte) Minuten am Tag völlig leer. Das Ziel kann in dieser Ziel weder handeln noch denken"
                    },
                    {
                        "name": "Schlag V",
                        "level": 12,
                        "value": "Wie Schlag I, abgesehen von der Dauer"
                    },
                    {
                        "name": "Entgeistigung",
                        "level": 13,
                        "value": "Der Geist des Ziels ist für die Spruchdauer völlig leer. Es kann weder Ereignisse, noch die Zeit, noch Handlungen wahrnehmen. Am Ende der Spruchdauer ist er eine Runde lang benommen, in der sein Geist langsam wieder zurückkehrt"
                    },
                    {
                        "name": "Massen-Desorientierung",
                        "level": 14,
                        "value": "Wie Desorientierung, nur betrifft der Spruch die Stufe des Zauberers an Zielen"
                    },
                    {
                        "name": "Gebrochener Geist",
                        "level": 15,
                        "value": "Das Ziel wird zum brabbelnde Idioten. Es kann herumgeführt werden aber selbst keine Aktion ausführen"
                    },
                    {
                        "name": "Massen-Gleichgewichtsstörung",
                        "level": 16,
                        "value": "Wie Gleichgewicht stören, nur sind die Stufe des Zauberers an Zielen betroffen"
                    },
                    {
                        "name": "Fern-Geistzerstörung",
                        "level": 17,
                        "value": "Wie ein beliebiger Spruch der 10. oder einer niedrigeren Stufe auf dieser Liste, nur ist die Reichweite 100m"
                    },
                    {
                        "name": "Massen-Verstauchen",
                        "level": 18,
                        "value": "Wie Verstauchen, nur sind die Stufe des Zauberers an Zielen betroffen"
                    },
                    {
                        "name": "Grauen",
                        "level": 19,
                        "value": "[WW-Mod.: -20] Das Ziel glaubt, daß ihn ein Wesen aus seinen schlimmsten Alpträumen attackiert. In jeder Runde wird es von der Kreatur angegriffen (die mit +100 auf Waffenlosen Kampf • Schlag, Rang 1 angreift, der Schaden ist echt). Egal welchen Schaden das Ziel der Kreatur zufügt, sie kann nur besiegt werden, wenn dem Ziel ein WW gelingt (ein WW pro Minute) oder wenn es das Bewußtsein verliert"
                    },
                    {
                        "name": "Erfahrungsverlust I",
                        "level": 20,
                        "value": "Das Ziel verliert 5% seiner gesammelten Erfahrung (normalerweise seine Erfahrungspunkte). Beachten Sie, daß das Ziel keine Stufe verliert, nur die Erfahrungspunkte (d.h. er braucht diese Erfahrungspunkte mehr, um die nächste Stufe erreichen zu können)"
                    },
                    {
                        "name": "Massen-Schmerzen",
                        "level": 25,
                        "value": "Wie Größerer Schmerz, nur sind die Stufe des Zauberers an Zielen betroffen, die Spruchdauer hält an, bis die Trefferpunkte geheilt wurden, und die Reichweite liegt bei 100m"
                    },
                    {
                        "name": "Massen-Hirnschock",
                        "level": 30,
                        "value": "Wie Hirnschock, nur können die Stufe des Zauberers an Zielen betroffen sein und die Reichweite ist 100m"
                    },
                    {
                        "name": "Massen-Entgeistigung",
                        "level": 50,
                        "value": "Wie Entgeistigung, nur können die Stufe des Zauberers an Zielen betroffen sein und die Reichweite ist 100m."
                    }
                ]
            },
            {
                "id": "22.5",
                "name": "11.2.6: Seelenzerstörung",
                "spells": [
                    {
                        "name": "Frage",
                        "level": 1,
                        "value": "Das Ziel muß eine einzige Verständnisfrage beantworten (vorausgesetzt, es versteht die Frage)"
                    },
                    {
                        "name": "Dämonische Besessenheit I",
                        "level": 2,
                        "value": "Das Ziel ist von einem niederen Dämon besessen. Der Zauberer hat weder über den Dämon noch über das Ziel Kontrolle. Der Dämon zwingt das Ziel, zufallsbestimmte (aber nicht notwendig zerstörerische) Dinge zu tun. Jede zweite Runde erhält das Ziel einen WW, um den Dämon wieder loszuwerden"
                    },
                    {
                        "name": "Neurose",
                        "level": 3,
                        "value": "Das Ziel hat eine extreme Abneigungen gegen etwas, was der Zauberer festlegt. Wenn es vor einer entsprechenden Wahl steht, hat es eine Chance von 50%, die Neurose zu überwinden. Beispielsweise würde eine Neurose gegen Pferde für das Ziel bedeuten, daß es nur mit 50% Wahrscheinlichkeit aufsteigen oder sich dem Tier nähern kann. Zu dieser Chance kommt der dreifache Selbstdisziplinbonus"
                    },
                    {
                        "name": "Schuldgefühl",
                        "level": 4,
                        "value": "Das Ziel fühlt sich für eine Tat in seiner Vergangenheit schuldig. Der SL sollte eine einschlägiges Ereignis aus der Vergangenheit des Ziels aussuchen. Es wird nie wieder ähnlich handeln und unternimmt Schritte, sein Schuldgefühl zu lindern"
                    },
                    {
                        "name": "Paranoia",
                        "level": 5,
                        "value": "Das Ziel traut niemandem vollkommen. In einer lebensbedrohlichen Situation besteht eine Wahrscheinlichkeit von 50% (zu der sein Selbstdisziplinbonus x 3 hinzukommt), daß er seine Sicherheit nicht in die Hände anderer legt"
                    },
                    {
                        "name": "Dämonische Besessenheit II",
                        "level": 6,
                        "value": "Wie Dämonische Besessenheit I, nur erhält das Ziel nur einmal pro Minute einen WW"
                    },
                    {
                        "name": "Panik",
                        "level": 7,
                        "value": "Das Ziel flieht panisch in jeder Situation, in der es persönlich gefährdet ist, wenn ihm ein WW mißlingt. In jedem Kampf muß es einen WW bestehen. Fliehen heißt, sich mit höchster Geschwindigkeit W10 Runden wegzubewegen"
                    },
                    {
                        "name": "Seelentausch",
                        "level": 8,
                        "value": "Die Seele des Ziels und die des Zauberers werden ausgewechselt. Der Zauberer kann im Körper des Ziels mit 50% der normalen Aktionsfähigkeit handeln. Das Ziel bleibt im Körper des Zauberers inaktiv. Der Zauberer kann den Spruch jederzeit aufheben (dauert 1 Runde), das Ziel kann den Spruch nur aufheben, wenn ihm ein WW gelingt (es erhält alle 10 Minuten einen). Wenn einer der Körper stirbt, sind beide Seelen wie von Absolution betroffen"
                    },
                    {
                        "name": "Dämonische Besessenheit III",
                        "level": 10,
                        "value": "Wie Dämonische Besessenheit I, nur erhält das Ziel nur einmal alle 10 Minuten einen WW"
                    },
                    {
                        "name": "Unterjochung",
                        "level": 11,
                        "value": "Ein Teil der Seele des Ziels wird entnommen und in einem organischen Gegenstand abgelegt, den der Zauberer bei sich trägt. Wann auch immer sich der Zauberer konzentriert, handelt der Körper des Ziels, wie er es will. Der Spruch wird aufgehoben, wenn der Zauberer ihn beendet, oder der Gegenstand zerstört wird, oder das Ziel weiter als 30m von dem Gegenstand entfernt ist, oder wenn der Zauberer den Gegenstand nicht mehr am Körper trägt. Wenn sich der Zauberer nicht konzentriert, steht dem Ziel frei zu tun, was es will (allerdings mit einem Malus von -30 auf alle Aktionen). Während es gelenkt wird, ist sich das Ziel all seiner Aktionen bewußt (aber er kann nichts tun, um sie aufzuhalten)"
                    },
                    {
                        "name": "Fluch des Seelenraubs",
                        "level": 12,
                        "value": "Ein Teil der Seele des Ziels wird auf einen zufälligen Gegenstand irgendwo innerhalb eines Umkreises von 150km übertragen. Das Ziel erleidet eine Malus von -30 auf alle Aktionen, bis der Spruch gebannt wurde, oder das Ziel den Gegenstand berührt. Das Ziel weiß immer in welcher Richtung seine „Seele“ sich von ihm befindet"
                    },
                    {
                        "name": "Dämonische Besessenheit IV",
                        "level": 13,
                        "value": "Wie Dämonische Besessenheit I, nur erhält das Ziel nur einmal pro Stunde einen WW"
                    },
                    {
                        "name": "Wort der Panik",
                        "level": 14,
                        "value": "Das Ziel flieht panisch vor dem Zauberer. Fliehen heißt, sich mit höchster Geschwindigkeit W10 Runden wegzubewegen"
                    },
                    {
                        "name": "Ruf der Panik",
                        "level": 15,
                        "value": "Wie Wort der Panik, nur sind alle in 6m-Radius vom Zauberer betroffen"
                    },
                    {
                        "name": "Fern-Seelenzerstörung",
                        "level": 17,
                        "value": "Wie ein beliebiger Spruch der 10. oder einer niedrigeren Stufe auf dieser Liste, nur ist die Reichweite 100m"
                    },
                    {
                        "name": "Finsteres Schlummern",
                        "level": 19,
                        "value": "Das Ziel wird in den Zustand eines tiefen Schlafs versetzt, aus dem er nicht erwacht und der es nicht altern läßt. Es stirbt nur, wenn sein Körper getötet wird oder wenn ein einziges, nicht-magisches Ereignis eintritt (das der Zauberer festlegt, wenn er den Spruch wirkt). Beachten Sie, daß der Zauberer diese nicht-magische Bedingung angeben muß (das ist nicht nur eine Wahlmöglichkeit)"
                    },
                    {
                        "name": "Verbannung",
                        "level": 20,
                        "value": "Wie Unterjochung, nur kann die Seele nur frei kommen, wenn der Zauberer den Spruch aufhebt, oder der Gegenstand zerstört wird, oder das Ziel den Gegenstand berührt"
                    },
                    {
                        "name": "Wahrhaftiger Seelentausch",
                        "level": 25,
                        "value": "Wie Seelentausch, nur kann der Zauberer mit 90% der normalen Aktionsfähigkeit handeln, und das Ziel kann nur einmal pro Stunde einen WW ablegen"
                    },
                    {
                        "name": "Absolution",
                        "level": 30,
                        "value": "[WW-Mod: 20] Die „Seele“ des Ziels wird aus dem Körper gerissen und geht für 30 Tage pro 10 Fehlschlag an den Ort, an den alle „Seelen“ gehen. Die Seele kann nur mittels Leben spenden frühzeitig zurückgeholt werden. Das Ziel ist bewußtlos, bis die Seele zu ihm zurückkehrt. Selbst unterbewußte Handlungen (z.B. wie alle Heilsprüche und unterbewußte Sprüche) erleiden einen Malus von - 75, während die Seele fort ist"
                    },
                    {
                        "name": "Wahrhaftige Absolution",
                        "level": 50,
                        "value": "Wie Absolution, nur kann die „Seele“ überhaupt nur mittels Leben spenden zurückgeholt werden."
                    }
                ]
            }
        ]
    },
    {
        "id": "23",
        "name": "Duale Basisliste Mystiker",
        "spellLists": [
            {
                "id": "23.0",
                "name": "11.3.1: Feststoffveränderung",
                "spells": [
                    {
                        "name": "Erwärmen",
                        "level": 1,
                        "value": "Pro Stufe der Zauberers können 30 Liter eines festen, unbelebten Materials mit einer Geschwindigkeit von 30 Liter pro Runde Konzentration auf bis zu 40°C erwärmt werden (wenn sich der Zauberer nicht weiter konzentriert, behält das Material diese Temperatur für die Spruchdauer bei)"
                    },
                    {
                        "name": "Erhitzen I",
                        "level": 2,
                        "value": "Wie Erwärmen, bis auf die Dauer. Außerdem muß sich der Zauberer jeweils einen Runde konzentrieren, um das Material um 25°C (bis zum Maximum) zu erhitzen. Der Zauberer muß das Ziel nur berühren, wenn er den Spruch wirkt"
                    },
                    {
                        "name": "Abkühlen",
                        "level": 3,
                        "value": "Wie Erwärmen, nur kann der Feststoff auf bis zu -20°C abgekühlt werden"
                    },
                    {
                        "name": "Spalte",
                        "level": 4,
                        "value": "Alle vorhandenen Risse und Fehler in einem bis zu 3m x 3m x 3m großen Teil eines beliebigen toten Materials dehnen sich bis zum Äußersten"
                    },
                    {
                        "name": "Tür",
                        "level": 5,
                        "value": "Bewirkt, daß sich eine Tür durch leichte Temperaturschwankungen ausdehnt oder zusammenzieht. Dadurch kann die Tür festgeklemmt oder gelöst werden (was für einen besonderen Modifikator zwischen +50 und -50 auf Manöver sorgt, mir denen die Tür aufgebrochen werden sollen)"
                    },
                    {
                        "name": "Zündeln",
                        "level": 6,
                        "value": "Läßt Holz augenblicklich in Flammen ausbrechen. Nichts von dem Holz, das entzündet werden soll, darf weiter als 30 cm von der Handfläche des Zauberers weg sein"
                    },
                    {
                        "name": "Erhitzen II",
                        "level": 8,
                        "value": "Wie Erhitzen I, nur ist die Reichweite 15m"
                    },
                    {
                        "name": "Tiefkühlen",
                        "level": 9,
                        "value": "Wie Abkühlen, nur ist die Reichweite 15m, und die Temperatur fällt pro Runde, in der sich der Zauberer konzentriert, um 25°C (bis zu einem Minimum von -130°C)"
                    },
                    {
                        "name": "Eisbarriere",
                        "level": 10,
                        "value": "Erzeugt eine bis zu 3m x 3m x (60cm an der Basis, 30cm an der Oberkante) große Eiswand. Man kann sie schmelzen oder sich hindurcharbeiten oder sie umwerfen, wenn sie nicht an einer festen Oberfläche angebracht ist. Es muß innerhalb von 3 Metern eine Wasserquelle vorhanden sein"
                    },
                    {
                        "name": "Feststofftür I",
                        "level": 11,
                        "value": "Erschafft eine Tür in einem beliebigen Feststoff. Sie kann bis zu 1m x 2m x 30cm groß sein"
                    },
                    {
                        "name": "Stein zu Erde zu Schlamm",
                        "level": 12,
                        "value": "Verwandelt 3m³ Stein in feste Erde oder 3m³ Erde in Schlamm oder 3m³ Schlamm in Erde oder 3m³ Erde in Stein"
                    },
                    {
                        "name": "Zerbersten",
                        "level": 13,
                        "value": "Läßt ein unbelebtes Objekt, das nicht aus Metall besteht und bis zu 30 Liter Volumen besitzt, zerbersten. Alle innerhalb eines Radius von 2 Metern erleiden einen Aufpralltreffer der Intensität A (jemand, der den Gegenstand hält erleidet einen C-Treffer)"
                    },
                    {
                        "name": "Feststofftür II",
                        "level": 14,
                        "value": "Wie Feststofftür I, nur ist sie bis zu 1,2m x 2,5m x 1,5m groß"
                    },
                    {
                        "name": "Feststoff formen",
                        "level": 15,
                        "value": "Der Zauberer kann 30 Liter eines festen, unbelebten Materials formen, als wäre es Kitt oder Ton. Am Ende der Spruchdauer härtet das Material bis zu seiner normalen Festigkeit aus"
                    },
                    {
                        "name": "Feststoffbrüchigkeit",
                        "level": 16,
                        "value": "30 Liter eines festen, unbelebten Materials wird ausgesprochen brüchig. Hierdurch zerbricht das Objekt, wenn es von einem Schlag getroffen wird (der SL kann bestimmen, daß bestimmte Objekte einen WW erhalten, damit sie nicht zerbrechen)"
                    },
                    {
                        "name": "Stein vernichten",
                        "level": 17,
                        "value": "Löst 3 Kubikmeter des Zielsteins auf (es bleibt nichts übrig)"
                    },
                    {
                        "name": "Metall vernichten",
                        "level": 19,
                        "value": "Wie Stein vernichten, nur sind 3 Kubikmeter Metall betroffen"
                    },
                    {
                        "name": "Feststofftunnel",
                        "level": 20,
                        "value": "Treibt einen Tunnel durch festes, unbelebtes Material, der 1,2 Meter im Durchmesser und 1,5m pro Stufe lang ist"
                    },
                    {
                        "name": "Wahrhaftige Feststofftür",
                        "level": 25,
                        "value": "Wie Feststofftür, nur ist sie bis zu 2m x 3,5m x 3m groß"
                    },
                    {
                        "name": "Wahrhaftiger Feststofftunnel",
                        "level": 30,
                        "value": "Wie Wahrhaftige Feststofftür, nur ist er permanent und 1m x 2m x 30cm/St groß"
                    },
                    {
                        "name": "Feststoffswandeln",
                        "level": 50,
                        "value": "Kann 30g eines unbelebten Feststoffs in einen anderen nicht-magischen Feststoff verwandeln, von dem der Zauberer eine Probe hat. Dieser Spruch erfordert 8 Stunden zusammenhängender, ununterbrochener Konzentration. Von diesem Spruch träumten die Alchemisten des Mittelalters."
                    }
                ]
            },
            {
                "id": "23.1",
                "name": "11.3.2: Flüssigkeitsveränderung",
                "spells": [
                    {
                        "name": "Wasser kochen/einfrieren",
                        "level": 1,
                        "value": "Pro Stufe des Zauberers können 30 Liter Flüssigkeit bis zum Siedepunkt erhitzt oder bis zum Gefrierpunkt abgekühlt werden (mit einer Geschwindigkeit von 10°C pro Runde Konzentration). Das funktioniert nicht bei Blut in einem lebendigen Körper"
                    },
                    {
                        "name": "Wasser reinigen/entsalzen",
                        "level": 2,
                        "value": "Wie Wasser kochen/ einfrieren, nur entfernt der Spruch alle Schwebstoffe und gelöste Substanzen"
                    },
                    {
                        "name": "Wasser verdampfen",
                        "level": 3,
                        "value": "Wie Wasser kochen/einfrieren, nur werden 300 Hektoliter Flüssigkeit pro Stufe mit einer Geschwindigkeit von 30 Hektolitern pro Runde verdampft"
                    },
                    {
                        "name": "Wasserbarriere",
                        "level": 4,
                        "value": "Erzeugt eine bis zu 3m x 3m x 30cm große Wand aus wogendem Wasser (es muß innerhalb von 3 Metern Entfernung eine Wasserquelle geben). Alle Bewegungen durch diese Barriere werden um 80% reduziert. Angriffe durch sie erleiden einen Malus von -80"
                    },
                    {
                        "name": "Wasserstrahl I",
                        "level": 5,
                        "value": "Ein druckvoller Strahl Wasser springt aus der Handfläche des Zauberers. Die Ergebnisse dieses Angriffs werden mittels der Angriffstabelle: Wasserstrahl 12-9 (Seite 247) bestimmt"
                    },
                    {
                        "name": "Wasserkorridor I",
                        "level": 6,
                        "value": "Erzeugt einen Korridor durch Flüssigkeiten, der bis zu 30 Metern lang, 1 Meter breit und 3 Meter tief sein kann (muß oben offen sein)"
                    },
                    {
                        "name": "Regenruf",
                        "level": 7,
                        "value": "Läßt es innerhalb eines Radius von 30m um den Zauberer regnen. Wie stark der Regen ist, hängt von der Luftfeuchtigkeit ab (SL-Entscheidung)"
                    },
                    {
                        "name": "Wasser beruhigen",
                        "level": 8,
                        "value": "Das Wasser innerhalb des Radius wird beruhigt. Wellen werden um bis zu 6 Meter in der Mitte gesenkt (am Rand weniger). Dieser Spruch hebt die Wirkung von Strömungen im Wirkungsbereich auf"
                    },
                    {
                        "name": "Welle",
                        "level": 9,
                        "value": "Erschafft eine Welle, die sich vom Zauberer wegbewegt. Sie ist pro Stufe 30cm hoch und 3m pro Stufe breit"
                    },
                    {
                        "name": "Wahrhaftige Wasserbarriere",
                        "level": 10,
                        "value": "Wie Wasserbarriere, nur ist die Dauer auf eine Minute pro Stufe des Zauberers festgesetzt"
                    },
                    {
                        "name": "Wasserkorridor III",
                        "level": 11,
                        "value": "Wie Wasserkorridor I, nur kann er bis zu 90m x 1,20m x 15m groß sein"
                    },
                    {
                        "name": "Flüssigkeit zu Wasser",
                        "level": 12,
                        "value": "Verwandelt eine beliebige Flüssigkeit in Wasser"
                    },
                    {
                        "name": "Strudel",
                        "level": 13,
                        "value": "Erschafft einen 6m breiten Strudel, der alle Gegenstände ohne eigenen Antrieb innerhalb von 60 Metern Entfernung an sich zieht (der Zauberer muß sich 2 Minuten konzentrieren, damit der Strudel entsteht). Gegenstände mit Antrieb können ein sehr schweres Manöver ausführen, um dem Sog des Strudels zu entkommen"
                    },
                    {
                        "name": "Wassertunnel",
                        "level": 14,
                        "value": "Erschafft einen Tunnel durch Flüssigkeiten, der einen Durchmesser von 1,5 Metern hat und 30m lang ist"
                    },
                    {
                        "name": "Wahrhaftige Wasserberuhigung",
                        "level": 15,
                        "value": "Wie Wasser beruhigen, nur ist der Wirkungsbereich 30m pro Stufe groß, und die Wellen werden in der Mitte um 15m niedriger"
                    },
                    {
                        "name": "Strömung lenken",
                        "level": 16,
                        "value": "Der Wirkungsbereich dieses Spruchs ist das Wasser direkt um das Boot herum, auf dem der Zauberer sich befindet. Solange sich der Zauberer konzentriert, kann er die Geschwindigkeit des Boots um 15m pro Runde (ungefähr 5 km/h) erhöhen"
                    },
                    {
                        "name": "Wasserblase",
                        "level": 17,
                        "value": "Erschafft eine Luftblase (3m-Radius) um den Zauberer und andere. Die Blase trägt sie bis zu 30m in Wasser hinein (die Luft wird erneuert). Der Zauberer muß sich konzentrieren, um die Blase zu bewegen (ohne Konzentration steigt sie einfach zur Wasseroberfläche hoch). Wenn die Spruchdauer abläuft, steigt die Blase langsam zur Oberfläche hoch. Alles, was in der Blase ist, steigt mit ihr hoch. Sobald sie die Oberfläche erreicht, platzt sie"
                    },
                    {
                        "name": "Wasserstrahl III",
                        "level": 18,
                        "value": "Wie Wasserstrahl I, bis auf die Reichweite"
                    },
                    {
                        "name": "Wahrhaftiger Wasserkorridor",
                        "level": 20,
                        "value": "Wie Wasserkorridor, nur kann der Korridor bis zu 30m pro Stufe lang, 2m breit und 30m tief sein (und es ist keine Konzentration nötig)"
                    },
                    {
                        "name": "Wahrhaftiger Wassertunnel",
                        "level": 25,
                        "value": "Wie Wassertunnel, nur kann er einen Durchmesser von bis zu 3 Metern haben und 30m pro Stufe lang sein (und es ist keine Konzentration nötig)"
                    },
                    {
                        "name": "Wasserquelle umleiten",
                        "level": 30,
                        "value": "Der Zauberer kann eine Wasserquelle oder einen Teil davon in einen Bach umleiten, der bis zu 5m x 2m groß sein kann und so lang wie die Spruchreichweite"
                    },
                    {
                        "name": "Flüssigkeitswandeln",
                        "level": 50,
                        "value": "Kann 30 Liter Flüssigkeit in eine beliebige andere, nichtmagische Flüssigkeit umwandeln, von der der Zauberer eine Probe hat. Dieser Spruch erfordert 8 Stunden zusammenhängender, ununterbrochener Konzentration."
                    }
                ]
            },
            {
                "id": "23.2",
                "name": "11.3.3: Gasveränderung",
                "spells": [
                    {
                        "name": "Kondensation",
                        "level": 1,
                        "value": "Kondensiert 30 Liter Wasser aus der Umgebungsluft. Das Wasser kondensiert allmählich in der Hand des Zauberers und kann in passende Behälter geleitet werden"
                    },
                    {
                        "name": "Luftbarriere",
                        "level": 2,
                        "value": "Erzeugt eine Barriere aus dichter, sich heftig drehender Luft mit Ausmaßen von bis zu 3m x 3m x 1m. Diese Barriere reduziert alle Bewegung durch sie hindurch um 50%. Zusätzlich erleiden Angriffe durch die Barriere einen Malus von -50"
                    },
                    {
                        "name": "Nebel II",
                        "level": 3,
                        "value": "Erzeug in einem Radius von 6m dichten Nebel"
                    },
                    {
                        "name": "Vakuum A",
                        "level": 4,
                        "value": "Erschafft ein fast vollständiges Vakuum in einem Radius von 2m. Alle in dem Bereich erleiden einen Aufpralltreffer der Intensität A, als die Luft zurückströmt"
                    },
                    {
                        "name": "Luftbremse I",
                        "level": 5,
                        "value": "Bringt im Wirkungsbereich alle Luftbewegungen mit Windgeschwindigkeiten bis zu 50km/h zum Stehen und verlangsamt stärkere Winde um 50km/h"
                    },
                    {
                        "name": "Nebel X",
                        "level": 6,
                        "value": "Wie Nebel II, nur ist der Wirkungsbereich 30m groß"
                    },
                    {
                        "name": "Wahrhaftige Luftbarriere",
                        "level": 7,
                        "value": "Wie Luftbarriere, nur ist die Dauer eine Minute pro Stufe"
                    },
                    {
                        "name": "Feuerstrahl I",
                        "level": 8,
                        "value": "Aus der Handfläche des Zauberers schießt ein Feuerstrahl (es muß innerhalb von 3 Metern ein Feuer brennen). Der Angriff wird auf der Angriffstabelle: Feuerstrahl 12-6 (Seite 241) ausgewürfelt"
                    },
                    {
                        "name": "Vakuum B",
                        "level": 9,
                        "value": "Wie Vakuum A, nur bewirkt das Vakuum kritische Aufpralltreffer der Intensität B"
                    },
                    {
                        "name": "Luftbremse V",
                        "level": 10,
                        "value": "Wie Luftbremse I, nur ist der Wirkungsbereich ein Radius von 15 Metern"
                    },
                    {
                        "name": "Nebel XX",
                        "level": 11,
                        "value": "Wie Nebel II, nur ist der Wirkungsbereich 100m groß"
                    },
                    {
                        "name": "Gas zu Luft",
                        "level": 12,
                        "value": "Alles Gas in einem Radius von 3m um den Zauberer wird in normale, atembare Luft umgewandelt"
                    },
                    {
                        "name": "Vakuum C",
                        "level": 13,
                        "value": "Wie Vakuum A, nur bewirkt das Vakuum kritische Aufpralltreffer der Intensität C"
                    },
                    {
                        "name": "Sauerstoffanreicherung",
                        "level": 14,
                        "value": "Reichert in einem 15mRadius die Luft mit Sauerstoff an. Alle im Wirkungsbereich erhalten einen besonderen Bonus von +20 auf ihre OB, und alle Feuerangriffe dort fügen doppelten Schaden zu"
                    },
                    {
                        "name": "Wirbelwind",
                        "level": 15,
                        "value": "Erzeugt einen Wirbelwind um den Zauberer. Der Wirbelwind bewegt sich mit dem Zauberer und hat einen Radius von 3 Metern. Kein Fernkampfangriff kann ihn durchdringen und jede Bewegung oder Nahkampf (außer dem des Zauberers) durch ihn hindurch oder in ihn hinein ist um 80% erschwert"
                    },
                    {
                        "name": "Feuerstrahl III",
                        "level": 16,
                        "value": "Wie Feuerstrahl I, nur ist die Reichweite 100 Meter"
                    },
                    {
                        "name": "Vakuum D",
                        "level": 17,
                        "value": "Wie Vakuum A, nur bewirkt das Vakuum kritische Aufpralltreffer der Intensität D"
                    },
                    {
                        "name": "Windumkehr",
                        "level": 19,
                        "value": "Erlaubt dem Zauberer, die Windrichtung innerhalb des Wirkungsbereichs zu ändern"
                    },
                    {
                        "name": "Wahrhaftiger Nebel",
                        "level": 20,
                        "value": "Wie Nebel II, nur ist die Dauer eine Stunde pro Stufe und der Wirkungsbereich ist 30m pro Stufe"
                    },
                    {
                        "name": "Vakuum E",
                        "level": 25,
                        "value": "Wie Vakuum A, nur bewirkt das Vakuum kritische Aufpralltreffer der Intensität E"
                    },
                    {
                        "name": "Wolken formen",
                        "level": 30,
                        "value": "Der Zauberer hat die völlige Kontrolle über die Wolken innerhalb der Reichweite (auch über Nebel). Er kann auch Sturmwolken kontrollieren und sie regnen lassen, aber er kann sie nicht erzeugen"
                    },
                    {
                        "name": "Gaswandeln",
                        "level": 50,
                        "value": "Kann bis zu 100m³ Gas (von dem nichts mehr als 6m entfernt sein kann) in ein beliebiges anderes, nichtmagisches Gas umwandeln, von dem der Zauberer einen Probe hat. Dieser Spruch erfordert 8 Stunden ununterbrochener Konzentration."
                    }
                ]
            },
            {
                "id": "23.3",
                "name": "11.3.4: Mystische Veränderung",
                "spells": [
                    {
                        "name": "Form einprägen",
                        "level": 1,
                        "value": "Der Zauberer studiert die Erscheinung und die Angewohnheiten eines Wesens, um dies später mit einem Gesicht wandeln, Verwandlungsoder Wandel-Spruch zu verwenden. Der Zauberer kann immer nur seine Stufe an Wesen studiert haben"
                    },
                    {
                        "name": "Wahrhaftiger Gesichtswandel",
                        "level": 2,
                        "value": "Der Zauberer kann seine Gesichtsform verändern. Wenn er Form einprägen auf ein Wesen angewandt hat, kann dessen genaue Gesichtsform übernehmen"
                    },
                    {
                        "name": "Volksverwandlung",
                        "level": 3,
                        "value": "Der Zauberer kann seine Gestalt so verändern, daß er wie ein Angehöriger eines anderen Volks wirkt (seine Masse verändert sich dabei nicht). Es kann keine bestimmte Person sein. Siehe Abschnitt 5.20 (Seite 42)"
                    },
                    {
                        "name": "Volk kaschieren",
                        "level": 4,
                        "value": "Im Bezug auf geistige oder magische Erkennung erscheint das Ziel als Angehöriger des Volks, das der Zauberer wählt"
                    },
                    {
                        "name": "Vergrößerung",
                        "level": 5,
                        "value": "Der Zauberer kann seine Masse (und normalerweise auch seine Größe) um 10% pro Stufe ändern. Allerdings verändert sich seine Stärke nicht proportional zur neuen Größe (von der für Bewegung notwendigen abgesehen)"
                    },
                    {
                        "name": "Verkleinerung",
                        "level": 6,
                        "value": "Wie Vergrößerung, nur schrumpft der Zauberer um 10% pro Stufe (maximal um 90%) und seine Stärke nimmt nicht proportional ab"
                    },
                    {
                        "name": "Beruf kaschieren",
                        "level": 7,
                        "value": "Wie Volk kaschieren, nur kann der Beruf des Zauberers falsch dargestellt werden"
                    },
                    {
                        "name": "Wandellungen",
                        "level": 8,
                        "value": "Der Zauberer kann beliebig Wasser, Luft oder Gas atmen (allerdings immer nur eins davon)"
                    },
                    {
                        "name": "Verwandlung",
                        "level": 9,
                        "value": "Wie Volksverwandlung, aber der Zauberer kann eine beliebige organische Gestalt annehmen, solange deren Masse zwischen 50% und 200% seiner eigenen liegt. Das Ziel erhält keine besondere Fertigkeiten durch die Verwandlung. Siehe Abschnitt 5.20 (Seite 42)"
                    },
                    {
                        "name": "Mystische Sprache",
                        "level": 10,
                        "value": "[WW-Mod.: -50] Der Zauberer kann mental mit jedem empfindungsfähigen Wesen sprechen, und auf das Wesen wirkt es, als spräche der Zauberer in seiner Sprache"
                    },
                    {
                        "name": "Macht kaschieren",
                        "level": 11,
                        "value": "Wie Volk kaschieren, nur wird die Stufe des Zauberers fasch dargestellt werden (von der ersten Stufe bis zum Doppelten seiner tatsächlichen Stufe)"
                    },
                    {
                        "name": "Doppelgängerverwandlung",
                        "level": 12,
                        "value": "Wie Verwandlung, nur kann ein bestimmtes Wesen kopiert werden, wenn es vorher mit Form einprägen studiert wurde"
                    },
                    {
                        "name": "Präsenz aufheben",
                        "level": 13,
                        "value": "Wie Volk kaschieren, nur wirkt das Ziel als hätte es keine Präsenz"
                    },
                    {
                        "name": "Kaschieren",
                        "level": 14,
                        "value": "Versieht den Zauberer mit allen Kaschieren-Sprüche gleichzeitig"
                    },
                    {
                        "name": "Steter Wandel",
                        "level": 15,
                        "value": "Wie Verwandlung, nur kann der Zauberer jederzeit während der Spruchdauer eine andere Gestalt annehmen, indem er sich pro Verwandlung eine Runde konzentriert"
                    },
                    {
                        "name": "Längere Volksverwandlung",
                        "level": 16,
                        "value": "Wie Volksverwandlung, bis auf die Dauer"
                    },
                    {
                        "name": "Längere Verwandlung",
                        "level": 18,
                        "value": "Wie Verwandlung, bis auf die Dauer"
                    },
                    {
                        "name": "Wahrhaftiges Kaschieren",
                        "level": 19,
                        "value": "Wie Kaschieren, nur muß der Zauberer sich nicht konzentrieren"
                    },
                    {
                        "name": "Längere Doppelgängerverwandlung",
                        "level": 20,
                        "value": "Wie Doppelgängerverwandlung, bis auf die Dauer"
                    },
                    {
                        "name": "Wahrhaftige Doppelgängerverwandlung",
                        "level": 25,
                        "value": "Wie Doppelgängerverwandlung, nur bleibt die Wirkung bestehen, bis der Zauberer sie aufhebt (oder bis sie gebannt wird)"
                    },
                    {
                        "name": "Heilige Präsenz",
                        "level": 30,
                        "value": "Wie Kaschieren, nur kann der Zauberer seine Macht und seine Präsenz so wirken lassen wie die einer niederen Gottheit"
                    },
                    {
                        "name": "Fremdpersona",
                        "level": 50,
                        "value": "Der Zauberer kann eine Persona entwickeln und legt seine eigene tief in seinem Unterbewußtsein ab. Für alle Entdeckungsversuche (vielleicht mit Ausnahme von Geist erforschen) erscheint der Zauberer als die falsche Persona. Der Zauberer hat keinen Kontrolle über seine Aktionen, bis die festgelegte Spruchdauer abgelaufen ist. Die falsche Persona kann eine bestimmte Person sein, wenn diese 30 Tage lang einmal pro Tag mit Form einprägen studiert wurde."
                    }
                ]
            },
            {
                "id": "23.4",
                "name": "11.3.5: Verstecken",
                "spells": [
                    {
                        "name": "Flimmern",
                        "level": 1,
                        "value": "Das Ziel erscheint Angreifern verschwommen, dies bewirkt einen Abzug von -10 auf Angriffe gegen das Ziel"
                    },
                    {
                        "name": "Transparenz I",
                        "level": 2,
                        "value": "Ein einzelnes Objekt wird unsichtbar (1 Gewand, 1 nackter Körper usw.), bis entweder 24 Stunden verstrichen sind oder bis das Ziel von einem harten Schlag getroffen wird (indem es von einer Waffe getroffen wird, stürzt o.ä..) oder bis das Ziel eine gewalttätige Handlung ausführt (z.B. einen Angriff )"
                    },
                    {
                        "name": "Schatten",
                        "level": 3,
                        "value": "Der Zauberer und Gegenstände, die er am Körper trägt, wirken wie ein Schatten und sind damit in dunkler Umgebung fast unsichtbar. In vielen Situation kann das als besonderer Bonus zwischen +25 und +75 auf Schleichen/Verstecken abgehandelt werden"
                    },
                    {
                        "name": "Stille",
                        "level": 4,
                        "value": "Alle Geräusche in einem Radius von 30cm um den Körper des Zauberers verstummen völlig. Daraus ergibt sich ein besonderer Bonus von +25 auf Schleichen"
                    },
                    {
                        "name": "Unsichtbarkeit I",
                        "level": 5,
                        "value": "Wie Transparenz I, aber alles in 30cm Umkreis um das Ziel ist unsichtbar, solange es sich vollständig in diesem Radius befindet und keine der unter Transparenz I genannten Abbruchbedingungen eintritt. Siehe Abschnitt 5.5 (Seite 37)"
                    },
                    {
                        "name": "Unsichtbarkeit II",
                        "level": 6,
                        "value": "Wie Unsichtbarkeit I, aber der Radius kann von 0 bis zu 30cm variieren"
                    },
                    {
                        "name": "Bildfläche",
                        "level": 7,
                        "value": "Erzeugt eine 300m² große Bildfläche, auf der der Zauberer eine beliebige, unbewegliche Kulisse erschaffen kann. Die Kulisse wirkt dreidimensional und normal"
                    },
                    {
                        "name": "Verschieben I",
                        "level": 8,
                        "value": "Der Zauberer scheint leicht von seinem eigentlichen Aufenthaltsort versetzt zu sein. Angriffe auf ihn schlagen mit einer Wahrscheinlichkeit von 10% fehl. Jedesmal, wenn der Zauberer wegen dieses Spruchs verfehlt wurde, sinkt die Wahrscheinlichkeit um 5%"
                    },
                    {
                        "name": "Kein Sinn",
                        "level": 9,
                        "value": "Wie Unsichtbarkeit I, nur kann der Zauberer auch nicht über den Geruchssinn oder das Gehör wahrgenommen werden"
                    },
                    {
                        "name": "Schattenmystiker",
                        "level": 10,
                        "value": "Erschafft ein Abbild des Zauberers. Solange er sich konzentriert, bewegt es sich so wie er will, andernfalls tut es, was auch immer der Zauberer tut. Mit einer Runde Konzentration kann der Schattenmystiker wieder mit sich selbst verschmelzen und sich dann wieder ablösen"
                    },
                    {
                        "name": "Unsichtbarkeitssphäre I",
                        "level": 11,
                        "value": "Wie Unsichtbarkeit I, aber der Radius ist 3 Meter"
                    },
                    {
                        "name": "Verschieben II",
                        "level": 12,
                        "value": "Wie Verschieben I, nur liegt die Wahrscheinlichkeit, daß Angriffe fehlschlagen, bei 20%"
                    },
                    {
                        "name": "Abflachen",
                        "level": 13,
                        "value": "Der Zauberer flacht soweit ab, daß er nur noch zwei Dimensionen hat. So kann er durch Risse schlüpfen (und von der Seite nicht gesehen werden"
                    },
                    {
                        "name": "Verschmelzen",
                        "level": 14,
                        "value": "Das Ziel kann mit beliebigem festen, unbelebten Material verschmelzen. Wenn es verschmolzen ist, kann das Ziel sich weder bewegen noch nimmt es etwa wahr. Wenn es das Material verläßt, kann es auf jeder Seite davon heraustreten. Das Ziel kann sich nicht durch Material hindurchbewegen, das tiefer ist als sein eigener Körper plus 60 cm"
                    },
                    {
                        "name": "Präsenz aufheben",
                        "level": 15,
                        "value": "Der Zauberer hat keine Präsenz (im Hinblick auf Entdeckungssprüche)"
                    },
                    {
                        "name": "Verschieben III",
                        "level": 16,
                        "value": "Wie Verschieben I, nur liegt die Wahrscheinlichkeit, daß Angriffe fehlschlagen, bei 30%"
                    },
                    {
                        "name": "Hindurchdringen",
                        "level": 17,
                        "value": "Das Ziel kann sich durch alles unbelebte Material mit einer Dicke von bis zu 30cm pro Stufe bewegen. Es braucht je eine Minute für 60cm"
                    },
                    {
                        "name": "Vollendetes Verschmelzen",
                        "level": 19,
                        "value": "Wie Verschmelzen, nur kann sich der Zauberer in dem Material drehen und die Umgebung wahrnehmen, wenn er sich innerhalb von 15cm von der Oberfläche befindet"
                    },
                    {
                        "name": "Verschieben IV",
                        "level": 20,
                        "value": "Wie Verschieben I, nur liegt die Wahrscheinlichkeit, daß Angriffe fehlschlagen, bei 40%"
                    },
                    {
                        "name": "Unentdeckt",
                        "level": 25,
                        "value": "Der Zauberer und Gegenstände, die er am Körper trägt, können nicht über Entdeckungssprüche gefunden werden"
                    },
                    {
                        "name": "Verschieben V",
                        "level": 30,
                        "value": "Wie Verschieben I, nur liegt die Wahrscheinlichkeit, daß Angriffe fehlschlagen, bei 50%"
                    },
                    {
                        "name": "Wahrhaftiges Verstecken",
                        "level": 50,
                        "value": "Der Zauberer kann mit einem Material verschmelzen, Präsenz aufheben verwenden und die Aktivität in der Umgebung beobachten"
                    }
                ]
            },
            {
                "id": "23.5",
                "name": "11.3.6: Wege der Verwirrung",
                "spells": [
                    {
                        "name": "Ablenkung",
                        "level": 1,
                        "value": "Das Ziel erleidet einen Malus von -30 auf alle Aktionen"
                    },
                    {
                        "name": "Verwirren",
                        "level": 2,
                        "value": "Das Ziel ist unfähig, sich zu entscheiden oder Handlungen einzuleiten"
                    },
                    {
                        "name": "Verschwommene Sicht",
                        "level": 3,
                        "value": "Alle Fernkampfangriffe des Ziels haben erleiden OB-Malus von -100, alle sonstigen Handlungen haben einen Malus von -50"
                    },
                    {
                        "name": "Furcht",
                        "level": 4,
                        "value": "Das Ziel fürchtet den Zauberer und versucht zu fliehen. Dies bedeutet normalerweise, daß das Ziel mit maximaler Geschwindigkeit vom Zauberer wegläuft"
                    },
                    {
                        "name": "Stolpern",
                        "level": 5,
                        "value": "Das Ziel verliert das Gleichgewicht. Wenn es sich bewegt, stolpert es und fällt hin (1-5 Runden keine Aktion). Wenn es ein Manöver ausführt, scheitert es"
                    },
                    {
                        "name": "Patzer",
                        "level": 6,
                        "value": "Das Ziel verpatzt den Einsatz einer Waffe oder eines Gegenstandes in seiner Hand, das Ergebnis wird durch einen Wurf auf der entsprechenden Patzertabelle festgestellt"
                    },
                    {
                        "name": "Halluzination",
                        "level": 7,
                        "value": "Das Ziel sieht einen Gegner, der nicht da ist, und muß mit ihm kämpfen, bis es ihn besiegt hat (d.h. bis der Gegner genug Schaden eingesteckt hat, um zu Boden zu gehen). Der Gegner hat die gleichen Fähigkeiten wie das Ziel, fügt ihm aber keinen Schaden zu (d.h. er schlägt immer daneben)"
                    },
                    {
                        "name": "Herumwirbeln",
                        "level": 8,
                        "value": "Das Ziel wird ein paar Mal herumgewirbelt und bleibt so stehen, daß seine Blickrichtung um 180° anders ist. Es versucht eine Runde lang, sich zu erholen"
                    },
                    {
                        "name": "Waffe verändern",
                        "level": 9,
                        "value": "Die Waffe des Ziels wird so verändert, daß sie ihm als eine ähnliche aber andere Waffe erscheint. Wenn es mit dieser Waffe kämpft, kann es nur den OB für die Waffenkategorie verwenden (d.h. die Waffe ist seiner ähnlich aber nicht die gleiche)"
                    },
                    {
                        "name": "Trugbilder",
                        "level": 10,
                        "value": "Das Ziel sieht alles klar, was sich bewegt, aber der Zauberer kann die feste Kulisse kontrollieren, die das Ziel „sieht“"
                    },
                    {
                        "name": "Blenden",
                        "level": 11,
                        "value": "Das Ziel ist geblendet (blind)"
                    },
                    {
                        "name": "Verlagern",
                        "level": 12,
                        "value": "Das Ziel sieht alles, was sich bewegt, so als wäre es um 15-45cm verlagert. Jeder seiner Angriffe gegen ein Ziel in Bewegung schlägt mit 50% Wahrscheinlichkeit fehl"
                    },
                    {
                        "name": "Massen-Ablenkung",
                        "level": 13,
                        "value": "Die Stufe des Zauberers an Zielen kann wie in Ablenkung abgelenkt werden (alle Ziele müssen im Sichtfeld des Zauberers sein)"
                    },
                    {
                        "name": "Wort der Furcht",
                        "level": 14,
                        "value": "Wie Furcht, nur wirkt der Spruch unverzüglich und die Spruchdauer ist 1 Minute pro Fehlschlag von 5"
                    },
                    {
                        "name": "Gedächtnisschwund",
                        "level": 15,
                        "value": "Das Ziel leitet unter Gedächtnisschwund"
                    },
                    {
                        "name": "Ruf der Verwirrung",
                        "level": 16,
                        "value": "Wie Verwirren, nur wirkt der Spruch unverzüglich und alle Wesen innerhalb eines Radius von 15m sind Ziele"
                    },
                    {
                        "name": "Fern-Irreführung",
                        "level": 17,
                        "value": "Wie ein beliebiger Spruch dieser Liste der Stufe 10 oder eine niedrigeren, nur ist die Reichweite auf 100 Meter erhöht"
                    },
                    {
                        "name": "Ruf der Furcht",
                        "level": 18,
                        "value": "Wie Furcht, nur wirkt der Spruch unverzüglich und die Dauer ist eine Minute und alle Wesen innerhalb eines Radius von 15 Metern sind Ziele"
                    },
                    {
                        "name": "Meister-Irreführung",
                        "level": 20,
                        "value": "Wie jeder beliebige Spruch dieser Liste der Stufe 10 oder einer niedrigeren, nur betrifft der Spruch bis zu 20 Ziele"
                    },
                    {
                        "name": "Wahrhaftiger Gedächtnisschwund",
                        "level": 25,
                        "value": "Wie Gedächtnisschwund, nur ist die Dauer permanent (bis sie gebannt wird)"
                    },
                    {
                        "name": "Parallele Wirklichkeit",
                        "level": 30,
                        "value": "Das Ziel sieht und hört eine Welt, in der alle realen Dinge ein Abbild haben, das aber verändert oder verzerrt ist (d.h. ein Zwerg könnte als Ork erscheinen, ein Haus als Höhle usw.). Der Zauberer hat keine Kontrolle über diese Wirklichkeit"
                    },
                    {
                        "name": "Wahrhaftige Irreführung",
                        "level": 50,
                        "value": "Wie jeder andere Spruch dieser Liste der 20. Stufe oder einer niedrigeren, nur ist die Reichweite 100m und der Spruch betrifft bis zu 20 Ziele auf einmal."
                    }
                ]
            }
        ]
    }
];
